import * as p from "react";
import I, { forwardRef as Et, createElement as P, useLayoutEffect as er, useEffect as Ne, createContext as Wt, useRef as Le, useId as Zi, useContext as xe, useInsertionEffect as wd, useCallback as Ve, useMemo as Ke, Children as C6, isValidElement as b6, useState as ve, Fragment as Nn, Component as xd, memo as Cd, createRef as n1, Suspense as L6 } from "react";
import * as An from "react-dom";
import j6 from "react-dom";
var eo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function N6(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var U2 = { exports: {} }, Za = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ys;
function A6() {
  if (Ys) return Za;
  Ys = 1;
  var e = I, t = Symbol.for("react.element"), a = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(c, f, d) {
    var u, h = {}, y = null, m = null;
    d !== void 0 && (y = "" + d), f.key !== void 0 && (y = "" + f.key), f.ref !== void 0 && (m = f.ref);
    for (u in f) n.call(f, u) && !i.hasOwnProperty(u) && (h[u] = f[u]);
    if (c && c.defaultProps) for (u in f = c.defaultProps, f) h[u] === void 0 && (h[u] = f[u]);
    return { $$typeof: t, type: c, key: y, ref: m, props: h, _owner: o.current };
  }
  return Za.Fragment = a, Za.jsx = s, Za.jsxs = s, Za;
}
var Fa = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qs;
function S6() {
  return Qs || (Qs = 1, process.env.NODE_ENV !== "production" && function() {
    var e = I, t = Symbol.for("react.element"), a = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), c = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v = Symbol.iterator, k = "@@iterator";
    function g(b) {
      if (b === null || typeof b != "object")
        return null;
      var E = v && b[v] || b[k];
      return typeof E == "function" ? E : null;
    }
    var M = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(b) {
      {
        for (var E = arguments.length, $ = new Array(E > 1 ? E - 1 : 0), ae = 1; ae < E; ae++)
          $[ae - 1] = arguments[ae];
        x("error", b, $);
      }
    }
    function x(b, E, $) {
      {
        var ae = M.ReactDebugCurrentFrame, we = ae.getStackAddendum();
        we !== "" && (E += "%s", $ = $.concat([we]));
        var je = $.map(function(ge) {
          return String(ge);
        });
        je.unshift("Warning: " + E), Function.prototype.apply.call(console[b], console, je);
      }
    }
    var C = !1, L = !1, N = !1, j = !1, A = !1, D;
    D = Symbol.for("react.module.reference");
    function H(b) {
      return !!(typeof b == "string" || typeof b == "function" || b === n || b === i || A || b === o || b === d || b === u || j || b === m || C || L || N || typeof b == "object" && b !== null && (b.$$typeof === y || b.$$typeof === h || b.$$typeof === s || b.$$typeof === c || b.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      b.$$typeof === D || b.getModuleId !== void 0));
    }
    function Z(b, E, $) {
      var ae = b.displayName;
      if (ae)
        return ae;
      var we = E.displayName || E.name || "";
      return we !== "" ? $ + "(" + we + ")" : $;
    }
    function R(b) {
      return b.displayName || "Context";
    }
    function _(b) {
      if (b == null)
        return null;
      if (typeof b.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof b == "function")
        return b.displayName || b.name || null;
      if (typeof b == "string")
        return b;
      switch (b) {
        case n:
          return "Fragment";
        case a:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case d:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case c:
            var E = b;
            return R(E) + ".Consumer";
          case s:
            var $ = b;
            return R($._context) + ".Provider";
          case f:
            return Z(b, b.render, "ForwardRef");
          case h:
            var ae = b.displayName || null;
            return ae !== null ? ae : _(b.type) || "Memo";
          case y: {
            var we = b, je = we._payload, ge = we._init;
            try {
              return _(ge(je));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var T = Object.assign, G = 0, q, V, B, Q, me, be, z;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function K() {
      {
        if (G === 0) {
          q = console.log, V = console.info, B = console.warn, Q = console.error, me = console.group, be = console.groupCollapsed, z = console.groupEnd;
          var b = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: b,
            log: b,
            warn: b,
            error: b,
            group: b,
            groupCollapsed: b,
            groupEnd: b
          });
        }
        G++;
      }
    }
    function U() {
      {
        if (G--, G === 0) {
          var b = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: T({}, b, {
              value: q
            }),
            info: T({}, b, {
              value: V
            }),
            warn: T({}, b, {
              value: B
            }),
            error: T({}, b, {
              value: Q
            }),
            group: T({}, b, {
              value: me
            }),
            groupCollapsed: T({}, b, {
              value: be
            }),
            groupEnd: T({}, b, {
              value: z
            })
          });
        }
        G < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ne = M.ReactCurrentDispatcher, O;
    function X(b, E, $) {
      {
        if (O === void 0)
          try {
            throw Error();
          } catch (we) {
            var ae = we.stack.trim().match(/\n( *(at )?)/);
            O = ae && ae[1] || "";
          }
        return `
` + O + b;
      }
    }
    var re = !1, ie;
    {
      var fe = typeof WeakMap == "function" ? WeakMap : Map;
      ie = new fe();
    }
    function ke(b, E) {
      if (!b || re)
        return "";
      {
        var $ = ie.get(b);
        if ($ !== void 0)
          return $;
      }
      var ae;
      re = !0;
      var we = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var je;
      je = ne.current, ne.current = null, K();
      try {
        if (E) {
          var ge = function() {
            throw Error();
          };
          if (Object.defineProperty(ge.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ge, []);
            } catch (rt) {
              ae = rt;
            }
            Reflect.construct(b, [], ge);
          } else {
            try {
              ge.call();
            } catch (rt) {
              ae = rt;
            }
            b.call(ge.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (rt) {
            ae = rt;
          }
          b();
        }
      } catch (rt) {
        if (rt && ae && typeof rt.stack == "string") {
          for (var ue = rt.stack.split(`
`), et = ae.stack.split(`
`), Re = ue.length - 1, Oe = et.length - 1; Re >= 1 && Oe >= 0 && ue[Re] !== et[Oe]; )
            Oe--;
          for (; Re >= 1 && Oe >= 0; Re--, Oe--)
            if (ue[Re] !== et[Oe]) {
              if (Re !== 1 || Oe !== 1)
                do
                  if (Re--, Oe--, Oe < 0 || ue[Re] !== et[Oe]) {
                    var Mt = `
` + ue[Re].replace(" at new ", " at ");
                    return b.displayName && Mt.includes("<anonymous>") && (Mt = Mt.replace("<anonymous>", b.displayName)), typeof b == "function" && ie.set(b, Mt), Mt;
                  }
                while (Re >= 1 && Oe >= 0);
              break;
            }
        }
      } finally {
        re = !1, ne.current = je, U(), Error.prepareStackTrace = we;
      }
      var ea = b ? b.displayName || b.name : "", A1 = ea ? X(ea) : "";
      return typeof b == "function" && ie.set(b, A1), A1;
    }
    function Fe(b, E, $) {
      return ke(b, !1);
    }
    function J(b) {
      var E = b.prototype;
      return !!(E && E.isReactComponent);
    }
    function lt(b, E, $) {
      if (b == null)
        return "";
      if (typeof b == "function")
        return ke(b, J(b));
      if (typeof b == "string")
        return X(b);
      switch (b) {
        case d:
          return X("Suspense");
        case u:
          return X("SuspenseList");
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case f:
            return Fe(b.render);
          case h:
            return lt(b.type, E, $);
          case y: {
            var ae = b, we = ae._payload, je = ae._init;
            try {
              return lt(je(we), E, $);
            } catch {
            }
          }
        }
      return "";
    }
    var nt = Object.prototype.hasOwnProperty, gt = {}, K1 = M.ReactDebugCurrentFrame;
    function At(b) {
      if (b) {
        var E = b._owner, $ = lt(b.type, b._source, E ? E.type : null);
        K1.setExtraStackFrame($);
      } else
        K1.setExtraStackFrame(null);
    }
    function a1(b, E, $, ae, we) {
      {
        var je = Function.call.bind(nt);
        for (var ge in b)
          if (je(b, ge)) {
            var ue = void 0;
            try {
              if (typeof b[ge] != "function") {
                var et = Error((ae || "React class") + ": " + $ + " type `" + ge + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof b[ge] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw et.name = "Invariant Violation", et;
              }
              ue = b[ge](E, ge, ae, $, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Re) {
              ue = Re;
            }
            ue && !(ue instanceof Error) && (At(we), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ae || "React class", $, ge, typeof ue), At(null)), ue instanceof Error && !(ue.message in gt) && (gt[ue.message] = !0, At(we), w("Failed %s type: %s", $, ue.message), At(null));
          }
      }
    }
    var Yn = Array.isArray;
    function Ha(b) {
      return Yn(b);
    }
    function L1(b) {
      {
        var E = typeof Symbol == "function" && Symbol.toStringTag, $ = E && b[Symbol.toStringTag] || b.constructor.name || "Object";
        return $;
      }
    }
    function Jr(b) {
      try {
        return Va(b), !1;
      } catch {
        return !0;
      }
    }
    function Va(b) {
      return "" + b;
    }
    function Qn(b) {
      if (Jr(b))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", L1(b)), Va(b);
    }
    var Jn = M.ReactCurrentOwner, X1 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Kn, Oa;
    function Kr(b) {
      if (nt.call(b, "ref")) {
        var E = Object.getOwnPropertyDescriptor(b, "ref").get;
        if (E && E.isReactWarning)
          return !1;
      }
      return b.ref !== void 0;
    }
    function j1(b) {
      if (nt.call(b, "key")) {
        var E = Object.getOwnPropertyDescriptor(b, "key").get;
        if (E && E.isReactWarning)
          return !1;
      }
      return b.key !== void 0;
    }
    function Xn(b, E) {
      typeof b.ref == "string" && Jn.current;
    }
    function Xr(b, E) {
      {
        var $ = function() {
          Kn || (Kn = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", E));
        };
        $.isReactWarning = !0, Object.defineProperty(b, "key", {
          get: $,
          configurable: !0
        });
      }
    }
    function e2(b, E) {
      {
        var $ = function() {
          Oa || (Oa = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", E));
        };
        $.isReactWarning = !0, Object.defineProperty(b, "ref", {
          get: $,
          configurable: !0
        });
      }
    }
    var t2 = function(b, E, $, ae, we, je, ge) {
      var ue = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: b,
        key: E,
        ref: $,
        props: ge,
        // Record the component responsible for creating this element.
        _owner: je
      };
      return ue._store = {}, Object.defineProperty(ue._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ue, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ae
      }), Object.defineProperty(ue, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: we
      }), Object.freeze && (Object.freeze(ue.props), Object.freeze(ue)), ue;
    };
    function a2(b, E, $, ae, we) {
      {
        var je, ge = {}, ue = null, et = null;
        $ !== void 0 && (Qn($), ue = "" + $), j1(E) && (Qn(E.key), ue = "" + E.key), Kr(E) && (et = E.ref, Xn(E, we));
        for (je in E)
          nt.call(E, je) && !X1.hasOwnProperty(je) && (ge[je] = E[je]);
        if (b && b.defaultProps) {
          var Re = b.defaultProps;
          for (je in Re)
            ge[je] === void 0 && (ge[je] = Re[je]);
        }
        if (ue || et) {
          var Oe = typeof b == "function" ? b.displayName || b.name || "Unknown" : b;
          ue && Xr(ge, Oe), et && e2(ge, Oe);
        }
        return t2(b, ue, et, we, ae, Jn.current, ge);
      }
    }
    var qa = M.ReactCurrentOwner, ee = M.ReactDebugCurrentFrame;
    function de(b) {
      if (b) {
        var E = b._owner, $ = lt(b.type, b._source, E ? E.type : null);
        ee.setExtraStackFrame($);
      } else
        ee.setExtraStackFrame(null);
    }
    var Me;
    Me = !1;
    function le(b) {
      return typeof b == "object" && b !== null && b.$$typeof === t;
    }
    function Ie() {
      {
        if (qa.current) {
          var b = _(qa.current.type);
          if (b)
            return `

Check the render method of \`` + b + "`.";
        }
        return "";
      }
    }
    function Ye(b) {
      return "";
    }
    var Ge = {};
    function Vt(b) {
      {
        var E = Ie();
        if (!E) {
          var $ = typeof b == "string" ? b : b.displayName || b.name;
          $ && (E = `

Check the top-level render call using <` + $ + ">.");
        }
        return E;
      }
    }
    function ot(b, E) {
      {
        if (!b._store || b._store.validated || b.key != null)
          return;
        b._store.validated = !0;
        var $ = Vt(E);
        if (Ge[$])
          return;
        Ge[$] = !0;
        var ae = "";
        b && b._owner && b._owner !== qa.current && (ae = " It was passed a child from " + _(b._owner.type) + "."), de(b), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', $, ae), de(null);
      }
    }
    function Ot(b, E) {
      {
        if (typeof b != "object")
          return;
        if (Ha(b))
          for (var $ = 0; $ < b.length; $++) {
            var ae = b[$];
            le(ae) && ot(ae, E);
          }
        else if (le(b))
          b._store && (b._store.validated = !0);
        else if (b) {
          var we = g(b);
          if (typeof we == "function" && we !== b.entries)
            for (var je = we.call(b), ge; !(ge = je.next()).done; )
              le(ge.value) && ot(ge.value, E);
        }
      }
    }
    function qt(b) {
      {
        var E = b.type;
        if (E == null || typeof E == "string")
          return;
        var $;
        if (typeof E == "function")
          $ = E.propTypes;
        else if (typeof E == "object" && (E.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        E.$$typeof === h))
          $ = E.propTypes;
        else
          return;
        if ($) {
          var ae = _(E);
          a1($, b.props, "prop", ae, b);
        } else if (E.PropTypes !== void 0 && !Me) {
          Me = !0;
          var we = _(E);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", we || "Unknown");
        }
        typeof E.getDefaultProps == "function" && !E.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function vt(b) {
      {
        for (var E = Object.keys(b.props), $ = 0; $ < E.length; $++) {
          var ae = E[$];
          if (ae !== "children" && ae !== "key") {
            de(b), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ae), de(null);
            break;
          }
        }
        b.ref !== null && (de(b), w("Invalid attribute `ref` supplied to `React.Fragment`."), de(null));
      }
    }
    var N1 = {};
    function Ba(b, E, $, ae, we, je) {
      {
        var ge = H(b);
        if (!ge) {
          var ue = "";
          (b === void 0 || typeof b == "object" && b !== null && Object.keys(b).length === 0) && (ue += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var et = Ye();
          et ? ue += et : ue += Ie();
          var Re;
          b === null ? Re = "null" : Ha(b) ? Re = "array" : b !== void 0 && b.$$typeof === t ? (Re = "<" + (_(b.type) || "Unknown") + " />", ue = " Did you accidentally export a JSX literal instead of a component?") : Re = typeof b, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Re, ue);
        }
        var Oe = a2(b, E, $, we, je);
        if (Oe == null)
          return Oe;
        if (ge) {
          var Mt = E.children;
          if (Mt !== void 0)
            if (ae)
              if (Ha(Mt)) {
                for (var ea = 0; ea < Mt.length; ea++)
                  Ot(Mt[ea], b);
                Object.freeze && Object.freeze(Mt);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ot(Mt, b);
        }
        if (nt.call(E, "key")) {
          var A1 = _(b), rt = Object.keys(E).filter(function(x6) {
            return x6 !== "key";
          }), n2 = rt.length > 0 ? "{key: someKey, " + rt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!N1[A1 + n2]) {
            var w6 = rt.length > 0 ? "{" + rt.join(": ..., ") + ": ...}" : "{}";
            w(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, n2, A1, w6, A1), N1[A1 + n2] = !0;
          }
        }
        return b === n ? vt(Oe) : qt(Oe), Oe;
      }
    }
    function k6(b, E, $) {
      return Ba(b, E, $, !0);
    }
    function g6(b, E, $) {
      return Ba(b, E, $, !1);
    }
    var v6 = g6, M6 = k6;
    Fa.Fragment = n, Fa.jsx = v6, Fa.jsxs = M6;
  }()), Fa;
}
process.env.NODE_ENV === "production" ? U2.exports = A6() : U2.exports = S6();
var l = U2.exports;
function bd(e) {
  var t, a, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (a = bd(e[t])) && (n && (n += " "), n += a);
  } else for (a in e) e[a] && (n && (n += " "), n += a);
  return n;
}
function he() {
  for (var e, t, a = 0, n = "", o = arguments.length; a < o; a++) (e = arguments[a]) && (t = bd(e)) && (n && (n += " "), n += t);
  return n;
}
const Fi = "-", I6 = (e) => {
  const t = z6(e), {
    conflictingClassGroups: a,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (s) => {
      const c = s.split(Fi);
      return c[0] === "" && c.length !== 1 && c.shift(), Ld(c, t) || T6(s);
    },
    getConflictingClassGroupIds: (s, c) => {
      const f = a[s] || [];
      return c && n[s] ? [...f, ...n[s]] : f;
    }
  };
}, Ld = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const a = e[0], n = t.nextPart.get(a), o = n ? Ld(e.slice(1), n) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(Fi);
  return (s = t.validators.find(({
    validator: c
  }) => c(i))) == null ? void 0 : s.classGroupId;
}, Js = /^\[(.+)\]$/, T6 = (e) => {
  if (Js.test(e)) {
    const t = Js.exec(e)[1], a = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (a)
      return "arbitrary.." + a;
  }
}, z6 = (e) => {
  const {
    theme: t,
    prefix: a
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return _6(Object.entries(e.classGroups), a).forEach(([i, s]) => {
    W2(s, n, i, t);
  }), n;
}, W2 = (e, t, a, n) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? t : Ks(t, o);
      i.classGroupId = a;
      return;
    }
    if (typeof o == "function") {
      if (D6(o)) {
        W2(o(n), t, a, n);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: a
      });
      return;
    }
    Object.entries(o).forEach(([i, s]) => {
      W2(s, Ks(t, i), a, n);
    });
  });
}, Ks = (e, t) => {
  let a = e;
  return t.split(Fi).forEach((n) => {
    a.nextPart.has(n) || a.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), a = a.nextPart.get(n);
  }), a;
}, D6 = (e) => e.isThemeGetter, _6 = (e, t) => t ? e.map(([a, n]) => {
  const o = n.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([s, c]) => [t + s, c])) : i);
  return [a, o];
}) : e, P6 = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, a = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const o = (i, s) => {
    a.set(i, s), t++, t > e && (t = 0, n = a, a = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let s = a.get(i);
      if (s !== void 0)
        return s;
      if ((s = n.get(i)) !== void 0)
        return o(i, s), s;
    },
    set(i, s) {
      a.has(i) ? a.set(i, s) : o(i, s);
    }
  };
}, jd = "!", E6 = (e) => {
  const {
    separator: t,
    experimentalParseClassName: a
  } = e, n = t.length === 1, o = t[0], i = t.length, s = (c) => {
    const f = [];
    let d = 0, u = 0, h;
    for (let g = 0; g < c.length; g++) {
      let M = c[g];
      if (d === 0) {
        if (M === o && (n || c.slice(g, g + i) === t)) {
          f.push(c.slice(u, g)), u = g + i;
          continue;
        }
        if (M === "/") {
          h = g;
          continue;
        }
      }
      M === "[" ? d++ : M === "]" && d--;
    }
    const y = f.length === 0 ? c : c.substring(u), m = y.startsWith(jd), v = m ? y.substring(1) : y, k = h && h > u ? h - u : void 0;
    return {
      modifiers: f,
      hasImportantModifier: m,
      baseClassName: v,
      maybePostfixModifierPosition: k
    };
  };
  return a ? (c) => a({
    className: c,
    parseClassName: s
  }) : s;
}, R6 = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let a = [];
  return e.forEach((n) => {
    n[0] === "[" ? (t.push(...a.sort(), n), a = []) : a.push(n);
  }), t.push(...a.sort()), t;
}, H6 = (e) => ({
  cache: P6(e.cacheSize),
  parseClassName: E6(e),
  ...I6(e)
}), V6 = /\s+/, O6 = (e, t) => {
  const {
    parseClassName: a,
    getClassGroupId: n,
    getConflictingClassGroupIds: o
  } = t, i = [], s = e.trim().split(V6);
  let c = "";
  for (let f = s.length - 1; f >= 0; f -= 1) {
    const d = s[f], {
      modifiers: u,
      hasImportantModifier: h,
      baseClassName: y,
      maybePostfixModifierPosition: m
    } = a(d);
    let v = !!m, k = n(v ? y.substring(0, m) : y);
    if (!k) {
      if (!v) {
        c = d + (c.length > 0 ? " " + c : c);
        continue;
      }
      if (k = n(y), !k) {
        c = d + (c.length > 0 ? " " + c : c);
        continue;
      }
      v = !1;
    }
    const g = R6(u).join(":"), M = h ? g + jd : g, w = M + k;
    if (i.includes(w))
      continue;
    i.push(w);
    const x = o(k, v);
    for (let C = 0; C < x.length; ++C) {
      const L = x[C];
      i.push(M + L);
    }
    c = d + (c.length > 0 ? " " + c : c);
  }
  return c;
};
function q6() {
  let e = 0, t, a, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (a = Nd(t)) && (n && (n += " "), n += a);
  return n;
}
const Nd = (e) => {
  if (typeof e == "string")
    return e;
  let t, a = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = Nd(e[n])) && (a && (a += " "), a += t);
  return a;
};
function B6(e, ...t) {
  let a, n, o, i = s;
  function s(f) {
    const d = t.reduce((u, h) => h(u), e());
    return a = H6(d), n = a.cache.get, o = a.cache.set, i = c, c(f);
  }
  function c(f) {
    const d = n(f);
    if (d)
      return d;
    const u = O6(f, a);
    return o(f, u), u;
  }
  return function() {
    return i(q6.apply(null, arguments));
  };
}
const Ae = (e) => {
  const t = (a) => a[e] || [];
  return t.isThemeGetter = !0, t;
}, Ad = /^\[(?:([a-z-]+):)?(.+)\]$/i, Z6 = /^\d+\/\d+$/, F6 = /* @__PURE__ */ new Set(["px", "full", "screen"]), G6 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, $6 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, U6 = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, W6 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Y6 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Qt = (e) => ua(e) || F6.has(e) || Z6.test(e), o1 = (e) => ja(e, "length", n5), ua = (e) => !!e && !Number.isNaN(Number(e)), o2 = (e) => ja(e, "number", ua), Ga = (e) => !!e && Number.isInteger(Number(e)), Q6 = (e) => e.endsWith("%") && ua(e.slice(0, -1)), oe = (e) => Ad.test(e), r1 = (e) => G6.test(e), J6 = /* @__PURE__ */ new Set(["length", "size", "percentage"]), K6 = (e) => ja(e, J6, Sd), X6 = (e) => ja(e, "position", Sd), e5 = /* @__PURE__ */ new Set(["image", "url"]), t5 = (e) => ja(e, e5, r5), a5 = (e) => ja(e, "", o5), $a = () => !0, ja = (e, t, a) => {
  const n = Ad.exec(e);
  return n ? n[1] ? typeof t == "string" ? n[1] === t : t.has(n[1]) : a(n[2]) : !1;
}, n5 = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  $6.test(e) && !U6.test(e)
), Sd = () => !1, o5 = (e) => W6.test(e), r5 = (e) => Y6.test(e), i5 = () => {
  const e = Ae("colors"), t = Ae("spacing"), a = Ae("blur"), n = Ae("brightness"), o = Ae("borderColor"), i = Ae("borderRadius"), s = Ae("borderSpacing"), c = Ae("borderWidth"), f = Ae("contrast"), d = Ae("grayscale"), u = Ae("hueRotate"), h = Ae("invert"), y = Ae("gap"), m = Ae("gradientColorStops"), v = Ae("gradientColorStopPositions"), k = Ae("inset"), g = Ae("margin"), M = Ae("opacity"), w = Ae("padding"), x = Ae("saturate"), C = Ae("scale"), L = Ae("sepia"), N = Ae("skew"), j = Ae("space"), A = Ae("translate"), D = () => ["auto", "contain", "none"], H = () => ["auto", "hidden", "clip", "visible", "scroll"], Z = () => ["auto", oe, t], R = () => [oe, t], _ = () => ["", Qt, o1], T = () => ["auto", ua, oe], G = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], q = () => ["solid", "dashed", "dotted", "double", "none"], V = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], B = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], Q = () => ["", "0", oe], me = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], be = () => [ua, oe];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [$a],
      spacing: [Qt, o1],
      blur: ["none", "", r1, oe],
      brightness: be(),
      borderColor: [e],
      borderRadius: ["none", "", "full", r1, oe],
      borderSpacing: R(),
      borderWidth: _(),
      contrast: be(),
      grayscale: Q(),
      hueRotate: be(),
      invert: Q(),
      gap: R(),
      gradientColorStops: [e],
      gradientColorStopPositions: [Q6, o1],
      inset: Z(),
      margin: Z(),
      opacity: be(),
      padding: R(),
      saturate: be(),
      scale: be(),
      sepia: Q(),
      skew: be(),
      space: R(),
      translate: R()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", oe]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [r1]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": me()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": me()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...G(), oe]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: H()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": H()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": H()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: D()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": D()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": D()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [k]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [k]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [k]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [k]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [k]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [k]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [k]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [k]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [k]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Ga, oe]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: Z()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", oe]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: Q()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: Q()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Ga, oe]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [$a]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Ga, oe]
        }, oe]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": T()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": T()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [$a]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Ga, oe]
        }, oe]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": T()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": T()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", oe]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", oe]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [y]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [y]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [y]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...B()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...B(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...B(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [w]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [w]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [w]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [w]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [w]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [w]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [w]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [w]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [w]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [g]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [g]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [g]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [g]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [g]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [g]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [g]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [g]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [g]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [j]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [j]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", oe, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [oe, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [oe, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [r1]
        }, r1]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [oe, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [oe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [oe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [oe, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", r1, o1]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", o2]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [$a]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", oe]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", ua, o2]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Qt, oe]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", oe]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", oe]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [M]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [M]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...q(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Qt, o1]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Qt, oe]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: R()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", oe]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", oe]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [M]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...G(), X6]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", K6]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, t5]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [v]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [m]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [c]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [c]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [c]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [c]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [c]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [c]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [c]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [c]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [c]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [M]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...q(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [c]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [c]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [M]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: q()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...q()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Qt, oe]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Qt, o1]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: _()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [M]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Qt, o1]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", r1, a5]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [$a]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [M]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...V(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": V()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [a]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [f]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", r1, oe]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [d]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [h]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [L]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [a]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [f]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [d]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [h]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [M]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [L]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", oe]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: be()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", oe]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: be()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", oe]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [C]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [C]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [C]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Ga, oe]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [A]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [A]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [N]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [N]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", oe]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", oe]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": R()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": R()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": R()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": R()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": R()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": R()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": R()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": R()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": R()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": R()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": R()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": R()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": R()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": R()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": R()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": R()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": R()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": R()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", oe]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Qt, o1, o2]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, s5 = /* @__PURE__ */ B6(i5);
function S(...e) {
  return s5(he(e));
}
const Ewe = (e) => e < 1e3 ? e.toString() : e < 1e4 ? e.toString().slice(0, 1) + "," + e.toString().slice(1) : e < 1e6 ? e % 1e3 === 0 ? e / 1e3 + "K" : (e / 1e3).toFixed(1) + "K" : e % 1e6 === 0 ? e / 1e6 + "M" : (e / 1e6).toFixed(1) + "M", Rwe = (e, t, a) => {
  if ((e == null ? void 0 : e.length) > a) {
    const n = e.substring(0, t), o = e.substring((e == null ? void 0 : e.length) - t);
    return `${n}...${o}`;
  }
  return e;
}, c5 = (e) => {
  const t = e.replace("#", ""), a = parseInt(t.substr(0, 2), 16), n = parseInt(t.substr(2, 2), 16), o = parseInt(t.substr(4, 2), 16);
  return (a * 299 + n * 587 + o * 114) / 1e3 < 128;
}, Xs = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, ec = he, Lt = (e, t) => (a) => {
  var n;
  if ((t == null ? void 0 : t.variants) == null) return ec(e, a == null ? void 0 : a.class, a == null ? void 0 : a.className);
  const { variants: o, defaultVariants: i } = t, s = Object.keys(o).map((d) => {
    const u = a == null ? void 0 : a[d], h = i == null ? void 0 : i[d];
    if (u === null) return null;
    const y = Xs(u) || Xs(h);
    return o[d][y];
  }), c = a && Object.entries(a).reduce((d, u) => {
    let [h, y] = u;
    return y === void 0 || (d[h] = y), d;
  }, {}), f = t == null || (n = t.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((d, u) => {
    let { class: h, className: y, ...m } = u;
    return Object.entries(m).every((v) => {
      let [k, g] = v;
      return Array.isArray(g) ? g.includes({
        ...i,
        ...c
      }[k]) : {
        ...i,
        ...c
      }[k] === g;
    }) ? [
      ...d,
      h,
      y
    ] : d;
  }, []);
  return ec(e, s, f, a == null ? void 0 : a.class, a == null ? void 0 : a.className);
}, f5 = "data:image/jpeg;base64,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", d5 = (e) => e.charAt(0).toUpperCase(), tc = Lt("object-cover aspect-square", {
  variants: {
    variant: {
      rounded: "rounded-full drop-shadow",
      square: ""
    },
    size: {
      sm: "w-4 avatar-sm text-[10px]",
      md: "w-6 avatar-sm text-[14px]",
      lg: "w-10 avatar-sm text-[16px]",
      xl: "w-16 avatar-lg text-[20px]",
      "2xl": "w-24 avatar-lg text-[24px]",
      "3xl": "w-32 avatar-lg text-[32px]"
    },
    bordered: {
      border: "border-[#ffffff]",
      none: "border-none"
    },
    content: {
      image: "",
      text: "color-bg-tertiary color-text-secondary flex items-center justify-center"
    }
  },
  defaultVariants: {
    variant: "rounded",
    size: "md",
    bordered: "none",
    content: "image"
  }
}), zo = I.forwardRef(
  ({ src: e, alt: t, className: a, variant: n, size: o, bordered: i, content: s = "image", ...c }, f) => s === "image" ? /* @__PURE__ */ l.jsx(
    "img",
    {
      src: e || f5,
      alt: t,
      className: S(tc({ variant: n, size: o, bordered: i }), a),
      ref: f,
      ...c
    }
  ) : /* @__PURE__ */ l.jsx(
    "div",
    {
      className: S(
        "font-[700]",
        tc({ variant: n, size: o, bordered: i, content: s }),
        a
      ),
      ref: f,
      ...c,
      children: d5(t || "")
    }
  )
);
zo.displayName = "Avatar";
const Hwe = Et(
  ({
    avatars: e,
    size: t = "lg",
    variant: a = "rounded",
    bordered: n = "none",
    className: o,
    content: i,
    showCounter: s = !0
  }, c) => {
    const d = e.slice(0, 5), u = e.length;
    return /* @__PURE__ */ l.jsxs("div", { ref: c, className: S("flex items-center gap-3", o), children: [
      /* @__PURE__ */ l.jsx(
        "div",
        {
          className: S("flex overflow-hidden p-0.5", {
            "-space-x-1": t === "sm",
            "-space-x-2": t === "md" || t === "lg",
            "-space-x-4": t === "xl" || t === "2xl" || t === "3xl"
          }),
          children: d.map((h, y) => /* @__PURE__ */ l.jsx(
            zo,
            {
              ...h,
              content: i,
              alt: h.alt || "",
              size: h.size || t,
              variant: h.variant || a,
              bordered: h.bordered || n,
              className: S("inline-flex items-center", h.className)
            },
            y
          ))
        }
      ),
      s && u > 5 && /* @__PURE__ */ l.jsxs(
        "div",
        {
          className: S("color-text-secondary", {
            "text-helper-text-sm": t === "sm" || t === "md",
            "text-body-sm": t === "lg",
            "text-body-md": t === "xl",
            "text-heading-md": t === "2xl" || t === "3xl"
          }),
          children: [
            u,
            " members"
          ]
        }
      )
    ] });
  }
), l5 = {
  File3d: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M6 23H18C19.6569 23 21 21.6569 21 20V7L15 1H6C4.34315 1 3 2.34315 3 4V20C3 21.6569 4.34315 23 6 23Z",
            fill: "#E77B24",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M9.02615 13.0426C9.13756 13.0518 9.25623 13.0518 9.38217 13.0426C9.50811 13.0335 9.62435 13.0083 9.73092 12.967C9.84232 12.9211 9.93193 12.8569 9.99974 12.7744C10.0724 12.6919 10.1087 12.5818 10.1087 12.4443C10.1087 12.238 10.0361 12.0798 9.89076 11.9697C9.74545 11.8597 9.57834 11.8047 9.38943 11.8047C9.12787 11.8047 8.92928 11.8872 8.79366 12.0523C8.66288 12.2127 8.59991 12.4168 8.60475 12.6644H7.6239C7.63358 12.4168 7.6796 12.1921 7.76194 11.9904C7.84913 11.784 7.9678 11.6075 8.11796 11.4608C8.27296 11.3141 8.45702 11.2017 8.67014 11.1238C8.88327 11.0413 9.12061 11 9.38217 11C9.58561 11 9.78904 11.0298 9.99248 11.0894C10.1959 11.1444 10.3776 11.2293 10.5374 11.3439C10.7021 11.4585 10.8353 11.5983 10.937 11.7634C11.0387 11.9285 11.0896 12.1188 11.0896 12.3343C11.0896 12.5681 11.029 12.7744 10.9079 12.9532C10.7917 13.132 10.6149 13.2536 10.3776 13.3177V13.3315C10.6585 13.3911 10.8789 13.5195 11.0387 13.7166C11.1986 13.9138 11.2785 14.1499 11.2785 14.425C11.2785 14.6772 11.2252 14.9019 11.1186 15.099C11.0169 15.2962 10.8789 15.4613 10.7045 15.5942C10.5301 15.7272 10.3291 15.8281 10.1015 15.8968C9.87381 15.9656 9.63646 16 9.38943 16C9.10365 16 8.84209 15.961 8.60475 15.8831C8.37225 15.8051 8.17366 15.6928 8.00897 15.5461C7.84429 15.3948 7.71593 15.2114 7.6239 14.9959C7.53671 14.7804 7.49554 14.5328 7.50038 14.2531H8.48124C8.48608 14.3815 8.50788 14.5053 8.54663 14.6245C8.58538 14.7391 8.64108 14.84 8.71373 14.9271C8.78639 15.0096 8.876 15.0761 8.98256 15.1265C9.09397 15.177 9.22475 15.2022 9.3749 15.2022C9.6074 15.2022 9.80357 15.1357 9.96342 15.0028C10.1233 14.8652 10.2032 14.6795 10.2032 14.4457C10.2032 14.2623 10.1644 14.1224 10.0869 14.0261C10.0143 13.9298 9.91982 13.8611 9.80357 13.8198C9.68732 13.774 9.55896 13.7487 9.4185 13.7442C9.28287 13.735 9.15209 13.7304 9.02615 13.7304V13.0426Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M13.0488 15.0028H14.066C14.2307 15.0028 14.3906 14.9775 14.5456 14.9271C14.7006 14.8767 14.8386 14.7941 14.9597 14.6795C15.0808 14.5603 15.1777 14.4067 15.2503 14.2187C15.323 14.0307 15.3593 13.8015 15.3593 13.5309C15.3593 13.2834 15.3327 13.061 15.2794 12.8638C15.2309 12.6621 15.1486 12.4901 15.0324 12.348C14.9161 12.2059 14.7611 12.0981 14.5674 12.0248C14.3784 11.9468 14.1435 11.9078 13.8626 11.9078H13.0488V15.0028ZM11.9082 11H14.146C14.4802 11 14.7902 11.0504 15.0759 11.1513C15.3666 11.2522 15.616 11.4035 15.8243 11.6052C16.0374 11.807 16.2021 12.0591 16.3184 12.3618C16.4395 12.6644 16.5 13.0197 16.5 13.4278C16.5 13.7854 16.4516 14.1155 16.3547 14.4182C16.2578 14.7208 16.1101 14.9821 15.9115 15.2022C15.7177 15.4223 15.4731 15.5965 15.1777 15.7249C14.887 15.8487 14.5431 15.9106 14.146 15.9106H11.9082V11Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M15 6V1L21 7H16C15.4477 7 15 6.55228 15 6Z",
            fill: "#E77B24",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M15 6V1L21 7H16C15.4477 7 15 6.55228 15 6Z",
            fill: "black",
            fillOpacity: "0.2",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  FileWord: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M6 23H18C19.6569 23 21 21.6569 21 20V7L15 1H6C4.34315 1 3 2.34315 3 4V20C3 21.6569 4.34315 23 6 23Z",
            fill: "#0067CD",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M15 6V1L21 7H16C15.4477 7 15 6.55228 15 6Z",
            fill: "#0067CD",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M15 6V1L21 7H16C15.4477 7 15 6.55228 15 6Z",
            fill: "black",
            fillOpacity: "0.2",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M6.87484 15.0094H7.65496C7.78126 15.0094 7.90385 14.9848 8.02272 14.9357C8.1416 14.8867 8.24747 14.8063 8.34034 14.6948C8.43321 14.5788 8.50751 14.4293 8.56323 14.2463C8.61895 14.0634 8.64682 13.8403 8.64682 13.577C8.64682 13.336 8.62638 13.1196 8.58552 12.9277C8.54837 12.7314 8.48522 12.564 8.39606 12.4257C8.30691 12.2874 8.18803 12.1825 8.03944 12.1111C7.89456 12.0353 7.71439 11.9973 7.49893 11.9973H6.87484V15.0094ZM6 11.1138H7.71625C7.97257 11.1138 8.21032 11.1629 8.4295 11.261C8.65239 11.3592 8.8437 11.5065 9.00344 11.7028C9.16689 11.8992 9.2932 12.1446 9.38235 12.4391C9.47522 12.7336 9.52166 13.0794 9.52166 13.4766C9.52166 13.8246 9.48451 14.1459 9.41021 14.4404C9.33592 14.7349 9.22261 14.9893 9.07031 15.2035C8.92171 15.4177 8.73411 15.5872 8.50751 15.7122C8.28462 15.8327 8.02087 15.8929 7.71625 15.8929H6V11.1138Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M10.8323 13.5234C10.8323 13.7242 10.8509 13.9206 10.888 14.1124C10.9289 14.2999 10.992 14.4694 11.0775 14.6212C11.1629 14.7729 11.2744 14.8956 11.4118 14.9893C11.5493 15.0785 11.7164 15.1232 11.9133 15.1232C12.1102 15.1232 12.2774 15.0785 12.4148 14.9893C12.5523 14.8956 12.6637 14.7729 12.7492 14.6212C12.8346 14.4694 12.8959 14.2999 12.933 14.1124C12.9739 13.9206 12.9943 13.7242 12.9943 13.5234C12.9943 13.3137 12.9739 13.1107 12.933 12.9143C12.8959 12.718 12.8346 12.544 12.7492 12.3922C12.6637 12.2361 12.5523 12.1133 12.4148 12.0241C12.2774 11.9304 12.1102 11.8835 11.9133 11.8835C11.7164 11.8835 11.5493 11.9304 11.4118 12.0241C11.2744 12.1133 11.1629 12.2361 11.0775 12.3922C10.992 12.544 10.9289 12.718 10.888 12.9143C10.8509 13.1107 10.8323 13.3137 10.8323 13.5234ZM9.95747 13.5234C9.95747 13.1664 10.002 12.8362 10.0912 12.5328C10.1804 12.2249 10.3085 11.9572 10.4757 11.7296C10.6429 11.502 10.8472 11.3235 11.0886 11.1941C11.3338 11.0647 11.6087 11 11.9133 11C12.2217 11 12.4966 11.0647 12.738 11.1941C12.9795 11.3235 13.1838 11.502 13.351 11.7296C13.5181 11.9572 13.6463 12.2249 13.7354 12.5328C13.8246 12.8362 13.8692 13.1664 13.8692 13.5234C13.8692 13.8715 13.8246 14.1972 13.7354 14.5007C13.6463 14.7996 13.5181 15.0607 13.351 15.2838C13.1838 15.5069 12.9795 15.6832 12.738 15.8126C12.4966 15.9375 12.2217 16 11.9133 16C11.6087 16 11.3338 15.9375 11.0886 15.8126C10.8472 15.6832 10.6429 15.5069 10.4757 15.2838C10.3085 15.0607 10.1804 14.7996 10.0912 14.5007C10.002 14.1972 9.95747 13.8715 9.95747 13.5234Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M17.1196 12.7202C17.1047 12.5997 17.0713 12.4904 17.0193 12.3922C16.9673 12.2896 16.9023 12.2004 16.8243 12.1245C16.7462 12.0486 16.6571 11.9906 16.5568 11.9505C16.4602 11.9058 16.358 11.8835 16.2503 11.8835C16.0534 11.8835 15.8863 11.9304 15.7488 12.0241C15.6114 12.1133 15.4999 12.2361 15.4145 12.3922C15.329 12.544 15.2659 12.718 15.225 12.9143C15.1879 13.1107 15.1693 13.3137 15.1693 13.5234C15.1693 13.7242 15.1879 13.9206 15.225 14.1124C15.2659 14.2999 15.329 14.4694 15.4145 14.6212C15.4999 14.7729 15.6114 14.8956 15.7488 14.9893C15.8863 15.0785 16.0534 15.1232 16.2503 15.1232C16.5178 15.1232 16.7258 15.025 16.8744 14.8286C17.0267 14.6323 17.1196 14.3735 17.153 14.0522H18C17.9777 14.3512 17.9201 14.6212 17.8273 14.8621C17.7344 15.1031 17.6118 15.3083 17.4595 15.4779C17.3072 15.6475 17.1289 15.7769 16.9246 15.8661C16.7202 15.9554 16.4955 16 16.2503 16C15.9457 16 15.6708 15.9375 15.4256 15.8126C15.1842 15.6832 14.9798 15.5069 14.8127 15.2838C14.6455 15.0607 14.5173 14.7996 14.4282 14.5007C14.339 14.1972 14.2945 13.8715 14.2945 13.5234C14.2945 13.1664 14.339 12.8362 14.4282 12.5328C14.5173 12.2249 14.6455 11.9572 14.8127 11.7296C14.9798 11.502 15.1842 11.3235 15.4256 11.1941C15.6708 11.0647 15.9457 11 16.2503 11C16.4695 11 16.6757 11.0379 16.8688 11.1138C17.0657 11.1896 17.2403 11.3012 17.3926 11.4485C17.5486 11.5913 17.6768 11.7697 17.7771 11.9839C17.8774 12.1981 17.9406 12.4436 17.9666 12.7202H17.1196Z",
            fill: "white",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  FilePdf: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M6 23H18C19.6569 23 21 21.6569 21 20V7L15 1H6C4.34315 1 3 2.34315 3 4V20C3 21.6569 4.34315 23 6 23Z",
            fill: "#FB3449",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M15 6V1L21 7H16C15.4477 7 15 6.55228 15 6Z",
            fill: "#C41124",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M6.98628 13.3529H7.75269C7.86577 13.3529 7.97466 13.3436 8.07936 13.3249C8.18406 13.3063 8.2762 13.2712 8.35577 13.2199C8.43534 13.1639 8.49816 13.0868 8.54423 12.9888C8.59449 12.8908 8.61962 12.7624 8.61962 12.6036C8.61962 12.4449 8.59449 12.3165 8.54423 12.2185C8.49816 12.1204 8.43534 12.0458 8.35577 11.9944C8.2762 11.9384 8.18406 11.901 8.07936 11.8824C7.97466 11.8637 7.86577 11.8543 7.75269 11.8543H6.98628V13.3529ZM6 11H8.02282C8.30342 11 8.54214 11.0467 8.73898 11.1401C8.93581 11.2288 9.09496 11.3478 9.21641 11.4972C9.34205 11.6466 9.4321 11.817 9.48654 12.0084C9.54517 12.1998 9.57449 12.3982 9.57449 12.6036C9.57449 12.8044 9.54517 13.0028 9.48654 13.1989C9.4321 13.3903 9.34205 13.5607 9.21641 13.7101C9.09496 13.8595 8.93581 13.9809 8.73898 14.0742C8.54214 14.1629 8.30342 14.2073 8.02282 14.2073H6.98628V16H6V11Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M11.1764 15.0756H12.0559C12.1982 15.0756 12.3365 15.05 12.4705 14.9986C12.6045 14.9472 12.7238 14.8632 12.8285 14.7465C12.9332 14.6251 13.017 14.4687 13.0798 14.2773C13.1426 14.0859 13.1741 13.8525 13.1741 13.577C13.1741 13.3249 13.151 13.0985 13.105 12.8978C13.0631 12.6923 12.9919 12.5173 12.8914 12.3725C12.7909 12.2278 12.6568 12.1181 12.4893 12.0434C12.326 11.9641 12.1229 11.9244 11.88 11.9244H11.1764V15.0756ZM10.1901 11H12.125C12.4139 11 12.682 11.0514 12.9291 11.1541C13.1803 11.2568 13.396 11.4108 13.5761 11.6162C13.7604 11.8217 13.9028 12.0784 14.0033 12.3866C14.108 12.6947 14.1603 13.0565 14.1603 13.472C14.1603 13.8361 14.1185 14.1723 14.0347 14.4804C13.9509 14.7885 13.8232 15.0546 13.6515 15.2787C13.484 15.5028 13.2725 15.6802 13.017 15.8109C12.7657 15.937 12.4684 16 12.125 16H10.1901V11Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M14.8464 11H18V11.9244H15.8327V13.0798H17.711V13.9342H15.8327V16H14.8464V11Z",
            fill: "white",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  FilePpt: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M6 23H18C19.6569 23 21 21.6569 21 20V7L15 1H6C4.34315 1 3 2.34315 3 4V20C3 21.6569 4.34315 23 6 23Z",
            fill: "#DF3114",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M15 6V1L21 7H16C15.4477 7 15 6.55228 15 6Z",
            fill: "#DF3114",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M15 6V1L21 7H16C15.4477 7 15 6.55228 15 6Z",
            fill: "black",
            fillOpacity: "0.2",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M7.01128 13.3529H7.79712C7.91306 13.3529 8.02471 13.3436 8.13206 13.3249C8.23942 13.3063 8.33389 13.2712 8.41548 13.2199C8.49707 13.1639 8.56148 13.0868 8.60872 12.9888C8.66025 12.8908 8.68601 12.7624 8.68601 12.6036C8.68601 12.4449 8.66025 12.3165 8.60872 12.2185C8.56148 12.1204 8.49707 12.0458 8.41548 11.9944C8.33389 11.9384 8.23942 11.901 8.13206 11.8824C8.02471 11.8637 7.91306 11.8543 7.79712 11.8543H7.01128V13.3529ZM6 11H8.07409C8.3618 11 8.60657 11.0467 8.8084 11.1401C9.01022 11.2288 9.1734 11.3478 9.29793 11.4972C9.42676 11.6466 9.51908 11.817 9.57491 12.0084C9.63503 12.1998 9.66509 12.3982 9.66509 12.6036C9.66509 12.8044 9.63503 13.0028 9.57491 13.1989C9.51908 13.3903 9.42676 13.5607 9.29793 13.7101C9.1734 13.8595 9.01022 13.9809 8.8084 14.0742C8.60657 14.1629 8.3618 14.2073 8.07409 14.2073H7.01128V16H6V11Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M11.3076 13.3529H12.0934C12.2093 13.3529 12.321 13.3436 12.4283 13.3249C12.5357 13.3063 12.6302 13.2712 12.7118 13.2199C12.7934 13.1639 12.8578 13.0868 12.905 12.9888C12.9565 12.8908 12.9823 12.7624 12.9823 12.6036C12.9823 12.4449 12.9565 12.3165 12.905 12.2185C12.8578 12.1204 12.7934 12.0458 12.7118 11.9944C12.6302 11.9384 12.5357 11.901 12.4283 11.8824C12.321 11.8637 12.2093 11.8543 12.0934 11.8543H11.3076V13.3529ZM10.2963 11H12.3704C12.6581 11 12.9029 11.0467 13.1047 11.1401C13.3065 11.2288 13.4697 11.3478 13.5942 11.4972C13.723 11.6466 13.8154 11.817 13.8712 12.0084C13.9313 12.1998 13.9614 12.3982 13.9614 12.6036C13.9614 12.8044 13.9313 13.0028 13.8712 13.1989C13.8154 13.3903 13.723 13.5607 13.5942 13.7101C13.4697 13.8595 13.3065 13.9809 13.1047 14.0742C12.9029 14.1629 12.6581 14.2073 12.3704 14.2073H11.3076V16H10.2963V11Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M15.6103 11.9244H14.2319V11H18V11.9244H16.6216V16H15.6103V11.9244Z",
            fill: "white",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  FileExcel: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M6 23H18C19.6569 23 21 21.6569 21 20V7L15 1H6C4.34315 1 3 2.34315 3 4V20C3 21.6569 4.34315 23 6 23Z",
            fill: "#317C38",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M7.58115 13.3896L6.12065 11.1138H7.27635L8.16535 12.6399L9.0861 11.1138H10.1783L8.72415 13.3963L10.3053 15.8929H9.11785L8.12725 14.2396L7.1176 15.8929H6L7.58115 13.3896Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M10.7053 11.1138H11.7022V15.0094H13.912V15.8929H10.7053V11.1138Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M15.1489 14.3066C15.1489 14.4672 15.1764 14.6033 15.2314 14.7149C15.2864 14.8264 15.3584 14.9179 15.4473 14.9893C15.5404 15.0562 15.6484 15.1075 15.7712 15.1432C15.8939 15.1745 16.0209 15.1901 16.1522 15.1901C16.2411 15.1901 16.3363 15.1834 16.4379 15.17C16.5395 15.1522 16.6348 15.1209 16.7237 15.0763C16.8126 15.0317 16.8866 14.9714 16.9459 14.8956C17.0052 14.8153 17.0348 14.7149 17.0348 14.5944C17.0348 14.465 16.9946 14.3601 16.9142 14.2798C16.838 14.1995 16.7364 14.1325 16.6094 14.079C16.4824 14.0254 16.3384 13.9786 16.1776 13.9384C16.0167 13.8983 15.8537 13.8536 15.6886 13.8046C15.5193 13.7599 15.3542 13.7064 15.1933 13.6439C15.0324 13.577 14.8885 13.4922 14.7615 13.3896C14.6345 13.2869 14.5308 13.1597 14.4504 13.008C14.3742 12.8519 14.3361 12.6644 14.3361 12.4458C14.3361 12.2004 14.3847 11.9884 14.4821 11.8099C14.5837 11.627 14.7149 11.4752 14.8758 11.3548C15.0367 11.2343 15.2187 11.145 15.4219 11.087C15.6251 11.029 15.8283 11 16.0315 11C16.2686 11 16.4951 11.029 16.711 11.087C16.9311 11.1406 17.1258 11.2298 17.2952 11.3548C17.4645 11.4797 17.5978 11.6403 17.6952 11.8367C17.7968 12.0286 17.8476 12.2628 17.8476 12.5395H16.8824C16.8739 12.3967 16.8443 12.2784 16.7935 12.1847C16.7469 12.091 16.6834 12.0174 16.603 11.9639C16.5226 11.9103 16.4294 11.8724 16.3236 11.8501C16.222 11.8278 16.1098 11.8166 15.9871 11.8166C15.9066 11.8166 15.8262 11.8255 15.7458 11.8434C15.6653 11.8612 15.5912 11.8925 15.5235 11.9371C15.46 11.9817 15.4071 12.0375 15.3648 12.1044C15.3224 12.1714 15.3013 12.2561 15.3013 12.3588C15.3013 12.4525 15.3182 12.5283 15.3521 12.5863C15.3859 12.6444 15.4515 12.6979 15.5489 12.747C15.6505 12.7961 15.7881 12.8452 15.9617 12.8942C16.1395 12.9433 16.3702 13.0058 16.6538 13.0817C16.7385 13.0995 16.8549 13.133 17.0031 13.1821C17.1555 13.2267 17.3057 13.3003 17.4539 13.4029C17.6021 13.5056 17.7291 13.6439 17.8349 13.8179C17.945 13.9875 18 14.2062 18 14.4739C18 14.6925 17.9598 14.8956 17.8794 15.083C17.7989 15.2704 17.6783 15.4333 17.5174 15.5716C17.3608 15.7055 17.1639 15.8104 16.9269 15.8862C16.694 15.9621 16.4231 16 16.1141 16C15.8643 16 15.6209 15.9665 15.3838 15.8996C15.151 15.8371 14.9435 15.7367 14.7615 15.5984C14.5837 15.4601 14.4419 15.2838 14.3361 15.0696C14.2302 14.8554 14.1794 14.6011 14.1837 14.3066H15.1489Z",
            fill: "white",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M15 6V1L21 7H16C15.4477 7 15 6.55228 15 6Z",
            fill: "#27632D",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  Section: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M4 2C2.89543 2 2 2.89543 2 4V9C2 10.1046 2.89543 11 4 11H20C21.1046 11 22 10.1046 22 9V4C22 2.89543 21.1046 2 20 2H4Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2 15C2 13.8954 2.89543 13 4 13H9C10.1046 13 11 13.8954 11 15V20C11 21.1046 10.1046 22 9 22H4C2.89543 22 2 21.1046 2 20V15ZM9 15H4V20H9V15Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15 13C13.8954 13 13 13.8954 13 15V20C13 21.1046 13.8954 22 15 22H20C21.1046 22 22 21.1046 22 20V15C22 13.8954 21.1046 13 20 13H15ZM15 15H20V20H15V15Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  XSocial: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          d: "M18.244 2.25H21.552L14.325 10.51L22.827 21.75H16.17L10.956 14.933L4.99 21.75H1.68L9.41 12.915L1.254 2.25H8.08L12.793 8.481L18.244 2.25ZM17.083 19.77H18.916L7.084 4.126H5.117L17.083 19.77Z",
          fill: "currentColor",
          stroke: "transparent"
        }
      )
    }
  ),
  Farcaster: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.94205 24.0001H18.0579C21.3344 24.0001 24 21.3347 24 18.0581V5.94228C24 2.66575 21.3344 0.00012207 18.0579 0.00012207H5.94205C2.66561 0.00012207 0 2.66575 0 5.94228V18.0581C0 21.3347 2.66561 24.0001 5.94205 24.0001Z",
            fill: "#9C7BD2",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M6.74561 5H17.0654V6.98676H20L19.385 8.97401H18.8643V17.0132C19.1254 17.0132 19.3374 17.2151 19.3374 17.4644V18.0064H19.4321C19.6938 18.0064 19.9058 18.2087 19.9058 18.4581V19H14.6035V18.4581C14.6035 18.2087 14.8155 18.0064 15.0772 18.0064H15.1719V17.4644C15.1719 17.2476 15.3323 17.0666 15.5458 17.0229L15.5358 12.5871C15.3684 10.8147 13.8071 9.4257 11.9055 9.4257C10.0039 9.4257 8.44269 10.8147 8.27529 12.5871L8.26526 17.0191C8.51787 17.055 8.82862 17.2408 8.82862 17.4644V18.0064H8.92335C9.18448 18.0064 9.39648 18.2087 9.39648 18.4581V19H4.09473V18.4581C4.09473 18.2087 4.30674 18.0064 4.56787 18.0064H4.66259V17.4644C4.66259 17.2151 4.8746 17.0132 5.13623 17.0132V8.97401H4.61548L4 6.98676H6.74561V5Z",
            fill: "white",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  Farcaster2: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: [
        /* @__PURE__ */ l.jsxs("g", { clipPath: "url(#clip0_2230_11557)", children: [
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M4.95171 20.0001H15.0483C17.7787 20.0001 20 17.7789 20 15.0484V4.95192C20 2.22148 17.7787 0.00012207 15.0483 0.00012207H4.95171C2.22134 0.00012207 0 2.22148 0 4.95192V15.0484C0 17.7789 2.22134 20.0001 4.95171 20.0001Z",
              fill: "#363B3F",
              stroke: "transparent"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              d: "M5.62004 4.16667H14.2199V5.8223H16.6654L16.1529 7.47834H15.7189V14.1777C15.9365 14.1777 16.1132 14.3459 16.1132 14.5537V15.0053H16.1921C16.4102 15.0053 16.5868 15.1739 16.5868 15.3817V15.8333H12.1683V15.3817C12.1683 15.1739 12.345 15.0053 12.563 15.0053H12.6419V14.5537C12.6419 14.373 12.7756 14.2222 12.9535 14.1858L12.9452 10.4892C12.8057 9.01228 11.5046 7.85475 9.91997 7.85475C8.33532 7.85475 7.03427 9.01228 6.89477 10.4892L6.88642 14.1825C7.09692 14.2125 7.35588 14.3673 7.35588 14.5537V15.0053H7.43482C7.65243 15.0053 7.8291 15.1739 7.8291 15.3817V15.8333H3.41097V15.3817C3.41097 15.1739 3.58765 15.0053 3.80525 15.0053H3.88419V14.5537C3.88419 14.3459 4.06087 14.1777 4.27889 14.1777V7.47834H3.84493L3.33203 5.8223H5.62004V4.16667Z",
              fill: "white",
              stroke: "transparent"
            }
          )
        ] }),
        /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_2230_11557", children: /* @__PURE__ */ l.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  ),
  Warpcast: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.94021 23.9926H18.0523C21.3278 23.9926 23.9926 21.328 23.9926 18.0524V5.94042C23.9926 2.66491 21.3278 0.00012207 18.0523 0.00012207H5.94021C2.66478 0.00012207 0 2.66491 0 5.94042V18.0524C0 21.328 2.66478 23.9926 5.94021 23.9926ZM14.5601 12.036L15.7431 7.59302H18.8537L15.9693 17.4164H13.2796L11.9963 12.8548L10.713 17.4164H8.02911L5.13837 7.59302H8.24928L9.4436 12.0687L10.6419 7.59302H13.3732L14.5601 12.036Z",
          fill: "#472A91",
          stroke: "transparent"
        }
      )
    }
  ),
  Orb: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          d: "M17.796 17.765C16.8878 17.765 16.1515 17.0161 16.1515 16.0923C16.1515 15.1685 16.8878 14.4197 17.796 14.4197C18.7043 14.4197 19.4406 15.1685 19.4406 16.0923C19.4406 17.0161 18.7043 17.765 17.796 17.765ZM11.8973 17.0568C9.21939 17.0508 7.05352 14.8308 7.05974 12.0986C7.06596 9.36629 9.24192 7.15626 11.9198 7.16239C14.5978 7.16847 16.7636 9.38842 16.7574 12.1207C16.7512 14.853 14.5752 17.063 11.8973 17.0568ZM11.9086 2C6.43623 2 2 6.52623 2 12.1096C2 17.693 6.43623 22.2192 11.9086 22.2192C17.3809 22.2192 21.8172 17.693 21.8172 12.1096C21.8172 6.52623 17.3809 2 11.9086 2Z",
          fill: "currentColor",
          stroke: "transparent"
        }
      )
    }
  ),
  Lens: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.13345 6.00367C8.43578 6.59243 7.94215 7.42741 7.7944 8.48231C6.92985 7.83972 5.97908 7.59271 5.06155 7.66165C4.00699 7.74088 3.03594 8.23368 2.31314 8.94462C1.59027 9.65561 1.091 10.609 1.01119 11.642C0.930416 12.6875 1.28297 13.7784 2.19955 14.7294L2.20052 14.7304C2.28214 14.8146 2.36504 14.8984 2.44923 14.9817L2.45048 14.9829C6.53742 19.0001 11.964 19 11.9998 19C12.0356 19 17.4625 19.0001 21.5493 14.9835C21.635 14.8997 21.7192 14.8147 21.8017 14.7285C22.7176 13.7768 23.0698 12.6858 22.9887 11.6403C22.9087 10.6071 22.4091 9.65386 21.686 8.94311C20.9629 8.23242 19.9918 7.74002 18.9373 7.66112C18.0199 7.59246 17.0693 7.83976 16.2052 8.48259C16.0575 7.42756 15.5639 6.59248 14.8661 6.00366C14.0647 5.32733 13.0238 5 11.9998 5C10.9758 5 9.93489 5.32733 9.13345 6.00367ZM15.6995 9.24238C15.6998 9.28481 15.6998 9.32661 15.6998 9.36687C15.6998 9.32798 15.6998 9.28765 15.6995 9.24671L15.6995 9.24238ZM8.07645 9.45821C8.04533 9.42788 8.01375 9.39733 7.98198 9.36687C7.93118 9.31816 7.87989 9.26964 7.82917 9.22252C7.81547 9.20978 7.80173 9.19717 7.78798 9.18469C7.7745 9.17246 7.76099 9.16035 7.74747 9.14837C7.7748 9.17258 7.80204 9.1973 7.82917 9.22252C7.91162 9.29912 7.99556 9.37939 8.07645 9.45821Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.7388 13.5351C14.6387 13.5351 14.6044 13.6804 14.6683 13.7571C14.7804 13.8917 14.8479 14.065 14.8479 14.254C14.8479 14.6827 14.5008 15.0302 14.0727 15.0302C13.6447 15.0302 13.2976 14.6827 13.2976 14.254C13.2976 14.2303 13.2667 14.2184 13.2527 14.2377C13.1313 14.4055 13.0492 14.5938 13.0156 14.7915C12.9967 14.9025 12.9065 14.9945 12.7932 14.9945H12.7294C12.5808 14.9945 12.4582 14.8739 12.4802 14.7278C12.6305 13.7263 13.6161 13 14.7388 13C15.8614 13 16.8472 13.7263 16.9975 14.7278C17.0193 14.8739 16.8968 14.9945 16.7482 14.9945C16.5997 14.9945 16.482 14.8733 16.4498 14.7291C16.3028 14.0727 15.6216 13.5351 14.7388 13.5351ZM7.856 14.254C7.856 14.2225 7.81516 14.2055 7.79606 14.2306C7.66637 14.401 7.57807 14.5938 7.54077 14.7969C7.51878 14.9165 7.42165 15.0159 7.29939 15.0159H7.25177C7.1032 15.0159 6.98064 14.8953 7.00255 14.7491C7.15278 13.7471 8.13857 13.0213 9.26121 13.0213C10.3839 13.0213 11.3696 13.7471 11.5199 14.7491C11.5418 14.8953 11.4192 15.0159 11.2707 15.0159C11.1221 15.0159 11.0044 14.8947 10.9722 14.7504C10.8253 14.0936 10.1441 13.5564 9.26121 13.5564C9.17959 13.5564 9.15007 13.6718 9.20477 13.732C9.32992 13.8699 9.40621 14.053 9.40621 14.254C9.40621 14.6827 9.05917 15.0302 8.6311 15.0302C8.20304 15.0302 7.856 14.6827 7.856 14.254ZM13.2751 16.0413C13.1447 15.9704 12.9824 16.0212 12.8775 16.1258C12.675 16.3273 12.3682 16.4649 12.0131 16.4649C11.6571 16.4649 11.3506 16.3287 11.1486 16.127C11.0438 16.0223 10.8818 15.9709 10.7511 16.0413C10.6205 16.1116 10.5704 16.276 10.6641 16.3907C10.9705 16.7663 11.467 17 12.0131 17C12.5595 17 13.0549 16.7638 13.361 16.391C13.4549 16.2766 13.4055 16.1121 13.2751 16.0413Z",
            fill: "white",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  Hey: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          d: "M21.3805 7.95042C21.1362 7.7597 20.6589 7.50905 19.9941 7.78695C20.6703 6.32118 21.0793 4.62109 20.0112 4.14703C19.0737 3.73291 18.2215 4.41948 17.5226 5.27497C17.9203 4.21242 18.2441 2.7085 17.2953 2.21809C16.1647 1.63505 14.8579 2.28348 14.2158 3.42232C14.1022 3.62393 13.7386 4.17973 13.1648 5.29677C13.3466 4.41403 13.1648 3.58034 12.6193 3.17711C12.1591 2.83383 11.5398 2.81203 10.9716 3.11718C10.6648 3.28064 9.52277 4.23966 7.66486 9.68319C7.57963 9.92839 7.72168 10.19 7.97735 10.2717C8.23303 10.3534 8.50575 10.2172 8.59098 9.97199C9.50005 7.31288 10.8523 4.24511 11.4489 3.92907C11.5795 3.85824 11.8295 3.76016 12.0284 3.90728C12.2329 4.05984 12.3977 4.49577 12.1989 5.22593C11.767 6.77344 11.4375 8.69693 11.4205 8.77866C11.3807 9.00752 11.5227 9.23093 11.7557 9.30177C11.9886 9.3726 12.2329 9.26907 12.3409 9.05656C13.3466 7.04589 14.6476 4.49032 14.9147 4.0217C15.3806 3.19891 16.1022 2.59952 16.801 2.93735C17.6532 3.35148 16.801 5.53652 15.0681 9.30722C14.9601 9.54152 15.0681 9.81397 15.3125 9.92295C15.551 10.0319 15.8408 9.92839 15.9544 9.69954C17.5169 6.55003 18.784 4.2887 19.7441 4.96983C20.3521 5.40574 18.8975 7.89593 18.1078 9.40529C17.7953 9.99924 17.4999 10.5605 17.2556 11.0781C17.1192 11.3397 17.0113 11.574 16.9431 11.7647C16.926 11.8083 16.909 11.8355 16.9033 11.8464L16.9147 11.8519C16.8692 11.999 16.8465 12.1135 16.8635 12.1734C16.9147 12.3695 17.0851 12.5112 17.2953 12.5276C17.5453 12.5494 17.659 12.4676 17.7897 12.2224C17.7897 12.217 17.7953 12.2115 17.7953 12.2061C17.8521 12.1025 17.909 11.9664 17.9828 11.7974C18.5056 10.7512 19.6816 8.79501 20.4884 8.5934C20.5964 8.56615 20.6759 8.5825 20.7668 8.65334C21.6646 9.3617 20.2271 12.8164 18.9715 14.9306C18.9374 14.9959 15.3181 20.8209 11.2102 21.0443C9.92617 21.1479 8.7387 20.3033 8.72733 20.2978C8.72165 20.2923 8.71029 20.2869 8.70461 20.2815C7.38646 19.4369 6.28421 18.2381 5.14787 16.1239C2.8752 11.9227 2.69338 10.555 3.13655 10.2117C3.28428 10.0973 3.52291 10.081 3.78427 10.2226C5.50581 11.1653 6.7217 13.9443 6.73874 13.9824C6.81261 14.1459 6.98306 14.2549 7.17055 14.2604C7.35805 14.2658 7.53419 14.1677 7.61941 14.0042C7.62509 13.9934 8.22167 12.8981 9.11938 12.849C9.81254 12.8055 10.608 13.4158 11.4205 14.5927C12.4489 16.0803 13.4658 16.7778 14.4545 16.6633C15.8238 16.5053 16.4601 14.8325 16.4885 14.7616C16.4999 14.7289 16.5056 14.7071 16.5226 14.669L15.6079 14.3584C15.5965 14.3911 15.5908 14.4129 15.5738 14.4456C15.4488 14.778 14.9772 15.6661 14.3351 15.737C13.7613 15.8024 13.017 15.2139 12.2329 14.075C11.2045 12.5821 10.1364 11.8574 9.06256 11.9173C8.26712 11.9608 7.65918 12.4349 7.27282 12.8654C6.64784 11.683 5.75013 10.228 4.26721 9.41074C3.70472 9.10015 3.01155 9.1165 2.52861 9.47613C1.48886 10.2553 1.93771 12.217 4.27857 16.5598C5.51718 18.8593 6.6592 20.1017 8.14781 21.0607C8.28984 21.1642 9.46596 21.9598 10.8807 21.9979C11.0114 22.0033 11.142 21.9979 11.2727 21.987C15.8976 21.7363 19.6532 15.6771 19.8124 15.4046C20.3975 14.4129 23.2327 9.41619 21.3805 7.95042Z",
          fill: "currentColor",
          stroke: "transparent"
        }
      )
    }
  ),
  Markdown: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 18 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.00065 0.833496C4.33761 0.833496 3.70173 1.09689 3.23288 1.56573C2.76404 2.03457 2.50065 2.67045 2.50065 3.3335V6.66683C2.50065 7.12707 2.87375 7.50016 3.33398 7.50016C3.79422 7.50016 4.16732 7.12707 4.16732 6.66683V3.3335C4.16732 3.11248 4.25511 2.90052 4.4114 2.74424C4.56768 2.58796 4.77964 2.50016 5.00065 2.50016H10.834V5.00016C10.834 5.6632 11.0974 6.29909 11.5662 6.76793C12.0351 7.23677 12.6709 7.50016 13.334 7.50016H15.834V16.6668C15.834 16.8878 15.7462 17.0998 15.5899 17.2561C15.4336 17.4124 15.2217 17.5002 15.0007 17.5002H3.33398C2.87375 17.5002 2.50065 17.8733 2.50065 18.3335C2.50065 18.7937 2.87375 19.1668 3.33398 19.1668H15.0007C15.6637 19.1668 16.2996 18.9034 16.7684 18.4346C17.2373 17.9658 17.5007 17.3299 17.5007 16.6668V5.8335C17.5007 5.61248 17.4129 5.40052 17.2566 5.24424L13.0899 1.07757C12.9336 0.921293 12.7217 0.833496 12.5007 0.833496H5.00065ZM12.5007 2.84534V5.00016C12.5007 5.22118 12.5884 5.43314 12.7447 5.58942C12.901 5.7457 13.113 5.8335 13.334 5.8335H15.4888L12.5007 2.84534Z",
            fill: "#363B3F",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M2.50065 12.429V15.0002C2.50065 15.4604 2.12755 15.8335 1.66732 15.8335C1.20708 15.8335 0.833984 15.4604 0.833984 15.0002V10.2431C0.833984 9.37027 1.93837 8.99133 2.47422 9.68029L4.58398 12.3928L6.69374 9.68029C7.2296 8.99134 8.33398 9.37026 8.33398 10.2431V15.0002C8.33398 15.4604 7.96089 15.8335 7.50065 15.8335C7.04041 15.8335 6.66732 15.4604 6.66732 15.0002V12.429L5.37334 14.0927C4.97298 14.6074 4.19499 14.6074 3.79463 14.0927L2.50065 12.429Z",
            fill: "#363B3F",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.584 12.5001C14.584 11.6863 14.4079 11.0087 14.0522 10.4719C13.6932 9.93013 13.1998 9.60493 12.6973 9.41559C11.8646 9.10182 10.9028 9.13741 10.3398 9.15824C10.2684 9.16089 10.2032 9.1633 10.1457 9.16472C9.60667 9.17805 9.16732 9.61753 9.16732 10.1668V14.8335C9.16732 15.3828 9.60667 15.8223 10.1457 15.8356C10.2032 15.837 10.2681 15.8394 10.3395 15.842C10.9024 15.8629 11.8646 15.8985 12.6973 15.5847C13.1998 15.3954 13.6932 15.0702 14.0522 14.5284C14.4079 13.9916 14.584 13.314 14.584 12.5001ZM12.1097 10.9752C11.7306 10.8324 11.2899 10.8094 10.834 10.8145V14.1858C11.2899 14.1909 11.7306 14.1679 12.1097 14.0251C12.3549 13.9327 12.5351 13.8005 12.6628 13.6078C12.7937 13.4103 12.9173 13.0764 12.9173 12.5001C12.9173 11.9239 12.7937 11.59 12.6628 11.3925C12.5351 11.1998 12.3549 11.0676 12.1097 10.9752Z",
            fill: "#363B3F",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  Telegram: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.3749 8.84156C6.74359 6.48951 10.3236 4.93889 12.1148 4.18971C17.2292 2.05065 18.2919 1.67907 18.9846 1.6668C19.1369 1.6641 19.4776 1.70206 19.6982 1.8821C19.8845 2.03412 19.9358 2.23947 19.9603 2.3836C19.9848 2.52773 20.0154 2.85607 19.9911 3.11262C19.714 6.04083 18.5147 13.1468 17.9046 16.4265C17.6465 17.8142 17.1382 18.2795 16.6461 18.3251C15.5766 18.424 14.7645 17.6144 13.7287 16.9316C12.1078 15.8632 11.1921 15.1981 9.61879 14.1556C7.80053 12.9507 8.97923 12.2885 10.0154 11.2062C10.2866 10.923 14.9987 6.6132 15.0899 6.22224C15.1013 6.17334 15.1119 5.99107 15.0042 5.89483C14.8965 5.79859 14.7376 5.8315 14.6229 5.85767C14.4604 5.89478 11.871 7.61575 6.85486 11.0206C6.11988 11.5281 5.45416 11.7754 4.8577 11.7624C4.20015 11.7481 2.93528 11.3886 1.99498 11.0812C0.84166 10.7042 -0.074973 10.5049 0.00484519 9.86468C0.0464194 9.53121 0.503103 9.19017 1.3749 8.84156Z",
          fill: "#363B3F",
          stroke: "transparent"
        }
      )
    }
  ),
  Github2: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx("g", { clipPath: "url(#clip0_2230_11561)", children: /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10 0C4.475 0 0 4.39702 0 9.82573C0 14.1736 2.8625 17.846 6.8375 19.1479C7.3375 19.2339 7.525 18.9391 7.525 18.6812C7.525 18.4478 7.5125 17.674 7.5125 16.8511C5 17.3056 4.35 16.2493 4.15 15.6966C4.0375 15.4141 3.55 14.5421 3.125 14.3087C2.775 14.1245 2.275 13.67 3.1125 13.6578C3.9 13.6455 4.4625 14.3701 4.65 14.6649C5.55 16.151 6.9875 15.7335 7.5625 15.4755C7.65 14.8369 7.9125 14.407 8.2 14.1613C5.975 13.9157 3.65 13.0682 3.65 9.30988C3.65 8.24133 4.0375 7.35702 4.675 6.66922C4.575 6.42357 4.225 5.41643 4.775 4.0654C4.775 4.0654 5.6125 3.80747 7.525 5.07253C8.325 4.85146 9.175 4.74092 10.025 4.74092C10.875 4.74092 11.725 4.85146 12.525 5.07253C14.4375 3.79519 15.275 4.0654 15.275 4.0654C15.825 5.41643 15.475 6.42357 15.375 6.66922C16.0125 7.35702 16.4 8.22905 16.4 9.30988C16.4 13.0805 14.0625 13.9157 11.8375 14.1613C12.2 14.4684 12.5125 15.0579 12.5125 15.9791C12.5125 17.2933 12.5 18.3496 12.5 18.6812C12.5 18.9391 12.6875 19.2462 13.1875 19.1479C17.1375 17.846 20 14.1613 20 9.82573C20 4.39702 15.525 0 10 0Z",
            fill: "#363B3F",
            stroke: "transparent"
          }
        ) }),
        /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_2230_11561", children: /* @__PURE__ */ l.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  ),
  PageBreak: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 18 18",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M1.5 2.25C1.5 1.83579 1.83579 1.5 2.25 1.5C2.66421 1.5 3 1.83579 3 2.25V4.25C3 4.80228 3.44772 5.25 4 5.25H14C14.5523 5.25 15 4.80228 15 4.25V2.25C15 1.83579 15.3358 1.5 15.75 1.5C16.1642 1.5 16.5 1.83579 16.5 2.25V4.75C16.5 5.85457 15.6046 6.75 14.5 6.75H3.5C2.39543 6.75 1.5 5.85457 1.5 4.75V2.25Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M1.5 13.25C1.5 12.1454 2.39543 11.25 3.5 11.25H14.5C15.6046 11.25 16.5 12.1454 16.5 13.25V15.75C16.5 16.1642 16.1642 16.5 15.75 16.5C15.3358 16.5 15 16.1642 15 15.75V13.75C15 13.1977 14.5523 12.75 14 12.75H4C3.44772 12.75 3 13.1977 3 13.75V15.75C3 16.1642 2.66421 16.5 2.25 16.5C1.83579 16.5 1.5 16.1642 1.5 15.75V13.25Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M0.75 9C0.75 8.58579 1.08579 8.25 1.5 8.25H3C3.41421 8.25 3.75 8.58579 3.75 9C3.75 9.41421 3.41421 9.75 3 9.75H1.5C1.08579 9.75 0.75 9.41421 0.75 9Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M5.25 9C5.25 8.58579 5.58579 8.25 6 8.25H7.5C7.91421 8.25 8.25 8.58579 8.25 9C8.25 9.41421 7.91421 9.75 7.5 9.75H6C5.58579 9.75 5.25 9.41421 5.25 9Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M12.75 9C12.75 8.58579 12.4142 8.25 12 8.25H10.5C10.0858 8.25 9.75 8.58579 9.75 9C9.75 9.41421 10.0858 9.75 10.5 9.75H12C12.4142 9.75 12.75 9.41421 12.75 9Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M14.25 9C14.25 8.58579 14.5858 8.25 15 8.25H16.5C16.9142 8.25 17.25 8.58579 17.25 9C17.25 9.41421 16.9142 9.75 16.5 9.75H15C14.5858 9.75 14.25 9.41421 14.25 9Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  PageBreakRemove: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M1.33398 1.99998C1.33398 1.63179 1.63246 1.33331 2.00065 1.33331C2.36884 1.33331 2.66732 1.63179 2.66732 1.99998V3.66665C2.66732 4.21893 3.11503 4.66665 3.66732 4.66665H12.334C12.8863 4.66665 13.334 4.21893 13.334 3.66665V1.99998C13.334 1.63179 13.6325 1.33331 14.0007 1.33331C14.3688 1.33331 14.6673 1.63179 14.6673 1.99998V3.99998C14.6673 5.10455 13.7719 5.99998 12.6673 5.99998H3.33398C2.22942 5.99998 1.33398 5.10455 1.33398 3.99998V1.99998Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M1.33398 12C1.33398 10.8954 2.22941 9.99998 3.33398 9.99998H12.6673C13.7719 9.99998 14.6673 10.8954 14.6673 12V14C14.6673 14.3682 14.3688 14.6666 14.0007 14.6666C13.6325 14.6666 13.334 14.3682 13.334 14V11.3333H2.66732V14C2.66732 14.3682 2.36884 14.6666 2.00065 14.6666C1.63246 14.6666 1.33398 14.3682 1.33398 14V12Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.46712 6.46645C6.64463 6.28894 6.93243 6.28894 7.10994 6.46645L8.00065 7.35716L8.89136 6.46645C9.06887 6.28894 9.35667 6.28894 9.53418 6.46645C9.7117 6.64396 9.7117 6.93176 9.53418 7.10927L8.64348 7.99998L9.53418 8.89069C9.7117 9.0682 9.7117 9.356 9.53418 9.53351C9.35667 9.71102 9.06887 9.71102 8.89136 9.53351L8.00065 8.6428L7.10994 9.53351C6.93243 9.71102 6.64463 9.71102 6.46712 9.53351C6.28961 9.356 6.28961 9.0682 6.46712 8.89069L7.35783 7.99998L6.46712 7.10927C6.28961 6.93176 6.28961 6.64396 6.46712 6.46645Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  CircleCheck2: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx("g", { clipPath: "url(#clip0_3331_2680)", children: /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.1654 10.0002C19.1654 15.0628 15.0613 19.1668 9.9987 19.1668C4.93609 19.1668 0.832031 15.0628 0.832031 10.0002C0.832031 4.93755 4.93609 0.833496 9.9987 0.833496C15.0613 0.833496 19.1654 4.93755 19.1654 10.0002ZM13.088 8.92275C13.4134 8.59731 13.4134 8.06968 13.088 7.74424C12.7625 7.4188 12.2349 7.4188 11.9094 7.74424L9.16536 10.4883L8.08795 9.41091C7.76252 9.08547 7.23488 9.08547 6.90944 9.41091C6.584 9.73634 6.584 10.264 6.90944 10.5894L8.57611 12.2561C8.90154 12.5815 9.42918 12.5815 9.75462 12.2561L13.088 8.92275Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ) }),
        /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_3331_2680", children: /* @__PURE__ */ l.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  ),
  FileExport: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 19 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.16797 0.833496C2.50493 0.833496 1.86904 1.09689 1.4002 1.56573C0.931361 2.03457 0.667969 2.67045 0.667969 3.3335V16.6668C0.667969 17.3299 0.931361 17.9658 1.4002 18.4346C1.86904 18.9034 2.50493 19.1668 3.16797 19.1668H9.83463C10.2949 19.1668 10.668 18.7937 10.668 18.3335C10.668 17.8733 10.2949 17.5002 9.83463 17.5002H3.16797C2.94696 17.5002 2.73499 17.4124 2.57871 17.2561C2.42243 17.0998 2.33464 16.8878 2.33464 16.6668V3.3335C2.33464 3.11248 2.42243 2.90052 2.57871 2.74424C2.73499 2.58796 2.94695 2.50016 3.16797 2.50016H9.0013V5.00016C9.0013 5.6632 9.2647 6.29909 9.73354 6.76793C10.2024 7.23677 10.8383 7.50016 11.5013 7.50016H14.0013V10.0002C14.0013 10.4604 14.3744 10.8335 14.8346 10.8335C15.2949 10.8335 15.668 10.4604 15.668 10.0002V5.8335C15.668 5.61248 15.5802 5.40052 15.4239 5.24424L11.2572 1.07757C11.1009 0.921293 10.889 0.833496 10.668 0.833496H3.16797ZM10.668 2.84534V5.00016C10.668 5.22118 10.7558 5.43314 10.912 5.58942C11.0683 5.7457 11.2803 5.8335 11.5013 5.8335H13.6561L10.668 2.84534Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.8346 12.5002C15.2949 12.5002 15.668 12.8733 15.668 13.3335V18.3335C15.668 18.7937 15.2949 19.1668 14.8346 19.1668C14.3744 19.1668 14.0013 18.7937 14.0013 18.3335V13.3335C14.0013 12.8733 14.3744 12.5002 14.8346 12.5002Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.7454 15.2442C12.0708 14.9188 12.5985 14.9188 12.9239 15.2442L14.8346 17.155L16.7454 15.2442C17.0708 14.9188 17.5985 14.9188 17.9239 15.2442C18.2493 15.5697 18.2493 16.0973 17.9239 16.4228L15.4239 18.9228C15.0985 19.2482 14.5708 19.2482 14.2454 18.9228L11.7454 16.4228C11.4199 16.0973 11.4199 15.5697 11.7454 15.2442Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  FileImport: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.75 0.75C3.15326 0.75 2.58097 0.987053 2.15901 1.40901C1.73705 1.83097 1.5 2.40326 1.5 3V15C1.5 15.5967 1.73705 16.169 2.15901 16.591C2.58097 17.0129 3.15326 17.25 3.75 17.25H9.75C10.1642 17.25 10.5 16.9142 10.5 16.5C10.5 16.0858 10.1642 15.75 9.75 15.75H3.75C3.55109 15.75 3.36032 15.671 3.21967 15.5303C3.07902 15.3897 3 15.1989 3 15V3C3 2.80109 3.07902 2.61032 3.21967 2.46967C3.36032 2.32902 3.55109 2.25 3.75 2.25H9V4.5C9 5.09674 9.23705 5.66903 9.65901 6.09099C10.081 6.51295 10.6533 6.75 11.25 6.75H13.5V9C13.5 9.41421 13.8358 9.75 14.25 9.75C14.6642 9.75 15 9.41421 15 9V5.25C15 5.05109 14.921 4.86032 14.7803 4.71967L11.0303 0.96967C10.8897 0.829018 10.6989 0.75 10.5 0.75H3.75ZM10.5 2.56066V4.5C10.5 4.69891 10.579 4.88968 10.7197 5.03033C10.8603 5.17098 11.0511 5.25 11.25 5.25H13.1893L10.5 2.56066Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.25 17.25C13.8358 17.25 13.5 16.9142 13.5 16.5V12C13.5 11.5858 13.8358 11.25 14.25 11.25C14.6642 11.25 15 11.5858 15 12V16.5C15 16.9142 14.6642 17.25 14.25 17.25Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.0303 14.7803C16.7374 15.0732 16.2626 15.0732 15.9697 14.7803L14.25 13.0607L12.5303 14.7803C12.2374 15.0732 11.7626 15.0732 11.4697 14.7803C11.1768 14.4874 11.1768 14.0126 11.4697 13.7197L13.7197 11.4697C14.0126 11.1768 14.4874 11.1768 14.7803 11.4697L17.0303 13.7197C17.3232 14.0126 17.3232 14.4874 17.0303 14.7803Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        )
      ]
    }
  ),
  BookQuestion: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 14 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M6.17502 9.73251C6.17502 9.3183 6.5108 8.98251 6.92502 8.98251H6.93252C7.34673 8.98251 7.68252 9.3183 7.68252 9.73251C7.68252 10.1467 7.34673 10.4825 6.93252 10.4825H6.92502C6.5108 10.4825 6.17502 10.1467 6.17502 9.73251Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M6.54617 5.35656C6.70927 5.26429 6.90272 5.22984 7.09177 5.26147C7.28068 5.29307 7.44822 5.38773 7.56706 5.52396C7.68465 5.65875 7.74776 5.82599 7.75 5.9964C7.74867 6.09135 7.66232 6.27123 7.31844 6.49447C7.17044 6.59056 7.01695 6.66583 6.89736 6.71758C6.83865 6.74299 6.79074 6.7616 6.75922 6.77329C6.74353 6.77912 6.73208 6.78315 6.72561 6.78539L6.71982 6.78737C6.32728 6.91613 6.11263 7.33832 6.24027 7.73155C6.36815 8.12553 6.7912 8.34124 7.18518 8.21336L6.95363 7.5C7.18518 8.21336 7.18585 8.21314 7.18607 8.21307L7.18711 8.21273L7.18962 8.21191L7.19634 8.20967L7.21638 8.20284C7.23256 8.19724 7.25434 8.18951 7.28093 8.17965C7.33398 8.15997 7.40688 8.13152 7.49314 8.09419C7.66351 8.02045 7.89661 7.90749 8.13521 7.75261C8.5618 7.47566 9.25004 6.9037 9.25004 5.99416L9.25 5.98818C9.24574 5.4536 9.04854 4.94041 8.6974 4.53789C8.34665 4.13583 7.86525 3.87003 7.33931 3.78203C6.81351 3.69406 6.27169 3.78845 5.80761 4.05098C5.34315 4.31373 4.98374 4.7298 4.79723 5.23033C4.6526 5.61848 4.85 6.05038 5.23814 6.19501C5.62629 6.33964 6.05818 6.14223 6.20282 5.75409C6.26371 5.59068 6.38346 5.4486 6.54617 5.35656Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.75 2.25C13.75 1.85218 13.592 1.47065 13.3107 1.18934C13.0294 0.908035 12.6478 0.75 12.25 0.75H2.875C2.17881 0.75 1.51113 1.02656 1.01884 1.51884C0.526562 2.01113 0.25 2.67881 0.25 3.375V14.625C0.25 15.3212 0.526562 15.9889 1.01884 16.4812C1.51113 16.9734 2.17881 17.25 2.875 17.25H12.25C12.6478 17.25 13.0294 17.092 13.3107 16.8107C13.592 16.5294 13.75 16.1478 13.75 15.75V2.25ZM2.875 2.25C2.57663 2.25 2.29048 2.36853 2.0795 2.5795C1.86853 2.79048 1.75 3.07663 1.75 3.375V12.2533C2.09832 12.0881 2.48212 12 2.875 12H12.25V2.25H2.875ZM12.25 13.5H2.875C2.57663 13.5 2.29048 13.6185 2.0795 13.8295C1.86853 14.0405 1.75 14.3266 1.75 14.625C1.75 14.9234 1.86853 15.2095 2.0795 15.4205C2.29048 15.6315 2.57663 15.75 2.875 15.75H12.25V13.5Z",
            fill: "currentColor",
            stroke: "transparent"
          }
        )
      ]
    }
  )
};
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u5 = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Id = (...e) => e.filter((t, a, n) => !!t && t.trim() !== "" && n.indexOf(t) === a).join(" ").trim();
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var h5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p5 = Et(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: a = 2,
    absoluteStrokeWidth: n,
    className: o = "",
    children: i,
    iconNode: s,
    ...c
  }, f) => P(
    "svg",
    {
      ref: f,
      ...h5,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: n ? Number(a) * 24 / Number(t) : a,
      className: Id("lucide", o),
      ...c
    },
    [
      ...s.map(([d, u]) => P(d, u)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r = (e, t) => {
  const a = Et(
    ({ className: n, ...o }, i) => P(p5, {
      ref: i,
      iconNode: t,
      className: Id(`lucide-${u5(e)}`, n),
      ...o
    })
  );
  return a.displayName = `${e}`, a;
};
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y5 = [
  ["path", { d: "M3.5 13h6", key: "p1my2r" }],
  ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
  ["path", { d: "M18 7v9", key: "pknjwm" }],
  ["path", { d: "m14 12 4 4 4-4", key: "buelq4" }]
], m5 = r("AArrowDown", y5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k5 = [
  ["path", { d: "M3.5 13h6", key: "p1my2r" }],
  ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
  ["path", { d: "M18 16V7", key: "ty0viw" }],
  ["path", { d: "m14 11 4-4 4 4", key: "1pu57t" }]
], g5 = r("AArrowUp", k5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v5 = [
  ["path", { d: "M21 14h-5", key: "1vh23k" }],
  ["path", { d: "M16 16v-3.5a2.5 2.5 0 0 1 5 0V16", key: "1wh10o" }],
  ["path", { d: "M4.5 13h6", key: "dfilno" }],
  ["path", { d: "m3 16 4.5-9 4.5 9", key: "2dxa0e" }]
], M5 = r("ALargeSmall", v5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w5 = [
  ["circle", { cx: "16", cy: "4", r: "1", key: "1grugj" }],
  ["path", { d: "m18 19 1-7-6 1", key: "r0i19z" }],
  ["path", { d: "m5 8 3-3 5.5 3-2.36 3.5", key: "9ptxx2" }],
  ["path", { d: "M4.24 14.5a5 5 0 0 0 6.88 6", key: "10kmtu" }],
  ["path", { d: "M13.76 17.5a5 5 0 0 0-6.88-6", key: "2qq6rc" }]
], x5 = r("Accessibility", w5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C5 = [
  [
    "path",
    {
      d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
      key: "169zse"
    }
  ]
], b5 = r("Activity", C5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L5 = [
  [
    "path",
    {
      d: "M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "larmp2"
    }
  ],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "M18.3 17.7a2.5 2.5 0 0 1-3.16 3.83 2.53 2.53 0 0 1-1.14-2V12", key: "1bo8pg" }],
  ["path", { d: "M6.6 15.6A2 2 0 1 0 10 17v-5", key: "t9h90c" }]
], j5 = r("AirVent", L5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N5 = [
  [
    "path",
    {
      d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1",
      key: "ns4c3b"
    }
  ],
  ["path", { d: "m12 15 5 6H7Z", key: "14qnn2" }]
], A5 = r("Airplay", N5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S5 = [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
], I5 = r("AlarmClockCheck", S5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T5 = [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
], z5 = r("AlarmClockMinus", T5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D5 = [
  ["path", { d: "M6.87 6.87a8 8 0 1 0 11.26 11.26", key: "3on8tj" }],
  ["path", { d: "M19.9 14.25a8 8 0 0 0-9.15-9.15", key: "15ghsc" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.26 18.67 4 21", key: "yzmioq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M4 4 2 6", key: "1ycko6" }]
], _5 = r("AlarmClockOff", D5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P5 = [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
], E5 = r("AlarmClockPlus", P5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R5 = [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M12 9v4l2 2", key: "1c63tq" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }]
], H5 = r("AlarmClock", R5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V5 = [
  ["path", { d: "M11 21c0-2.5 2-2.5 2-5", key: "1sicvv" }],
  ["path", { d: "M16 21c0-2.5 2-2.5 2-5", key: "1o3eny" }],
  ["path", { d: "m19 8-.8 3a1.25 1.25 0 0 1-1.2 1H7a1.25 1.25 0 0 1-1.2-1L5 8", key: "1bvca4" }],
  [
    "path",
    { d: "M21 3a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a1 1 0 0 1 1-1z", key: "x3qr1j" }
  ],
  ["path", { d: "M6 21c0-2.5 2-2.5 2-5", key: "i3w1gp" }]
], O5 = r("AlarmSmoke", V5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q5 = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["polyline", { points: "11 3 11 11 14 8 17 11 17 3", key: "1wcwz3" }]
], B5 = r("Album", q5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z5 = [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4", key: "11f1s0" }],
  ["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4", key: "t14dx9" }],
  ["path", { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1", key: "1w07xs" }],
  ["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1", key: "1apec2" }]
], F5 = r("AlignCenterHorizontal", Z5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G5 = [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4", key: "14d6g8" }],
  ["path", { d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4", key: "1e2lrw" }],
  ["path", { d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1", key: "1fkdwx" }],
  ["path", { d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1", key: "1euafb" }]
], $5 = r("AlignCenterVertical", G5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U5 = [
  ["path", { d: "M17 12H7", key: "16if0g" }],
  ["path", { d: "M19 18H5", key: "18s9l3" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
], W5 = r("AlignCenter", U5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y5 = [
  ["rect", { width: "6", height: "16", x: "4", y: "2", rx: "2", key: "z5wdxg" }],
  ["rect", { width: "6", height: "9", x: "14", y: "9", rx: "2", key: "um7a8w" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }]
], Q5 = r("AlignEndHorizontal", Y5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J5 = [
  ["rect", { width: "16", height: "6", x: "2", y: "4", rx: "2", key: "10wcwx" }],
  ["rect", { width: "9", height: "6", x: "9", y: "14", rx: "2", key: "4p5bwg" }],
  ["path", { d: "M22 22V2", key: "12ipfv" }]
], K5 = r("AlignEndVertical", J5);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X5 = [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M17 22v-5", key: "4b6g73" }],
  ["path", { d: "M17 7V2", key: "hnrr36" }],
  ["path", { d: "M7 22v-3", key: "1r4jpn" }],
  ["path", { d: "M7 5V2", key: "liy1u9" }]
], e8 = r(
  "AlignHorizontalDistributeCenter",
  X5
);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t8 = [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M10 2v20", key: "uyc634" }],
  ["path", { d: "M20 2v20", key: "1tx262" }]
], a8 = r("AlignHorizontalDistributeEnd", t8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n8 = [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M4 2v20", key: "gtpd5x" }],
  ["path", { d: "M14 2v20", key: "tg6bpw" }]
], o8 = r(
  "AlignHorizontalDistributeStart",
  n8
);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r8 = [
  ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }],
  ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
], i8 = r("AlignHorizontalJustifyCenter", r8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s8 = [
  ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }],
  ["rect", { width: "6", height: "10", x: "12", y: "7", rx: "2", key: "1ht384" }],
  ["path", { d: "M22 2v20", key: "40qfg1" }]
], c8 = r("AlignHorizontalJustifyEnd", s8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f8 = [
  ["rect", { width: "6", height: "14", x: "6", y: "5", rx: "2", key: "hsirpf" }],
  ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
], d8 = r("AlignHorizontalJustifyStart", f8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l8 = [
  ["rect", { width: "6", height: "10", x: "9", y: "7", rx: "2", key: "yn7j0q" }],
  ["path", { d: "M4 22V2", key: "tsjzd3" }],
  ["path", { d: "M20 22V2", key: "1bnhr8" }]
], u8 = r("AlignHorizontalSpaceAround", l8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h8 = [
  ["rect", { width: "6", height: "14", x: "3", y: "5", rx: "2", key: "j77dae" }],
  ["rect", { width: "6", height: "10", x: "15", y: "7", rx: "2", key: "bq30hj" }],
  ["path", { d: "M3 2v20", key: "1d2pfg" }],
  ["path", { d: "M21 2v20", key: "p059bm" }]
], p8 = r("AlignHorizontalSpaceBetween", h8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y8 = [
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 18h18", key: "1h113x" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }]
], m8 = r("AlignJustify", y8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k8 = [
  ["path", { d: "M15 12H3", key: "6jk70r" }],
  ["path", { d: "M17 18H3", key: "1amg6g" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
], g8 = r("AlignLeft", k8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v8 = [
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M21 18H7", key: "1ygte8" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
], M8 = r("AlignRight", v8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w8 = [
  ["rect", { width: "6", height: "16", x: "4", y: "6", rx: "2", key: "1n4dg1" }],
  ["rect", { width: "6", height: "9", x: "14", y: "6", rx: "2", key: "17khns" }],
  ["path", { d: "M22 2H2", key: "fhrpnj" }]
], x8 = r("AlignStartHorizontal", w8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C8 = [
  ["rect", { width: "9", height: "6", x: "6", y: "14", rx: "2", key: "lpm2y7" }],
  ["rect", { width: "16", height: "6", x: "6", y: "4", rx: "2", key: "rdj6ps" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
], b8 = r("AlignStartVertical", C8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L8 = [
  ["path", { d: "M22 17h-3", key: "1lwga1" }],
  ["path", { d: "M22 7h-5", key: "o2endc" }],
  ["path", { d: "M5 17H2", key: "1gx9xc" }],
  ["path", { d: "M7 7H2", key: "6bq26l" }],
  ["rect", { x: "5", y: "14", width: "14", height: "6", rx: "2", key: "1qrzuf" }],
  ["rect", { x: "7", y: "4", width: "10", height: "6", rx: "2", key: "we8e9z" }]
], j8 = r("AlignVerticalDistributeCenter", L8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N8 = [
  ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }],
  ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
], A8 = r("AlignVerticalDistributeEnd", N8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S8 = [
  ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }],
  ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M2 4h20", key: "mda7wb" }]
], I8 = r("AlignVerticalDistributeStart", S8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T8 = [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
], z8 = r("AlignVerticalJustifyCenter", T8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D8 = [
  ["rect", { width: "14", height: "6", x: "5", y: "12", rx: "2", key: "4l4tp2" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 22h20", key: "272qi7" }]
], _8 = r("AlignVerticalJustifyEnd", D8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P8 = [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "6", rx: "2", key: "13squh" }],
  ["path", { d: "M2 2h20", key: "1ennik" }]
], E8 = r("AlignVerticalJustifyStart", P8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R8 = [
  ["rect", { width: "10", height: "6", x: "7", y: "9", rx: "2", key: "b1zbii" }],
  ["path", { d: "M22 20H2", key: "1p1f7z" }],
  ["path", { d: "M22 4H2", key: "1b7qnq" }]
], H8 = r("AlignVerticalSpaceAround", R8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V8 = [
  ["rect", { width: "14", height: "6", x: "5", y: "15", rx: "2", key: "1w91an" }],
  ["rect", { width: "10", height: "6", x: "7", y: "3", rx: "2", key: "17wqzy" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M2 3h20", key: "91anmk" }]
], O8 = r("AlignVerticalSpaceBetween", V8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q8 = [
  ["path", { d: "M10 10H6", key: "1bsnug" }],
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.28a1 1 0 0 0-.684-.948l-1.923-.641a1 1 0 0 1-.578-.502l-1.539-3.076A1 1 0 0 0 16.382 8H14",
      key: "lrkjwd"
    }
  ],
  ["path", { d: "M8 8v4", key: "1fwk8c" }],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
], B8 = r("Ambulance", q8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z8 = [
  [
    "path",
    {
      d: "M17.5 12c0 4.4-3.6 8-8 8A4.5 4.5 0 0 1 5 15.5c0-6 8-4 8-8.5a3 3 0 1 0-6 0c0 3 2.5 8.5 12 13",
      key: "1o9ehi"
    }
  ],
  ["path", { d: "M16 12h3", key: "4uvgyw" }]
], F8 = r("Ampersand", Z8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G8 = [
  [
    "path",
    {
      d: "M10 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "12lh1k"
    }
  ],
  [
    "path",
    {
      d: "M22 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "173c68"
    }
  ]
], $8 = r("Ampersands", G8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U8 = [
  [
    "path",
    { d: "M10 2v5.632c0 .424-.272.795-.653.982A6 6 0 0 0 6 14c.006 4 3 7 5 8", key: "1h8rid" }
  ],
  ["path", { d: "M10 5H8a2 2 0 0 0 0 4h.68", key: "3ezsi6" }],
  ["path", { d: "M14 2v5.632c0 .424.272.795.652.982A6 6 0 0 1 18 14c0 4-3 7-5 8", key: "yt6q09" }],
  ["path", { d: "M14 5h2a2 2 0 0 1 0 4h-.68", key: "8f95yk" }],
  ["path", { d: "M18 22H6", key: "mg6kv4" }],
  ["path", { d: "M9 2h6", key: "1jrp98" }]
], W8 = r("Amphora", U8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y8 = [
  ["path", { d: "M12 22V8", key: "qkxhtm" }],
  ["path", { d: "M5 12H2a10 10 0 0 0 20 0h-3", key: "1hv3nh" }],
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }]
], Q8 = r("Anchor", Y8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J8 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["path", { d: "M7.5 8 10 9", key: "olxxln" }],
  ["path", { d: "m14 9 2.5-1", key: "1j6cij" }],
  ["path", { d: "M9 10h.01", key: "qbtxuw" }],
  ["path", { d: "M15 10h.01", key: "1qmjsl" }]
], K8 = r("Angry", J8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X8 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M14 9h2", key: "116p9w" }]
], e9 = r("Annoyed", X8);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t9 = [
  ["path", { d: "M2 12 7 2", key: "117k30" }],
  ["path", { d: "m7 12 5-10", key: "1tvx22" }],
  ["path", { d: "m12 12 5-10", key: "ev1o1a" }],
  ["path", { d: "m17 12 5-10", key: "1e4ti3" }],
  ["path", { d: "M4.5 7h15", key: "vlsxkz" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
], a9 = r("Antenna", t9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n9 = [
  ["path", { d: "M7 10H6a4 4 0 0 1-4-4 1 1 0 0 1 1-1h4", key: "1hjpb6" }],
  [
    "path",
    { d: "M7 5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1 7 7 0 0 1-7 7H8a1 1 0 0 1-1-1z", key: "1qn45f" }
  ],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  [
    "path",
    { d: "M5 20a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1", key: "1fi4x8" }
  ]
], o9 = r("Anvil", n9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r9 = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14.31 8 5.74 9.94", key: "1y6ab4" }],
  ["path", { d: "M9.69 8h11.48", key: "1wxppr" }],
  ["path", { d: "m7.38 12 5.74-9.94", key: "1grp0k" }],
  ["path", { d: "M9.69 16 3.95 6.06", key: "libnyf" }],
  ["path", { d: "M14.31 16H2.83", key: "x5fava" }],
  ["path", { d: "m16.62 12-5.74 9.94", key: "1vwawt" }]
], i9 = r("Aperture", r9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s9 = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M14 8h.01", key: "1primd" }]
], c9 = r("AppWindowMac", s9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f9 = [
  ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" }],
  ["path", { d: "M10 4v4", key: "pp8u80" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["path", { d: "M6 4v4", key: "1svtjw" }]
], d9 = r("AppWindow", f9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l9 = [
  [
    "path",
    {
      d: "M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4.91 4.91 0 0 0 17 5c-2.22 0-4 1.44-5 2-1-.56-2.78-2-5-2a4.9 4.9 0 0 0-5 4.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06Z",
      key: "3s7exb"
    }
  ],
  ["path", { d: "M10 2c1 .5 2 2 2 5", key: "fcco2y" }]
], u9 = r("Apple", l9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h9 = [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h2", key: "tvwodi" }],
  ["path", { d: "M20 8v11a2 2 0 0 1-2 2h-2", key: "1gkqxj" }],
  ["path", { d: "m9 15 3-3 3 3", key: "1pd0qc" }],
  ["path", { d: "M12 12v9", key: "192myk" }]
], p9 = r("ArchiveRestore", h9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y9 = [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "m9.5 17 5-5", key: "nakeu6" }],
  ["path", { d: "m9.5 12 5 5", key: "1hccrj" }]
], m9 = r("ArchiveX", y9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k9 = [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "M10 12h4", key: "a56b0p" }]
], g9 = r("Archive", k9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v9 = [
  ["path", { d: "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3", key: "irtipd" }],
  [
    "path",
    {
      d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
      key: "1qyhux"
    }
  ],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
], M9 = r("Armchair", v9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w9 = [
  ["path", { d: "M15 5H9", key: "1tp3ed" }],
  ["path", { d: "M15 9v3h4l-7 7-7-7h4V9z", key: "ncdc4b" }]
], x9 = r("ArrowBigDownDash", w9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C9 = [["path", { d: "M15 6v6h4l-7 7-7-7h4V6h6z", key: "1thax2" }]], b9 = r("ArrowBigDown", C9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L9 = [
  ["path", { d: "M19 15V9", key: "1hci5f" }],
  ["path", { d: "M15 15h-3v4l-7-7 7-7v4h3v6z", key: "16tjna" }]
], j9 = r("ArrowBigLeftDash", L9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N9 = [["path", { d: "M18 15h-6v4l-7-7 7-7v4h6v6z", key: "lbrdak" }]], A9 = r("ArrowBigLeft", N9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S9 = [
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["path", { d: "M9 9h3V5l7 7-7 7v-4H9V9z", key: "1sg2xn" }]
], I9 = r("ArrowBigRightDash", S9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T9 = [["path", { d: "M6 9h6V5l7 7-7 7v-4H6V9z", key: "7fvt9c" }]], z9 = r("ArrowBigRight", T9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D9 = [
  ["path", { d: "M9 19h6", key: "456am0" }],
  ["path", { d: "M9 15v-3H5l7-7 7 7h-4v3H9z", key: "1r2uve" }]
], _9 = r("ArrowBigUpDash", D9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P9 = [["path", { d: "M9 18v-6H5l7-7 7 7h-4v6H9z", key: "1x06kx" }]], E9 = r("ArrowBigUp", P9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R9 = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
], H9 = r("ArrowDown01", R9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V9 = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }]
], O9 = r("ArrowDown10", V9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q9 = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
], B9 = r("ArrowDownAZ", q9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z9 = [
  ["path", { d: "M19 3H5", key: "1236rx" }],
  ["path", { d: "M12 21V7", key: "gj6g52" }],
  ["path", { d: "m6 15 6 6 6-6", key: "h15q88" }]
], F9 = r("ArrowDownFromLine", Z9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G9 = [
  ["path", { d: "M17 7 7 17", key: "15tmo1" }],
  ["path", { d: "M17 17H7V7", key: "1org7z" }]
], $9 = r("ArrowDownLeft", G9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U9 = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h4", key: "6d7r33" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h10", key: "1438ji" }]
], W9 = r("ArrowDownNarrowWide", U9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y9 = [
  ["path", { d: "m7 7 10 10", key: "1fmybs" }],
  ["path", { d: "M17 7v10H7", key: "6fjiku" }]
], Q9 = r("ArrowDownRight", Y9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J9 = [
  ["path", { d: "M12 2v14", key: "jyx4ut" }],
  ["path", { d: "m19 9-7 7-7-7", key: "1oe3oy" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
], K9 = r("ArrowDownToDot", J9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X9 = [
  ["path", { d: "M12 17V3", key: "1cwfxf" }],
  ["path", { d: "m6 11 6 6 6-6", key: "12ii2o" }],
  ["path", { d: "M19 21H5", key: "150jfl" }]
], e7 = r("ArrowDownToLine", X9);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t7 = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "m21 8-4-4-4 4", key: "1c9v7m" }],
  ["path", { d: "M17 4v16", key: "7dpous" }]
], a7 = r("ArrowDownUp", t7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n7 = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h10", key: "1w87gc" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }]
], o7 = r("ArrowDownWideNarrow", n7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r7 = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
], i7 = r("ArrowDownZA", r7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s7 = [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
], c7 = r("ArrowDown", s7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f7 = [
  ["path", { d: "m9 6-6 6 6 6", key: "7v63n9" }],
  ["path", { d: "M3 12h14", key: "13k4hi" }],
  ["path", { d: "M21 19V5", key: "b4bplr" }]
], d7 = r("ArrowLeftFromLine", f7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l7 = [
  ["path", { d: "M8 3 4 7l4 4", key: "9rb6wj" }],
  ["path", { d: "M4 7h16", key: "6tx8e3" }],
  ["path", { d: "m16 21 4-4-4-4", key: "siv7j2" }],
  ["path", { d: "M20 17H4", key: "h6l3hr" }]
], u7 = r("ArrowLeftRight", l7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h7 = [
  ["path", { d: "M3 19V5", key: "rwsyhb" }],
  ["path", { d: "m13 6-6 6 6 6", key: "1yhaz7" }],
  ["path", { d: "M7 12h14", key: "uoisry" }]
], p7 = r("ArrowLeftToLine", h7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y7 = [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
], m7 = r("ArrowLeft", y7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k7 = [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M21 12H7", key: "13ipq5" }],
  ["path", { d: "m15 18 6-6-6-6", key: "6tx3qv" }]
], g7 = r("ArrowRightFromLine", k7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v7 = [
  ["path", { d: "m16 3 4 4-4 4", key: "1x1c3m" }],
  ["path", { d: "M20 7H4", key: "zbl0bi" }],
  ["path", { d: "m8 21-4-4 4-4", key: "h9nckh" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
], M7 = r("ArrowRightLeft", v7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w7 = [
  ["path", { d: "M17 12H3", key: "8awo09" }],
  ["path", { d: "m11 18 6-6-6-6", key: "8c2y43" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
], x7 = r("ArrowRightToLine", w7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C7 = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
], b7 = r("ArrowRight", C7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L7 = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
], j7 = r("ArrowUp01", L7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N7 = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }]
], A7 = r("ArrowUp10", N7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S7 = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
], I7 = r("ArrowUpAZ", S7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T7 = [
  ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
  ["path", { d: "M17 20V4", key: "1ejh1v" }],
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }]
], z7 = r("ArrowUpDown", T7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D7 = [
  ["path", { d: "m5 9 7-7 7 7", key: "1hw5ic" }],
  ["path", { d: "M12 16V2", key: "ywoabb" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
], _7 = r("ArrowUpFromDot", D7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P7 = [
  ["path", { d: "m18 9-6-6-6 6", key: "kcunyi" }],
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
], E7 = r("ArrowUpFromLine", P7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R7 = [
  ["path", { d: "M7 17V7h10", key: "11bw93" }],
  ["path", { d: "M17 17 7 7", key: "2786uv" }]
], H7 = r("ArrowUpLeft", R7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V7 = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h10", key: "jvxblo" }]
], O7 = r("ArrowUpNarrowWide", V7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q7 = [
  ["path", { d: "M7 7h10v10", key: "1tivn9" }],
  ["path", { d: "M7 17 17 7", key: "1vkiza" }]
], B7 = r("ArrowUpRight", q7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z7 = [
  ["path", { d: "M5 3h14", key: "7usisc" }],
  ["path", { d: "m18 13-6-6-6 6", key: "1kf1n9" }],
  ["path", { d: "M12 7v14", key: "1akyts" }]
], F7 = r("ArrowUpToLine", Z7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G7 = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h10", key: "1438ji" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h4", key: "1krc32" }]
], $7 = r("ArrowUpWideNarrow", G7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U7 = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
], W7 = r("ArrowUpZA", U7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y7 = [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
], Q7 = r("ArrowUp", Y7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J7 = [
  ["path", { d: "m4 6 3-3 3 3", key: "9aidw8" }],
  ["path", { d: "M7 17V3", key: "19qxw1" }],
  ["path", { d: "m14 6 3-3 3 3", key: "6iy689" }],
  ["path", { d: "M17 17V3", key: "o0fmgi" }],
  ["path", { d: "M4 21h16", key: "1h09gz" }]
], K7 = r("ArrowsUpFromLine", J7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X7 = [
  ["path", { d: "M12 6v12", key: "1vza4d" }],
  ["path", { d: "M17.196 9 6.804 15", key: "1ah31z" }],
  ["path", { d: "m6.804 9 10.392 6", key: "1b6pxd" }]
], em = r("Asterisk", X7);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tm = [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8", key: "7n84p3" }]
], am = r("AtSign", tm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nm = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9-4.54-4.52-9.87-6.54-11.9-4.5-2.04 2.03-.02 7.36 4.5 11.9 4.54 4.52 9.87 6.54 11.9 4.5Z",
      key: "1l2ple"
    }
  ],
  [
    "path",
    {
      d: "M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9-2.03-2.04-7.36-.02-11.9 4.5-4.52 4.54-6.54 9.87-4.5 11.9 2.03 2.04 7.36.02 11.9-4.5Z",
      key: "1wam0m"
    }
  ]
], om = r("Atom", nm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rm = [
  ["path", { d: "M2 10v3", key: "1fnikh" }],
  ["path", { d: "M6 6v11", key: "11sgs0" }],
  ["path", { d: "M10 3v18", key: "yhl04a" }],
  ["path", { d: "M14 8v7", key: "3a1oy3" }],
  ["path", { d: "M18 5v13", key: "123xd1" }],
  ["path", { d: "M22 10v3", key: "154ddg" }]
], im = r("AudioLines", rm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sm = [
  [
    "path",
    {
      d: "M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2",
      key: "57tc96"
    }
  ]
], cm = r("AudioWaveform", sm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fm = [
  [
    "path",
    {
      d: "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526",
      key: "1yiouv"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "6", key: "1vp47v" }]
], dm = r("Award", fm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lm = [
  ["path", { d: "m14 12-8.5 8.5a2.12 2.12 0 1 1-3-3L11 9", key: "csbz4o" }],
  ["path", { d: "M15 13 9 7l4-4 6 6h3a8 8 0 0 1-7 7z", key: "113wfo" }]
], um = r("Axe", lm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hm = [
  ["path", { d: "M4 4v16h16", key: "1s015l" }],
  ["path", { d: "m4 20 7-7", key: "17qe9y" }]
], pm = r("Axis3d", hm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ym = [
  ["path", { d: "M9 12h.01", key: "157uk2" }],
  ["path", { d: "M15 12h.01", key: "1k8ypt" }],
  ["path", { d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5", key: "1u7htd" }],
  [
    "path",
    {
      d: "M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1",
      key: "5yv0yz"
    }
  ]
], mm = r("Baby", ym);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const km = [
  [
    "path",
    { d: "M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z", key: "1ol0lm" }
  ],
  ["path", { d: "M8 10h8", key: "c7uz4u" }],
  ["path", { d: "M8 18h8", key: "1no2b1" }],
  ["path", { d: "M8 22v-6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6", key: "1fr6do" }],
  ["path", { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2", key: "donm21" }]
], gm = r("Backpack", km);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vm = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
], Mm = r("BadgeAlert", vm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wm = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M15.4 10a4 4 0 1 0 0 4", key: "2eqtx8" }]
], xm = r("BadgeCent", wm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cm = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], bm = r("BadgeCheck", Cm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lm = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
], jm = r("BadgeDollarSign", Lm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nm = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M7 12h5", key: "gblrwe" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
], Am = r("BadgeEuro", Nm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sm = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["line", { x1: "12", x2: "12.01", y1: "17", y2: "17", key: "io3f8k" }]
], Im = r("BadgeHelp", Sm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tm = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 8h8", key: "1bis0t" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m13 17-5-1h1a4 4 0 0 0 0-8", key: "nu2bwa" }]
], zm = r("BadgeIndianRupee", Tm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dm = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "12", key: "1y1yb1" }],
  ["line", { x1: "12", x2: "12.01", y1: "8", y2: "8", key: "110wyk" }]
], _m = r("BadgeInfo", Dm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pm = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 8 3 3v7", key: "17yadx" }],
  ["path", { d: "m12 11 3-3", key: "p4cfq1" }],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M9 16h6", key: "8wimt3" }]
], Em = r("BadgeJapaneseYen", Pm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rm = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
], Hm = r("BadgeMinus", Rm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vm = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
], Om = r("BadgePercent", Vm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qm = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "16", key: "10p56q" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
], Bm = r("BadgePlus", qm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zm = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 12h4", key: "qz6y1c" }],
  ["path", { d: "M10 16V9.5a2.5 2.5 0 0 1 5 0", key: "3mlbjk" }],
  ["path", { d: "M8 16h7", key: "sbedsn" }]
], Fm = r("BadgePoundSterling", Zm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gm = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9 16h5", key: "1syiyw" }],
  ["path", { d: "M9 12h5a2 2 0 1 0 0-4h-3v9", key: "1ge9c1" }]
], $m = r("BadgeRussianRuble", Gm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Um = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M11 17V8h4", key: "1bfq6y" }],
  ["path", { d: "M11 12h3", key: "2eqnfz" }],
  ["path", { d: "M9 16h4", key: "1skf3a" }]
], Wm = r("BadgeSwissFranc", Um);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ym = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
], Qm = r("BadgeX", Ym);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jm = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ]
], Km = r("Badge", Jm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xm = [
  ["path", { d: "M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2", key: "4irg2o" }],
  ["path", { d: "M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10", key: "14fcyx" }],
  ["rect", { width: "13", height: "8", x: "8", y: "6", rx: "1", key: "o6oiis" }],
  ["circle", { cx: "18", cy: "20", r: "2", key: "t9985n" }],
  ["circle", { cx: "9", cy: "20", r: "2", key: "e5v82j" }]
], ek = r("BaggageClaim", Xm);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tk = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.9 4.9 14.2 14.2", key: "1m5liu" }]
], ak = r("Ban", tk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nk = [
  ["path", { d: "M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5", key: "1cscit" }],
  [
    "path",
    {
      d: "M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z",
      key: "1y1nbv"
    }
  ]
], ok = r("Banana", nk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rk = [
  ["path", { d: "M10 10.01h.01", key: "1e9xi7" }],
  ["path", { d: "M10 14.01h.01", key: "ac23bv" }],
  ["path", { d: "M14 10.01h.01", key: "2wfrvf" }],
  ["path", { d: "M14 14.01h.01", key: "8tw8yn" }],
  ["path", { d: "M18 6v11.5", key: "dkbidh" }],
  ["path", { d: "M6 6v12", key: "vkc79e" }],
  ["rect", { x: "2", y: "6", width: "20", height: "12", rx: "2", key: "1wpnh2" }]
], ik = r("Bandage", rk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sk = [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M6 12h.01M18 12h.01", key: "113zkx" }]
], ck = r("Banknote", sk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fk = [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M8 5v14", key: "1ybrkv" }],
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "M17 5v14", key: "ycjyhj" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
], dk = r("Barcode", fk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lk = [
  ["path", { d: "M4 20h16", key: "14thso" }],
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], uk = r("Baseline", lk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hk = [
  ["path", { d: "M10 4 8 6", key: "1rru8s" }],
  ["path", { d: "M17 19v2", key: "ts1sot" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M7 19v2", key: "12npes" }],
  [
    "path",
    {
      d: "M9 5 7.621 3.621A2.121 2.121 0 0 0 4 5v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5",
      key: "14ym8i"
    }
  ]
], pk = r("Bath", hk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yk = [
  ["path", { d: "M15 7h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2", key: "1sdynx" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1", key: "1gkd3k" }],
  ["path", { d: "m11 7-3 5h4l-3 5", key: "b4a64w" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
], mk = r("BatteryCharging", yk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kk = [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "13", key: "c6fn6x" }]
], gk = r("BatteryFull", kk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vk = [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }]
], Mk = r("BatteryLow", vk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wk = [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }]
], xk = r("BatteryMedium", wk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ck = [
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["path", { d: "M13.5 7H16a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2.5", key: "jzl4pj" }],
  ["path", { d: "M22 11v2", key: "1wo06k" }],
  ["path", { d: "M6.5 17H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2.5", key: "1ar5vp" }],
  ["path", { d: "M7 12h6", key: "iekk3h" }]
], bk = r("BatteryPlus", Ck);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lk = [
  ["path", { d: "M10 17h.01", key: "nbq80n" }],
  ["path", { d: "M10 7v6", key: "nne03l" }],
  ["path", { d: "M14 7h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2", key: "1x5o8m" }],
  ["path", { d: "M22 11v2", key: "1wo06k" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "1mdjgh" }]
], jk = r("BatteryWarning", Lk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nk = [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
], Ak = r("Battery", Nk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sk = [
  ["path", { d: "M4.5 3h15", key: "c7n0jr" }],
  ["path", { d: "M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3", key: "m1uhx7" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }]
], Ik = r("Beaker", Sk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tk = [
  [
    "path",
    {
      d: "M9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22a13.96 13.96 0 0 0 9.9-4.1",
      key: "bq3udt"
    }
  ],
  ["path", { d: "M10.75 5.093A6 6 0 0 1 22 8c0 2.411-.61 4.68-1.683 6.66", key: "17ccse" }],
  [
    "path",
    {
      d: "M5.341 10.62a4 4 0 0 0 6.487 1.208M10.62 5.341a4.015 4.015 0 0 1 2.039 2.04",
      key: "18zqgq"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], zk = r("BeanOff", Tk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dk = [
  [
    "path",
    {
      d: "M10.165 6.598C9.954 7.478 9.64 8.36 9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22c7.732 0 14-6.268 14-14a6 6 0 0 0-11.835-1.402Z",
      key: "1tvzk7"
    }
  ],
  ["path", { d: "M5.341 10.62a4 4 0 1 0 5.279-5.28", key: "2cyri2" }]
], _k = r("Bean", Dk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pk = [
  ["path", { d: "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8", key: "1k78r4" }],
  ["path", { d: "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "fb3tl2" }],
  ["path", { d: "M12 4v6", key: "1dcgq2" }],
  ["path", { d: "M2 18h20", key: "ajqnye" }]
], Ek = r("BedDouble", Pk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rk = [
  ["path", { d: "M3 20v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8", key: "1wm6mi" }],
  ["path", { d: "M5 10V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4", key: "4k93s5" }],
  ["path", { d: "M3 18h18", key: "1h113x" }]
], Hk = r("BedSingle", Rk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vk = [
  ["path", { d: "M2 4v16", key: "vw9hq8" }],
  ["path", { d: "M2 8h18a2 2 0 0 1 2 2v10", key: "1dgv2r" }],
  ["path", { d: "M2 17h20", key: "18nfp3" }],
  ["path", { d: "M6 8v9", key: "1yriud" }]
], Ok = r("Bed", Vk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qk = [
  ["circle", { cx: "12.5", cy: "8.5", r: "2.5", key: "9738u8" }],
  [
    "path",
    {
      d: "M12.5 2a6.5 6.5 0 0 0-6.22 4.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c4 0 8.4-1.8 11.4-4.3A6.5 6.5 0 0 0 12.5 2Z",
      key: "o0f6za"
    }
  ],
  [
    "path",
    {
      d: "m18.5 6 2.19 4.5a6.48 6.48 0 0 1 .31 2 6.49 6.49 0 0 1-2.6 5.2C15.4 20.2 11 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5",
      key: "k7p6i0"
    }
  ]
], Bk = r("Beef", qk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zk = [
  ["path", { d: "M13 13v5", key: "igwfh0" }],
  ["path", { d: "M17 11.47V8", key: "16yw0g" }],
  ["path", { d: "M17 11h1a3 3 0 0 1 2.745 4.211", key: "1xbt65" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3", key: "c55o3e" }],
  [
    "path",
    { d: "M7.536 7.535C6.766 7.649 6.154 8 5.5 8a2.5 2.5 0 0 1-1.768-4.268", key: "1ydug7" }
  ],
  [
    "path",
    {
      d: "M8.727 3.204C9.306 2.767 9.885 2 11 2c1.56 0 2 1.5 3 1.5s1.72-.5 2.5-.5a1 1 0 1 1 0 5c-.78 0-1.5-.5-2.5-.5a3.149 3.149 0 0 0-.842.12",
      key: "q81o7q"
    }
  ],
  ["path", { d: "M9 14.6V18", key: "20ek98" }]
], Fk = r("BeerOff", Zk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gk = [
  ["path", { d: "M17 11h1a3 3 0 0 1 0 6h-1", key: "1yp76v" }],
  ["path", { d: "M9 12v6", key: "1u1cab" }],
  ["path", { d: "M13 12v6", key: "1sugkk" }],
  [
    "path",
    {
      d: "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z",
      key: "1510fo"
    }
  ],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8", key: "19jb7n" }]
], $k = r("Beer", Gk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uk = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M13.916 2.314A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.74 7.327A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673 9 9 0 0 1-.585-.665",
      key: "1tip0g"
    }
  ],
  ["circle", { cx: "18", cy: "8", r: "3", key: "1g0gzu" }]
], Wk = r("BellDot", Uk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yk = [
  ["path", { d: "M18.8 4A6.3 8.7 0 0 1 20 9", key: "xve1fh" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
  ["rect", { width: "10", height: "6", x: "4", y: "16", rx: "2", key: "17f3te" }],
  ["path", { d: "M14 19c3 0 4.6-1.6 4.6-1.6", key: "n7odp6" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }]
], Qk = r("BellElectric", Yk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jk = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }],
  [
    "path",
    {
      d: "M16.243 3.757A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673A9.4 9.4 0 0 1 18.667 12",
      key: "bdwj86"
    }
  ]
], Kk = r("BellMinus", Jk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xk = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742",
      key: "178tsu"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05", key: "1hqiys" }]
], eg = r("BellOff", Xk);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tg = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }],
  ["path", { d: "M18 5v6", key: "g5ayrv" }],
  [
    "path",
    {
      d: "M20.002 14.464a9 9 0 0 0 .738.863A1 1 0 0 1 20 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 8.75-5.332",
      key: "1abcvy"
    }
  ]
], ag = r("BellPlus", tg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ng = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  ["path", { d: "M22 8c0-2.3-.8-4.3-2-6", key: "5bb3ad" }],
  [
    "path",
    {
      d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
      key: "11g9vi"
    }
  ],
  ["path", { d: "M4 2C2.8 3.7 2 5.7 2 8", key: "tap9e0" }]
], og = r("BellRing", ng);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rg = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
      key: "11g9vi"
    }
  ]
], ig = r("Bell", rg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sg = [
  ["rect", { width: "13", height: "7", x: "3", y: "3", rx: "1", key: "11xb64" }],
  ["path", { d: "m22 15-3-3 3-3", key: "26chmm" }],
  ["rect", { width: "13", height: "7", x: "3", y: "14", rx: "1", key: "k6ky7n" }]
], cg = r("BetweenHorizontalEnd", sg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fg = [
  ["rect", { width: "13", height: "7", x: "8", y: "3", rx: "1", key: "pkso9a" }],
  ["path", { d: "m2 9 3 3-3 3", key: "1agib5" }],
  ["rect", { width: "13", height: "7", x: "8", y: "14", rx: "1", key: "1q5fc1" }]
], dg = r("BetweenHorizontalStart", fg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lg = [
  ["rect", { width: "7", height: "13", x: "3", y: "3", rx: "1", key: "1fdu0f" }],
  ["path", { d: "m9 22 3-3 3 3", key: "17z65a" }],
  ["rect", { width: "7", height: "13", x: "14", y: "3", rx: "1", key: "1squn4" }]
], ug = r("BetweenVerticalEnd", lg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hg = [
  ["rect", { width: "7", height: "13", x: "3", y: "8", rx: "1", key: "1fjrkv" }],
  ["path", { d: "m15 2-3 3-3-3", key: "1uh6eb" }],
  ["rect", { width: "7", height: "13", x: "14", y: "8", rx: "1", key: "w3fjg8" }]
], pg = r("BetweenVerticalStart", hg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yg = [
  [
    "path",
    {
      d: "M12.409 13.017A5 5 0 0 1 22 15c0 3.866-4 7-9 7-4.077 0-8.153-.82-10.371-2.462-.426-.316-.631-.832-.62-1.362C2.118 12.723 2.627 2 10 2a3 3 0 0 1 3 3 2 2 0 0 1-2 2c-1.105 0-1.64-.444-2-1",
      key: "1pmlyh"
    }
  ],
  ["path", { d: "M15 14a5 5 0 0 0-7.584 2", key: "5rb254" }],
  ["path", { d: "M9.964 6.825C8.019 7.977 9.5 13 8 15", key: "kbvsx9" }]
], mg = r("BicepsFlexed", yg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kg = [
  ["circle", { cx: "18.5", cy: "17.5", r: "3.5", key: "15x4ox" }],
  ["circle", { cx: "5.5", cy: "17.5", r: "3.5", key: "1noe27" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["path", { d: "M12 17.5V14l-3-3 4-3 2 3h2", key: "1npguv" }]
], gg = r("Bike", kg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vg = [
  ["rect", { x: "14", y: "14", width: "4", height: "6", rx: "2", key: "p02svl" }],
  ["rect", { x: "6", y: "4", width: "4", height: "6", rx: "2", key: "xm4xkj" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 10h4", key: "ru81e7" }],
  ["path", { d: "M6 14h2v6", key: "16z9wg" }],
  ["path", { d: "M14 4h2v6", key: "1idq9u" }]
], Mg = r("Binary", vg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wg = [
  ["path", { d: "M10 10h4", key: "tcdvrf" }],
  ["path", { d: "M19 7V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3", key: "3apit1" }],
  [
    "path",
    {
      d: "M20 21a2 2 0 0 0 2-2v-3.851c0-1.39-2-2.962-2-4.829V8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2z",
      key: "rhpgnw"
    }
  ],
  ["path", { d: "M 22 16 L 2 16", key: "14lkq7" }],
  [
    "path",
    {
      d: "M4 21a2 2 0 0 1-2-2v-3.851c0-1.39 2-2.962 2-4.829V8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v11a2 2 0 0 1-2 2z",
      key: "104b3k"
    }
  ],
  ["path", { d: "M9 7V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3", key: "14fczp" }]
], xg = r("Binoculars", wg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cg = [
  ["circle", { cx: "12", cy: "11.9", r: "2", key: "e8h31w" }],
  ["path", { d: "M6.7 3.4c-.9 2.5 0 5.2 2.2 6.7C6.5 9 3.7 9.6 2 11.6", key: "17bolr" }],
  ["path", { d: "m8.9 10.1 1.4.8", key: "15ezny" }],
  ["path", { d: "M17.3 3.4c.9 2.5 0 5.2-2.2 6.7 2.4-1.2 5.2-.6 6.9 1.5", key: "wtwa5u" }],
  ["path", { d: "m15.1 10.1-1.4.8", key: "1r0b28" }],
  ["path", { d: "M16.7 20.8c-2.6-.4-4.6-2.6-4.7-5.3-.2 2.6-2.1 4.8-4.7 5.2", key: "m7qszh" }],
  ["path", { d: "M12 13.9v1.6", key: "zfyyim" }],
  ["path", { d: "M13.5 5.4c-1-.2-2-.2-3 0", key: "1bi9q0" }],
  ["path", { d: "M17 16.4c.7-.7 1.2-1.6 1.5-2.5", key: "1rhjqw" }],
  ["path", { d: "M5.5 13.9c.3.9.8 1.8 1.5 2.5", key: "8gsud3" }]
], bg = r("Biohazard", Cg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lg = [
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20", key: "oj1oa8" }],
  ["path", { d: "m20 7 2 .5-2 .5", key: "12nv4d" }],
  ["path", { d: "M10 18v3", key: "1yea0a" }],
  ["path", { d: "M14 17.75V21", key: "1pymcb" }],
  ["path", { d: "M7 18a6 6 0 0 0 3.84-10.61", key: "1npnn0" }]
], jg = r("Bird", Lg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ng = [
  [
    "path",
    {
      d: "M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727",
      key: "yr8idg"
    }
  ]
], Ag = r("Bitcoin", Ng);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sg = [
  ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
  ["circle", { cx: "15", cy: "15", r: "7", key: "19ennj" }]
], Ig = r("Blend", Sg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tg = [
  ["path", { d: "M3 3h18", key: "o7r712" }],
  ["path", { d: "M20 7H8", key: "gd2fo2" }],
  ["path", { d: "M20 11H8", key: "1ynp89" }],
  ["path", { d: "M10 19h10", key: "19hjk5" }],
  ["path", { d: "M8 15h12", key: "1yqzne" }],
  ["path", { d: "M4 3v14", key: "fggqzn" }],
  ["circle", { cx: "4", cy: "19", r: "2", key: "p3m9r0" }]
], zg = r("Blinds", Tg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dg = [
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  [
    "path",
    {
      d: "M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3",
      key: "1fpvtg"
    }
  ]
], _g = r("Blocks", Dg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pg = [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "12", key: "1rsjjs" }],
  ["line", { x1: "3", x2: "6", y1: "12", y2: "12", key: "11yl8c" }]
], Eg = r("BluetoothConnected", Pg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rg = [
  ["path", { d: "m17 17-5 5V12l-5 5", key: "v5aci6" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M14.5 9.5 17 7l-5-5v4.5", key: "1kddfz" }]
], Hg = r("BluetoothOff", Rg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vg = [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["path", { d: "M20.83 14.83a4 4 0 0 0 0-5.66", key: "k8tn1j" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
], Og = r("BluetoothSearching", Vg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qg = [["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }]], Bg = r("Bluetooth", qg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zg = [
  [
    "path",
    { d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8", key: "mg9rjx" }
  ]
], Fg = r("Bold", Zg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gg = [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
], $g = r("Bolt", Gg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ug = [
  ["circle", { cx: "11", cy: "13", r: "9", key: "hd149" }],
  [
    "path",
    {
      d: "M14.35 4.65 16.3 2.7a2.41 2.41 0 0 1 3.4 0l1.6 1.6a2.4 2.4 0 0 1 0 3.4l-1.95 1.95",
      key: "jp4j1b"
    }
  ],
  ["path", { d: "m22 2-1.5 1.5", key: "ay92ug" }]
], Wg = r("Bomb", Ug);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yg = [
  [
    "path",
    {
      d: "M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z",
      key: "w610uw"
    }
  ]
], Qg = r("Bone", Yg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jg = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m8 13 4-7 4 7", key: "4rari8" }],
  ["path", { d: "M9.1 11h5.7", key: "1gkovt" }]
], Kg = r("BookA", Jg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xg = [
  ["path", { d: "M12 6v7", key: "1f6ttz" }],
  ["path", { d: "M16 8v3", key: "gejaml" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 8v3", key: "1qzp49" }]
], ev = r("BookAudio", Xg);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tv = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 9.5 2 2 4-4", key: "1dth82" }]
], av = r("BookCheck", tv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nv = [
  ["path", { d: "M2 16V4a2 2 0 0 1 2-2h11", key: "spzkk5" }],
  [
    "path",
    {
      d: "M22 18H11a2 2 0 1 0 0 4h10.5a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5H11a2 2 0 0 0-2 2v12",
      key: "1wz07i"
    }
  ],
  ["path", { d: "M5 14H4a2 2 0 1 0 0 4h1", key: "16gqf9" }]
], ov = r("BookCopy", nv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rv = [
  ["path", { d: "M12 17h1.5", key: "1gkc67" }],
  ["path", { d: "M12 22h1.5", key: "1my7sn" }],
  ["path", { d: "M12 2h1.5", key: "19tvb7" }],
  ["path", { d: "M17.5 22H19a1 1 0 0 0 1-1", key: "10akbh" }],
  ["path", { d: "M17.5 2H19a1 1 0 0 1 1 1v1.5", key: "1vrfjs" }],
  ["path", { d: "M20 14v3h-2.5", key: "1naeju" }],
  ["path", { d: "M20 8.5V10", key: "1ctpfu" }],
  ["path", { d: "M4 10V8.5", key: "1o3zg5" }],
  ["path", { d: "M4 19.5V14", key: "ob81pf" }],
  ["path", { d: "M4 4.5A2.5 2.5 0 0 1 6.5 2H8", key: "s8vcyb" }],
  ["path", { d: "M8 22H6.5a1 1 0 0 1 0-5H8", key: "1cu73q" }]
], iv = r("BookDashed", rv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sv = [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 10 3 3 3-3", key: "zt5b4y" }]
], cv = r("BookDown", sv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fv = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 12v-2a4 4 0 0 1 8 0v2", key: "1vsqkj" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }]
], dv = r("BookHeadphones", fv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lv = [
  [
    "path",
    {
      d: "M16 8.2A2.22 2.22 0 0 0 13.8 6c-.8 0-1.4.3-1.8.9-.4-.6-1-.9-1.8-.9A2.22 2.22 0 0 0 8 8.2c0 .6.3 1.2.7 1.6A226.652 226.652 0 0 0 12 13a404 404 0 0 0 3.3-3.1 2.413 2.413 0 0 0 .7-1.7",
      key: "1t75a8"
    }
  ],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
], uv = r("BookHeart", lv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hv = [
  ["path", { d: "m20 13.7-2.1-2.1a2 2 0 0 0-2.8 0L9.7 17", key: "q6ojf0" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["circle", { cx: "10", cy: "8", r: "2", key: "2qkj4p" }]
], pv = r("BookImage", hv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yv = [
  ["path", { d: "m19 3 1 1", key: "ze14oc" }],
  ["path", { d: "m20 2-4.5 4.5", key: "1sppr8" }],
  ["path", { d: "M20 8v13a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "1ocbpn" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H14", key: "1gfsgw" }],
  ["circle", { cx: "14", cy: "8", r: "2", key: "u49eql" }]
], mv = r("BookKey", yv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kv = [
  ["path", { d: "M18 6V4a2 2 0 1 0-4 0v2", key: "1aquzs" }],
  ["path", { d: "M20 15v6a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "1rkj32" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10", key: "18wgow" }],
  ["rect", { x: "12", y: "6", width: "8", height: "5", rx: "1", key: "73l30o" }]
], gv = r("BookLock", kv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vv = [
  ["path", { d: "M10 2v8l3-3 3 3V2", key: "sqw3rj" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
], Mv = r("BookMarked", vv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wv = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], xv = r("BookMinus", wv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cv = [
  ["path", { d: "M12 21V7", key: "gj6g52" }],
  ["path", { d: "m16 12 2 2 4-4", key: "mdajum" }],
  [
    "path",
    {
      d: "M22 6V4a1 1 0 0 0-1-1h-5a4 4 0 0 0-4 4 4 4 0 0 0-4-4H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h6a3 3 0 0 1 3 3 3 3 0 0 1 3-3h6a1 1 0 0 0 1-1v-1.3",
      key: "8arnkb"
    }
  ]
], bv = r("BookOpenCheck", Cv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lv = [
  ["path", { d: "M12 7v14", key: "1akyts" }],
  ["path", { d: "M16 12h2", key: "7q9ll5" }],
  ["path", { d: "M16 8h2", key: "msurwy" }],
  [
    "path",
    {
      d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
      key: "ruj8y"
    }
  ],
  ["path", { d: "M6 12h2", key: "32wvfc" }],
  ["path", { d: "M6 8h2", key: "30oboj" }]
], jv = r("BookOpenText", Lv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nv = [
  ["path", { d: "M12 7v14", key: "1akyts" }],
  [
    "path",
    {
      d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
      key: "ruj8y"
    }
  ]
], Av = r("BookOpen", Nv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sv = [
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], Iv = r("BookPlus", Sv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tv = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 11h8", key: "vwpz6n" }],
  ["path", { d: "M8 7h6", key: "1f0q6e" }]
], zv = r("BookText", Tv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dv = [
  ["path", { d: "M10 13h4", key: "ytezjc" }],
  ["path", { d: "M12 6v7", key: "1f6ttz" }],
  ["path", { d: "M16 8V6H8v2", key: "x8j6u4" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
], _v = r("BookType", Dv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pv = [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "M18 2h1a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "161d7n" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2", key: "1lorq7" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
], Ev = r("BookUp2", Pv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rv = [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
], Hv = r("BookUp", Rv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vv = [
  ["path", { d: "M15 13a3 3 0 1 0-6 0", key: "10j68g" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }]
], Ov = r("BookUser", Vv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qv = [
  ["path", { d: "m14.5 7-5 5", key: "dy991v" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9.5 7 5 5", key: "s45iea" }]
], Bv = r("BookX", qv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zv = [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
], Fv = r("Book", Zv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gv = [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }]
], $v = r("BookmarkCheck", Gv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uv = [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
], Wv = r("BookmarkMinus", Uv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yv = [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }],
  ["line", { x1: "12", x2: "12", y1: "7", y2: "13", key: "1cppfj" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
], Qv = r("BookmarkPlus", Yv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jv = [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
], Kv = r("BookmarkX", Jv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xv = [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }]
], eM = r("Bookmark", Xv);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tM = [
  ["path", { d: "M4 9V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "vvzvr1" }],
  ["path", { d: "M8 8v1", key: "xcqmfk" }],
  ["path", { d: "M12 8v1", key: "1rj8u4" }],
  ["path", { d: "M16 8v1", key: "1q12zr" }],
  ["rect", { width: "20", height: "12", x: "2", y: "9", rx: "2", key: "igpb89" }],
  ["circle", { cx: "8", cy: "15", r: "2", key: "fa4a8s" }],
  ["circle", { cx: "16", cy: "15", r: "2", key: "14c3ya" }]
], aM = r("BoomBox", tM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nM = [
  ["path", { d: "M12 6V2H8", key: "1155em" }],
  ["path", { d: "m8 18-4 4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z", key: "w2lp3e" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M9 11v2", key: "1ueba0" }],
  ["path", { d: "M15 11v2", key: "i11awn" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }]
], oM = r("BotMessageSquare", nM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rM = [
  ["path", { d: "M13.67 8H18a2 2 0 0 1 2 2v4.33", key: "7az073" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }],
  ["path", { d: "M8 8H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 1.414-.586", key: "s09a7a" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }],
  ["path", { d: "M9.67 4H12v2.33", key: "110xot" }]
], iM = r("BotOff", rM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sM = [
  ["path", { d: "M12 8V4H8", key: "hb8ula" }],
  ["rect", { width: "16", height: "12", x: "4", y: "8", rx: "2", key: "enze0r" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M15 13v2", key: "1xurst" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }]
], cM = r("Bot", sM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fM = [
  [
    "path",
    {
      d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
      key: "hh9hay"
    }
  ],
  ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
  ["path", { d: "M12 22V12", key: "d0xqtd" }]
], dM = r("Box", fM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lM = [
  [
    "path",
    {
      d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z",
      key: "lc1i9w"
    }
  ],
  ["path", { d: "m7 16.5-4.74-2.85", key: "1o9zyk" }],
  ["path", { d: "m7 16.5 5-3", key: "va8pkn" }],
  ["path", { d: "M7 16.5v5.17", key: "jnp8gn" }],
  [
    "path",
    {
      d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z",
      key: "8zsnat"
    }
  ],
  ["path", { d: "m17 16.5-5-3", key: "8arw3v" }],
  ["path", { d: "m17 16.5 4.74-2.85", key: "8rfmw" }],
  ["path", { d: "M17 16.5v5.17", key: "k6z78m" }],
  [
    "path",
    {
      d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z",
      key: "1xygjf"
    }
  ],
  ["path", { d: "M12 8 7.26 5.15", key: "1vbdud" }],
  ["path", { d: "m12 8 4.74-2.85", key: "3rx089" }],
  ["path", { d: "M12 13.5V8", key: "1io7kd" }]
], uM = r("Boxes", lM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hM = [
  [
    "path",
    { d: "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1", key: "ezmyqa" }
  ],
  [
    "path",
    {
      d: "M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1",
      key: "e1hn23"
    }
  ]
], pM = r("Braces", hM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yM = [
  ["path", { d: "M16 3h3v18h-3", key: "1yor1f" }],
  ["path", { d: "M8 21H5V3h3", key: "1qrfwo" }]
], mM = r("Brackets", yM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kM = [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  ["path", { d: "M9 13a4.5 4.5 0 0 0 3-4", key: "10igwf" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M12 13h4", key: "1ku699" }],
  ["path", { d: "M12 18h6a2 2 0 0 1 2 2v1", key: "105ag5" }],
  ["path", { d: "M12 8h8", key: "1lhi5i" }],
  ["path", { d: "M16 8V5a2 2 0 0 1 2-2", key: "u6izg6" }],
  ["circle", { cx: "16", cy: "13", r: ".5", key: "ry7gng" }],
  ["circle", { cx: "18", cy: "3", r: ".5", key: "1aiba7" }],
  ["circle", { cx: "20", cy: "21", r: ".5", key: "yhc1fs" }],
  ["circle", { cx: "20", cy: "8", r: ".5", key: "1e43v0" }]
], gM = r("BrainCircuit", kM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vM = [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.142 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588 4 4 0 0 0 7.636 2.106 3.2 3.2 0 0 0 .164-.546c.028-.13.306-.13.335 0a3.2 3.2 0 0 0 .163.546 4 4 0 0 0 7.636-2.106 4 4 0 0 0 .556-6.588 4 4 0 0 0-2.526-5.77A3 3 0 1 0 12 5",
      key: "1kgmhc"
    }
  ],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m15.7 10.4-.9.4", key: "ayzo6p" }],
  ["path", { d: "m9.2 13.2-.9.4", key: "1uzb3g" }],
  ["path", { d: "m13.6 15.7-.4-.9", key: "11ifqf" }],
  ["path", { d: "m10.8 9.2-.4-.9", key: "1pmk2v" }],
  ["path", { d: "m15.7 13.5-.9-.4", key: "7ng02m" }],
  ["path", { d: "m9.2 10.9-.9-.4", key: "1x66zd" }],
  ["path", { d: "m10.5 15.7.4-.9", key: "3js94g" }],
  ["path", { d: "m13.1 9.2.4-.9", key: "18n7mc" }]
], MM = r("BrainCog", vM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wM = [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z",
      key: "ep3f8r"
    }
  ],
  ["path", { d: "M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4", key: "1p4c4q" }],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }]
], xM = r("Brain", wM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CM = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 9v6", key: "199k2o" }],
  ["path", { d: "M16 15v6", key: "8rj2es" }],
  ["path", { d: "M16 3v6", key: "1j6rpj" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M8 15v6", key: "1stoo3" }],
  ["path", { d: "M8 3v6", key: "vlvjmk" }]
], bM = r("BrickWall", CM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LM = [
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M22 13a18.15 18.15 0 0 1-20 0", key: "12hx5q" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
], jM = r("BriefcaseBusiness", LM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NM = [
  ["path", { d: "M10 20v2", key: "1n8e1g" }],
  ["path", { d: "M14 20v2", key: "1lq872" }],
  ["path", { d: "M18 20v2", key: "10uadw" }],
  ["path", { d: "M21 20H3", key: "kdqkdp" }],
  ["path", { d: "M6 20v2", key: "a9bc87" }],
  ["path", { d: "M8 16V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v12", key: "17n9tx" }],
  ["rect", { x: "4", y: "6", width: "16", height: "10", rx: "2", key: "1097i5" }]
], AM = r("BriefcaseConveyorBelt", NM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SM = [
  ["path", { d: "M12 11v4", key: "a6ujw6" }],
  ["path", { d: "M14 13h-4", key: "1pl8zg" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M18 6v14", key: "1mu4gy" }],
  ["path", { d: "M6 6v14", key: "1s15cj" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
], IM = r("BriefcaseMedical", SM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TM = [
  ["path", { d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16", key: "jecpp" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
], zM = r("Briefcase", TM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DM = [
  ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "2", key: "yj20xf" }],
  ["path", { d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2", key: "1ltk23" }],
  ["path", { d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2", key: "1q24h9" }]
], _M = r("BringToFront", DM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PM = [
  ["path", { d: "m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08", key: "1styjt" }],
  [
    "path",
    {
      d: "M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z",
      key: "z0l1mu"
    }
  ]
], EM = r("Brush", PM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RM = [
  ["path", { d: "M15 7.13V6a3 3 0 0 0-5.14-2.1L8 2", key: "vl8zik" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M22 13h-4v-2a4 4 0 0 0-4-4h-1.3", key: "1ou0bd" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M7.7 7.7A4 4 0 0 0 6 11v3a6 6 0 0 0 11.13 3.13", key: "1njkjs" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }]
], HM = r("BugOff", RM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VM = [
  [
    "path",
    {
      d: "M12.765 21.522a.5.5 0 0 1-.765-.424v-8.196a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z",
      key: "17shqo"
    }
  ],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M18 11a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v3a6.1 6.1 0 0 0 2 4.5", key: "1tjixy" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }]
], OM = r("BugPlay", VM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qM = [
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }],
  [
    "path",
    {
      d: "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6",
      key: "xs1cw7"
    }
  ],
  ["path", { d: "M12 20v-9", key: "1qisl0" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M22 13h-4", key: "1jl80f" }],
  ["path", { d: "M17.2 17c2.1.1 3.8 1.9 3.8 4", key: "k3fwyw" }]
], BM = r("Bug", qM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZM = [
  ["path", { d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z", key: "1b4qmf" }],
  ["path", { d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "i71pzd" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2", key: "10jefs" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "M10 10h4", key: "tcdvrf" }],
  ["path", { d: "M10 14h4", key: "kelpxr" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
], FM = r("Building2", ZM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GM = [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["path", { d: "M9 22v-4h6v4", key: "r93iot" }],
  ["path", { d: "M8 6h.01", key: "1dz90k" }],
  ["path", { d: "M16 6h.01", key: "1x0f13" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }]
], $M = r("Building", GM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UM = [
  ["path", { d: "M4 6 2 7", key: "1mqr15" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "m22 7-2-1", key: "1umjhc" }],
  ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 21v-2", key: "sqyl04" }]
], WM = r("BusFront", UM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YM = [
  ["path", { d: "M8 6v6", key: "18i7km" }],
  ["path", { d: "M15 6v6", key: "1sg6z9" }],
  ["path", { d: "M2 12h19.6", key: "de5uta" }],
  [
    "path",
    {
      d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3",
      key: "1wwztk"
    }
  ],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }],
  ["path", { d: "M9 18h5", key: "lrx6i" }],
  ["circle", { cx: "16", cy: "18", r: "2", key: "1v4tcr" }]
], QM = r("Bus", YM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JM = [
  ["path", { d: "M10 3h.01", key: "lbucoy" }],
  ["path", { d: "M14 2h.01", key: "1k8aa1" }],
  ["path", { d: "m2 9 20-5", key: "1kz0j5" }],
  ["path", { d: "M12 12V6.5", key: "1vbrij" }],
  ["rect", { width: "16", height: "10", x: "4", y: "12", rx: "3", key: "if91er" }],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
], KM = r("CableCar", JM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XM = [
  [
    "path",
    {
      d: "M17 21v-2a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1",
      key: "10bnsj"
    }
  ],
  ["path", { d: "M19 15V6.5a1 1 0 0 0-7 0v11a1 1 0 0 1-7 0V9", key: "1eqmu1" }],
  ["path", { d: "M21 21v-2h-4", key: "14zm7j" }],
  ["path", { d: "M3 5h4V3", key: "z442eg" }],
  [
    "path",
    { d: "M7 5a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1V3", key: "ebdjd7" }
  ]
], ew = r("Cable", XM);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tw = [
  ["circle", { cx: "9", cy: "7", r: "2", key: "1305pl" }],
  [
    "path",
    { d: "M7.2 7.9 3 11v9c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-9c0-2-3-6-7-8l-3.6 2.6", key: "xle13f" }
  ],
  ["path", { d: "M16 13H3", key: "1wpj08" }],
  ["path", { d: "M16 17H3", key: "3lvfcd" }]
], aw = r("CakeSlice", tw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nw = [
  ["path", { d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8", key: "1w3rig" }],
  ["path", { d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1", key: "n2jgmb" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M7 8v3", key: "1qtyvj" }],
  ["path", { d: "M12 8v3", key: "hwp4zt" }],
  ["path", { d: "M17 8v3", key: "1i6e5u" }],
  ["path", { d: "M7 4h.01", key: "1bh4kh" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M17 4h.01", key: "1upcoc" }]
], ow = r("Cake", nw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rw = [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["line", { x1: "8", x2: "16", y1: "6", y2: "6", key: "x4nwl0" }],
  ["line", { x1: "16", x2: "16", y1: "14", y2: "18", key: "wjye3r" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
], iw = r("Calculator", rw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sw = [
  ["path", { d: "M11 14h1v4", key: "fy54vd" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
], cw = r("Calendar1", sw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fw = [
  ["path", { d: "m14 18 4 4 4-4", key: "1waygx" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M18 14v8", key: "irew45" }],
  [
    "path",
    { d: "M21 11.354V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.343", key: "bse4f3" }
  ],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
], dw = r("CalendarArrowDown", fw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lw = [
  ["path", { d: "m14 18 4-4 4 4", key: "ftkppy" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M18 22v-8", key: "su0gjh" }],
  ["path", { d: "M21 11.343V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9", key: "1exg90" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
], uw = r("CalendarArrowUp", lw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hw = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 14V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "bce9hv" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
], pw = r("CalendarCheck2", hw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yw = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m9 16 2 2 4-4", key: "19s6y9" }]
], mw = r("CalendarCheck", yw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kw = [
  ["path", { d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5", key: "1osxxc" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M3 10h5", key: "r794hk" }],
  ["path", { d: "M17.5 17.5 16 16.3V14", key: "akvzfd" }],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }]
], gw = r("CalendarClock", kw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vw = [
  ["path", { d: "m15.2 16.9-.9-.4", key: "1r0w5f" }],
  ["path", { d: "m15.2 19.1-.9.4", key: "j188fs" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "m16.9 15.2-.4-.9", key: "699xu" }],
  ["path", { d: "m16.9 20.8-.4.9", key: "dfjc4z" }],
  ["path", { d: "m19.5 14.3-.4.9", key: "1eb35c" }],
  ["path", { d: "m19.5 21.7-.4-.9", key: "1tonu5" }],
  ["path", { d: "M21 10.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "11kmuh" }],
  ["path", { d: "m21.7 16.5-.9.4", key: "1knoei" }],
  ["path", { d: "m21.7 19.5-.9-.4", key: "q4dx6b" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
], Mw = r("CalendarCog", vw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ww = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M16 18h.01", key: "kzsmim" }]
], xw = r("CalendarDays", ww);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cw = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 17V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11Z", key: "kg77oy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M15 22v-4a2 2 0 0 1 2-2h4", key: "1gnbqr" }]
], bw = r("CalendarFold", Cw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lw = [
  ["path", { d: "M3 10h18V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7", key: "136lmk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  [
    "path",
    {
      d: "M21.29 14.7a2.43 2.43 0 0 0-2.65-.52c-.3.12-.57.3-.8.53l-.34.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L17.5 22l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1t7hil"
    }
  ]
], jw = r("CalendarHeart", Lw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nw = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M10 16h4", key: "17e571" }]
], Aw = r("CalendarMinus2", Nw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sw = [
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 15V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8.5", key: "1scpom" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
], Iw = r("CalendarMinus", Sw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tw = [
  ["path", { d: "M4.2 4.2A2 2 0 0 0 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 1.82-1.18", key: "16swn3" }],
  ["path", { d: "M21 15.5V6a2 2 0 0 0-2-2H9.5", key: "yhw86o" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h7", key: "1wap6i" }],
  ["path", { d: "M21 10h-5.5", key: "quycpq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], zw = r("CalendarOff", Tw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dw = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M10 16h4", key: "17e571" }],
  ["path", { d: "M12 14v4", key: "1thi36" }]
], _w = r("CalendarPlus2", Dw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pw = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }]
], Ew = r("CalendarPlus", Pw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rw = [
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M17 14h-6", key: "bkmgh3" }],
  ["path", { d: "M13 18H7", key: "bb0bb7" }],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 18h.01", key: "1bdyru" }]
], Hw = r("CalendarRange", Rw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vw = [
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 11.75V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.25", key: "1jrsq6" }],
  ["path", { d: "m22 22-1.875-1.875", key: "13zax7" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
], Ow = r("CalendarSearch", Vw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qw = [
  ["path", { d: "M11 10v4h4", key: "172dkj" }],
  ["path", { d: "m11 14 1.535-1.605a5 5 0 0 1 8 1.5", key: "vu0qm5" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "m21 18-1.535 1.605a5 5 0 0 1-8-1.5", key: "1qgeyt" }],
  ["path", { d: "M21 22v-4h-4", key: "hrummi" }],
  ["path", { d: "M21 8.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4.3", key: "mctw84" }],
  ["path", { d: "M3 10h4", key: "1el30a" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
], Bw = r("CalendarSync", qw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zw = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m17 22 5-5", key: "1k6ppv" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }]
], Fw = r("CalendarX2", Zw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gw = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m14 14-4 4", key: "rymu2i" }],
  ["path", { d: "m10 14 4 4", key: "3sz06r" }]
], $w = r("CalendarX", Gw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uw = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], Ww = r("Calendar", Uw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yw = [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16", key: "qmtpty" }],
  ["path", { d: "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5", key: "1ufyfc" }],
  ["path", { d: "M14.121 15.121A3 3 0 1 1 9.88 10.88", key: "11zox6" }]
], Qw = r("CameraOff", Yw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jw = [
  [
    "path",
    {
      d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
      key: "1tc9qg"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "3", key: "1vg3eu" }]
], Kw = r("Camera", Jw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xw = [
  [
    "path",
    {
      d: "M5.7 21a2 2 0 0 1-3.5-2l8.6-14a6 6 0 0 1 10.4 6 2 2 0 1 1-3.464-2 2 2 0 1 0-3.464-2Z",
      key: "isaq8g"
    }
  ],
  ["path", { d: "M17.75 7 15 2.1", key: "12x7e8" }],
  ["path", { d: "M10.9 4.8 13 9", key: "100a87" }],
  ["path", { d: "m7.9 9.7 2 4.4", key: "ntfhaj" }],
  ["path", { d: "M4.9 14.7 7 18.9", key: "1x43jy" }]
], ex = r("CandyCane", Xw);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tx = [
  ["path", { d: "m8.5 8.5-1 1a4.95 4.95 0 0 0 7 7l1-1", key: "1ff4ui" }],
  [
    "path",
    { d: "M11.843 6.187A4.947 4.947 0 0 1 16.5 7.5a4.947 4.947 0 0 1 1.313 4.657", key: "1sbrv4" }
  ],
  ["path", { d: "M14 16.5V14", key: "1maf8j" }],
  ["path", { d: "M14 6.5v1.843", key: "1a6u6t" }],
  ["path", { d: "M10 10v7.5", key: "80pj65" }],
  [
    "path",
    {
      d: "m16 7 1-5 1.367.683A3 3 0 0 0 19.708 3H21v1.292a3 3 0 0 0 .317 1.341L22 7l-5 1",
      key: "11a9mt"
    }
  ],
  [
    "path",
    {
      d: "m8 17-1 5-1.367-.683A3 3 0 0 0 4.292 21H3v-1.292a3 3 0 0 0-.317-1.341L2 17l5-1",
      key: "3mjmon"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], ax = r("CandyOff", tx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nx = [
  ["path", { d: "m9.5 7.5-2 2a4.95 4.95 0 1 0 7 7l2-2a4.95 4.95 0 1 0-7-7Z", key: "ue6khb" }],
  ["path", { d: "M14 6.5v10", key: "5xnk7c" }],
  ["path", { d: "M10 7.5v10", key: "1uew51" }],
  [
    "path",
    { d: "m16 7 1-5 1.37.68A3 3 0 0 0 19.7 3H21v1.3c0 .46.1.92.32 1.33L22 7l-5 1", key: "b9cp6k" }
  ],
  [
    "path",
    { d: "m8 17-1 5-1.37-.68A3 3 0 0 0 4.3 21H3v-1.3a3 3 0 0 0-.32-1.33L2 17l5-1", key: "5lney8" }
  ]
], ox = r("Candy", nx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rx = [
  ["path", { d: "M12 22v-4", key: "1utk9m" }],
  [
    "path",
    {
      d: "M7 12c-1.5 0-4.5 1.5-5 3 3.5 1.5 6 1 6 1-1.5 1.5-2 3.5-2 5 2.5 0 4.5-1.5 6-3 1.5 1.5 3.5 3 6 3 0-1.5-.5-3.5-2-5 0 0 2.5.5 6-1-.5-1.5-3.5-3-5-3 1.5-1 4-4 4-6-2.5 0-5.5 1.5-7 3 0-2.5-.5-5-2-7-1.5 2-2 4.5-2 7-1.5-1.5-4.5-3-7-3 0 2 2.5 5 4 6",
      key: "1mezod"
    }
  ]
], ix = r("Cannabis", rx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sx = [
  ["path", { d: "M10.5 5H19a2 2 0 0 1 2 2v8.5", key: "jqtk4d" }],
  ["path", { d: "M17 11h-.5", key: "1961ue" }],
  ["path", { d: "M19 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2", key: "1keqsi" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M7 11h4", key: "1o1z6v" }],
  ["path", { d: "M7 15h2.5", key: "1ina1g" }]
], cx = r("CaptionsOff", sx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fx = [
  ["rect", { width: "18", height: "14", x: "3", y: "5", rx: "2", ry: "2", key: "12ruh7" }],
  ["path", { d: "M7 15h4M15 15h2M7 11h2M13 11h4", key: "1ueiar" }]
], dx = r("Captions", fx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lx = [
  [
    "path",
    { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8", key: "1imjwt" }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
], ux = r("CarFront", lx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hx = [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  [
    "path",
    { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8", key: "1imjwt" }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
], px = r("CarTaxiFront", hx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yx = [
  [
    "path",
    {
      d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2",
      key: "5owen"
    }
  ],
  ["circle", { cx: "7", cy: "17", r: "2", key: "u2ysq9" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }],
  ["circle", { cx: "17", cy: "17", r: "2", key: "axvx0g" }]
], mx = r("Car", yx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kx = [
  ["path", { d: "M18 19V9a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a2 2 0 0 0 2 2h2", key: "19jm3t" }],
  ["path", { d: "M2 9h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2", key: "13hakp" }],
  ["path", { d: "M22 17v1a1 1 0 0 1-1 1H10v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9", key: "1crci8" }],
  ["circle", { cx: "8", cy: "19", r: "2", key: "t8fc5s" }]
], gx = r("Caravan", kx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vx = [
  [
    "path",
    {
      d: "M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 0 0-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46",
      key: "rfqxbe"
    }
  ],
  ["path", { d: "M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z", key: "6b25w4" }],
  ["path", { d: "M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z", key: "fn65lo" }]
], Mx = r("Carrot", vx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wx = [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }]
], xx = r("CaseLower", wx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cx = [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["circle", { cx: "18", cy: "12", r: "3", key: "1kchzo" }],
  ["path", { d: "M21 9v6", key: "anns31" }]
], bx = r("CaseSensitive", Cx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lx = [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["path", { d: "M15 11h4.5a2 2 0 0 1 0 4H15V7h4a2 2 0 0 1 0 4", key: "1sqfas" }]
], jx = r("CaseUpper", Lx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nx = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["circle", { cx: "8", cy: "10", r: "2", key: "1xl4ub" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "10", r: "2", key: "r14t7q" }],
  ["path", { d: "m6 20 .7-2.9A1.4 1.4 0 0 1 8.1 16h7.8a1.4 1.4 0 0 1 1.4 1l.7 3", key: "l01ucn" }]
], Ax = r("CassetteTape", Nx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sx = [
  ["path", { d: "M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6", key: "3zrzxg" }],
  ["path", { d: "M2 12a9 9 0 0 1 8 8", key: "g6cvee" }],
  ["path", { d: "M2 16a5 5 0 0 1 4 4", key: "1y1dii" }],
  ["line", { x1: "2", x2: "2.01", y1: "20", y2: "20", key: "xu2jvo" }]
], Ix = r("Cast", Sx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tx = [
  ["path", { d: "M22 20v-9H2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z", key: "109fe4" }],
  ["path", { d: "M18 11V4H6v7", key: "mon5oj" }],
  ["path", { d: "M15 22v-4a3 3 0 0 0-3-3a3 3 0 0 0-3 3v4", key: "1k4jtn" }],
  ["path", { d: "M22 11V9", key: "3zbp94" }],
  ["path", { d: "M2 11V9", key: "1x5rnq" }],
  ["path", { d: "M6 4V2", key: "1rsq15" }],
  ["path", { d: "M18 4V2", key: "1jsdo1" }],
  ["path", { d: "M10 4V2", key: "75d9ly" }],
  ["path", { d: "M14 4V2", key: "8nj3z6" }]
], zx = r("Castle", Tx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dx = [
  [
    "path",
    {
      d: "M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z",
      key: "x6xyqk"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  ["path", { d: "M11.25 16.25h1.5L12 17l-.75-.75Z", key: "12kq1m" }]
], _x = r("Cat", Dx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Px = [
  [
    "path",
    {
      d: "M16.75 12h3.632a1 1 0 0 1 .894 1.447l-2.034 4.069a1 1 0 0 1-1.708.134l-2.124-2.97",
      key: "ir91b5"
    }
  ],
  [
    "path",
    {
      d: "M17.106 9.053a1 1 0 0 1 .447 1.341l-3.106 6.211a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3z",
      key: "jlp8i1"
    }
  ],
  ["path", { d: "M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15", key: "19bib8" }],
  ["path", { d: "M2 21v-4", key: "l40lih" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }]
], Ex = r("Cctv", Px);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rx = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  [
    "path",
    {
      d: "M7 11.207a.5.5 0 0 1 .146-.353l2-2a.5.5 0 0 1 .708 0l3.292 3.292a.5.5 0 0 0 .708 0l4.292-4.292a.5.5 0 0 1 .854.353V16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z",
      key: "q0gr47"
    }
  ]
], Hx = r("ChartArea", Rx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vx = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "7", y: "13", width: "9", height: "4", rx: "1", key: "1iip1u" }],
  ["rect", { x: "7", y: "5", width: "12", height: "4", rx: "1", key: "1anskk" }]
], Ox = r("ChartBarBig", Vx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qx = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 11h8", key: "1feolt" }],
  ["path", { d: "M7 16h3", key: "ur6vzw" }],
  ["path", { d: "M7 6h12", key: "sz5b0d" }]
], Bx = r("ChartBarDecreasing", qx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zx = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 11h8", key: "1feolt" }],
  ["path", { d: "M7 16h12", key: "wsnu98" }],
  ["path", { d: "M7 6h3", key: "w9rmul" }]
], Fx = r("ChartBarIncreasing", Zx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gx = [
  ["path", { d: "M11 13v4", key: "vyy2rb" }],
  ["path", { d: "M15 5v4", key: "1gx88a" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "7", y: "13", width: "9", height: "4", rx: "1", key: "1iip1u" }],
  ["rect", { x: "7", y: "5", width: "12", height: "4", rx: "1", key: "1anskk" }]
], $x = r("ChartBarStacked", Gx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ux = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 16h8", key: "srdodz" }],
  ["path", { d: "M7 11h12", key: "127s9w" }],
  ["path", { d: "M7 6h3", key: "w9rmul" }]
], Wx = r("ChartBar", Ux);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yx = [
  ["path", { d: "M9 5v4", key: "14uxtq" }],
  ["rect", { width: "4", height: "6", x: "7", y: "9", rx: "1", key: "f4fvz0" }],
  ["path", { d: "M9 15v2", key: "r5rk32" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["rect", { width: "4", height: "8", x: "15", y: "5", rx: "1", key: "z38je5" }],
  ["path", { d: "M17 13v3", key: "5l0wba" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }]
], Qx = r("ChartCandlestick", Yx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jx = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "15", y: "5", width: "4", height: "12", rx: "1", key: "q8uenq" }],
  ["rect", { x: "7", y: "8", width: "4", height: "9", rx: "1", key: "sr5ea" }]
], Kx = r("ChartColumnBig", Jx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xx = [
  ["path", { d: "M13 17V9", key: "1fwyjl" }],
  ["path", { d: "M18 17v-3", key: "1sqioe" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 17V5", key: "1wzmnc" }]
], eC = r("ChartColumnDecreasing", Xx);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tC = [
  ["path", { d: "M13 17V9", key: "1fwyjl" }],
  ["path", { d: "M18 17V5", key: "sfb6ij" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
], aC = r("ChartColumnIncreasing", tC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nC = [
  ["path", { d: "M11 13H7", key: "t0o9gq" }],
  ["path", { d: "M19 9h-4", key: "rera1j" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "15", y: "5", width: "4", height: "12", rx: "1", key: "q8uenq" }],
  ["rect", { x: "7", y: "8", width: "4", height: "9", rx: "1", key: "sr5ea" }]
], oC = r("ChartColumnStacked", nC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rC = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M18 17V9", key: "2bz60n" }],
  ["path", { d: "M13 17V5", key: "1frdt8" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
], iC = r("ChartColumn", rC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sC = [
  ["path", { d: "M10 6h8", key: "zvc2xc" }],
  ["path", { d: "M12 16h6", key: "yi5mkt" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 11h7", key: "wz2hg0" }]
], cC = r("ChartGantt", sC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fC = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "m19 9-5 5-4-4-3 3", key: "2osh9i" }]
], dC = r("ChartLine", fC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lC = [
  ["path", { d: "m13.11 7.664 1.78 2.672", key: "go2gg9" }],
  ["path", { d: "m14.162 12.788-3.324 1.424", key: "11x848" }],
  ["path", { d: "m20 4-6.06 1.515", key: "1wxxh7" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["circle", { cx: "12", cy: "6", r: "2", key: "1jj5th" }],
  ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }],
  ["circle", { cx: "9", cy: "15", r: "2", key: "lf2ghp" }]
], uC = r("ChartNetwork", lC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hC = [
  ["path", { d: "M12 20V10", key: "g8npz5" }],
  ["path", { d: "M18 20v-4", key: "8uic4z" }],
  ["path", { d: "M6 20V4", key: "1w1bmo" }]
], pC = r("ChartNoAxesColumnDecreasing", hC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yC = [
  ["line", { x1: "12", x2: "12", y1: "20", y2: "10", key: "1vz5eb" }],
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "16", key: "hq0ia6" }]
], mC = r("ChartNoAxesColumnIncreasing", yC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kC = [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "10", key: "1xfpm4" }],
  ["line", { x1: "12", x2: "12", y1: "20", y2: "4", key: "be30l9" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "14", key: "1r4le6" }]
], gC = r("ChartNoAxesColumn", kC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vC = [
  ["path", { d: "M12 16v5", key: "zza2cw" }],
  ["path", { d: "M16 14v7", key: "1g90b9" }],
  ["path", { d: "M20 10v11", key: "1iqoj0" }],
  [
    "path",
    { d: "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15", key: "1fw8x9" }
  ],
  ["path", { d: "M4 18v3", key: "1yp0dc" }],
  ["path", { d: "M8 14v7", key: "n3cwzv" }]
], MC = r("ChartNoAxesCombined", vC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wC = [
  ["path", { d: "M8 6h10", key: "9lnwnk" }],
  ["path", { d: "M6 12h9", key: "1g9pqf" }],
  ["path", { d: "M11 18h7", key: "c8dzvl" }]
], xC = r("ChartNoAxesGantt", wC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CC = [
  [
    "path",
    {
      d: "M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z",
      key: "pzmjnu"
    }
  ],
  ["path", { d: "M21.21 15.89A10 10 0 1 1 8 2.83", key: "k2fpak" }]
], bC = r("ChartPie", CC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LC = [
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }],
  ["circle", { cx: "18.5", cy: "5.5", r: ".5", fill: "currentColor", key: "lysivs" }],
  ["circle", { cx: "11.5", cy: "11.5", r: ".5", fill: "currentColor", key: "byv1b8" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" }],
  ["circle", { cx: "17.5", cy: "14.5", r: ".5", fill: "currentColor", key: "1gjh6j" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }]
], jC = r("ChartScatter", LC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NC = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 16c.5-2 1.5-7 4-7 2 0 2 3 4 3 2.5 0 4.5-5 5-7", key: "lw07rv" }]
], AC = r("ChartSpline", NC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SC = [
  ["path", { d: "M18 6 7 17l-5-5", key: "116fxf" }],
  ["path", { d: "m22 10-7.5 7.5L13 16", key: "ke71qq" }]
], IC = r("CheckCheck", SC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TC = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Gi = r("Check", TC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zC = [
  [
    "path",
    {
      d: "M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z",
      key: "1qvrer"
    }
  ],
  ["path", { d: "M6 17h12", key: "1jwigz" }]
], DC = r("ChefHat", zC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _C = [
  ["path", { d: "M2 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z", key: "cvxqlc" }],
  ["path", { d: "M12 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z", key: "1ostrc" }],
  ["path", { d: "M7 14c3.22-2.91 4.29-8.75 5-12 1.66 2.38 4.94 9 5 12", key: "hqx58h" }],
  ["path", { d: "M22 9c-4.29 0-7.14-2.33-10-7 5.71 0 10 4.67 10 7Z", key: "eykp1o" }]
], PC = r("Cherry", _C);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EC = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], tr = r("ChevronDown", EC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RC = [
  ["path", { d: "m17 18-6-6 6-6", key: "1yerx2" }],
  ["path", { d: "M7 6v12", key: "1p53r6" }]
], HC = r("ChevronFirst", RC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VC = [
  ["path", { d: "m7 18 6-6-6-6", key: "lwmzdw" }],
  ["path", { d: "M17 6v12", key: "1o0aio" }]
], OC = r("ChevronLast", VC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qC = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], BC = r("ChevronLeft", qC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZC = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], FC = r("ChevronRight", ZC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GC = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], Td = r("ChevronUp", GC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $C = [
  ["path", { d: "m7 20 5-5 5 5", key: "13a0gw" }],
  ["path", { d: "m7 4 5 5 5-5", key: "1kwcof" }]
], UC = r("ChevronsDownUp", $C);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WC = [
  ["path", { d: "m7 6 5 5 5-5", key: "1lc07p" }],
  ["path", { d: "m7 13 5 5 5-5", key: "1d48rs" }]
], YC = r("ChevronsDown", WC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QC = [
  ["path", { d: "m18 8 4 4-4 4", key: "1ak13k" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
], JC = r("ChevronsLeftRightEllipsis", QC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KC = [
  ["path", { d: "m9 7-5 5 5 5", key: "j5w590" }],
  ["path", { d: "m15 7 5 5-5 5", key: "1bl6da" }]
], XC = r("ChevronsLeftRight", KC);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eb = [
  ["path", { d: "m11 17-5-5 5-5", key: "13zhaf" }],
  ["path", { d: "m18 17-5-5 5-5", key: "h8a8et" }]
], tb = r("ChevronsLeft", eb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ab = [
  ["path", { d: "m20 17-5-5 5-5", key: "30x0n2" }],
  ["path", { d: "m4 17 5-5-5-5", key: "16spf4" }]
], nb = r("ChevronsRightLeft", ab);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ob = [
  ["path", { d: "m6 17 5-5-5-5", key: "xnjwq" }],
  ["path", { d: "m13 17 5-5-5-5", key: "17xmmf" }]
], rb = r("ChevronsRight", ob);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ib = [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
], sb = r("ChevronsUpDown", ib);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cb = [
  ["path", { d: "m17 11-5-5-5 5", key: "e8nh98" }],
  ["path", { d: "m17 18-5-5-5 5", key: "2avn1x" }]
], fb = r("ChevronsUp", cb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const db = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["line", { x1: "21.17", x2: "12", y1: "8", y2: "8", key: "a0cw5f" }],
  ["line", { x1: "3.95", x2: "8.54", y1: "6.06", y2: "14", key: "1kftof" }],
  ["line", { x1: "10.88", x2: "15.46", y1: "21.94", y2: "14", key: "1ymyh8" }]
], lb = r("Chrome", db);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ub = [
  ["path", { d: "M10 9h4", key: "u4k05v" }],
  ["path", { d: "M12 7v5", key: "ma6bk" }],
  ["path", { d: "M14 22v-4a2 2 0 0 0-4 0v4", key: "1pdhuj" }],
  [
    "path",
    {
      d: "M18 22V5.618a1 1 0 0 0-.553-.894l-4.553-2.277a2 2 0 0 0-1.788 0L6.553 4.724A1 1 0 0 0 6 5.618V22",
      key: "1rkokr"
    }
  ],
  [
    "path",
    {
      d: "m18 7 3.447 1.724a1 1 0 0 1 .553.894V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.618a1 1 0 0 1 .553-.894L6 7",
      key: "1w6esw"
    }
  ]
], hb = r("Church", ub);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pb = [
  ["path", { d: "M12 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h13", key: "1gdiyg" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M21 12a1 1 0 0 1 1 1v2a1 1 0 0 1-.5.866", key: "166zjj" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }],
  ["path", { d: "M7 12v4", key: "jqww69" }]
], yb = r("CigaretteOff", pb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mb = [
  ["path", { d: "M17 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h14", key: "1mb5g1" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "M21 16a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1", key: "1yl5r7" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }],
  ["path", { d: "M7 12v4", key: "jqww69" }]
], kb = r("Cigarette", mb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gb = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
], vb = r("CircleAlert", gb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mb = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
], wb = r("CircleArrowDown", Mb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xb = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }]
], Cb = r("CircleArrowLeft", xb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bb = [
  ["path", { d: "M2 12a10 10 0 1 1 10 10", key: "1yn6ov" }],
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "M8 22H2v-6", key: "sulq54" }]
], Lb = r("CircleArrowOutDownLeft", bb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jb = [
  ["path", { d: "M12 22a10 10 0 1 1 10-10", key: "130bv5" }],
  ["path", { d: "M22 22 12 12", key: "131aw7" }],
  ["path", { d: "M22 16v6h-6", key: "1gvm70" }]
], Nb = r("CircleArrowOutDownRight", jb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ab = [
  ["path", { d: "M2 8V2h6", key: "hiwtdz" }],
  ["path", { d: "m2 2 10 10", key: "1oh8rs" }],
  ["path", { d: "M12 2A10 10 0 1 1 2 12", key: "rrk4fa" }]
], Sb = r("CircleArrowOutUpLeft", Ab);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ib = [
  ["path", { d: "M22 12A10 10 0 1 1 12 2", key: "1fm58d" }],
  ["path", { d: "M22 2 12 12", key: "yg2myt" }],
  ["path", { d: "M16 2h6v6", key: "zan5cs" }]
], Tb = r("CircleArrowOutUpRight", Ib);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zb = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
], Db = r("CircleArrowRight", zb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _b = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
], Pb = r("CircleArrowUp", _b);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eb = [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
], Rb = r("CircleCheckBig", Eb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hb = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], Vb = r("CircleCheck", Hb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ob = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
], qb = r("CircleChevronDown", Ob);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bb = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
], Zb = r("CircleChevronLeft", Bb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fb = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
], Gb = r("CircleChevronRight", Fb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $b = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
], Ub = r("CircleChevronUp", $b);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wb = [
  ["path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0", key: "5ilxe3" }],
  ["path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0", key: "11zvb9" }],
  ["path", { d: "M17.609 3.721a10 10 0 0 1 2.69 2.7", key: "1iw5b2" }],
  ["path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8", key: "c0bmvh" }],
  ["path", { d: "M20.279 17.609a10 10 0 0 1-2.7 2.69", key: "1ruxm7" }],
  ["path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8", key: "qkgqxc" }],
  ["path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69", key: "1mcia2" }],
  ["path", { d: "M6.391 20.279a10 10 0 0 1-2.69-2.7", key: "1fvljs" }]
], Yb = r("CircleDashed", Wb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qb = [
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], Jb = r("CircleDivide", Qb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kb = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
], Xb = r("CircleDollarSign", Kb);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eL = [
  ["path", { d: "M10.1 2.18a9.93 9.93 0 0 1 3.8 0", key: "1qdqn0" }],
  ["path", { d: "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7", key: "1bq7p6" }],
  ["path", { d: "M21.82 10.1a9.93 9.93 0 0 1 0 3.8", key: "1rlaqf" }],
  ["path", { d: "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69", key: "1xk03u" }],
  ["path", { d: "M13.9 21.82a9.94 9.94 0 0 1-3.8 0", key: "l7re25" }],
  ["path", { d: "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7", key: "1v18p6" }],
  ["path", { d: "M2.18 13.9a9.93 9.93 0 0 1 0-3.8", key: "xdo6bj" }],
  ["path", { d: "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69", key: "1jjmaz" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
], tL = r("CircleDotDashed", eL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aL = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
], nL = r("CircleDot", aL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oL = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
], rL = r("CircleEllipsis", oL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iL = [
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], sL = r("CircleEqual", iL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cL = [
  ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }],
  ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
  ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
  ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
  ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }]
], fL = r("CircleFadingArrowUp", cL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dL = [
  ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
  ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
  ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
  ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }]
], lL = r("CircleFadingPlus", dL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uL = [
  ["path", { d: "M15.6 2.7a10 10 0 1 0 5.7 5.7", key: "1e0p6d" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M13.4 10.6 19 5", key: "1kr7tw" }]
], hL = r("CircleGauge", uL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pL = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], yL = r("CircleHelp", pL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mL = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], kL = r("CircleMinus", mL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gL = [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.35 2.69A10 10 0 0 1 21.3 15.65", key: "1pfsoa" }],
  ["path", { d: "M19.08 19.08A10 10 0 1 1 4.92 4.92", key: "1ablyi" }]
], vL = r("CircleOff", gL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ML = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m5 5 14 14", key: "11anup" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.34", key: "a9qo08" }]
], wL = r("CircleParkingOff", ML);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xL = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
], CL = r("CircleParking", xL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bL = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "10", x2: "10", y1: "15", y2: "9", key: "c1nkhi" }],
  ["line", { x1: "14", x2: "14", y1: "15", y2: "9", key: "h65svq" }]
], LL = r("CirclePause", bL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jL = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
], NL = r("CirclePercent", jL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AL = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polygon", { points: "10 8 16 12 10 16 10 8", key: "1cimsy" }]
], SL = r("CirclePlay", AL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IL = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
], TL = r("CirclePlus", IL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zL = [
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005", key: "1pek45" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], DL = r("CirclePower", zL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _L = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M22 2 2 22", key: "y4kqgn" }]
], PL = r("CircleSlash2", _L);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EL = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }]
], RL = r("CircleSlash", EL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HL = [["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }]], VL = r("CircleSmall", HL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OL = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["rect", { x: "9", y: "9", width: "6", height: "6", rx: "1", key: "1ssd4o" }]
], qL = r("CircleStop", OL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BL = [
  ["path", { d: "M18 20a6 6 0 0 0-12 0", key: "1qehca" }],
  ["circle", { cx: "12", cy: "10", r: "4", key: "1h16sb" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], ZL = r("CircleUserRound", BL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FL = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662", key: "154egf" }]
], GL = r("CircleUser", FL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $L = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], UL = r("CircleX", $L);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WL = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], YL = r("Circle", WL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QL = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M11 9h4a2 2 0 0 0 2-2V3", key: "1ve2rv" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "M7 21v-4a2 2 0 0 1 2-2h4", key: "1fwkro" }],
  ["circle", { cx: "15", cy: "15", r: "2", key: "3i40o0" }]
], JL = r("CircuitBoard", QL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KL = [
  [
    "path",
    {
      d: "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z",
      key: "4ite01"
    }
  ],
  ["path", { d: "M19.65 15.66A8 8 0 0 1 8.35 4.34", key: "1gxipu" }],
  ["path", { d: "m14 10-5.5 5.5", key: "92pfem" }],
  ["path", { d: "M14 17.85V10H6.15", key: "xqmtsk" }]
], XL = r("Citrus", KL);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ej = [
  [
    "path",
    { d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z", key: "1tn4o7" }
  ],
  ["path", { d: "m6.2 5.3 3.1 3.9", key: "iuk76l" }],
  ["path", { d: "m12.4 3.4 3.1 4", key: "6hsd6n" }],
  ["path", { d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z", key: "ltgou9" }]
], tj = r("Clapperboard", ej);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aj = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m9 14 2 2 4-4", key: "df797q" }]
], nj = r("ClipboardCheck", aj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oj = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2", key: "4jdomd" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v4", key: "3hqy98" }],
  ["path", { d: "M21 14H11", key: "1bme5i" }],
  ["path", { d: "m15 10-4 4 4 4", key: "5dvupr" }]
], rj = r("ClipboardCopy", oj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ij = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M12 11h4", key: "1jrz19" }],
  ["path", { d: "M12 16h4", key: "n85exb" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
], sj = r("ClipboardList", ij);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cj = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }]
], fj = r("ClipboardMinus", cj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dj = [
  [
    "path",
    { d: "M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z", key: "1pp7kr" }
  ],
  [
    "path",
    {
      d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10",
      key: "2ik1ml"
    }
  ],
  ["path", { d: "m17 10 4 4-4 4", key: "vp2hj1" }]
], lj = r("ClipboardPaste", dj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uj = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5", key: "1but9f" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 1.73 1", key: "1p8n7l" }],
  ["path", { d: "M8 18h1", key: "13wk12" }],
  [
    "path",
    {
      d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "2t3380"
    }
  ]
], hj = r("ClipboardPenLine", uj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pj = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5", key: "cereej" }],
  ["path", { d: "M4 13.5V6a2 2 0 0 1 2-2h2", key: "5ua5vh" }],
  [
    "path",
    {
      d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1y4qbx"
    }
  ]
], yj = r("ClipboardPen", pj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mj = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }],
  ["path", { d: "M12 17v-6", key: "1y8rbf" }]
], kj = r("ClipboardPlus", mj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gj = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 12v-1h6v1", key: "iehl6m" }],
  ["path", { d: "M11 17h2", key: "12w5me" }],
  ["path", { d: "M12 11v6", key: "1bwqyc" }]
], vj = r("ClipboardType", gj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mj = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m15 11-6 6", key: "1toa9n" }],
  ["path", { d: "m9 11 6 6", key: "wlibny" }]
], wj = r("ClipboardX", Mj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xj = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ]
], Cj = r("Clipboard", xj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bj = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 8", key: "12zbmj" }]
], Lj = r("Clock1", bj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jj = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 10", key: "atfzqc" }]
], Nj = r("Clock10", jj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aj = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 8", key: "l5bg6f" }]
], Sj = r("Clock11", Aj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ij = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12", key: "1fub01" }]
], Tj = r("Clock12", Ij);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zj = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 10", key: "1g230d" }]
], Dj = r("Clock2", zj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _j = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16.5 12", key: "1aq6pp" }]
], Pj = r("Clock3", _j);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ej = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
], Rj = r("Clock4", Ej);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hj = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 16", key: "1pcbox" }]
], Vj = r("Clock5", Hj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oj = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 12 16.5", key: "hb2qv6" }]
], qj = r("Clock6", Oj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bj = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 16", key: "ka3394" }]
], Zj = r("Clock7", Bj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fj = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 14", key: "tmc9b4" }]
], Gj = r("Clock8", Fj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $j = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 7.5 12", key: "1k60p0" }]
], Uj = r("Clock9", $j);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wj = [
  ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }],
  ["path", { d: "M16 21.16a10 10 0 1 1 5-13.516", key: "cxo92l" }],
  ["path", { d: "M20 11.5v6", key: "2ei3xq" }],
  ["path", { d: "M20 21.5h.01", key: "1r2dzp" }]
], Yj = r("ClockAlert", Wj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qj = [
  ["path", { d: "M12.338 21.994A10 10 0 1 1 21.925 13.227", key: "1i7shu" }],
  ["path", { d: "M12 6v6l2 1", key: "19cm8n" }],
  ["path", { d: "m14 18 4 4 4-4", key: "1waygx" }],
  ["path", { d: "M18 14v8", key: "irew45" }]
], Jj = r("ClockArrowDown", Qj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kj = [
  ["path", { d: "M13.228 21.925A10 10 0 1 1 21.994 12.338", key: "1fzlyi" }],
  ["path", { d: "M12 6v6l1.562.781", key: "1ujuk9" }],
  ["path", { d: "m14 18 4-4 4 4", key: "ftkppy" }],
  ["path", { d: "M18 22v-8", key: "su0gjh" }]
], Xj = r("ClockArrowUp", Kj);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eN = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
], tN = r("Clock", eN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aN = [
  ["path", { d: "M12 12v4", key: "tww15h" }],
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M17 18h.5a1 1 0 0 0 0-9h-1.79A7 7 0 1 0 7 17.708", key: "xsb5ju" }]
], nN = r("CloudAlert", aN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oN = [
  ["circle", { cx: "12", cy: "17", r: "3", key: "1spfwm" }],
  ["path", { d: "M4.2 15.1A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.2", key: "zaobp" }],
  ["path", { d: "m15.7 18.4-.9-.3", key: "4qxpbn" }],
  ["path", { d: "m9.2 15.9-.9-.3", key: "17q7o2" }],
  ["path", { d: "m10.6 20.7.3-.9", key: "1pf4s2" }],
  ["path", { d: "m13.1 14.2.3-.9", key: "1mnuqm" }],
  ["path", { d: "m13.6 20.7-.4-1", key: "1jpd1m" }],
  ["path", { d: "m10.8 14.3-.4-1", key: "17ugyy" }],
  ["path", { d: "m8.3 18.6 1-.4", key: "s42vdx" }],
  ["path", { d: "m14.7 15.8 1-.4", key: "2wizun" }]
], rN = r("CloudCog", oN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iN = [
  ["path", { d: "M12 13v8l-4-4", key: "1f5nwf" }],
  ["path", { d: "m12 21 4-4", key: "1lfcce" }],
  ["path", { d: "M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284", key: "ui1hmy" }]
], sN = r("CloudDownload", iN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cN = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M8 19v1", key: "1dk2by" }],
  ["path", { d: "M8 14v1", key: "84yxot" }],
  ["path", { d: "M16 19v1", key: "v220m7" }],
  ["path", { d: "M16 14v1", key: "g12gj6" }],
  ["path", { d: "M12 21v1", key: "q8vafk" }],
  ["path", { d: "M12 16v1", key: "1mx6rx" }]
], fN = r("CloudDrizzle", cN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dN = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 17H7", key: "pygtm1" }],
  ["path", { d: "M17 21H9", key: "1u2q02" }]
], lN = r("CloudFog", dN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uN = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v2", key: "a1is7l" }],
  ["path", { d: "M8 14v2", key: "1e9m6t" }],
  ["path", { d: "M16 20h.01", key: "xwek51" }],
  ["path", { d: "M8 20h.01", key: "1vjney" }],
  ["path", { d: "M12 16v2", key: "z66u1j" }],
  ["path", { d: "M12 22h.01", key: "1urd7a" }]
], hN = r("CloudHail", uN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pN = [
  ["path", { d: "M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973", key: "1cez44" }],
  ["path", { d: "m13 12-3 5h4l-3 5", key: "1t22er" }]
], yN = r("CloudLightning", pN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mN = [
  ["path", { d: "M10.188 8.5A6 6 0 0 1 16 4a1 1 0 0 0 6 6 6 6 0 0 1-3 5.197", key: "erj67n" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
], kN = r("CloudMoonRain", mN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gN = [
  ["path", { d: "M10.188 8.5A6 6 0 0 1 16 4a1 1 0 0 0 6 6 6 6 0 0 1-3 5.197", key: "erj67n" }],
  ["path", { d: "M13 16a3 3 0 1 1 0 6H7a5 5 0 1 1 4.9-6Z", key: "p44pc9" }]
], vN = r("CloudMoon", gN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MN = [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193", key: "yfwify" }],
  [
    "path",
    { d: "M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07", key: "jlfiyv" }
  ]
], wN = r("CloudOff", MN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xN = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m9.2 22 3-7", key: "sb5f6j" }],
  ["path", { d: "m9 13-3 7", key: "500co5" }],
  ["path", { d: "m17 13-3 7", key: "8t2fiy" }]
], CN = r("CloudRainWind", xN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bN = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v6", key: "1j4efv" }],
  ["path", { d: "M8 14v6", key: "17c4r9" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
], LN = r("CloudRain", bN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jN = [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M8 19h.01", key: "puxtts" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M12 21h.01", key: "h35vbk" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M16 19h.01", key: "1vcnzz" }]
], NN = r("CloudSnow", jN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AN = [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
], SN = r("CloudSunRain", AN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IN = [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z", key: "s09mg5" }]
], TN = r("CloudSun", IN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zN = [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m8 17 4-4 4 4", key: "1quai1" }]
], DN = r("CloudUpload", zN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _N = [
  ["path", { d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "p7xjir" }]
], PN = r("Cloud", _N);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EN = [
  ["path", { d: "M17.5 21H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "gqqjvc" }],
  ["path", { d: "M22 10a3 3 0 0 0-3-3h-2.207a5.502 5.502 0 0 0-10.702.5", key: "1p2s76" }]
], RN = r("Cloudy", EN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HN = [
  ["path", { d: "M16.17 7.83 2 22", key: "t58vo8" }],
  [
    "path",
    {
      d: "M4.02 12a2.827 2.827 0 1 1 3.81-4.17A2.827 2.827 0 1 1 12 4.02a2.827 2.827 0 1 1 4.17 3.81A2.827 2.827 0 1 1 19.98 12a2.827 2.827 0 1 1-3.81 4.17A2.827 2.827 0 1 1 12 19.98a2.827 2.827 0 1 1-4.17-3.81A1 1 0 1 1 4 12",
      key: "17k36q"
    }
  ],
  ["path", { d: "m7.83 7.83 8.34 8.34", key: "1d7sxk" }]
], VN = r("Clover", HN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ON = [
  [
    "path",
    {
      d: "M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z",
      key: "27yuqz"
    }
  ],
  ["path", { d: "M12 17.66L12 22", key: "ogfahf" }]
], qN = r("Club", ON);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BN = [
  ["path", { d: "m18 16 4-4-4-4", key: "1inbqp" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
  ["path", { d: "m14.5 4-5 16", key: "e7oirm" }]
], ZN = r("CodeXml", BN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FN = [
  ["polyline", { points: "16 18 22 12 16 6", key: "z7tu5w" }],
  ["polyline", { points: "8 6 2 12 8 18", key: "1eg1df" }]
], GN = r("Code", FN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $N = [
  ["polygon", { points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2", key: "srzb37" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "15.5", key: "1t73f2" }],
  ["polyline", { points: "22 8.5 12 15.5 2 8.5", key: "ajlxae" }],
  ["polyline", { points: "2 15.5 12 8.5 22 15.5", key: "susrui" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "8.5", key: "2cldga" }]
], UN = r("Codepen", $N);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WN = [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["polyline", { points: "7.5 4.21 12 6.81 16.5 4.21", key: "fabo96" }],
  ["polyline", { points: "7.5 19.79 7.5 14.6 3 12", key: "z377f1" }],
  ["polyline", { points: "21 12 16.5 14.6 16.5 19.79", key: "9nrev1" }],
  ["polyline", { points: "3.27 6.96 12 12.01 20.73 6.96", key: "1180pa" }],
  ["line", { x1: "12", x2: "12", y1: "22.08", y2: "12", key: "3z3uq6" }]
], YN = r("Codesandbox", WN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QN = [
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M14 2v2", key: "6buw04" }],
  [
    "path",
    {
      d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
      key: "pwadti"
    }
  ],
  ["path", { d: "M6 2v2", key: "colzsn" }]
], JN = r("Coffee", QN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KN = [
  ["path", { d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z", key: "sobvz5" }],
  ["path", { d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", key: "11i496" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 22v-2", key: "1osdcq" }],
  ["path", { d: "m17 20.66-1-1.73", key: "eq3orb" }],
  ["path", { d: "M11 10.27 7 3.34", key: "16pf9h" }],
  ["path", { d: "m20.66 17-1.73-1", key: "sg0v6f" }],
  ["path", { d: "m3.34 7 1.73 1", key: "1ulond" }],
  ["path", { d: "M14 12h8", key: "4f43i9" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "m20.66 7-1.73 1", key: "1ow05n" }],
  ["path", { d: "m3.34 17 1.73-1", key: "nuk764" }],
  ["path", { d: "m17 3.34-1 1.73", key: "2wel8s" }],
  ["path", { d: "m11 13.73-4 6.93", key: "794ttg" }]
], XN = r("Cog", KN);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eA = [
  ["circle", { cx: "8", cy: "8", r: "6", key: "3yglwk" }],
  ["path", { d: "M18.09 10.37A6 6 0 1 1 10.34 18", key: "t5s6rm" }],
  ["path", { d: "M7 6h1v4", key: "1obek4" }],
  ["path", { d: "m16.71 13.88.7.71-2.82 2.82", key: "1rbuyh" }]
], tA = r("Coins", eA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aA = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 3v18", key: "108xh3" }]
], nA = r("Columns2", aA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oA = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
], rA = r("Columns3", oA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iA = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7.5 3v18", key: "w0wo6v" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M16.5 3v18", key: "10tjh1" }]
], sA = r("Columns4", iA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cA = [
  ["path", { d: "M10 18H5a3 3 0 0 1-3-3v-1", key: "ru65g8" }],
  ["path", { d: "M14 2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "e30een" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "2ahx8o" }],
  ["path", { d: "m7 21 3-3-3-3", key: "127cv2" }],
  ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
  ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }]
], fA = r("Combine", cA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dA = [
  [
    "path",
    { d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3", key: "11bfej" }
  ]
], lA = r("Command", dA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uA = [
  [
    "path",
    {
      d: "m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z",
      key: "9ktpf1"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], hA = r("Compass", uA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pA = [
  [
    "path",
    {
      d: "M15.536 11.293a1 1 0 0 0 0 1.414l2.376 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z",
      key: "1uwlt4"
    }
  ],
  [
    "path",
    {
      d: "M2.297 11.293a1 1 0 0 0 0 1.414l2.377 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414L6.088 8.916a1 1 0 0 0-1.414 0z",
      key: "10291m"
    }
  ],
  [
    "path",
    {
      d: "M8.916 17.912a1 1 0 0 0 0 1.415l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.415l-2.377-2.376a1 1 0 0 0-1.414 0z",
      key: "1tqoq1"
    }
  ],
  [
    "path",
    {
      d: "M8.916 4.674a1 1 0 0 0 0 1.414l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z",
      key: "1x6lto"
    }
  ]
], yA = r("Component", pA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mA = [
  ["rect", { width: "14", height: "8", x: "5", y: "2", rx: "2", key: "wc9tft" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h2", key: "rwmk9e" }],
  ["path", { d: "M12 18h6", key: "aqd8w3" }]
], kA = r("Computer", mA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gA = [
  [
    "path",
    { d: "M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z", key: "1pvr1r" }
  ],
  ["path", { d: "M20 16a8 8 0 1 0-16 0", key: "1pa543" }],
  ["path", { d: "M12 4v4", key: "1bq03y" }],
  ["path", { d: "M10 4h4", key: "1xpv9s" }]
], vA = r("ConciergeBell", gA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MA = [
  ["path", { d: "m20.9 18.55-8-15.98a1 1 0 0 0-1.8 0l-8 15.98", key: "53pte7" }],
  ["ellipse", { cx: "12", cy: "19", rx: "9", ry: "3", key: "1ji25f" }]
], wA = r("Cone", MA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xA = [
  ["rect", { x: "2", y: "6", width: "20", height: "8", rx: "1", key: "1estib" }],
  ["path", { d: "M17 14v7", key: "7m2elx" }],
  ["path", { d: "M7 14v7", key: "1cm7wv" }],
  ["path", { d: "M17 3v3", key: "1v4jwn" }],
  ["path", { d: "M7 3v3", key: "7o6guu" }],
  ["path", { d: "M10 14 2.3 6.3", key: "1023jk" }],
  ["path", { d: "m14 6 7.7 7.7", key: "1s8pl2" }],
  ["path", { d: "m8 6 8 8", key: "hl96qh" }]
], CA = r("Construction", xA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bA = [
  ["path", { d: "M16 2v2", key: "scm5qe" }],
  ["path", { d: "M17.915 22a6 6 0 0 0-12 0", key: "suqz9p" }],
  ["path", { d: "M8 2v2", key: "pbkmx" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
], LA = r("ContactRound", bA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jA = [
  ["path", { d: "M16 2v2", key: "scm5qe" }],
  ["path", { d: "M7 22v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", key: "1waht3" }],
  ["path", { d: "M8 2v2", key: "pbkmx" }],
  ["circle", { cx: "12", cy: "11", r: "3", key: "itu57m" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
], NA = r("Contact", jA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AA = [
  [
    "path",
    {
      d: "M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z",
      key: "1t2lqe"
    }
  ],
  ["path", { d: "M10 21.9V14L2.1 9.1", key: "o7czzq" }],
  ["path", { d: "m10 14 11.9-6.9", key: "zm5e20" }],
  ["path", { d: "M14 19.8v-8.1", key: "159ecu" }],
  ["path", { d: "M18 17.5V9.4", key: "11uown" }]
], SA = r("Container", AA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IA = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 18a6 6 0 0 0 0-12v12z", key: "j4l70d" }]
], TA = r("Contrast", IA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zA = [
  ["path", { d: "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5", key: "laymnq" }],
  ["path", { d: "M8.5 8.5v.01", key: "ue8clq" }],
  ["path", { d: "M16 15.5v.01", key: "14dtrp" }],
  ["path", { d: "M12 12v.01", key: "u5ubse" }],
  ["path", { d: "M11 17v.01", key: "1hyl5a" }],
  ["path", { d: "M7 14v.01", key: "uct60s" }]
], DA = r("Cookie", zA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _A = [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8", key: "u0tga0" }],
  ["path", { d: "m4 8 16-4", key: "16g0ng" }],
  [
    "path",
    {
      d: "m8.86 6.78-.45-1.81a2 2 0 0 1 1.45-2.43l1.94-.48a2 2 0 0 1 2.43 1.46l.45 1.8",
      key: "12cejc"
    }
  ]
], PA = r("CookingPot", _A);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EA = [
  ["path", { d: "m12 15 2 2 4-4", key: "2c609p" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], RA = r("CopyCheck", EA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HA = [
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], VA = r("CopyMinus", HA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OA = [
  ["line", { x1: "15", x2: "15", y1: "12", y2: "18", key: "1p7wdc" }],
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], qA = r("CopyPlus", OA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BA = [
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], ZA = r("CopySlash", BA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FA = [
  ["line", { x1: "12", x2: "18", y1: "12", y2: "18", key: "1rg63v" }],
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], GA = r("CopyX", FA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $A = [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], UA = r("Copy", $A);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WA = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.17 14.83a4 4 0 1 0 0-5.66", key: "1sveal" }]
], YA = r("Copyleft", WA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QA = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M14.83 14.83a4 4 0 1 1 0-5.66", key: "1i56pz" }]
], JA = r("Copyright", QA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KA = [
  ["polyline", { points: "9 10 4 15 9 20", key: "r3jprv" }],
  ["path", { d: "M20 4v7a4 4 0 0 1-4 4H4", key: "6o5b7l" }]
], XA = r("CornerDownLeft", KA);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eS = [
  ["polyline", { points: "15 10 20 15 15 20", key: "1q7qjw" }],
  ["path", { d: "M4 4v7a4 4 0 0 0 4 4h12", key: "z08zvw" }]
], tS = r("CornerDownRight", eS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aS = [
  ["polyline", { points: "14 15 9 20 4 15", key: "nkc4i" }],
  ["path", { d: "M20 4h-7a4 4 0 0 0-4 4v12", key: "nbpdq2" }]
], nS = r("CornerLeftDown", aS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oS = [
  ["polyline", { points: "14 9 9 4 4 9", key: "m9oyvo" }],
  ["path", { d: "M20 20h-7a4 4 0 0 1-4-4V4", key: "1blwi3" }]
], rS = r("CornerLeftUp", oS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iS = [
  ["polyline", { points: "10 15 15 20 20 15", key: "axus6l" }],
  ["path", { d: "M4 4h7a4 4 0 0 1 4 4v12", key: "wcbgct" }]
], sS = r("CornerRightDown", iS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cS = [
  ["polyline", { points: "10 9 15 4 20 9", key: "1lr6px" }],
  ["path", { d: "M4 20h7a4 4 0 0 0 4-4V4", key: "1plgdj" }]
], fS = r("CornerRightUp", cS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dS = [
  ["polyline", { points: "9 14 4 9 9 4", key: "881910" }],
  ["path", { d: "M20 20v-7a4 4 0 0 0-4-4H4", key: "1nkjon" }]
], lS = r("CornerUpLeft", dS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uS = [
  ["polyline", { points: "15 14 20 9 15 4", key: "1tbx3s" }],
  ["path", { d: "M4 20v-7a4 4 0 0 1 4-4h12", key: "1lu4f8" }]
], hS = r("CornerUpRight", uS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pS = [
  ["rect", { width: "16", height: "16", x: "4", y: "4", rx: "2", key: "14l7u7" }],
  ["rect", { width: "6", height: "6", x: "9", y: "9", rx: "1", key: "5aljv4" }],
  ["path", { d: "M15 2v2", key: "13l42r" }],
  ["path", { d: "M15 20v2", key: "15mkzm" }],
  ["path", { d: "M2 15h2", key: "1gxd5l" }],
  ["path", { d: "M2 9h2", key: "1bbxkp" }],
  ["path", { d: "M20 15h2", key: "19e6y8" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M9 2v2", key: "165o2o" }],
  ["path", { d: "M9 20v2", key: "i2bqo8" }]
], yS = r("Cpu", pS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mS = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  [
    "path",
    { d: "M10 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1", key: "1ss3eq" }
  ],
  [
    "path",
    { d: "M17 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1", key: "1od56t" }
  ]
], kS = r("CreativeCommons", mS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gS = [
  ["rect", { width: "20", height: "14", x: "2", y: "5", rx: "2", key: "ynyp8z" }],
  ["line", { x1: "2", x2: "22", y1: "10", y2: "10", key: "1b3vmo" }]
], vS = r("CreditCard", gS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MS = [
  [
    "path",
    {
      d: "m4.6 13.11 5.79-3.21c1.89-1.05 4.79 1.78 3.71 3.71l-3.22 5.81C8.8 23.16.79 15.23 4.6 13.11Z",
      key: "1ozxlb"
    }
  ],
  [
    "path",
    {
      d: "m10.5 9.5-1-2.29C9.2 6.48 8.8 6 8 6H4.5C2.79 6 2 6.5 2 8.5a7.71 7.71 0 0 0 2 4.83",
      key: "ffuyb5"
    }
  ],
  ["path", { d: "M8 6c0-1.55.24-4-2-4-2 0-2.5 2.17-2.5 4", key: "osnpzi" }],
  [
    "path",
    {
      d: "m14.5 13.5 2.29 1c.73.3 1.21.7 1.21 1.5v3.5c0 1.71-.5 2.5-2.5 2.5a7.71 7.71 0 0 1-4.83-2",
      key: "1vubaw"
    }
  ],
  ["path", { d: "M18 16c1.55 0 4-.24 4 2 0 2-2.17 2.5-4 2.5", key: "wxr772" }]
], wS = r("Croissant", MS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xS = [
  ["path", { d: "M6 2v14a2 2 0 0 0 2 2h14", key: "ron5a4" }],
  ["path", { d: "M18 22V8a2 2 0 0 0-2-2H2", key: "7s9ehn" }]
], CS = r("Crop", xS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bS = [
  [
    "path",
    {
      d: "M4 9a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4a1 1 0 0 1 1 1v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4a1 1 0 0 1 1-1h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-4a1 1 0 0 1-1-1V4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4a1 1 0 0 1-1 1z",
      key: "1xbrqy"
    }
  ]
], LS = r("Cross", bS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jS = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "22", x2: "18", y1: "12", y2: "12", key: "l9bcsi" }],
  ["line", { x1: "6", x2: "2", y1: "12", y2: "12", key: "13hhkx" }],
  ["line", { x1: "12", x2: "12", y1: "6", y2: "2", key: "10w3f3" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "18", key: "15g9kq" }]
], NS = r("Crosshair", jS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AS = [
  [
    "path",
    {
      d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
      key: "1vdc57"
    }
  ],
  ["path", { d: "M5 21h14", key: "11awu3" }]
], SS = r("Crown", AS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IS = [
  [
    "path",
    {
      d: "m21.12 6.4-6.05-4.06a2 2 0 0 0-2.17-.05L2.95 8.41a2 2 0 0 0-.95 1.7v5.82a2 2 0 0 0 .88 1.66l6.05 4.07a2 2 0 0 0 2.17.05l9.95-6.12a2 2 0 0 0 .95-1.7V8.06a2 2 0 0 0-.88-1.66Z",
      key: "1u2ovd"
    }
  ],
  ["path", { d: "M10 22v-8L2.25 9.15", key: "11pn4q" }],
  ["path", { d: "m10 14 11.77-6.87", key: "1kt1wh" }]
], TS = r("Cuboid", IS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zS = [
  ["path", { d: "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8", key: "8166m8" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "yjz344" }],
  ["path", { d: "m12 8 1-6h2", key: "3ybfa4" }]
], DS = r("CupSoda", zS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _S = [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["line", { x1: "3", x2: "6", y1: "3", y2: "6", key: "1jkytn" }],
  ["line", { x1: "21", x2: "18", y1: "3", y2: "6", key: "14zfjt" }],
  ["line", { x1: "3", x2: "6", y1: "21", y2: "18", key: "iusuec" }],
  ["line", { x1: "21", x2: "18", y1: "21", y2: "18", key: "yj2dd7" }]
], PS = r("Currency", _S);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ES = [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 18 0V5", key: "aqi0yr" }]
], RS = r("Cylinder", ES);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HS = [
  [
    "path",
    { d: "M11 11.31c1.17.56 1.54 1.69 3.5 1.69 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1", key: "157kva" }
  ],
  ["path", { d: "M11.75 18c.35.5 1.45 1 2.75 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1", key: "d7q6m6" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  [
    "path",
    { d: "M7 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1L10 4a1 1 0 0 0-1-1z", key: "pr6s65" }
  ]
], VS = r("Dam", HS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OS = [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 12a9 3 0 0 0 5 2.69", key: "1ui2ym" }],
  ["path", { d: "M21 9.3V5", key: "6k6cib" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 6.47 2.88", key: "i62tjy" }],
  ["path", { d: "M12 12v4h4", key: "1bxaet" }],
  [
    "path",
    {
      d: "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16",
      key: "1f4ei9"
    }
  ]
], qS = r("DatabaseBackup", OS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BS = [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 15 21.84", key: "14ibmq" }],
  ["path", { d: "M21 5V8", key: "1marbg" }],
  ["path", { d: "M21 12L18 17H22L19 22", key: "zafso" }],
  ["path", { d: "M3 12A9 3 0 0 0 14.59 14.87", key: "1y4wr8" }]
], ZS = r("DatabaseZap", BS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FS = [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 21 19V5", key: "1wlel7" }],
  ["path", { d: "M3 12A9 3 0 0 0 21 12", key: "mv7ke4" }]
], GS = r("Database", FS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $S = [
  [
    "path",
    {
      d: "M10 5a2 2 0 0 0-1.344.519l-6.328 5.74a1 1 0 0 0 0 1.481l6.328 5.741A2 2 0 0 0 10 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z",
      key: "1yo7s0"
    }
  ],
  ["path", { d: "m12 9 6 6", key: "anjzzh" }],
  ["path", { d: "m18 9-6 6", key: "1fp51s" }]
], US = r("Delete", $S);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WS = [
  ["circle", { cx: "12", cy: "4", r: "2", key: "muu5ef" }],
  [
    "path",
    {
      d: "M10.2 3.2C5.5 4 2 8.1 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4 0c0-4.9-3.5-9-8.2-9.8",
      key: "lfo06j"
    }
  ],
  ["path", { d: "M3.2 14.8a9 9 0 0 0 17.6 0", key: "12xarc" }]
], YS = r("Dessert", WS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QS = [
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }],
  ["path", { d: "M6.48 3.66a10 10 0 0 1 13.86 13.86", key: "xr8kdq" }],
  ["path", { d: "m6.41 6.41 11.18 11.18", key: "uhpjw7" }],
  ["path", { d: "M3.66 6.48a10 10 0 0 0 13.86 13.86", key: "cldpwv" }]
], JS = r("Diameter", QS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KS = [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
      key: "1ey20j"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], XS = r("DiamondMinus", KS);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eI = [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0Z",
      key: "1tpxz2"
    }
  ],
  ["path", { d: "M9.2 9.2h.01", key: "1b7bvt" }],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "M14.7 14.8h.01", key: "17nsh4" }]
], tI = r("DiamondPercent", eI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aI = [
  ["path", { d: "M12 8v8", key: "napkw2" }],
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
      key: "1ey20j"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], nI = r("DiamondPlus", aI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oI = [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41l-7.59-7.59a2.41 2.41 0 0 0-3.41 0Z",
      key: "1f1r0c"
    }
  ]
], rI = r("Diamond", oI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iI = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
], sI = r("Dice1", iI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cI = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ["path", { d: "M9 15h.01", key: "fzyn71" }]
], fI = r("Dice2", cI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dI = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
], lI = r("Dice3", dI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uI = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }]
], hI = r("Dice4", uI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pI = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
], yI = r("Dice5", pI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mI = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
], kI = r("Dice6", mI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gI = [
  ["rect", { width: "12", height: "12", x: "2", y: "10", rx: "2", ry: "2", key: "6agr2n" }],
  [
    "path",
    { d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6", key: "1o487t" }
  ],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 14h.01", key: "ssrbsk" }],
  ["path", { d: "M15 6h.01", key: "cblpky" }],
  ["path", { d: "M18 9h.01", key: "2061c0" }]
], vI = r("Dices", gI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MI = [
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
], wI = r("Diff", MI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xI = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
], CI = r("Disc2", xI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bI = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M6 12c0-1.7.7-3.2 1.8-4.2", key: "oqkarx" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M18 12c0 1.7-.7 3.2-1.8 4.2", key: "1eah9h" }]
], LI = r("Disc3", bI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jI = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "12", r: "5", key: "nd82uf" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
], NI = r("DiscAlbum", jI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AI = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
], SI = r("Disc", AI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const II = [
  ["circle", { cx: "12", cy: "6", r: "1", key: "1bh7o1" }],
  ["line", { x1: "5", x2: "19", y1: "12", y2: "12", key: "13b5wn" }],
  ["circle", { cx: "12", cy: "18", r: "1", key: "lqb9t5" }]
], TI = r("Divide", II);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zI = [
  ["path", { d: "M15 2c-1.35 1.5-2.092 3-2.5 4.5L14 8", key: "1bivrr" }],
  ["path", { d: "m17 6-2.891-2.891", key: "xu6p2f" }],
  ["path", { d: "M2 15c3.333-3 6.667-3 10-3", key: "nxix30" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "m20 9 .891.891", key: "3xwk7g" }],
  ["path", { d: "M22 9c-1.5 1.35-3 2.092-4.5 2.5l-1-1", key: "18cutr" }],
  ["path", { d: "M3.109 14.109 4 15", key: "q76aoh" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m7 18 2.891 2.891", key: "1sisit" }],
  ["path", { d: "M9 22c1.35-1.5 2.092-3 2.5-4.5L10 16", key: "rlvei3" }]
], DI = r("DnaOff", zI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _I = [
  ["path", { d: "m10 16 1.5 1.5", key: "11lckj" }],
  ["path", { d: "m14 8-1.5-1.5", key: "1ohn8i" }],
  ["path", { d: "M15 2c-1.798 1.998-2.518 3.995-2.807 5.993", key: "80uv8i" }],
  ["path", { d: "m16.5 10.5 1 1", key: "696xn5" }],
  ["path", { d: "m17 6-2.891-2.891", key: "xu6p2f" }],
  ["path", { d: "M2 15c6.667-6 13.333 0 20-6", key: "1pyr53" }],
  ["path", { d: "m20 9 .891.891", key: "3xwk7g" }],
  ["path", { d: "M3.109 14.109 4 15", key: "q76aoh" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m7 18 2.891 2.891", key: "1sisit" }],
  ["path", { d: "M9 22c1.798-1.998 2.518-3.995 2.807-5.993", key: "q3hbxp" }]
], PI = r("Dna", _I);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EI = [
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 16h12", key: "u522kt" }]
], RI = r("Dock", EI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HI = [
  ["path", { d: "M11.25 16.25h1.5L12 17z", key: "w7jh35" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  [
    "path",
    {
      d: "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444a11.702 11.702 0 0 0-.493-3.309",
      key: "u7s9ue"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  [
    "path",
    {
      d: "M8.5 8.5c-.384 1.05-1.083 2.028-2.344 2.5-1.931.722-3.576-.297-3.656-1-.113-.994 1.177-6.53 4-7 1.923-.321 3.651.845 3.651 2.235A7.497 7.497 0 0 1 14 5.277c0-1.39 1.844-2.598 3.767-2.277 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5",
      key: "v8hric"
    }
  ]
], VI = r("Dog", HI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OI = [
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
  ["path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6", key: "1b0p4s" }]
], qI = r("DollarSign", OI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BI = [
  [
    "path",
    {
      d: "M20.5 10a2.5 2.5 0 0 1-2.4-3H18a2.95 2.95 0 0 1-2.6-4.4 10 10 0 1 0 6.3 7.1c-.3.2-.8.3-1.2.3",
      key: "19sr3x"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], ZI = r("Donut", BI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FI = [
  ["path", { d: "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14", key: "36qu9e" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M14 12v.01", key: "xfcn54" }]
], GI = r("DoorClosed", FI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $I = [
  ["path", { d: "M13 4h3a2 2 0 0 1 2 2v14", key: "hrm0s9" }],
  ["path", { d: "M2 20h3", key: "1gaodv" }],
  ["path", { d: "M13 20h9", key: "s90cdi" }],
  ["path", { d: "M10 12v.01", key: "vx6srw" }],
  [
    "path",
    {
      d: "M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z",
      key: "199qr4"
    }
  ]
], UI = r("DoorOpen", $I);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WI = [["circle", { cx: "12.1", cy: "12.1", r: "1", key: "18d7e5" }]], YI = r("Dot", WI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QI = [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "7 10 12 15 17 10", key: "2ggqvy" }],
  ["line", { x1: "12", x2: "12", y1: "15", y2: "3", key: "1vk2je" }]
], JI = r("Download", QI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KI = [
  ["path", { d: "m12.99 6.74 1.93 3.44", key: "iwagvd" }],
  ["path", { d: "M19.136 12a10 10 0 0 1-14.271 0", key: "ppmlo4" }],
  ["path", { d: "m21 21-2.16-3.84", key: "vylbct" }],
  ["path", { d: "m3 21 8.02-14.26", key: "1ssaw4" }],
  ["circle", { cx: "12", cy: "5", r: "2", key: "f1ur92" }]
], XI = r("DraftingCompass", KI);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eT = [
  ["path", { d: "M10 11h.01", key: "d2at3l" }],
  ["path", { d: "M14 6h.01", key: "k028ub" }],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6.5 13.1h.01", key: "1748ia" }],
  ["path", { d: "M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3", key: "172yzv" }],
  ["path", { d: "M17.4 9.9c-.8.8-2 .8-2.8 0", key: "1obv0w" }],
  [
    "path",
    {
      d: "M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7",
      key: "rqjl8i"
    }
  ],
  ["path", { d: "M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4", key: "1mr6wy" }]
], tT = r("Drama", eT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aT = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M19.13 5.09C15.22 9.14 10 10.44 2.25 10.94", key: "hpej1" }],
  ["path", { d: "M21.75 12.84c-6.62-1.41-12.14 1-16.38 6.32", key: "1tr44o" }],
  ["path", { d: "M8.56 2.75c4.37 6 6 9.42 8 17.72", key: "kbh691" }]
], nT = r("Dribbble", aT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oT = [
  [
    "path",
    { d: "M10 18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3 1 1 0 0 1 1-1z", key: "ioqxb1" }
  ],
  [
    "path",
    {
      d: "M13 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1l-.81 3.242a1 1 0 0 1-.97.758H8",
      key: "1rs59n"
    }
  ],
  ["path", { d: "M14 4h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3", key: "105ega" }],
  ["path", { d: "M18 6h4", key: "66u95g" }],
  ["path", { d: "m5 10-2 8", key: "xt2lic" }],
  ["path", { d: "m7 18 2-8", key: "1bzku2" }]
], rT = r("Drill", oT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iT = [
  [
    "path",
    {
      d: "M18.715 13.186C18.29 11.858 17.384 10.607 16 9.5c-2-1.6-3.5-4-4-6.5a10.7 10.7 0 0 1-.884 2.586",
      key: "8suz2t"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    { d: "M8.795 8.797A11 11 0 0 1 8 9.5C6 11.1 5 13 5 15a7 7 0 0 0 13.222 3.208", key: "19dw9m" }
  ]
], sT = r("DropletOff", iT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cT = [
  [
    "path",
    {
      d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
      key: "c7niix"
    }
  ]
], fT = r("Droplet", cT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dT = [
  [
    "path",
    {
      d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
      key: "1ptgy4"
    }
  ],
  [
    "path",
    {
      d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
      key: "1sl1rz"
    }
  ]
], lT = r("Droplets", dT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uT = [
  ["path", { d: "m2 2 8 8", key: "1v6059" }],
  ["path", { d: "m22 2-8 8", key: "173r8a" }],
  ["ellipse", { cx: "12", cy: "9", rx: "10", ry: "5", key: "liohsx" }],
  ["path", { d: "M7 13.4v7.9", key: "1yi6u9" }],
  ["path", { d: "M12 14v8", key: "1tn2tj" }],
  ["path", { d: "M17 13.4v7.9", key: "eqz2v3" }],
  ["path", { d: "M2 9v8a10 5 0 0 0 20 0V9", key: "1750ul" }]
], hT = r("Drum", uT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pT = [
  [
    "path",
    { d: "M15.4 15.63a7.875 6 135 1 1 6.23-6.23 4.5 3.43 135 0 0-6.23 6.23", key: "1dtqwm" }
  ],
  [
    "path",
    {
      d: "m8.29 12.71-2.6 2.6a2.5 2.5 0 1 0-1.65 4.65A2.5 2.5 0 1 0 8.7 18.3l2.59-2.59",
      key: "1oq1fw"
    }
  ]
], yT = r("Drumstick", pT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mT = [
  ["path", { d: "M14.4 14.4 9.6 9.6", key: "ic80wn" }],
  [
    "path",
    {
      d: "M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z",
      key: "nnl7wr"
    }
  ],
  ["path", { d: "m21.5 21.5-1.4-1.4", key: "1f1ice" }],
  ["path", { d: "M3.9 3.9 2.5 2.5", key: "1evmna" }],
  [
    "path",
    {
      d: "M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z",
      key: "yhosts"
    }
  ]
], kT = r("Dumbbell", mT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gT = [
  ["path", { d: "M6 18.5a3.5 3.5 0 1 0 7 0c0-1.57.92-2.52 2.04-3.46", key: "1qngmn" }],
  ["path", { d: "M6 8.5c0-.75.13-1.47.36-2.14", key: "b06bma" }],
  ["path", { d: "M8.8 3.15A6.5 6.5 0 0 1 19 8.5c0 1.63-.44 2.81-1.09 3.76", key: "g10hsz" }],
  ["path", { d: "M12.5 6A2.5 2.5 0 0 1 15 8.5M10 13a2 2 0 0 0 1.82-1.18", key: "ygzou7" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], vT = r("EarOff", gT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MT = [
  ["path", { d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0", key: "1dfaln" }],
  ["path", { d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4", key: "1qnva7" }]
], wT = r("Ear", MT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xT = [
  ["path", { d: "M7 3.34V5a3 3 0 0 0 3 3", key: "w732o8" }],
  ["path", { d: "M11 21.95V18a2 2 0 0 0-2-2 2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05", key: "f02343" }],
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  ["path", { d: "M12 2a10 10 0 1 0 9.54 13", key: "zjsr6q" }],
  ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
  ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" }]
], CT = r("EarthLock", xT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bT = [
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  [
    "path",
    {
      d: "M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17",
      key: "1tzkfa"
    }
  ],
  ["path", { d: "M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05", key: "14pb5j" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], LT = r("Earth", bT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jT = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a7 7 0 1 0 10 10", key: "1yuj32" }]
], NT = r("Eclipse", jT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AT = [
  ["circle", { cx: "11.5", cy: "12.5", r: "3.5", key: "1cl1mi" }],
  [
    "path",
    {
      d: "M3 8c0-3.5 2.5-6 6.5-6 5 0 4.83 3 7.5 5s5 2 5 6c0 4.5-2.5 6.5-7 6.5-2.5 0-2.5 2.5-6 2.5s-7-2-7-5.5c0-3 1.5-3 1.5-5C3.5 10 3 9 3 8Z",
      key: "165ef9"
    }
  ]
], ST = r("EggFried", AT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IT = [
  [
    "path",
    {
      d: "M6.399 6.399C5.362 8.157 4.65 10.189 4.5 12c-.37 4.43 1.27 9.95 7.5 10 3.256-.026 5.259-1.547 6.375-3.625",
      key: "6et380"
    }
  ],
  [
    "path",
    {
      d: "M19.532 13.875A14.07 14.07 0 0 0 19.5 12c-.36-4.34-3.95-9.96-7.5-10-1.04.012-2.082.502-3.046 1.297",
      key: "gcdc3f"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], TT = r("EggOff", IT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zT = [
  [
    "path",
    {
      d: "M12 22c6.23-.05 7.87-5.57 7.5-10-.36-4.34-3.95-9.96-7.5-10-3.55.04-7.14 5.66-7.5 10-.37 4.43 1.27 9.95 7.5 10z",
      key: "1c39pg"
    }
  ]
], DT = r("Egg", zT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _T = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
], PT = r("EllipsisVertical", _T);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ET = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
], RT = r("Ellipsis", ET);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HT = [
  ["path", { d: "M5 15a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0", key: "yrdkhy" }],
  ["path", { d: "M5 9a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0", key: "gzkvyz" }]
], VT = r("EqualApproximately", HT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OT = [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }],
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }]
], qT = r("EqualNot", OT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BT = [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }]
], ZT = r("Equal", BT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FT = [
  [
    "path",
    {
      d: "m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21",
      key: "182aya"
    }
  ],
  ["path", { d: "M22 21H7", key: "t4ddhn" }],
  ["path", { d: "m5 11 9 9", key: "1mo9qw" }]
], GT = r("Eraser", FT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $T = [
  [
    "path",
    {
      d: "m15 20 3-3h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h2l3 3z",
      key: "rbahqx"
    }
  ],
  ["path", { d: "M6 8v1", key: "1636ez" }],
  ["path", { d: "M10 8v1", key: "1talb4" }],
  ["path", { d: "M14 8v1", key: "1rsfgr" }],
  ["path", { d: "M18 8v1", key: "gnkwox" }]
], UT = r("EthernetPort", $T);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WT = [
  ["path", { d: "M4 10h12", key: "1y6xl8" }],
  ["path", { d: "M4 14h9", key: "1loblj" }],
  [
    "path",
    {
      d: "M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2",
      key: "1j6lzo"
    }
  ]
], YT = r("Euro", WT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QT = [
  ["path", { d: "m15 15 6 6", key: "1s409w" }],
  ["path", { d: "m15 9 6-6", key: "ko1vev" }],
  ["path", { d: "M21 16.2V21h-4.8", key: "1hrera" }],
  ["path", { d: "M21 7.8V3h-4.8", key: "ul1q53" }],
  ["path", { d: "M3 16.2V21h4.8", key: "1x04uo" }],
  ["path", { d: "m3 21 6-6", key: "wwnumi" }],
  ["path", { d: "M3 7.8V3h4.8", key: "1ijppm" }],
  ["path", { d: "M9 9 3 3", key: "v551iv" }]
], JT = r("Expand", QT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KT = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
], XT = r("ExternalLink", KT);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ez = [
  ["path", { d: "m15 18-.722-3.25", key: "1j64jw" }],
  ["path", { d: "M2 8a10.645 10.645 0 0 0 20 0", key: "1e7gxb" }],
  ["path", { d: "m20 15-1.726-2.05", key: "1cnuld" }],
  ["path", { d: "m4 15 1.726-2.05", key: "1dsqqd" }],
  ["path", { d: "m9 18 .722-3.25", key: "ypw2yx" }]
], tz = r("EyeClosed", ez);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const az = [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], nz = r("EyeOff", az);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oz = [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], rz = r("Eye", oz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iz = [
  [
    "path",
    { d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z", key: "1jg4f8" }
  ]
], sz = r("Facebook", iz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cz = [
  [
    "path",
    {
      d: "M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "159hny"
    }
  ],
  ["path", { d: "M17 18h1", key: "uldtlt" }],
  ["path", { d: "M12 18h1", key: "s9uhes" }],
  ["path", { d: "M7 18h1", key: "1neino" }]
], fz = r("Factory", cz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dz = [
  [
    "path",
    {
      d: "M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z",
      key: "484a7f"
    }
  ],
  ["path", { d: "M12 12v.01", key: "u5ubse" }]
], lz = r("Fan", dz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uz = [
  ["polygon", { points: "13 19 22 12 13 5 13 19", key: "587y9g" }],
  ["polygon", { points: "2 19 11 12 2 5 2 19", key: "3pweh0" }]
], hz = r("FastForward", uz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pz = [
  [
    "path",
    {
      d: "M12.67 19a2 2 0 0 0 1.416-.588l6.154-6.172a6 6 0 0 0-8.49-8.49L5.586 9.914A2 2 0 0 0 5 11.328V18a1 1 0 0 0 1 1z",
      key: "18jl4k"
    }
  ],
  ["path", { d: "M16 8 2 22", key: "vp34q" }],
  ["path", { d: "M17.5 15H9", key: "1oz8nu" }]
], yz = r("Feather", pz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mz = [
  ["path", { d: "M4 3 2 5v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "1n2rgs" }],
  ["path", { d: "M6 8h4", key: "utf9t1" }],
  ["path", { d: "M6 18h4", key: "12yh4b" }],
  ["path", { d: "m12 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "3ha7mj" }],
  ["path", { d: "M14 8h4", key: "1r8wg2" }],
  ["path", { d: "M14 18h4", key: "1t3kbu" }],
  ["path", { d: "m20 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "dfd4e2" }]
], kz = r("Fence", mz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gz = [
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m6.8 15-3.5 2", key: "hjy98k" }],
  ["path", { d: "m20.7 7-3.5 2", key: "f08gto" }],
  ["path", { d: "M6.8 9 3.3 7", key: "1aevh4" }],
  ["path", { d: "m20.7 17-3.5-2", key: "1liqo3" }],
  ["path", { d: "m9 22 3-8 3 8", key: "wees03" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M18 18.7a9 9 0 1 0-12 0", key: "dhzg4g" }]
], vz = r("FerrisWheel", gz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mz = [
  ["path", { d: "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z", key: "1340ok" }],
  ["path", { d: "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z", key: "1hz3m3" }],
  ["path", { d: "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z", key: "1oz8n2" }],
  ["path", { d: "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z", key: "1ff65i" }],
  ["path", { d: "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z", key: "pdip6e" }]
], wz = r("Figma", Mz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xz = [
  ["path", { d: "M10 12v-1", key: "v7bkov" }],
  ["path", { d: "M10 18v-2", key: "1cjy8d" }],
  ["path", { d: "M10 7V6", key: "dljcrl" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M15.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 .274 1.01", key: "gkbcor" }
  ],
  ["circle", { cx: "10", cy: "20", r: "2", key: "1xzdoj" }]
], Cz = r("FileArchive", xz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bz = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "3", cy: "17", r: "1", key: "vo6nti" }],
  ["path", { d: "M2 17v-3a4 4 0 0 1 8 0v3", key: "1ggdre" }],
  ["circle", { cx: "9", cy: "17", r: "1", key: "bc1fq4" }]
], Lz = r("FileAudio2", bz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jz = [
  ["path", { d: "M17.5 22h.5a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "rslqgf" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M2 19a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0v-4a6 6 0 0 1 12 0v4a2 2 0 1 1-4 0v-1a2 2 0 1 1 4 0",
      key: "9f7x3i"
    }
  ]
], Nz = r("FileAudio", jz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Az = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 18 4-4", key: "12zab0" }],
  ["path", { d: "M8 10v8h8", key: "tlaukw" }]
], Sz = r("FileAxis3d", Az);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14 12.5 1 5.5-3-1-3 1 1-5.5", key: "14xlky" }]
], Tz = r("FileBadge2", Iz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zz = [
  ["path", { d: "M12 22h6a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "12ixgl" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "u0c8gj" }],
  ["path", { d: "M7 16.5 8 22l-3-1-3 1 1-5.5", key: "5gm2nr" }]
], Dz = r("FileBadge", zz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _z = [
  ["path", { d: "M14.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "16lz6z" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M3 13.1a2 2 0 0 0-1 1.76v3.24a2 2 0 0 0 .97 1.78L6 21.7a2 2 0 0 0 2.03.01L11 19.9a2 2 0 0 0 1-1.76V14.9a2 2 0 0 0-.97-1.78L8 11.3a2 2 0 0 0-2.03-.01Z",
      key: "99pj1s"
    }
  ],
  ["path", { d: "M7 17v5", key: "1yj1jh" }],
  ["path", { d: "M11.7 14.2 7 17l-4.7-2.8", key: "1yk8tc" }]
], Pz = r("FileBox", _z);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ez = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 18v-2", key: "qcmpov" }],
  ["path", { d: "M12 18v-4", key: "q1q25u" }],
  ["path", { d: "M16 18v-6", key: "15y0np" }]
], Rz = r("FileChartColumnIncreasing", Ez);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 18v-1", key: "zg0ygc" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "M16 18v-3", key: "j5jt4h" }]
], Vz = r("FileChartColumn", Hz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oz = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m16 13-3.5 3.5-2-2L8 17", key: "zz7yod" }]
], qz = r("FileChartLine", Oz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bz = [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3.5", key: "13ddob" }],
  ["path", { d: "M4.017 11.512a6 6 0 1 0 8.466 8.475", key: "s6vs5t" }],
  [
    "path",
    {
      d: "M9 16a1 1 0 0 1-1-1v-4c0-.552.45-1.008.995-.917a6 6 0 0 1 4.922 4.922c.091.544-.365.995-.917.995z",
      key: "1dl6s6"
    }
  ]
], Zz = r("FileChartPie", Bz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fz = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m3 15 2 2 4-4", key: "1lhrkk" }]
], Gz = r("FileCheck2", Fz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $z = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m9 15 2 2 4-4", key: "1grp1n" }]
], Uz = r("FileCheck", $z);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wz = [
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "37hlfg" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "8", cy: "16", r: "6", key: "10v15b" }],
  ["path", { d: "M9.5 17.5 8 16.25V14", key: "1o80t2" }]
], Yz = r("FileClock", Wz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qz = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m5 12-3 3 3 3", key: "oke12k" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
], Jz = r("FileCode2", Qz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kz = [
  ["path", { d: "M10 12.5 8 15l2 2.5", key: "1tg20x" }],
  ["path", { d: "m14 12.5 2 2.5-2 2.5", key: "yinavb" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }]
], Xz = r("FileCode", Kz);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eD = [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m3.2 12.9-.9-.4", key: "1i3dj5" }],
  ["path", { d: "m3.2 15.1-.9.4", key: "1fvgj0" }],
  [
    "path",
    {
      d: "M4.677 21.5a2 2 0 0 0 1.313.5H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2.5",
      key: "1yo3oz"
    }
  ],
  ["path", { d: "m4.9 11.2-.4-.9", key: "otmhb9" }],
  ["path", { d: "m4.9 16.8-.4.9", key: "1b8z07" }],
  ["path", { d: "m7.5 10.3-.4.9", key: "11k65u" }],
  ["path", { d: "m7.5 17.7-.4-.9", key: "431x55" }],
  ["path", { d: "m9.7 12.5-.9.4", key: "87sjan" }],
  ["path", { d: "m9.7 15.5-.9-.4", key: "khqm91" }],
  ["circle", { cx: "6", cy: "14", r: "3", key: "a1xfv6" }]
], tD = r("FileCog", eD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aD = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
], nD = r("FileDiff", aD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oD = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "4", height: "6", x: "2", y: "12", rx: "2", key: "jm304g" }],
  ["path", { d: "M10 12h2v6", key: "12zw74" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
], rD = r("FileDigit", oD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iD = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "m9 15 3 3 3-3", key: "1npd3o" }]
], sD = r("FileDown", iD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cD = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M10.29 10.7a2.43 2.43 0 0 0-2.66-.52c-.29.12-.56.3-.78.53l-.35.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L6.5 18l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1c1fso"
    }
  ]
], fD = r("FileHeart", cD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dD = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "10", cy: "12", r: "2", key: "737tya" }],
  ["path", { d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22", key: "wt3hpn" }]
], lD = r("FileImage", dD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uD = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M2 15h10", key: "jfw4w8" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
], hD = r("FileInput", uD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pD = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "fq0c9t" }
  ],
  [
    "path",
    { d: "M8 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "4gibmv" }
  ]
], yD = r("FileJson2", pD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mD = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "1oajmo" }
  ],
  [
    "path",
    { d: "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "mpwhp6" }
  ]
], kD = r("FileJson", mD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gD = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v6", key: "rc0qvx" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "m10 10-4.5 4.5", key: "7fwrp6" }],
  ["path", { d: "m9 11 1 1", key: "wa6s5q" }]
], vD = r("FileKey2", gD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MD = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["circle", { cx: "10", cy: "16", r: "2", key: "4ckbqe" }],
  ["path", { d: "m16 10-4.5 4.5", key: "7p3ebg" }],
  ["path", { d: "m15 11 1 1", key: "1bsyx3" }]
], wD = r("FileKey", MD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xD = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v1", key: "jmtmu2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "8", height: "5", x: "2", y: "13", rx: "1", key: "10y5wo" }],
  ["path", { d: "M8 13v-2a2 2 0 1 0-4 0v2", key: "1pdxzg" }]
], CD = r("FileLock2", xD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bD = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["rect", { width: "8", height: "6", x: "8", y: "12", rx: "1", key: "3yr8at" }],
  ["path", { d: "M10 12v-2a2 2 0 1 1 4 0v2", key: "j4i8d" }]
], LD = r("FileLock", bD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jD = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }]
], ND = r("FileMinus2", jD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AD = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }]
], SD = r("FileMinus", AD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ID = [
  ["path", { d: "M10.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v8.4", key: "1d3kfm" }],
  ["path", { d: "M8 18v-7.7L16 9v7", key: "1oie6o" }],
  ["circle", { cx: "14", cy: "16", r: "2", key: "1bzzi3" }],
  ["circle", { cx: "6", cy: "18", r: "2", key: "1fncim" }]
], TD = r("FileMusic", ID);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zD = [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M4 7V4a2 2 0 0 1 2-2 2 2 0 0 0-2 2", key: "1vk7w2" }],
  ["path", { d: "M4.063 20.999a2 2 0 0 0 2 1L18 22a2 2 0 0 0 2-2V7l-5-5H6", key: "1jink5" }],
  ["path", { d: "m5 11-3 3", key: "1dgrs4" }],
  ["path", { d: "m5 17-3-3h10", key: "1mvvaf" }]
], DD = r("FileOutput", zD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _D = [
  [
    "path",
    {
      d: "m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2",
      key: "142zxg"
    }
  ],
  [
    "path",
    {
      d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "2t3380"
    }
  ],
  ["path", { d: "M8 18h1", key: "13wk12" }]
], PD = r("FilePenLine", _D);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ED = [
  ["path", { d: "M12.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v9.5", key: "1couwa" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1y4qbx"
    }
  ]
], RD = r("FilePen", ED);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HD = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }],
  ["path", { d: "M6 12v6", key: "1u72j0" }]
], VD = r("FilePlus2", HD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OD = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }]
], qD = r("FilePlus", OD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BD = [
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }]
], ZD = r("FileQuestion", BD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FD = [
  ["path", { d: "M20 10V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4", key: "1rdf37" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M16 14a2 2 0 0 0-2 2", key: "ceaadl" }],
  ["path", { d: "M20 14a2 2 0 0 1 2 2", key: "1ny6zw" }],
  ["path", { d: "M20 22a2 2 0 0 0 2-2", key: "1l9q4k" }],
  ["path", { d: "M16 22a2 2 0 0 1-2-2", key: "1wqh5n" }]
], GD = r("FileScan", FD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $D = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "11.5", cy: "14.5", r: "2.5", key: "1bq0ko" }],
  ["path", { d: "M13.3 16.3 15 18", key: "2quom7" }]
], UD = r("FileSearch2", $D);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WD = [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4.268 21a2 2 0 0 0 1.727 1H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "ms7g94" }
  ],
  ["path", { d: "m9 18-1.5-1.5", key: "1j6qii" }],
  ["circle", { cx: "5", cy: "14", r: "3", key: "ufru5t" }]
], YD = r("FileSearch", WD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QD = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M10 11v2", key: "1s651w" }],
  ["path", { d: "M8 17h8", key: "wh5c61" }],
  ["path", { d: "M14 16v2", key: "12fp5e" }]
], JD = r("FileSliders", QD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KD = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 13h2", key: "yr2amv" }],
  ["path", { d: "M14 13h2", key: "un5t4a" }],
  ["path", { d: "M8 17h2", key: "2yhykz" }],
  ["path", { d: "M14 17h2", key: "10kma7" }]
], XD = r("FileSpreadsheet", KD);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e_ = [
  ["path", { d: "M21 7h-3a2 2 0 0 1-2-2V2", key: "9rb54x" }],
  [
    "path",
    {
      d: "M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17Z",
      key: "1059l0"
    }
  ],
  ["path", { d: "M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15", key: "16874u" }],
  ["path", { d: "M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11", key: "k2ox98" }]
], t_ = r("FileStack", e_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a_ = [
  ["path", { d: "m10 18 3-3-3-3", key: "18f6ys" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M4 11V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
      key: "50q2rw"
    }
  ]
], n_ = r("FileSymlink", a_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o_ = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 16 2-2-2-2", key: "10vzyd" }],
  ["path", { d: "M12 18h4", key: "1wd2n7" }]
], r_ = r("FileTerminal", o_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i_ = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
], s_ = r("FileText", i_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c_ = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M2 13v-1h6v1", key: "1dh9dg" }],
  ["path", { d: "M5 12v6", key: "150t9c" }],
  ["path", { d: "M4 18h2", key: "1xrofg" }]
], f_ = r("FileType2", c_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d_ = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 13v-1h6v1", key: "1bb014" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M11 18h2", key: "12mj7e" }]
], l_ = r("FileType", d_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u_ = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "m15 15-3-3-3 3", key: "15xj92" }]
], h_ = r("FileUp", u_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p_ = [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M15 18a3 3 0 1 0-6 0", key: "16awa0" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }]
], y_ = r("FileUser", p_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m_ = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "8", height: "6", x: "2", y: "12", rx: "1", key: "1a6c1e" }],
  ["path", { d: "m10 15.5 4 2.5v-6l-4 2.5", key: "t7cp39" }]
], k_ = r("FileVideo2", m_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g_ = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m10 11 5 3-5 3v-6Z", key: "7ntvm4" }]
], v_ = r("FileVideo", g_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M_ = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M11.5 13.5a2.5 2.5 0 0 1 0 3", key: "1fccat" }],
  ["path", { d: "M15 12a5 5 0 0 1 0 6", key: "ps46cm" }]
], w_ = r("FileVolume2", M_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x_ = [
  ["path", { d: "M11 11a5 5 0 0 1 0 6", key: "193qb2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4 6.765V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-.93-.23", key: "ifyjnl" }
  ],
  [
    "path",
    {
      d: "M7 10.51a.5.5 0 0 0-.826-.38l-1.893 1.628A1 1 0 0 1 3.63 12H2.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h1.129a1 1 0 0 1 .652.242l1.893 1.63a.5.5 0 0 0 .826-.38z",
      key: "mk8rxu"
    }
  ]
], C_ = r("FileVolume", x_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b_ = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], L_ = r("FileWarning", b_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j_ = [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 12.5-5 5", key: "b853mi" }],
  ["path", { d: "m3 12.5 5 5", key: "1qls4r" }]
], N_ = r("FileX2", j_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A_ = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14.5 12.5-5 5", key: "b62r18" }],
  ["path", { d: "m9.5 12.5 5 5", key: "1rk7el" }]
], S_ = r("FileX", A_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I_ = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }]
], T_ = r("File", I_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z_ = [
  ["path", { d: "M20 7h-3a2 2 0 0 1-2-2V2", key: "x099mo" }],
  ["path", { d: "M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z", key: "18t6ie" }],
  ["path", { d: "M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8", key: "1nja0z" }]
], D_ = r("Files", z_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  ["path", { d: "M3 7.5h4", key: "zfgn84" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 16.5h4", key: "1230mu" }],
  ["path", { d: "M17 3v18", key: "in4fa5" }],
  ["path", { d: "M17 7.5h4", key: "myr1c1" }],
  ["path", { d: "M17 16.5h4", key: "go4c1d" }]
], P_ = r("Film", __);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E_ = [
  ["path", { d: "M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055", key: "1fi1da" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
], R_ = r("FilterX", E_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H_ = [
  ["polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3", key: "1yg77f" }]
], V_ = r("Filter", H_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O_ = [
  ["path", { d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4", key: "1nerag" }],
  ["path", { d: "M14 13.12c0 2.38 0 6.38-1 8.88", key: "o46ks0" }],
  ["path", { d: "M17.29 21.02c.12-.6.43-2.3.5-3.02", key: "ptglia" }],
  ["path", { d: "M2 12a10 10 0 0 1 18-6", key: "ydlgp0" }],
  ["path", { d: "M2 16h.01", key: "1gqxmh" }],
  ["path", { d: "M21.8 16c.2-2 .131-5.354 0-6", key: "drycrb" }],
  ["path", { d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2", key: "1tidbn" }],
  ["path", { d: "M8.65 22c.21-.66.45-1.32.57-2", key: "13wd9y" }],
  ["path", { d: "M9 6.8a6 6 0 0 1 9 5.2v2", key: "1fr1j5" }]
], q_ = r("Fingerprint", O_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B_ = [
  ["path", { d: "M15 6.5V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3.5", key: "sqyvz" }],
  ["path", { d: "M9 18h8", key: "i7pszb" }],
  ["path", { d: "M18 3h-3", key: "7idoqj" }],
  ["path", { d: "M11 3a6 6 0 0 0-6 6v11", key: "1v5je3" }],
  ["path", { d: "M5 13h4", key: "svpcxo" }],
  ["path", { d: "M17 10a4 4 0 0 0-8 0v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2Z", key: "vsjego" }]
], Z_ = r("FireExtinguisher", B_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F_ = [
  [
    "path",
    {
      d: "M18 12.47v.03m0-.5v.47m-.475 5.056A6.744 6.744 0 0 1 15 18c-3.56 0-7.56-2.53-8.5-6 .348-1.28 1.114-2.433 2.121-3.38m3.444-2.088A8.802 8.802 0 0 1 15 6c3.56 0 6.06 2.54 7 6-.309 1.14-.786 2.177-1.413 3.058",
      key: "1j1hse"
    }
  ],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33m7.48-4.372A9.77 9.77 0 0 1 16 6.07m0 11.86a9.77 9.77 0 0 1-1.728-3.618",
      key: "1q46z8"
    }
  ],
  [
    "path",
    {
      d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98M8.53 3h5.27a2 2 0 0 1 1.98 1.67l.23 1.4M2 2l20 20",
      key: "1407gh"
    }
  ]
], G_ = r("FishOff", F_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $_ = [
  ["path", { d: "M2 16s9-15 20-4C11 23 2 8 2 8", key: "h4oh4o" }]
], U_ = r("FishSymbol", $_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W_ = [
  [
    "path",
    {
      d: "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z",
      key: "15baut"
    }
  ],
  ["path", { d: "M18 12v.5", key: "18hhni" }],
  ["path", { d: "M16 17.93a9.77 9.77 0 0 1 0-11.86", key: "16dt7o" }],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33",
      key: "l9di03"
    }
  ],
  [
    "path",
    { d: "M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4", key: "1kjonw" }
  ],
  [
    "path",
    { d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98", key: "1zlm23" }
  ]
], Y_ = r("Fish", W_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q_ = [
  ["path", { d: "M8 2c3 0 5 2 8 2s4-1 4-1v11", key: "9rwyz9" }],
  ["path", { d: "M4 22V4", key: "1plyxx" }],
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2", key: "1myooe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], J_ = r("FlagOff", Q_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K_ = [["path", { d: "M17 22V2L7 7l10 5", key: "1rmf0r" }]], X_ = r("FlagTriangleLeft", K_);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eP = [["path", { d: "M7 22V2l10 5-10 5", key: "17n18y" }]], tP = r("FlagTriangleRight", eP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aP = [
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z", key: "i9b6wo" }],
  ["line", { x1: "4", x2: "4", y1: "22", y2: "15", key: "1cm3nv" }]
], nP = r("Flag", aP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oP = [
  [
    "path",
    {
      d: "M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z",
      key: "1ir223"
    }
  ],
  ["path", { d: "m5 22 14-4", key: "1brv4h" }],
  ["path", { d: "m5 18 14 4", key: "lgyyje" }]
], rP = r("FlameKindling", oP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iP = [
  [
    "path",
    {
      d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z",
      key: "96xj49"
    }
  ]
], sP = r("Flame", iP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cP = [
  ["path", { d: "M16 16v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4", key: "1r120k" }],
  ["path", { d: "M7 2h11v4c0 2-2 2-2 4v1", key: "dz1920" }],
  ["line", { x1: "11", x2: "18", y1: "6", y2: "6", key: "bi1vpe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], fP = r("FlashlightOff", cP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dP = [
  [
    "path",
    {
      d: "M18 6c0 2-2 2-2 4v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4V2h12z",
      key: "1orkel"
    }
  ],
  ["line", { x1: "6", x2: "18", y1: "6", y2: "6", key: "1z11jq" }],
  ["line", { x1: "12", x2: "12", y1: "12", y2: "12", key: "1f4yc1" }]
], lP = r("Flashlight", dP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uP = [
  ["path", { d: "M10 2v2.343", key: "15t272" }],
  ["path", { d: "M14 2v6.343", key: "sxr80q" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20 20a2 2 0 0 1-2 2H6a2 2 0 0 1-1.755-2.96l5.227-9.563", key: "k0duyd" }],
  ["path", { d: "M6.453 15H15", key: "1f0z33" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }]
], hP = r("FlaskConicalOff", uP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pP = [
  [
    "path",
    {
      d: "M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2",
      key: "18mbvz"
    }
  ],
  ["path", { d: "M6.453 15h11.094", key: "3shlmq" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }]
], yP = r("FlaskConical", pP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mP = [
  ["path", { d: "M10 2v6.292a7 7 0 1 0 4 0V2", key: "1s42pc" }],
  ["path", { d: "M5 15h14", key: "m0yey3" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }]
], kP = r("FlaskRound", mP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gP = [
  ["path", { d: "m3 7 5 5-5 5V7", key: "couhi7" }],
  ["path", { d: "m21 7-5 5 5 5V7", key: "6ouia7" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
], vP = r("FlipHorizontal2", gP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MP = [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3", key: "1i73f7" }],
  ["path", { d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3", key: "saxlbk" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
], wP = r("FlipHorizontal", MP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xP = [
  ["path", { d: "m17 3-5 5-5-5h10", key: "1ftt6x" }],
  ["path", { d: "m17 21-5-5-5 5h10", key: "1m0wmu" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
], CP = r("FlipVertical2", xP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bP = [
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3", key: "14bfxa" }],
  ["path", { d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3", key: "14rx03" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
], LP = r("FlipVertical", bP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jP = [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1",
      key: "3pnvol"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["path", { d: "M12 10v12", key: "6ubwww" }],
  ["path", { d: "M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z", key: "9hd38g" }],
  ["path", { d: "M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z", key: "ufn41s" }]
], NP = r("Flower2", jP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AP = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5",
      key: "14wa3c"
    }
  ],
  ["path", { d: "M12 7.5V9", key: "1oy5b0" }],
  ["path", { d: "M7.5 12H9", key: "eltsq1" }],
  ["path", { d: "M16.5 12H15", key: "vk5kw4" }],
  ["path", { d: "M12 16.5V15", key: "k7eayi" }],
  ["path", { d: "m8 8 1.88 1.88", key: "nxy4qf" }],
  ["path", { d: "M14.12 9.88 16 8", key: "1lst6k" }],
  ["path", { d: "m8 16 1.88-1.88", key: "h2eex1" }],
  ["path", { d: "M14.12 14.12 16 16", key: "uqkrx3" }]
], SP = r("Flower", AP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IP = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
], TP = r("Focus", IP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zP = [
  ["path", { d: "M2 12h6", key: "1wqiqv" }],
  ["path", { d: "M22 12h-6", key: "1eg9hc" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 9-3 3 3 3", key: "12ol22" }],
  ["path", { d: "m5 15 3-3-3-3", key: "1kdhjc" }]
], DP = r("FoldHorizontal", zP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _P = [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3-3-3 3", key: "e37ymu" }],
  ["path", { d: "m15 5-3 3-3-3", key: "19d6lf" }]
], PP = r("FoldVertical", _P);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EP = [
  ["circle", { cx: "15", cy: "19", r: "2", key: "u2pros" }],
  [
    "path",
    {
      d: "M20.9 19.8A2 2 0 0 0 22 18V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h5.1",
      key: "1jj40k"
    }
  ],
  ["path", { d: "M15 11v-1", key: "cntcp" }],
  ["path", { d: "M15 17v-2", key: "1279jj" }]
], RP = r("FolderArchive", EP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HP = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
], VP = r("FolderCheck", HP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OP = [
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  [
    "path",
    {
      d: "M7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2",
      key: "1urifu"
    }
  ],
  ["path", { d: "M16 14v2l1 1", key: "xth2jh" }]
], qP = r("FolderClock", OP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BP = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
], ZP = r("FolderClosed", BP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FP = [
  ["path", { d: "M10 10.5 8 13l2 2.5", key: "m4t9c1" }],
  ["path", { d: "m14 10.5 2 2.5-2 2.5", key: "14w2eb" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z",
      key: "1u1bxd"
    }
  ]
], GP = r("FolderCode", FP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $P = [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  [
    "path",
    {
      d: "M10.3 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.3",
      key: "1k8050"
    }
  ],
  ["path", { d: "m21.7 19.4-.9-.3", key: "1qgwi9" }],
  ["path", { d: "m15.2 16.9-.9-.3", key: "1t7mvx" }],
  ["path", { d: "m16.6 21.7.3-.9", key: "1j67ps" }],
  ["path", { d: "m19.1 15.2.3-.9", key: "18r7jp" }],
  ["path", { d: "m19.6 21.7-.4-1", key: "z2vh2" }],
  ["path", { d: "m16.8 15.3-.4-1", key: "1ei7r6" }],
  ["path", { d: "m14.3 19.6 1-.4", key: "11sv9r" }],
  ["path", { d: "m20.7 16.8 1-.4", key: "19m87a" }]
], UP = r("FolderCog", $P);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WP = [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "1", key: "49l61u" }]
], YP = r("FolderDot", WP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QP = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m15 13-3 3-3-3", key: "6j2sf0" }]
], JP = r("FolderDown", QP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KP = [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v5",
      key: "1w6njk"
    }
  ],
  ["circle", { cx: "13", cy: "12", r: "2", key: "1j92g6" }],
  ["path", { d: "M18 19c-2.8 0-5-2.2-5-5v8", key: "pkpw2h" }],
  ["circle", { cx: "20", cy: "19", r: "2", key: "1obnsp" }]
], XP = r("FolderGit2", KP);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eE = [
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M14 13h3", key: "1dgedf" }],
  ["path", { d: "M7 13h3", key: "1pygq7" }]
], tE = r("FolderGit", eE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aE = [
  [
    "path",
    {
      d: "M11 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1.5",
      key: "6hud8k"
    }
  ],
  [
    "path",
    {
      d: "M13.9 17.45c-1.2-1.2-1.14-2.8-.2-3.73a2.43 2.43 0 0 1 3.44 0l.36.34.34-.34a2.43 2.43 0 0 1 3.45-.01c.95.95 1 2.53-.2 3.74L17.5 21Z",
      key: "wpff58"
    }
  ]
], nE = r("FolderHeart", aE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oE = [
  [
    "path",
    {
      d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1",
      key: "fm4g5t"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m9 16 3-3-3-3", key: "6m91ic" }]
], rE = r("FolderInput", oE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iE = [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["path", { d: "M8 10v4", key: "tgpxqk" }],
  ["path", { d: "M12 10v2", key: "hh53o1" }],
  ["path", { d: "M16 10v6", key: "1d6xys" }]
], sE = r("FolderKanban", iE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cE = [
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2",
      key: "3hgo9p"
    }
  ],
  ["path", { d: "m22 14-4.5 4.5", key: "1ef6z8" }],
  ["path", { d: "m21 15 1 1", key: "1ejcpy" }]
], fE = r("FolderKey", cE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dE = [
  ["rect", { width: "8", height: "5", x: "14", y: "17", rx: "1", key: "19aais" }],
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2.5",
      key: "1w6v7t"
    }
  ],
  ["path", { d: "M20 17v-2a2 2 0 1 0-4 0v2", key: "pwaxnr" }]
], lE = r("FolderLock", dE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uE = [
  ["path", { d: "M9 13h6", key: "1uhe8q" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
], hE = r("FolderMinus", uE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pE = [
  [
    "path",
    {
      d: "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2",
      key: "1nmvlm"
    }
  ],
  ["circle", { cx: "14", cy: "15", r: "1", key: "1gm4qj" }]
], yE = r("FolderOpenDot", pE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mE = [
  [
    "path",
    {
      d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
      key: "usdka0"
    }
  ]
], kE = r("FolderOpen", mE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gE = [
  [
    "path",
    {
      d: "M2 7.5V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-1.5",
      key: "1yk7aj"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m5 10-3 3 3 3", key: "1r8ie0" }]
], vE = r("FolderOutput", gE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ME = [
  [
    "path",
    {
      d: "M2 11.5V5a2 2 0 0 1 2-2h3.9c.7 0 1.3.3 1.7.9l.8 1.2c.4.6 1 .9 1.7.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.5",
      key: "a8xqs0"
    }
  ],
  [
    "path",
    {
      d: "M11.378 13.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1saktj"
    }
  ]
], wE = r("FolderPen", ME);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xE = [
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
], CE = r("FolderPlus", xE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bE = [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  ["path", { d: "M12 15v5", key: "11xva1" }]
], LE = r("FolderRoot", bE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jE = [
  ["circle", { cx: "11.5", cy: "12.5", r: "2.5", key: "1ea5ju" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M13.3 14.3 15 16", key: "1y4v1n" }]
], NE = r("FolderSearch2", jE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AE = [
  [
    "path",
    {
      d: "M10.7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v4.1",
      key: "1bw5m7"
    }
  ],
  ["path", { d: "m21 21-1.9-1.9", key: "1g2n9r" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }]
], SE = r("FolderSearch", AE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IE = [
  [
    "path",
    {
      d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
      key: "x1c07l"
    }
  ],
  ["path", { d: "m8 16 3-3-3-3", key: "rlqrt1" }]
], TE = r("FolderSymlink", IE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zE = [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5",
      key: "1dkoa9"
    }
  ],
  ["path", { d: "M12 10v4h4", key: "1czhmt" }],
  ["path", { d: "m12 14 1.535-1.605a5 5 0 0 1 8 1.5", key: "lvuxfi" }],
  ["path", { d: "M22 22v-4h-4", key: "1ewp4q" }],
  ["path", { d: "m22 18-1.535 1.605a5 5 0 0 1-8-1.5", key: "14ync0" }]
], DE = r("FolderSync", zE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _E = [
  [
    "path",
    {
      d: "M20 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "hod4my"
    }
  ],
  [
    "path",
    {
      d: "M20 21a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.9a1 1 0 0 1-.88-.55l-.42-.85a1 1 0 0 0-.92-.6H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "w4yl2u"
    }
  ],
  ["path", { d: "M3 5a2 2 0 0 0 2 2h3", key: "f2jnh7" }],
  ["path", { d: "M3 3v13a2 2 0 0 0 2 2h3", key: "k8epm1" }]
], PE = r("FolderTree", _E);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EE = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m9 13 3-3 3 3", key: "1pxg3c" }]
], RE = r("FolderUp", EE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HE = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "m9.5 10.5 5 5", key: "ra9qjz" }],
  ["path", { d: "m14.5 10.5-5 5", key: "l2rkpq" }]
], VE = r("FolderX", HE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OE = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
], qE = r("Folder", OE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BE = [
  [
    "path",
    {
      d: "M20 17a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.9a2 2 0 0 1-1.69-.9l-.81-1.2a2 2 0 0 0-1.67-.9H8a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2Z",
      key: "4u7rpt"
    }
  ],
  ["path", { d: "M2 8v11a2 2 0 0 0 2 2h14", key: "1eicx1" }]
], ZE = r("Folders", BE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FE = [
  [
    "path",
    {
      d: "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z",
      key: "1dudjm"
    }
  ],
  [
    "path",
    {
      d: "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z",
      key: "l2t8xc"
    }
  ],
  ["path", { d: "M16 17h4", key: "1dejxt" }],
  ["path", { d: "M4 13h4", key: "1bwh8b" }]
], GE = r("Footprints", FE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $E = [
  ["path", { d: "M12 12H5a2 2 0 0 0-2 2v5", key: "7zsz91" }],
  ["circle", { cx: "13", cy: "19", r: "2", key: "wjnkru" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M8 19h3m5-17v17h6M6 12V7c0-1.1.9-2 2-2h3l5 5", key: "13bk1p" }]
], UE = r("Forklift", $E);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WE = [
  ["polyline", { points: "15 17 20 12 15 7", key: "1w3sku" }],
  ["path", { d: "M4 18v-2a4 4 0 0 1 4-4h12", key: "jmiej9" }]
], YE = r("Forward", WE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QE = [
  ["line", { x1: "22", x2: "2", y1: "6", y2: "6", key: "15w7dq" }],
  ["line", { x1: "22", x2: "2", y1: "18", y2: "18", key: "1ip48p" }],
  ["line", { x1: "6", x2: "6", y1: "2", y2: "22", key: "a2lnyx" }],
  ["line", { x1: "18", x2: "18", y1: "2", y2: "22", key: "8vb6jd" }]
], JE = r("Frame", QE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KE = [
  ["path", { d: "M5 16V9h14V2H5l14 14h-7m-7 0 7 7v-7m-7 0h7", key: "1a2nng" }]
], XE = r("Framer", KE);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eR = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], tR = r("Frown", eR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aR = [
  ["line", { x1: "3", x2: "15", y1: "22", y2: "22", key: "xegly4" }],
  ["line", { x1: "4", x2: "14", y1: "9", y2: "9", key: "xcnuvu" }],
  ["path", { d: "M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18", key: "16j0yd" }],
  [
    "path",
    {
      d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5",
      key: "7cu91f"
    }
  ]
], nR = r("Fuel", aR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oR = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["rect", { width: "10", height: "8", x: "7", y: "8", rx: "1", key: "vys8me" }]
], rR = r("Fullscreen", oR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iR = [
  ["path", { d: "M2 7v10", key: "a2pl2d" }],
  ["path", { d: "M6 5v14", key: "1kq3d7" }],
  ["rect", { width: "12", height: "18", x: "10", y: "3", rx: "2", key: "13i7bc" }]
], sR = r("GalleryHorizontalEnd", iR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cR = [
  ["path", { d: "M2 3v18", key: "pzttux" }],
  ["rect", { width: "12", height: "18", x: "6", y: "3", rx: "2", key: "btr8bg" }],
  ["path", { d: "M22 3v18", key: "6jf3v" }]
], fR = r("GalleryHorizontal", cR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dR = [
  ["rect", { width: "18", height: "14", x: "3", y: "3", rx: "2", key: "74y24f" }],
  ["path", { d: "M4 21h1", key: "16zlid" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M19 21h1", key: "edywat" }]
], lR = r("GalleryThumbnails", dR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uR = [
  ["path", { d: "M7 2h10", key: "nczekb" }],
  ["path", { d: "M5 6h14", key: "u2x4p" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }]
], hR = r("GalleryVerticalEnd", uR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pR = [
  ["path", { d: "M3 2h18", key: "15qxfx" }],
  ["rect", { width: "18", height: "12", x: "3", y: "6", rx: "2", key: "1439r6" }],
  ["path", { d: "M3 22h18", key: "8prr45" }]
], yR = r("GalleryVertical", pR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mR = [
  ["line", { x1: "6", x2: "10", y1: "11", y2: "11", key: "1gktln" }],
  ["line", { x1: "8", x2: "8", y1: "9", y2: "13", key: "qnk9ow" }],
  ["line", { x1: "15", x2: "15.01", y1: "12", y2: "12", key: "krot7o" }],
  ["line", { x1: "18", x2: "18.01", y1: "10", y2: "10", key: "1lcuu1" }],
  [
    "path",
    {
      d: "M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z",
      key: "mfqc10"
    }
  ]
], kR = r("Gamepad2", mR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gR = [
  ["line", { x1: "6", x2: "10", y1: "12", y2: "12", key: "161bw2" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "15", x2: "15.01", y1: "13", y2: "13", key: "dqpgro" }],
  ["line", { x1: "18", x2: "18.01", y1: "11", y2: "11", key: "meh2c" }],
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
], vR = r("Gamepad", gR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MR = [
  ["path", { d: "m12 14 4-4", key: "9kzdfg" }],
  ["path", { d: "M3.34 19a10 10 0 1 1 17.32 0", key: "19p75a" }]
], wR = r("Gauge", MR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xR = [
  ["path", { d: "m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8", key: "15492f" }],
  ["path", { d: "m16 16 6-6", key: "vzrcl6" }],
  ["path", { d: "m8 8 6-6", key: "18bi4p" }],
  ["path", { d: "m9 7 8 8", key: "5jnvq1" }],
  ["path", { d: "m21 11-8-8", key: "z4y7zo" }]
], CR = r("Gavel", xR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bR = [
  ["path", { d: "M6 3h12l4 6-10 13L2 9Z", key: "1pcd5k" }],
  ["path", { d: "M11 3 8 9l4 13 4-13-3-6", key: "1fcu3u" }],
  ["path", { d: "M2 9h20", key: "16fsjt" }]
], LR = r("Gem", bR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jR = [
  ["path", { d: "M9 10h.01", key: "qbtxuw" }],
  ["path", { d: "M15 10h.01", key: "1qmjsl" }],
  [
    "path",
    {
      d: "M12 2a8 8 0 0 0-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 0 0-8-8z",
      key: "uwwb07"
    }
  ]
], NR = r("Ghost", jR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AR = [
  ["rect", { x: "3", y: "8", width: "18", height: "4", rx: "1", key: "bkv52" }],
  ["path", { d: "M12 8v13", key: "1c76mn" }],
  ["path", { d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7", key: "6wjy6b" }],
  [
    "path",
    {
      d: "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5",
      key: "1ihvrl"
    }
  ]
], SR = r("Gift", AR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IR = [
  ["path", { d: "M6 3v12", key: "qpgusn" }],
  ["path", { d: "M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "1d02ji" }],
  ["path", { d: "M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "chk6ph" }],
  ["path", { d: "M15 6a9 9 0 0 0-9 9", key: "or332x" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
], TR = r("GitBranchPlus", IR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zR = [
  ["line", { x1: "6", x2: "6", y1: "3", y2: "15", key: "17qcm7" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M18 9a9 9 0 0 1-9 9", key: "n2h4wq" }]
], DR = r("GitBranch", zR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _R = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["line", { x1: "3", x2: "9", y1: "12", y2: "12", key: "1dyftd" }],
  ["line", { x1: "15", x2: "21", y1: "12", y2: "12", key: "oup4p8" }]
], PR = r("GitCommitHorizontal", _R);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ER = [
  ["path", { d: "M12 3v6", key: "1holv5" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M12 15v6", key: "a9ows0" }]
], RR = r("GitCommitVertical", ER);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HR = [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
  ["path", { d: "M12 18H7a2 2 0 0 1-2-2V9", key: "16sdep" }],
  ["path", { d: "m9 15 3 3-3 3", key: "1m3kbl" }]
], VR = r("GitCompareArrows", HR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OR = [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["path", { d: "M11 18H8a2 2 0 0 1-2-2V9", key: "19pyzm" }]
], qR = r("GitCompare", OR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BR = [
  ["circle", { cx: "12", cy: "18", r: "3", key: "1mpf1b" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["path", { d: "M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9", key: "1uq4wg" }],
  ["path", { d: "M12 12v3", key: "158kv8" }]
], ZR = r("GitFork", BR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FR = [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["circle", { cx: "5", cy: "18", r: "3", key: "104gr9" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  ["path", { d: "M16 15.7A9 9 0 0 0 19 9", key: "1e3vqb" }]
], GR = r("GitGraph", FR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $R = [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 21V9a9 9 0 0 0 9 9", key: "7kw0sc" }]
], UR = r("GitMerge", $R);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WR = [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v12", key: "ih889a" }],
  ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }]
], YR = r("GitPullRequestArrow", WR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QR = [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 9v12", key: "1sc30k" }],
  ["path", { d: "m21 3-6 6", key: "16nqsk" }],
  ["path", { d: "m21 9-6-6", key: "9j17rh" }],
  ["path", { d: "M18 11.5V15", key: "65xf6f" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
], JR = r("GitPullRequestClosed", QR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KR = [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v12", key: "ih889a" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v3", key: "1rbwk6" }],
  ["path", { d: "M19 15v6", key: "10aioa" }],
  ["path", { d: "M22 18h-6", key: "1d5gi5" }]
], XR = r("GitPullRequestCreateArrow", KR);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eH = [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 9v12", key: "1sc30k" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v3", key: "1jb6z3" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
], tH = r("GitPullRequestCreate", eH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aH = [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M18 6V5", key: "1oao2s" }],
  ["path", { d: "M18 11v-1", key: "11c8tz" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
], nH = r("GitPullRequestDraft", aH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oH = [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
], rH = r("GitPullRequest", oH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iH = [
  [
    "path",
    {
      d: "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4",
      key: "tonef"
    }
  ],
  ["path", { d: "M9 18c-4.51 2-5-2-7-2", key: "9comsn" }]
], sH = r("Github", iH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cH = [
  [
    "path",
    {
      d: "m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.1 3.26a.42.42 0 0 0-.1-.18.38.38 0 0 0-.26-.08.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z",
      key: "148pdi"
    }
  ]
], fH = r("Gitlab", cH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dH = [
  [
    "path",
    {
      d: "M5.116 4.104A1 1 0 0 1 6.11 3h11.78a1 1 0 0 1 .994 1.105L17.19 20.21A2 2 0 0 1 15.2 22H8.8a2 2 0 0 1-2-1.79z",
      key: "p55z4y"
    }
  ],
  ["path", { d: "M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0", key: "mjntcy" }]
], lH = r("GlassWater", dH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uH = [
  ["circle", { cx: "6", cy: "15", r: "4", key: "vux9w4" }],
  ["circle", { cx: "18", cy: "15", r: "4", key: "18o8ve" }],
  ["path", { d: "M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2", key: "1ag4bs" }],
  ["path", { d: "M2.5 13 5 7c.7-1.3 1.4-2 3-2", key: "1hm1gs" }],
  ["path", { d: "M21.5 13 19 7c-.7-1.3-1.5-2-3-2", key: "1r31ai" }]
], hH = r("Glasses", uH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pH = [
  [
    "path",
    {
      d: "M15.686 15A14.5 14.5 0 0 1 12 22a14.5 14.5 0 0 1 0-20 10 10 0 1 0 9.542 13",
      key: "qkt0x6"
    }
  ],
  ["path", { d: "M2 12h8.5", key: "ovaggd" }],
  ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
  ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" }]
], yH = r("GlobeLock", pH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mH = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
], kH = r("Globe", mH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gH = [
  ["path", { d: "M12 13V2l8 4-8 4", key: "5wlwwj" }],
  ["path", { d: "M20.561 10.222a9 9 0 1 1-12.55-5.29", key: "1c0wjv" }],
  ["path", { d: "M8.002 9.997a5 5 0 1 0 8.9 2.02", key: "gb1g7m" }]
], vH = r("Goal", gH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MH = [
  ["path", { d: "M18 11.5V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4", key: "edstyy" }],
  ["path", { d: "M14 10V8a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "19wdwo" }],
  ["path", { d: "M10 9.9V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5", key: "1lugqo" }],
  ["path", { d: "M6 14a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1hbeus" }],
  [
    "path",
    { d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0", key: "1etffm" }
  ]
], wH = r("Grab", MH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xH = [
  [
    "path",
    {
      d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z",
      key: "j76jl0"
    }
  ],
  ["path", { d: "M22 10v6", key: "1lu8f3" }],
  ["path", { d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5", key: "1r8lef" }]
], CH = r("GraduationCap", xH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bH = [
  ["path", { d: "M22 5V2l-5.89 5.89", key: "1eenpo" }],
  ["circle", { cx: "16.6", cy: "15.89", r: "3", key: "xjtalx" }],
  ["circle", { cx: "8.11", cy: "7.4", r: "3", key: "u2fv6i" }],
  ["circle", { cx: "12.35", cy: "11.65", r: "3", key: "i6i8g7" }],
  ["circle", { cx: "13.91", cy: "5.85", r: "3", key: "6ye0dv" }],
  ["circle", { cx: "18.15", cy: "10.09", r: "3", key: "snx9no" }],
  ["circle", { cx: "6.56", cy: "13.2", r: "3", key: "17x4xg" }],
  ["circle", { cx: "10.8", cy: "17.44", r: "3", key: "1hogw9" }],
  ["circle", { cx: "5", cy: "19", r: "3", key: "1sn6vo" }]
], LH = r("Grape", bH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jH = [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
], NH = r("Grid2x2Check", jH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AH = [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M19 22v-6", key: "qhmiwi" }]
], SH = r("Grid2x2Plus", AH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IH = [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "m16 16 5 5", key: "8tpb07" }],
  ["path", { d: "m16 21 5-5", key: "193jll" }]
], TH = r("Grid2x2X", IH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zH = [
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
], DH = r("Grid2x2", zH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _H = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
], PH = r("Grid3x3", _H);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EH = [
  ["circle", { cx: "12", cy: "9", r: "1", key: "124mty" }],
  ["circle", { cx: "19", cy: "9", r: "1", key: "1ruzo2" }],
  ["circle", { cx: "5", cy: "9", r: "1", key: "1a8b28" }],
  ["circle", { cx: "12", cy: "15", r: "1", key: "1e56xg" }],
  ["circle", { cx: "19", cy: "15", r: "1", key: "1a92ep" }],
  ["circle", { cx: "5", cy: "15", r: "1", key: "5r1jwy" }]
], RH = r("GripHorizontal", EH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HH = [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
  ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }]
], VH = r("GripVertical", HH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OH = [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "19", cy: "5", r: "1", key: "w8mnmm" }],
  ["circle", { cx: "5", cy: "5", r: "1", key: "lttvr7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }],
  ["circle", { cx: "19", cy: "19", r: "1", key: "shf9b7" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
], qH = r("Grip", OH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BH = [
  ["path", { d: "M3 7V5c0-1.1.9-2 2-2h2", key: "adw53z" }],
  ["path", { d: "M17 3h2c1.1 0 2 .9 2 2v2", key: "an4l38" }],
  ["path", { d: "M21 17v2c0 1.1-.9 2-2 2h-2", key: "144t0e" }],
  ["path", { d: "M7 21H5c-1.1 0-2-.9-2-2v-2", key: "rtnfgi" }],
  ["rect", { width: "7", height: "5", x: "7", y: "7", rx: "1", key: "1eyiv7" }],
  ["rect", { width: "7", height: "5", x: "10", y: "12", rx: "1", key: "1qlmkx" }]
], ZH = r("Group", BH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FH = [
  ["path", { d: "m11.9 12.1 4.514-4.514", key: "109xqo" }],
  [
    "path",
    {
      d: "M20.1 2.3a1 1 0 0 0-1.4 0l-1.114 1.114A2 2 0 0 0 17 4.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 17.828 7h1.344a2 2 0 0 0 1.414-.586L21.7 5.3a1 1 0 0 0 0-1.4z",
      key: "txyc8t"
    }
  ],
  ["path", { d: "m6 16 2 2", key: "16qmzd" }],
  [
    "path",
    {
      d: "M8.2 9.9C8.7 8.8 9.8 8 11 8c2.8 0 5 2.2 5 5 0 1.2-.8 2.3-1.9 2.8l-.9.4A2 2 0 0 0 12 18a4 4 0 0 1-4 4c-3.3 0-6-2.7-6-6a4 4 0 0 1 4-4 2 2 0 0 0 1.8-1.2z",
      key: "1u8q3z"
    }
  ],
  ["circle", { cx: "11.5", cy: "12.5", r: ".5", fill: "currentColor", key: "16onso" }]
], GH = r("Guitar", FH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $H = [
  ["path", { d: "M13.144 21.144A7.274 10.445 45 1 0 2.856 10.856", key: "1k1t7q" }],
  [
    "path",
    {
      d: "M13.144 21.144A7.274 4.365 45 0 0 2.856 10.856a7.274 4.365 45 0 0 10.288 10.288",
      key: "153t1g"
    }
  ],
  [
    "path",
    {
      d: "M16.565 10.435 18.6 8.4a2.501 2.501 0 1 0 1.65-4.65 2.5 2.5 0 1 0-4.66 1.66l-2.024 2.025",
      key: "gzrt0n"
    }
  ],
  ["path", { d: "m8.5 16.5-1-1", key: "otr954" }]
], UH = r("Ham", $H);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WH = [
  ["path", { d: "m15 12-8.373 8.373a1 1 0 1 1-3-3L12 9", key: "eefl8a" }],
  ["path", { d: "m18 15 4-4", key: "16gjal" }],
  [
    "path",
    {
      d: "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172V7l-2.26-2.26a6 6 0 0 0-4.202-1.756L9 2.96l.92.82A6.18 6.18 0 0 1 12 8.4V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5",
      key: "b7pghm"
    }
  ]
], YH = r("Hammer", WH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QH = [
  ["path", { d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17", key: "geh8rc" }],
  [
    "path",
    {
      d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "1fto5m"
    }
  ],
  ["path", { d: "m2 16 6 6", key: "1pfhp9" }],
  ["circle", { cx: "16", cy: "9", r: "2.9", key: "1n0dlu" }],
  ["circle", { cx: "6", cy: "5", r: "3", key: "151irh" }]
], JH = r("HandCoins", QH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KH = [
  ["path", { d: "M11 14h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16", key: "1ifwr1" }],
  [
    "path",
    {
      d: "m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "17abbs"
    }
  ],
  ["path", { d: "m2 15 6 6", key: "10dquu" }],
  [
    "path",
    {
      d: "M19.5 8.5c.7-.7 1.5-1.6 1.5-2.7A2.73 2.73 0 0 0 16 4a2.78 2.78 0 0 0-5 1.8c0 1.2.8 2 1.5 2.8L16 12Z",
      key: "1h3036"
    }
  ]
], XH = r("HandHeart", KH);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eV = [
  ["path", { d: "M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14", key: "1j4xps" }],
  [
    "path",
    {
      d: "m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "uospg8"
    }
  ],
  ["path", { d: "m2 13 6 6", key: "16e5sb" }]
], tV = r("HandHelping", eV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aV = [
  ["path", { d: "M18 12.5V10a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4", key: "wc6myp" }],
  ["path", { d: "M14 11V9a2 2 0 1 0-4 0v2", key: "94qvcw" }],
  ["path", { d: "M10 10.5V5a2 2 0 1 0-4 0v9", key: "m1ah89" }],
  [
    "path",
    {
      d: "m7 15-1.76-1.76a2 2 0 0 0-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v5",
      key: "t1skq1"
    }
  ]
], nV = r("HandMetal", aV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oV = [
  ["path", { d: "M12 3V2", key: "ar7q03" }],
  [
    "path",
    {
      d: "m15.4 17.4 3.2-2.8a2 2 0 1 1 2.8 2.9l-3.6 3.3c-.7.8-1.7 1.2-2.8 1.2h-4c-1.1 0-2.1-.4-2.8-1.2l-1.302-1.464A1 1 0 0 0 6.151 19H5",
      key: "n2g93r"
    }
  ],
  ["path", { d: "M2 14h12a2 2 0 0 1 0 4h-2", key: "1o2jem" }],
  ["path", { d: "M4 10h16", key: "img6z1" }],
  ["path", { d: "M5 10a7 7 0 0 1 14 0", key: "1ega1o" }],
  ["path", { d: "M5 14v6a1 1 0 0 1-1 1H2", key: "1hescx" }]
], rV = r("HandPlatter", oV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iV = [
  ["path", { d: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1fvzgz" }],
  ["path", { d: "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "1kc0my" }],
  ["path", { d: "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8", key: "10h0bg" }],
  [
    "path",
    {
      d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "1s1gnw"
    }
  ]
], sV = r("Hand", iV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cV = [
  ["path", { d: "m11 17 2 2a1 1 0 1 0 3-3", key: "efffak" }],
  [
    "path",
    {
      d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4",
      key: "9pr0kb"
    }
  ],
  ["path", { d: "m21 3 1 11h-2", key: "1tisrp" }],
  ["path", { d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3", key: "1uvwmv" }],
  ["path", { d: "M3 4h8", key: "1ep09j" }]
], fV = r("Handshake", cV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dV = [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
], lV = r("HardDriveDownload", dV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uV = [
  ["path", { d: "m16 6-4-4-4 4", key: "13yo43" }],
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
], hV = r("HardDriveUpload", uV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pV = [
  ["line", { x1: "22", x2: "2", y1: "12", y2: "12", key: "1y58io" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ],
  ["line", { x1: "6", x2: "6.01", y1: "16", y2: "16", key: "sgf278" }],
  ["line", { x1: "10", x2: "10.01", y1: "16", y2: "16", key: "1l4acy" }]
], yV = r("HardDrive", pV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mV = [
  ["path", { d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5", key: "1p9q5i" }],
  ["path", { d: "M14 6a6 6 0 0 1 6 6v3", key: "1hnv84" }],
  ["path", { d: "M4 15v-3a6 6 0 0 1 6-6", key: "9ciidu" }],
  ["rect", { x: "2", y: "15", width: "20", height: "4", rx: "1", key: "g3x8cw" }]
], kV = r("HardHat", mV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gV = [
  ["line", { x1: "4", x2: "20", y1: "9", y2: "9", key: "4lhtct" }],
  ["line", { x1: "4", x2: "20", y1: "15", y2: "15", key: "vyu0kd" }],
  ["line", { x1: "10", x2: "8", y1: "3", y2: "21", key: "1ggp8o" }],
  ["line", { x1: "16", x2: "14", y1: "3", y2: "21", key: "weycgp" }]
], vV = r("Hash", gV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MV = [
  ["path", { d: "m5.2 6.2 1.4 1.4", key: "17imol" }],
  ["path", { d: "M2 13h2", key: "13gyu8" }],
  ["path", { d: "M20 13h2", key: "16rner" }],
  ["path", { d: "m17.4 7.6 1.4-1.4", key: "t4xlah" }],
  ["path", { d: "M22 17H2", key: "1gtaj3" }],
  ["path", { d: "M22 21H2", key: "1gy6en" }],
  ["path", { d: "M16 13a4 4 0 0 0-8 0", key: "1dyczq" }],
  ["path", { d: "M12 5V2.5", key: "1vytko" }]
], wV = r("Haze", MV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xV = [
  [
    "path",
    {
      d: "M22 9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1l2 2h12l2-2h1a1 1 0 0 0 1-1Z",
      key: "2128wb"
    }
  ],
  ["path", { d: "M7.5 12h9", key: "1t0ckc" }]
], CV = r("HdmiPort", xV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bV = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "m17 12 3-2v8", key: "1hhhft" }]
], LV = r("Heading1", bV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jV = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1", key: "9jr5yi" }]
], NV = r("Heading2", jV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AV = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2", key: "68ncm8" }],
  ["path", { d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2", key: "1ejuhz" }]
], SV = r("Heading3", AV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IV = [
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 10v3a1 1 0 0 0 1 1h3", key: "tj5zdr" }],
  ["path", { d: "M21 10v8", key: "1kdml4" }],
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }]
], TV = r("Heading4", IV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zV = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 13v-3h4", key: "1nvgqp" }],
  [
    "path",
    { d: "M17 17.7c.4.2.8.3 1.3.3 1.5 0 2.7-1.1 2.7-2.5S19.8 13 18.3 13H17", key: "2nebdn" }
  ]
], DV = r("Heading5", zV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _V = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["circle", { cx: "19", cy: "16", r: "2", key: "15mx69" }],
  ["path", { d: "M20 10c-2 2-3 3.5-3 6", key: "f35dl0" }]
], PV = r("Heading6", _V);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EV = [
  ["path", { d: "M6 12h12", key: "8npq4p" }],
  ["path", { d: "M6 20V4", key: "1w1bmo" }],
  ["path", { d: "M18 20V4", key: "o2hl4u" }]
], RV = r("Heading", EV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HV = [
  ["path", { d: "M21 14h-1.343", key: "1jdnxi" }],
  ["path", { d: "M9.128 3.47A9 9 0 0 1 21 12v3.343", key: "6kipu2" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20.414 20.414A2 2 0 0 1 19 21h-1a2 2 0 0 1-2-2v-3", key: "9x50f4" }],
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 2.636-6.364",
      key: "1bkxnm"
    }
  ]
], VV = r("HeadphoneOff", HV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OV = [
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3",
      key: "1xhozi"
    }
  ]
], qV = r("Headphones", OV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BV = [
  [
    "path",
    {
      d: "M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z",
      key: "12oyoe"
    }
  ],
  ["path", { d: "M21 16v2a4 4 0 0 1-4 4h-5", key: "1x7m43" }]
], ZV = r("Headset", BV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FV = [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "m12 13-1-1 2-2-3-3 2-2", key: "xjdxli" }]
], GV = r("HeartCrack", FV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $V = [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  [
    "path",
    {
      d: "M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66",
      key: "4oyue0"
    }
  ],
  ["path", { d: "m18 15-2-2", key: "60u0ii" }],
  ["path", { d: "m15 18-2-2", key: "6p76be" }]
], UV = r("HeartHandshake", $V);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WV = [
  ["line", { x1: "2", y1: "2", x2: "22", y2: "22", key: "1w4vcy" }],
  [
    "path",
    { d: "M16.5 16.5 12 21l-7-7c-1.5-1.45-3-3.2-3-5.5a5.5 5.5 0 0 1 2.14-4.35", key: "3mpagl" }
  ],
  [
    "path",
    {
      d: "M8.76 3.1c1.15.22 2.13.78 3.24 1.9 1.5-1.5 2.74-2 4.5-2A5.5 5.5 0 0 1 22 8.5c0 2.12-1.3 3.78-2.67 5.17",
      key: "1gh3v3"
    }
  ]
], YV = r("HeartOff", WV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QV = [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27", key: "1uw2ng" }]
], JV = r("HeartPulse", QV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KV = [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ]
], XV = r("Heart", KV);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eO = [
  ["path", { d: "M11 8c2-3-2-3 0-6", key: "1ldv5m" }],
  ["path", { d: "M15.5 8c2-3-2-3 0-6", key: "1otqoz" }],
  ["path", { d: "M6 10h.01", key: "1lbq93" }],
  ["path", { d: "M6 14h.01", key: "zudwn7" }],
  ["path", { d: "M10 16v-4", key: "1c25yv" }],
  ["path", { d: "M14 16v-4", key: "1dkbt8" }],
  ["path", { d: "M18 16v-4", key: "1yg9me" }],
  [
    "path",
    { d: "M20 6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3", key: "1ubg90" }
  ],
  ["path", { d: "M5 20v2", key: "1abpe8" }],
  ["path", { d: "M19 20v2", key: "kqn6ft" }]
], tO = r("Heater", eO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aO = [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ]
], nO = r("Hexagon", aO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oO = [
  ["path", { d: "m9 11-6 6v3h9l3-3", key: "1a3l36" }],
  ["path", { d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4", key: "14a9rk" }]
], rO = r("Highlighter", oO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iO = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
], sO = r("History", iO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cO = [
  ["path", { d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.28.01.53-.09.7-.27", key: "qyzcap" }],
  [
    "path",
    {
      d: "M11.14 20.57c.52.24 2.44 1.12 4.08 1.37.46.06.86-.25.9-.71.12-1.52-.3-3.43-.5-4.28",
      key: "y078lb"
    }
  ],
  ["path", { d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .7-.26", key: "1utre3" }],
  [
    "path",
    {
      d: "M17.99 5.52a20.83 20.83 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-1.17.1-2.5.02-3.9-.25",
      key: "17o9hm"
    }
  ],
  ["path", { d: "M20.57 11.14c.24.52 1.12 2.44 1.37 4.08.04.3-.08.59-.31.75", key: "1d1n4p" }],
  [
    "path",
    {
      d: "M4.93 4.93a10 10 0 0 0-.67 13.4c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.85.85 0 0 0 .48-.24",
      key: "9uv3tt"
    }
  ],
  [
    "path",
    {
      d: "M5.52 17.99c1.05.95 2.91 2.42 4.5 3.15a.8.8 0 0 0 1.13-.68c.2-2.34-.33-5.3-1.57-8.28",
      key: "1292wz"
    }
  ],
  [
    "path",
    {
      d: "M8.35 2.68a10 10 0 0 1 9.98 1.58c.43.35.4.96-.12 1.17-1.5.6-4.3.98-6.07 1.05",
      key: "7ozu9p"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], fO = r("HopOff", cO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dO = [
  [
    "path",
    {
      d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.55.03 1-.42.97-.97-.06-1.27-.26-3.5-.85-5.18",
      key: "18lxf1"
    }
  ],
  [
    "path",
    {
      d: "M11.5 6.5c1.64 0 5-.38 6.71-1.07.52-.2.55-.82.12-1.17A10 10 0 0 0 4.26 18.33c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.88.88 0 0 0 .73-.74c.3-2.14-.15-3.5-.61-4.88",
      key: "vtfxrw"
    }
  ],
  [
    "path",
    {
      d: "M15.62 16.95c.2.85.62 2.76.5 4.28a.77.77 0 0 1-.9.7 16.64 16.64 0 0 1-4.08-1.36",
      key: "13hl71"
    }
  ],
  [
    "path",
    {
      d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .96-.96 17.68 17.68 0 0 0-.9-4.87",
      key: "1sl8oj"
    }
  ],
  [
    "path",
    {
      d: "M16.94 15.62c.86.2 2.77.62 4.29.5a.77.77 0 0 0 .7-.9 16.64 16.64 0 0 0-1.36-4.08",
      key: "19c6kt"
    }
  ],
  [
    "path",
    {
      d: "M17.99 5.52a20.82 20.82 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-2.33.2-5.3-.32-8.27-1.57",
      key: "85ghs3"
    }
  ],
  ["path", { d: "M4.93 4.93 3 3a.7.7 0 0 1 0-1", key: "x087yj" }],
  [
    "path",
    {
      d: "M9.58 12.18c1.24 2.98 1.77 5.95 1.57 8.28a.8.8 0 0 1-1.13.68 20.82 20.82 0 0 1-4.5-3.15",
      key: "11xdqo"
    }
  ]
], lO = r("Hop", dO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uO = [
  ["path", { d: "M12 6v4", key: "16clxf" }],
  ["path", { d: "M14 14h-4", key: "esezmu" }],
  ["path", { d: "M14 18h-4", key: "16mqa2" }],
  ["path", { d: "M14 8h-4", key: "z8ypaz" }],
  [
    "path",
    {
      d: "M18 12h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2",
      key: "b1k337"
    }
  ],
  ["path", { d: "M18 22V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v18", key: "16g51d" }]
], hO = r("Hospital", uO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pO = [
  ["path", { d: "M10 22v-6.57", key: "1wmca3" }],
  ["path", { d: "M12 11h.01", key: "z322tv" }],
  ["path", { d: "M12 7h.01", key: "1ivr5q" }],
  ["path", { d: "M14 15.43V22", key: "1q2vjd" }],
  ["path", { d: "M15 16a5 5 0 0 0-6 0", key: "o9wqvi" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }],
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 7h.01", key: "1vti4s" }],
  ["rect", { x: "4", y: "2", width: "16", height: "20", rx: "2", key: "1uxh74" }]
], yO = r("Hotel", pO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mO = [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  ["path", { d: "M5 2h14", key: "pdyrp9" }],
  [
    "path",
    {
      d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22",
      key: "1d314k"
    }
  ],
  [
    "path",
    { d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2", key: "1vvvr6" }
  ]
], kO = r("Hourglass", mO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gO = [
  ["path", { d: "M10 12V8.964", key: "1vll13" }],
  ["path", { d: "M14 12V8.964", key: "1x3qvg" }],
  [
    "path",
    { d: "M15 12a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1z", key: "ppykja" }
  ],
  [
    "path",
    {
      d: "M8.5 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-2",
      key: "1gvg2z"
    }
  ]
], vO = r("HousePlug", gO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MO = [
  [
    "path",
    {
      d: "M13.22 2.416a2 2 0 0 0-2.511.057l-7 5.999A2 2 0 0 0 3 10v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7.354",
      key: "5phn05"
    }
  ],
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "M18 3v6", key: "x1uolp" }]
], wO = r("HousePlus", MO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xO = [
  ["path", { d: "M9.5 13.866a4 4 0 0 1 5 .01", key: "1wy54i" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "1d0kgt"
    }
  ],
  ["path", { d: "M7 10.754a8 8 0 0 1 10 0", key: "exoy2g" }]
], CO = r("HouseWifi", xO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bO = [
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "1d0kgt"
    }
  ]
], LO = r("House", bO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jO = [
  [
    "path",
    {
      d: "M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6m-4 4h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0",
      key: "1uxfcu"
    }
  ],
  ["path", { d: "M12.14 11a3.5 3.5 0 1 1 6.71 0", key: "4k3m1s" }],
  ["path", { d: "M15.5 6.5a3.5 3.5 0 1 0-7 0", key: "zmuahr" }]
], NO = r("IceCreamBowl", jO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AO = [
  ["path", { d: "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11", key: "1v6356" }],
  ["path", { d: "M17 7A5 5 0 0 0 7 7", key: "151p3v" }],
  ["path", { d: "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4", key: "1sdaij" }]
], SO = r("IceCreamCone", AO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IO = [
  ["path", { d: "M16 10h2", key: "8sgtl7" }],
  ["path", { d: "M16 14h2", key: "epxaof" }],
  ["path", { d: "M6.17 15a3 3 0 0 1 5.66 0", key: "n6f512" }],
  ["circle", { cx: "9", cy: "11", r: "2", key: "yxgjnd" }],
  ["rect", { x: "2", y: "5", width: "20", height: "14", rx: "2", key: "qneu4z" }]
], TO = r("IdCard", IO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zO = [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19 3 3v-5.5", key: "9ldu5r" }],
  ["path", { d: "m17 22 3-3", key: "1nkfve" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
], DO = r("ImageDown", zO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _O = [
  ["path", { d: "M21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7", key: "m87ecr" }],
  ["line", { x1: "16", x2: "22", y1: "5", y2: "5", key: "ez7e4s" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
], PO = r("ImageMinus", _O);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EO = [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83", key: "1bzlo9" }],
  ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21", key: "1q0aeu" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "15", key: "5mozeu" }],
  [
    "path",
    {
      d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
      key: "mmje98"
    }
  ],
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }]
], RO = r("ImageOff", EO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HO = [
  ["path", { d: "m11 16-5 5", key: "j5f7ct" }],
  ["path", { d: "M11 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6.5", key: "7s81lt" }],
  [
    "path",
    {
      d: "M15.765 22a.5.5 0 0 1-.765-.424V13.38a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z",
      key: "1omb6s"
    }
  ],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
], VO = r("ImagePlay", HO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OO = [
  ["path", { d: "M16 5h6", key: "1vod17" }],
  ["path", { d: "M19 2v6", key: "4bpg5p" }],
  ["path", { d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5", key: "1ue2ih" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
], qO = r("ImagePlus", OO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BO = [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19.5 3-3 3 3", key: "9vmjn0" }],
  ["path", { d: "M17 22v-5.5", key: "1aa6fl" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
], ZO = r("ImageUp", BO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FO = [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M17 21h2a2 2 0 0 0 2-2", key: "130fy9" }],
  ["path", { d: "M21 12v3", key: "1wzk3p" }],
  ["path", { d: "m21 3-5 5", key: "1g5oa7" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2", key: "kk3yz1" }],
  ["path", { d: "m5 21 4.144-4.144a1.21 1.21 0 0 1 1.712 0L13 19", key: "fyekpt" }],
  ["path", { d: "M9 3h3", key: "d52fa" }],
  ["rect", { x: "3", y: "11", width: "10", height: "10", rx: "1", key: "1wpmix" }]
], GO = r("ImageUpscale", FO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $O = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
], UO = r("Image", $O);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WO = [
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
  ["path", { d: "m22 13-1.296-1.296a2.41 2.41 0 0 0-3.408 0L11 18", key: "nf6bnh" }],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["rect", { width: "16", height: "16", x: "6", y: "2", rx: "2", key: "12espp" }]
], YO = r("Images", WO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QO = [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m8 11 4 4 4-4", key: "1dohi6" }],
  [
    "path",
    {
      d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4",
      key: "1ywtjm"
    }
  ]
], JO = r("Import", QO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KO = [
  ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ]
], XO = r("Inbox", KO);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eq = [
  ["path", { d: "M21 12H11", key: "wd7e0v" }],
  ["path", { d: "M21 18H11", key: "4wu86t" }],
  ["path", { d: "M21 6H11", key: "6dy1d6" }],
  ["path", { d: "m7 8-4 4 4 4", key: "o5hrat" }]
], tq = r("IndentDecrease", eq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aq = [
  ["path", { d: "M21 12H11", key: "wd7e0v" }],
  ["path", { d: "M21 18H11", key: "4wu86t" }],
  ["path", { d: "M21 6H11", key: "6dy1d6" }],
  ["path", { d: "m3 8 4 4-4 4", key: "1a3j6y" }]
], nq = r("IndentIncrease", aq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oq = [
  ["path", { d: "M6 3h12", key: "ggurg9" }],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "m6 13 8.5 8", key: "u1kupk" }],
  ["path", { d: "M6 13h3", key: "wdp6ag" }],
  ["path", { d: "M9 13c6.667 0 6.667-10 0-10", key: "1nkvk2" }]
], rq = r("IndianRupee", oq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iq = [
  [
    "path",
    {
      d: "M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z",
      key: "1z0uae"
    }
  ]
], sq = r("Infinity", iq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cq = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], fq = r("Info", cq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dq = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7h.01", key: "7u93v4" }],
  ["path", { d: "M17 7h.01", key: "14a9sn" }],
  ["path", { d: "M7 17h.01", key: "19xn7k" }],
  ["path", { d: "M17 17h.01", key: "1sd3ek" }]
], lq = r("InspectionPanel", dq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uq = [
  ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "5", ry: "5", key: "2e1cvw" }],
  ["path", { d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z", key: "9exkf1" }],
  ["line", { x1: "17.5", x2: "17.51", y1: "6.5", y2: "6.5", key: "r4j83e" }]
], hq = r("Instagram", uq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pq = [
  ["line", { x1: "19", x2: "10", y1: "4", y2: "4", key: "15jd3p" }],
  ["line", { x1: "14", x2: "5", y1: "20", y2: "20", key: "bu0au3" }],
  ["line", { x1: "15", x2: "9", y1: "4", y2: "20", key: "uljnxc" }]
], yq = r("Italic", pq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mq = [
  ["path", { d: "M20 10c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8h8", key: "4znkd0" }],
  ["polyline", { points: "16 14 20 18 16 22", key: "11njsm" }]
], kq = r("IterationCcw", mq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gq = [
  ["path", { d: "M4 10c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8H4", key: "tuf4su" }],
  ["polyline", { points: "8 22 4 18 8 14", key: "evkj9s" }]
], vq = r("IterationCw", gq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mq = [
  ["path", { d: "M12 9.5V21m0-11.5L6 3m6 6.5L18 3", key: "2ej80x" }],
  ["path", { d: "M6 15h12", key: "1hwgt5" }],
  ["path", { d: "M6 11h12", key: "wf4gp6" }]
], wq = r("JapaneseYen", Mq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xq = [
  [
    "path",
    {
      d: "M21 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2Z",
      key: "jg2n2t"
    }
  ],
  ["path", { d: "M6 15v-2", key: "gd6mvg" }],
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["circle", { cx: "12", cy: "6", r: "3", key: "1gm2ql" }]
], Cq = r("Joystick", xq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bq = [
  ["path", { d: "M6 5v11", key: "mdvv1e" }],
  ["path", { d: "M12 5v6", key: "14ar3b" }],
  ["path", { d: "M18 5v14", key: "7ji314" }]
], Lq = r("Kanban", bq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jq = [
  [
    "path",
    {
      d: "M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z",
      key: "1s6t7t"
    }
  ],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" }]
], Nq = r("KeyRound", jq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aq = [
  [
    "path",
    {
      d: "M12.4 2.7a2.5 2.5 0 0 1 3.4 0l5.5 5.5a2.5 2.5 0 0 1 0 3.4l-3.7 3.7a2.5 2.5 0 0 1-3.4 0L8.7 9.8a2.5 2.5 0 0 1 0-3.4z",
      key: "165ttr"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  [
    "path",
    {
      d: "m9.4 10.6-6.814 6.814A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814",
      key: "1ubxi2"
    }
  ]
], Sq = r("KeySquare", Aq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iq = [
  ["path", { d: "m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4", key: "g0fldk" }],
  ["path", { d: "m21 2-9.6 9.6", key: "1j0ho8" }],
  ["circle", { cx: "7.5", cy: "15.5", r: "5.5", key: "yqb3hr" }]
], Tq = r("Key", Iq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zq = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 8h4", key: "utf9t1" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M6 12v4", key: "dy92yo" }],
  ["path", { d: "M10 12v4", key: "1fxnav" }],
  ["path", { d: "M14 12v4", key: "1hft58" }],
  ["path", { d: "M18 12v4", key: "tjjnbz" }]
], Dq = r("KeyboardMusic", zq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _q = [
  ["path", { d: "M 20 4 A2 2 0 0 1 22 6", key: "1g1fkt" }],
  ["path", { d: "M 22 6 L 22 16.41", key: "1qjg3w" }],
  ["path", { d: "M 7 16 L 16 16", key: "n0yqwb" }],
  ["path", { d: "M 9.69 4 L 20 4", key: "kbpcgx" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2", key: "s23sx2" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }]
], Pq = r("KeyboardOff", _q);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eq = [
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M7 16h10", key: "wp8him" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }]
], Rq = r("Keyboard", Eq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hq = [
  ["path", { d: "M12 2v5", key: "nd4vlx" }],
  ["path", { d: "M6 7h12l4 9H2l4-9Z", key: "123d64" }],
  ["path", { d: "M9.17 16a3 3 0 1 0 5.66 0", key: "1061mw" }]
], Vq = r("LampCeiling", Hq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oq = [
  ["path", { d: "m14 5-3 3 2 7 8-8-7-2Z", key: "1b0msb" }],
  ["path", { d: "m14 5-3 3-3-3 3-3 3 3Z", key: "1uemms" }],
  ["path", { d: "M9.5 6.5 4 12l3 6", key: "1bx08v" }],
  ["path", { d: "M3 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H3Z", key: "wap775" }]
], qq = r("LampDesk", Oq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bq = [
  ["path", { d: "M9 2h6l3 7H6l3-7Z", key: "wcx6mj" }],
  ["path", { d: "M12 9v13", key: "3n1su1" }],
  ["path", { d: "M9 22h6", key: "1rlq3v" }]
], Zq = r("LampFloor", Bq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fq = [
  ["path", { d: "M11 13h6l3 7H8l3-7Z", key: "9n3qlo" }],
  ["path", { d: "M14 13V8a2 2 0 0 0-2-2H8", key: "1hu4hb" }],
  ["path", { d: "M4 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4v6Z", key: "s053bc" }]
], Gq = r("LampWallDown", Fq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $q = [
  ["path", { d: "M11 4h6l3 7H8l3-7Z", key: "11x1ee" }],
  ["path", { d: "M14 11v5a2 2 0 0 1-2 2H8", key: "eutp5o" }],
  ["path", { d: "M4 15h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4v-6Z", key: "1iuthr" }]
], Uq = r("LampWallUp", $q);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wq = [
  ["path", { d: "M8 2h8l4 10H4L8 2Z", key: "9dma5w" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M8 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H8Z", key: "mwf4oh" }]
], Yq = r("Lamp", Wq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qq = [
  ["path", { d: "m12 8 6-3-6-3v10", key: "mvpnpy" }],
  [
    "path",
    {
      d: "m8 11.99-5.5 3.14a1 1 0 0 0 0 1.74l8.5 4.86a2 2 0 0 0 2 0l8.5-4.86a1 1 0 0 0 0-1.74L16 12",
      key: "ek95tt"
    }
  ],
  ["path", { d: "m6.49 12.85 11.02 6.3", key: "1kt42w" }],
  ["path", { d: "M17.51 12.85 6.5 19.15", key: "v55bdg" }]
], Jq = r("LandPlot", Qq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kq = [
  ["line", { x1: "3", x2: "21", y1: "22", y2: "22", key: "j8o0r" }],
  ["line", { x1: "6", x2: "6", y1: "18", y2: "11", key: "10tf0k" }],
  ["line", { x1: "10", x2: "10", y1: "18", y2: "11", key: "54lgf6" }],
  ["line", { x1: "14", x2: "14", y1: "18", y2: "11", key: "380y" }],
  ["line", { x1: "18", x2: "18", y1: "18", y2: "11", key: "1kevvc" }],
  ["polygon", { points: "12 2 20 7 4 7", key: "jkujk7" }]
], Xq = r("Landmark", Kq);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eB = [
  ["path", { d: "m5 8 6 6", key: "1wu5hv" }],
  ["path", { d: "m4 14 6-6 2-3", key: "1k1g8d" }],
  ["path", { d: "M2 5h12", key: "or177f" }],
  ["path", { d: "M7 2h1", key: "1t2jsx" }],
  ["path", { d: "m22 22-5-10-5 10", key: "don7ne" }],
  ["path", { d: "M14 18h6", key: "1m8k6r" }]
], tB = r("Languages", eB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aB = [
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }],
  ["rect", { x: "3", y: "4", width: "18", height: "12", rx: "2", key: "8ur36m" }]
], nB = r("LaptopMinimalCheck", aB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oB = [
  ["rect", { width: "18", height: "12", x: "3", y: "4", rx: "2", ry: "2", key: "1qhy41" }],
  ["line", { x1: "2", x2: "22", y1: "20", y2: "20", key: "ni3hll" }]
], rB = r("LaptopMinimal", oB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iB = [
  [
    "path",
    {
      d: "M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16",
      key: "tarvll"
    }
  ]
], sB = r("Laptop", iB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cB = [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  ["path", { d: "M7 16.93c.96.43 1.96.74 2.99.91", key: "ybbtv3" }],
  [
    "path",
    {
      d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2",
      key: "gt5e1w"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }],
  [
    "path",
    {
      d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14z",
      key: "72q637"
    }
  ]
], fB = r("LassoSelect", cB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dB = [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  [
    "path",
    {
      d: "M3.3 14A6.8 6.8 0 0 1 2 10c0-4.4 4.5-8 10-8s10 3.6 10 8-4.5 8-10 8a12 12 0 0 1-5-1",
      key: "146dds"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }]
], lB = r("Lasso", dB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uB = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M18 13a6 6 0 0 1-6 5 6 6 0 0 1-6-5h12Z", key: "b2q4dd" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], hB = r("Laugh", uB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pB = [
  [
    "path",
    {
      d: "m16.02 12 5.48 3.13a1 1 0 0 1 0 1.74L13 21.74a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74L7.98 12",
      key: "1cuww1"
    }
  ],
  [
    "path",
    {
      d: "M13 13.74a2 2 0 0 1-2 0L2.5 8.87a1 1 0 0 1 0-1.74L11 2.26a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74Z",
      key: "pdlvxu"
    }
  ]
], yB = r("Layers2", pB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mB = [
  [
    "path",
    {
      d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
      key: "zw3jo"
    }
  ],
  [
    "path",
    {
      d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
      key: "1wduqc"
    }
  ],
  [
    "path",
    {
      d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
      key: "kqbvx6"
    }
  ]
], kB = r("Layers", mB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gB = [
  ["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1", key: "10lvy0" }],
  ["rect", { width: "7", height: "5", x: "14", y: "3", rx: "1", key: "16une8" }],
  ["rect", { width: "7", height: "9", x: "14", y: "12", rx: "1", key: "1hutg5" }],
  ["rect", { width: "7", height: "5", x: "3", y: "16", rx: "1", key: "ldoo1y" }]
], vB = r("LayoutDashboard", gB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MB = [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }]
], wB = r("LayoutGrid", MB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xB = [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["path", { d: "M14 4h7", key: "3xa0d5" }],
  ["path", { d: "M14 9h7", key: "1icrd9" }],
  ["path", { d: "M14 15h7", key: "1mj8o2" }],
  ["path", { d: "M14 20h7", key: "11slyb" }]
], CB = r("LayoutList", xB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bB = [
  ["rect", { width: "7", height: "18", x: "3", y: "3", rx: "1", key: "2obqm" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
], LB = r("LayoutPanelLeft", bB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jB = [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
], NB = r("LayoutPanelTop", jB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AB = [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "9", height: "7", x: "3", y: "14", rx: "1", key: "jqznyg" }],
  ["rect", { width: "5", height: "7", x: "16", y: "14", rx: "1", key: "q5h2i8" }]
], SB = r("LayoutTemplate", AB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IB = [
  [
    "path",
    {
      d: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z",
      key: "nnexq3"
    }
  ],
  ["path", { d: "M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12", key: "mt58a7" }]
], TB = r("Leaf", IB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zB = [
  [
    "path",
    {
      d: "M2 22c1.25-.987 2.27-1.975 3.9-2.2a5.56 5.56 0 0 1 3.8 1.5 4 4 0 0 0 6.187-2.353 3.5 3.5 0 0 0 3.69-5.116A3.5 3.5 0 0 0 20.95 8 3.5 3.5 0 1 0 16 3.05a3.5 3.5 0 0 0-5.831 1.373 3.5 3.5 0 0 0-5.116 3.69 4 4 0 0 0-2.348 6.155C3.499 15.42 4.409 16.712 4.2 18.1 3.926 19.743 3.014 20.732 2 22",
      key: "1134nt"
    }
  ],
  ["path", { d: "M2 22 17 7", key: "1q7jp2" }]
], DB = r("LeafyGreen", zB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _B = [
  [
    "path",
    {
      d: "M16 12h3a2 2 0 0 0 1.902-1.38l1.056-3.333A1 1 0 0 0 21 6H3a1 1 0 0 0-.958 1.287l1.056 3.334A2 2 0 0 0 5 12h3",
      key: "13jjxg"
    }
  ],
  ["path", { d: "M18 6V3a1 1 0 0 0-1-1h-3", key: "1550fe" }],
  ["rect", { width: "8", height: "12", x: "8", y: "10", rx: "1", key: "qmu8b6" }]
], PB = r("Lectern", _B);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EB = [
  ["path", { d: "M15 12h6", key: "upa0zy" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "m3 13 3.553-7.724a.5.5 0 0 1 .894 0L11 13", key: "blevx4" }],
  ["path", { d: "M3 18h18", key: "1h113x" }],
  ["path", { d: "M4 11h6", key: "olkgv1" }]
], RB = r("LetterText", EB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HB = [
  ["rect", { width: "8", height: "18", x: "3", y: "3", rx: "1", key: "oynpb5" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  [
    "path",
    {
      d: "M20.4 18.9c.2.5-.1 1.1-.6 1.3l-1.9.7c-.5.2-1.1-.1-1.3-.6L11.1 5.1c-.2-.5.1-1.1.6-1.3l1.9-.7c.5-.2 1.1.1 1.3.6Z",
      key: "1qboyk"
    }
  ]
], VB = r("LibraryBig", HB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OB = [
  ["path", { d: "m16 6 4 14", key: "ji33uf" }],
  ["path", { d: "M12 6v14", key: "1n7gus" }],
  ["path", { d: "M8 8v12", key: "1gg7y9" }],
  ["path", { d: "M4 4v16", key: "6qkkli" }]
], qB = r("Library", OB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BB = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.93 4.93 4.24 4.24", key: "1ymg45" }],
  ["path", { d: "m14.83 9.17 4.24-4.24", key: "1cb5xl" }],
  ["path", { d: "m14.83 14.83 4.24 4.24", key: "q42g0n" }],
  ["path", { d: "m9.17 14.83-4.24 4.24", key: "bqpfvv" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
], ZB = r("LifeBuoy", BB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FB = [
  ["path", { d: "M8 20V8c0-2.2 1.8-4 4-4 1.5 0 2.8.8 3.5 2", key: "1rtphz" }],
  ["path", { d: "M6 12h4", key: "a4o3ry" }],
  ["path", { d: "M14 12h2v8", key: "c1fccl" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 20h4", key: "lzx1xo" }]
], GB = r("Ligature", FB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $B = [
  ["path", { d: "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5", key: "1fkcox" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5", key: "10m8kw" }],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
], UB = r("LightbulbOff", $B);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WB = [
  [
    "path",
    {
      d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
      key: "1gvzjb"
    }
  ],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
], YB = r("Lightbulb", WB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QB = [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7", key: "10o201" }],
  ["path", { d: "M15 7h2a5 5 0 0 1 4 8", key: "1d3206" }],
  ["line", { x1: "8", x2: "12", y1: "12", y2: "12", key: "rvw6j4" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], JB = r("Link2Off", QB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KB = [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
], XB = r("Link2", KB);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eZ = [
  ["path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", key: "1cjeqo" }],
  ["path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71", key: "19qd67" }]
], tZ = r("Link", eZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aZ = [
  [
    "path",
    {
      d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z",
      key: "c2jq9f"
    }
  ],
  ["rect", { width: "4", height: "12", x: "2", y: "9", key: "mk3on5" }],
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }]
], nZ = r("Linkedin", aZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oZ = [
  ["path", { d: "M11 18H3", key: "n3j2dh" }],
  ["path", { d: "m15 18 2 2 4-4", key: "1szwhi" }],
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }]
], rZ = r("ListCheck", oZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iZ = [
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "m3 7 2 2 4-4", key: "1obspn" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
], sZ = r("ListChecks", iZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cZ = [
  ["path", { d: "m3 10 2.5-2.5L3 5", key: "i6eama" }],
  ["path", { d: "m3 19 2.5-2.5L3 14", key: "w2gmor" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }]
], fZ = r("ListCollapse", cZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dZ = [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["path", { d: "M21 6v10a2 2 0 0 1-2 2h-5", key: "ilrcs8" }],
  ["path", { d: "m16 16-2 2 2 2", key: "kkc6pm" }]
], lZ = r("ListEnd", dZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uZ = [
  ["path", { d: "M10 18h4", key: "1ulq68" }],
  ["path", { d: "M11 6H3", key: "1u26ik" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "M18 9V3", key: "xwwp7m" }],
  ["path", { d: "M7 12h8", key: "7a1bxv" }]
], hZ = r("ListFilterPlus", uZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pZ = [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
], yZ = r("ListFilter", pZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mZ = [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
], kZ = r("ListMinus", mZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gZ = [
  ["path", { d: "M21 15V6", key: "h1cx4g" }],
  ["path", { d: "M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", key: "8saifv" }],
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }]
], vZ = r("ListMusic", gZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MZ = [
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M4 10h2", key: "16xx2s" }],
  ["path", { d: "M4 6h1v4", key: "cnovpq" }],
  ["path", { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1", key: "m9a95d" }]
], wZ = r("ListOrdered", MZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xZ = [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M18 9v6", key: "1twb98" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
], CZ = r("ListPlus", xZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bZ = [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M7 12H3", key: "13ou7f" }],
  ["path", { d: "M7 18H3", key: "1sijw9" }],
  [
    "path",
    {
      d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14",
      key: "qth677"
    }
  ],
  ["path", { d: "M11 10v4h4", key: "172dkj" }]
], LZ = r("ListRestart", bZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jZ = [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M10 6H3", key: "lf8lx7" }],
  ["path", { d: "M21 18V8a2 2 0 0 0-2-2h-5", key: "1hghli" }],
  ["path", { d: "m16 8-2-2 2-2", key: "160uvd" }]
], NZ = r("ListStart", jZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AZ = [
  ["rect", { x: "3", y: "5", width: "6", height: "6", rx: "1", key: "1defrl" }],
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
], SZ = r("ListTodo", AZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IZ = [
  ["path", { d: "M21 12h-8", key: "1bmf0i" }],
  ["path", { d: "M21 6H8", key: "1pqkrb" }],
  ["path", { d: "M21 18h-8", key: "1tm79t" }],
  ["path", { d: "M3 6v4c0 1.1.9 2 2 2h3", key: "1ywdgy" }],
  ["path", { d: "M3 10v6c0 1.1.9 2 2 2h3", key: "2wc746" }]
], TZ = r("ListTree", IZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zZ = [
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }],
  ["path", { d: "m16 12 5 3-5 3v-6Z", key: "zpskkp" }]
], DZ = r("ListVideo", zZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Z = [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "m19 10-4 4", key: "1tz659" }],
  ["path", { d: "m15 10 4 4", key: "1n7nei" }]
], PZ = r("ListX", _Z);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EZ = [
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M3 18h.01", key: "1tta3j" }],
  ["path", { d: "M3 6h.01", key: "1rqtza" }],
  ["path", { d: "M8 12h13", key: "1za7za" }],
  ["path", { d: "M8 18h13", key: "1lx6n3" }],
  ["path", { d: "M8 6h13", key: "ik3vkj" }]
], RZ = r("List", EZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HZ = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], VZ = r("LoaderCircle", HZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OZ = [
  ["path", { d: "M22 12a1 1 0 0 1-10 0 1 1 0 0 0-10 0", key: "1lzz15" }],
  ["path", { d: "M7 20.7a1 1 0 1 1 5-8.7 1 1 0 1 0 5-8.6", key: "1gnrpi" }],
  ["path", { d: "M7 3.3a1 1 0 1 1 5 8.6 1 1 0 1 0 5 8.6", key: "u9yy5q" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], qZ = r("LoaderPinwheel", OZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BZ = [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
], ZZ = r("Loader", BZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FZ = [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], GZ = r("LocateFixed", FZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $Z = [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  [
    "path",
    {
      d: "M7.11 7.11C5.83 8.39 5 10.1 5 12c0 3.87 3.13 7 7 7 1.9 0 3.61-.83 4.89-2.11",
      key: "1oh7ia"
    }
  ],
  [
    "path",
    {
      d: "M18.71 13.96c.19-.63.29-1.29.29-1.96 0-3.87-3.13-7-7-7-.67 0-1.33.1-1.96.29",
      key: "3qdecy"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], UZ = r("LocateOff", $Z);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WZ = [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }]
], YZ = r("Locate", WZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QZ = [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 9.33-2.5", key: "car5b7" }]
], JZ = r("LockKeyholeOpen", QZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KZ = [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  ["rect", { x: "3", y: "10", width: "18", height: "12", rx: "2", key: "6s8ecr" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 10 0v3", key: "1pqi11" }]
], XZ = r("LockKeyhole", KZ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eF = [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 9.9-1", key: "1mm8w8" }]
], tF = r("LockOpen", eF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aF = [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
], nF = r("Lock", aF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oF = [
  ["path", { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4", key: "u53s6r" }],
  ["polyline", { points: "10 17 15 12 10 7", key: "1ail0h" }],
  ["line", { x1: "15", x2: "3", y1: "12", y2: "12", key: "v6grx8" }]
], rF = r("LogIn", oF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iF = [
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }],
  ["polyline", { points: "16 17 21 12 16 7", key: "1gabdz" }],
  ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }]
], sF = r("LogOut", iF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cF = [
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M3 12h1", key: "lp3yf2" }],
  ["path", { d: "M3 18h1", key: "1eiwyy" }],
  ["path", { d: "M3 6h1", key: "rgxa97" }],
  ["path", { d: "M8 12h1", key: "1con00" }],
  ["path", { d: "M8 18h1", key: "13wk12" }],
  ["path", { d: "M8 6h1", key: "tn6mkg" }]
], fF = r("Logs", cF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dF = [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ["path", { d: "M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0", key: "107gwy" }]
], lF = r("Lollipop", dF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uF = [
  [
    "path",
    { d: "M6 20a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2", key: "1m57jg" }
  ],
  ["path", { d: "M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14", key: "1l99gc" }],
  ["path", { d: "M10 20h4", key: "ni2waw" }],
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  ["circle", { cx: "8", cy: "20", r: "2", key: "ckkr5m" }]
], hF = r("Luggage", uF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pF = [
  [
    "path",
    {
      d: "m6 15-4-4 6.75-6.77a7.79 7.79 0 0 1 11 11L13 22l-4-4 6.39-6.36a2.14 2.14 0 0 0-3-3L6 15",
      key: "1i3lhw"
    }
  ],
  ["path", { d: "m5 8 4 4", key: "j6kj7e" }],
  ["path", { d: "m12 15 4 4", key: "lnac28" }]
], yF = r("Magnet", pF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mF = [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "12jkf8" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
], kF = r("MailCheck", mF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gF = [
  ["path", { d: "M22 15V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "fuxbkv" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
], vF = r("MailMinus", gF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MF = [
  [
    "path",
    {
      d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z",
      key: "1jhwl8"
    }
  ],
  ["path", { d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10", key: "1qfld7" }]
], wF = r("MailOpen", MF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xF = [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "12jkf8" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
], CF = r("MailPlus", xF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bF = [
  ["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5", key: "e61zoh" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  [
    "path",
    {
      d: "M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2",
      key: "7z9rxb"
    }
  ],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
], LF = r("MailQuestion", bF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jF = [
  ["path", { d: "M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5", key: "w80f2v" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "8lzu5m" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.5-1.5", key: "1x83k4" }]
], NF = r("MailSearch", jF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AF = [
  ["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5", key: "e61zoh" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M20 14v4", key: "1hm744" }],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
], SF = r("MailWarning", AF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IF = [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9", key: "1j9vog" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m17 17 4 4", key: "1b3523" }],
  ["path", { d: "m21 17-4 4", key: "uinynz" }]
], TF = r("MailX", IF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zF = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }]
], DF = r("Mail", zF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _F = [
  [
    "path",
    {
      d: "M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z",
      key: "1lbycx"
    }
  ],
  ["polyline", { points: "15,9 18,9 18,11", key: "1pm9c0" }],
  ["path", { d: "M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2", key: "15i455" }],
  ["line", { x1: "6", x2: "7", y1: "10", y2: "10", key: "1e2scm" }]
], PF = r("Mailbox", _F);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EF = [
  ["rect", { width: "16", height: "13", x: "6", y: "4", rx: "2", key: "1drq3f" }],
  ["path", { d: "m22 7-7.1 3.78c-.57.3-1.23.3-1.8 0L6 7", key: "xn252p" }],
  ["path", { d: "M2 8v11c0 1.1.9 2 2 2h14", key: "n13cji" }]
], RF = r("Mails", EF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HF = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }]
], VF = r("MapPinCheckInside", HF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OF = [
  [
    "path",
    {
      d: "M19.43 12.935c.357-.967.57-1.955.57-2.935a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32.197 32.197 0 0 0 .813-.728",
      key: "1dq61d"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "m16 18 2 2 4-4", key: "1mkfmb" }]
], qF = r("MapPinCheck", OF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BF = [
  [
    "path",
    {
      d: "M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1z",
      key: "1p1rcz"
    }
  ],
  [
    "path",
    {
      d: "M18 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2",
      key: "mcbcs9"
    }
  ],
  ["path", { d: "M18 22v-3", key: "1t1ugv" }],
  ["circle", { cx: "10", cy: "10", r: "3", key: "1ns7v1" }]
], ZF = r("MapPinHouse", BF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FF = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], GF = r("MapPinMinusInside", FF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $F = [
  [
    "path",
    {
      d: "M18.977 14C19.6 12.701 20 11.343 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738",
      key: "11uxia"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M16 18h6", key: "987eiv" }]
], UF = r("MapPinMinus", $F);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WF = [
  ["path", { d: "M12.75 7.09a3 3 0 0 1 2.16 2.16", key: "1d4wjd" }],
  [
    "path",
    {
      d: "M17.072 17.072c-1.634 2.17-3.527 3.912-4.471 4.727a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 1.432-4.568",
      key: "12yil7"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.475 2.818A8 8 0 0 1 20 10c0 1.183-.31 2.377-.81 3.533", key: "lhrkcz" }],
  ["path", { d: "M9.13 9.13a3 3 0 0 0 3.74 3.74", key: "13wojd" }]
], YF = r("MapPinOff", WF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QF = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], JF = r("MapPinPlusInside", QF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KF = [
  [
    "path",
    {
      d: "M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738",
      key: "fcdtly"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M16 18h6", key: "987eiv" }],
  ["path", { d: "M19 15v6", key: "10aioa" }]
], XF = r("MapPinPlus", KF);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eG = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
], tG = r("MapPinXInside", eG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aG = [
  [
    "path",
    {
      d: "M19.752 11.901A7.78 7.78 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 19 19 0 0 0 .09-.077",
      key: "y0ewhp"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "m21.5 15.5-5 5", key: "11iqnx" }],
  ["path", { d: "m21.5 20.5-5-5", key: "1bylgx" }]
], nG = r("MapPinX", aG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oG = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
], rG = r("MapPin", oG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iG = [
  [
    "path",
    {
      d: "M18 8c0 3.613-3.869 7.429-5.393 8.795a1 1 0 0 1-1.214 0C9.87 15.429 6 11.613 6 8a6 6 0 0 1 12 0",
      key: "11u0oz"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  [
    "path",
    {
      d: "M8.714 14h-3.71a1 1 0 0 0-.948.683l-2.004 6A1 1 0 0 0 3 22h18a1 1 0 0 0 .948-1.316l-2-6a1 1 0 0 0-.949-.684h-3.712",
      key: "q8zwxj"
    }
  ]
], sG = r("MapPinned", iG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cG = [
  [
    "path",
    {
      d: "m11 19-1.106-.552a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0l4.212 2.106a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619V12",
      key: "svfegj"
    }
  ],
  ["path", { d: "M15 5.764V12", key: "1ocw4k" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }],
  ["path", { d: "M9 3.236v15", key: "1uimfh" }]
], fG = r("MapPlus", cG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dG = [
  [
    "path",
    {
      d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
      key: "169xi5"
    }
  ],
  ["path", { d: "M15 5.764v15", key: "1pn4in" }],
  ["path", { d: "M9 3.236v15", key: "1uimfh" }]
], lG = r("Map", dG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uG = [
  ["path", { d: "m14 6 4 4", key: "1q72g9" }],
  ["path", { d: "M17 3h4v4", key: "19p9u1" }],
  ["path", { d: "m21 3-7.75 7.75", key: "1cjbfd" }],
  ["circle", { cx: "9", cy: "15", r: "6", key: "bx5svt" }]
], hG = r("MarsStroke", uG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pG = [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "m21 3-6.75 6.75", key: "pv0uzu" }],
  ["circle", { cx: "10", cy: "14", r: "6", key: "1qwbdc" }]
], yG = r("Mars", pG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mG = [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M12 11v11", key: "ur9y6a" }],
  ["path", { d: "m19 3-7 8-7-8Z", key: "1sgpiw" }]
], kG = r("Martini", mG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gG = [
  ["polyline", { points: "15 3 21 3 21 9", key: "mznyad" }],
  ["polyline", { points: "9 21 3 21 3 15", key: "1avn1i" }],
  ["line", { x1: "21", x2: "14", y1: "3", y2: "10", key: "ota7mn" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
], vG = r("Maximize2", gG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MG = [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v3", key: "1dcmit" }],
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2h-3", key: "1e4gt3" }],
  ["path", { d: "M3 16v3a2 2 0 0 0 2 2h3", key: "wsl5sc" }],
  ["path", { d: "M16 21h3a2 2 0 0 0 2-2v-3", key: "18trek" }]
], wG = r("Maximize", MG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xG = [
  [
    "path",
    {
      d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15",
      key: "143lza"
    }
  ],
  ["path", { d: "M11 12 5.12 2.2", key: "qhuxz6" }],
  ["path", { d: "m13 12 5.88-9.8", key: "hbye0f" }],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["circle", { cx: "12", cy: "17", r: "5", key: "qbz8iq" }],
  ["path", { d: "M12 18v-2h-.5", key: "fawc4q" }]
], CG = r("Medal", xG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bG = [
  ["path", { d: "M9.26 9.26 3 11v3l14.14 3.14", key: "3429n" }],
  ["path", { d: "M21 15.34V6l-7.31 2.03", key: "4o1dh8" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], LG = r("MegaphoneOff", bG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jG = [
  ["path", { d: "m3 11 18-5v12L3 14v-3z", key: "n962bs" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }]
], NG = r("Megaphone", jG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AG = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "8", x2: "16", y1: "15", y2: "15", key: "1xb1d9" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], SG = r("Meh", AG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IG = [
  ["path", { d: "M6 19v-3", key: "1nvgqn" }],
  ["path", { d: "M10 19v-3", key: "iu8nkm" }],
  ["path", { d: "M14 19v-3", key: "kcehxu" }],
  ["path", { d: "M18 19v-3", key: "1vh91z" }],
  ["path", { d: "M8 11V9", key: "63erz4" }],
  ["path", { d: "M16 11V9", key: "fru6f3" }],
  ["path", { d: "M12 11V9", key: "ha00sb" }],
  ["path", { d: "M2 15h20", key: "16ne18" }],
  [
    "path",
    {
      d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.1a2 2 0 0 0 0 3.837V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.1a2 2 0 0 0 0-3.837Z",
      key: "lhddv3"
    }
  ]
], TG = r("MemoryStick", IG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zG = [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
], DG = r("Menu", zG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _G = [
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22", key: "1hyw0i" }],
  ["path", { d: "m20 22-5-5", key: "1m27yz" }]
], PG = r("Merge", _G);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EG = [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22z", key: "k85zhp" }]
], RG = r("MessageCircleCode", EG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HG = [
  ["path", { d: "M13.5 3.1c-.5 0-1-.1-1.5-.1s-1 .1-1.5.1", key: "16ll65" }],
  ["path", { d: "M19.3 6.8a10.45 10.45 0 0 0-2.1-2.1", key: "1nq77a" }],
  ["path", { d: "M20.9 13.5c.1-.5.1-1 .1-1.5s-.1-1-.1-1.5", key: "1sf7wn" }],
  ["path", { d: "M17.2 19.3a10.45 10.45 0 0 0 2.1-2.1", key: "x1hs5g" }],
  ["path", { d: "M10.5 20.9c.5.1 1 .1 1.5.1s1-.1 1.5-.1", key: "19m18z" }],
  ["path", { d: "M3.5 17.5 2 22l4.5-1.5", key: "1f36qi" }],
  ["path", { d: "M3.1 10.5c0 .5-.1 1-.1 1.5s.1 1 .1 1.5", key: "1vz3ju" }],
  ["path", { d: "M6.8 4.7a10.45 10.45 0 0 0-2.1 2.1", key: "19f9do" }]
], VG = r("MessageCircleDashed", HG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OG = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  [
    "path",
    {
      d: "M15.8 9.2a2.5 2.5 0 0 0-3.5 0l-.3.4-.35-.3a2.42 2.42 0 1 0-3.2 3.6l3.6 3.5 3.6-3.5c1.2-1.2 1.1-2.7.2-3.7",
      key: "43lnbm"
    }
  ]
], qG = r("MessageCircleHeart", OG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BG = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
], ZG = r("MessageCircleMore", BG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FG = [
  ["path", { d: "M20.5 14.9A9 9 0 0 0 9.1 3.5", key: "1iebmn" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5.6 5.6C3 8.3 2.2 12.5 4 16l-2 6 6-2c3.4 1.8 7.6 1.1 10.3-1.7", key: "1ov8ce" }]
], GG = r("MessageCircleOff", FG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $G = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
], UG = r("MessageCirclePlus", $G);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WG = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], YG = r("MessageCircleQuestion", WG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QG = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }],
  ["path", { d: "M7 12h7a2 2 0 0 1 2 2v1", key: "1gheu4" }]
], JG = r("MessageCircleReply", QG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KG = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
], XG = r("MessageCircleWarning", KG);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e$ = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], t$ = r("MessageCircleX", e$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a$ = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }]
], n$ = r("MessageCircle", a$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o$ = [
  ["path", { d: "M10 7.5 8 10l2 2.5", key: "xb17xw" }],
  ["path", { d: "m14 7.5 2 2.5-2 2.5", key: "5rap1v" }],
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
], r$ = r("MessageSquareCode", o$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i$ = [
  ["path", { d: "M10 17H7l-4 4v-7", key: "1r71xu" }],
  ["path", { d: "M14 17h1", key: "nufu4t" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 14v1a2 2 0 0 1-2 2", key: "29akq3" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M9 3h1", key: "1yesri" }]
], s$ = r("MessageSquareDashed", i$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c$ = [
  ["path", { d: "m5 19-2 2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2", key: "1xuzuj" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
], f$ = r("MessageSquareDiff", c$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d$ = [
  ["path", { d: "M11.7 3H5a2 2 0 0 0-2 2v16l4-4h12a2 2 0 0 0 2-2v-2.7", key: "uodpkb" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }]
], l$ = r("MessageSquareDot", d$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u$ = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  [
    "path",
    {
      d: "M14.8 7.5a1.84 1.84 0 0 0-2.6 0l-.2.3-.3-.3a1.84 1.84 0 1 0-2.4 2.8L12 13l2.7-2.7c.9-.9.8-2.1.1-2.8",
      key: "1blaws"
    }
  ]
], h$ = r("MessageSquareHeart", u$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p$ = [
  ["path", { d: "M19 15v-2a2 2 0 1 0-4 0v2", key: "h3d1vz" }],
  ["path", { d: "M9 17H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3.5", key: "xsnnhn" }],
  ["rect", { x: "13", y: "15", width: "8", height: "5", rx: "1", key: "1ccwuk" }]
], y$ = r("MessageSquareLock", p$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m$ = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }]
], k$ = r("MessageSquareMore", m$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g$ = [
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M3.6 3.6c-.4.3-.6.8-.6 1.4v16l4-4h10", key: "pwpm4a" }]
], v$ = r("MessageSquareOff", g$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M$ = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], w$ = r("MessageSquarePlus", M$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x$ = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M8 12a2 2 0 0 0 2-2V8H8", key: "1jfesj" }],
  ["path", { d: "M14 12a2 2 0 0 0 2-2V8h-2", key: "1dq9mh" }]
], C$ = r("MessageSquareQuote", x$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b$ = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m10 7-3 3 3 3", key: "1eugdv" }],
  ["path", { d: "M17 13v-1a2 2 0 0 0-2-2H7", key: "ernfh3" }]
], L$ = r("MessageSquareReply", b$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j$ = [
  ["path", { d: "M21 12v3a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h7", key: "tqtdkg" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "m16 8 5-5", key: "15mbrl" }]
], N$ = r("MessageSquareShare", j$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A$ = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M13 8H7", key: "14i4kc" }],
  ["path", { d: "M17 12H7", key: "16if0g" }]
], S$ = r("MessageSquareText", A$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I$ = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M12 7v2", key: "stiyo7" }],
  ["path", { d: "M12 13h.01", key: "y0uutt" }]
], T$ = r("MessageSquareWarning", I$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z$ = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
], D$ = r("MessageSquareX", z$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _$ = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
], P$ = r("MessageSquare", _$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E$ = [
  ["path", { d: "M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z", key: "p1xzt8" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1", key: "1cx29u" }]
], R$ = r("MessagesSquare", E$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H$ = [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2", key: "80xlxr" }],
  ["path", { d: "M5 10v2a7 7 0 0 0 12 5", key: "p2k8kg" }],
  ["path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33", key: "1gzdoj" }],
  ["path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12", key: "r2i35w" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
], V$ = r("MicOff", H$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O$ = [
  [
    "path",
    {
      d: "m11 7.601-5.994 8.19a1 1 0 0 0 .1 1.298l.817.818a1 1 0 0 0 1.314.087L15.09 12",
      key: "80a601"
    }
  ],
  [
    "path",
    {
      d: "M16.5 21.174C15.5 20.5 14.372 20 13 20c-2.058 0-3.928 2.356-6 2-2.072-.356-2.775-3.369-1.5-4.5",
      key: "j0ngtp"
    }
  ],
  ["circle", { cx: "16", cy: "7", r: "5", key: "d08jfb" }]
], q$ = r("MicVocal", O$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B$ = [
  ["path", { d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z", key: "131961" }],
  ["path", { d: "M19 10v2a7 7 0 0 1-14 0v-2", key: "1vc78b" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
], Z$ = r("Mic", B$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F$ = [
  ["path", { d: "M18 12h2", key: "quuxs7" }],
  ["path", { d: "M18 16h2", key: "zsn3lv" }],
  ["path", { d: "M18 20h2", key: "9x5y9y" }],
  ["path", { d: "M18 4h2", key: "1luxfb" }],
  ["path", { d: "M18 8h2", key: "nxqzg" }],
  ["path", { d: "M4 12h2", key: "1ltxp0" }],
  ["path", { d: "M4 16h2", key: "8a5zha" }],
  ["path", { d: "M4 20h2", key: "27dk57" }],
  ["path", { d: "M4 4h2", key: "10groj" }],
  ["path", { d: "M4 8h2", key: "18vq6w" }],
  [
    "path",
    {
      d: "M8 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1.5c-.276 0-.494.227-.562.495a2 2 0 0 1-3.876 0C9.994 2.227 9.776 2 9.5 2z",
      key: "1681fp"
    }
  ]
], G$ = r("Microchip", F$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $$ = [
  ["path", { d: "M6 18h8", key: "1borvv" }],
  ["path", { d: "M3 22h18", key: "8prr45" }],
  ["path", { d: "M14 22a7 7 0 1 0 0-14h-1", key: "1jwaiy" }],
  ["path", { d: "M9 14h2", key: "197e7h" }],
  ["path", { d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z", key: "1bmzmy" }],
  ["path", { d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3", key: "1drr47" }]
], U$ = r("Microscope", $$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W$ = [
  ["rect", { width: "20", height: "15", x: "2", y: "4", rx: "2", key: "2no95f" }],
  ["rect", { width: "8", height: "7", x: "6", y: "8", rx: "1", key: "zh9wx" }],
  ["path", { d: "M18 8v7", key: "o5zi4n" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 19v2", key: "1dawf0" }]
], Y$ = r("Microwave", W$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q$ = [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M12 3v3", key: "1n5kay" }],
  [
    "path",
    {
      d: "M4 6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h13a2 2 0 0 0 1.152-.365l3.424-2.317a1 1 0 0 0 0-1.635l-3.424-2.318A2 2 0 0 0 17 6z",
      key: "1btarq"
    }
  ]
], J$ = r("Milestone", Q$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K$ = [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v1.343M15 2v2.789a4 4 0 0 0 .672 2.219l.656.984a4 4 0 0 1 .672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3",
      key: "y0ejgx"
    }
  ],
  ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.472 6.472 0 0 0 3.435.435", key: "iaxqsy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], X$ = r("MilkOff", K$);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eU = [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2",
      key: "qtp12x"
    }
  ],
  ["path", { d: "M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "ygeh44" }]
], tU = r("Milk", eU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aU = [
  ["polyline", { points: "4 14 10 14 10 20", key: "11kfnr" }],
  ["polyline", { points: "20 10 14 10 14 4", key: "rlmsce" }],
  ["line", { x1: "14", x2: "21", y1: "10", y2: "3", key: "o5lafz" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
], nU = r("Minimize2", aU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oU = [
  ["path", { d: "M8 3v3a2 2 0 0 1-2 2H3", key: "hohbtr" }],
  ["path", { d: "M21 8h-3a2 2 0 0 1-2-2V3", key: "5jw1f3" }],
  ["path", { d: "M3 16h3a2 2 0 0 1 2 2v3", key: "198tvr" }],
  ["path", { d: "M16 21v-3a2 2 0 0 1 2-2h3", key: "ph8mxp" }]
], rU = r("Minimize", oU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iU = [["path", { d: "M5 12h14", key: "1ays0h" }]], sU = r("Minus", iU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cU = [
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], fU = r("MonitorCheck", cU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dU = [
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m15.2 4.9-.9-.4", key: "12wd2u" }],
  ["path", { d: "m15.2 7.1-.9.4", key: "1r2vl7" }],
  ["path", { d: "m16.9 3.2-.4-.9", key: "3zbo91" }],
  ["path", { d: "m16.9 8.8-.4.9", key: "1qr2dn" }],
  ["path", { d: "m19.5 2.3-.4.9", key: "1rjrkq" }],
  ["path", { d: "m19.5 9.7-.4-.9", key: "heryx5" }],
  ["path", { d: "m21.7 4.5-.9.4", key: "17fqt1" }],
  ["path", { d: "m21.7 7.5-.9-.4", key: "14zyni" }],
  ["path", { d: "M22 13v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7", key: "1tnzv8" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }]
], lU = r("MonitorCog", dU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uU = [
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  ["path", { d: "M22 12v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9", key: "1fet9y" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], hU = r("MonitorDot", uU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pU = [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m15 10-3 3-3-3", key: "lzhmyn" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], yU = r("MonitorDown", pU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mU = [
  ["path", { d: "M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2", key: "k0q8oc" }],
  ["path", { d: "M22 15V5a2 2 0 0 0-2-2H9", key: "cp1ac0" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], kU = r("MonitorOff", mU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gU = [
  ["path", { d: "M10 13V7", key: "1u13u9" }],
  ["path", { d: "M14 13V7", key: "1vj9om" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], vU = r("MonitorPause", gU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MU = [
  [
    "path",
    {
      d: "M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z",
      key: "1pctta"
    }
  ],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2", key: "x3v2xh" }]
], wU = r("MonitorPlay", MU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xU = [
  ["path", { d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8", key: "10dyio" }],
  ["path", { d: "M10 19v-3.96 3.15", key: "1irgej" }],
  ["path", { d: "M7 19h5", key: "qswx4l" }],
  ["rect", { width: "6", height: "10", x: "16", y: "12", rx: "2", key: "1egngj" }]
], CU = r("MonitorSmartphone", xU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bU = [
  ["path", { d: "M5.5 20H8", key: "1k40s5" }],
  ["path", { d: "M17 9h.01", key: "1j24nn" }],
  ["rect", { width: "10", height: "16", x: "12", y: "4", rx: "2", key: "ixliua" }],
  ["path", { d: "M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4", key: "1mp6e1" }],
  ["circle", { cx: "17", cy: "15", r: "1", key: "tqvash" }]
], LU = r("MonitorSpeaker", bU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jU = [
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2", key: "x3v2xh" }],
  ["rect", { x: "9", y: "7", width: "6", height: "6", rx: "1", key: "5m2oou" }]
], NU = r("MonitorStop", jU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AU = [
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], SU = r("MonitorUp", AU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IU = [
  ["path", { d: "m14.5 12.5-5-5", key: "1jahn5" }],
  ["path", { d: "m9.5 12.5 5-5", key: "1k2t7b" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
], TU = r("MonitorX", IU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zU = [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
], DU = r("Monitor", zU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _U = [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9", key: "4ay0iu" }],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }]
], PU = r("MoonStar", _U);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EU = [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
], RU = r("Moon", EU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HU = [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }],
  [
    "path",
    { d: "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19", key: "1pvmmp" }
  ]
], VU = r("MountainSnow", HU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OU = [["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }]], qU = r("Mountain", OU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BU = [
  ["path", { d: "M12 6v.343", key: "1gyhex" }],
  ["path", { d: "M18.218 18.218A7 7 0 0 1 5 15V9a7 7 0 0 1 .782-3.218", key: "ukzz01" }],
  ["path", { d: "M19 13.343V9A7 7 0 0 0 8.56 2.902", key: "104jy9" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
], ZU = r("MouseOff", BU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FU = [
  [
    "path",
    {
      d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
      key: "edeuup"
    }
  ]
], GU = r("MousePointer2", FU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $U = [
  [
    "path",
    {
      d: "M2.034 2.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.944L8.204 7.545a1 1 0 0 0-.66.66l-1.066 3.443a.5.5 0 0 1-.944.033z",
      key: "11pp1i"
    }
  ],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  ["path", { d: "m11.8 11.8 8.4 8.4", key: "oogvdj" }]
], UU = r("MousePointerBan", $U);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WU = [
  ["path", { d: "M14 4.1 12 6", key: "ita8i4" }],
  ["path", { d: "m5.1 8-2.9-.8", key: "1go3kf" }],
  ["path", { d: "m6 12-1.9 2", key: "mnht97" }],
  ["path", { d: "M7.2 2.2 8 5.1", key: "1cfko1" }],
  [
    "path",
    {
      d: "M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z",
      key: "s0h3yz"
    }
  ]
], YU = r("MousePointerClick", WU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QU = [
  ["path", { d: "M12.586 12.586 19 19", key: "ea5xo7" }],
  [
    "path",
    {
      d: "M3.688 3.037a.497.497 0 0 0-.651.651l6.5 15.999a.501.501 0 0 0 .947-.062l1.569-6.083a2 2 0 0 1 1.448-1.479l6.124-1.579a.5.5 0 0 0 .063-.947z",
      key: "277e5u"
    }
  ]
], JU = r("MousePointer", QU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KU = [
  ["rect", { x: "5", y: "2", width: "14", height: "20", rx: "7", key: "11ol66" }],
  ["path", { d: "M12 6v4", key: "16clxf" }]
], XU = r("Mouse", KU);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eW = [
  ["path", { d: "M5 3v16h16", key: "1mqmf9" }],
  ["path", { d: "m5 19 6-6", key: "jh6hbb" }],
  ["path", { d: "m2 6 3-3 3 3", key: "tkyvxa" }],
  ["path", { d: "m18 16 3 3-3 3", key: "1d4glt" }]
], tW = r("Move3d", eW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aW = [
  ["path", { d: "M19 13v6h-6", key: "1hxl6d" }],
  ["path", { d: "M5 11V5h6", key: "12e2xe" }],
  ["path", { d: "m5 5 14 14", key: "11anup" }]
], nW = r("MoveDiagonal2", aW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oW = [
  ["path", { d: "M11 19H5v-6", key: "8awifj" }],
  ["path", { d: "M13 5h6v6", key: "7voy1q" }],
  ["path", { d: "M19 5 5 19", key: "wwaj1z" }]
], rW = r("MoveDiagonal", oW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iW = [
  ["path", { d: "M11 19H5V13", key: "1akmht" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
], sW = r("MoveDownLeft", iW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cW = [
  ["path", { d: "M19 13V19H13", key: "10vkzq" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
], fW = r("MoveDownRight", cW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dW = [
  ["path", { d: "M8 18L12 22L16 18", key: "cskvfv" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
], lW = r("MoveDown", dW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uW = [
  ["path", { d: "m18 8 4 4-4 4", key: "1ak13k" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }]
], hW = r("MoveHorizontal", uW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pW = [
  ["path", { d: "M6 8L2 12L6 16", key: "kyvwex" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
], yW = r("MoveLeft", pW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mW = [
  ["path", { d: "M18 8L22 12L18 16", key: "1r0oui" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
], kW = r("MoveRight", mW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gW = [
  ["path", { d: "M5 11V5H11", key: "3q78g9" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
], vW = r("MoveUpLeft", gW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MW = [
  ["path", { d: "M13 5H19V11", key: "1n1gyv" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
], wW = r("MoveUpRight", MW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xW = [
  ["path", { d: "M8 6L12 2L16 6", key: "1yvkyx" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
], CW = r("MoveUp", xW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bW = [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "m8 18 4 4 4-4", key: "bh5tu3" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }]
], LW = r("MoveVertical", bW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jW = [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
  ["path", { d: "m19 9 3 3-3 3", key: "1mg7y2" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }],
  ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
], NW = r("Move", jW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AW = [
  ["circle", { cx: "8", cy: "18", r: "4", key: "1fc0mg" }],
  ["path", { d: "M12 18V2l7 4", key: "g04rme" }]
], SW = r("Music2", AW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IW = [
  ["circle", { cx: "12", cy: "18", r: "4", key: "m3r9ws" }],
  ["path", { d: "M16 18V2", key: "40x2m5" }]
], TW = r("Music3", IW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zW = [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["path", { d: "m9 9 12-2", key: "1e64n2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
], DW = r("Music4", zW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _W = [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
], PW = r("Music", _W);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EW = [
  ["path", { d: "M9.31 9.31 5 21l7-4 7 4-1.17-3.17", key: "qoq2o2" }],
  ["path", { d: "M14.53 8.88 12 2l-1.17 3.17", key: "k3sjzy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], RW = r("Navigation2Off", EW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HW = [
  ["polygon", { points: "12 2 19 21 12 17 5 21 12 2", key: "x8c0qg" }]
], VW = r("Navigation2", HW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OW = [
  ["path", { d: "M8.43 8.43 3 11l8 2 2 8 2.57-5.43", key: "1vdtb7" }],
  ["path", { d: "M17.39 11.73 22 2l-9.73 4.61", key: "tya3r6" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], qW = r("NavigationOff", OW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BW = [
  ["polygon", { points: "3 11 22 2 13 21 11 13 3 11", key: "1ltx0t" }]
], ZW = r("Navigation", BW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FW = [
  ["rect", { x: "16", y: "16", width: "6", height: "6", rx: "1", key: "4q2zg0" }],
  ["rect", { x: "2", y: "16", width: "6", height: "6", rx: "1", key: "8cvhb9" }],
  ["rect", { x: "9", y: "2", width: "6", height: "6", rx: "1", key: "1egb70" }],
  ["path", { d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3", key: "1jsf9p" }],
  ["path", { d: "M12 12V8", key: "2874zd" }]
], GW = r("Network", FW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $W = [
  [
    "path",
    {
      d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2",
      key: "7pis2x"
    }
  ],
  ["path", { d: "M18 14h-8", key: "sponae" }],
  ["path", { d: "M15 18h-5", key: "95g1m2" }],
  ["path", { d: "M10 6h8v4h-8V6Z", key: "smlsk5" }]
], UW = r("Newspaper", $W);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WW = [
  ["path", { d: "M6 8.32a7.43 7.43 0 0 1 0 7.36", key: "9iaqei" }],
  ["path", { d: "M9.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "1yha7l" }],
  ["path", { d: "M12.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "4iu2gk" }],
  ["path", { d: "M16.37 2a20.16 20.16 0 0 1 0 20", key: "sap9u2" }]
], YW = r("Nfc", WW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QW = [
  ["path", { d: "M12 2v10", key: "mnfbl" }],
  ["path", { d: "m9 4 6 4", key: "t8piew" }],
  ["path", { d: "m9 8 6-4", key: "sndyih" }],
  ["circle", { cx: "12", cy: "17", r: "5", key: "qbz8iq" }]
], JW = r("NonBinary", QW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KW = [
  ["path", { d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4", key: "re6nr2" }],
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  [
    "path",
    {
      d: "M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "pqwjuv"
    }
  ]
], XW = r("NotebookPen", KW);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eY = [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M15 2v20", key: "dcj49h" }],
  ["path", { d: "M15 7h5", key: "1xj5lc" }],
  ["path", { d: "M15 12h5", key: "w5shd9" }],
  ["path", { d: "M15 17h5", key: "1qaofu" }]
], tY = r("NotebookTabs", eY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aY = [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M9.5 8h5", key: "11mslq" }],
  ["path", { d: "M9.5 12H16", key: "ktog6x" }],
  ["path", { d: "M9.5 16H14", key: "p1seyn" }]
], nY = r("NotebookText", aY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oY = [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M16 2v20", key: "rotuqe" }]
], rY = r("Notebook", oY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iY = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v2", key: "j91f56" }],
  ["path", { d: "M20 12v2", key: "w8o0tu" }],
  ["path", { d: "M20 18v2a2 2 0 0 1-2 2h-1", key: "1c9ggx" }],
  ["path", { d: "M13 22h-2", key: "191ugt" }],
  ["path", { d: "M7 22H6a2 2 0 0 1-2-2v-2", key: "1rt9px" }],
  ["path", { d: "M4 14v-2", key: "1v0sqh" }],
  ["path", { d: "M4 8V6a2 2 0 0 1 2-2h2", key: "1mwabg" }],
  ["path", { d: "M8 10h6", key: "3oa6kw" }],
  ["path", { d: "M8 14h8", key: "1fgep2" }],
  ["path", { d: "M8 18h5", key: "17enja" }]
], sY = r("NotepadTextDashed", iY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cY = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "16", height: "18", x: "4", y: "4", rx: "2", key: "1u9h20" }],
  ["path", { d: "M8 10h6", key: "3oa6kw" }],
  ["path", { d: "M8 14h8", key: "1fgep2" }],
  ["path", { d: "M8 18h5", key: "17enja" }]
], fY = r("NotepadText", cY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dY = [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592a7.01 7.01 0 0 0 4.125-2.939",
      key: "1xcvy9"
    }
  ],
  ["path", { d: "M19 10v3.343", key: "163tfc" }],
  [
    "path",
    {
      d: "M12 12c-1.349-.573-1.905-1.005-2.5-2-.546.902-1.048 1.353-2.5 2-1.018-.644-1.46-1.08-2-2-1.028.71-1.69.918-3 1 1.081-1.048 1.757-2.03 2-3 .194-.776.84-1.551 1.79-2.21m11.654 5.997c.887-.457 1.28-.891 1.556-1.787 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4-.74 0-1.461.068-2.15.192",
      key: "17914v"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], lY = r("NutOff", dY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uY = [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592A7.003 7.003 0 0 0 19 14v-4",
      key: "1tgyif"
    }
  ],
  [
    "path",
    {
      d: "M12 4C8 4 4.5 6 4 8c-.243.97-.919 1.952-2 3 1.31-.082 1.972-.29 3-1 .54.92.982 1.356 2 2 1.452-.647 1.954-1.098 2.5-2 .595.995 1.151 1.427 2.5 2 1.31-.621 1.862-1.058 2.5-2 .629.977 1.162 1.423 2.5 2 1.209-.548 1.68-.967 2-2 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4Z",
      key: "tnsqj"
    }
  ]
], hY = r("Nut", uY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pY = [
  ["path", { d: "M12 16h.01", key: "1drbdi" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  [
    "path",
    {
      d: "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z",
      key: "1fd625"
    }
  ]
], yY = r("OctagonAlert", pY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mY = [
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], kY = r("OctagonMinus", mY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gY = [
  ["path", { d: "M10 15V9", key: "1lckn7" }],
  ["path", { d: "M14 15V9", key: "1muqhk" }],
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ]
], vY = r("OctagonPause", gY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MY = [
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], wY = r("OctagonX", MY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xY = [
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ]
], CY = r("Octagon", xY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bY = [
  [
    "path",
    {
      d: "M3 20h4.5a.5.5 0 0 0 .5-.5v-.282a.52.52 0 0 0-.247-.437 8 8 0 1 1 8.494-.001.52.52 0 0 0-.247.438v.282a.5.5 0 0 0 .5.5H21",
      key: "1x94xo"
    }
  ]
], LY = r("Omega", bY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jY = [
  ["path", { d: "M3 3h6l6 18h6", key: "ph9rgk" }],
  ["path", { d: "M14 3h7", key: "16f0ms" }]
], NY = r("Option", jY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AY = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M10.4 21.9a10 10 0 0 0 9.941-15.416", key: "eohfx2" }],
  ["path", { d: "M13.5 2.1a10 10 0 0 0-9.841 15.416", key: "19pvbm" }]
], SY = r("Orbit", AY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IY = [
  ["path", { d: "M12 12V4a1 1 0 0 1 1-1h6.297a1 1 0 0 1 .651 1.759l-4.696 4.025", key: "1bx4vc" }],
  [
    "path",
    {
      d: "m12 21-7.414-7.414A2 2 0 0 1 4 12.172V6.415a1.002 1.002 0 0 1 1.707-.707L20 20.009",
      key: "1h3km6"
    }
  ],
  [
    "path",
    {
      d: "m12.214 3.381 8.414 14.966a1 1 0 0 1-.167 1.199l-1.168 1.163a1 1 0 0 1-.706.291H6.351a1 1 0 0 1-.625-.219L3.25 18.8a1 1 0 0 1 .631-1.781l4.165.027",
      key: "1hj4wg"
    }
  ]
], TY = r("Origami", IY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zY = [
  ["path", { d: "M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z", key: "1ront0" }],
  ["path", { d: "m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9", key: "19h2x1" }],
  ["path", { d: "M12 3v6", key: "1holv5" }]
], DY = r("Package2", zY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Y = [
  ["path", { d: "m16 16 2 2 4-4", key: "gfu2re" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
], PY = r("PackageCheck", _Y);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EY = [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
], RY = r("PackageMinus", EY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HY = [
  ["path", { d: "M12 22v-9", key: "x3hkom" }],
  [
    "path",
    {
      d: "M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z",
      key: "2ntwy6"
    }
  ],
  [
    "path",
    {
      d: "M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13",
      key: "1pmm1c"
    }
  ],
  [
    "path",
    {
      d: "M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z",
      key: "12ttoo"
    }
  ]
], VY = r("PackageOpen", HY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OY = [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  ["path", { d: "M19 13v6", key: "85cyf1" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
], qY = r("PackagePlus", OY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BY = [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["circle", { cx: "18.5", cy: "15.5", r: "2.5", key: "b5zd12" }],
  ["path", { d: "M20.27 17.27 22 19", key: "1l4muz" }]
], ZY = r("PackageSearch", BY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FY = [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["path", { d: "m17 13 5 5m-5 0 5-5", key: "im3w4b" }]
], GY = r("PackageX", FY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $Y = [
  [
    "path",
    {
      d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
      key: "1a0edw"
    }
  ],
  ["path", { d: "M12 22V12", key: "d0xqtd" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }]
], UY = r("Package", $Y);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WY = [
  [
    "path",
    { d: "m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z", key: "irua1i" }
  ],
  ["path", { d: "m5 2 5 5", key: "1lls2c" }],
  ["path", { d: "M2 13h15", key: "1hkzvu" }],
  ["path", { d: "M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z", key: "xk76lq" }]
], YY = r("PaintBucket", WY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QY = [
  ["rect", { width: "16", height: "6", x: "2", y: "2", rx: "2", key: "jcyz7m" }],
  ["path", { d: "M10 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", key: "1b9h7c" }],
  ["rect", { width: "4", height: "6", x: "8", y: "16", rx: "1", key: "d6e7yl" }]
], JY = r("PaintRoller", QY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KY = [
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M14 2v4", key: "qmzblu" }],
  ["path", { d: "M17 2a1 1 0 0 1 1 1v9H6V3a1 1 0 0 1 1-1z", key: "ycvu00" }],
  [
    "path",
    {
      d: "M6 12a1 1 0 0 0-1 1v1a2 2 0 0 0 2 2h2a1 1 0 0 1 1 1v2.9a2 2 0 1 0 4 0V17a1 1 0 0 1 1-1h2a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1",
      key: "iw4wnp"
    }
  ]
], XY = r("PaintbrushVertical", KY);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eQ = [
  ["path", { d: "m14.622 17.897-10.68-2.913", key: "vj2p1u" }],
  [
    "path",
    {
      d: "M18.376 2.622a1 1 0 1 1 3.002 3.002L17.36 9.643a.5.5 0 0 0 0 .707l.944.944a2.41 2.41 0 0 1 0 3.408l-.944.944a.5.5 0 0 1-.707 0L8.354 7.348a.5.5 0 0 1 0-.707l.944-.944a2.41 2.41 0 0 1 3.408 0l.944.944a.5.5 0 0 0 .707 0z",
      key: "18tc5c"
    }
  ],
  [
    "path",
    {
      d: "M9 8c-1.804 2.71-3.97 3.46-6.583 3.948a.507.507 0 0 0-.302.819l7.32 8.883a1 1 0 0 0 1.185.204C12.735 20.405 16 16.792 16 15",
      key: "ytzfxy"
    }
  ]
], tQ = r("Paintbrush", eQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aQ = [
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  [
    "path",
    {
      d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z",
      key: "12rzf8"
    }
  ]
], nQ = r("Palette", aQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "m15 8-3 3-3-3", key: "1oxy1z" }]
], rQ = r("PanelBottomClose", oQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M14 15h1", key: "171nev" }],
  ["path", { d: "M19 15h2", key: "1vnucp" }],
  ["path", { d: "M3 15h2", key: "8bym0q" }],
  ["path", { d: "M9 15h1", key: "1tg3ks" }]
], sQ = r("PanelBottomDashed", iQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
], fQ = r("PanelBottomOpen", cQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
], lQ = r("PanelBottom", dQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m16 15-3-3 3-3", key: "14y99z" }]
], hQ = r("PanelLeftClose", uQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 14v1", key: "askpd8" }],
  ["path", { d: "M9 19v2", key: "16tejx" }],
  ["path", { d: "M9 3v2", key: "1noubl" }],
  ["path", { d: "M9 9v1", key: "19ebxg" }]
], yQ = r("PanelLeftDashed", pQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m14 9 3 3-3 3", key: "8010ee" }]
], kQ = r("PanelLeftOpen", mQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }]
], vQ = r("PanelLeft", gQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m8 9 3 3-3 3", key: "12hl5m" }]
], wQ = r("PanelRightClose", MQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 14v1", key: "ilsfch" }],
  ["path", { d: "M15 19v2", key: "1fst2f" }],
  ["path", { d: "M15 3v2", key: "z204g4" }],
  ["path", { d: "M15 9v1", key: "z2a8b1" }]
], CQ = r("PanelRightDashed", xQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }]
], LQ = r("PanelRightOpen", bQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
], NQ = r("PanelRight", jQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "m9 16 3-3 3 3", key: "1idcnm" }]
], SQ = r("PanelTopClose", AQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M14 9h1", key: "l0svgy" }],
  ["path", { d: "M19 9h2", key: "te2zfg" }],
  ["path", { d: "M3 9h2", key: "1h4ldw" }],
  ["path", { d: "M9 9h1", key: "15jzuz" }]
], TQ = r("PanelTopDashed", IQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "m15 14-3 3-3-3", key: "g215vf" }]
], DQ = r("PanelTopOpen", zQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Q = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }]
], PQ = r("PanelTop", _Q);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M9 15h12", key: "5ijen5" }]
], RQ = r("PanelsLeftBottom", EQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h12", key: "1wkqb3" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
], VQ = r("PanelsRightBottom", HQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OQ = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M9 21V9", key: "1oto5p" }]
], qQ = r("PanelsTopLeft", OQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BQ = [
  ["path", { d: "M13.234 20.252 21 12.3", key: "1cbrk9" }],
  [
    "path",
    {
      d: "m16 6-8.414 8.586a2 2 0 0 0 0 2.828 2 2 0 0 0 2.828 0l8.414-8.586a4 4 0 0 0 0-5.656 4 4 0 0 0-5.656 0l-8.415 8.585a6 6 0 1 0 8.486 8.486",
      key: "1pkts6"
    }
  ]
], ZQ = r("Paperclip", BQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FQ = [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }]
], GQ = r("Parentheses", FQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $Q = [
  ["path", { d: "M11 15h2", key: "199qp6" }],
  ["path", { d: "M12 12v3", key: "158kv8" }],
  ["path", { d: "M12 19v3", key: "npa21l" }],
  [
    "path",
    {
      d: "M15.282 19a1 1 0 0 0 .948-.68l2.37-6.988a7 7 0 1 0-13.2 0l2.37 6.988a1 1 0 0 0 .948.68z",
      key: "1jofit"
    }
  ],
  ["path", { d: "M9 9a3 3 0 1 1 6 0", key: "jdoeu8" }]
], UQ = r("ParkingMeter", $Q);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WQ = [
  ["path", { d: "M5.8 11.3 2 22l10.7-3.79", key: "gwxi1d" }],
  ["path", { d: "M4 3h.01", key: "1vcuye" }],
  ["path", { d: "M22 8h.01", key: "1mrtc2" }],
  ["path", { d: "M15 2h.01", key: "1cjtqr" }],
  ["path", { d: "M22 20h.01", key: "1mrys2" }],
  [
    "path",
    {
      d: "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10",
      key: "hbicv8"
    }
  ],
  [
    "path",
    { d: "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17", key: "1i94pl" }
  ],
  ["path", { d: "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7", key: "1cofks" }],
  [
    "path",
    {
      d: "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z",
      key: "4kbmks"
    }
  ]
], YQ = r("PartyPopper", WQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QQ = [
  ["rect", { x: "14", y: "4", width: "4", height: "16", rx: "1", key: "zuxfzm" }],
  ["rect", { x: "6", y: "4", width: "4", height: "16", rx: "1", key: "1okwgv" }]
], JQ = r("Pause", QQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KQ = [
  ["circle", { cx: "11", cy: "4", r: "2", key: "vol9p0" }],
  ["circle", { cx: "18", cy: "8", r: "2", key: "17gozi" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }],
  [
    "path",
    {
      d: "M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z",
      key: "1ydw1z"
    }
  ]
], XQ = r("PawPrint", KQ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eJ = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", key: "1uq1d7" }],
  ["path", { d: "M15 14h.01", key: "1kp3bh" }],
  ["path", { d: "M9 6h6", key: "dgm16u" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
], tJ = r("PcCase", eJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aJ = [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  [
    "path",
    {
      d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z",
      key: "1ykcvy"
    }
  ]
], nJ = r("PenLine", aJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oJ = [
  [
    "path",
    {
      d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
      key: "bjo8r8"
    }
  ],
  ["path", { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353", key: "16h5ne" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], rJ = r("PenOff", oJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iJ = [
  [
    "path",
    {
      d: "M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z",
      key: "nt11vn"
    }
  ],
  [
    "path",
    {
      d: "m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18",
      key: "15qc1e"
    }
  ],
  ["path", { d: "m2.3 2.3 7.286 7.286", key: "1wuzzi" }],
  ["circle", { cx: "11", cy: "11", r: "2", key: "xmgehs" }]
], sJ = r("PenTool", iJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cJ = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ]
], fJ = r("Pen", cJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dJ = [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  [
    "path",
    {
      d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z",
      key: "1ykcvy"
    }
  ],
  ["path", { d: "m15 5 3 3", key: "1w25hb" }]
], lJ = r("PencilLine", dJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uJ = [
  [
    "path",
    {
      d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
      key: "bjo8r8"
    }
  ],
  ["path", { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353", key: "16h5ne" }],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], hJ = r("PencilOff", uJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pJ = [
  [
    "path",
    { d: "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13", key: "orapub" }
  ],
  ["path", { d: "m8 6 2-2", key: "115y1s" }],
  ["path", { d: "m18 16 2-2", key: "ee94s4" }],
  [
    "path",
    {
      d: "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17",
      key: "cfq27r"
    }
  ],
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], yJ = r("PencilRuler", pJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mJ = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], kJ = r("Pencil", mJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gJ = [
  [
    "path",
    {
      d: "M10.83 2.38a2 2 0 0 1 2.34 0l8 5.74a2 2 0 0 1 .73 2.25l-3.04 9.26a2 2 0 0 1-1.9 1.37H7.04a2 2 0 0 1-1.9-1.37L2.1 10.37a2 2 0 0 1 .73-2.25z",
      key: "2hea0t"
    }
  ]
], vJ = r("Pentagon", gJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MJ = [
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }],
  ["circle", { cx: "6.5", cy: "6.5", r: "2.5", key: "4mh3h7" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "2.5", key: "1mdrzq" }]
], wJ = r("Percent", MJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xJ = [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["path", { d: "m9 20 3-6 3 6", key: "se2kox" }],
  ["path", { d: "m6 8 6 2 6-2", key: "4o3us4" }],
  ["path", { d: "M12 10v4", key: "1kjpxc" }]
], CJ = r("PersonStanding", xJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bJ = [
  ["path", { d: "M20 11H4", key: "6ut86h" }],
  ["path", { d: "M20 7H4", key: "zbl0bi" }],
  ["path", { d: "M7 21V4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 12H7", key: "1ana5r" }]
], LJ = r("PhilippinePeso", bJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jJ = [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ],
  ["path", { d: "M14.05 2a9 9 0 0 1 8 7.94", key: "vmijpz" }],
  ["path", { d: "M14.05 6A5 5 0 0 1 18 10", key: "13nbpp" }]
], NJ = r("PhoneCall", jJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AJ = [
  ["polyline", { points: "18 2 22 6 18 10", key: "6vjanh" }],
  ["line", { x1: "14", x2: "22", y1: "6", y2: "6", key: "1jsywh" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
], SJ = r("PhoneForwarded", AJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IJ = [
  ["polyline", { points: "16 2 16 8 22 8", key: "1ygljm" }],
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
], TJ = r("PhoneIncoming", IJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zJ = [
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  ["line", { x1: "16", x2: "22", y1: "2", y2: "8", key: "13zxdn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
], DJ = r("PhoneMissed", zJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _J = [
  [
    "path",
    {
      d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91",
      key: "z86iuo"
    }
  ],
  ["line", { x1: "22", x2: "2", y1: "2", y2: "22", key: "11kh81" }]
], PJ = r("PhoneOff", _J);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EJ = [
  ["polyline", { points: "22 8 22 2 16 2", key: "1g204g" }],
  ["line", { x1: "16", x2: "22", y1: "8", y2: "2", key: "1ggias" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
], RJ = r("PhoneOutgoing", EJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HJ = [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
], VJ = r("Phone", HJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OJ = [
  ["line", { x1: "9", x2: "9", y1: "4", y2: "20", key: "ovs5a5" }],
  ["path", { d: "M4 7c0-1.7 1.3-3 3-3h13", key: "10pag4" }],
  ["path", { d: "M18 20c-1.7 0-3-1.3-3-3V4", key: "1gaosr" }]
], qJ = r("Pi", OJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BJ = [
  [
    "path",
    {
      d: "M18.5 8c-1.4 0-2.6-.8-3.2-2A6.87 6.87 0 0 0 2 9v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8.5C22 9.6 20.4 8 18.5 8",
      key: "lag0yf"
    }
  ],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M6 14v4", key: "9ng0ue" }],
  ["path", { d: "M10 14v4", key: "1v8uk5" }],
  ["path", { d: "M14 14v4", key: "1tqops" }],
  ["path", { d: "M18 14v4", key: "18uqwm" }]
], ZJ = r("Piano", BJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FJ = [
  ["path", { d: "M14.531 12.469 6.619 20.38a1 1 0 1 1-3-3l7.912-7.912", key: "we99rg" }],
  [
    "path",
    {
      d: "M15.686 4.314A12.5 12.5 0 0 0 5.461 2.958 1 1 0 0 0 5.58 4.71a22 22 0 0 1 6.318 3.393",
      key: "1w6hck"
    }
  ],
  [
    "path",
    {
      d: "M17.7 3.7a1 1 0 0 0-1.4 0l-4.6 4.6a1 1 0 0 0 0 1.4l2.6 2.6a1 1 0 0 0 1.4 0l4.6-4.6a1 1 0 0 0 0-1.4z",
      key: "15hgfx"
    }
  ],
  [
    "path",
    {
      d: "M19.686 8.314a12.501 12.501 0 0 1 1.356 10.225 1 1 0 0 1-1.751-.119 22 22 0 0 0-3.393-6.319",
      key: "452b4h"
    }
  ]
], GJ = r("Pickaxe", FJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $J = [
  ["path", { d: "M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4", key: "daa4of" }],
  ["rect", { width: "10", height: "7", x: "12", y: "13", rx: "2", key: "1nb8gs" }]
], UJ = r("PictureInPicture2", $J);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WJ = [
  ["path", { d: "M2 10h6V4", key: "zwrco" }],
  ["path", { d: "m2 4 6 6", key: "ug085t" }],
  ["path", { d: "M21 10V7a2 2 0 0 0-2-2h-7", key: "git5jr" }],
  ["path", { d: "M3 14v2a2 2 0 0 0 2 2h3", key: "1f7fh3" }],
  ["rect", { x: "12", y: "14", width: "10", height: "7", rx: "1", key: "1wjs3o" }]
], YJ = r("PictureInPicture", WJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QJ = [
  [
    "path",
    {
      d: "M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2V5z",
      key: "1ivx2i"
    }
  ],
  ["path", { d: "M2 9v1c0 1.1.9 2 2 2h1", key: "nm575m" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }]
], JJ = r("PiggyBank", QJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KJ = [
  ["path", { d: "M14 3v11", key: "mlfb7b" }],
  ["path", { d: "M14 9h-3a3 3 0 0 1 0-6h9", key: "1ulc19" }],
  ["path", { d: "M18 3v11", key: "1phi0r" }],
  ["path", { d: "M22 18H2l4-4", key: "yt65j9" }],
  ["path", { d: "m6 22-4-4", key: "6jgyf5" }]
], XJ = r("PilcrowLeft", KJ);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eK = [
  ["path", { d: "M10 3v11", key: "o3l5kj" }],
  ["path", { d: "M10 9H7a1 1 0 0 1 0-6h8", key: "1wb1nc" }],
  ["path", { d: "M14 3v11", key: "mlfb7b" }],
  ["path", { d: "m18 14 4 4H2", key: "4r8io1" }],
  ["path", { d: "m22 18-4 4", key: "1hjjrd" }]
], tK = r("PilcrowRight", eK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aK = [
  ["path", { d: "M13 4v16", key: "8vvj80" }],
  ["path", { d: "M17 4v16", key: "7dpous" }],
  ["path", { d: "M19 4H9.5a4.5 4.5 0 0 0 0 9H13", key: "sh4n9v" }]
], nK = r("Pilcrow", aK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oK = [
  ["path", { d: "M18 11h-4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4", key: "17ldeb" }],
  ["path", { d: "M6 7v13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7", key: "nc37y6" }],
  ["rect", { width: "16", height: "5", x: "4", y: "2", rx: "1", key: "3jeezo" }]
], rK = r("PillBottle", oK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iK = [
  [
    "path",
    { d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z", key: "wa1lgi" }
  ],
  ["path", { d: "m8.5 8.5 7 7", key: "rvfmvr" }]
], sK = r("Pill", iK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cK = [
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  ["path", { d: "M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89", key: "znwnzq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11",
      key: "c9qhm2"
    }
  ]
], fK = r("PinOff", cK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dK = [
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  [
    "path",
    {
      d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
      key: "1nkz8b"
    }
  ]
], lK = r("Pin", dK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uK = [
  ["path", { d: "m2 22 1-1h3l9-9", key: "1sre89" }],
  ["path", { d: "M3 21v-3l9-9", key: "hpe2y6" }],
  [
    "path",
    {
      d: "m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z",
      key: "196du1"
    }
  ]
], hK = r("Pipette", uK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pK = [
  ["path", { d: "m12 14-1 1", key: "11onhr" }],
  ["path", { d: "m13.75 18.25-1.25 1.42", key: "1yisr3" }],
  ["path", { d: "M17.775 5.654a15.68 15.68 0 0 0-12.121 12.12", key: "1qtqk6" }],
  ["path", { d: "M18.8 9.3a1 1 0 0 0 2.1 7.7", key: "fbbbr2" }],
  [
    "path",
    {
      d: "M21.964 20.732a1 1 0 0 1-1.232 1.232l-18-5a1 1 0 0 1-.695-1.232A19.68 19.68 0 0 1 15.732 2.037a1 1 0 0 1 1.232.695z",
      key: "1hyfdd"
    }
  ]
], yK = r("Pizza", pK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mK = [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4a2 2 0 0 0 1.09 1.52l4.4 2.2c.42.22.78.55 1.01.96l.6 1.03c.49.88-.06 1.98-1.06 2.1l-1.18.15c-.47.06-.95-.02-1.37-.24L4.29 11.15a2 2 0 0 1-.52-.38Z",
      key: "1ma21e"
    }
  ]
], kK = r("PlaneLanding", mK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gK = [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z",
      key: "fkigj9"
    }
  ]
], vK = r("PlaneTakeoff", gK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MK = [
  [
    "path",
    {
      d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
      key: "1v9wt8"
    }
  ]
], wK = r("Plane", MK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xK = [["polygon", { points: "6 3 20 12 6 21 6 3", key: "1oa8hb" }]], Y2 = r("Play", xK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CK = [
  ["path", { d: "M9 2v6", key: "17ngun" }],
  ["path", { d: "M15 2v6", key: "s7yy2p" }],
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M6 11V8h12v3a6 6 0 1 1-12 0Z", key: "wtfw2c" }]
], bK = r("Plug2", CK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LK = [
  [
    "path",
    { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z", key: "goz73y" }
  ],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  ["path", { d: "m18 3-4 4h6l-4 4", key: "16psg9" }]
], jK = r("PlugZap", LK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NK = [
  ["path", { d: "M12 22v-5", key: "1ega77" }],
  ["path", { d: "M9 8V2", key: "14iosj" }],
  ["path", { d: "M15 8V2", key: "18g5xt" }],
  ["path", { d: "M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z", key: "osxo6l" }]
], AK = r("Plug", NK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SK = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], IK = r("Plus", SK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TK = [
  ["path", { d: "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2-2 1-2 2 2 1 2 2", key: "19w3oe" }],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M20.83 8.83a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z", key: "6fykxj" }],
  ["path", { d: "M18 11.66V22a4 4 0 0 0 4-4V6", key: "1utzek" }]
], zK = r("PocketKnife", TK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DK = [
  [
    "path",
    {
      d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z",
      key: "1mz881"
    }
  ],
  ["polyline", { points: "8 10 12 14 16 10", key: "w4mbv5" }]
], _K = r("Pocket", DK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PK = [
  ["path", { d: "M16.85 18.58a9 9 0 1 0-9.7 0", key: "d71mpg" }],
  ["path", { d: "M8 14a5 5 0 1 1 8 0", key: "fc81rn" }],
  ["circle", { cx: "12", cy: "11", r: "1", key: "1gvufo" }],
  ["path", { d: "M13 17a1 1 0 1 0-2 0l.5 4.5a.5.5 0 1 0 1 0Z", key: "za5kbj" }]
], EK = r("Podcast", PK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RK = [
  ["path", { d: "M10 4.5V4a2 2 0 0 0-2.41-1.957", key: "jsi14n" }],
  ["path", { d: "M13.9 8.4a2 2 0 0 0-1.26-1.295", key: "hirc7f" }],
  [
    "path",
    { d: "M21.7 16.2A8 8 0 0 0 22 14v-3a2 2 0 1 0-4 0v-1a2 2 0 0 0-3.63-1.158", key: "1jxb2e" }
  ],
  [
    "path",
    {
      d: "m7 15-1.8-1.8a2 2 0 0 0-2.79 2.86L6 19.7a7.74 7.74 0 0 0 6 2.3h2a8 8 0 0 0 5.657-2.343",
      key: "10r7hm"
    }
  ],
  ["path", { d: "M6 6v8", key: "tv5xkp" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], HK = r("PointerOff", RK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VK = [
  ["path", { d: "M22 14a8 8 0 0 1-8 8", key: "56vcr3" }],
  ["path", { d: "M18 11v-1a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1agjmk" }],
  ["path", { d: "M14 10V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1", key: "wdbh2u" }],
  ["path", { d: "M10 9.5V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v10", key: "1ibuk9" }],
  [
    "path",
    {
      d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "g6ys72"
    }
  ]
], OK = r("Pointer", VK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qK = [
  [
    "path",
    {
      d: "M18 8a2 2 0 0 0 0-4 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0 0 4",
      key: "10td1f"
    }
  ],
  ["path", { d: "M10 22 9 8", key: "yjptiv" }],
  ["path", { d: "m14 22 1-14", key: "8jwc8b" }],
  [
    "path",
    {
      d: "M20 8c.5 0 .9.4.8 1l-2.6 12c-.1.5-.7 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L3.2 9c-.1-.6.3-1 .8-1Z",
      key: "1qo33t"
    }
  ]
], BK = r("Popcorn", qK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZK = [
  [
    "path",
    {
      d: "M18.6 14.4c.8-.8.8-2 0-2.8l-8.1-8.1a4.95 4.95 0 1 0-7.1 7.1l8.1 8.1c.9.7 2.1.7 2.9-.1Z",
      key: "1o68ps"
    }
  ],
  ["path", { d: "m22 22-5.5-5.5", key: "17o70y" }]
], FK = r("Popsicle", ZK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GK = [
  ["path", { d: "M18 7c0-5.333-8-5.333-8 0", key: "1prm2n" }],
  ["path", { d: "M10 7v14", key: "18tmcs" }],
  ["path", { d: "M6 21h12", key: "4dkmi1" }],
  ["path", { d: "M6 13h10", key: "ybwr4a" }]
], $K = r("PoundSterling", GK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UK = [
  ["path", { d: "M18.36 6.64A9 9 0 0 1 20.77 15", key: "dxknvb" }],
  ["path", { d: "M6.16 6.16a9 9 0 1 0 12.68 12.68", key: "1x7qb5" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], WK = r("PowerOff", UK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YK = [
  ["path", { d: "M12 2v10", key: "mnfbl" }],
  ["path", { d: "M18.4 6.6a9 9 0 1 1-12.77.04", key: "obofu9" }]
], QK = r("Power", YK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JK = [
  ["path", { d: "M2 3h20", key: "91anmk" }],
  ["path", { d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3", key: "2k9sn8" }],
  ["path", { d: "m7 21 5-5 5 5", key: "bip4we" }]
], KK = r("Presentation", JK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XK = [
  ["path", { d: "M13.5 22H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v.5", key: "qeb09x" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }],
  ["path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2", key: "1md90i" }],
  ["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6", key: "1itne7" }]
], eX = r("PrinterCheck", XK);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tX = [
  [
    "path",
    {
      d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "143wyd"
    }
  ],
  ["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6", key: "1itne7" }],
  ["rect", { x: "6", y: "14", width: "12", height: "8", rx: "1", key: "1ue0tg" }]
], aX = r("Printer", tX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nX = [
  ["path", { d: "M5 7 3 5", key: "1yys58" }],
  ["path", { d: "M9 6V3", key: "1ptz9u" }],
  ["path", { d: "m13 7 2-2", key: "1w3vmq" }],
  ["circle", { cx: "9", cy: "13", r: "3", key: "1mma13" }],
  [
    "path",
    {
      d: "M11.83 12H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17",
      key: "2frwzc"
    }
  ],
  ["path", { d: "M16 16h2", key: "dnq2od" }]
], oX = r("Projector", nX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rX = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M12 9v11", key: "1fnkrn" }],
  ["path", { d: "M2 9h13a2 2 0 0 1 2 2v9", key: "11z3ex" }]
], iX = r("Proportions", rX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sX = [
  [
    "path",
    {
      d: "M15.39 4.39a1 1 0 0 0 1.68-.474 2.5 2.5 0 1 1 3.014 3.015 1 1 0 0 0-.474 1.68l1.683 1.682a2.414 2.414 0 0 1 0 3.414L19.61 15.39a1 1 0 0 1-1.68-.474 2.5 2.5 0 1 0-3.014 3.015 1 1 0 0 1 .474 1.68l-1.683 1.682a2.414 2.414 0 0 1-3.414 0L8.61 19.61a1 1 0 0 0-1.68.474 2.5 2.5 0 1 1-3.014-3.015 1 1 0 0 0 .474-1.68l-1.683-1.682a2.414 2.414 0 0 1 0-3.414L4.39 8.61a1 1 0 0 1 1.68.474 2.5 2.5 0 1 0 3.014-3.015 1 1 0 0 1-.474-1.68l1.683-1.682a2.414 2.414 0 0 1 3.414 0z",
      key: "w46dr5"
    }
  ]
], cX = r("Puzzle", sX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fX = [
  [
    "path",
    {
      d: "M2.5 16.88a1 1 0 0 1-.32-1.43l9-13.02a1 1 0 0 1 1.64 0l9 13.01a1 1 0 0 1-.32 1.44l-8.51 4.86a2 2 0 0 1-1.98 0Z",
      key: "aenxs0"
    }
  ],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
], dX = r("Pyramid", fX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lX = [
  ["rect", { width: "5", height: "5", x: "3", y: "3", rx: "1", key: "1tu5fj" }],
  ["rect", { width: "5", height: "5", x: "16", y: "3", rx: "1", key: "1v8r4q" }],
  ["rect", { width: "5", height: "5", x: "3", y: "16", rx: "1", key: "1x03jg" }],
  ["path", { d: "M21 16h-3a2 2 0 0 0-2 2v3", key: "177gqh" }],
  ["path", { d: "M21 21v.01", key: "ents32" }],
  ["path", { d: "M12 7v3a2 2 0 0 1-2 2H7", key: "8crl2c" }],
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M12 3h.01", key: "n36tog" }],
  ["path", { d: "M12 16v.01", key: "133mhm" }],
  ["path", { d: "M16 12h1", key: "1slzba" }],
  ["path", { d: "M21 12v.01", key: "1lwtk9" }],
  ["path", { d: "M12 21v-1", key: "1880an" }]
], uX = r("QrCode", lX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hX = [
  [
    "path",
    {
      d: "M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
      key: "rib7q0"
    }
  ],
  [
    "path",
    {
      d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
      key: "1ymkrd"
    }
  ]
], pX = r("Quote", hX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yX = [
  ["path", { d: "M13 16a3 3 0 0 1 2.24 5", key: "1epib5" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }],
  [
    "path",
    {
      d: "M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1 1 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1a3 3 0 0 0-3 3",
      key: "ue9ozu"
    }
  ],
  ["path", { d: "M20 8.54V4a2 2 0 1 0-4 0v3", key: "49iql8" }],
  ["path", { d: "M7.612 12.524a3 3 0 1 0-1.6 4.3", key: "1e33i0" }]
], mX = r("Rabbit", yX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kX = [
  ["path", { d: "M19.07 4.93A10 10 0 0 0 6.99 3.34", key: "z3du51" }],
  ["path", { d: "M4 6h.01", key: "oypzma" }],
  ["path", { d: "M2.29 9.62A10 10 0 1 0 21.31 8.35", key: "qzzz0" }],
  ["path", { d: "M16.24 7.76A6 6 0 1 0 8.23 16.67", key: "1yjesh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M17.99 11.66A6 6 0 0 1 15.77 16.67", key: "1u2y91" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "m13.41 10.59 5.66-5.66", key: "mhq4k0" }]
], gX = r("Radar", kX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vX = [
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  [
    "path",
    {
      d: "M7.5 4.2c-.3-.5-.9-.7-1.3-.4C3.9 5.5 2.3 8.1 2 11c-.1.5.4 1 1 1h5c0-1.5.8-2.8 2-3.4-1.1-1.9-2-3.5-2.5-4.4z",
      key: "wy49g3"
    }
  ],
  [
    "path",
    {
      d: "M21 12c.6 0 1-.4 1-1-.3-2.9-1.8-5.5-4.1-7.1-.4-.3-1.1-.2-1.3.3-.6.9-1.5 2.5-2.6 4.3 1.2.7 2 2 2 3.5h5z",
      key: "vklnvr"
    }
  ],
  [
    "path",
    {
      d: "M7.5 19.8c-.3.5-.1 1.1.4 1.3 2.6 1.2 5.6 1.2 8.2 0 .5-.2.7-.8.4-1.3-.5-.9-1.4-2.5-2.5-4.3-1.2.7-2.8.7-4 0-1.1 1.8-2 3.4-2.5 4.3z",
      key: "wkdf1o"
    }
  ]
], MX = r("Radiation", vX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wX = [
  [
    "path",
    {
      d: "M3 12h3.28a1 1 0 0 1 .948.684l2.298 7.934a.5.5 0 0 0 .96-.044L13.82 4.771A1 1 0 0 1 14.792 4H21",
      key: "1mqj8i"
    }
  ]
], xX = r("Radical", wX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CX = [
  ["path", { d: "M5 16v2", key: "g5qcv5" }],
  ["path", { d: "M19 16v2", key: "1gbaio" }],
  ["rect", { width: "20", height: "8", x: "2", y: "8", rx: "2", key: "vjsjur" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
], bX = r("RadioReceiver", CX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LX = [
  ["path", { d: "M4.9 16.1C1 12.2 1 5.8 4.9 1.9", key: "s0qx1y" }],
  ["path", { d: "M7.8 4.7a6.14 6.14 0 0 0-.8 7.5", key: "1idnkw" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }],
  ["path", { d: "M16.2 4.8c2 2 2.26 5.11.8 7.47", key: "ojru2q" }],
  ["path", { d: "M19.1 1.9a9.96 9.96 0 0 1 0 14.1", key: "rhi7fg" }],
  ["path", { d: "M9.5 18h5", key: "mfy3pd" }],
  ["path", { d: "m8 22 4-11 4 11", key: "25yftu" }]
], jX = r("RadioTower", LX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NX = [
  ["path", { d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9", key: "1vaf9d" }],
  ["path", { d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5", key: "u1ii0m" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5", key: "1j5fej" }],
  ["path", { d: "M19.1 4.9C23 8.8 23 15.1 19.1 19", key: "10b0cb" }]
], AX = r("Radio", NX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SX = [
  ["path", { d: "M20.34 17.52a10 10 0 1 0-2.82 2.82", key: "fydyku" }],
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["path", { d: "m13.41 13.41 4.18 4.18", key: "1gqbwc" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
], IX = r("Radius", SX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TX = [
  ["path", { d: "M5 15h14", key: "m0yey3" }],
  ["path", { d: "M5 9h14", key: "7tsvo6" }],
  ["path", { d: "m14 20-5-5 6-6-5-5", key: "1jo42i" }]
], zX = r("RailSymbol", TX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DX = [
  ["path", { d: "M22 17a10 10 0 0 0-20 0", key: "ozegv" }],
  ["path", { d: "M6 17a6 6 0 0 1 12 0", key: "5giftw" }],
  ["path", { d: "M10 17a2 2 0 0 1 4 0", key: "gnsikk" }]
], _X = r("Rainbow", DX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PX = [
  ["path", { d: "M13 22H4a2 2 0 0 1 0-4h12", key: "bt3f23" }],
  ["path", { d: "M13.236 18a3 3 0 0 0-2.2-5", key: "1tbvmo" }],
  ["path", { d: "M16 9h.01", key: "1bdo4e" }],
  [
    "path",
    {
      d: "M16.82 3.94a3 3 0 1 1 3.237 4.868l1.815 2.587a1.5 1.5 0 0 1-1.5 2.1l-2.872-.453a3 3 0 0 0-3.5 3",
      key: "9ch7kn"
    }
  ],
  ["path", { d: "M17 4.988a3 3 0 1 0-5.2 2.052A7 7 0 0 0 4 14.015 4 4 0 0 0 8 18", key: "3s7e9i" }]
], EX = r("Rat", PX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RX = [
  ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }],
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
], HX = r("Ratio", RX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VX = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M12 6.5v11", key: "ecfhkf" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
], OX = r("ReceiptCent", VX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qX = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 12h5", key: "1g6qi8" }],
  ["path", { d: "M16 9.5a4 4 0 1 0 0 5.2", key: "b2px4r" }]
], BX = r("ReceiptEuro", qX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZX = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["path", { d: "M12 17.5 8 15h1a4 4 0 0 0 0-8", key: "grpkl4" }],
  ["path", { d: "M8 11h8", key: "vwpz6n" }]
], FX = r("ReceiptIndianRupee", ZX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GX = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "m12 10 3-3", key: "1mc12w" }],
  ["path", { d: "m9 7 3 3v7.5", key: "39i0xv" }],
  ["path", { d: "M9 11h6", key: "1fldmi" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }]
], $X = r("ReceiptJapaneseYen", GX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UX = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 13h5", key: "1k9z8w" }],
  ["path", { d: "M10 17V9.5a2.5 2.5 0 0 1 5 0", key: "1dzgp0" }],
  ["path", { d: "M8 17h7", key: "8mjdqu" }]
], WX = r("ReceiptPoundSterling", UX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YX = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 15h5", key: "vxg57a" }],
  ["path", { d: "M8 11h5a2 2 0 1 0 0-4h-3v10", key: "1usi5u" }]
], QX = r("ReceiptRussianRuble", YX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JX = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M10 17V7h5", key: "k7jq18" }],
  ["path", { d: "M10 11h4", key: "1i0mka" }],
  ["path", { d: "M8 15h5", key: "vxg57a" }]
], KX = r("ReceiptSwissFranc", JX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XX = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M14 8H8", key: "1l3xfs" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "M13 16H8", key: "wsln4y" }]
], eee = r("ReceiptText", XX);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tee = [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 17.5v-11", key: "1jc1ny" }]
], aee = r("Receipt", tee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nee = [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
], oee = r("RectangleEllipsis", nee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ree = [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
], iee = r("RectangleHorizontal", ree);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const see = [
  ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }]
], cee = r("RectangleVertical", see);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fee = [
  [
    "path",
    {
      d: "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5",
      key: "x6z5xu"
    }
  ],
  [
    "path",
    {
      d: "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12",
      key: "1x4zh5"
    }
  ],
  ["path", { d: "m14 16-3 3 3 3", key: "f6jyew" }],
  ["path", { d: "M8.293 13.596 7.196 9.5 3.1 10.598", key: "wf1obh" }],
  [
    "path",
    {
      d: "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843",
      key: "9tzpgr"
    }
  ],
  ["path", { d: "m13.378 9.633 4.096 1.098 1.097-4.096", key: "1oe83g" }]
], dee = r("Recycle", fee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lee = [
  ["path", { d: "m15 14 5-5-5-5", key: "12vg1m" }],
  ["path", { d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13", key: "6uklza" }]
], uee = r("Redo2", lee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hee = [
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }],
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
], pee = r("RedoDot", hee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yee = [
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
], mee = r("Redo", yee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kee = [
  ["path", { d: "M3 2v6h6", key: "18ldww" }],
  ["path", { d: "M21 12A9 9 0 0 0 6 5.3L3 8", key: "1pbrqz" }],
  ["path", { d: "M21 22v-6h-6", key: "usdfbe" }],
  ["path", { d: "M3 12a9 9 0 0 0 15 6.7l3-2.7", key: "1hosoe" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
], gee = r("RefreshCcwDot", kee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vee = [
  ["path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "14sxne" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16", key: "1hlbsb" }],
  ["path", { d: "M16 16h5v5", key: "ccwih5" }]
], Mee = r("RefreshCcw", vee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wee = [
  ["path", { d: "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47", key: "1krf6h" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }],
  ["path", { d: "M3 12C3 9.51 4 7.26 5.64 5.64", key: "ruvoct" }],
  ["path", { d: "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64", key: "19q130" }],
  ["path", { d: "M21 12c0 1-.16 1.97-.47 2.87", key: "4w8emr" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
], xee = r("RefreshCwOff", wee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cee = [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
], bee = r("RefreshCw", Cee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lee = [
  [
    "path",
    { d: "M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z", key: "fpq118" }
  ],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M15 7v6", key: "1nx30x" }]
], jee = r("Refrigerator", Lee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nee = [
  ["path", { d: "M17 3v10", key: "15fgeh" }],
  ["path", { d: "m12.67 5.5 8.66 5", key: "1gpheq" }],
  ["path", { d: "m12.67 10.5 8.66-5", key: "1dkfa6" }],
  [
    "path",
    { d: "M9 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z", key: "swwfx4" }
  ]
], Aee = r("Regex", Nee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const See = [
  ["path", { d: "M4 7V4h16v3", key: "9msm58" }],
  ["path", { d: "M5 20h6", key: "1h6pxn" }],
  ["path", { d: "M13 4 8 20", key: "kqq6aj" }],
  ["path", { d: "m15 15 5 5", key: "me55sn" }],
  ["path", { d: "m20 15-5 5", key: "11p7ol" }]
], Iee = r("RemoveFormatting", See);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tee = [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }],
  ["path", { d: "M11 10h1v4", key: "70cz1p" }]
], zee = r("Repeat1", Tee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dee = [
  ["path", { d: "m2 9 3-3 3 3", key: "1ltn5i" }],
  ["path", { d: "M13 18H7a2 2 0 0 1-2-2V6", key: "1r6tfw" }],
  ["path", { d: "m22 15-3 3-3-3", key: "4rnwn2" }],
  ["path", { d: "M11 6h6a2 2 0 0 1 2 2v10", key: "2f72bc" }]
], _ee = r("Repeat2", Dee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pee = [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }]
], Eee = r("Repeat", Pee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ree = [
  ["path", { d: "M14 14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "1yyzbs" }],
  ["path", { d: "M14 4a2 2 0 0 1 2-2", key: "1w2hp7" }],
  ["path", { d: "M16 10a2 2 0 0 1-2-2", key: "shjach" }],
  ["path", { d: "M20 14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "zfj4xr" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2", key: "188mtx" }],
  ["path", { d: "M22 8a2 2 0 0 1-2 2", key: "ddf4tu" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5a 3 3 0 0 1 3-3h1", key: "1ageje" }],
  ["rect", { x: "2", y: "14", width: "8", height: "8", rx: "2", key: "4rksxw" }]
], Hee = r("ReplaceAll", Ree);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vee = [
  ["path", { d: "M14 4a2 2 0 0 1 2-2", key: "1w2hp7" }],
  ["path", { d: "M16 10a2 2 0 0 1-2-2", key: "shjach" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2", key: "188mtx" }],
  ["path", { d: "M22 8a2 2 0 0 1-2 2", key: "ddf4tu" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5a3 3 0 0 1 3-3h1", key: "3y3t5z" }],
  ["rect", { x: "2", y: "14", width: "8", height: "8", rx: "2", key: "4rksxw" }]
], Oee = r("Replace", Vee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qee = [
  ["polyline", { points: "7 17 2 12 7 7", key: "t83bqg" }],
  ["polyline", { points: "12 17 7 12 12 7", key: "1g4ajm" }],
  ["path", { d: "M22 18v-2a4 4 0 0 0-4-4H7", key: "1fcyog" }]
], Bee = r("ReplyAll", qee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zee = [
  ["polyline", { points: "9 17 4 12 9 7", key: "hvgpf2" }],
  ["path", { d: "M20 18v-2a4 4 0 0 0-4-4H4", key: "5vmcpk" }]
], Fee = r("Reply", Zee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gee = [
  ["polygon", { points: "11 19 2 12 11 5 11 19", key: "14yba5" }],
  ["polygon", { points: "22 19 13 12 22 5 22 19", key: "1pi1cj" }]
], $ee = r("Rewind", Gee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uee = [
  [
    "path",
    { d: "M12 11.22C11 9.997 10 9 10 8a2 2 0 0 1 4 0c0 1-.998 2.002-2.01 3.22", key: "1rnhq3" }
  ],
  ["path", { d: "m12 18 2.57-3.5", key: "116vt7" }],
  ["path", { d: "M6.243 9.016a7 7 0 0 1 11.507-.009", key: "10dq0b" }],
  ["path", { d: "M9.35 14.53 12 11.22", key: "tdsyp2" }],
  [
    "path",
    {
      d: "M9.35 14.53C7.728 12.246 6 10.221 6 7a6 5 0 0 1 12 0c-.005 3.22-1.778 5.235-3.43 7.5l3.557 4.527a1 1 0 0 1-.203 1.43l-1.894 1.36a1 1 0 0 1-1.384-.215L12 18l-2.679 3.593a1 1 0 0 1-1.39.213l-1.865-1.353a1 1 0 0 1-.203-1.422z",
      key: "nmifey"
    }
  ]
], Wee = r("Ribbon", Uee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yee = [
  [
    "path",
    {
      d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
      key: "m3kijz"
    }
  ],
  [
    "path",
    {
      d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
      key: "1fmvmk"
    }
  ],
  ["path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0", key: "1f8sc4" }],
  ["path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5", key: "qeys4" }]
], Qee = r("Rocket", Yee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jee = [
  ["polyline", { points: "3.5 2 6.5 12.5 18 12.5", key: "y3iy52" }],
  ["line", { x1: "9.5", x2: "5.5", y1: "12.5", y2: "20", key: "19vg5i" }],
  ["line", { x1: "15", x2: "18.5", y1: "12.5", y2: "20", key: "1inpmv" }],
  ["path", { d: "M2.75 18a13 13 0 0 0 18.5 0", key: "1nquas" }]
], Kee = r("RockingChair", Jee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xee = [
  ["path", { d: "M6 19V5", key: "1r845m" }],
  ["path", { d: "M10 19V6.8", key: "9j2tfs" }],
  ["path", { d: "M14 19v-7.8", key: "10s8qv" }],
  ["path", { d: "M18 5v4", key: "1tajlv" }],
  ["path", { d: "M18 19v-6", key: "ielfq3" }],
  ["path", { d: "M22 19V9", key: "158nzp" }],
  ["path", { d: "M2 19V9a4 4 0 0 1 4-4c2 0 4 1.33 6 4s4 4 6 4a4 4 0 1 0-3-6.65", key: "1930oh" }]
], ete = r("RollerCoaster", Xee);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tte = [
  [
    "path",
    {
      d: "M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2",
      key: "10n0gc"
    }
  ],
  ["path", { d: "m15.194 13.707 3.814 1.86-1.86 3.814", key: "16shm9" }],
  [
    "path",
    {
      d: "M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4",
      key: "1lxi77"
    }
  ]
], ate = r("Rotate3d", tte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nte = [
  ["path", { d: "M20 9V7a2 2 0 0 0-2-2h-6", key: "19z8uc" }],
  ["path", { d: "m15 2-3 3 3 3", key: "177bxs" }],
  ["path", { d: "M20 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2", key: "d36hnl" }]
], ote = r("RotateCcwSquare", nte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rte = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
], ite = r("RotateCcw", rte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ste = [
  ["path", { d: "M12 5H6a2 2 0 0 0-2 2v3", key: "l96uqu" }],
  ["path", { d: "m9 8 3-3-3-3", key: "1gzgc3" }],
  ["path", { d: "M4 14v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", key: "1w2k5h" }]
], cte = r("RotateCwSquare", ste);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fte = [
  ["path", { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8", key: "1p45f6" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }]
], dte = r("RotateCw", fte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lte = [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5c.4 0 .9-.1 1.3-.2", key: "1effex" }],
  ["path", { d: "M5.2 5.2A3.5 3.53 0 0 0 6.5 12H12", key: "k9y2ds" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M21 15.3a3.5 3.5 0 0 0-3.3-3.3", key: "11nlu2" }],
  ["path", { d: "M15 5h-4.3", key: "6537je" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
], ute = r("RouteOff", lte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hte = [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15", key: "1d8sl" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
], pte = r("Route", hte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yte = [
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6.01 18H6", key: "19vcac" }],
  ["path", { d: "M10.01 18H10", key: "uamcmx" }],
  ["path", { d: "M15 10v4", key: "qjz1xs" }],
  ["path", { d: "M17.84 7.17a4 4 0 0 0-5.66 0", key: "1rif40" }],
  ["path", { d: "M20.66 4.34a8 8 0 0 0-11.31 0", key: "6a5xfq" }]
], mte = r("Router", yte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kte = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }]
], gte = r("Rows2", kte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vte = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
], Mte = r("Rows3", vte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wte = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 7.5H3", key: "1hm9pq" }],
  ["path", { d: "M21 12H3", key: "2avoz0" }],
  ["path", { d: "M21 16.5H3", key: "n7jzkj" }]
], xte = r("Rows4", wte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cte = [
  ["path", { d: "M4 11a9 9 0 0 1 9 9", key: "pv89mb" }],
  ["path", { d: "M4 4a16 16 0 0 1 16 16", key: "k0647b" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
], bte = r("Rss", Cte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lte = [
  [
    "path",
    {
      d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z",
      key: "icamh8"
    }
  ],
  ["path", { d: "m14.5 12.5 2-2", key: "inckbg" }],
  ["path", { d: "m11.5 9.5 2-2", key: "fmmyf7" }],
  ["path", { d: "m8.5 6.5 2-2", key: "vc6u1g" }],
  ["path", { d: "m17.5 15.5 2-2", key: "wo5hmg" }]
], jte = r("Ruler", Lte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nte = [
  ["path", { d: "M6 11h8a4 4 0 0 0 0-8H9v18", key: "18ai8t" }],
  ["path", { d: "M6 15h8", key: "1y8f6l" }]
], Ate = r("RussianRuble", Nte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ste = [
  ["path", { d: "M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z", key: "1404fh" }],
  ["path", { d: "M21 14 10 2 3 14h18Z", key: "1nzg7v" }],
  ["path", { d: "M10 2v16", key: "1labyt" }]
], Ite = r("Sailboat", Ste);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tte = [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  [
    "path",
    {
      d: "M11.38 12a2.4 2.4 0 0 1-.4-4.77 2.4 2.4 0 0 1 3.2-2.77 2.4 2.4 0 0 1 3.47-.63 2.4 2.4 0 0 1 3.37 3.37 2.4 2.4 0 0 1-1.1 3.7 2.51 2.51 0 0 1 .03 1.1",
      key: "10xrj0"
    }
  ],
  ["path", { d: "m13 12 4-4", key: "1hckqy" }],
  ["path", { d: "M10.9 7.25A3.99 3.99 0 0 0 4 10c0 .73.2 1.41.54 2", key: "1p4srx" }]
], zte = r("Salad", Tte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dte = [
  ["path", { d: "m2.37 11.223 8.372-6.777a2 2 0 0 1 2.516 0l8.371 6.777", key: "f1wd0e" }],
  ["path", { d: "M21 15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5.25", key: "1pfu07" }],
  ["path", { d: "M3 15a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h9", key: "1oq9qw" }],
  ["path", { d: "m6.67 15 6.13 4.6a2 2 0 0 0 2.8-.4l3.15-4.2", key: "1fnwu5" }],
  ["rect", { width: "20", height: "4", x: "2", y: "11", rx: "1", key: "itshg" }]
], _te = r("Sandwich", Dte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pte = [
  ["path", { d: "M4 10a7.31 7.31 0 0 0 10 10Z", key: "1fzpp3" }],
  ["path", { d: "m9 15 3-3", key: "88sc13" }],
  ["path", { d: "M17 13a6 6 0 0 0-6-6", key: "15cc6u" }],
  ["path", { d: "M21 13A10 10 0 0 0 11 3", key: "11nf8s" }]
], Ete = r("SatelliteDish", Pte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rte = [
  ["path", { d: "M13 7 9 3 5 7l4 4", key: "vyckw6" }],
  ["path", { d: "m17 11 4 4-4 4-4-4", key: "rchckc" }],
  ["path", { d: "m8 12 4 4 6-6-4-4Z", key: "1sshf7" }],
  ["path", { d: "m16 8 3-3", key: "x428zp" }],
  ["path", { d: "M9 21a6 6 0 0 0-6-6", key: "1iajcf" }]
], Hte = r("Satellite", Rte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vte = [
  ["path", { d: "M10 2v3a1 1 0 0 0 1 1h5", key: "1xspal" }],
  ["path", { d: "M18 18v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6", key: "1ra60u" }],
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
  [
    "path",
    {
      d: "M8 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9.172a2 2 0 0 1 1.414.586l2.828 2.828A2 2 0 0 1 22 6.828V16a2 2 0 0 1-2.01 2z",
      key: "1yve0x"
    }
  ]
], Ote = r("SaveAll", Vte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qte = [
  ["path", { d: "M13 13H8a1 1 0 0 0-1 1v7", key: "h8g396" }],
  ["path", { d: "M14 8h1", key: "1lfen6" }],
  ["path", { d: "M17 21v-4", key: "1yknxs" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    { d: "M20.41 20.41A2 2 0 0 1 19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 .59-1.41", key: "1t4vdl" }
  ],
  ["path", { d: "M29.5 11.5s5 5 4 5", key: "zzn4i6" }],
  ["path", { d: "M9 3h6.2a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V15", key: "24cby9" }]
], Bte = r("SaveOff", qte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zte = [
  [
    "path",
    {
      d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
      key: "1c8476"
    }
  ],
  ["path", { d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7", key: "1ydtos" }],
  ["path", { d: "M7 3v4a1 1 0 0 0 1 1h7", key: "t51u73" }]
], Fte = r("Save", Zte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gte = [
  ["path", { d: "M5 7v11a1 1 0 0 0 1 1h11", key: "13dt1j" }],
  ["path", { d: "M5.293 18.707 11 13", key: "ezgbsx" }],
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }]
], $te = r("Scale3d", Gte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ute = [
  ["path", { d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "7g6ntu" }],
  ["path", { d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "ijws7r" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2", key: "3gwbw2" }]
], Wte = r("Scale", Ute);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yte = [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  ["path", { d: "M14 15H9v-5", key: "pi4jk9" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M21 3 9 15", key: "15kdhq" }]
], Qte = r("Scaling", Yte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jte = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 7v10", key: "23sfjj" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M17 7v10", key: "578dap" }]
], Kte = r("ScanBarcode", Jte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xte = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
      key: "11ak4c"
    }
  ]
], e1e = r("ScanEye", Xte);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t1e = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }]
], a1e = r("ScanFace", t1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n1e = [
  [
    "path",
    {
      d: "M11.246 16.657a1 1 0 0 0 1.508 0l3.57-4.101A2.75 2.75 0 1 0 12 9.168a2.75 2.75 0 1 0-4.324 3.388z",
      key: "1algrk"
    }
  ],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
], o1e = r("ScanHeart", n1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r1e = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }]
], i1e = r("ScanLine", r1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s1e = [
  ["path", { d: "M17 12v4a1 1 0 0 1-1 1h-4", key: "uk4fdo" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M17 8V7", key: "q2g9wo" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M7 17h.01", key: "19xn7k" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["rect", { x: "7", y: "7", width: "5", height: "5", rx: "1", key: "m9kyts" }]
], c1e = r("ScanQrCode", s1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f1e = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m16 16-1.9-1.9", key: "1dq9hf" }]
], d1e = r("ScanSearch", f1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l1e = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 8h8", key: "1jbsf9" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h6", key: "1vyc9m" }]
], u1e = r("ScanText", l1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h1e = [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
], p1e = r("Scan", h1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y1e = [
  ["path", { d: "M14 22v-4a2 2 0 1 0-4 0v4", key: "hhkicm" }],
  [
    "path",
    {
      d: "m18 10 3.447 1.724a1 1 0 0 1 .553.894V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7.382a1 1 0 0 1 .553-.894L6 10",
      key: "1xqip1"
    }
  ],
  ["path", { d: "M18 5v17", key: "1sw6gf" }],
  ["path", { d: "m4 6 7.106-3.553a2 2 0 0 1 1.788 0L20 6", key: "9d2mlk" }],
  ["path", { d: "M6 5v17", key: "1xfsm0" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }]
], m1e = r("School", y1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k1e = [
  ["path", { d: "M5.42 9.42 8 12", key: "12pkuq" }],
  ["circle", { cx: "4", cy: "8", r: "2", key: "107mxr" }],
  ["path", { d: "m14 6-8.58 8.58", key: "gvzu5l" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "M10.8 14.8 14 18", key: "ax7m9r" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
], g1e = r("ScissorsLineDashed", k1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v1e = [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M8.12 8.12 12 12", key: "1alkpv" }],
  ["path", { d: "M20 4 8.12 15.88", key: "xgtan2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M14.8 14.8 20 20", key: "ptml3r" }]
], M1e = r("Scissors", v1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w1e = [
  ["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3", key: "i8wdob" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
], x1e = r("ScreenShareOff", w1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C1e = [
  ["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3", key: "i8wdob" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m17 8 5-5", key: "fqif7o" }],
  ["path", { d: "M17 3h5v5", key: "1o3tu8" }]
], b1e = r("ScreenShare", C1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L1e = [
  ["path", { d: "M15 12h-5", key: "r7krc0" }],
  ["path", { d: "M15 8h-5", key: "1khuty" }],
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
      key: "1ph1d7"
    }
  ]
], j1e = r("ScrollText", L1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N1e = [
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
      key: "1ph1d7"
    }
  ]
], A1e = r("Scroll", N1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S1e = [
  ["path", { d: "m8 11 2 2 4-4", key: "1sed1v" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
], I1e = r("SearchCheck", S1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T1e = [
  ["path", { d: "m13 13.5 2-2.5-2-2.5", key: "1rvxrh" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ["path", { d: "M9 8.5 7 11l2 2.5", key: "6ffwbx" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], z1e = r("SearchCode", T1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D1e = [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
], _1e = r("SearchSlash", D1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P1e = [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["path", { d: "m8.5 8.5 5 5", key: "a8mexj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
], E1e = r("SearchX", P1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R1e = [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
], zd = r("Search", R1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H1e = [
  ["path", { d: "M16 5a4 3 0 0 0-8 0c0 4 8 3 8 7a4 3 0 0 1-8 0", key: "vqan6v" }],
  ["path", { d: "M8 19a4 3 0 0 0 8 0c0-4-8-3-8-7a4 3 0 0 1 8 0", key: "wdjd8o" }]
], V1e = r("Section", H1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O1e = [
  [
    "path",
    {
      d: "M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z",
      key: "117uat"
    }
  ],
  ["path", { d: "M6 12h16", key: "s4cdu5" }]
], q1e = r("SendHorizontal", O1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B1e = [
  ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
  ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }],
  ["path", { d: "M7 14v1a2 2 0 0 0 2 2h1", key: "pao6x6" }],
  ["path", { d: "M14 7h1a2 2 0 0 1 2 2v1", key: "19tdru" }]
], Z1e = r("SendToBack", B1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F1e = [
  [
    "path",
    {
      d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
      key: "1ffxy3"
    }
  ],
  ["path", { d: "m21.854 2.147-10.94 10.939", key: "12cjpa" }]
], G1e = r("Send", F1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $1e = [
  ["line", { x1: "3", x2: "21", y1: "12", y2: "12", key: "10d38w" }],
  ["polyline", { points: "8 8 12 4 16 8", key: "zo8t4w" }],
  ["polyline", { points: "16 16 12 20 8 16", key: "1oyrid" }]
], U1e = r("SeparatorHorizontal", $1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W1e = [
  ["line", { x1: "12", x2: "12", y1: "3", y2: "21", key: "1efggb" }],
  ["polyline", { points: "8 8 4 12 8 16", key: "bnfmv4" }],
  ["polyline", { points: "16 16 20 12 16 8", key: "u90052" }]
], Y1e = r("SeparatorVertical", W1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q1e = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5",
      key: "tn8das"
    }
  ],
  [
    "path",
    {
      d: "M4.5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5",
      key: "1g2pve"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m15.7 13.4-.9-.3", key: "1jwmzr" }],
  ["path", { d: "m9.2 10.9-.9-.3", key: "qapnim" }],
  ["path", { d: "m10.6 15.7.3-.9", key: "quwk0k" }],
  ["path", { d: "m13.6 15.7-.4-1", key: "cb9xp7" }],
  ["path", { d: "m10.8 9.3-.4-1", key: "1uaiz5" }],
  ["path", { d: "m8.3 13.6 1-.4", key: "s6srou" }],
  ["path", { d: "m14.7 10.8 1-.4", key: "4d31cq" }],
  ["path", { d: "m13.4 8.3-.3.9", key: "1bm987" }]
], J1e = r("ServerCog", Q1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K1e = [
  [
    "path",
    {
      d: "M6 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2",
      key: "4b9dqc"
    }
  ],
  [
    "path",
    {
      d: "M6 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2",
      key: "22nnkd"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m13 6-4 6h6l-4 6", key: "14hqih" }]
], X1e = r("ServerCrash", K1e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eae = [
  ["path", { d: "M7 2h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5", key: "bt2siv" }],
  ["path", { d: "M10 10 2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 0 0 2 2h6z", key: "1hjrv1" }],
  ["path", { d: "M22 17v-1a2 2 0 0 0-2-2h-1", key: "1iynyr" }],
  ["path", { d: "M4 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16.5l1-.5.5.5-8-8H4z", key: "161ggg" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], tae = r("ServerOff", eae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aae = [
  ["rect", { width: "20", height: "8", x: "2", y: "2", rx: "2", ry: "2", key: "ngkwjq" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", ry: "2", key: "iecqi9" }],
  ["line", { x1: "6", x2: "6.01", y1: "6", y2: "6", key: "16zg32" }],
  ["line", { x1: "6", x2: "6.01", y1: "18", y2: "18", key: "nzw8ys" }]
], nae = r("Server", aae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oae = [
  ["path", { d: "M20 7h-9", key: "3s1dr2" }],
  ["path", { d: "M14 17H5", key: "gfn3mx" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["circle", { cx: "7", cy: "7", r: "3", key: "dfmy0x" }]
], rae = r("Settings2", oae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iae = [
  [
    "path",
    {
      d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
      key: "1qme2f"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], sae = r("Settings", iae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cae = [
  [
    "path",
    {
      d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z",
      key: "1bo67w"
    }
  ],
  ["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1", key: "1bkyp8" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "3.5", key: "w3z12y" }]
], fae = r("Shapes", cae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dae = [
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
  ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
  ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
  ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
], lae = r("Share2", dae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uae = [
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["polyline", { points: "16 6 12 2 8 6", key: "m901s6" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "15", key: "1p0rca" }]
], hae = r("Share", uae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pae = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["line", { x1: "3", x2: "21", y1: "9", y2: "9", key: "1vqk6q" }],
  ["line", { x1: "3", x2: "21", y1: "15", y2: "15", key: "o2sbyz" }],
  ["line", { x1: "9", x2: "9", y1: "9", y2: "21", key: "1ib60c" }],
  ["line", { x1: "15", x2: "15", y1: "9", y2: "21", key: "1n26ft" }]
], yae = r("Sheet", pae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mae = [
  [
    "path",
    {
      d: "M14 11a2 2 0 1 1-4 0 4 4 0 0 1 8 0 6 6 0 0 1-12 0 8 8 0 0 1 16 0 10 10 0 1 1-20 0 11.93 11.93 0 0 1 2.42-7.22 2 2 0 1 1 3.16 2.44",
      key: "1cn552"
    }
  ]
], kae = r("Shell", mae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gae = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
], vae = r("ShieldAlert", gae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mae = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m4.243 5.21 14.39 12.472", key: "1c9a7c" }]
], wae = r("ShieldBan", Mae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xae = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], Cae = r("ShieldCheck", xae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bae = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
], Lae = r("ShieldEllipsis", bae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jae = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 22V2", key: "zs6s6o" }]
], Nae = r("ShieldHalf", jae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aae = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }]
], Sae = r("ShieldMinus", Aae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iae = [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71",
      key: "1jlk70"
    }
  ],
  [
    "path",
    {
      d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264",
      key: "18rp1v"
    }
  ]
], Tae = r("ShieldOff", Iae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zae = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M12 9v6", key: "199k2o" }]
], Dae = r("ShieldPlus", zae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ae = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], Pae = r("ShieldQuestion", _ae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eae = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }]
], Rae = r("ShieldX", Eae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hae = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ]
], Vae = r("Shield", Hae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oae = [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["path", { d: "M12 2v7.5", key: "1e5rl5" }],
  ["path", { d: "m19 5-5.23 5.23", key: "1ezxxf" }],
  ["path", { d: "M22 12h-7.5", key: "le1719" }],
  ["path", { d: "m19 19-5.23-5.23", key: "p3fmgn" }],
  ["path", { d: "M12 14.5V22", key: "dgcmos" }],
  ["path", { d: "M10.23 13.77 5 19", key: "qwopd4" }],
  ["path", { d: "M9.5 12H2", key: "r7bup8" }],
  ["path", { d: "M10.23 10.23 5 5", key: "k2y7lj" }],
  ["circle", { cx: "12", cy: "12", r: "2.5", key: "ix0uyj" }]
], qae = r("ShipWheel", Oae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bae = [
  ["path", { d: "M12 10.189V14", key: "1p8cqu" }],
  ["path", { d: "M12 2v3", key: "qbqxhf" }],
  ["path", { d: "M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6", key: "qpkstq" }],
  [
    "path",
    {
      d: "M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76",
      key: "7tigtc"
    }
  ],
  [
    "path",
    {
      d: "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "1924j5"
    }
  ]
], Zae = r("Ship", Bae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fae = [
  [
    "path",
    {
      d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z",
      key: "1wgbhj"
    }
  ]
], Gae = r("Shirt", Fae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $ae = [
  ["path", { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z", key: "hou9p0" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M16 10a4 4 0 0 1-8 0", key: "1ltviw" }]
], Uae = r("ShoppingBag", $ae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wae = [
  ["path", { d: "m15 11-1 9", key: "5wnq3a" }],
  ["path", { d: "m19 11-4-7", key: "cnml18" }],
  ["path", { d: "M2 11h20", key: "3eubbj" }],
  ["path", { d: "m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4", key: "yiazzp" }],
  ["path", { d: "M4.5 15.5h15", key: "13mye1" }],
  ["path", { d: "m5 11 4-7", key: "116ra9" }],
  ["path", { d: "m9 11 1 9", key: "1ojof7" }]
], Yae = r("ShoppingBasket", Wae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qae = [
  ["circle", { cx: "8", cy: "21", r: "1", key: "jimo8o" }],
  ["circle", { cx: "19", cy: "21", r: "1", key: "13723u" }],
  [
    "path",
    {
      d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
      key: "9zh506"
    }
  ]
], Jae = r("ShoppingCart", Qae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kae = [
  ["path", { d: "M2 22v-5l5-5 5 5-5 5z", key: "1fh25c" }],
  ["path", { d: "M9.5 14.5 16 8", key: "1smz5x" }],
  [
    "path",
    { d: "m17 2 5 5-.5.5a3.53 3.53 0 0 1-5 0s0 0 0 0a3.53 3.53 0 0 1 0-5L17 2", key: "1q8uv5" }
  ]
], Xae = r("Shovel", Kae);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ene = [
  ["path", { d: "m4 4 2.5 2.5", key: "uv2vmf" }],
  ["path", { d: "M13.5 6.5a4.95 4.95 0 0 0-7 7", key: "frdkwv" }],
  ["path", { d: "M15 5 5 15", key: "1ag8rq" }],
  ["path", { d: "M14 17v.01", key: "eokfpp" }],
  ["path", { d: "M10 16v.01", key: "14uyyl" }],
  ["path", { d: "M13 13v.01", key: "1v1k97" }],
  ["path", { d: "M16 10v.01", key: "5169yg" }],
  ["path", { d: "M11 20v.01", key: "cj92p8" }],
  ["path", { d: "M17 14v.01", key: "11cswd" }],
  ["path", { d: "M20 11v.01", key: "19e0od" }]
], tne = r("ShowerHead", ene);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ane = [
  ["path", { d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8", key: "17vawe" }],
  ["path", { d: "M9 19.8V15m0 0H4.2M9 15l-6 6", key: "chjx8e" }],
  ["path", { d: "M15 4.2V9m0 0h4.8M15 9l6-6", key: "lav6yq" }],
  ["path", { d: "M9 4.2V9m0 0H4.2M9 9 3 3", key: "1pxi2q" }]
], nne = r("Shrink", ane);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const one = [
  ["path", { d: "M12 22v-7l-2-2", key: "eqv9mc" }],
  ["path", { d: "M17 8v.8A6 6 0 0 1 13.8 20H10A6.5 6.5 0 0 1 7 8a5 5 0 0 1 10 0Z", key: "ubcgy" }],
  ["path", { d: "m14 14-2 2", key: "847xa2" }]
], rne = r("Shrub", one);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ine = [
  ["path", { d: "m18 14 4 4-4 4", key: "10pe0f" }],
  ["path", { d: "m18 2 4 4-4 4", key: "pucp1d" }],
  ["path", { d: "M2 18h1.973a4 4 0 0 0 3.3-1.7l5.454-8.6a4 4 0 0 1 3.3-1.7H22", key: "1ailkh" }],
  ["path", { d: "M2 6h1.972a4 4 0 0 1 3.6 2.2", key: "km57vx" }],
  ["path", { d: "M22 18h-6.041a4 4 0 0 1-3.3-1.8l-.359-.45", key: "os18l9" }]
], sne = r("Shuffle", ine);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cne = [
  [
    "path",
    {
      d: "M18 7V5a1 1 0 0 0-1-1H6.5a.5.5 0 0 0-.4.8l4.5 6a2 2 0 0 1 0 2.4l-4.5 6a.5.5 0 0 0 .4.8H17a1 1 0 0 0 1-1v-2",
      key: "wuwx1p"
    }
  ]
], fne = r("Sigma", cne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dne = [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }]
], lne = r("SignalHigh", dne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const une = [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }]
], hne = r("SignalLow", une);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pne = [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }]
], yne = r("SignalMedium", pne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mne = [["path", { d: "M2 20h.01", key: "4haj6o" }]], kne = r("SignalZero", mne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gne = [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }],
  ["path", { d: "M22 4v16", key: "sih9yq" }]
], vne = r("Signal", gne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mne = [
  [
    "path",
    {
      d: "m21 17-2.156-1.868A.5.5 0 0 0 18 15.5v.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1c0-2.545-3.991-3.97-8.5-4a1 1 0 0 0 0 5c4.153 0 4.745-11.295 5.708-13.5a2.5 2.5 0 1 1 3.31 3.284",
      key: "y32ogt"
    }
  ],
  ["path", { d: "M3 21h18", key: "itz85i" }]
], wne = r("Signature", Mne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xne = [
  ["path", { d: "M10 9H4L2 7l2-2h6", key: "1hq7x2" }],
  ["path", { d: "M14 5h6l2 2-2 2h-6", key: "bv62ej" }],
  ["path", { d: "M10 22V4a2 2 0 1 1 4 0v18", key: "eqpcf2" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }]
], Cne = r("SignpostBig", xne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bne = [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M12 3v3", key: "1n5kay" }],
  [
    "path",
    {
      d: "M18 6a2 2 0 0 1 1.387.56l2.307 2.22a1 1 0 0 1 0 1.44l-2.307 2.22A2 2 0 0 1 18 13H6a2 2 0 0 1-1.387-.56l-2.306-2.22a1 1 0 0 1 0-1.44l2.306-2.22A2 2 0 0 1 6 6z",
      key: "gqqp9m"
    }
  ]
], Lne = r("Signpost", bne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jne = [
  ["path", { d: "M7 18v-6a5 5 0 1 1 10 0v6", key: "pcx96s" }],
  [
    "path",
    { d: "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z", key: "1b4s83" }
  ],
  ["path", { d: "M21 12h1", key: "jtio3y" }],
  ["path", { d: "M18.5 4.5 18 5", key: "g5sp9y" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "m4.929 4.929.707.707", key: "1i51kw" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }]
], Nne = r("Siren", jne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ane = [
  ["polygon", { points: "19 20 9 12 19 4 19 20", key: "o2sva" }],
  ["line", { x1: "5", x2: "5", y1: "19", y2: "5", key: "1ocqjk" }]
], Sne = r("SkipBack", Ane);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ine = [
  ["polygon", { points: "5 4 15 12 5 20 5 4", key: "16p6eg" }],
  ["line", { x1: "19", x2: "19", y1: "5", y2: "19", key: "futhcm" }]
], Tne = r("SkipForward", Ine);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zne = [
  ["path", { d: "m12.5 17-.5-1-.5 1h1z", key: "3me087" }],
  [
    "path",
    {
      d: "M15 22a1 1 0 0 0 1-1v-1a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20v1a1 1 0 0 0 1 1z",
      key: "1o5pge"
    }
  ],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }]
], Dne = r("Skull", zne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ne = [
  ["rect", { width: "3", height: "8", x: "13", y: "2", rx: "1.5", key: "diqz80" }],
  ["path", { d: "M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5", key: "183iwg" }],
  ["rect", { width: "3", height: "8", x: "8", y: "14", rx: "1.5", key: "hqg7r1" }],
  ["path", { d: "M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5", key: "76g71w" }],
  ["rect", { width: "8", height: "3", x: "14", y: "13", rx: "1.5", key: "1kmz0a" }],
  ["path", { d: "M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5", key: "jc4sz0" }],
  ["rect", { width: "8", height: "3", x: "2", y: "8", rx: "1.5", key: "1omvl4" }],
  ["path", { d: "M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5", key: "16f3cl" }]
], Pne = r("Slack", _ne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ene = [["path", { d: "M22 2 2 22", key: "y4kqgn" }]], Rne = r("Slash", Ene);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hne = [
  [
    "path",
    {
      d: "M11 16.586V19a1 1 0 0 1-1 1H2L18.37 3.63a1 1 0 1 1 3 3l-9.663 9.663a1 1 0 0 1-1.414 0L8 14",
      key: "1sllp5"
    }
  ]
], Vne = r("Slice", Hne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const One = [
  ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
  ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
  ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
  ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
  ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
  ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }]
], qne = r("SlidersHorizontal", One);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bne = [
  ["line", { x1: "4", x2: "4", y1: "21", y2: "14", key: "1p332r" }],
  ["line", { x1: "4", x2: "4", y1: "10", y2: "3", key: "gb41h5" }],
  ["line", { x1: "12", x2: "12", y1: "21", y2: "12", key: "hf2csr" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "3", key: "1kfi7u" }],
  ["line", { x1: "20", x2: "20", y1: "21", y2: "16", key: "1lhrwl" }],
  ["line", { x1: "20", x2: "20", y1: "12", y2: "3", key: "16vvfq" }],
  ["line", { x1: "2", x2: "6", y1: "14", y2: "14", key: "1uebub" }],
  ["line", { x1: "10", x2: "14", y1: "8", y2: "8", key: "1yglbp" }],
  ["line", { x1: "18", x2: "22", y1: "16", y2: "16", key: "1jxqpz" }]
], Zne = r("SlidersVertical", Bne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fne = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12.667 8 10 12h4l-2.667 4", key: "h9lk2d" }]
], Gne = r("SmartphoneCharging", Fne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $ne = [
  ["rect", { width: "7", height: "12", x: "2", y: "6", rx: "1", key: "5nje8w" }],
  ["path", { d: "M13 8.32a7.43 7.43 0 0 1 0 7.36", key: "1g306n" }],
  ["path", { d: "M16.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "uqvjvo" }],
  ["path", { d: "M19.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "ujntz3" }]
], Une = r("SmartphoneNfc", $ne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wne = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
], Yne = r("Smartphone", Wne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qne = [
  ["path", { d: "M22 11v1a10 10 0 1 1-9-10", key: "ew0xw9" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }],
  ["path", { d: "M16 5h6", key: "1vod17" }],
  ["path", { d: "M19 2v6", key: "4bpg5p" }]
], Jne = r("SmilePlus", Qne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kne = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], Xne = r("Smile", Kne);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eoe = [
  ["path", { d: "M2 13a6 6 0 1 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0", key: "hneq2s" }],
  ["circle", { cx: "10", cy: "13", r: "8", key: "194lz3" }],
  ["path", { d: "M2 21h12c4.4 0 8-3.6 8-8V7a2 2 0 1 0-4 0v6", key: "ixqyt7" }],
  ["path", { d: "M18 3 19.1 5.2", key: "9tjm43" }],
  ["path", { d: "M22 3 20.9 5.2", key: "j3odrs" }]
], toe = r("Snail", eoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aoe = [
  ["path", { d: "m10 20-1.25-2.5L6 18", key: "18frcb" }],
  ["path", { d: "M10 4 8.75 6.5 6 6", key: "7mghy3" }],
  ["path", { d: "m14 20 1.25-2.5L18 18", key: "1chtki" }],
  ["path", { d: "m14 4 1.25 2.5L18 6", key: "1b4wsy" }],
  ["path", { d: "m17 21-3-6h-4", key: "15hhxa" }],
  ["path", { d: "m17 3-3 6 1.5 3", key: "11697g" }],
  ["path", { d: "M2 12h6.5L10 9", key: "kv9z4n" }],
  ["path", { d: "m20 10-1.5 2 1.5 2", key: "1swlpi" }],
  ["path", { d: "M22 12h-6.5L14 15", key: "1mxi28" }],
  ["path", { d: "m4 10 1.5 2L4 14", key: "k9enpj" }],
  ["path", { d: "m7 21 3-6-1.5-3", key: "j8hb9u" }],
  ["path", { d: "m7 3 3 6h4", key: "1otusx" }]
], noe = r("Snowflake", aoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ooe = [
  ["path", { d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3", key: "1dgpiv" }],
  [
    "path",
    {
      d: "M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
      key: "xacw8m"
    }
  ],
  ["path", { d: "M4 18v2", key: "jwo5n2" }],
  ["path", { d: "M20 18v2", key: "1ar1qi" }],
  ["path", { d: "M12 4v9", key: "oqhhn3" }]
], roe = r("Sofa", ooe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ioe = [
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M19.5 12 22 6", key: "shfsr5" }],
  [
    "path",
    {
      d: "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62",
      key: "rpc6vp"
    }
  ],
  [
    "path",
    {
      d: "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62",
      key: "1lf63m"
    }
  ],
  [
    "path",
    { d: "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62", key: "97tijn" }
  ]
], soe = r("Soup", ioe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const coe = [
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
], foe = r("Space", coe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const doe = [
  [
    "path",
    {
      d: "M5 9c-1.5 1.5-3 3.2-3 5.5A5.5 5.5 0 0 0 7.5 20c1.8 0 3-.5 4.5-2 1.5 1.5 2.7 2 4.5 2a5.5 5.5 0 0 0 5.5-5.5c0-2.3-1.5-4-3-5.5l-7-7-7 7Z",
      key: "40bo9n"
    }
  ],
  ["path", { d: "M12 18v4", key: "jadmvz" }]
], loe = r("Spade", doe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uoe = [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ]
], hoe = r("Sparkle", uoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const poe = [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }],
  ["path", { d: "M4 17v2", key: "vumght" }],
  ["path", { d: "M5 18H3", key: "zchphs" }]
], yoe = r("Sparkles", poe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const moe = [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["circle", { cx: "12", cy: "14", r: "4", key: "1jruaj" }],
  ["path", { d: "M12 14h.01", key: "1etili" }]
], koe = r("Speaker", moe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const goe = [
  [
    "path",
    {
      d: "M8.8 20v-4.1l1.9.2a2.3 2.3 0 0 0 2.164-2.1V8.3A5.37 5.37 0 0 0 2 8.25c0 2.8.656 3.054 1 4.55a5.77 5.77 0 0 1 .029 2.758L2 20",
      key: "11atix"
    }
  ],
  ["path", { d: "M19.8 17.8a7.5 7.5 0 0 0 .003-10.603", key: "yol142" }],
  ["path", { d: "M17 15a3.5 3.5 0 0 0-.025-4.975", key: "ssbmkc" }]
], voe = r("Speech", goe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Moe = [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  [
    "path",
    {
      d: "M4 21c1.1 0 1.1-1 2.3-1s1.1 1 2.3 1c1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1",
      key: "8mdmtu"
    }
  ]
], woe = r("SpellCheck2", Moe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xoe = [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
], Coe = r("SpellCheck", xoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const boe = [
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M5 17A12 12 0 0 1 17 5", key: "1okkup" }]
], Loe = r("Spline", boe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const joe = [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M8 3H3v5", key: "15dfkv" }],
  ["path", { d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3", key: "1qrqzj" }],
  ["path", { d: "m15 9 6-6", key: "ko1vev" }]
], Noe = r("Split", joe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aoe = [
  ["path", { d: "M3 3h.01", key: "159qn6" }],
  ["path", { d: "M7 5h.01", key: "1hq22a" }],
  ["path", { d: "M11 7h.01", key: "1osv80" }],
  ["path", { d: "M3 7h.01", key: "1xzrh3" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }],
  ["path", { d: "M3 11h.01", key: "1eifu7" }],
  ["rect", { width: "4", height: "4", x: "15", y: "5", key: "mri9e4" }],
  ["path", { d: "m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2", key: "aib6hk" }],
  ["path", { d: "m13 14 8-2", key: "1d7bmk" }],
  ["path", { d: "m13 19 8-2", key: "1y2vml" }]
], Soe = r("SprayCan", Aoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ioe = [
  ["path", { d: "M7 20h10", key: "e6iznv" }],
  ["path", { d: "M10 20c5.5-2.5.8-6.4 3-10", key: "161w41" }],
  [
    "path",
    {
      d: "M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z",
      key: "9gtqwd"
    }
  ],
  [
    "path",
    {
      d: "M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z",
      key: "bkxnd2"
    }
  ]
], Toe = r("Sprout", Ioe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zoe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M17 12h-2l-2 5-2-10-2 5H7", key: "15hlnc" }]
], Doe = r("SquareActivity", zoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _oe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 8-8 8", key: "166keh" }],
  ["path", { d: "M16 16H8V8", key: "1w2ppm" }]
], Poe = r("SquareArrowDownLeft", _oe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eoe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "M16 8v8H8", key: "1lbpgo" }]
], Roe = r("SquareArrowDownRight", Eoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hoe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
], Voe = r("SquareArrowDown", Hoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ooe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }]
], qoe = r("SquareArrowLeft", Ooe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Boe = [
  ["path", { d: "M13 21h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6", key: "14qz4y" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
], Zoe = r("SquareArrowOutDownLeft", Boe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Foe = [
  ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "14rsvq" }],
  ["path", { d: "m21 21-9-9", key: "1et2py" }],
  ["path", { d: "M21 15v6h-6", key: "1jko0i" }]
], Goe = r("SquareArrowOutDownRight", Foe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $oe = [
  ["path", { d: "M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6", key: "14mv1t" }],
  ["path", { d: "m3 3 9 9", key: "rks13r" }],
  ["path", { d: "M3 9V3h6", key: "ira0h2" }]
], Uoe = r("SquareArrowOutUpLeft", $oe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Woe = [
  ["path", { d: "M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6", key: "y09zxi" }],
  ["path", { d: "m21 3-9 9", key: "mpx6sq" }],
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }]
], Yoe = r("SquareArrowOutUpRight", Woe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qoe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
], Joe = r("SquareArrowRight", Qoe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Koe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 16V8h8", key: "19xb1h" }],
  ["path", { d: "M16 16 8 8", key: "1qdy8n" }]
], Xoe = r("SquareArrowUpLeft", Koe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ere = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 8h8v8", key: "b65dnt" }],
  ["path", { d: "m8 16 8-8", key: "13b9ih" }]
], tre = r("SquareArrowUpRight", ere);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const are = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
], nre = r("SquareArrowUp", are);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ore = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8.5 14 7-4", key: "12hpby" }],
  ["path", { d: "m8.5 10 7 4", key: "wwy2dy" }]
], rre = r("SquareAsterisk", ore);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ire = [
  [
    "path",
    { d: "M4 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2", key: "1vzg26" }
  ],
  ["path", { d: "M10 22H8", key: "euku7a" }],
  ["path", { d: "M16 22h-2", key: "18d249" }],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
], sre = r("SquareBottomDashedScissors", ire);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cre = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 8h7", key: "kbo1nt" }],
  ["path", { d: "M8 12h6", key: "ikassy" }],
  ["path", { d: "M11 16h5", key: "oq65wt" }]
], fre = r("SquareChartGantt", cre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dre = [
  ["path", { d: "M21 10.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.5", key: "1uzm8b" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
], lre = r("SquareCheckBig", dre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ure = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], hre = r("SquareCheck", ure);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pre = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
], yre = r("SquareChevronDown", pre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mre = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
], kre = r("SquareChevronLeft", mre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gre = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
], vre = r("SquareChevronRight", gre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mre = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
], wre = r("SquareChevronUp", Mre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xre = [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
], Cre = r("SquareCode", xre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bre = [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  [
    "path",
    { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2", key: "as5y1o" }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }]
], Lre = r("SquareDashedBottomCode", bre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jre = [
  [
    "path",
    { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2", key: "as5y1o" }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }]
], Nre = r("SquareDashedBottom", jre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Are = [
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }]
], Sre = r("SquareDashedKanban", Are);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ire = [
  [
    "path",
    {
      d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
      key: "xwnzip"
    }
  ],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h2", key: "1qve2z" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v2", key: "p14lih" }],
  ["path", { d: "M3 14v1", key: "vnatye" }]
], Tre = r("SquareDashedMousePointer", Ire);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zre = [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }]
], Dre = r("SquareDashed", zre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _re = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }]
], Pre = r("SquareDivide", _re);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ere = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
], Rre = r("SquareDot", Ere);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hre = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }]
], Vre = r("SquareEqual", Hre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ore = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3", key: "m1af9g" }],
  ["path", { d: "M9 11.2h5.7", key: "3zgcl2" }]
], qre = r("SquareFunction", Ore);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bre = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }]
], Zre = r("SquareKanban", Bre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fre = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7v10", key: "d5nglc" }],
  ["path", { d: "M11 7v10", key: "pptsnr" }],
  ["path", { d: "m15 7 2 10", key: "1m7qm5" }]
], Gre = r("SquareLibrary", Fre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $re = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 16V8l4 4 4-4v8", key: "141u4e" }]
], Ure = r("SquareM", $re);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wre = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 8h10", key: "1jw688" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h10", key: "wp8him" }]
], Yre = r("SquareMenu", Wre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qre = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], Jre = r("SquareMinus", Qre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kre = [
  [
    "path",
    {
      d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
      key: "xwnzip"
    }
  ],
  ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "14rsvq" }]
], Xre = r("SquareMousePointer", Kre);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e2e = [
  ["path", { d: "M3.6 3.6A2 2 0 0 1 5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-.59 1.41", key: "9l1ft6" }],
  ["path", { d: "M3 8.7V19a2 2 0 0 0 2 2h10.3", key: "17knke" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.3", key: "1jxgo2" }]
], t2e = r("SquareParkingOff", e2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a2e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
], n2e = r("SquareParking", a2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o2e = [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  [
    "path",
    {
      d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
      key: "ohrbg2"
    }
  ]
], r2e = r("SquarePen", o2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i2e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
], s2e = r("SquarePercent", i2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c2e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7h10", key: "udp07y" }],
  ["path", { d: "M10 7v10", key: "i1d9ee" }],
  ["path", { d: "M16 17a2 2 0 0 1-2-2V7", key: "ftwdc7" }]
], f2e = r("SquarePi", c2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d2e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 12H9.5a2.5 2.5 0 0 1 0-5H17", key: "1l9586" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M16 7v10", key: "lavkr4" }]
], l2e = r("SquarePilcrow", d2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u2e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m9 8 6 4-6 4Z", key: "f1r3lt" }]
], h2e = r("SquarePlay", u2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p2e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
], y2e = r("SquarePlus", p2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m2e = [
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005", key: "1pek45" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
], k2e = r("SquarePower", m2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g2e = [
  ["path", { d: "M7 12h2l2 5 2-10h4", key: "1fxv6h" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
], v2e = r("SquareRadical", g2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M2e = [
  ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "2", key: "1btzen" }],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
], w2e = r("SquareScissors", M2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x2e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M16 8.9V7H8l4 5-4 5h8v-1.9", key: "9nih0i" }]
], C2e = r("SquareSigma", x2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b2e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }]
], L2e = r("SquareSlash", b2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j2e = [
  ["path", { d: "M8 19H5c-1 0-2-1-2-2V7c0-1 1-2 2-2h3", key: "lubmu8" }],
  ["path", { d: "M16 5h3c1 0 2 1 2 2v10c0 1-1 2-2 2h-3", key: "1ag34g" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
], N2e = r("SquareSplitHorizontal", j2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A2e = [
  ["path", { d: "M5 8V5c0-1 1-2 2-2h10c1 0 2 1 2 2v3", key: "1pi83i" }],
  ["path", { d: "M19 16v3c0 1-1 2-2 2H7c-1 0-2-1-2-2v-3", key: "ido5k7" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
], S2e = r("SquareSplitVertical", A2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I2e = [
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }],
  ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "1", key: "z9xiuo" }]
], T2e = r("SquareSquare", I2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z2e = [
  ["path", { d: "M4 10c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2", key: "4i38lg" }],
  ["path", { d: "M10 16c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2", key: "mlte4a" }],
  ["rect", { width: "8", height: "8", x: "14", y: "14", rx: "2", key: "1fa9i4" }]
], D2e = r("SquareStack", z2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _2e = [
  ["path", { d: "m7 11 2-2-2-2", key: "1lz0vl" }],
  ["path", { d: "M11 13h4", key: "1p7l4v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }]
], P2e = r("SquareTerminal", _2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E2e = [
  ["path", { d: "M18 21a6 6 0 0 0-12 0", key: "kaz2du" }],
  ["circle", { cx: "12", cy: "11", r: "4", key: "1gt34v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
], R2e = r("SquareUserRound", E2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H2e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", key: "1m6ac2" }]
], V2e = r("SquareUser", H2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O2e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], q2e = r("SquareX", O2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B2e = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
], Z2e = r("Square", B2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F2e = [
  ["path", { d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9-9 9-9-1.8-9-9 1.8-9 9-9", key: "garfkc" }]
], G2e = r("Squircle", F2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $2e = [
  ["path", { d: "M15.236 22a3 3 0 0 0-2.2-5", key: "21bitc" }],
  ["path", { d: "M16 20a3 3 0 0 1 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4", key: "oh0fg0" }],
  ["path", { d: "M18 13h.01", key: "9veqaj" }],
  [
    "path",
    {
      d: "M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10",
      key: "980v8a"
    }
  ]
], U2e = r("Squirrel", $2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W2e = [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  [
    "path",
    {
      d: "M19.27 13.73A2.5 2.5 0 0 0 17.5 13h-11A2.5 2.5 0 0 0 4 15.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5c0-.66-.26-1.3-.73-1.77Z",
      key: "1sy9ra"
    }
  ],
  [
    "path",
    { d: "M14 13V8.5C14 7 15 7 15 5a3 3 0 0 0-3-3c-1.66 0-3 1-3 3s1 2 1 3.5V13", key: "cnxgux" }
  ]
], Y2e = r("Stamp", W2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q2e = [
  [
    "path",
    {
      d: "M12 18.338a2.1 2.1 0 0 0-.987.244L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16l2.309-4.679A.53.53 0 0 1 12 2",
      key: "2ksp49"
    }
  ]
], J2e = r("StarHalf", Q2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K2e = [
  ["path", { d: "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43", key: "16m0ql" }],
  ["path", { d: "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91", key: "1vt8nq" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], X2e = r("StarOff", K2e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eie = [
  [
    "path",
    {
      d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
      key: "r04s7s"
    }
  ]
], tie = r("Star", eie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aie = [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["polygon", { points: "14,20 4,12 14,4", key: "ypakod" }]
], nie = r("StepBack", aie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oie = [
  ["line", { x1: "6", x2: "6", y1: "4", y2: "20", key: "fy8qot" }],
  ["polygon", { points: "10,4 20,12 10,20", key: "1mc1pf" }]
], rie = r("StepForward", oie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iie = [
  ["path", { d: "M11 2v2", key: "1539x4" }],
  ["path", { d: "M5 2v2", key: "1yf1q8" }],
  ["path", { d: "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1", key: "rb5t3r" }],
  ["path", { d: "M8 15a6 6 0 0 0 12 0v-3", key: "x18d4x" }],
  ["circle", { cx: "20", cy: "10", r: "2", key: "ts1r5v" }]
], sie = r("Stethoscope", iie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cie = [
  [
    "path",
    { d: "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z", key: "1wis1t" }
  ],
  ["path", { d: "M14 3v4a2 2 0 0 0 2 2h4", key: "36rjfy" }],
  ["path", { d: "M8 13h.01", key: "1sbv64" }],
  ["path", { d: "M16 13h.01", key: "wip0gl" }],
  ["path", { d: "M10 16s.8 1 2 1c1.3 0 2-1 2-1", key: "1vvgv3" }]
], fie = r("Sticker", cie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const die = [
  ["path", { d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z", key: "qazsjp" }],
  ["path", { d: "M15 3v4a2 2 0 0 0 2 2h4", key: "40519r" }]
], lie = r("StickyNote", die);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uie = [
  ["path", { d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7", key: "ztvudi" }],
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["path", { d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4", key: "2ebpfo" }],
  ["path", { d: "M2 7h20", key: "1fcdvo" }],
  [
    "path",
    {
      d: "M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7",
      key: "6c3vgh"
    }
  ]
], hie = r("Store", uie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pie = [
  ["rect", { width: "20", height: "6", x: "2", y: "4", rx: "2", key: "qdearl" }],
  ["rect", { width: "20", height: "6", x: "2", y: "14", rx: "2", key: "1xrn6j" }]
], yie = r("StretchHorizontal", pie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mie = [
  ["rect", { width: "6", height: "20", x: "4", y: "2", rx: "2", key: "19qu7m" }],
  ["rect", { width: "6", height: "20", x: "14", y: "2", rx: "2", key: "24v0nk" }]
], kie = r("StretchVertical", mie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gie = [
  ["path", { d: "M16 4H9a3 3 0 0 0-2.83 4", key: "43sutm" }],
  ["path", { d: "M14 12a4 4 0 0 1 0 8H6", key: "nlfj13" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
], vie = r("Strikethrough", gie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mie = [
  ["path", { d: "m4 5 8 8", key: "1eunvl" }],
  ["path", { d: "m12 5-8 8", key: "1ah0jp" }],
  [
    "path",
    {
      d: "M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07",
      key: "e8ta8j"
    }
  ]
], wie = r("Subscript", Mie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xie = [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M20 12h.01", key: "1ykeid" }],
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M4 12h.01", key: "158zrr" }],
  ["path", { d: "M17.657 6.343h.01", key: "31pqzk" }],
  ["path", { d: "M17.657 17.657h.01", key: "jehnf4" }],
  ["path", { d: "M6.343 17.657h.01", key: "gdk6ow" }],
  ["path", { d: "M6.343 6.343h.01", key: "1uurf0" }]
], Cie = r("SunDim", xie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bie = [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 3v1", key: "1asbbs" }],
  ["path", { d: "M12 20v1", key: "1wcdkc" }],
  ["path", { d: "M3 12h1", key: "lp3yf2" }],
  ["path", { d: "M20 12h1", key: "1vloll" }],
  ["path", { d: "m18.364 5.636-.707.707", key: "1hakh0" }],
  ["path", { d: "m6.343 17.657-.707.707", key: "18m9nf" }],
  ["path", { d: "m5.636 5.636.707.707", key: "1xv1c5" }],
  ["path", { d: "m17.657 17.657.707.707", key: "vl76zb" }]
], Lie = r("SunMedium", bie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jie = [
  ["path", { d: "M12 8a2.83 2.83 0 0 0 4 4 4 4 0 1 1-4-4", key: "1fu5g2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.9 4.9 1.4 1.4", key: "b9915j" }],
  ["path", { d: "m17.7 17.7 1.4 1.4", key: "qc3ed3" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.3 17.7-1.4 1.4", key: "5gca6" }],
  ["path", { d: "m19.1 4.9-1.4 1.4", key: "wpu9u6" }]
], Nie = r("SunMoon", jie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aie = [
  ["path", { d: "M10 21v-1", key: "1u8rkd" }],
  ["path", { d: "M10 4V3", key: "pkzwkn" }],
  ["path", { d: "M10 9a3 3 0 0 0 0 6", key: "gv75dk" }],
  ["path", { d: "m14 20 1.25-2.5L18 18", key: "1chtki" }],
  ["path", { d: "m14 4 1.25 2.5L18 6", key: "1b4wsy" }],
  ["path", { d: "m17 21-3-6 1.5-3H22", key: "o5qa3v" }],
  ["path", { d: "m17 3-3 6 1.5 3", key: "11697g" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "m20 10-1.5 2 1.5 2", key: "1swlpi" }],
  ["path", { d: "m3.64 18.36.7-.7", key: "105rm9" }],
  ["path", { d: "m4.34 6.34-.7-.7", key: "d3unjp" }]
], Sie = r("SunSnow", Aie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iie = [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
], Tie = r("Sun", Iie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zie = [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
], Die = r("Sunrise", zie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ie = [
  ["path", { d: "M12 10V2", key: "16sf7g" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
], Pie = r("Sunset", _ie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eie = [
  ["path", { d: "m4 19 8-8", key: "hr47gm" }],
  ["path", { d: "m12 19-8-8", key: "1dhhmo" }],
  [
    "path",
    {
      d: "M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06",
      key: "1dfcux"
    }
  ]
], Rie = r("Superscript", Eie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hie = [
  ["path", { d: "M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z", key: "1ldrpk" }],
  ["path", { d: "M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7", key: "11i5po" }],
  ["path", { d: "M 7 17h.01", key: "1euzgo" }],
  [
    "path",
    {
      d: "m11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8",
      key: "o2gii7"
    }
  ]
], Vie = r("SwatchBook", Hie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oie = [
  ["path", { d: "M10 21V3h8", key: "br2l0g" }],
  ["path", { d: "M6 16h9", key: "2py0wn" }],
  ["path", { d: "M10 9.5h7", key: "13dmhz" }]
], qie = r("SwissFranc", Oie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bie = [
  ["path", { d: "M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5", key: "mtk2lu" }],
  ["path", { d: "M13 5h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5", key: "120jsl" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m18 22-3-3 3-3", key: "kgdoj7" }],
  ["path", { d: "m6 2 3 3-3 3", key: "1fnbkv" }]
], Zie = r("SwitchCamera", Bie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fie = [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }]
], Gie = r("Sword", Fie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $ie = [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }],
  ["polyline", { points: "14.5 6.5 18 3 21 3 21 6 17.5 9.5", key: "hbey2j" }],
  ["line", { x1: "5", x2: "9", y1: "14", y2: "18", key: "1hf58s" }],
  ["line", { x1: "7", x2: "4", y1: "17", y2: "20", key: "pidxm4" }],
  ["line", { x1: "3", x2: "5", y1: "19", y2: "21", key: "1pehsh" }]
], Uie = r("Swords", $ie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wie = [
  ["path", { d: "m18 2 4 4", key: "22kx64" }],
  ["path", { d: "m17 7 3-3", key: "1w1zoj" }],
  ["path", { d: "M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5", key: "1exhtz" }],
  ["path", { d: "m9 11 4 4", key: "rovt3i" }],
  ["path", { d: "m5 19-3 3", key: "59f2uf" }],
  ["path", { d: "m14 4 6 6", key: "yqp9t2" }]
], Yie = r("Syringe", Wie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qie = [
  [
    "path",
    {
      d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18",
      key: "gugj83"
    }
  ]
], Jie = r("Table2", Qie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kie = [
  ["path", { d: "M12 21v-6", key: "lihzve" }],
  ["path", { d: "M12 9V3", key: "da5inc" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
], Xie = r("TableCellsMerge", Kie);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e0e = [
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
], t0e = r("TableCellsSplit", e0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a0e = [
  ["path", { d: "M14 14v2", key: "w2a1xv" }],
  ["path", { d: "M14 20v2", key: "1lq872" }],
  ["path", { d: "M14 2v2", key: "6buw04" }],
  ["path", { d: "M14 8v2", key: "i67w9a" }],
  ["path", { d: "M2 15h8", key: "82wtch" }],
  ["path", { d: "M2 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2", key: "up0l64" }],
  ["path", { d: "M2 9h8", key: "yelfik" }],
  ["path", { d: "M22 15h-4", key: "1es58f" }],
  ["path", { d: "M22 3h-2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2", key: "pdjoqf" }],
  ["path", { d: "M22 9h-4", key: "1luja7" }],
  ["path", { d: "M5 3v18", key: "14hmio" }]
], n0e = r("TableColumnsSplit", a0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o0e = [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M21 12h.01", key: "msek7k" }],
  ["path", { d: "M21 18h.01", key: "1e8rq1" }],
  ["path", { d: "M21 6h.01", key: "1koanj" }]
], r0e = r("TableOfContents", o0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i0e = [
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
], s0e = r("TableProperties", i0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c0e = [
  ["path", { d: "M14 10h2", key: "1lstlu" }],
  ["path", { d: "M15 22v-8", key: "1fwwgm" }],
  ["path", { d: "M15 2v4", key: "1044rn" }],
  ["path", { d: "M2 10h2", key: "1r8dkt" }],
  ["path", { d: "M20 10h2", key: "1ug425" }],
  ["path", { d: "M3 19h18", key: "awlh7x" }],
  ["path", { d: "M3 22v-6a2 2 135 0 1 2-2h14a2 2 45 0 1 2 2v6", key: "ibqhof" }],
  ["path", { d: "M3 2v2a2 2 45 0 0 2 2h14a2 2 135 0 0 2-2V2", key: "1uenja" }],
  ["path", { d: "M8 10h2", key: "66od0" }],
  ["path", { d: "M9 22v-8", key: "fmnu31" }],
  ["path", { d: "M9 2v4", key: "j1yeou" }]
], f0e = r("TableRowsSplit", c0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d0e = [
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
], l0e = r("Table", d0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u0e = [
  ["rect", { width: "10", height: "14", x: "3", y: "8", rx: "2", key: "1vrsiq" }],
  ["path", { d: "M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4", key: "1j4zmg" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
], h0e = r("TabletSmartphone", u0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p0e = [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["line", { x1: "12", x2: "12.01", y1: "18", y2: "18", key: "1dp563" }]
], y0e = r("Tablet", p0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m0e = [
  ["circle", { cx: "7", cy: "7", r: "5", key: "x29byf" }],
  ["circle", { cx: "17", cy: "17", r: "5", key: "1op1d2" }],
  ["path", { d: "M12 17h10", key: "ls21zv" }],
  ["path", { d: "m3.46 10.54 7.08-7.08", key: "1rehiu" }]
], k0e = r("Tablets", m0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g0e = [
  [
    "path",
    {
      d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
      key: "vktsd0"
    }
  ],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }]
], v0e = r("Tag", g0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M0e = [
  ["path", { d: "m15 5 6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19", key: "1cbfv1" }],
  [
    "path",
    {
      d: "M9.586 5.586A2 2 0 0 0 8.172 5H3a1 1 0 0 0-1 1v5.172a2 2 0 0 0 .586 1.414L8.29 18.29a2.426 2.426 0 0 0 3.42 0l3.58-3.58a2.426 2.426 0 0 0 0-3.42z",
      key: "135mg7"
    }
  ],
  ["circle", { cx: "6.5", cy: "9.5", r: ".5", fill: "currentColor", key: "5pm5xn" }]
], w0e = r("Tags", M0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x0e = [["path", { d: "M4 4v16", key: "6qkkli" }]], C0e = r("Tally1", x0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b0e = [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }]
], L0e = r("Tally2", b0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j0e = [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }]
], N0e = r("Tally3", j0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A0e = [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }]
], S0e = r("Tally4", A0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I0e = [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }],
  ["path", { d: "M22 6 2 18", key: "h9moai" }]
], T0e = r("Tally5", I0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z0e = [
  ["circle", { cx: "17", cy: "4", r: "2", key: "y5j2s2" }],
  ["path", { d: "M15.59 5.41 5.41 15.59", key: "l0vprr" }],
  ["circle", { cx: "4", cy: "17", r: "2", key: "9p4efm" }],
  ["path", { d: "M12 22s-4-9-1.5-11.5S22 12 22 12", key: "1twk4o" }]
], D0e = r("Tangent", z0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _0e = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
], P0e = r("Target", _0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E0e = [
  [
    "path",
    {
      d: "m10.065 12.493-6.18 1.318a.934.934 0 0 1-1.108-.702l-.537-2.15a1.07 1.07 0 0 1 .691-1.265l13.504-4.44",
      key: "k4qptu"
    }
  ],
  ["path", { d: "m13.56 11.747 4.332-.924", key: "19l80z" }],
  ["path", { d: "m16 21-3.105-6.21", key: "7oh9d" }],
  [
    "path",
    {
      d: "M16.485 5.94a2 2 0 0 1 1.455-2.425l1.09-.272a1 1 0 0 1 1.212.727l1.515 6.06a1 1 0 0 1-.727 1.213l-1.09.272a2 2 0 0 1-2.425-1.455z",
      key: "m7xp4m"
    }
  ],
  ["path", { d: "m6.158 8.633 1.114 4.456", key: "74o979" }],
  ["path", { d: "m8 21 3.105-6.21", key: "1fvxut" }],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }]
], R0e = r("Telescope", E0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H0e = [
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }],
  ["path", { d: "m14 5 3-3 3 3", key: "1sorif" }],
  ["path", { d: "m14 10 3-3 3 3", key: "1jyi9h" }],
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  ["path", { d: "M17 14H7l-5 8h20Z", key: "13ar7p" }],
  ["path", { d: "M8 14v8", key: "1ghmqk" }],
  ["path", { d: "m9 14 5 8", key: "13pgi6" }]
], V0e = r("TentTree", H0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O0e = [
  ["path", { d: "M3.5 21 14 3", key: "1szst5" }],
  ["path", { d: "M20.5 21 10 3", key: "1310c3" }],
  ["path", { d: "M15.5 21 12 15l-3.5 6", key: "1ddtfw" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }]
], q0e = r("Tent", O0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B0e = [
  ["polyline", { points: "4 17 10 11 4 5", key: "akl6gq" }],
  ["line", { x1: "12", x2: "20", y1: "19", y2: "19", key: "q2wloq" }]
], Z0e = r("Terminal", B0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F0e = [
  [
    "path",
    { d: "M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01a2.83 2.83 0 0 1 0-4L17 3", key: "1ub6xw" }
  ],
  ["path", { d: "m16 2 6 6", key: "1gw87d" }],
  ["path", { d: "M12 16H4", key: "1cjfip" }]
], G0e = r("TestTubeDiagonal", F0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $0e = [
  ["path", { d: "M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5c-1.4 0-2.5-1.1-2.5-2.5V2", key: "125lnx" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M14.5 16h-5", key: "1ox875" }]
], U0e = r("TestTube", $0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W0e = [
  ["path", { d: "M9 2v17.5A2.5 2.5 0 0 1 6.5 22A2.5 2.5 0 0 1 4 19.5V2", key: "1hjrqt" }],
  ["path", { d: "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5V2", key: "16lc8n" }],
  ["path", { d: "M3 2h7", key: "7s29d5" }],
  ["path", { d: "M14 2h7", key: "7sicin" }],
  ["path", { d: "M9 16H4", key: "1bfye3" }],
  ["path", { d: "M20 16h-5", key: "ddnjpe" }]
], Y0e = r("TestTubes", W0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q0e = [
  ["path", { d: "M5 4h1a3 3 0 0 1 3 3 3 3 0 0 1 3-3h1", key: "18xjzo" }],
  ["path", { d: "M13 20h-1a3 3 0 0 1-3-3 3 3 0 0 1-3 3H5", key: "fj48gi" }],
  ["path", { d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1", key: "1n9rhb" }],
  ["path", { d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7", key: "13ksps" }],
  ["path", { d: "M9 7v10", key: "1vc8ob" }]
], J0e = r("TextCursorInput", Q0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K0e = [
  ["path", { d: "M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1", key: "uvaxm9" }],
  ["path", { d: "M7 22h1a4 4 0 0 0 4-4v-1", key: "11xy8d" }],
  ["path", { d: "M7 2h1a4 4 0 0 1 4 4v1", key: "1uw06m" }]
], X0e = r("TextCursor", K0e);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ese = [
  ["path", { d: "M17 6H3", key: "16j9eg" }],
  ["path", { d: "M21 12H8", key: "scolzb" }],
  ["path", { d: "M21 18H8", key: "1wfozv" }],
  ["path", { d: "M3 12v6", key: "fv4c87" }]
], tse = r("TextQuote", ese);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ase = [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M10 12H3", key: "1ulcyk" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["circle", { cx: "17", cy: "15", r: "3", key: "1upz2a" }],
  ["path", { d: "m21 19-1.9-1.9", key: "dwi7p8" }]
], nse = r("TextSearch", ase);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ose = [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["line", { x1: "7", x2: "15", y1: "8", y2: "8", key: "1758g8" }],
  ["line", { x1: "7", x2: "17", y1: "12", y2: "12", key: "197423" }],
  ["line", { x1: "7", x2: "13", y1: "16", y2: "16", key: "37cgm6" }]
], rse = r("TextSelect", ose);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ise = [
  ["path", { d: "M17 6.1H3", key: "wptmhv" }],
  ["path", { d: "M21 12.1H3", key: "1j38uz" }],
  ["path", { d: "M15.1 18H3", key: "1nb16a" }]
], sse = r("Text", ise);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cse = [
  ["path", { d: "M2 10s3-3 3-8", key: "3xiif0" }],
  ["path", { d: "M22 10s-3-3-3-8", key: "ioaa5q" }],
  ["path", { d: "M10 2c0 4.4-3.6 8-8 8", key: "16fkpi" }],
  ["path", { d: "M14 2c0 4.4 3.6 8 8 8", key: "b9eulq" }],
  ["path", { d: "M2 10s2 2 2 5", key: "1au1lb" }],
  ["path", { d: "M22 10s-2 2-2 5", key: "qi2y5e" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M2 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "1vsc2m" }],
  ["path", { d: "M14 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "hrha4u" }]
], fse = r("Theater", cse);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dse = [
  ["path", { d: "m10 20-1.25-2.5L6 18", key: "18frcb" }],
  ["path", { d: "M10 4 8.75 6.5 6 6", key: "7mghy3" }],
  ["path", { d: "M10.585 15H10", key: "4nqulp" }],
  ["path", { d: "M2 12h6.5L10 9", key: "kv9z4n" }],
  ["path", { d: "M20 14.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z", key: "yu0u2z" }],
  ["path", { d: "m4 10 1.5 2L4 14", key: "k9enpj" }],
  ["path", { d: "m7 21 3-6-1.5-3", key: "j8hb9u" }],
  ["path", { d: "m7 3 3 6h2", key: "1bbqgq" }]
], lse = r("ThermometerSnowflake", dse);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const use = [
  ["path", { d: "M12 9a4 4 0 0 0-2 7.5", key: "1jvsq6" }],
  ["path", { d: "M12 3v2", key: "1w22ol" }],
  ["path", { d: "m6.6 18.4-1.4 1.4", key: "w2yidj" }],
  ["path", { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "iof6y5" }],
  ["path", { d: "M4 13H2", key: "118le4" }],
  ["path", { d: "M6.34 7.34 4.93 5.93", key: "1brd51" }]
], hse = r("ThermometerSun", use);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pse = [
  ["path", { d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "17jzev" }]
], yse = r("Thermometer", pse);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mse = [
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  [
    "path",
    {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
      key: "m61m77"
    }
  ]
], kse = r("ThumbsDown", mse);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gse = [
  ["path", { d: "M7 10v12", key: "1qc93n" }],
  [
    "path",
    {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
      key: "emmmcr"
    }
  ]
], vse = r("ThumbsUp", gse);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mse = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], wse = r("TicketCheck", Mse);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xse = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }]
], Cse = r("TicketMinus", xse);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bse = [
  [
    "path",
    {
      d: "M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "1l48ns"
    }
  ],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
], Lse = r("TicketPercent", bse);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jse = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M12 9v6", key: "199k2o" }]
], Nse = r("TicketPlus", jse);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ase = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }]
], Sse = r("TicketSlash", Ase);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ise = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }],
  ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }]
], Tse = r("TicketX", Ise);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zse = [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M13 5v2", key: "dyzc3o" }],
  ["path", { d: "M13 17v2", key: "1ont0d" }],
  ["path", { d: "M13 11v2", key: "1wjjxi" }]
], Dse = r("Ticket", zse);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _se = [
  ["path", { d: "M10.5 17h1.227a2 2 0 0 0 1.345-.52L18 12", key: "16muxl" }],
  ["path", { d: "m12 13.5 3.75.5", key: "1i9qhk" }],
  ["path", { d: "m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8", key: "12lg5p" }],
  ["path", { d: "M6 10V8", key: "1y41hn" }],
  ["path", { d: "M6 14v1", key: "cao2tf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["rect", { x: "2", y: "8", width: "20", height: "13", rx: "2", key: "p3bz5l" }]
], Pse = r("TicketsPlane", _se);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ese = [
  ["path", { d: "m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8", key: "12lg5p" }],
  ["path", { d: "M6 10V8", key: "1y41hn" }],
  ["path", { d: "M6 14v1", key: "cao2tf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["rect", { x: "2", y: "8", width: "20", height: "13", rx: "2", key: "p3bz5l" }]
], Rse = r("Tickets", Ese);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hse = [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M4.6 11a8 8 0 0 0 1.7 8.7 8 8 0 0 0 8.7 1.7", key: "10he05" }],
  ["path", { d: "M7.4 7.4a8 8 0 0 1 10.3 1 8 8 0 0 1 .9 10.2", key: "15f7sh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M12 12v-2", key: "fwoke6" }]
], Vse = r("TimerOff", Hse);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ose = [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M12 14v-4", key: "1evpnu" }],
  ["path", { d: "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6", key: "1ts96g" }],
  ["path", { d: "M9 17H4v5", key: "8t5av" }]
], qse = r("TimerReset", Ose);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bse = [
  ["line", { x1: "10", x2: "14", y1: "2", y2: "2", key: "14vaq8" }],
  ["line", { x1: "12", x2: "15", y1: "14", y2: "11", key: "17fdiu" }],
  ["circle", { cx: "12", cy: "14", r: "8", key: "1e1u0o" }]
], Zse = r("Timer", Bse);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fse = [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "8", cy: "12", r: "2", key: "1nvbw3" }]
], Gse = r("ToggleLeft", Fse);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $se = [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }]
], Use = r("ToggleRight", $se);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wse = [
  [
    "path",
    {
      d: "M7 12h13a1 1 0 0 1 1 1 5 5 0 0 1-5 5h-.598a.5.5 0 0 0-.424.765l1.544 2.47a.5.5 0 0 1-.424.765H5.402a.5.5 0 0 1-.424-.765L7 18",
      key: "kc4kqr"
    }
  ],
  ["path", { d: "M8 18a5 5 0 0 1-5-5V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8", key: "1tqs57" }]
], Yse = r("Toilet", Wse);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qse = [
  ["path", { d: "M21 4H3", key: "1hwok0" }],
  ["path", { d: "M18 8H6", key: "41n648" }],
  ["path", { d: "M19 12H9", key: "1g4lpz" }],
  ["path", { d: "M16 16h-6", key: "1j5d54" }],
  ["path", { d: "M11 20H9", key: "39obr8" }]
], Jse = r("Tornado", Qse);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kse = [
  ["ellipse", { cx: "12", cy: "11", rx: "3", ry: "2", key: "1b2qxu" }],
  ["ellipse", { cx: "12", cy: "12.5", rx: "10", ry: "8.5", key: "h8emeu" }]
], Xse = r("Torus", Kse);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ece = [
  ["path", { d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16", key: "lnt0bk" }],
  ["path", { d: "M2 14h12", key: "d8icqz" }],
  ["path", { d: "M22 14h-2", key: "jrx26d" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M22 16V6a2 2 0 0 0-2-2H10", key: "11y8e4" }]
], tce = r("TouchpadOff", ece);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ace = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }]
], nce = r("Touchpad", ace);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oce = [
  [
    "path",
    { d: "M18.2 12.27 20 6H4l1.8 6.27a1 1 0 0 0 .95.73h10.5a1 1 0 0 0 .96-.73Z", key: "1pledb" }
  ],
  ["path", { d: "M8 13v9", key: "hmv0ci" }],
  ["path", { d: "M16 22v-9", key: "ylnf1u" }],
  ["path", { d: "m9 6 1 7", key: "dpdgam" }],
  ["path", { d: "m15 6-1 7", key: "ls7zgu" }],
  ["path", { d: "M12 6V2", key: "1pj48d" }],
  ["path", { d: "M13 2h-2", key: "mj6ths" }]
], rce = r("TowerControl", oce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ice = [
  ["rect", { width: "18", height: "12", x: "3", y: "8", rx: "1", key: "158fvp" }],
  ["path", { d: "M10 8V5c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v3", key: "s0042v" }],
  ["path", { d: "M19 8V5c0-.6-.4-1-1-1h-3a1 1 0 0 0-1 1v3", key: "9wmeh2" }]
], sce = r("ToyBrick", ice);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cce = [
  ["path", { d: "m10 11 11 .9a1 1 0 0 1 .8 1.1l-.665 4.158a1 1 0 0 1-.988.842H20", key: "she1j9" }],
  ["path", { d: "M16 18h-5", key: "bq60fd" }],
  ["path", { d: "M18 5a1 1 0 0 0-1 1v5.573", key: "1kv8ia" }],
  ["path", { d: "M3 4h8.129a1 1 0 0 1 .99.863L13 11.246", key: "1q1ert" }],
  ["path", { d: "M4 11V4", key: "9ft8pt" }],
  ["path", { d: "M7 15h.01", key: "k5ht0j" }],
  ["path", { d: "M8 10.1V4", key: "1jgyzo" }],
  ["circle", { cx: "18", cy: "18", r: "2", key: "1emm8v" }],
  ["circle", { cx: "7", cy: "15", r: "5", key: "ddtuc" }]
], fce = r("Tractor", cce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dce = [
  ["path", { d: "M9.3 6.2a4.55 4.55 0 0 0 5.4 0", key: "flyxqv" }],
  ["path", { d: "M7.9 10.7c.9.8 2.4 1.3 4.1 1.3s3.2-.5 4.1-1.3", key: "1nlxxg" }],
  [
    "path",
    {
      d: "M13.9 3.5a1.93 1.93 0 0 0-3.8-.1l-3 10c-.1.2-.1.4-.1.6 0 1.7 2.2 3 5 3s5-1.3 5-3c0-.2 0-.4-.1-.5Z",
      key: "vz7x1l"
    }
  ],
  [
    "path",
    {
      d: "m7.5 12.2-4.7 2.7c-.5.3-.8.7-.8 1.1s.3.8.8 1.1l7.6 4.5c.9.5 2.1.5 3 0l7.6-4.5c.7-.3 1-.7 1-1.1s-.3-.8-.8-1.1l-4.7-2.8",
      key: "1xfzlw"
    }
  ]
], lce = r("TrafficCone", dce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uce = [
  ["path", { d: "M2 22V12a10 10 0 1 1 20 0v10", key: "o0fyp0" }],
  ["path", { d: "M15 6.8v1.4a3 2.8 0 1 1-6 0V6.8", key: "m8q3n9" }],
  ["path", { d: "M10 15h.01", key: "44in9x" }],
  ["path", { d: "M14 15h.01", key: "5mohn5" }],
  ["path", { d: "M10 19a4 4 0 0 1-4-4v-3a6 6 0 1 1 12 0v3a4 4 0 0 1-4 4Z", key: "hckbmu" }],
  ["path", { d: "m9 19-2 3", key: "iij7hm" }],
  ["path", { d: "m15 19 2 3", key: "npx8sa" }]
], hce = r("TrainFrontTunnel", uce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pce = [
  ["path", { d: "M8 3.1V7a4 4 0 0 0 8 0V3.1", key: "1v71zp" }],
  ["path", { d: "m9 15-1-1", key: "1yrq24" }],
  ["path", { d: "m15 15 1-1", key: "1t0d6s" }],
  ["path", { d: "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z", key: "1p0hjs" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m16 19 2 3", key: "xo31yx" }]
], yce = r("TrainFront", pce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mce = [
  ["path", { d: "M2 17 17 2", key: "18b09t" }],
  ["path", { d: "m2 14 8 8", key: "1gv9hu" }],
  ["path", { d: "m5 11 8 8", key: "189pqp" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "m11 5 8 8", key: "ummqn6" }],
  ["path", { d: "m14 2 8 8", key: "1vk7dn" }],
  ["path", { d: "M7 22 22 7", key: "15mb1i" }]
], kce = r("TrainTrack", mce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gce = [
  ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M12 3v8", key: "1h2ygw" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m18 22-2-3", key: "1p0ohu" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }]
], vce = r("TramFront", gce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mce = [
  ["path", { d: "M12 16v6", key: "c8a4gj" }],
  ["path", { d: "M14 20h-4", key: "m8m19d" }],
  ["path", { d: "M18 2h4v4", key: "1341mj" }],
  ["path", { d: "m2 2 7.17 7.17", key: "13q8l2" }],
  ["path", { d: "M2 5.355V2h3.357", key: "18136r" }],
  ["path", { d: "m22 2-7.17 7.17", key: "1epvy4" }],
  ["path", { d: "M8 5 5 8", key: "mgbjhz" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
], wce = r("Transgender", Mce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xce = [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
], Cce = r("Trash2", xce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bce = [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }]
], Lce = r("Trash", bce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jce = [
  [
    "path",
    {
      d: "M8 19a4 4 0 0 1-2.24-7.32A3.5 3.5 0 0 1 9 6.03V6a3 3 0 1 1 6 0v.04a3.5 3.5 0 0 1 3.24 5.65A4 4 0 0 1 16 19Z",
      key: "oadzkq"
    }
  ],
  ["path", { d: "M12 19v3", key: "npa21l" }]
], Nce = r("TreeDeciduous", jce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ace = [
  ["path", { d: "M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4", key: "foxbe7" }],
  [
    "path",
    { d: "M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3", key: "18arnh" }
  ],
  [
    "path",
    {
      d: "M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35",
      key: "ywahnh"
    }
  ],
  ["path", { d: "M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14", key: "ft0feo" }]
], Sce = r("TreePalm", Ace);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ice = [
  [
    "path",
    {
      d: "m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z",
      key: "cpyugq"
    }
  ],
  ["path", { d: "M12 22v-3", key: "kmzjlo" }]
], Tce = r("TreePine", Ice);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zce = [
  ["path", { d: "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z", key: "1l6gj6" }],
  ["path", { d: "M7 16v6", key: "1a82de" }],
  ["path", { d: "M13 19v3", key: "13sx9i" }],
  [
    "path",
    {
      d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
      key: "1sj9kv"
    }
  ]
], Dce = r("Trees", zce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ce = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["rect", { width: "3", height: "9", x: "7", y: "7", key: "14n3xi" }],
  ["rect", { width: "3", height: "5", x: "14", y: "7", key: "s4azjd" }]
], Pce = r("Trello", _ce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ece = [
  ["polyline", { points: "22 17 13.5 8.5 8.5 13.5 2 7", key: "1r2t7k" }],
  ["polyline", { points: "16 17 22 17 22 11", key: "11uiuu" }]
], Rce = r("TrendingDown", Ece);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hce = [
  ["path", { d: "M14.828 14.828 21 21", key: "ar5fw7" }],
  ["path", { d: "M21 16v5h-5", key: "1ck2sf" }],
  ["path", { d: "m21 3-9 9-4-4-6 6", key: "1h02xo" }],
  ["path", { d: "M21 8V3h-5", key: "1qoq8a" }]
], Vce = r("TrendingUpDown", Hce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oce = [
  ["polyline", { points: "22 7 13.5 15.5 8.5 10.5 2 17", key: "126l90" }],
  ["polyline", { points: "16 7 22 7 22 13", key: "kwv8wd" }]
], qce = r("TrendingUp", Oce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bce = [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], Zce = r("TriangleAlert", Bce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fce = [
  ["path", { d: "M10.17 4.193a2 2 0 0 1 3.666.013", key: "pltmmw" }],
  ["path", { d: "M14 21h2", key: "v4qezv" }],
  ["path", { d: "m15.874 7.743 1 1.732", key: "10m0iw" }],
  ["path", { d: "m18.849 12.952 1 1.732", key: "zadnam" }],
  ["path", { d: "M21.824 18.18a2 2 0 0 1-1.835 2.824", key: "fvwuk4" }],
  ["path", { d: "M4.024 21a2 2 0 0 1-1.839-2.839", key: "1e1kah" }],
  ["path", { d: "m5.136 12.952-1 1.732", key: "1u4ldi" }],
  ["path", { d: "M8 21h2", key: "i9zjee" }],
  ["path", { d: "m8.102 7.743-1 1.732", key: "1zzo4u" }]
], Gce = r("TriangleDashed", Fce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $ce = [
  [
    "path",
    {
      d: "M22 18a2 2 0 0 1-2 2H3c-1.1 0-1.3-.6-.4-1.3L20.4 4.3c.9-.7 1.6-.4 1.6.7Z",
      key: "183wce"
    }
  ]
], Uce = r("TriangleRight", $ce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wce = [
  [
    "path",
    { d: "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z", key: "14u9p9" }
  ]
], Yce = r("Triangle", Wce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qce = [
  ["path", { d: "M6 9H4.5a2.5 2.5 0 0 1 0-5H6", key: "17hqa7" }],
  ["path", { d: "M18 9h1.5a2.5 2.5 0 0 0 0-5H18", key: "lmptdp" }],
  ["path", { d: "M4 22h16", key: "57wxv0" }],
  ["path", { d: "M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22", key: "1nw9bq" }],
  ["path", { d: "M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22", key: "1np0yb" }],
  ["path", { d: "M18 2H6v7a6 6 0 0 0 12 0V2Z", key: "u46fv3" }]
], Jce = r("Trophy", Qce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kce = [
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  ["path", { d: "M15 18H9", key: "1lyqi6" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
      key: "lysw3i"
    }
  ],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
], Xce = r("Truck", Kce);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const efe = [
  [
    "path",
    {
      d: "m12 10 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a8 8 0 1 0-16 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3l2-4h4Z",
      key: "1lbbv7"
    }
  ],
  ["path", { d: "M4.82 7.9 8 10", key: "m9wose" }],
  ["path", { d: "M15.18 7.9 12 10", key: "p8dp2u" }],
  ["path", { d: "M16.93 10H20a2 2 0 0 1 0 4H2", key: "12nsm7" }]
], tfe = r("Turtle", efe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const afe = [
  [
    "path",
    {
      d: "M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z",
      key: "1pctta"
    }
  ],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }]
], nfe = r("TvMinimalPlay", afe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ofe = [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }]
], rfe = r("TvMinimal", ofe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ife = [
  ["rect", { width: "20", height: "15", x: "2", y: "7", rx: "2", ry: "2", key: "10ag99" }],
  ["polyline", { points: "17 2 12 7 7 2", key: "11pgbg" }]
], sfe = r("Tv", ife);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cfe = [
  ["path", { d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7", key: "c0yzno" }]
], ffe = r("Twitch", cfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dfe = [
  [
    "path",
    {
      d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
      key: "pff0z6"
    }
  ]
], lfe = r("Twitter", dfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ufe = [
  [
    "path",
    {
      d: "M14 16.5a.5.5 0 0 0 .5.5h.5a2 2 0 0 1 0 4H9a2 2 0 0 1 0-4h.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V8a2 2 0 0 1-4 0V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3a2 2 0 0 1-4 0v-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5Z",
      key: "1reda3"
    }
  ]
], hfe = r("TypeOutline", ufe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pfe = [
  ["polyline", { points: "4 7 4 4 20 4 20 7", key: "1nosan" }],
  ["line", { x1: "9", x2: "15", y1: "20", y2: "20", key: "swin9y" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
], yfe = r("Type", pfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mfe = [
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "M15.5 21a1.85 1.85 0 0 1-3.5-1v-8H2a10 10 0 0 1 3.428-6.575", key: "eki10q" }],
  ["path", { d: "M17.5 12H22A10 10 0 0 0 9.004 3.455", key: "n2ayka" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], kfe = r("UmbrellaOff", mfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gfe = [
  ["path", { d: "M22 12a10.06 10.06 1 0 0-20 0Z", key: "1teyop" }],
  ["path", { d: "M12 12v8a2 2 0 0 0 4 0", key: "ulpmoc" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }]
], vfe = r("Umbrella", gfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mfe = [
  ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4", key: "9kb039" }],
  ["line", { x1: "4", x2: "20", y1: "20", y2: "20", key: "nun2al" }]
], wfe = r("Underline", Mfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xfe = [
  ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
  ["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11", key: "f3b9sd" }]
], Cfe = r("Undo2", xfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bfe = [
  ["path", { d: "M21 17a9 9 0 0 0-15-6.7L3 13", key: "8mp6z9" }],
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }]
], Lfe = r("UndoDot", bfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jfe = [
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13", key: "1r6uu6" }]
], Nfe = r("Undo", jfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Afe = [
  ["path", { d: "M16 12h6", key: "15xry1" }],
  ["path", { d: "M8 12H2", key: "1jqql6" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 15 3-3-3-3", key: "wjy7rq" }],
  ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }]
], Sfe = r("UnfoldHorizontal", Afe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ife = [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
  ["path", { d: "m15 5-3-3-3 3", key: "itvq4r" }]
], Tfe = r("UnfoldVertical", Ife);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zfe = [
  ["rect", { width: "8", height: "6", x: "5", y: "4", rx: "1", key: "nzclkv" }],
  ["rect", { width: "8", height: "6", x: "11", y: "14", rx: "1", key: "4tytwb" }]
], Dfe = r("Ungroup", zfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _fe = [
  ["circle", { cx: "12", cy: "10", r: "1", key: "1gnqs8" }],
  ["path", { d: "M22 20V8h-4l-6-4-6 4H2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2", key: "1qj5sn" }],
  ["path", { d: "M6 17v.01", key: "roodi6" }],
  ["path", { d: "M6 13v.01", key: "67c122" }],
  ["path", { d: "M18 17v.01", key: "12ktxm" }],
  ["path", { d: "M18 13v.01", key: "tn1rt1" }],
  ["path", { d: "M14 22v-5a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5", key: "11g7fi" }]
], Pfe = r("University", _fe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Efe = [
  ["path", { d: "M15 7h2a5 5 0 0 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2", key: "1re2ne" }]
], Rfe = r("Unlink2", Efe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hfe = [
  [
    "path",
    {
      d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
      key: "yqzxt4"
    }
  ],
  [
    "path",
    {
      d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
      key: "4qinb0"
    }
  ],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "5", key: "1041cp" }],
  ["line", { x1: "2", x2: "5", y1: "8", y2: "8", key: "14m1p5" }],
  ["line", { x1: "16", x2: "16", y1: "19", y2: "22", key: "rzdirn" }],
  ["line", { x1: "19", x2: "22", y1: "16", y2: "16", key: "ox905f" }]
], Vfe = r("Unlink", Hfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ofe = [
  ["path", { d: "m19 5 3-3", key: "yk6iyv" }],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  [
    "path",
    { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z", key: "goz73y" }
  ],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  [
    "path",
    { d: "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z", key: "1snsnr" }
  ]
], qfe = r("Unplug", Ofe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bfe = [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "17 8 12 3 7 8", key: "t8dd8p" }],
  ["line", { x1: "12", x2: "12", y1: "3", y2: "15", key: "widbto" }]
], Zfe = r("Upload", Bfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ffe = [
  ["circle", { cx: "10", cy: "7", r: "1", key: "dypaad" }],
  ["circle", { cx: "4", cy: "20", r: "1", key: "22iqad" }],
  ["path", { d: "M4.7 19.3 19 5", key: "1enqfc" }],
  ["path", { d: "m21 3-3 1 2 2Z", key: "d3ov82" }],
  ["path", { d: "M9.26 7.68 5 12l2 5", key: "1esawj" }],
  ["path", { d: "m10 14 5 2 3.5-3.5", key: "v8oal5" }],
  ["path", { d: "m18 12 1-1 1 1-1 1Z", key: "1bh22v" }]
], Gfe = r("Usb", Ffe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $fe = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["polyline", { points: "16 11 18 13 22 9", key: "1pwet4" }]
], Ufe = r("UserCheck", $fe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wfe = [
  ["circle", { cx: "18", cy: "15", r: "3", key: "gjjjvw" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M10 15H6a4 4 0 0 0-4 4v2", key: "1nfge6" }],
  ["path", { d: "m21.7 16.4-.9-.3", key: "12j9ji" }],
  ["path", { d: "m15.2 13.9-.9-.3", key: "1fdjdi" }],
  ["path", { d: "m16.6 18.7.3-.9", key: "heedtr" }],
  ["path", { d: "m19.1 12.2.3-.9", key: "1af3ki" }],
  ["path", { d: "m19.6 18.7-.4-1", key: "1x9vze" }],
  ["path", { d: "m16.8 12.3-.4-1", key: "vqeiwj" }],
  ["path", { d: "m14.3 16.6 1-.4", key: "1qlj63" }],
  ["path", { d: "m20.7 13.8 1-.4", key: "1v5t8k" }]
], Yfe = r("UserCog", Wfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qfe = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
], Jfe = r("UserMinus", Qfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kfe = [
  ["path", { d: "M11.5 15H7a4 4 0 0 0-4 4v2", key: "15lzij" }],
  [
    "path",
    {
      d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1817ys"
    }
  ],
  ["circle", { cx: "10", cy: "7", r: "4", key: "e45bow" }]
], Xfe = r("UserPen", Kfe);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ede = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
], tde = r("UserPlus", ede);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ade = [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
], nde = r("UserRoundCheck", ade);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ode = [
  ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m19.5 14.3-.4.9", key: "1eb35c" }],
  ["path", { d: "m16.9 20.8-.4.9", key: "dfjc4z" }],
  ["path", { d: "m21.7 19.5-.9-.4", key: "q4dx6b" }],
  ["path", { d: "m15.2 16.9-.9-.4", key: "1r0w5f" }],
  ["path", { d: "m21.7 16.5-.9.4", key: "1knoei" }],
  ["path", { d: "m15.2 19.1-.9.4", key: "j188fs" }],
  ["path", { d: "m19.5 21.7-.4-.9", key: "1tonu5" }],
  ["path", { d: "m16.9 15.2-.4-.9", key: "699xu" }]
], rde = r("UserRoundCog", ode);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ide = [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M22 19h-6", key: "vcuq98" }]
], sde = r("UserRoundMinus", ide);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cde = [
  ["path", { d: "M2 21a8 8 0 0 1 10.821-7.487", key: "1c8h7z" }],
  [
    "path",
    {
      d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1817ys"
    }
  ],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }]
], fde = r("UserRoundPen", cde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dde = [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M22 19h-6", key: "vcuq98" }]
], lde = r("UserRoundPlus", dde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ude = [
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.9-1.9", key: "1e5ubv" }]
], hde = r("UserRoundSearch", ude);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pde = [
  ["path", { d: "M2 21a8 8 0 0 1 11.873-7", key: "74fkxq" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }],
  ["path", { d: "m22 17-5 5", key: "gqnmv0" }]
], yde = r("UserRoundX", pde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mde = [
  ["circle", { cx: "12", cy: "8", r: "5", key: "1hypcn" }],
  ["path", { d: "M20 21a8 8 0 0 0-16 0", key: "rfgkzh" }]
], kde = r("UserRound", mde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gde = [
  ["circle", { cx: "10", cy: "7", r: "4", key: "e45bow" }],
  ["path", { d: "M10.3 15H7a4 4 0 0 0-4 4v2", key: "3bnktk" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["path", { d: "m21 21-1.9-1.9", key: "1g2n9r" }]
], vde = r("UserSearch", gde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mde = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "17", x2: "22", y1: "8", y2: "13", key: "3nzzx3" }],
  ["line", { x1: "22", x2: "17", y1: "8", y2: "13", key: "1swrse" }]
], wde = r("UserX", Mde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xde = [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
], Cde = r("User", xde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bde = [
  ["path", { d: "M18 21a8 8 0 0 0-16 0", key: "3ypg7q" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3", key: "10s06x" }]
], Lde = r("UsersRound", bde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jde = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["path", { d: "M16 3.13a4 4 0 0 1 0 7.75", key: "1da9ce" }]
], Nde = r("Users", jde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ade = [
  ["path", { d: "m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8", key: "n7qcjb" }],
  [
    "path",
    { d: "M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7", key: "d0u48b" }
  ],
  ["path", { d: "m2.1 21.8 6.4-6.3", key: "yn04lh" }],
  ["path", { d: "m19 5-7 7", key: "194lzd" }]
], Sde = r("UtensilsCrossed", Ade);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ide = [
  ["path", { d: "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2", key: "cjf0a3" }],
  ["path", { d: "M7 2v20", key: "1473qp" }],
  ["path", { d: "M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7", key: "j28e5" }]
], Tde = r("Utensils", Ide);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zde = [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M2 5h20", key: "1fs1ex" }],
  ["path", { d: "M3 3v2", key: "9imdir" }],
  ["path", { d: "M7 3v2", key: "n0os7" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["path", { d: "M21 3v2", key: "1duuac" }],
  ["path", { d: "m19 5-7 7-7-7", key: "133zxf" }]
], Dde = r("UtilityPole", zde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _de = [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
], Pde = r("Variable", _de);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ede = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }],
  ["path", { d: "m7.9 7.9 2.7 2.7", key: "hpeyl3" }],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" }],
  ["path", { d: "m13.4 10.6 2.7-2.7", key: "264c1n" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" }],
  ["path", { d: "m7.9 16.1 2.7-2.7", key: "p81g5e" }],
  ["circle", { cx: "16.5", cy: "16.5", r: ".5", fill: "currentColor", key: "fubopw" }],
  ["path", { d: "m13.4 13.4 2.7 2.7", key: "abhel3" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
], Rde = r("Vault", Ede);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hde = [
  ["path", { d: "M16 8q6 0 6-6-6 0-6 6", key: "qsyyc4" }],
  ["path", { d: "M17.41 3.59a10 10 0 1 0 3 3", key: "41m9h7" }],
  ["path", { d: "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14", key: "qiv7li" }]
], Vde = r("Vegan", Hde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ode = [
  ["path", { d: "M18 11c-1.5 0-2.5.5-3 2", key: "1fod00" }],
  [
    "path",
    {
      d: "M4 6a2 2 0 0 0-2 2v4a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V8a2 2 0 0 0-2-2h-3a8 8 0 0 0-5 2 8 8 0 0 0-5-2z",
      key: "d70hit"
    }
  ],
  ["path", { d: "M6 11c1.5 0 2.5.5 3 2", key: "136fht" }]
], qde = r("VenetianMask", Ode);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bde = [
  ["path", { d: "M10 20h4", key: "ni2waw" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }],
  ["path", { d: "M17 2h4v4", key: "vhe59" }],
  ["path", { d: "m21 2-5.46 5.46", key: "19kypf" }],
  ["circle", { cx: "12", cy: "11", r: "5", key: "16gxyc" }]
], Zde = r("VenusAndMars", Bde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fde = [
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  ["path", { d: "M9 19h6", key: "456am0" }],
  ["circle", { cx: "12", cy: "9", r: "6", key: "1nw4tq" }]
], Gde = r("Venus", Fde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $de = [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["path", { d: "M8 8v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2", key: "1hbad5" }],
  ["path", { d: "M16 10.34V6c0-.55-.45-1-1-1h-4.34", key: "1x5tf0" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], Ude = r("VibrateOff", $de);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wde = [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["rect", { width: "8", height: "14", x: "8", y: "5", rx: "1", key: "1oyrl4" }]
], Yde = r("Vibrate", Wde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qde = [
  [
    "path",
    { d: "M10.66 6H14a2 2 0 0 1 2 2v2.5l5.248-3.062A.5.5 0 0 1 22 7.87v8.196", key: "w8jjjt" }
  ],
  ["path", { d: "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2", key: "1xawa7" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], Jde = r("VideoOff", Qde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kde = [
  [
    "path",
    {
      d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
      key: "ftymec"
    }
  ],
  ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2", key: "158x01" }]
], Xde = r("Video", Kde);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ele = [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["circle", { cx: "8", cy: "14", r: "2", key: "1k2qr5" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "14", r: "2", key: "14k7lr" }]
], tle = r("Videotape", ele);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ale = [
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2", key: "mrq65r" }],
  ["path", { d: "M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2", key: "be3xqs" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
      key: "11ak4c"
    }
  ]
], nle = r("View", ale);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ole = [
  ["circle", { cx: "6", cy: "12", r: "4", key: "1ehtga" }],
  ["circle", { cx: "18", cy: "12", r: "4", key: "4vafl8" }],
  ["line", { x1: "6", x2: "18", y1: "16", y2: "16", key: "pmt8us" }]
], rle = r("Voicemail", ole);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ile = [
  ["path", { d: "M11.1 7.1a16.55 16.55 0 0 1 10.9 4", key: "2880wi" }],
  ["path", { d: "M12 12a12.6 12.6 0 0 1-8.7 5", key: "113sja" }],
  ["path", { d: "M16.8 13.6a16.55 16.55 0 0 1-9 7.5", key: "1qmsgl" }],
  ["path", { d: "M20.7 17a12.8 12.8 0 0 0-8.7-5 13.3 13.3 0 0 1 0-10", key: "1bmeqp" }],
  ["path", { d: "M6.3 3.8a16.55 16.55 0 0 0 1.9 11.5", key: "iekzv9" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], sle = r("Volleyball", ile);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cle = [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["path", { d: "M16 9a5 5 0 0 1 0 6", key: "1q6k2b" }]
], fle = r("Volume1", cle);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dle = [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["path", { d: "M16 9a5 5 0 0 1 0 6", key: "1q6k2b" }],
  ["path", { d: "M19.364 18.364a9 9 0 0 0 0-12.728", key: "ijwkga" }]
], lle = r("Volume2", dle);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ule = [
  ["path", { d: "M16 9a5 5 0 0 1 .95 2.293", key: "1fgyg8" }],
  ["path", { d: "M19.364 5.636a9 9 0 0 1 1.889 9.96", key: "l3zxae" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11",
      key: "1gbwow"
    }
  ],
  ["path", { d: "M9.828 4.172A.686.686 0 0 1 11 4.657v.686", key: "s2je0y" }]
], hle = r("VolumeOff", ule);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ple = [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["line", { x1: "22", x2: "16", y1: "9", y2: "15", key: "1ewh16" }],
  ["line", { x1: "16", x2: "22", y1: "9", y2: "15", key: "5ykzw1" }]
], yle = r("VolumeX", ple);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mle = [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ]
], kle = r("Volume", mle);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gle = [
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }],
  ["path", { d: "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z", key: "1ezoue" }],
  ["path", { d: "M22 19H2", key: "nuriw5" }]
], vle = r("Vote", gle);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mle = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2", key: "4125el" }],
  [
    "path",
    {
      d: "M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21",
      key: "1dpki6"
    }
  ]
], wle = r("WalletCards", Mle);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xle = [
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  [
    "path",
    {
      d: "M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14",
      key: "u1rqew"
    }
  ]
], Cle = r("WalletMinimal", xle);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ble = [
  [
    "path",
    {
      d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
      key: "18etb6"
    }
  ],
  ["path", { d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4", key: "xoc0q4" }]
], Lle = r("Wallet", ble);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jle = [
  ["circle", { cx: "8", cy: "9", r: "2", key: "gjzl9d" }],
  [
    "path",
    {
      d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2",
      key: "69xh40"
    }
  ],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }]
], Nle = r("Wallpaper", jle);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ale = [
  [
    "path",
    {
      d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
      key: "ul74o6"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  ["path", { d: "M5 6v4", key: "ilb8ba" }],
  ["path", { d: "M19 14v4", key: "blhpug" }],
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M7 8H3", key: "zfb6yr" }],
  ["path", { d: "M21 16h-4", key: "1cnmox" }],
  ["path", { d: "M11 3H9", key: "1obp7u" }]
], Sle = r("WandSparkles", Ale);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ile = [
  ["path", { d: "M15 4V2", key: "z1p9b7" }],
  ["path", { d: "M15 16v-2", key: "px0unx" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M17.8 11.8 19 13", key: "yihg8r" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ["path", { d: "M17.8 6.2 19 5", key: "fd4us0" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M12.2 6.2 11 5", key: "i3da3b" }]
], Tle = r("Wand", Ile);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zle = [
  [
    "path",
    {
      d: "M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z",
      key: "gksnxg"
    }
  ],
  ["path", { d: "M6 18h12", key: "9pbo8z" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }],
  ["rect", { width: "12", height: "12", x: "6", y: "10", key: "apd30q" }]
], Dle = r("Warehouse", zle);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _le = [
  ["path", { d: "M3 6h3", key: "155dbl" }],
  ["path", { d: "M17 6h.01", key: "e2y6kg" }],
  ["rect", { width: "18", height: "20", x: "3", y: "2", rx: "2", key: "od3kk9" }],
  ["circle", { cx: "12", cy: "13", r: "5", key: "nlbqau" }],
  ["path", { d: "M12 18a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 1 0-5", key: "17lach" }]
], Ple = r("WashingMachine", _le);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ele = [
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["polyline", { points: "12 10 12 12 13 13", key: "19dquz" }],
  [
    "path",
    { d: "m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05", key: "18k57s" }
  ],
  ["path", { d: "m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05", key: "16ny36" }]
], Rle = r("Watch", Ele);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hle = [
  ["path", { d: "M19 5a2 2 0 0 0-2 2v11", key: "s41o68" }],
  [
    "path",
    {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "rd2r6e"
    }
  ],
  ["path", { d: "M7 13h10", key: "1rwob1" }],
  ["path", { d: "M7 9h10", key: "12czzb" }],
  ["path", { d: "M9 5a2 2 0 0 0-2 2v11", key: "x0q4gh" }]
], Vle = r("WavesLadder", Hle);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ole = [
  [
    "path",
    {
      d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "knzxuh"
    }
  ],
  [
    "path",
    {
      d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "2jd2cc"
    }
  ],
  [
    "path",
    {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "rd2r6e"
    }
  ]
], qle = r("Waves", Ole);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ble = [
  ["circle", { cx: "12", cy: "4.5", r: "2.5", key: "r5ysbb" }],
  ["path", { d: "m10.2 6.3-3.9 3.9", key: "1nzqf6" }],
  ["circle", { cx: "4.5", cy: "12", r: "2.5", key: "jydg6v" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["circle", { cx: "19.5", cy: "12", r: "2.5", key: "1piiel" }],
  ["path", { d: "m13.8 17.7 3.9-3.9", key: "1wyg1y" }],
  ["circle", { cx: "12", cy: "19.5", r: "2.5", key: "13o1pw" }]
], Zle = r("Waypoints", Ble);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fle = [
  ["circle", { cx: "12", cy: "10", r: "8", key: "1gshiw" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 22h10", key: "10w4w3" }],
  ["path", { d: "M12 22v-4", key: "1utk9m" }]
], Gle = r("Webcam", Fle);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $le = [
  ["path", { d: "M17 17h-5c-1.09-.02-1.94.92-2.5 1.9A3 3 0 1 1 2.57 15", key: "1tvl6x" }],
  ["path", { d: "M9 3.4a4 4 0 0 1 6.52.66", key: "q04jfq" }],
  ["path", { d: "m6 17 3.1-5.8a2.5 2.5 0 0 0 .057-2.05", key: "azowf0" }],
  ["path", { d: "M20.3 20.3a4 4 0 0 1-2.3.7", key: "5joiws" }],
  ["path", { d: "M18.6 13a4 4 0 0 1 3.357 3.414", key: "cangb8" }],
  ["path", { d: "m12 6 .6 1", key: "tpjl1n" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], Ule = r("WebhookOff", $le);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wle = [
  [
    "path",
    {
      d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2",
      key: "q3hayz"
    }
  ],
  ["path", { d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06", key: "1go1hn" }],
  ["path", { d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8", key: "qlwsc0" }]
], Yle = r("Webhook", Wle);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qle = [
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }],
  [
    "path",
    {
      d: "M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z",
      key: "56o5sh"
    }
  ]
], Jle = r("Weight", Qle);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kle = [
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "m16 8-1.17 1.17", key: "1qqm82" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    { d: "m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97", key: "4wz8re" }
  ],
  [
    "path",
    { d: "M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62", key: "rves66" }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98",
      key: "ak46r"
    }
  ],
  [
    "path",
    {
      d: "M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28",
      key: "1tw520"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], Xle = r("WheatOff", Kle);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eue = [
  ["path", { d: "M2 22 16 8", key: "60hf96" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    {
      d: "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1sdzmb"
    }
  ],
  [
    "path",
    {
      d: "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "eoatbi"
    }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "2m8kc5"
    }
  ],
  [
    "path",
    {
      d: "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "vex3ng"
    }
  ]
], tue = r("Wheat", eue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aue = [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }],
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
], nue = r("WholeWord", aue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oue = [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 14 0", key: "1x1e6c" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
], rue = r("WifiHigh", oue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iue = [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
], sue = r("WifiLow", iue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cue = [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 5.17-2.69", key: "1dl1wf" }],
  ["path", { d: "M19 12.859a10 10 0 0 0-2.007-1.523", key: "4k23kn" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 4.177-2.643", key: "1grhjp" }],
  ["path", { d: "M22 8.82a15 15 0 0 0-11.288-3.764", key: "z3jwby" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], fue = r("WifiOff", cue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const due = [["path", { d: "M12 20h.01", key: "zekei9" }]], lue = r("WifiZero", due);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uue = [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 20 0", key: "dnpr2z" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 14 0", key: "1x1e6c" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
], hue = r("Wifi", uue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pue = [
  ["path", { d: "M10 2v8", key: "d4bbey" }],
  ["path", { d: "M12.8 21.6A2 2 0 1 0 14 18H2", key: "19kp1d" }],
  ["path", { d: "M17.5 10a2.5 2.5 0 1 1 2 4H2", key: "19kpjc" }],
  ["path", { d: "m6 6 4 4 4-4", key: "k13n16" }]
], yue = r("WindArrowDown", pue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mue = [
  ["path", { d: "M12.8 19.6A2 2 0 1 0 14 16H2", key: "148xed" }],
  ["path", { d: "M17.5 8a2.5 2.5 0 1 1 2 4H2", key: "1u4tom" }],
  ["path", { d: "M9.8 4.4A2 2 0 1 1 11 8H2", key: "75valh" }]
], kue = r("Wind", mue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gue = [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h3m7 0h-1.343", key: "v48bem" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    {
      d: "M7.307 7.307A12.33 12.33 0 0 0 7 10a5 5 0 0 0 7.391 4.391M8.638 2.981C8.75 2.668 8.872 2.34 9 2h6c1.5 4 2 6 2 8 0 .407-.05.809-.145 1.198",
      key: "1ymjlu"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], vue = r("WineOff", gue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mue = [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    { d: "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z", key: "10ffi3" }
  ]
], wue = r("Wine", Mue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xue = [
  ["rect", { width: "8", height: "8", x: "3", y: "3", rx: "2", key: "by2w9f" }],
  ["path", { d: "M7 11v4a2 2 0 0 0 2 2h4", key: "xkn7yn" }],
  ["rect", { width: "8", height: "8", x: "13", y: "13", rx: "2", key: "1cgmvn" }]
], Cue = r("Workflow", xue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bue = [
  ["path", { d: "m19 12-1.5 3", key: "9bcu4o" }],
  ["path", { d: "M19.63 18.81 22 20", key: "121v98" }],
  [
    "path",
    {
      d: "M6.47 8.23a1.68 1.68 0 0 1 2.44 1.93l-.64 2.08a6.76 6.76 0 0 0 10.16 7.67l.42-.27a1 1 0 1 0-2.73-4.21l-.42.27a1.76 1.76 0 0 1-2.63-1.99l.64-2.08A6.66 6.66 0 0 0 3.94 3.9l-.7.4a1 1 0 1 0 2.55 4.34z",
      key: "1tij6q"
    }
  ]
], Lue = r("Worm", bue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jue = [
  ["line", { x1: "3", x2: "21", y1: "6", y2: "6", key: "4m8b97" }],
  ["path", { d: "M3 12h15a3 3 0 1 1 0 6h-4", key: "1cl7v7" }],
  ["polyline", { points: "16 16 14 18 16 20", key: "1jznyi" }],
  ["line", { x1: "3", x2: "10", y1: "18", y2: "18", key: "1h33wv" }]
], Nue = r("WrapText", jue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aue = [
  [
    "path",
    {
      d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z",
      key: "cbrjhi"
    }
  ]
], Sue = r("Wrench", Aue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iue = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], Tue = r("X", Iue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zue = [
  [
    "path",
    {
      d: "M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17",
      key: "1q2vi4"
    }
  ],
  ["path", { d: "m10 15 5-3-5-3z", key: "1jp15x" }]
], Due = r("Youtube", zue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ue = [
  ["path", { d: "M10.513 4.856 13.12 2.17a.5.5 0 0 1 .86.46l-1.377 4.317", key: "193nxd" }],
  ["path", { d: "M15.656 10H20a1 1 0 0 1 .78 1.63l-1.72 1.773", key: "27a7lr" }],
  [
    "path",
    {
      d: "M16.273 16.273 10.88 21.83a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14H4a1 1 0 0 1-.78-1.63l4.507-4.643",
      key: "1e0qe9"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], Pue = r("ZapOff", _ue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eue = [
  [
    "path",
    {
      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
      key: "1xq2db"
    }
  ]
], Rue = r("Zap", Eue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hue = [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "11", x2: "11", y1: "8", y2: "14", key: "1vmskp" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
], Vue = r("ZoomIn", Hue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oue = [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
], que = r("ZoomOut", Oue);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bue = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AArrowDown: m5,
  AArrowUp: g5,
  ALargeSmall: M5,
  Accessibility: x5,
  Activity: b5,
  AirVent: j5,
  Airplay: A5,
  AlarmClock: H5,
  AlarmClockCheck: I5,
  AlarmClockMinus: z5,
  AlarmClockOff: _5,
  AlarmClockPlus: E5,
  AlarmSmoke: O5,
  Album: B5,
  AlignCenter: W5,
  AlignCenterHorizontal: F5,
  AlignCenterVertical: $5,
  AlignEndHorizontal: Q5,
  AlignEndVertical: K5,
  AlignHorizontalDistributeCenter: e8,
  AlignHorizontalDistributeEnd: a8,
  AlignHorizontalDistributeStart: o8,
  AlignHorizontalJustifyCenter: i8,
  AlignHorizontalJustifyEnd: c8,
  AlignHorizontalJustifyStart: d8,
  AlignHorizontalSpaceAround: u8,
  AlignHorizontalSpaceBetween: p8,
  AlignJustify: m8,
  AlignLeft: g8,
  AlignRight: M8,
  AlignStartHorizontal: x8,
  AlignStartVertical: b8,
  AlignVerticalDistributeCenter: j8,
  AlignVerticalDistributeEnd: A8,
  AlignVerticalDistributeStart: I8,
  AlignVerticalJustifyCenter: z8,
  AlignVerticalJustifyEnd: _8,
  AlignVerticalJustifyStart: E8,
  AlignVerticalSpaceAround: H8,
  AlignVerticalSpaceBetween: O8,
  Ambulance: B8,
  Ampersand: F8,
  Ampersands: $8,
  Amphora: W8,
  Anchor: Q8,
  Angry: K8,
  Annoyed: e9,
  Antenna: a9,
  Anvil: o9,
  Aperture: i9,
  AppWindow: d9,
  AppWindowMac: c9,
  Apple: u9,
  Archive: g9,
  ArchiveRestore: p9,
  ArchiveX: m9,
  Armchair: M9,
  ArrowBigDown: b9,
  ArrowBigDownDash: x9,
  ArrowBigLeft: A9,
  ArrowBigLeftDash: j9,
  ArrowBigRight: z9,
  ArrowBigRightDash: I9,
  ArrowBigUp: E9,
  ArrowBigUpDash: _9,
  ArrowDown: c7,
  ArrowDown01: H9,
  ArrowDown10: O9,
  ArrowDownAZ: B9,
  ArrowDownFromLine: F9,
  ArrowDownLeft: $9,
  ArrowDownNarrowWide: W9,
  ArrowDownRight: Q9,
  ArrowDownToDot: K9,
  ArrowDownToLine: e7,
  ArrowDownUp: a7,
  ArrowDownWideNarrow: o7,
  ArrowDownZA: i7,
  ArrowLeft: m7,
  ArrowLeftFromLine: d7,
  ArrowLeftRight: u7,
  ArrowLeftToLine: p7,
  ArrowRight: b7,
  ArrowRightFromLine: g7,
  ArrowRightLeft: M7,
  ArrowRightToLine: x7,
  ArrowUp: Q7,
  ArrowUp01: j7,
  ArrowUp10: A7,
  ArrowUpAZ: I7,
  ArrowUpDown: z7,
  ArrowUpFromDot: _7,
  ArrowUpFromLine: E7,
  ArrowUpLeft: H7,
  ArrowUpNarrowWide: O7,
  ArrowUpRight: B7,
  ArrowUpToLine: F7,
  ArrowUpWideNarrow: $7,
  ArrowUpZA: W7,
  ArrowsUpFromLine: K7,
  Asterisk: em,
  AtSign: am,
  Atom: om,
  AudioLines: im,
  AudioWaveform: cm,
  Award: dm,
  Axe: um,
  Axis3d: pm,
  Baby: mm,
  Backpack: gm,
  Badge: Km,
  BadgeAlert: Mm,
  BadgeCent: xm,
  BadgeCheck: bm,
  BadgeDollarSign: jm,
  BadgeEuro: Am,
  BadgeHelp: Im,
  BadgeIndianRupee: zm,
  BadgeInfo: _m,
  BadgeJapaneseYen: Em,
  BadgeMinus: Hm,
  BadgePercent: Om,
  BadgePlus: Bm,
  BadgePoundSterling: Fm,
  BadgeRussianRuble: $m,
  BadgeSwissFranc: Wm,
  BadgeX: Qm,
  BaggageClaim: ek,
  Ban: ak,
  Banana: ok,
  Bandage: ik,
  Banknote: ck,
  Barcode: dk,
  Baseline: uk,
  Bath: pk,
  Battery: Ak,
  BatteryCharging: mk,
  BatteryFull: gk,
  BatteryLow: Mk,
  BatteryMedium: xk,
  BatteryPlus: bk,
  BatteryWarning: jk,
  Beaker: Ik,
  Bean: _k,
  BeanOff: zk,
  Bed: Ok,
  BedDouble: Ek,
  BedSingle: Hk,
  Beef: Bk,
  Beer: $k,
  BeerOff: Fk,
  Bell: ig,
  BellDot: Wk,
  BellElectric: Qk,
  BellMinus: Kk,
  BellOff: eg,
  BellPlus: ag,
  BellRing: og,
  BetweenHorizontalEnd: cg,
  BetweenHorizontalStart: dg,
  BetweenVerticalEnd: ug,
  BetweenVerticalStart: pg,
  BicepsFlexed: mg,
  Bike: gg,
  Binary: Mg,
  Binoculars: xg,
  Biohazard: bg,
  Bird: jg,
  Bitcoin: Ag,
  Blend: Ig,
  Blinds: zg,
  Blocks: _g,
  Bluetooth: Bg,
  BluetoothConnected: Eg,
  BluetoothOff: Hg,
  BluetoothSearching: Og,
  Bold: Fg,
  Bolt: $g,
  Bomb: Wg,
  Bone: Qg,
  Book: Fv,
  BookA: Kg,
  BookAudio: ev,
  BookCheck: av,
  BookCopy: ov,
  BookDashed: iv,
  BookDown: cv,
  BookHeadphones: dv,
  BookHeart: uv,
  BookImage: pv,
  BookKey: mv,
  BookLock: gv,
  BookMarked: Mv,
  BookMinus: xv,
  BookOpen: Av,
  BookOpenCheck: bv,
  BookOpenText: jv,
  BookPlus: Iv,
  BookText: zv,
  BookType: _v,
  BookUp: Hv,
  BookUp2: Ev,
  BookUser: Ov,
  BookX: Bv,
  Bookmark: eM,
  BookmarkCheck: $v,
  BookmarkMinus: Wv,
  BookmarkPlus: Qv,
  BookmarkX: Kv,
  BoomBox: aM,
  Bot: cM,
  BotMessageSquare: oM,
  BotOff: iM,
  Box: dM,
  Boxes: uM,
  Braces: pM,
  Brackets: mM,
  Brain: xM,
  BrainCircuit: gM,
  BrainCog: MM,
  BrickWall: bM,
  Briefcase: zM,
  BriefcaseBusiness: jM,
  BriefcaseConveyorBelt: AM,
  BriefcaseMedical: IM,
  BringToFront: _M,
  Brush: EM,
  Bug: BM,
  BugOff: HM,
  BugPlay: OM,
  Building: $M,
  Building2: FM,
  Bus: QM,
  BusFront: WM,
  Cable: ew,
  CableCar: KM,
  Cake: ow,
  CakeSlice: aw,
  Calculator: iw,
  Calendar: Ww,
  Calendar1: cw,
  CalendarArrowDown: dw,
  CalendarArrowUp: uw,
  CalendarCheck: mw,
  CalendarCheck2: pw,
  CalendarClock: gw,
  CalendarCog: Mw,
  CalendarDays: xw,
  CalendarFold: bw,
  CalendarHeart: jw,
  CalendarMinus: Iw,
  CalendarMinus2: Aw,
  CalendarOff: zw,
  CalendarPlus: Ew,
  CalendarPlus2: _w,
  CalendarRange: Hw,
  CalendarSearch: Ow,
  CalendarSync: Bw,
  CalendarX: $w,
  CalendarX2: Fw,
  Camera: Kw,
  CameraOff: Qw,
  Candy: ox,
  CandyCane: ex,
  CandyOff: ax,
  Cannabis: ix,
  Captions: dx,
  CaptionsOff: cx,
  Car: mx,
  CarFront: ux,
  CarTaxiFront: px,
  Caravan: gx,
  Carrot: Mx,
  CaseLower: xx,
  CaseSensitive: bx,
  CaseUpper: jx,
  CassetteTape: Ax,
  Cast: Ix,
  Castle: zx,
  Cat: _x,
  Cctv: Ex,
  ChartArea: Hx,
  ChartBar: Wx,
  ChartBarBig: Ox,
  ChartBarDecreasing: Bx,
  ChartBarIncreasing: Fx,
  ChartBarStacked: $x,
  ChartCandlestick: Qx,
  ChartColumn: iC,
  ChartColumnBig: Kx,
  ChartColumnDecreasing: eC,
  ChartColumnIncreasing: aC,
  ChartColumnStacked: oC,
  ChartGantt: cC,
  ChartLine: dC,
  ChartNetwork: uC,
  ChartNoAxesColumn: gC,
  ChartNoAxesColumnDecreasing: pC,
  ChartNoAxesColumnIncreasing: mC,
  ChartNoAxesCombined: MC,
  ChartNoAxesGantt: xC,
  ChartPie: bC,
  ChartScatter: jC,
  ChartSpline: AC,
  Check: Gi,
  CheckCheck: IC,
  ChefHat: DC,
  Cherry: PC,
  ChevronDown: tr,
  ChevronFirst: HC,
  ChevronLast: OC,
  ChevronLeft: BC,
  ChevronRight: FC,
  ChevronUp: Td,
  ChevronsDown: YC,
  ChevronsDownUp: UC,
  ChevronsLeft: tb,
  ChevronsLeftRight: XC,
  ChevronsLeftRightEllipsis: JC,
  ChevronsRight: rb,
  ChevronsRightLeft: nb,
  ChevronsUp: fb,
  ChevronsUpDown: sb,
  Chrome: lb,
  Church: hb,
  Cigarette: kb,
  CigaretteOff: yb,
  Circle: YL,
  CircleAlert: vb,
  CircleArrowDown: wb,
  CircleArrowLeft: Cb,
  CircleArrowOutDownLeft: Lb,
  CircleArrowOutDownRight: Nb,
  CircleArrowOutUpLeft: Sb,
  CircleArrowOutUpRight: Tb,
  CircleArrowRight: Db,
  CircleArrowUp: Pb,
  CircleCheck: Vb,
  CircleCheckBig: Rb,
  CircleChevronDown: qb,
  CircleChevronLeft: Zb,
  CircleChevronRight: Gb,
  CircleChevronUp: Ub,
  CircleDashed: Yb,
  CircleDivide: Jb,
  CircleDollarSign: Xb,
  CircleDot: nL,
  CircleDotDashed: tL,
  CircleEllipsis: rL,
  CircleEqual: sL,
  CircleFadingArrowUp: fL,
  CircleFadingPlus: lL,
  CircleGauge: hL,
  CircleHelp: yL,
  CircleMinus: kL,
  CircleOff: vL,
  CircleParking: CL,
  CircleParkingOff: wL,
  CirclePause: LL,
  CirclePercent: NL,
  CirclePlay: SL,
  CirclePlus: TL,
  CirclePower: DL,
  CircleSlash: RL,
  CircleSlash2: PL,
  CircleSmall: VL,
  CircleStop: qL,
  CircleUser: GL,
  CircleUserRound: ZL,
  CircleX: UL,
  CircuitBoard: JL,
  Citrus: XL,
  Clapperboard: tj,
  Clipboard: Cj,
  ClipboardCheck: nj,
  ClipboardCopy: rj,
  ClipboardList: sj,
  ClipboardMinus: fj,
  ClipboardPaste: lj,
  ClipboardPen: yj,
  ClipboardPenLine: hj,
  ClipboardPlus: kj,
  ClipboardType: vj,
  ClipboardX: wj,
  Clock: tN,
  Clock1: Lj,
  Clock10: Nj,
  Clock11: Sj,
  Clock12: Tj,
  Clock2: Dj,
  Clock3: Pj,
  Clock4: Rj,
  Clock5: Vj,
  Clock6: qj,
  Clock7: Zj,
  Clock8: Gj,
  Clock9: Uj,
  ClockAlert: Yj,
  ClockArrowDown: Jj,
  ClockArrowUp: Xj,
  Cloud: PN,
  CloudAlert: nN,
  CloudCog: rN,
  CloudDownload: sN,
  CloudDrizzle: fN,
  CloudFog: lN,
  CloudHail: hN,
  CloudLightning: yN,
  CloudMoon: vN,
  CloudMoonRain: kN,
  CloudOff: wN,
  CloudRain: LN,
  CloudRainWind: CN,
  CloudSnow: NN,
  CloudSun: TN,
  CloudSunRain: SN,
  CloudUpload: DN,
  Cloudy: RN,
  Clover: VN,
  Club: qN,
  Code: GN,
  CodeXml: ZN,
  Codepen: UN,
  Codesandbox: YN,
  Coffee: JN,
  Cog: XN,
  Coins: tA,
  Columns2: nA,
  Columns3: rA,
  Columns4: sA,
  Combine: fA,
  Command: lA,
  Compass: hA,
  Component: yA,
  Computer: kA,
  ConciergeBell: vA,
  Cone: wA,
  Construction: CA,
  Contact: NA,
  ContactRound: LA,
  Container: SA,
  Contrast: TA,
  Cookie: DA,
  CookingPot: PA,
  Copy: UA,
  CopyCheck: RA,
  CopyMinus: VA,
  CopyPlus: qA,
  CopySlash: ZA,
  CopyX: GA,
  Copyleft: YA,
  Copyright: JA,
  CornerDownLeft: XA,
  CornerDownRight: tS,
  CornerLeftDown: nS,
  CornerLeftUp: rS,
  CornerRightDown: sS,
  CornerRightUp: fS,
  CornerUpLeft: lS,
  CornerUpRight: hS,
  Cpu: yS,
  CreativeCommons: kS,
  CreditCard: vS,
  Croissant: wS,
  Crop: CS,
  Cross: LS,
  Crosshair: NS,
  Crown: SS,
  Cuboid: TS,
  CupSoda: DS,
  Currency: PS,
  Cylinder: RS,
  Dam: VS,
  Database: GS,
  DatabaseBackup: qS,
  DatabaseZap: ZS,
  Delete: US,
  Dessert: YS,
  Diameter: JS,
  Diamond: rI,
  DiamondMinus: XS,
  DiamondPercent: tI,
  DiamondPlus: nI,
  Dice1: sI,
  Dice2: fI,
  Dice3: lI,
  Dice4: hI,
  Dice5: yI,
  Dice6: kI,
  Dices: vI,
  Diff: wI,
  Disc: SI,
  Disc2: CI,
  Disc3: LI,
  DiscAlbum: NI,
  Divide: TI,
  Dna: PI,
  DnaOff: DI,
  Dock: RI,
  Dog: VI,
  DollarSign: qI,
  Donut: ZI,
  DoorClosed: GI,
  DoorOpen: UI,
  Dot: YI,
  Download: JI,
  DraftingCompass: XI,
  Drama: tT,
  Dribbble: nT,
  Drill: rT,
  Droplet: fT,
  DropletOff: sT,
  Droplets: lT,
  Drum: hT,
  Drumstick: yT,
  Dumbbell: kT,
  Ear: wT,
  EarOff: vT,
  Earth: LT,
  EarthLock: CT,
  Eclipse: NT,
  Egg: DT,
  EggFried: ST,
  EggOff: TT,
  Ellipsis: RT,
  EllipsisVertical: PT,
  Equal: ZT,
  EqualApproximately: VT,
  EqualNot: qT,
  Eraser: GT,
  EthernetPort: UT,
  Euro: YT,
  Expand: JT,
  ExternalLink: XT,
  Eye: rz,
  EyeClosed: tz,
  EyeOff: nz,
  Facebook: sz,
  Factory: fz,
  Fan: lz,
  FastForward: hz,
  Feather: yz,
  Fence: kz,
  FerrisWheel: vz,
  Figma: wz,
  File: T_,
  FileArchive: Cz,
  FileAudio: Nz,
  FileAudio2: Lz,
  FileAxis3d: Sz,
  FileBadge: Dz,
  FileBadge2: Tz,
  FileBox: Pz,
  FileChartColumn: Vz,
  FileChartColumnIncreasing: Rz,
  FileChartLine: qz,
  FileChartPie: Zz,
  FileCheck: Uz,
  FileCheck2: Gz,
  FileClock: Yz,
  FileCode: Xz,
  FileCode2: Jz,
  FileCog: tD,
  FileDiff: nD,
  FileDigit: rD,
  FileDown: sD,
  FileHeart: fD,
  FileImage: lD,
  FileInput: hD,
  FileJson: kD,
  FileJson2: yD,
  FileKey: wD,
  FileKey2: vD,
  FileLock: LD,
  FileLock2: CD,
  FileMinus: SD,
  FileMinus2: ND,
  FileMusic: TD,
  FileOutput: DD,
  FilePen: RD,
  FilePenLine: PD,
  FilePlus: qD,
  FilePlus2: VD,
  FileQuestion: ZD,
  FileScan: GD,
  FileSearch: YD,
  FileSearch2: UD,
  FileSliders: JD,
  FileSpreadsheet: XD,
  FileStack: t_,
  FileSymlink: n_,
  FileTerminal: r_,
  FileText: s_,
  FileType: l_,
  FileType2: f_,
  FileUp: h_,
  FileUser: y_,
  FileVideo: v_,
  FileVideo2: k_,
  FileVolume: C_,
  FileVolume2: w_,
  FileWarning: L_,
  FileX: S_,
  FileX2: N_,
  Files: D_,
  Film: P_,
  Filter: V_,
  FilterX: R_,
  Fingerprint: q_,
  FireExtinguisher: Z_,
  Fish: Y_,
  FishOff: G_,
  FishSymbol: U_,
  Flag: nP,
  FlagOff: J_,
  FlagTriangleLeft: X_,
  FlagTriangleRight: tP,
  Flame: sP,
  FlameKindling: rP,
  Flashlight: lP,
  FlashlightOff: fP,
  FlaskConical: yP,
  FlaskConicalOff: hP,
  FlaskRound: kP,
  FlipHorizontal: wP,
  FlipHorizontal2: vP,
  FlipVertical: LP,
  FlipVertical2: CP,
  Flower: SP,
  Flower2: NP,
  Focus: TP,
  FoldHorizontal: DP,
  FoldVertical: PP,
  Folder: qE,
  FolderArchive: RP,
  FolderCheck: VP,
  FolderClock: qP,
  FolderClosed: ZP,
  FolderCode: GP,
  FolderCog: UP,
  FolderDot: YP,
  FolderDown: JP,
  FolderGit: tE,
  FolderGit2: XP,
  FolderHeart: nE,
  FolderInput: rE,
  FolderKanban: sE,
  FolderKey: fE,
  FolderLock: lE,
  FolderMinus: hE,
  FolderOpen: kE,
  FolderOpenDot: yE,
  FolderOutput: vE,
  FolderPen: wE,
  FolderPlus: CE,
  FolderRoot: LE,
  FolderSearch: SE,
  FolderSearch2: NE,
  FolderSymlink: TE,
  FolderSync: DE,
  FolderTree: PE,
  FolderUp: RE,
  FolderX: VE,
  Folders: ZE,
  Footprints: GE,
  Forklift: UE,
  Forward: YE,
  Frame: JE,
  Framer: XE,
  Frown: tR,
  Fuel: nR,
  Fullscreen: rR,
  GalleryHorizontal: fR,
  GalleryHorizontalEnd: sR,
  GalleryThumbnails: lR,
  GalleryVertical: yR,
  GalleryVerticalEnd: hR,
  Gamepad: vR,
  Gamepad2: kR,
  Gauge: wR,
  Gavel: CR,
  Gem: LR,
  Ghost: NR,
  Gift: SR,
  GitBranch: DR,
  GitBranchPlus: TR,
  GitCommitHorizontal: PR,
  GitCommitVertical: RR,
  GitCompare: qR,
  GitCompareArrows: VR,
  GitFork: ZR,
  GitGraph: GR,
  GitMerge: UR,
  GitPullRequest: rH,
  GitPullRequestArrow: YR,
  GitPullRequestClosed: JR,
  GitPullRequestCreate: tH,
  GitPullRequestCreateArrow: XR,
  GitPullRequestDraft: nH,
  Github: sH,
  Gitlab: fH,
  GlassWater: lH,
  Glasses: hH,
  Globe: kH,
  GlobeLock: yH,
  Goal: vH,
  Grab: wH,
  GraduationCap: CH,
  Grape: LH,
  Grid2x2: DH,
  Grid2x2Check: NH,
  Grid2x2Plus: SH,
  Grid2x2X: TH,
  Grid3x3: PH,
  Grip: qH,
  GripHorizontal: RH,
  GripVertical: VH,
  Group: ZH,
  Guitar: GH,
  Ham: UH,
  Hammer: YH,
  Hand: sV,
  HandCoins: JH,
  HandHeart: XH,
  HandHelping: tV,
  HandMetal: nV,
  HandPlatter: rV,
  Handshake: fV,
  HardDrive: yV,
  HardDriveDownload: lV,
  HardDriveUpload: hV,
  HardHat: kV,
  Hash: vV,
  Haze: wV,
  HdmiPort: CV,
  Heading: RV,
  Heading1: LV,
  Heading2: NV,
  Heading3: SV,
  Heading4: TV,
  Heading5: DV,
  Heading6: PV,
  HeadphoneOff: VV,
  Headphones: qV,
  Headset: ZV,
  Heart: XV,
  HeartCrack: GV,
  HeartHandshake: UV,
  HeartOff: YV,
  HeartPulse: JV,
  Heater: tO,
  Hexagon: nO,
  Highlighter: rO,
  History: sO,
  Hop: lO,
  HopOff: fO,
  Hospital: hO,
  Hotel: yO,
  Hourglass: kO,
  House: LO,
  HousePlug: vO,
  HousePlus: wO,
  HouseWifi: CO,
  IceCreamBowl: NO,
  IceCreamCone: SO,
  IdCard: TO,
  Image: UO,
  ImageDown: DO,
  ImageMinus: PO,
  ImageOff: RO,
  ImagePlay: VO,
  ImagePlus: qO,
  ImageUp: ZO,
  ImageUpscale: GO,
  Images: YO,
  Import: JO,
  Inbox: XO,
  IndentDecrease: tq,
  IndentIncrease: nq,
  IndianRupee: rq,
  Infinity: sq,
  Info: fq,
  InspectionPanel: lq,
  Instagram: hq,
  Italic: yq,
  IterationCcw: kq,
  IterationCw: vq,
  JapaneseYen: wq,
  Joystick: Cq,
  Kanban: Lq,
  Key: Tq,
  KeyRound: Nq,
  KeySquare: Sq,
  Keyboard: Rq,
  KeyboardMusic: Dq,
  KeyboardOff: Pq,
  Lamp: Yq,
  LampCeiling: Vq,
  LampDesk: qq,
  LampFloor: Zq,
  LampWallDown: Gq,
  LampWallUp: Uq,
  LandPlot: Jq,
  Landmark: Xq,
  Languages: tB,
  Laptop: sB,
  LaptopMinimal: rB,
  LaptopMinimalCheck: nB,
  Lasso: lB,
  LassoSelect: fB,
  Laugh: hB,
  Layers: kB,
  Layers2: yB,
  LayoutDashboard: vB,
  LayoutGrid: wB,
  LayoutList: CB,
  LayoutPanelLeft: LB,
  LayoutPanelTop: NB,
  LayoutTemplate: SB,
  Leaf: TB,
  LeafyGreen: DB,
  Lectern: PB,
  LetterText: RB,
  Library: qB,
  LibraryBig: VB,
  LifeBuoy: ZB,
  Ligature: GB,
  Lightbulb: YB,
  LightbulbOff: UB,
  Link: tZ,
  Link2: XB,
  Link2Off: JB,
  Linkedin: nZ,
  List: RZ,
  ListCheck: rZ,
  ListChecks: sZ,
  ListCollapse: fZ,
  ListEnd: lZ,
  ListFilter: yZ,
  ListFilterPlus: hZ,
  ListMinus: kZ,
  ListMusic: vZ,
  ListOrdered: wZ,
  ListPlus: CZ,
  ListRestart: LZ,
  ListStart: NZ,
  ListTodo: SZ,
  ListTree: TZ,
  ListVideo: DZ,
  ListX: PZ,
  Loader: ZZ,
  LoaderCircle: VZ,
  LoaderPinwheel: qZ,
  Locate: YZ,
  LocateFixed: GZ,
  LocateOff: UZ,
  Lock: nF,
  LockKeyhole: XZ,
  LockKeyholeOpen: JZ,
  LockOpen: tF,
  LogIn: rF,
  LogOut: sF,
  Logs: fF,
  Lollipop: lF,
  Luggage: hF,
  Magnet: yF,
  Mail: DF,
  MailCheck: kF,
  MailMinus: vF,
  MailOpen: wF,
  MailPlus: CF,
  MailQuestion: LF,
  MailSearch: NF,
  MailWarning: SF,
  MailX: TF,
  Mailbox: PF,
  Mails: RF,
  Map: lG,
  MapPin: rG,
  MapPinCheck: qF,
  MapPinCheckInside: VF,
  MapPinHouse: ZF,
  MapPinMinus: UF,
  MapPinMinusInside: GF,
  MapPinOff: YF,
  MapPinPlus: XF,
  MapPinPlusInside: JF,
  MapPinX: nG,
  MapPinXInside: tG,
  MapPinned: sG,
  MapPlus: fG,
  Mars: yG,
  MarsStroke: hG,
  Martini: kG,
  Maximize: wG,
  Maximize2: vG,
  Medal: CG,
  Megaphone: NG,
  MegaphoneOff: LG,
  Meh: SG,
  MemoryStick: TG,
  Menu: DG,
  Merge: PG,
  MessageCircle: n$,
  MessageCircleCode: RG,
  MessageCircleDashed: VG,
  MessageCircleHeart: qG,
  MessageCircleMore: ZG,
  MessageCircleOff: GG,
  MessageCirclePlus: UG,
  MessageCircleQuestion: YG,
  MessageCircleReply: JG,
  MessageCircleWarning: XG,
  MessageCircleX: t$,
  MessageSquare: P$,
  MessageSquareCode: r$,
  MessageSquareDashed: s$,
  MessageSquareDiff: f$,
  MessageSquareDot: l$,
  MessageSquareHeart: h$,
  MessageSquareLock: y$,
  MessageSquareMore: k$,
  MessageSquareOff: v$,
  MessageSquarePlus: w$,
  MessageSquareQuote: C$,
  MessageSquareReply: L$,
  MessageSquareShare: N$,
  MessageSquareText: S$,
  MessageSquareWarning: T$,
  MessageSquareX: D$,
  MessagesSquare: R$,
  Mic: Z$,
  MicOff: V$,
  MicVocal: q$,
  Microchip: G$,
  Microscope: U$,
  Microwave: Y$,
  Milestone: J$,
  Milk: tU,
  MilkOff: X$,
  Minimize: rU,
  Minimize2: nU,
  Minus: sU,
  Monitor: DU,
  MonitorCheck: fU,
  MonitorCog: lU,
  MonitorDot: hU,
  MonitorDown: yU,
  MonitorOff: kU,
  MonitorPause: vU,
  MonitorPlay: wU,
  MonitorSmartphone: CU,
  MonitorSpeaker: LU,
  MonitorStop: NU,
  MonitorUp: SU,
  MonitorX: TU,
  Moon: RU,
  MoonStar: PU,
  Mountain: qU,
  MountainSnow: VU,
  Mouse: XU,
  MouseOff: ZU,
  MousePointer: JU,
  MousePointer2: GU,
  MousePointerBan: UU,
  MousePointerClick: YU,
  Move: NW,
  Move3d: tW,
  MoveDiagonal: rW,
  MoveDiagonal2: nW,
  MoveDown: lW,
  MoveDownLeft: sW,
  MoveDownRight: fW,
  MoveHorizontal: hW,
  MoveLeft: yW,
  MoveRight: kW,
  MoveUp: CW,
  MoveUpLeft: vW,
  MoveUpRight: wW,
  MoveVertical: LW,
  Music: PW,
  Music2: SW,
  Music3: TW,
  Music4: DW,
  Navigation: ZW,
  Navigation2: VW,
  Navigation2Off: RW,
  NavigationOff: qW,
  Network: GW,
  Newspaper: UW,
  Nfc: YW,
  NonBinary: JW,
  Notebook: rY,
  NotebookPen: XW,
  NotebookTabs: tY,
  NotebookText: nY,
  NotepadText: fY,
  NotepadTextDashed: sY,
  Nut: hY,
  NutOff: lY,
  Octagon: CY,
  OctagonAlert: yY,
  OctagonMinus: kY,
  OctagonPause: vY,
  OctagonX: wY,
  Omega: LY,
  Option: NY,
  Orbit: SY,
  Origami: TY,
  Package: UY,
  Package2: DY,
  PackageCheck: PY,
  PackageMinus: RY,
  PackageOpen: VY,
  PackagePlus: qY,
  PackageSearch: ZY,
  PackageX: GY,
  PaintBucket: YY,
  PaintRoller: JY,
  Paintbrush: tQ,
  PaintbrushVertical: XY,
  Palette: nQ,
  PanelBottom: lQ,
  PanelBottomClose: rQ,
  PanelBottomDashed: sQ,
  PanelBottomOpen: fQ,
  PanelLeft: vQ,
  PanelLeftClose: hQ,
  PanelLeftDashed: yQ,
  PanelLeftOpen: kQ,
  PanelRight: NQ,
  PanelRightClose: wQ,
  PanelRightDashed: CQ,
  PanelRightOpen: LQ,
  PanelTop: PQ,
  PanelTopClose: SQ,
  PanelTopDashed: TQ,
  PanelTopOpen: DQ,
  PanelsLeftBottom: RQ,
  PanelsRightBottom: VQ,
  PanelsTopLeft: qQ,
  Paperclip: ZQ,
  Parentheses: GQ,
  ParkingMeter: UQ,
  PartyPopper: YQ,
  Pause: JQ,
  PawPrint: XQ,
  PcCase: tJ,
  Pen: fJ,
  PenLine: nJ,
  PenOff: rJ,
  PenTool: sJ,
  Pencil: kJ,
  PencilLine: lJ,
  PencilOff: hJ,
  PencilRuler: yJ,
  Pentagon: vJ,
  Percent: wJ,
  PersonStanding: CJ,
  PhilippinePeso: LJ,
  Phone: VJ,
  PhoneCall: NJ,
  PhoneForwarded: SJ,
  PhoneIncoming: TJ,
  PhoneMissed: DJ,
  PhoneOff: PJ,
  PhoneOutgoing: RJ,
  Pi: qJ,
  Piano: ZJ,
  Pickaxe: GJ,
  PictureInPicture: YJ,
  PictureInPicture2: UJ,
  PiggyBank: JJ,
  Pilcrow: nK,
  PilcrowLeft: XJ,
  PilcrowRight: tK,
  Pill: sK,
  PillBottle: rK,
  Pin: lK,
  PinOff: fK,
  Pipette: hK,
  Pizza: yK,
  Plane: wK,
  PlaneLanding: kK,
  PlaneTakeoff: vK,
  Play: Y2,
  Plug: AK,
  Plug2: bK,
  PlugZap: jK,
  Plus: IK,
  Pocket: _K,
  PocketKnife: zK,
  Podcast: EK,
  Pointer: OK,
  PointerOff: HK,
  Popcorn: BK,
  Popsicle: FK,
  PoundSterling: $K,
  Power: QK,
  PowerOff: WK,
  Presentation: KK,
  Printer: aX,
  PrinterCheck: eX,
  Projector: oX,
  Proportions: iX,
  Puzzle: cX,
  Pyramid: dX,
  QrCode: uX,
  Quote: pX,
  Rabbit: mX,
  Radar: gX,
  Radiation: MX,
  Radical: xX,
  Radio: AX,
  RadioReceiver: bX,
  RadioTower: jX,
  Radius: IX,
  RailSymbol: zX,
  Rainbow: _X,
  Rat: EX,
  Ratio: HX,
  Receipt: aee,
  ReceiptCent: OX,
  ReceiptEuro: BX,
  ReceiptIndianRupee: FX,
  ReceiptJapaneseYen: $X,
  ReceiptPoundSterling: WX,
  ReceiptRussianRuble: QX,
  ReceiptSwissFranc: KX,
  ReceiptText: eee,
  RectangleEllipsis: oee,
  RectangleHorizontal: iee,
  RectangleVertical: cee,
  Recycle: dee,
  Redo: mee,
  Redo2: uee,
  RedoDot: pee,
  RefreshCcw: Mee,
  RefreshCcwDot: gee,
  RefreshCw: bee,
  RefreshCwOff: xee,
  Refrigerator: jee,
  Regex: Aee,
  RemoveFormatting: Iee,
  Repeat: Eee,
  Repeat1: zee,
  Repeat2: _ee,
  Replace: Oee,
  ReplaceAll: Hee,
  Reply: Fee,
  ReplyAll: Bee,
  Rewind: $ee,
  Ribbon: Wee,
  Rocket: Qee,
  RockingChair: Kee,
  RollerCoaster: ete,
  Rotate3d: ate,
  RotateCcw: ite,
  RotateCcwSquare: ote,
  RotateCw: dte,
  RotateCwSquare: cte,
  Route: pte,
  RouteOff: ute,
  Router: mte,
  Rows2: gte,
  Rows3: Mte,
  Rows4: xte,
  Rss: bte,
  Ruler: jte,
  RussianRuble: Ate,
  Sailboat: Ite,
  Salad: zte,
  Sandwich: _te,
  Satellite: Hte,
  SatelliteDish: Ete,
  Save: Fte,
  SaveAll: Ote,
  SaveOff: Bte,
  Scale: Wte,
  Scale3d: $te,
  Scaling: Qte,
  Scan: p1e,
  ScanBarcode: Kte,
  ScanEye: e1e,
  ScanFace: a1e,
  ScanHeart: o1e,
  ScanLine: i1e,
  ScanQrCode: c1e,
  ScanSearch: d1e,
  ScanText: u1e,
  School: m1e,
  Scissors: M1e,
  ScissorsLineDashed: g1e,
  ScreenShare: b1e,
  ScreenShareOff: x1e,
  Scroll: A1e,
  ScrollText: j1e,
  Search: zd,
  SearchCheck: I1e,
  SearchCode: z1e,
  SearchSlash: _1e,
  SearchX: E1e,
  Section: V1e,
  Send: G1e,
  SendHorizontal: q1e,
  SendToBack: Z1e,
  SeparatorHorizontal: U1e,
  SeparatorVertical: Y1e,
  Server: nae,
  ServerCog: J1e,
  ServerCrash: X1e,
  ServerOff: tae,
  Settings: sae,
  Settings2: rae,
  Shapes: fae,
  Share: hae,
  Share2: lae,
  Sheet: yae,
  Shell: kae,
  Shield: Vae,
  ShieldAlert: vae,
  ShieldBan: wae,
  ShieldCheck: Cae,
  ShieldEllipsis: Lae,
  ShieldHalf: Nae,
  ShieldMinus: Sae,
  ShieldOff: Tae,
  ShieldPlus: Dae,
  ShieldQuestion: Pae,
  ShieldX: Rae,
  Ship: Zae,
  ShipWheel: qae,
  Shirt: Gae,
  ShoppingBag: Uae,
  ShoppingBasket: Yae,
  ShoppingCart: Jae,
  Shovel: Xae,
  ShowerHead: tne,
  Shrink: nne,
  Shrub: rne,
  Shuffle: sne,
  Sigma: fne,
  Signal: vne,
  SignalHigh: lne,
  SignalLow: hne,
  SignalMedium: yne,
  SignalZero: kne,
  Signature: wne,
  Signpost: Lne,
  SignpostBig: Cne,
  Siren: Nne,
  SkipBack: Sne,
  SkipForward: Tne,
  Skull: Dne,
  Slack: Pne,
  Slash: Rne,
  Slice: Vne,
  SlidersHorizontal: qne,
  SlidersVertical: Zne,
  Smartphone: Yne,
  SmartphoneCharging: Gne,
  SmartphoneNfc: Une,
  Smile: Xne,
  SmilePlus: Jne,
  Snail: toe,
  Snowflake: noe,
  Sofa: roe,
  Soup: soe,
  Space: foe,
  Spade: loe,
  Sparkle: hoe,
  Sparkles: yoe,
  Speaker: koe,
  Speech: voe,
  SpellCheck: Coe,
  SpellCheck2: woe,
  Spline: Loe,
  Split: Noe,
  SprayCan: Soe,
  Sprout: Toe,
  Square: Z2e,
  SquareActivity: Doe,
  SquareArrowDown: Voe,
  SquareArrowDownLeft: Poe,
  SquareArrowDownRight: Roe,
  SquareArrowLeft: qoe,
  SquareArrowOutDownLeft: Zoe,
  SquareArrowOutDownRight: Goe,
  SquareArrowOutUpLeft: Uoe,
  SquareArrowOutUpRight: Yoe,
  SquareArrowRight: Joe,
  SquareArrowUp: nre,
  SquareArrowUpLeft: Xoe,
  SquareArrowUpRight: tre,
  SquareAsterisk: rre,
  SquareBottomDashedScissors: sre,
  SquareChartGantt: fre,
  SquareCheck: hre,
  SquareCheckBig: lre,
  SquareChevronDown: yre,
  SquareChevronLeft: kre,
  SquareChevronRight: vre,
  SquareChevronUp: wre,
  SquareCode: Cre,
  SquareDashed: Dre,
  SquareDashedBottom: Nre,
  SquareDashedBottomCode: Lre,
  SquareDashedKanban: Sre,
  SquareDashedMousePointer: Tre,
  SquareDivide: Pre,
  SquareDot: Rre,
  SquareEqual: Vre,
  SquareFunction: qre,
  SquareKanban: Zre,
  SquareLibrary: Gre,
  SquareM: Ure,
  SquareMenu: Yre,
  SquareMinus: Jre,
  SquareMousePointer: Xre,
  SquareParking: n2e,
  SquareParkingOff: t2e,
  SquarePen: r2e,
  SquarePercent: s2e,
  SquarePi: f2e,
  SquarePilcrow: l2e,
  SquarePlay: h2e,
  SquarePlus: y2e,
  SquarePower: k2e,
  SquareRadical: v2e,
  SquareScissors: w2e,
  SquareSigma: C2e,
  SquareSlash: L2e,
  SquareSplitHorizontal: N2e,
  SquareSplitVertical: S2e,
  SquareSquare: T2e,
  SquareStack: D2e,
  SquareTerminal: P2e,
  SquareUser: V2e,
  SquareUserRound: R2e,
  SquareX: q2e,
  Squircle: G2e,
  Squirrel: U2e,
  Stamp: Y2e,
  Star: tie,
  StarHalf: J2e,
  StarOff: X2e,
  StepBack: nie,
  StepForward: rie,
  Stethoscope: sie,
  Sticker: fie,
  StickyNote: lie,
  Store: hie,
  StretchHorizontal: yie,
  StretchVertical: kie,
  Strikethrough: vie,
  Subscript: wie,
  Sun: Tie,
  SunDim: Cie,
  SunMedium: Lie,
  SunMoon: Nie,
  SunSnow: Sie,
  Sunrise: Die,
  Sunset: Pie,
  Superscript: Rie,
  SwatchBook: Vie,
  SwissFranc: qie,
  SwitchCamera: Zie,
  Sword: Gie,
  Swords: Uie,
  Syringe: Yie,
  Table: l0e,
  Table2: Jie,
  TableCellsMerge: Xie,
  TableCellsSplit: t0e,
  TableColumnsSplit: n0e,
  TableOfContents: r0e,
  TableProperties: s0e,
  TableRowsSplit: f0e,
  Tablet: y0e,
  TabletSmartphone: h0e,
  Tablets: k0e,
  Tag: v0e,
  Tags: w0e,
  Tally1: C0e,
  Tally2: L0e,
  Tally3: N0e,
  Tally4: S0e,
  Tally5: T0e,
  Tangent: D0e,
  Target: P0e,
  Telescope: R0e,
  Tent: q0e,
  TentTree: V0e,
  Terminal: Z0e,
  TestTube: U0e,
  TestTubeDiagonal: G0e,
  TestTubes: Y0e,
  Text: sse,
  TextCursor: X0e,
  TextCursorInput: J0e,
  TextQuote: tse,
  TextSearch: nse,
  TextSelect: rse,
  Theater: fse,
  Thermometer: yse,
  ThermometerSnowflake: lse,
  ThermometerSun: hse,
  ThumbsDown: kse,
  ThumbsUp: vse,
  Ticket: Dse,
  TicketCheck: wse,
  TicketMinus: Cse,
  TicketPercent: Lse,
  TicketPlus: Nse,
  TicketSlash: Sse,
  TicketX: Tse,
  Tickets: Rse,
  TicketsPlane: Pse,
  Timer: Zse,
  TimerOff: Vse,
  TimerReset: qse,
  ToggleLeft: Gse,
  ToggleRight: Use,
  Toilet: Yse,
  Tornado: Jse,
  Torus: Xse,
  Touchpad: nce,
  TouchpadOff: tce,
  TowerControl: rce,
  ToyBrick: sce,
  Tractor: fce,
  TrafficCone: lce,
  TrainFront: yce,
  TrainFrontTunnel: hce,
  TrainTrack: kce,
  TramFront: vce,
  Transgender: wce,
  Trash: Lce,
  Trash2: Cce,
  TreeDeciduous: Nce,
  TreePalm: Sce,
  TreePine: Tce,
  Trees: Dce,
  Trello: Pce,
  TrendingDown: Rce,
  TrendingUp: qce,
  TrendingUpDown: Vce,
  Triangle: Yce,
  TriangleAlert: Zce,
  TriangleDashed: Gce,
  TriangleRight: Uce,
  Trophy: Jce,
  Truck: Xce,
  Turtle: tfe,
  Tv: sfe,
  TvMinimal: rfe,
  TvMinimalPlay: nfe,
  Twitch: ffe,
  Twitter: lfe,
  Type: yfe,
  TypeOutline: hfe,
  Umbrella: vfe,
  UmbrellaOff: kfe,
  Underline: wfe,
  Undo: Nfe,
  Undo2: Cfe,
  UndoDot: Lfe,
  UnfoldHorizontal: Sfe,
  UnfoldVertical: Tfe,
  Ungroup: Dfe,
  University: Pfe,
  Unlink: Vfe,
  Unlink2: Rfe,
  Unplug: qfe,
  Upload: Zfe,
  Usb: Gfe,
  User: Cde,
  UserCheck: Ufe,
  UserCog: Yfe,
  UserMinus: Jfe,
  UserPen: Xfe,
  UserPlus: tde,
  UserRound: kde,
  UserRoundCheck: nde,
  UserRoundCog: rde,
  UserRoundMinus: sde,
  UserRoundPen: fde,
  UserRoundPlus: lde,
  UserRoundSearch: hde,
  UserRoundX: yde,
  UserSearch: vde,
  UserX: wde,
  Users: Nde,
  UsersRound: Lde,
  Utensils: Tde,
  UtensilsCrossed: Sde,
  UtilityPole: Dde,
  Variable: Pde,
  Vault: Rde,
  Vegan: Vde,
  VenetianMask: qde,
  Venus: Gde,
  VenusAndMars: Zde,
  Vibrate: Yde,
  VibrateOff: Ude,
  Video: Xde,
  VideoOff: Jde,
  Videotape: tle,
  View: nle,
  Voicemail: rle,
  Volleyball: sle,
  Volume: kle,
  Volume1: fle,
  Volume2: lle,
  VolumeOff: hle,
  VolumeX: yle,
  Vote: vle,
  Wallet: Lle,
  WalletCards: wle,
  WalletMinimal: Cle,
  Wallpaper: Nle,
  Wand: Tle,
  WandSparkles: Sle,
  Warehouse: Dle,
  WashingMachine: Ple,
  Watch: Rle,
  Waves: qle,
  WavesLadder: Vle,
  Waypoints: Zle,
  Webcam: Gle,
  Webhook: Yle,
  WebhookOff: Ule,
  Weight: Jle,
  Wheat: tue,
  WheatOff: Xle,
  WholeWord: nue,
  Wifi: hue,
  WifiHigh: rue,
  WifiLow: sue,
  WifiOff: fue,
  WifiZero: lue,
  Wind: kue,
  WindArrowDown: yue,
  Wine: wue,
  WineOff: vue,
  Workflow: Cue,
  Worm: Lue,
  WrapText: Nue,
  Wrench: Sue,
  X: Tue,
  Youtube: Due,
  Zap: Rue,
  ZapOff: Pue,
  ZoomIn: Vue,
  ZoomOut: que
}, Symbol.toStringTag, { value: "Module" })), Zue = Object.assign({}, Bue, l5), Fue = Lt("object-contain", {
  variants: {
    size: {
      sm: "w-4 h-4",
      md: "w-5 h-5",
      lg: "w-8 h-8"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), Ce = Et(
  ({ name: e, className: t, size: a, strokeWidth: n, fill: o, stroke: i, ...s }, c) => {
    const f = Zue[e];
    return f ? /* @__PURE__ */ l.jsx(
      f,
      {
        name: e,
        ref: c,
        className: S(Fue({ size: a }), t),
        strokeWidth: n || 2,
        fill: o || "none",
        stroke: i || "currentColor",
        ...s
      }
    ) : null;
  }
);
Ce.displayName = "LucideIcon";
const Gue = Lt(
  "inline-flex items-center justify-center whitespace-nowrap rounded ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:color-button-disabled",
  {
    variants: {
      variant: {
        default: "color-button-default color-text-inverse hover:color-button-default-hover",
        danger: "color-button-danger color-text-inverse hover:color-button-danger-hover",
        secondary: "color-button-secondary color-text-default hover:color-button-secondary-hover",
        ghost: "color-text-default hover:color-button-secondary-hover"
      },
      size: {
        sm: "h-[30px] px-3 min-w-[108px] text-helper-text-sm",
        md: "h-9 px-4 py-2 min-w-[129px] text-body-sm-bold",
        lg: "h-10 px-8 min-w-[145px] text-body-sm-bold"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "md"
    }
  }
), zt = p.forwardRef(
  ({
    className: e,
    variant: t,
    size: a,
    toggleLeftIcon: n,
    toggleRightIcon: o,
    leftIcon: i,
    rightIcon: s,
    onClick: c,
    isLoading: f = !1,
    elevation: d,
    ...u
  }, h) => /* @__PURE__ */ l.jsx(
    "button",
    {
      className: S(Gue({ variant: t, size: a, className: e }), {
        "shadow-elevation-1": d === 1,
        "shadow-elevation-2": d === 2,
        "shadow-elevation-3": d === 3,
        "shadow-elevation-4": d === 4
      }),
      ref: h,
      onClick: c,
      ...u,
      children: f ? /* @__PURE__ */ l.jsx(
        Ce,
        {
          name: "LoaderCircle",
          size: a === "sm" ? "sm" : "md",
          className: "animate-spin",
          fill: "transparent",
          stroke: "currentColor"
        }
      ) : /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
        n && /* @__PURE__ */ l.jsx("span", { className: "start-adornment", children: /* @__PURE__ */ l.jsx(
          Ce,
          {
            size: a === "sm" ? "sm" : "md",
            name: i,
            fill: "transparent",
            stroke: t === "default" || t === "danger" ? "white" : "currentColor",
            className: "mr-2"
          }
        ) }),
        u.children,
        o && /* @__PURE__ */ l.jsx("span", { className: "end-adornment", children: /* @__PURE__ */ l.jsx(
          Ce,
          {
            size: a === "sm" ? "sm" : "md",
            name: s,
            fill: "transparent",
            stroke: t === "default" || t === "danger" ? "white" : "currentColor",
            className: "ml-2"
          }
        ) })
      ] })
    }
  )
);
zt.displayName = "Button";
const Vwe = ({ children: e, className: t }) => {
  const a = S("flex space-x-2", t);
  return /* @__PURE__ */ l.jsx("div", { className: a, children: e });
}, ar = Et(
  ({
    icon: e,
    variant: t,
    size: a = "sm",
    className: n,
    elevation: o,
    rounded: i = !1,
    isActive: s,
    fill: c,
    ...f
  }, d) => /* @__PURE__ */ l.jsx(
    zt,
    {
      ref: d,
      variant: t,
      className: S(
        "px-0",
        {
          "h-[30px] min-w-[30px]": a === "sm",
          "h-9 min-w-[36px] ": a === "md",
          "h-10 min-w-[40px]": a === "lg"
        },
        {
          "shadow-elevation-1": o === 1,
          "shadow-elevation-2": o === 2,
          "shadow-elevation-3": o === 3,
          "shadow-elevation-4": o === 4
        },
        {
          "rounded-full": i,
          rounded: !i
        },
        {
          "color-bg-brand hover:!color-bg-brand xl:hover:!color-bg-brand-hover": s && t === "ghost"
        },
        n
      ),
      size: a,
      ...f,
      children: /* @__PURE__ */ l.jsx(
        Ce,
        {
          "data-testid": "icon",
          "data-role": "icon",
          name: e,
          size: a === "sm" ? "sm" : "md",
          fill: c || "transparent",
          stroke: s && t === "ghost" ? "black" : t === "default" || t === "danger" ? "white" : "currentColor"
        }
      )
    }
  )
);
function ac(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function H1(...e) {
  return (t) => {
    let a = !1;
    const n = e.map((o) => {
      const i = ac(o, t);
      return !a && typeof i == "function" && (a = !0), i;
    });
    if (a)
      return () => {
        for (let o = 0; o < n.length; o++) {
          const i = n[o];
          typeof i == "function" ? i() : ac(e[o], null);
        }
      };
  };
}
function ye(...e) {
  return p.useCallback(H1(...e), e);
}
var c1 = p.forwardRef((e, t) => {
  const { children: a, ...n } = e, o = p.Children.toArray(a), i = o.find($ue);
  if (i) {
    const s = i.props.children, c = o.map((f) => f === i ? p.Children.count(s) > 1 ? p.Children.only(null) : p.isValidElement(s) ? s.props.children : null : f);
    return /* @__PURE__ */ l.jsx(Q2, { ...n, ref: t, children: p.isValidElement(s) ? p.cloneElement(s, void 0, c) : null });
  }
  return /* @__PURE__ */ l.jsx(Q2, { ...n, ref: t, children: a });
});
c1.displayName = "Slot";
var Q2 = p.forwardRef((e, t) => {
  const { children: a, ...n } = e;
  if (p.isValidElement(a)) {
    const o = Wue(a), i = Uue(n, a.props);
    return a.type !== p.Fragment && (i.ref = t ? H1(t, o) : o), p.cloneElement(a, i);
  }
  return p.Children.count(a) > 1 ? p.Children.only(null) : null;
});
Q2.displayName = "SlotClone";
var Dd = ({ children: e }) => /* @__PURE__ */ l.jsx(l.Fragment, { children: e });
function $ue(e) {
  return p.isValidElement(e) && e.type === Dd;
}
function Uue(e, t) {
  const a = { ...t };
  for (const n in t) {
    const o = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? o && i ? a[n] = (...c) => {
      i(...c), o(...c);
    } : o && (a[n] = o) : n === "style" ? a[n] = { ...o, ...i } : n === "className" && (a[n] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...a };
}
function Wue(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
var _d = c1, Yue = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Y = Yue.reduce((e, t) => {
  const a = p.forwardRef((n, o) => {
    const { asChild: i, ...s } = n, c = i ? c1 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l.jsx(c, { ...s, ref: o });
  });
  return a.displayName = `Primitive.${t}`, { ...e, [t]: a };
}, {});
function Pd(e, t) {
  e && An.flushSync(() => e.dispatchEvent(t));
}
var Que = "Label", Ed = p.forwardRef((e, t) => /* @__PURE__ */ l.jsx(
  Y.label,
  {
    ...e,
    ref: t,
    onMouseDown: (a) => {
      var o;
      a.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, a), !a.defaultPrevented && a.detail > 1 && a.preventDefault());
    }
  }
));
Ed.displayName = Que;
var Rd = Ed;
const Jue = Lt(
  "text-body-sm leading-none color-text-default peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), Z1 = p.forwardRef(({ className: e, required: t, children: a, ...n }, o) => /* @__PURE__ */ l.jsxs(
  Rd,
  {
    ref: o,
    className: S(Jue(), e),
    ...n,
    children: [
      a,
      t && /* @__PURE__ */ l.jsx("span", { className: "ml-1 text-red-500", children: "*" })
    ]
  }
));
Z1.displayName = Rd.displayName;
const Kue = p.forwardRef(
  ({
    className: e,
    label: t,
    required: a,
    isValid: n = !0,
    message: o,
    placeholder: i,
    onChange: s,
    leftIcon: c,
    rightIcon: f,
    ...d
  }, u) => {
    const h = p.useRef(null), y = ye(u, h), m = p.useCallback(() => {
      var g;
      (g = h.current) == null || g.focus();
    }, []), v = p.useMemo(() => {
      if (c == null)
        return;
      const g = p.Children.only(c);
      if (p.isValidElement(g))
        return p.cloneElement(g, {
          ...g.props,
          onClick: (M) => {
            var w, x;
            (x = (w = g.props).onClick) == null || x.call(w, M), m();
          },
          className: S("absolute left-3 color-text-disabled", {
            "cursor-not-allowed": d.disabled
          })
        });
    }, [m, c, d.disabled]), k = p.useMemo(() => {
      if (f == null)
        return;
      const g = p.Children.only(f);
      if (p.isValidElement(g))
        return p.cloneElement(g, {
          ...g.props,
          onClick: (M) => {
            var w, x;
            (x = (w = g.props).onClick) == null || x.call(w, M), m();
          },
          className: S(
            "absolute right-3 cursor-pointer color-text-disabled",
            {
              "cursor-not-allowed": d.disabled
            },
            {
              "color-text-danger": !n
            }
          )
        });
    }, [m, f, d.disabled, n]);
    return /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col w-full", children: [
      t ? /* @__PURE__ */ l.jsx(Z1, { required: a, className: "mb-2 text-body-sm", children: t }) : null,
      /* @__PURE__ */ l.jsxs("div", { className: "relative flex items-center group", children: [
        v,
        /* @__PURE__ */ l.jsx(
          "textarea",
          {
            className: S(
              "flex h-9 w-full rounded-md border color-border-default hover:color-border-hover bg-transparent px-3 py-2 text-body-sm color-text-default transition-colors file:border-0 file:bg-transparent file:text-body-sm placeholder:color-text-disabled focus-visible:outline-none focus-visible:color-border-hover overflow-hidden text-ellipsis",
              { "pr-3 pl-10": v },
              { "pr-10": k },
              { "color-border-danger": !n },
              {
                "disabled:cursor-not-allowed disabled:color-bg-disabled disabled:border-disabled disabled:color-text-disabled": d.disabled
              },
              e
            ),
            onInput: (g) => {
              g.currentTarget.style.height = "auto", g.currentTarget.style.height = `${g.currentTarget.scrollHeight}px`;
            },
            onChange: s,
            placeholder: i || "Placeholder",
            ref: y,
            ...d
          }
        ),
        k
      ] }),
      o ? /* @__PURE__ */ l.jsx(
        "p",
        {
          className: S("text-body-sm mt-2 text-wrap text-justify", {
            "color-text-danger": !n,
            "color-text-secondary": n
          }),
          children: o
        }
      ) : null
    ] });
  }
);
Kue.displayName = "TextAreaFieldV2";
const Xue = p.forwardRef(
  ({ className: e, label: t, required: a, message: n, placeholder: o, isValid: i = !0, ...s }, c) => {
    const f = S(
      "flex min-h-[80px] w-full rounded-sm border color-border-default hover:color-border-hover color-bg-default transition-colors px-3 py-2 text-body-sm color-text-default placeholder:color-text-disabled disabled:color-text-disabled focus-visible:outline-none focus-visible:color-border-hover disabled:cursor-not-allowed disabled:color-bg-disabled disabled:border-disabled",
      { "color-border-danger": !i },
      e
    );
    return /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col h-full", children: [
      t ? /* @__PURE__ */ l.jsx(Z1, { required: a, className: "mb-2 text-body-sm", children: t }) : null,
      /* @__PURE__ */ l.jsx(
        "textarea",
        {
          className: f,
          placeholder: o || "Placeholder",
          ref: c,
          ...s
        }
      ),
      n ? /* @__PURE__ */ l.jsx(
        "p",
        {
          className: S("text-body-sm font-normal mt-2 text-wrap text-justify", {
            "color-text-danger": !i,
            "color-text-secondary": i
          }),
          children: n
        }
      ) : null
    ] });
  }
);
Xue.displayName = "TextAreaField";
const Hd = p.forwardRef(
  ({
    className: e,
    label: t,
    required: a,
    type: n = "text",
    isValid: o = !0,
    message: i,
    onChange: s,
    leftIcon: c,
    rightIcon: f,
    ...d
  }, u) => {
    const h = p.useRef(null), y = ye(u, h), m = p.useCallback(() => {
      var g;
      (g = h.current) == null || g.focus();
    }, []), v = p.useMemo(() => {
      if (c == null)
        return;
      const g = p.Children.only(c);
      if (p.isValidElement(g))
        return p.cloneElement(g, {
          ...g.props,
          onClick: (M) => {
            var w, x;
            (x = (w = g.props).onClick) == null || x.call(w, M), m();
          },
          className: S("absolute left-3 color-text-disabled", {
            "cursor-not-allowed": d.disabled
          })
        });
    }, [m, c, d.disabled]), k = p.useMemo(() => {
      if (f == null)
        return;
      const g = p.Children.only(f);
      if (p.isValidElement(g))
        return p.cloneElement(g, {
          ...g.props,
          onClick: (M) => {
            var w, x;
            (x = (w = g.props).onClick) == null || x.call(w, M), m();
          },
          className: S(
            "absolute right-3 cursor-pointer color-text-disabled",
            {
              "cursor-not-allowed": d.disabled
            },
            {
              "color-text-danger": !o
            }
          )
        });
    }, [m, f, d.disabled, o]);
    return /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col w-full", children: [
      t ? /* @__PURE__ */ l.jsx(Z1, { required: a, className: "mb-2 text-body-sm", children: t }) : null,
      /* @__PURE__ */ l.jsxs("div", { className: "relative flex items-center group", children: [
        v,
        /* @__PURE__ */ l.jsx(
          "input",
          {
            type: n,
            className: S(
              "flex h-9 w-full rounded-md border color-border-default hover:color-border-hover bg-transparent px-3 py-2 text-body-sm  color-text-default transition-colors file:border-0 file:bg-transparent file:text-body-sm placeholder:color-text-disabled focus-visible:outline-none focus-visible:color-border-hover",
              { "pr-3 pl-10": v },
              { "pr-10": k },
              { "color-border-danger": !o },
              {
                "disabled:cursor-not-allowed disabled:color-bg-disabled disabled:border-disabled disabled:color-text-disabled": d.disabled
              },
              e
            ),
            onChange: s,
            ref: y,
            ...d
          }
        ),
        k
      ] }),
      i ? /* @__PURE__ */ l.jsx(
        "p",
        {
          className: S("text-body-sm mt-2 text-wrap text-justify", {
            "color-text-danger": !o,
            "color-text-secondary": o
          }),
          children: i
        }
      ) : null
    ] });
  }
);
Hd.displayName = "TextField";
function F(e, t, { checkForDefaultPrevented: a = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), a === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function e4e(e, t) {
  const a = p.createContext(t), n = (i) => {
    const { children: s, ...c } = i, f = p.useMemo(() => c, Object.values(c));
    return /* @__PURE__ */ l.jsx(a.Provider, { value: f, children: s });
  };
  n.displayName = e + "Provider";
  function o(i) {
    const s = p.useContext(a);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [n, o];
}
function at(e, t = []) {
  let a = [];
  function n(i, s) {
    const c = p.createContext(s), f = a.length;
    a = [...a, s];
    const d = (h) => {
      var M;
      const { scope: y, children: m, ...v } = h, k = ((M = y == null ? void 0 : y[e]) == null ? void 0 : M[f]) || c, g = p.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ l.jsx(k.Provider, { value: g, children: m });
    };
    d.displayName = i + "Provider";
    function u(h, y) {
      var k;
      const m = ((k = y == null ? void 0 : y[e]) == null ? void 0 : k[f]) || c, v = p.useContext(m);
      if (v) return v;
      if (s !== void 0) return s;
      throw new Error(`\`${h}\` must be used within \`${i}\``);
    }
    return [d, u];
  }
  const o = () => {
    const i = a.map((s) => p.createContext(s));
    return function(c) {
      const f = (c == null ? void 0 : c[e]) || i;
      return p.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
        [c, f]
      );
    };
  };
  return o.scopeName = e, [n, t4e(o, ...t)];
}
function t4e(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const a = () => {
    const n = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = n.reduce((c, { useScope: f, scopeName: d }) => {
        const h = f(i)[`__scope${d}`];
        return { ...c, ...h };
      }, {});
      return p.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return a.scopeName = t.scopeName, a;
}
function ct(e) {
  const t = p.useRef(e);
  return p.useEffect(() => {
    t.current = e;
  }), p.useMemo(() => (...a) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...a);
  }, []);
}
function ft({
  prop: e,
  defaultProp: t,
  onChange: a = () => {
  }
}) {
  const [n, o] = a4e({ defaultProp: t, onChange: a }), i = e !== void 0, s = i ? e : n, c = ct(a), f = p.useCallback(
    (d) => {
      if (i) {
        const h = typeof d == "function" ? d(e) : d;
        h !== e && c(h);
      } else
        o(d);
    },
    [i, e, o, c]
  );
  return [s, f];
}
function a4e({
  defaultProp: e,
  onChange: t
}) {
  const a = p.useState(e), [n] = a, o = p.useRef(n), i = ct(t);
  return p.useEffect(() => {
    o.current !== n && (i(n), o.current = n);
  }, [n, o, i]), a;
}
function $i(e) {
  const t = p.useRef({ value: e, previous: e });
  return p.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var We = globalThis != null && globalThis.document ? p.useLayoutEffect : () => {
};
function Ui(e) {
  const [t, a] = p.useState(void 0);
  return We(() => {
    if (e) {
      a({ width: e.offsetWidth, height: e.offsetHeight });
      const n = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, c;
        if ("borderBoxSize" in i) {
          const f = i.borderBoxSize, d = Array.isArray(f) ? f[0] : f;
          s = d.inlineSize, c = d.blockSize;
        } else
          s = e.offsetWidth, c = e.offsetHeight;
        a({ width: s, height: c });
      });
      return n.observe(e, { box: "border-box" }), () => n.unobserve(e);
    } else
      a(void 0);
  }, [e]), t;
}
var Wi = "Switch", [n4e, Owe] = at(Wi), [o4e, r4e] = n4e(Wi), Vd = p.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: a,
      name: n,
      checked: o,
      defaultChecked: i,
      required: s,
      disabled: c,
      value: f = "on",
      onCheckedChange: d,
      form: u,
      ...h
    } = e, [y, m] = p.useState(null), v = ye(t, (x) => m(x)), k = p.useRef(!1), g = y ? u || !!y.closest("form") : !0, [M = !1, w] = ft({
      prop: o,
      defaultProp: i,
      onChange: d
    });
    return /* @__PURE__ */ l.jsxs(o4e, { scope: a, checked: M, disabled: c, children: [
      /* @__PURE__ */ l.jsx(
        Y.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": M,
          "aria-required": s,
          "data-state": Bd(M),
          "data-disabled": c ? "" : void 0,
          disabled: c,
          value: f,
          ...h,
          ref: v,
          onClick: F(e.onClick, (x) => {
            w((C) => !C), g && (k.current = x.isPropagationStopped(), k.current || x.stopPropagation());
          })
        }
      ),
      g && /* @__PURE__ */ l.jsx(
        i4e,
        {
          control: y,
          bubbles: !k.current,
          name: n,
          value: f,
          checked: M,
          required: s,
          disabled: c,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Vd.displayName = Wi;
var Od = "SwitchThumb", qd = p.forwardRef(
  (e, t) => {
    const { __scopeSwitch: a, ...n } = e, o = r4e(Od, a);
    return /* @__PURE__ */ l.jsx(
      Y.span,
      {
        "data-state": Bd(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...n,
        ref: t
      }
    );
  }
);
qd.displayName = Od;
var i4e = (e) => {
  const { control: t, checked: a, bubbles: n = !0, ...o } = e, i = p.useRef(null), s = $i(a), c = Ui(t);
  return p.useEffect(() => {
    const f = i.current, d = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(d, "checked").set;
    if (s !== a && h) {
      const y = new Event("click", { bubbles: n });
      h.call(f, a), f.dispatchEvent(y);
    }
  }, [s, a, n]), /* @__PURE__ */ l.jsx(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: a,
      ...o,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...c,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Bd(e) {
  return e ? "checked" : "unchecked";
}
var Zd = Vd, s4e = qd;
const c4e = Lt("", {
  variants: {
    variant: {
      default: "",
      hover: "data-[state=unchecked]:color-bg-default-hover data-[state=checked]:color-bg-brand-hover",
      focus: "outline-none ring-2 ring-focused ring-offset-2 ring-offset-white"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), Yi = p.forwardRef(({ className: e, variant: t, disabled: a, ...n }, o) => /* @__PURE__ */ l.jsx(
  Zd,
  {
    className: S(
      "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:cursor-not-allowed data-[state=checked]:toggle-active data-[state=unchecked]:toggle-default data-[state=unchecked]:hover:enabled:color-bg-default-hover data-[state=checked]:hover:enabled:color-bg-brand-hover data-[state=checked]:disabled:toggle-default",
      c4e({ variant: t, className: e })
    ),
    disabled: a,
    ...n,
    ref: o,
    "data-testid": "toggle",
    children: /* @__PURE__ */ l.jsx(
      s4e,
      {
        "data-testid": "toggle-thumb",
        className: S(
          "pointer-events-none block h-5 w-5 rounded-full shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0",
          a ? "color-icon-disabled" : "color-icon-default"
        )
      }
    )
  }
));
Yi.displayName = Zd.displayName;
function f4e(e, t = globalThis == null ? void 0 : globalThis.document) {
  const a = ct(e);
  p.useEffect(() => {
    const n = (o) => {
      o.key === "Escape" && a(o);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [a, t]);
}
var d4e = "DismissableLayer", J2 = "dismissableLayer.update", l4e = "dismissableLayer.pointerDownOutside", u4e = "dismissableLayer.focusOutside", nc, Fd = p.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), F1 = p.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: a = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: c,
      ...f
    } = e, d = p.useContext(Fd), [u, h] = p.useState(null), y = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = p.useState({}), v = ye(t, (j) => h(j)), k = Array.from(d.layers), [g] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), M = k.indexOf(g), w = u ? k.indexOf(u) : -1, x = d.layersWithOutsidePointerEventsDisabled.size > 0, C = w >= M, L = p4e((j) => {
      const A = j.target, D = [...d.branches].some((H) => H.contains(A));
      !C || D || (o == null || o(j), s == null || s(j), j.defaultPrevented || c == null || c());
    }, y), N = y4e((j) => {
      const A = j.target;
      [...d.branches].some((H) => H.contains(A)) || (i == null || i(j), s == null || s(j), j.defaultPrevented || c == null || c());
    }, y);
    return f4e((j) => {
      w === d.layers.size - 1 && (n == null || n(j), !j.defaultPrevented && c && (j.preventDefault(), c()));
    }, y), p.useEffect(() => {
      if (u)
        return a && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (nc = y.body.style.pointerEvents, y.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(u)), d.layers.add(u), oc(), () => {
          a && d.layersWithOutsidePointerEventsDisabled.size === 1 && (y.body.style.pointerEvents = nc);
        };
    }, [u, y, a, d]), p.useEffect(() => () => {
      u && (d.layers.delete(u), d.layersWithOutsidePointerEventsDisabled.delete(u), oc());
    }, [u, d]), p.useEffect(() => {
      const j = () => m({});
      return document.addEventListener(J2, j), () => document.removeEventListener(J2, j);
    }, []), /* @__PURE__ */ l.jsx(
      Y.div,
      {
        ...f,
        ref: v,
        style: {
          pointerEvents: x ? C ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: F(e.onFocusCapture, N.onFocusCapture),
        onBlurCapture: F(e.onBlurCapture, N.onBlurCapture),
        onPointerDownCapture: F(
          e.onPointerDownCapture,
          L.onPointerDownCapture
        )
      }
    );
  }
);
F1.displayName = d4e;
var h4e = "DismissableLayerBranch", Gd = p.forwardRef((e, t) => {
  const a = p.useContext(Fd), n = p.useRef(null), o = ye(t, n);
  return p.useEffect(() => {
    const i = n.current;
    if (i)
      return a.branches.add(i), () => {
        a.branches.delete(i);
      };
  }, [a.branches]), /* @__PURE__ */ l.jsx(Y.div, { ...e, ref: o });
});
Gd.displayName = h4e;
function p4e(e, t = globalThis == null ? void 0 : globalThis.document) {
  const a = ct(e), n = p.useRef(!1), o = p.useRef(() => {
  });
  return p.useEffect(() => {
    const i = (c) => {
      if (c.target && !n.current) {
        let f = function() {
          $d(
            l4e,
            a,
            d,
            { discrete: !0 }
          );
        };
        const d = { originalEvent: c };
        c.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = f, t.addEventListener("click", o.current, { once: !0 })) : f();
      } else
        t.removeEventListener("click", o.current);
      n.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, a]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function y4e(e, t = globalThis == null ? void 0 : globalThis.document) {
  const a = ct(e), n = p.useRef(!1);
  return p.useEffect(() => {
    const o = (i) => {
      i.target && !n.current && $d(u4e, a, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, a]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function oc() {
  const e = new CustomEvent(J2);
  document.dispatchEvent(e);
}
function $d(e, t, a, { discrete: n }) {
  const o = a.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: a });
  t && o.addEventListener(e, t, { once: !0 }), n ? Pd(o, i) : o.dispatchEvent(i);
}
var m4e = F1, k4e = Gd, g4e = p.useId || (() => {
}), v4e = 0;
function $e(e) {
  const [t, a] = p.useState(g4e());
  return We(() => {
    a((n) => n ?? String(v4e++));
  }, [e]), t ? `radix-${t}` : "";
}
const M4e = ["top", "right", "bottom", "left"], f1 = Math.min, ht = Math.max, Do = Math.round, to = Math.floor, Zt = (e) => ({
  x: e,
  y: e
}), w4e = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, x4e = {
  start: "end",
  end: "start"
};
function K2(e, t, a) {
  return ht(e, f1(t, a));
}
function Kt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Xt(e) {
  return e.split("-")[0];
}
function Na(e) {
  return e.split("-")[1];
}
function Qi(e) {
  return e === "x" ? "y" : "x";
}
function Ji(e) {
  return e === "y" ? "height" : "width";
}
function d1(e) {
  return ["top", "bottom"].includes(Xt(e)) ? "y" : "x";
}
function Ki(e) {
  return Qi(d1(e));
}
function C4e(e, t, a) {
  a === void 0 && (a = !1);
  const n = Na(e), o = Ki(e), i = Ji(o);
  let s = o === "x" ? n === (a ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = _o(s)), [s, _o(s)];
}
function b4e(e) {
  const t = _o(e);
  return [X2(e), t, X2(t)];
}
function X2(e) {
  return e.replace(/start|end/g, (t) => x4e[t]);
}
function L4e(e, t, a) {
  const n = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return a ? t ? o : n : t ? n : o;
    case "left":
    case "right":
      return t ? i : s;
    default:
      return [];
  }
}
function j4e(e, t, a, n) {
  const o = Na(e);
  let i = L4e(Xt(e), a === "start", n);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(X2)))), i;
}
function _o(e) {
  return e.replace(/left|right|bottom|top/g, (t) => w4e[t]);
}
function N4e(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Ud(e) {
  return typeof e != "number" ? N4e(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Po(e) {
  const {
    x: t,
    y: a,
    width: n,
    height: o
  } = e;
  return {
    width: n,
    height: o,
    top: a,
    left: t,
    right: t + n,
    bottom: a + o,
    x: t,
    y: a
  };
}
function rc(e, t, a) {
  let {
    reference: n,
    floating: o
  } = e;
  const i = d1(t), s = Ki(t), c = Ji(s), f = Xt(t), d = i === "y", u = n.x + n.width / 2 - o.width / 2, h = n.y + n.height / 2 - o.height / 2, y = n[c] / 2 - o[c] / 2;
  let m;
  switch (f) {
    case "top":
      m = {
        x: u,
        y: n.y - o.height
      };
      break;
    case "bottom":
      m = {
        x: u,
        y: n.y + n.height
      };
      break;
    case "right":
      m = {
        x: n.x + n.width,
        y: h
      };
      break;
    case "left":
      m = {
        x: n.x - o.width,
        y: h
      };
      break;
    default:
      m = {
        x: n.x,
        y: n.y
      };
  }
  switch (Na(t)) {
    case "start":
      m[s] -= y * (a && d ? -1 : 1);
      break;
    case "end":
      m[s] += y * (a && d ? -1 : 1);
      break;
  }
  return m;
}
const A4e = async (e, t, a) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = a, c = i.filter(Boolean), f = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let d = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: h
  } = rc(d, n, f), y = n, m = {}, v = 0;
  for (let k = 0; k < c.length; k++) {
    const {
      name: g,
      fn: M
    } = c[k], {
      x: w,
      y: x,
      data: C,
      reset: L
    } = await M({
      x: u,
      y: h,
      initialPlacement: n,
      placement: y,
      strategy: o,
      middlewareData: m,
      rects: d,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = w ?? u, h = x ?? h, m = {
      ...m,
      [g]: {
        ...m[g],
        ...C
      }
    }, L && v <= 50 && (v++, typeof L == "object" && (L.placement && (y = L.placement), L.rects && (d = L.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : L.rects), {
      x: u,
      y: h
    } = rc(d, y, f)), k = -1);
  }
  return {
    x: u,
    y: h,
    placement: y,
    strategy: o,
    middlewareData: m
  };
};
async function hn(e, t) {
  var a;
  t === void 0 && (t = {});
  const {
    x: n,
    y: o,
    platform: i,
    rects: s,
    elements: c,
    strategy: f
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: h = "floating",
    altBoundary: y = !1,
    padding: m = 0
  } = Kt(t, e), v = Ud(m), g = c[y ? h === "floating" ? "reference" : "floating" : h], M = Po(await i.getClippingRect({
    element: (a = await (i.isElement == null ? void 0 : i.isElement(g))) == null || a ? g : g.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(c.floating)),
    boundary: d,
    rootBoundary: u,
    strategy: f
  })), w = h === "floating" ? {
    x: n,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, x = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c.floating)), C = await (i.isElement == null ? void 0 : i.isElement(x)) ? await (i.getScale == null ? void 0 : i.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, L = Po(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: w,
    offsetParent: x,
    strategy: f
  }) : w);
  return {
    top: (M.top - L.top + v.top) / C.y,
    bottom: (L.bottom - M.bottom + v.bottom) / C.y,
    left: (M.left - L.left + v.left) / C.x,
    right: (L.right - M.right + v.right) / C.x
  };
}
const S4e = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: a,
      y: n,
      placement: o,
      rects: i,
      platform: s,
      elements: c,
      middlewareData: f
    } = t, {
      element: d,
      padding: u = 0
    } = Kt(e, t) || {};
    if (d == null)
      return {};
    const h = Ud(u), y = {
      x: a,
      y: n
    }, m = Ki(o), v = Ji(m), k = await s.getDimensions(d), g = m === "y", M = g ? "top" : "left", w = g ? "bottom" : "right", x = g ? "clientHeight" : "clientWidth", C = i.reference[v] + i.reference[m] - y[m] - i.floating[v], L = y[m] - i.reference[m], N = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(d));
    let j = N ? N[x] : 0;
    (!j || !await (s.isElement == null ? void 0 : s.isElement(N))) && (j = c.floating[x] || i.floating[v]);
    const A = C / 2 - L / 2, D = j / 2 - k[v] / 2 - 1, H = f1(h[M], D), Z = f1(h[w], D), R = H, _ = j - k[v] - Z, T = j / 2 - k[v] / 2 + A, G = K2(R, T, _), q = !f.arrow && Na(o) != null && T !== G && i.reference[v] / 2 - (T < R ? H : Z) - k[v] / 2 < 0, V = q ? T < R ? T - R : T - _ : 0;
    return {
      [m]: y[m] + V,
      data: {
        [m]: G,
        centerOffset: T - G - V,
        ...q && {
          alignmentOffset: V
        }
      },
      reset: q
    };
  }
}), I4e = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var a, n;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: c,
        platform: f,
        elements: d
      } = t, {
        mainAxis: u = !0,
        crossAxis: h = !0,
        fallbackPlacements: y,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: k = !0,
        ...g
      } = Kt(e, t);
      if ((a = i.arrow) != null && a.alignmentOffset)
        return {};
      const M = Xt(o), w = d1(c), x = Xt(c) === c, C = await (f.isRTL == null ? void 0 : f.isRTL(d.floating)), L = y || (x || !k ? [_o(c)] : b4e(c)), N = v !== "none";
      !y && N && L.push(...j4e(c, k, v, C));
      const j = [c, ...L], A = await hn(t, g), D = [];
      let H = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (u && D.push(A[M]), h) {
        const T = C4e(o, s, C);
        D.push(A[T[0]], A[T[1]]);
      }
      if (H = [...H, {
        placement: o,
        overflows: D
      }], !D.every((T) => T <= 0)) {
        var Z, R;
        const T = (((Z = i.flip) == null ? void 0 : Z.index) || 0) + 1, G = j[T];
        if (G)
          return {
            data: {
              index: T,
              overflows: H
            },
            reset: {
              placement: G
            }
          };
        let q = (R = H.filter((V) => V.overflows[0] <= 0).sort((V, B) => V.overflows[1] - B.overflows[1])[0]) == null ? void 0 : R.placement;
        if (!q)
          switch (m) {
            case "bestFit": {
              var _;
              const V = (_ = H.filter((B) => {
                if (N) {
                  const Q = d1(B.placement);
                  return Q === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Q === "y";
                }
                return !0;
              }).map((B) => [B.placement, B.overflows.filter((Q) => Q > 0).reduce((Q, me) => Q + me, 0)]).sort((B, Q) => B[1] - Q[1])[0]) == null ? void 0 : _[0];
              V && (q = V);
              break;
            }
            case "initialPlacement":
              q = c;
              break;
          }
        if (o !== q)
          return {
            reset: {
              placement: q
            }
          };
      }
      return {};
    }
  };
};
function ic(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function sc(e) {
  return M4e.some((t) => e[t] >= 0);
}
const T4e = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: a
      } = t, {
        strategy: n = "referenceHidden",
        ...o
      } = Kt(e, t);
      switch (n) {
        case "referenceHidden": {
          const i = await hn(t, {
            ...o,
            elementContext: "reference"
          }), s = ic(i, a.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: sc(s)
            }
          };
        }
        case "escaped": {
          const i = await hn(t, {
            ...o,
            altBoundary: !0
          }), s = ic(i, a.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: sc(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function z4e(e, t) {
  const {
    placement: a,
    platform: n,
    elements: o
  } = e, i = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), s = Xt(a), c = Na(a), f = d1(a) === "y", d = ["left", "top"].includes(s) ? -1 : 1, u = i && f ? -1 : 1, h = Kt(t, e);
  let {
    mainAxis: y,
    crossAxis: m,
    alignmentAxis: v
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: h.mainAxis || 0,
    crossAxis: h.crossAxis || 0,
    alignmentAxis: h.alignmentAxis
  };
  return c && typeof v == "number" && (m = c === "end" ? v * -1 : v), f ? {
    x: m * u,
    y: y * d
  } : {
    x: y * d,
    y: m * u
  };
}
const D4e = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var a, n;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: c
      } = t, f = await z4e(t, e);
      return s === ((a = c.offset) == null ? void 0 : a.placement) && (n = c.arrow) != null && n.alignmentOffset ? {} : {
        x: o + f.x,
        y: i + f.y,
        data: {
          ...f,
          placement: s
        }
      };
    }
  };
}, _4e = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: a,
        y: n,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: c = {
          fn: (g) => {
            let {
              x: M,
              y: w
            } = g;
            return {
              x: M,
              y: w
            };
          }
        },
        ...f
      } = Kt(e, t), d = {
        x: a,
        y: n
      }, u = await hn(t, f), h = d1(Xt(o)), y = Qi(h);
      let m = d[y], v = d[h];
      if (i) {
        const g = y === "y" ? "top" : "left", M = y === "y" ? "bottom" : "right", w = m + u[g], x = m - u[M];
        m = K2(w, m, x);
      }
      if (s) {
        const g = h === "y" ? "top" : "left", M = h === "y" ? "bottom" : "right", w = v + u[g], x = v - u[M];
        v = K2(w, v, x);
      }
      const k = c.fn({
        ...t,
        [y]: m,
        [h]: v
      });
      return {
        ...k,
        data: {
          x: k.x - a,
          y: k.y - n,
          enabled: {
            [y]: i,
            [h]: s
          }
        }
      };
    }
  };
}, P4e = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: a,
        y: n,
        placement: o,
        rects: i,
        middlewareData: s
      } = t, {
        offset: c = 0,
        mainAxis: f = !0,
        crossAxis: d = !0
      } = Kt(e, t), u = {
        x: a,
        y: n
      }, h = d1(o), y = Qi(h);
      let m = u[y], v = u[h];
      const k = Kt(c, t), g = typeof k == "number" ? {
        mainAxis: k,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...k
      };
      if (f) {
        const x = y === "y" ? "height" : "width", C = i.reference[y] - i.floating[x] + g.mainAxis, L = i.reference[y] + i.reference[x] - g.mainAxis;
        m < C ? m = C : m > L && (m = L);
      }
      if (d) {
        var M, w;
        const x = y === "y" ? "width" : "height", C = ["top", "left"].includes(Xt(o)), L = i.reference[h] - i.floating[x] + (C && ((M = s.offset) == null ? void 0 : M[h]) || 0) + (C ? 0 : g.crossAxis), N = i.reference[h] + i.reference[x] + (C ? 0 : ((w = s.offset) == null ? void 0 : w[h]) || 0) - (C ? g.crossAxis : 0);
        v < L ? v = L : v > N && (v = N);
      }
      return {
        [y]: m,
        [h]: v
      };
    }
  };
}, E4e = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var a, n;
      const {
        placement: o,
        rects: i,
        platform: s,
        elements: c
      } = t, {
        apply: f = () => {
        },
        ...d
      } = Kt(e, t), u = await hn(t, d), h = Xt(o), y = Na(o), m = d1(o) === "y", {
        width: v,
        height: k
      } = i.floating;
      let g, M;
      h === "top" || h === "bottom" ? (g = h, M = y === (await (s.isRTL == null ? void 0 : s.isRTL(c.floating)) ? "start" : "end") ? "left" : "right") : (M = h, g = y === "end" ? "top" : "bottom");
      const w = k - u.top - u.bottom, x = v - u.left - u.right, C = f1(k - u[g], w), L = f1(v - u[M], x), N = !t.middlewareData.shift;
      let j = C, A = L;
      if ((a = t.middlewareData.shift) != null && a.enabled.x && (A = x), (n = t.middlewareData.shift) != null && n.enabled.y && (j = w), N && !y) {
        const H = ht(u.left, 0), Z = ht(u.right, 0), R = ht(u.top, 0), _ = ht(u.bottom, 0);
        m ? A = v - 2 * (H !== 0 || Z !== 0 ? H + Z : ht(u.left, u.right)) : j = k - 2 * (R !== 0 || _ !== 0 ? R + _ : ht(u.top, u.bottom));
      }
      await f({
        ...t,
        availableWidth: A,
        availableHeight: j
      });
      const D = await s.getDimensions(c.floating);
      return v !== D.width || k !== D.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function nr() {
  return typeof window < "u";
}
function Aa(e) {
  return Wd(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function pt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Yt(e) {
  var t;
  return (t = (Wd(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Wd(e) {
  return nr() ? e instanceof Node || e instanceof pt(e).Node : !1;
}
function _t(e) {
  return nr() ? e instanceof Element || e instanceof pt(e).Element : !1;
}
function Ut(e) {
  return nr() ? e instanceof HTMLElement || e instanceof pt(e).HTMLElement : !1;
}
function cc(e) {
  return !nr() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof pt(e).ShadowRoot;
}
function Sn(e) {
  const {
    overflow: t,
    overflowX: a,
    overflowY: n,
    display: o
  } = Pt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + a) && !["inline", "contents"].includes(o);
}
function R4e(e) {
  return ["table", "td", "th"].includes(Aa(e));
}
function or(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Xi(e) {
  const t = e0(), a = _t(e) ? Pt(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((n) => a[n] ? a[n] !== "none" : !1) || (a.containerType ? a.containerType !== "normal" : !1) || !t && (a.backdropFilter ? a.backdropFilter !== "none" : !1) || !t && (a.filter ? a.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((n) => (a.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (a.contain || "").includes(n));
}
function H4e(e) {
  let t = l1(e);
  for (; Ut(t) && !ka(t); ) {
    if (Xi(t))
      return t;
    if (or(t))
      return null;
    t = l1(t);
  }
  return null;
}
function e0() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ka(e) {
  return ["html", "body", "#document"].includes(Aa(e));
}
function Pt(e) {
  return pt(e).getComputedStyle(e);
}
function rr(e) {
  return _t(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function l1(e) {
  if (Aa(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    cc(e) && e.host || // Fallback.
    Yt(e)
  );
  return cc(t) ? t.host : t;
}
function Yd(e) {
  const t = l1(e);
  return ka(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ut(t) && Sn(t) ? t : Yd(t);
}
function pn(e, t, a) {
  var n;
  t === void 0 && (t = []), a === void 0 && (a = !0);
  const o = Yd(e), i = o === ((n = e.ownerDocument) == null ? void 0 : n.body), s = pt(o);
  if (i) {
    const c = ei(s);
    return t.concat(s, s.visualViewport || [], Sn(o) ? o : [], c && a ? pn(c) : []);
  }
  return t.concat(o, pn(o, [], a));
}
function ei(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Qd(e) {
  const t = Pt(e);
  let a = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const o = Ut(e), i = o ? e.offsetWidth : a, s = o ? e.offsetHeight : n, c = Do(a) !== i || Do(n) !== s;
  return c && (a = i, n = s), {
    width: a,
    height: n,
    $: c
  };
}
function t0(e) {
  return _t(e) ? e : e.contextElement;
}
function ha(e) {
  const t = t0(e);
  if (!Ut(t))
    return Zt(1);
  const a = t.getBoundingClientRect(), {
    width: n,
    height: o,
    $: i
  } = Qd(t);
  let s = (i ? Do(a.width) : a.width) / n, c = (i ? Do(a.height) : a.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
const V4e = /* @__PURE__ */ Zt(0);
function Jd(e) {
  const t = pt(e);
  return !e0() || !t.visualViewport ? V4e : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function O4e(e, t, a) {
  return t === void 0 && (t = !1), !a || t && a !== pt(e) ? !1 : t;
}
function V1(e, t, a, n) {
  t === void 0 && (t = !1), a === void 0 && (a = !1);
  const o = e.getBoundingClientRect(), i = t0(e);
  let s = Zt(1);
  t && (n ? _t(n) && (s = ha(n)) : s = ha(e));
  const c = O4e(i, a, n) ? Jd(i) : Zt(0);
  let f = (o.left + c.x) / s.x, d = (o.top + c.y) / s.y, u = o.width / s.x, h = o.height / s.y;
  if (i) {
    const y = pt(i), m = n && _t(n) ? pt(n) : n;
    let v = y, k = ei(v);
    for (; k && n && m !== v; ) {
      const g = ha(k), M = k.getBoundingClientRect(), w = Pt(k), x = M.left + (k.clientLeft + parseFloat(w.paddingLeft)) * g.x, C = M.top + (k.clientTop + parseFloat(w.paddingTop)) * g.y;
      f *= g.x, d *= g.y, u *= g.x, h *= g.y, f += x, d += C, v = pt(k), k = ei(v);
    }
  }
  return Po({
    width: u,
    height: h,
    x: f,
    y: d
  });
}
function a0(e, t) {
  const a = rr(e).scrollLeft;
  return t ? t.left + a : V1(Yt(e)).left + a;
}
function Kd(e, t, a) {
  a === void 0 && (a = !1);
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - (a ? 0 : (
    // RTL <body> scrollbar.
    a0(e, n)
  )), i = n.top + t.scrollTop;
  return {
    x: o,
    y: i
  };
}
function q4e(e) {
  let {
    elements: t,
    rect: a,
    offsetParent: n,
    strategy: o
  } = e;
  const i = o === "fixed", s = Yt(n), c = t ? or(t.floating) : !1;
  if (n === s || c && i)
    return a;
  let f = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = Zt(1);
  const u = Zt(0), h = Ut(n);
  if ((h || !h && !i) && ((Aa(n) !== "body" || Sn(s)) && (f = rr(n)), Ut(n))) {
    const m = V1(n);
    d = ha(n), u.x = m.x + n.clientLeft, u.y = m.y + n.clientTop;
  }
  const y = s && !h && !i ? Kd(s, f, !0) : Zt(0);
  return {
    width: a.width * d.x,
    height: a.height * d.y,
    x: a.x * d.x - f.scrollLeft * d.x + u.x + y.x,
    y: a.y * d.y - f.scrollTop * d.y + u.y + y.y
  };
}
function B4e(e) {
  return Array.from(e.getClientRects());
}
function Z4e(e) {
  const t = Yt(e), a = rr(e), n = e.ownerDocument.body, o = ht(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = ht(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let s = -a.scrollLeft + a0(e);
  const c = -a.scrollTop;
  return Pt(n).direction === "rtl" && (s += ht(t.clientWidth, n.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: c
  };
}
function F4e(e, t) {
  const a = pt(e), n = Yt(e), o = a.visualViewport;
  let i = n.clientWidth, s = n.clientHeight, c = 0, f = 0;
  if (o) {
    i = o.width, s = o.height;
    const d = e0();
    (!d || d && t === "fixed") && (c = o.offsetLeft, f = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: c,
    y: f
  };
}
function G4e(e, t) {
  const a = V1(e, !0, t === "fixed"), n = a.top + e.clientTop, o = a.left + e.clientLeft, i = Ut(e) ? ha(e) : Zt(1), s = e.clientWidth * i.x, c = e.clientHeight * i.y, f = o * i.x, d = n * i.y;
  return {
    width: s,
    height: c,
    x: f,
    y: d
  };
}
function fc(e, t, a) {
  let n;
  if (t === "viewport")
    n = F4e(e, a);
  else if (t === "document")
    n = Z4e(Yt(e));
  else if (_t(t))
    n = G4e(t, a);
  else {
    const o = Jd(e);
    n = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Po(n);
}
function Xd(e, t) {
  const a = l1(e);
  return a === t || !_t(a) || ka(a) ? !1 : Pt(a).position === "fixed" || Xd(a, t);
}
function $4e(e, t) {
  const a = t.get(e);
  if (a)
    return a;
  let n = pn(e, [], !1).filter((c) => _t(c) && Aa(c) !== "body"), o = null;
  const i = Pt(e).position === "fixed";
  let s = i ? l1(e) : e;
  for (; _t(s) && !ka(s); ) {
    const c = Pt(s), f = Xi(s);
    !f && c.position === "fixed" && (o = null), (i ? !f && !o : !f && c.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Sn(s) && !f && Xd(e, s)) ? n = n.filter((u) => u !== s) : o = c, s = l1(s);
  }
  return t.set(e, n), n;
}
function U4e(e) {
  let {
    element: t,
    boundary: a,
    rootBoundary: n,
    strategy: o
  } = e;
  const s = [...a === "clippingAncestors" ? or(t) ? [] : $4e(t, this._c) : [].concat(a), n], c = s[0], f = s.reduce((d, u) => {
    const h = fc(t, u, o);
    return d.top = ht(h.top, d.top), d.right = f1(h.right, d.right), d.bottom = f1(h.bottom, d.bottom), d.left = ht(h.left, d.left), d;
  }, fc(t, c, o));
  return {
    width: f.right - f.left,
    height: f.bottom - f.top,
    x: f.left,
    y: f.top
  };
}
function W4e(e) {
  const {
    width: t,
    height: a
  } = Qd(e);
  return {
    width: t,
    height: a
  };
}
function Y4e(e, t, a) {
  const n = Ut(t), o = Yt(t), i = a === "fixed", s = V1(e, !0, i, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const f = Zt(0);
  if (n || !n && !i)
    if ((Aa(t) !== "body" || Sn(o)) && (c = rr(t)), n) {
      const y = V1(t, !0, i, t);
      f.x = y.x + t.clientLeft, f.y = y.y + t.clientTop;
    } else o && (f.x = a0(o));
  const d = o && !n && !i ? Kd(o, c) : Zt(0), u = s.left + c.scrollLeft - f.x - d.x, h = s.top + c.scrollTop - f.y - d.y;
  return {
    x: u,
    y: h,
    width: s.width,
    height: s.height
  };
}
function r2(e) {
  return Pt(e).position === "static";
}
function dc(e, t) {
  if (!Ut(e) || Pt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let a = e.offsetParent;
  return Yt(e) === a && (a = a.ownerDocument.body), a;
}
function el(e, t) {
  const a = pt(e);
  if (or(e))
    return a;
  if (!Ut(e)) {
    let o = l1(e);
    for (; o && !ka(o); ) {
      if (_t(o) && !r2(o))
        return o;
      o = l1(o);
    }
    return a;
  }
  let n = dc(e, t);
  for (; n && R4e(n) && r2(n); )
    n = dc(n, t);
  return n && ka(n) && r2(n) && !Xi(n) ? a : n || H4e(e) || a;
}
const Q4e = async function(e) {
  const t = this.getOffsetParent || el, a = this.getDimensions, n = await a(e.floating);
  return {
    reference: Y4e(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function J4e(e) {
  return Pt(e).direction === "rtl";
}
const K4e = {
  convertOffsetParentRelativeRectToViewportRelativeRect: q4e,
  getDocumentElement: Yt,
  getClippingRect: U4e,
  getOffsetParent: el,
  getElementRects: Q4e,
  getClientRects: B4e,
  getDimensions: W4e,
  getScale: ha,
  isElement: _t,
  isRTL: J4e
};
function tl(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function X4e(e, t) {
  let a = null, n;
  const o = Yt(e);
  function i() {
    var c;
    clearTimeout(n), (c = a) == null || c.disconnect(), a = null;
  }
  function s(c, f) {
    c === void 0 && (c = !1), f === void 0 && (f = 1), i();
    const d = e.getBoundingClientRect(), {
      left: u,
      top: h,
      width: y,
      height: m
    } = d;
    if (c || t(), !y || !m)
      return;
    const v = to(h), k = to(o.clientWidth - (u + y)), g = to(o.clientHeight - (h + m)), M = to(u), x = {
      rootMargin: -v + "px " + -k + "px " + -g + "px " + -M + "px",
      threshold: ht(0, f1(1, f)) || 1
    };
    let C = !0;
    function L(N) {
      const j = N[0].intersectionRatio;
      if (j !== f) {
        if (!C)
          return s();
        j ? s(!1, j) : n = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      j === 1 && !tl(d, e.getBoundingClientRect()) && s(), C = !1;
    }
    try {
      a = new IntersectionObserver(L, {
        ...x,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      a = new IntersectionObserver(L, x);
    }
    a.observe(e);
  }
  return s(!0), i;
}
function ehe(e, t, a, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: f = !1
  } = n, d = t0(e), u = o || i ? [...d ? pn(d) : [], ...pn(t)] : [];
  u.forEach((M) => {
    o && M.addEventListener("scroll", a, {
      passive: !0
    }), i && M.addEventListener("resize", a);
  });
  const h = d && c ? X4e(d, a) : null;
  let y = -1, m = null;
  s && (m = new ResizeObserver((M) => {
    let [w] = M;
    w && w.target === d && m && (m.unobserve(t), cancelAnimationFrame(y), y = requestAnimationFrame(() => {
      var x;
      (x = m) == null || x.observe(t);
    })), a();
  }), d && !f && m.observe(d), m.observe(t));
  let v, k = f ? V1(e) : null;
  f && g();
  function g() {
    const M = V1(e);
    k && !tl(k, M) && a(), k = M, v = requestAnimationFrame(g);
  }
  return a(), () => {
    var M;
    u.forEach((w) => {
      o && w.removeEventListener("scroll", a), i && w.removeEventListener("resize", a);
    }), h == null || h(), (M = m) == null || M.disconnect(), m = null, f && cancelAnimationFrame(v);
  };
}
const the = D4e, ahe = _4e, nhe = I4e, ohe = E4e, rhe = T4e, lc = S4e, ihe = P4e, she = (e, t, a) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: K4e,
    ...a
  }, i = {
    ...o.platform,
    _c: n
  };
  return A4e(e, t, {
    ...o,
    platform: i
  });
};
var Mo = typeof document < "u" ? er : Ne;
function Eo(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let a, n, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (a = e.length, a !== t.length) return !1;
      for (n = a; n-- !== 0; )
        if (!Eo(e[n], t[n]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), a = o.length, a !== Object.keys(t).length)
      return !1;
    for (n = a; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[n]))
        return !1;
    for (n = a; n-- !== 0; ) {
      const i = o[n];
      if (!(i === "_owner" && e.$$typeof) && !Eo(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function al(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function uc(e, t) {
  const a = al(e);
  return Math.round(t * a) / a;
}
function i2(e) {
  const t = p.useRef(e);
  return Mo(() => {
    t.current = e;
  }), t;
}
function che(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: a = "absolute",
    middleware: n = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: c = !0,
    whileElementsMounted: f,
    open: d
  } = e, [u, h] = p.useState({
    x: 0,
    y: 0,
    strategy: a,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [y, m] = p.useState(n);
  Eo(y, n) || m(n);
  const [v, k] = p.useState(null), [g, M] = p.useState(null), w = p.useCallback((B) => {
    B !== N.current && (N.current = B, k(B));
  }, []), x = p.useCallback((B) => {
    B !== j.current && (j.current = B, M(B));
  }, []), C = i || v, L = s || g, N = p.useRef(null), j = p.useRef(null), A = p.useRef(u), D = f != null, H = i2(f), Z = i2(o), R = i2(d), _ = p.useCallback(() => {
    if (!N.current || !j.current)
      return;
    const B = {
      placement: t,
      strategy: a,
      middleware: y
    };
    Z.current && (B.platform = Z.current), she(N.current, j.current, B).then((Q) => {
      const me = {
        ...Q,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: R.current !== !1
      };
      T.current && !Eo(A.current, me) && (A.current = me, An.flushSync(() => {
        h(me);
      }));
    });
  }, [y, t, a, Z, R]);
  Mo(() => {
    d === !1 && A.current.isPositioned && (A.current.isPositioned = !1, h((B) => ({
      ...B,
      isPositioned: !1
    })));
  }, [d]);
  const T = p.useRef(!1);
  Mo(() => (T.current = !0, () => {
    T.current = !1;
  }), []), Mo(() => {
    if (C && (N.current = C), L && (j.current = L), C && L) {
      if (H.current)
        return H.current(C, L, _);
      _();
    }
  }, [C, L, _, H, D]);
  const G = p.useMemo(() => ({
    reference: N,
    floating: j,
    setReference: w,
    setFloating: x
  }), [w, x]), q = p.useMemo(() => ({
    reference: C,
    floating: L
  }), [C, L]), V = p.useMemo(() => {
    const B = {
      position: a,
      left: 0,
      top: 0
    };
    if (!q.floating)
      return B;
    const Q = uc(q.floating, u.x), me = uc(q.floating, u.y);
    return c ? {
      ...B,
      transform: "translate(" + Q + "px, " + me + "px)",
      ...al(q.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: a,
      left: Q,
      top: me
    };
  }, [a, c, q.floating, u.x, u.y]);
  return p.useMemo(() => ({
    ...u,
    update: _,
    refs: G,
    elements: q,
    floatingStyles: V
  }), [u, _, G, q, V]);
}
const fhe = (e) => {
  function t(a) {
    return {}.hasOwnProperty.call(a, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(a) {
      const {
        element: n,
        padding: o
      } = typeof e == "function" ? e(a) : e;
      return n && t(n) ? n.current != null ? lc({
        element: n.current,
        padding: o
      }).fn(a) : {} : n ? lc({
        element: n,
        padding: o
      }).fn(a) : {};
    }
  };
}, dhe = (e, t) => ({
  ...the(e),
  options: [e, t]
}), lhe = (e, t) => ({
  ...ahe(e),
  options: [e, t]
}), uhe = (e, t) => ({
  ...ihe(e),
  options: [e, t]
}), hhe = (e, t) => ({
  ...nhe(e),
  options: [e, t]
}), phe = (e, t) => ({
  ...ohe(e),
  options: [e, t]
}), yhe = (e, t) => ({
  ...rhe(e),
  options: [e, t]
}), mhe = (e, t) => ({
  ...fhe(e),
  options: [e, t]
});
var khe = "Arrow", nl = p.forwardRef((e, t) => {
  const { children: a, width: n = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ l.jsx(
    Y.svg,
    {
      ...i,
      ref: t,
      width: n,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? a : /* @__PURE__ */ l.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
nl.displayName = khe;
var ghe = nl, n0 = "Popper", [ol, k1] = at(n0), [vhe, rl] = ol(n0), il = (e) => {
  const { __scopePopper: t, children: a } = e, [n, o] = p.useState(null);
  return /* @__PURE__ */ l.jsx(vhe, { scope: t, anchor: n, onAnchorChange: o, children: a });
};
il.displayName = n0;
var sl = "PopperAnchor", cl = p.forwardRef(
  (e, t) => {
    const { __scopePopper: a, virtualRef: n, ...o } = e, i = rl(sl, a), s = p.useRef(null), c = ye(t, s);
    return p.useEffect(() => {
      i.onAnchorChange((n == null ? void 0 : n.current) || s.current);
    }), n ? null : /* @__PURE__ */ l.jsx(Y.div, { ...o, ref: c });
  }
);
cl.displayName = sl;
var o0 = "PopperContent", [Mhe, whe] = ol(o0), fl = p.forwardRef(
  (e, t) => {
    var O, X, re, ie, fe, ke;
    const {
      __scopePopper: a,
      side: n = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: s = 0,
      arrowPadding: c = 0,
      avoidCollisions: f = !0,
      collisionBoundary: d = [],
      collisionPadding: u = 0,
      sticky: h = "partial",
      hideWhenDetached: y = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: v,
      ...k
    } = e, g = rl(o0, a), [M, w] = p.useState(null), x = ye(t, (Fe) => w(Fe)), [C, L] = p.useState(null), N = Ui(C), j = (N == null ? void 0 : N.width) ?? 0, A = (N == null ? void 0 : N.height) ?? 0, D = n + (i !== "center" ? "-" + i : ""), H = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, Z = Array.isArray(d) ? d : [d], R = Z.length > 0, _ = {
      padding: H,
      boundary: Z.filter(Che),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: R
    }, { refs: T, floatingStyles: G, placement: q, isPositioned: V, middlewareData: B } = che({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: D,
      whileElementsMounted: (...Fe) => ehe(...Fe, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: g.anchor
      },
      middleware: [
        dhe({ mainAxis: o + A, alignmentAxis: s }),
        f && lhe({
          mainAxis: !0,
          crossAxis: !1,
          limiter: h === "partial" ? uhe() : void 0,
          ..._
        }),
        f && hhe({ ..._ }),
        phe({
          ..._,
          apply: ({ elements: Fe, rects: J, availableWidth: lt, availableHeight: nt }) => {
            const { width: gt, height: K1 } = J.reference, At = Fe.floating.style;
            At.setProperty("--radix-popper-available-width", `${lt}px`), At.setProperty("--radix-popper-available-height", `${nt}px`), At.setProperty("--radix-popper-anchor-width", `${gt}px`), At.setProperty("--radix-popper-anchor-height", `${K1}px`);
          }
        }),
        C && mhe({ element: C, padding: c }),
        bhe({ arrowWidth: j, arrowHeight: A }),
        y && yhe({ strategy: "referenceHidden", ..._ })
      ]
    }), [Q, me] = ul(q), be = ct(v);
    We(() => {
      V && (be == null || be());
    }, [V, be]);
    const z = (O = B.arrow) == null ? void 0 : O.x, W = (X = B.arrow) == null ? void 0 : X.y, K = ((re = B.arrow) == null ? void 0 : re.centerOffset) !== 0, [U, ne] = p.useState();
    return We(() => {
      M && ne(window.getComputedStyle(M).zIndex);
    }, [M]), /* @__PURE__ */ l.jsx(
      "div",
      {
        ref: T.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...G,
          transform: V ? G.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: U,
          "--radix-popper-transform-origin": [
            (ie = B.transformOrigin) == null ? void 0 : ie.x,
            (fe = B.transformOrigin) == null ? void 0 : fe.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((ke = B.hide) == null ? void 0 : ke.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ l.jsx(
          Mhe,
          {
            scope: a,
            placedSide: Q,
            onArrowChange: L,
            arrowX: z,
            arrowY: W,
            shouldHideArrow: K,
            children: /* @__PURE__ */ l.jsx(
              Y.div,
              {
                "data-side": Q,
                "data-align": me,
                ...k,
                ref: x,
                style: {
                  ...k.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: V ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
fl.displayName = o0;
var dl = "PopperArrow", xhe = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, ll = p.forwardRef(function(t, a) {
  const { __scopePopper: n, ...o } = t, i = whe(dl, n), s = xhe[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ l.jsx(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ l.jsx(
          ghe,
          {
            ...o,
            ref: a,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
ll.displayName = dl;
function Che(e) {
  return e !== null;
}
var bhe = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var g, M, w;
    const { placement: a, rects: n, middlewareData: o } = t, s = ((g = o.arrow) == null ? void 0 : g.centerOffset) !== 0, c = s ? 0 : e.arrowWidth, f = s ? 0 : e.arrowHeight, [d, u] = ul(a), h = { start: "0%", center: "50%", end: "100%" }[u], y = (((M = o.arrow) == null ? void 0 : M.x) ?? 0) + c / 2, m = (((w = o.arrow) == null ? void 0 : w.y) ?? 0) + f / 2;
    let v = "", k = "";
    return d === "bottom" ? (v = s ? h : `${y}px`, k = `${-f}px`) : d === "top" ? (v = s ? h : `${y}px`, k = `${n.floating.height + f}px`) : d === "right" ? (v = `${-f}px`, k = s ? h : `${m}px`) : d === "left" && (v = `${n.floating.width + f}px`, k = s ? h : `${m}px`), { data: { x: v, y: k } };
  }
});
function ul(e) {
  const [t, a = "center"] = e.split("-");
  return [t, a];
}
var ir = il, In = cl, sr = fl, cr = ll, Lhe = "Portal", Sa = p.forwardRef((e, t) => {
  var c;
  const { container: a, ...n } = e, [o, i] = p.useState(!1);
  We(() => i(!0), []);
  const s = a || o && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
  return s ? j6.createPortal(/* @__PURE__ */ l.jsx(Y.div, { ...n, ref: t }), s) : null;
});
Sa.displayName = Lhe;
function jhe(e, t) {
  return p.useReducer((a, n) => t[a][n] ?? a, e);
}
var mt = (e) => {
  const { present: t, children: a } = e, n = Nhe(t), o = typeof a == "function" ? a({ present: n.isPresent }) : p.Children.only(a), i = ye(n.ref, Ahe(o));
  return typeof a == "function" || n.isPresent ? p.cloneElement(o, { ref: i }) : null;
};
mt.displayName = "Presence";
function Nhe(e) {
  const [t, a] = p.useState(), n = p.useRef({}), o = p.useRef(e), i = p.useRef("none"), s = e ? "mounted" : "unmounted", [c, f] = jhe(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return p.useEffect(() => {
    const d = ao(n.current);
    i.current = c === "mounted" ? d : "none";
  }, [c]), We(() => {
    const d = n.current, u = o.current;
    if (u !== e) {
      const y = i.current, m = ao(d);
      e ? f("MOUNT") : m === "none" || (d == null ? void 0 : d.display) === "none" ? f("UNMOUNT") : f(u && y !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, f]), We(() => {
    if (t) {
      let d;
      const u = t.ownerDocument.defaultView ?? window, h = (m) => {
        const k = ao(n.current).includes(m.animationName);
        if (m.target === t && k && (f("ANIMATION_END"), !o.current)) {
          const g = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", d = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = g);
          });
        }
      }, y = (m) => {
        m.target === t && (i.current = ao(n.current));
      };
      return t.addEventListener("animationstart", y), t.addEventListener("animationcancel", h), t.addEventListener("animationend", h), () => {
        u.clearTimeout(d), t.removeEventListener("animationstart", y), t.removeEventListener("animationcancel", h), t.removeEventListener("animationend", h);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: p.useCallback((d) => {
      d && (n.current = getComputedStyle(d)), a(d);
    }, [])
  };
}
function ao(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Ahe(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
var She = "VisuallyHidden", Tn = p.forwardRef(
  (e, t) => /* @__PURE__ */ l.jsx(
    Y.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Tn.displayName = She;
var Ihe = Tn, [fr, qwe] = at("Tooltip", [
  k1
]), dr = k1(), hl = "TooltipProvider", The = 700, ti = "tooltip.open", [zhe, r0] = fr(hl), pl = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: a = The,
    skipDelayDuration: n = 300,
    disableHoverableContent: o = !1,
    children: i
  } = e, [s, c] = p.useState(!0), f = p.useRef(!1), d = p.useRef(0);
  return p.useEffect(() => {
    const u = d.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ l.jsx(
    zhe,
    {
      scope: t,
      isOpenDelayed: s,
      delayDuration: a,
      onOpen: p.useCallback(() => {
        window.clearTimeout(d.current), c(!1);
      }, []),
      onClose: p.useCallback(() => {
        window.clearTimeout(d.current), d.current = window.setTimeout(
          () => c(!0),
          n
        );
      }, [n]),
      isPointerInTransitRef: f,
      onPointerInTransitChange: p.useCallback((u) => {
        f.current = u;
      }, []),
      disableHoverableContent: o,
      children: i
    }
  );
};
pl.displayName = hl;
var lr = "Tooltip", [Dhe, zn] = fr(lr), yl = (e) => {
  const {
    __scopeTooltip: t,
    children: a,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: i,
    disableHoverableContent: s,
    delayDuration: c
  } = e, f = r0(lr, e.__scopeTooltip), d = dr(t), [u, h] = p.useState(null), y = $e(), m = p.useRef(0), v = s ?? f.disableHoverableContent, k = c ?? f.delayDuration, g = p.useRef(!1), [M = !1, w] = ft({
    prop: n,
    defaultProp: o,
    onChange: (j) => {
      j ? (f.onOpen(), document.dispatchEvent(new CustomEvent(ti))) : f.onClose(), i == null || i(j);
    }
  }), x = p.useMemo(() => M ? g.current ? "delayed-open" : "instant-open" : "closed", [M]), C = p.useCallback(() => {
    window.clearTimeout(m.current), m.current = 0, g.current = !1, w(!0);
  }, [w]), L = p.useCallback(() => {
    window.clearTimeout(m.current), m.current = 0, w(!1);
  }, [w]), N = p.useCallback(() => {
    window.clearTimeout(m.current), m.current = window.setTimeout(() => {
      g.current = !0, w(!0), m.current = 0;
    }, k);
  }, [k, w]);
  return p.useEffect(() => () => {
    m.current && (window.clearTimeout(m.current), m.current = 0);
  }, []), /* @__PURE__ */ l.jsx(ir, { ...d, children: /* @__PURE__ */ l.jsx(
    Dhe,
    {
      scope: t,
      contentId: y,
      open: M,
      stateAttribute: x,
      trigger: u,
      onTriggerChange: h,
      onTriggerEnter: p.useCallback(() => {
        f.isOpenDelayed ? N() : C();
      }, [f.isOpenDelayed, N, C]),
      onTriggerLeave: p.useCallback(() => {
        v ? L() : (window.clearTimeout(m.current), m.current = 0);
      }, [L, v]),
      onOpen: C,
      onClose: L,
      disableHoverableContent: v,
      children: a
    }
  ) });
};
yl.displayName = lr;
var ai = "TooltipTrigger", ml = p.forwardRef(
  (e, t) => {
    const { __scopeTooltip: a, ...n } = e, o = zn(ai, a), i = r0(ai, a), s = dr(a), c = p.useRef(null), f = ye(t, c, o.onTriggerChange), d = p.useRef(!1), u = p.useRef(!1), h = p.useCallback(() => d.current = !1, []);
    return p.useEffect(() => () => document.removeEventListener("pointerup", h), [h]), /* @__PURE__ */ l.jsx(In, { asChild: !0, ...s, children: /* @__PURE__ */ l.jsx(
      Y.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...n,
        ref: f,
        onPointerMove: F(e.onPointerMove, (y) => {
          y.pointerType !== "touch" && !u.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: F(e.onPointerLeave, () => {
          o.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: F(e.onPointerDown, () => {
          d.current = !0, document.addEventListener("pointerup", h, { once: !0 });
        }),
        onFocus: F(e.onFocus, () => {
          d.current || o.onOpen();
        }),
        onBlur: F(e.onBlur, o.onClose),
        onClick: F(e.onClick, o.onClose)
      }
    ) });
  }
);
ml.displayName = ai;
var i0 = "TooltipPortal", [_he, Phe] = fr(i0, {
  forceMount: void 0
}), kl = (e) => {
  const { __scopeTooltip: t, forceMount: a, children: n, container: o } = e, i = zn(i0, t);
  return /* @__PURE__ */ l.jsx(_he, { scope: t, forceMount: a, children: /* @__PURE__ */ l.jsx(mt, { present: a || i.open, children: /* @__PURE__ */ l.jsx(Sa, { asChild: !0, container: o, children: n }) }) });
};
kl.displayName = i0;
var ga = "TooltipContent", gl = p.forwardRef(
  (e, t) => {
    const a = Phe(ga, e.__scopeTooltip), { forceMount: n = a.forceMount, side: o = "top", ...i } = e, s = zn(ga, e.__scopeTooltip);
    return /* @__PURE__ */ l.jsx(mt, { present: n || s.open, children: s.disableHoverableContent ? /* @__PURE__ */ l.jsx(vl, { side: o, ...i, ref: t }) : /* @__PURE__ */ l.jsx(Ehe, { side: o, ...i, ref: t }) });
  }
), Ehe = p.forwardRef((e, t) => {
  const a = zn(ga, e.__scopeTooltip), n = r0(ga, e.__scopeTooltip), o = p.useRef(null), i = ye(t, o), [s, c] = p.useState(null), { trigger: f, onClose: d } = a, u = o.current, { onPointerInTransitChange: h } = n, y = p.useCallback(() => {
    c(null), h(!1);
  }, [h]), m = p.useCallback(
    (v, k) => {
      const g = v.currentTarget, M = { x: v.clientX, y: v.clientY }, w = Vhe(M, g.getBoundingClientRect()), x = Ohe(M, w), C = qhe(k.getBoundingClientRect()), L = Zhe([...x, ...C]);
      c(L), h(!0);
    },
    [h]
  );
  return p.useEffect(() => () => y(), [y]), p.useEffect(() => {
    if (f && u) {
      const v = (g) => m(g, u), k = (g) => m(g, f);
      return f.addEventListener("pointerleave", v), u.addEventListener("pointerleave", k), () => {
        f.removeEventListener("pointerleave", v), u.removeEventListener("pointerleave", k);
      };
    }
  }, [f, u, m, y]), p.useEffect(() => {
    if (s) {
      const v = (k) => {
        const g = k.target, M = { x: k.clientX, y: k.clientY }, w = (f == null ? void 0 : f.contains(g)) || (u == null ? void 0 : u.contains(g)), x = !Bhe(M, s);
        w ? y() : x && (y(), d());
      };
      return document.addEventListener("pointermove", v), () => document.removeEventListener("pointermove", v);
    }
  }, [f, u, s, d, y]), /* @__PURE__ */ l.jsx(vl, { ...e, ref: i });
}), [Rhe, Hhe] = fr(lr, { isInside: !1 }), vl = p.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: a,
      children: n,
      "aria-label": o,
      onEscapeKeyDown: i,
      onPointerDownOutside: s,
      ...c
    } = e, f = zn(ga, a), d = dr(a), { onClose: u } = f;
    return p.useEffect(() => (document.addEventListener(ti, u), () => document.removeEventListener(ti, u)), [u]), p.useEffect(() => {
      if (f.trigger) {
        const h = (y) => {
          const m = y.target;
          m != null && m.contains(f.trigger) && u();
        };
        return window.addEventListener("scroll", h, { capture: !0 }), () => window.removeEventListener("scroll", h, { capture: !0 });
      }
    }, [f.trigger, u]), /* @__PURE__ */ l.jsx(
      F1,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: s,
        onFocusOutside: (h) => h.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ l.jsxs(
          sr,
          {
            "data-state": f.stateAttribute,
            ...d,
            ...c,
            ref: t,
            style: {
              ...c.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ l.jsx(Dd, { children: n }),
              /* @__PURE__ */ l.jsx(Rhe, { scope: a, isInside: !0, children: /* @__PURE__ */ l.jsx(Ihe, { id: f.contentId, role: "tooltip", children: o || n }) })
            ]
          }
        )
      }
    );
  }
);
gl.displayName = ga;
var Ml = "TooltipArrow", wl = p.forwardRef(
  (e, t) => {
    const { __scopeTooltip: a, ...n } = e, o = dr(a);
    return Hhe(
      Ml,
      a
    ).isInside ? null : /* @__PURE__ */ l.jsx(cr, { ...o, ...n, ref: t });
  }
);
wl.displayName = Ml;
function Vhe(e, t) {
  const a = Math.abs(t.top - e.y), n = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(a, n, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case a:
      return "top";
    case n:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Ohe(e, t, a = 5) {
  const n = [];
  switch (t) {
    case "top":
      n.push(
        { x: e.x - a, y: e.y + a },
        { x: e.x + a, y: e.y + a }
      );
      break;
    case "bottom":
      n.push(
        { x: e.x - a, y: e.y - a },
        { x: e.x + a, y: e.y - a }
      );
      break;
    case "left":
      n.push(
        { x: e.x + a, y: e.y - a },
        { x: e.x + a, y: e.y + a }
      );
      break;
    case "right":
      n.push(
        { x: e.x - a, y: e.y - a },
        { x: e.x - a, y: e.y + a }
      );
      break;
  }
  return n;
}
function qhe(e) {
  const { top: t, right: a, bottom: n, left: o } = e;
  return [
    { x: o, y: t },
    { x: a, y: t },
    { x: a, y: n },
    { x: o, y: n }
  ];
}
function Bhe(e, t) {
  const { x: a, y: n } = e;
  let o = !1;
  for (let i = 0, s = t.length - 1; i < t.length; s = i++) {
    const c = t[i].x, f = t[i].y, d = t[s].x, u = t[s].y;
    f > n != u > n && a < (d - c) * (n - f) / (u - f) + c && (o = !o);
  }
  return o;
}
function Zhe(e) {
  const t = e.slice();
  return t.sort((a, n) => a.x < n.x ? -1 : a.x > n.x ? 1 : a.y < n.y ? -1 : a.y > n.y ? 1 : 0), Fhe(t);
}
function Fhe(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], s = t[t.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const a = [];
  for (let n = e.length - 1; n >= 0; n--) {
    const o = e[n];
    for (; a.length >= 2; ) {
      const i = a[a.length - 1], s = a[a.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x)) a.pop();
      else break;
    }
    a.push(o);
  }
  return a.pop(), t.length === 1 && a.length === 1 && t[0].x === a[0].x && t[0].y === a[0].y ? t : t.concat(a);
}
var xl = pl, Ghe = yl, $he = ml, Uhe = kl, Whe = gl, Yhe = wl;
const s0 = Wt({});
function c0(e) {
  const t = Le(null);
  return t.current === null && (t.current = e()), t.current;
}
const ur = Wt(null), f0 = Wt({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
class Qhe extends p.Component {
  getSnapshotBeforeUpdate(t) {
    const a = this.props.childRef.current;
    if (a && t.isPresent && !this.props.isPresent) {
      const n = this.props.sizeRef.current;
      n.height = a.offsetHeight || 0, n.width = a.offsetWidth || 0, n.top = a.offsetTop, n.left = a.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function Jhe({ children: e, isPresent: t }) {
  const a = Zi(), n = Le(null), o = Le({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }), { nonce: i } = xe(f0);
  return wd(() => {
    const { width: s, height: c, top: f, left: d } = o.current;
    if (t || !n.current || !s || !c)
      return;
    n.current.dataset.motionPopId = a;
    const u = document.createElement("style");
    return i && (u.nonce = i), document.head.appendChild(u), u.sheet && u.sheet.insertRule(`
          [data-motion-pop-id="${a}"] {
            position: absolute !important;
            width: ${s}px !important;
            height: ${c}px !important;
            top: ${f}px !important;
            left: ${d}px !important;
          }
        `), () => {
      document.head.removeChild(u);
    };
  }, [t]), l.jsx(Qhe, { isPresent: t, childRef: n, sizeRef: o, children: p.cloneElement(e, { ref: n }) });
}
const Khe = ({ children: e, initial: t, isPresent: a, onExitComplete: n, custom: o, presenceAffectsLayout: i, mode: s }) => {
  const c = c0(Xhe), f = Zi(), d = Ve((h) => {
    c.set(h, !0);
    for (const y of c.values())
      if (!y)
        return;
    n && n();
  }, [c, n]), u = Ke(
    () => ({
      id: f,
      initial: t,
      isPresent: a,
      custom: o,
      onExitComplete: d,
      register: (h) => (c.set(h, !1), () => c.delete(h))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    i ? [Math.random(), d] : [a, d]
  );
  return Ke(() => {
    c.forEach((h, y) => c.set(y, !1));
  }, [a]), p.useEffect(() => {
    !a && !c.size && n && n();
  }, [a]), s === "popLayout" && (e = l.jsx(Jhe, { isPresent: a, children: e })), l.jsx(ur.Provider, { value: u, children: e });
};
function Xhe() {
  return /* @__PURE__ */ new Map();
}
function Cl(e = !0) {
  const t = xe(ur);
  if (t === null)
    return [!0, null];
  const { isPresent: a, onExitComplete: n, register: o } = t, i = Zi();
  Ne(() => {
    e && o(i);
  }, [e]);
  const s = Ve(() => e && n && n(i), [i, n, e]);
  return !a && n ? [!1, s] : [!0];
}
const no = (e) => e.key || "";
function hc(e) {
  const t = [];
  return C6.forEach(e, (a) => {
    b6(a) && t.push(a);
  }), t;
}
const d0 = typeof window < "u", bl = d0 ? er : Ne, e3e = ({ children: e, custom: t, initial: a = !0, onExitComplete: n, presenceAffectsLayout: o = !0, mode: i = "sync", propagate: s = !1 }) => {
  const [c, f] = Cl(s), d = Ke(() => hc(e), [e]), u = s && !c ? [] : d.map(no), h = Le(!0), y = Le(d), m = c0(() => /* @__PURE__ */ new Map()), [v, k] = ve(d), [g, M] = ve(d);
  bl(() => {
    h.current = !1, y.current = d;
    for (let C = 0; C < g.length; C++) {
      const L = no(g[C]);
      u.includes(L) ? m.delete(L) : m.get(L) !== !0 && m.set(L, !1);
    }
  }, [g, u.length, u.join("-")]);
  const w = [];
  if (d !== v) {
    let C = [...d];
    for (let L = 0; L < g.length; L++) {
      const N = g[L], j = no(N);
      u.includes(j) || (C.splice(L, 0, N), w.push(N));
    }
    i === "wait" && w.length && (C = w), M(hc(C)), k(d);
    return;
  }
  process.env.NODE_ENV !== "production" && i === "wait" && g.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: x } = xe(s0);
  return l.jsx(l.Fragment, { children: g.map((C) => {
    const L = no(C), N = s && !c ? !1 : d === g || u.includes(L), j = () => {
      if (m.has(L))
        m.set(L, !0);
      else
        return;
      let A = !0;
      m.forEach((D) => {
        D || (A = !1);
      }), A && (x == null || x(), M(y.current), s && (f == null || f()), n && n());
    };
    return l.jsx(Khe, { isPresent: N, initial: !h.current || a ? void 0 : !1, custom: N ? void 0 : t, presenceAffectsLayout: o, mode: i, onExitComplete: N ? void 0 : j, children: C }, L);
  }) });
}, st = /* @__NO_SIDE_EFFECTS__ */ (e) => e;
let Ia = st, u1 = st;
process.env.NODE_ENV !== "production" && (Ia = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, u1 = (e, t) => {
  if (!e)
    throw new Error(t);
});
// @__NO_SIDE_EFFECTS__
function l0(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const va = /* @__NO_SIDE_EFFECTS__ */ (e, t, a) => {
  const n = t - e;
  return n === 0 ? 1 : (a - e) / n;
}, Ft = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, Jt = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3, t3e = {
  useManualTiming: !1
};
function a3e(e) {
  let t = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set(), n = !1, o = !1;
  const i = /* @__PURE__ */ new WeakSet();
  let s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function c(d) {
    i.has(d) && (f.schedule(d), e()), d(s);
  }
  const f = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (d, u = !1, h = !1) => {
      const m = h && n ? t : a;
      return u && i.add(d), m.has(d) || m.add(d), d;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (d) => {
      a.delete(d), i.delete(d);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (d) => {
      if (s = d, n) {
        o = !0;
        return;
      }
      n = !0, [t, a] = [a, t], t.forEach(c), t.clear(), n = !1, o && (o = !1, f.process(d));
    }
  };
  return f;
}
const oo = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], n3e = 40;
function Ll(e, t) {
  let a = !1, n = !0;
  const o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = () => a = !0, s = oo.reduce((M, w) => (M[w] = a3e(i), M), {}), { read: c, resolveKeyframes: f, update: d, preRender: u, render: h, postRender: y } = s, m = () => {
    const M = performance.now();
    a = !1, o.delta = n ? 1e3 / 60 : Math.max(Math.min(M - o.timestamp, n3e), 1), o.timestamp = M, o.isProcessing = !0, c.process(o), f.process(o), d.process(o), u.process(o), h.process(o), y.process(o), o.isProcessing = !1, a && t && (n = !1, e(m));
  }, v = () => {
    a = !0, n = !0, o.isProcessing || e(m);
  };
  return { schedule: oo.reduce((M, w) => {
    const x = s[w];
    return M[w] = (C, L = !1, N = !1) => (a || v(), x.schedule(C, L, N)), M;
  }, {}), cancel: (M) => {
    for (let w = 0; w < oo.length; w++)
      s[oo[w]].cancel(M);
  }, state: o, steps: s };
}
const { schedule: Se, cancel: h1, state: Ue, steps: s2 } = Ll(typeof requestAnimationFrame < "u" ? requestAnimationFrame : st, !0), jl = Wt({ strict: !1 }), pc = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, Ma = {};
for (const e in pc)
  Ma[e] = {
    isEnabled: (t) => pc[e].some((a) => !!t[a])
  };
function o3e(e) {
  for (const t in e)
    Ma[t] = {
      ...Ma[t],
      ...e[t]
    };
}
const r3e = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Ro(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || r3e.has(e);
}
let Nl = (e) => !Ro(e);
function i3e(e) {
  e && (Nl = (t) => t.startsWith("on") ? !Ro(t) : e(t));
}
try {
  i3e(require("@emotion/is-prop-valid").default);
} catch {
}
function s3e(e, t, a) {
  const n = {};
  for (const o in e)
    o === "values" && typeof e.values == "object" || (Nl(o) || a === !0 && Ro(o) || !t && !Ro(o) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && o.startsWith("onDrag")) && (n[o] = e[o]);
  return n;
}
const yc = /* @__PURE__ */ new Set();
function hr(e, t, a) {
  e || yc.has(t) || (console.warn(t), yc.add(t));
}
function c3e(e) {
  if (typeof Proxy > "u")
    return e;
  const t = /* @__PURE__ */ new Map(), a = (...n) => (process.env.NODE_ENV !== "production" && hr(!1, "motion() is deprecated. Use motion.create() instead."), e(...n));
  return new Proxy(a, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (n, o) => o === "create" ? e : (t.has(o) || t.set(o, e(o)), t.get(o))
  });
}
const pr = Wt({});
function yn(e) {
  return typeof e == "string" || Array.isArray(e);
}
function yr(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
const u0 = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], h0 = ["initial", ...u0];
function mr(e) {
  return yr(e.animate) || h0.some((t) => yn(e[t]));
}
function Al(e) {
  return !!(mr(e) || e.variants);
}
function f3e(e, t) {
  if (mr(e)) {
    const { initial: a, animate: n } = e;
    return {
      initial: a === !1 || yn(a) ? a : void 0,
      animate: yn(n) ? n : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function d3e(e) {
  const { initial: t, animate: a } = f3e(e, xe(pr));
  return Ke(() => ({ initial: t, animate: a }), [mc(t), mc(a)]);
}
function mc(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const l3e = Symbol.for("motionComponentSymbol");
function sa(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function u3e(e, t, a) {
  return Ve(
    (n) => {
      n && e.onMount && e.onMount(n), t && (n ? t.mount(n) : t.unmount()), a && (typeof a == "function" ? a(n) : sa(a) && (a.current = n));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
const p0 = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), h3e = "framerAppearId", Sl = "data-" + p0(h3e), { schedule: y0 } = Ll(queueMicrotask, !1), Il = Wt({});
function p3e(e, t, a, n, o) {
  var i, s;
  const { visualElement: c } = xe(pr), f = xe(jl), d = xe(ur), u = xe(f0).reducedMotion, h = Le(null);
  n = n || f.renderer, !h.current && n && (h.current = n(e, {
    visualState: t,
    parent: c,
    props: a,
    presenceContext: d,
    blockInitialAnimation: d ? d.initial === !1 : !1,
    reducedMotionConfig: u
  }));
  const y = h.current, m = xe(Il);
  y && !y.projection && o && (y.type === "html" || y.type === "svg") && y3e(h.current, a, o, m);
  const v = Le(!1);
  wd(() => {
    y && v.current && y.update(a, d);
  });
  const k = a[Sl], g = Le(!!k && !(!((i = window.MotionHandoffIsComplete) === null || i === void 0) && i.call(window, k)) && ((s = window.MotionHasOptimisedAnimation) === null || s === void 0 ? void 0 : s.call(window, k)));
  return bl(() => {
    y && (v.current = !0, window.MotionIsMounted = !0, y.updateFeatures(), y0.render(y.render), g.current && y.animationState && y.animationState.animateChanges());
  }), Ne(() => {
    y && (!g.current && y.animationState && y.animationState.animateChanges(), g.current && (queueMicrotask(() => {
      var M;
      (M = window.MotionHandoffMarkAsComplete) === null || M === void 0 || M.call(window, k);
    }), g.current = !1));
  }), y;
}
function y3e(e, t, a, n) {
  const { layoutId: o, layout: i, drag: s, dragConstraints: c, layoutScroll: f, layoutRoot: d } = t;
  e.projection = new a(e.latestValues, t["data-framer-portal-id"] ? void 0 : Tl(e.parent)), e.projection.setOptions({
    layoutId: o,
    layout: i,
    alwaysMeasureLayout: !!s || c && sa(c),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof i == "string" ? i : "both",
    initialPromotionConfig: n,
    layoutScroll: f,
    layoutRoot: d
  });
}
function Tl(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : Tl(e.parent);
}
function m3e({ preloadedFeatures: e, createVisualElement: t, useRender: a, useVisualState: n, Component: o }) {
  var i, s;
  e && o3e(e);
  function c(d, u) {
    let h;
    const y = {
      ...xe(f0),
      ...d,
      layoutId: k3e(d)
    }, { isStatic: m } = y, v = d3e(d), k = n(d, m);
    if (!m && d0) {
      g3e(y, e);
      const g = v3e(y);
      h = g.MeasureLayout, v.visualElement = p3e(o, k, y, t, g.ProjectionNode);
    }
    return l.jsxs(pr.Provider, { value: v, children: [h && v.visualElement ? l.jsx(h, { visualElement: v.visualElement, ...y }) : null, a(o, d, u3e(k, v.visualElement, u), k, m, v.visualElement)] });
  }
  c.displayName = `motion.${typeof o == "string" ? o : `create(${(s = (i = o.displayName) !== null && i !== void 0 ? i : o.name) !== null && s !== void 0 ? s : ""})`}`;
  const f = Et(c);
  return f[l3e] = o, f;
}
function k3e({ layoutId: e }) {
  const t = xe(s0).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function g3e(e, t) {
  const a = xe(jl).strict;
  if (process.env.NODE_ENV !== "production" && t && a) {
    const n = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? Ia(!1, n) : u1(!1, n);
  }
}
function v3e(e) {
  const { drag: t, layout: a } = Ma;
  if (!t && !a)
    return {};
  const n = { ...t, ...a };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || a != null && a.isEnabled(e) ? n.MeasureLayout : void 0,
    ProjectionNode: n.ProjectionNode
  };
}
const M3e = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function m0(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(M3e.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function kc(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((a, n) => {
    t[0][n] = a.get(), t[1][n] = a.getVelocity();
  }), t;
}
function k0(e, t, a, n) {
  if (typeof t == "function") {
    const [o, i] = kc(n);
    t = t(a !== void 0 ? a : e.custom, o, i);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [o, i] = kc(n);
    t = t(a !== void 0 ? a : e.custom, o, i);
  }
  return t;
}
const ni = (e) => Array.isArray(e), w3e = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), x3e = (e) => ni(e) ? e[e.length - 1] || 0 : e, Je = (e) => !!(e && e.getVelocity);
function wo(e) {
  const t = Je(e) ? e.get() : e;
  return w3e(t) ? t.toValue() : t;
}
function C3e({ scrapeMotionValuesFromProps: e, createRenderState: t, onUpdate: a }, n, o, i) {
  const s = {
    latestValues: b3e(n, o, i, e),
    renderState: t()
  };
  return a && (s.onMount = (c) => a({ props: n, current: c, ...s }), s.onUpdate = (c) => a(c)), s;
}
const zl = (e) => (t, a) => {
  const n = xe(pr), o = xe(ur), i = () => C3e(e, t, n, o);
  return a ? i() : c0(i);
};
function b3e(e, t, a, n) {
  const o = {}, i = n(e, {});
  for (const y in i)
    o[y] = wo(i[y]);
  let { initial: s, animate: c } = e;
  const f = mr(e), d = Al(e);
  t && d && !f && e.inherit !== !1 && (s === void 0 && (s = t.initial), c === void 0 && (c = t.animate));
  let u = a ? a.initial === !1 : !1;
  u = u || s === !1;
  const h = u ? c : s;
  if (h && typeof h != "boolean" && !yr(h)) {
    const y = Array.isArray(h) ? h : [h];
    for (let m = 0; m < y.length; m++) {
      const v = k0(e, y[m]);
      if (v) {
        const { transitionEnd: k, transition: g, ...M } = v;
        for (const w in M) {
          let x = M[w];
          if (Array.isArray(x)) {
            const C = u ? x.length - 1 : 0;
            x = x[C];
          }
          x !== null && (o[w] = x);
        }
        for (const w in k)
          o[w] = k[w];
      }
    }
  }
  return o;
}
const Ta = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], G1 = new Set(Ta), Dl = (e) => (t) => typeof t == "string" && t.startsWith(e), _l = /* @__PURE__ */ Dl("--"), L3e = /* @__PURE__ */ Dl("var(--"), g0 = (e) => L3e(e) ? j3e.test(e.split("/*")[0].trim()) : !1, j3e = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, Pl = (e, t) => t && typeof e == "number" ? t.transform(e) : e, e1 = (e, t, a) => a > t ? t : a < e ? e : a, za = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, mn = {
  ...za,
  transform: (e) => e1(0, 1, e)
}, ro = {
  ...za,
  default: 1
}, Dn = (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), i1 = /* @__PURE__ */ Dn("deg"), Gt = /* @__PURE__ */ Dn("%"), te = /* @__PURE__ */ Dn("px"), N3e = /* @__PURE__ */ Dn("vh"), A3e = /* @__PURE__ */ Dn("vw"), gc = {
  ...Gt,
  parse: (e) => Gt.parse(e) / 100,
  transform: (e) => Gt.transform(e * 100)
}, S3e = {
  // Border props
  borderWidth: te,
  borderTopWidth: te,
  borderRightWidth: te,
  borderBottomWidth: te,
  borderLeftWidth: te,
  borderRadius: te,
  radius: te,
  borderTopLeftRadius: te,
  borderTopRightRadius: te,
  borderBottomRightRadius: te,
  borderBottomLeftRadius: te,
  // Positioning props
  width: te,
  maxWidth: te,
  height: te,
  maxHeight: te,
  top: te,
  right: te,
  bottom: te,
  left: te,
  // Spacing props
  padding: te,
  paddingTop: te,
  paddingRight: te,
  paddingBottom: te,
  paddingLeft: te,
  margin: te,
  marginTop: te,
  marginRight: te,
  marginBottom: te,
  marginLeft: te,
  // Misc
  backgroundPositionX: te,
  backgroundPositionY: te
}, I3e = {
  rotate: i1,
  rotateX: i1,
  rotateY: i1,
  rotateZ: i1,
  scale: ro,
  scaleX: ro,
  scaleY: ro,
  scaleZ: ro,
  skew: i1,
  skewX: i1,
  skewY: i1,
  distance: te,
  translateX: te,
  translateY: te,
  translateZ: te,
  x: te,
  y: te,
  z: te,
  perspective: te,
  transformPerspective: te,
  opacity: mn,
  originX: gc,
  originY: gc,
  originZ: te
}, vc = {
  ...za,
  transform: Math.round
}, v0 = {
  ...S3e,
  ...I3e,
  zIndex: vc,
  size: te,
  // SVG
  fillOpacity: mn,
  strokeOpacity: mn,
  numOctaves: vc
}, T3e = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, z3e = Ta.length;
function D3e(e, t, a) {
  let n = "", o = !0;
  for (let i = 0; i < z3e; i++) {
    const s = Ta[i], c = e[s];
    if (c === void 0)
      continue;
    let f = !0;
    if (typeof c == "number" ? f = c === (s.startsWith("scale") ? 1 : 0) : f = parseFloat(c) === 0, !f || a) {
      const d = Pl(c, v0[s]);
      if (!f) {
        o = !1;
        const u = T3e[s] || s;
        n += `${u}(${d}) `;
      }
      a && (t[s] = d);
    }
  }
  return n = n.trim(), a ? n = a(t, o ? "" : n) : o && (n = "none"), n;
}
function M0(e, t, a) {
  const { style: n, vars: o, transformOrigin: i } = e;
  let s = !1, c = !1;
  for (const f in t) {
    const d = t[f];
    if (G1.has(f)) {
      s = !0;
      continue;
    } else if (_l(f)) {
      o[f] = d;
      continue;
    } else {
      const u = Pl(d, v0[f]);
      f.startsWith("origin") ? (c = !0, i[f] = u) : n[f] = u;
    }
  }
  if (t.transform || (s || a ? n.transform = D3e(t, e.transform, a) : n.transform && (n.transform = "none")), c) {
    const { originX: f = "50%", originY: d = "50%", originZ: u = 0 } = i;
    n.transformOrigin = `${f} ${d} ${u}`;
  }
}
const _3e = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, P3e = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function E3e(e, t, a = 1, n = 0, o = !0) {
  e.pathLength = 1;
  const i = o ? _3e : P3e;
  e[i.offset] = te.transform(-n);
  const s = te.transform(t), c = te.transform(a);
  e[i.array] = `${s} ${c}`;
}
function Mc(e, t, a) {
  return typeof e == "string" ? e : te.transform(t + a * e);
}
function R3e(e, t, a) {
  const n = Mc(t, e.x, e.width), o = Mc(a, e.y, e.height);
  return `${n} ${o}`;
}
function w0(e, {
  attrX: t,
  attrY: a,
  attrScale: n,
  originX: o,
  originY: i,
  pathLength: s,
  pathSpacing: c = 1,
  pathOffset: f = 0,
  // This is object creation, which we try to avoid per-frame.
  ...d
}, u, h) {
  if (M0(e, d, h), u) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: y, style: m, dimensions: v } = e;
  y.transform && (v && (m.transform = y.transform), delete y.transform), v && (o !== void 0 || i !== void 0 || m.transform) && (m.transformOrigin = R3e(v, o !== void 0 ? o : 0.5, i !== void 0 ? i : 0.5)), t !== void 0 && (y.x = t), a !== void 0 && (y.y = a), n !== void 0 && (y.scale = n), s !== void 0 && E3e(y, s, c, f, !1);
}
const x0 = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), El = () => ({
  ...x0(),
  attrs: {}
}), C0 = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function Rl(e, { style: t, vars: a }, n, o) {
  Object.assign(e.style, t, o && o.getProjectionStyles(n));
  for (const i in a)
    e.style.setProperty(i, a[i]);
}
const Hl = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function Vl(e, t, a, n) {
  Rl(e, t, void 0, n);
  for (const o in t.attrs)
    e.setAttribute(Hl.has(o) ? o : p0(o), t.attrs[o]);
}
const Ho = {};
function H3e(e) {
  Object.assign(Ho, e);
}
function Ol(e, { layout: t, layoutId: a }) {
  return G1.has(e) || e.startsWith("origin") || (t || a !== void 0) && (!!Ho[e] || e === "opacity");
}
function b0(e, t, a) {
  var n;
  const { style: o } = e, i = {};
  for (const s in o)
    (Je(o[s]) || t.style && Je(t.style[s]) || Ol(s, e) || ((n = a == null ? void 0 : a.getValue(s)) === null || n === void 0 ? void 0 : n.liveStyle) !== void 0) && (i[s] = o[s]);
  return i;
}
function ql(e, t, a) {
  const n = b0(e, t, a);
  for (const o in e)
    if (Je(e[o]) || Je(t[o])) {
      const i = Ta.indexOf(o) !== -1 ? "attr" + o.charAt(0).toUpperCase() + o.substring(1) : o;
      n[i] = e[o];
    }
  return n;
}
function V3e(e, t) {
  try {
    t.dimensions = typeof e.getBBox == "function" ? e.getBBox() : e.getBoundingClientRect();
  } catch {
    t.dimensions = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
}
const wc = ["x", "y", "width", "height", "cx", "cy", "r"], O3e = {
  useVisualState: zl({
    scrapeMotionValuesFromProps: ql,
    createRenderState: El,
    onUpdate: ({ props: e, prevProps: t, current: a, renderState: n, latestValues: o }) => {
      if (!a)
        return;
      let i = !!e.drag;
      if (!i) {
        for (const c in o)
          if (G1.has(c)) {
            i = !0;
            break;
          }
      }
      if (!i)
        return;
      let s = !t;
      if (t)
        for (let c = 0; c < wc.length; c++) {
          const f = wc[c];
          e[f] !== t[f] && (s = !0);
        }
      s && Se.read(() => {
        V3e(a, n), Se.render(() => {
          w0(n, o, C0(a.tagName), e.transformTemplate), Vl(a, n);
        });
      });
    }
  })
}, q3e = {
  useVisualState: zl({
    scrapeMotionValuesFromProps: b0,
    createRenderState: x0
  })
};
function Bl(e, t, a) {
  for (const n in t)
    !Je(t[n]) && !Ol(n, a) && (e[n] = t[n]);
}
function B3e({ transformTemplate: e }, t) {
  return Ke(() => {
    const a = x0();
    return M0(a, t, e), Object.assign({}, a.vars, a.style);
  }, [t]);
}
function Z3e(e, t) {
  const a = e.style || {}, n = {};
  return Bl(n, a, e), Object.assign(n, B3e(e, t)), n;
}
function F3e(e, t) {
  const a = {}, n = Z3e(e, t);
  return e.drag && e.dragListener !== !1 && (a.draggable = !1, n.userSelect = n.WebkitUserSelect = n.WebkitTouchCallout = "none", n.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (a.tabIndex = 0), a.style = n, a;
}
function G3e(e, t, a, n) {
  const o = Ke(() => {
    const i = El();
    return w0(i, t, C0(n), e.transformTemplate), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [t]);
  if (e.style) {
    const i = {};
    Bl(i, e.style, e), o.style = { ...i, ...o.style };
  }
  return o;
}
function $3e(e = !1) {
  return (a, n, o, { latestValues: i }, s) => {
    const f = (m0(a) ? G3e : F3e)(n, i, s, a), d = s3e(n, typeof a == "string", e), u = a !== Nn ? { ...d, ...f, ref: o } : {}, { children: h } = n, y = Ke(() => Je(h) ? h.get() : h, [h]);
    return P(a, {
      ...u,
      children: y
    });
  };
}
function U3e(e, t) {
  return function(n, { forwardMotionProps: o } = { forwardMotionProps: !1 }) {
    const s = {
      ...m0(n) ? O3e : q3e,
      preloadedFeatures: e,
      useRender: $3e(o),
      createVisualElement: t,
      Component: n
    };
    return m3e(s);
  };
}
function Zl(e, t) {
  if (!Array.isArray(t))
    return !1;
  const a = t.length;
  if (a !== e.length)
    return !1;
  for (let n = 0; n < a; n++)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function kr(e, t, a) {
  const n = e.getProps();
  return k0(n, t, a !== void 0 ? a : n.custom, e);
}
const W3e = /* @__PURE__ */ l0(() => window.ScrollTimeline !== void 0);
class Y3e {
  constructor(t) {
    this.stop = () => this.runAll("stop"), this.animations = t.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((t) => "finished" in t ? t.finished : t));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(t) {
    return this.animations[0][t];
  }
  setAll(t, a) {
    for (let n = 0; n < this.animations.length; n++)
      this.animations[n][t] = a;
  }
  attachTimeline(t, a) {
    const n = this.animations.map((o) => {
      if (W3e() && o.attachTimeline)
        return o.attachTimeline(t);
      if (typeof a == "function")
        return a(o);
    });
    return () => {
      n.forEach((o, i) => {
        o && o(), this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(t) {
    this.setAll("time", t);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(t) {
    this.setAll("speed", t);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let t = 0;
    for (let a = 0; a < this.animations.length; a++)
      t = Math.max(t, this.animations[a].duration);
    return t;
  }
  runAll(t) {
    this.animations.forEach((a) => a[t]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
class Q3e extends Y3e {
  then(t, a) {
    return Promise.all(this.animations).then(t).catch(a);
  }
}
function L0(e, t) {
  return e ? e[t] || e.default || e : void 0;
}
const oi = 2e4;
function Fl(e) {
  let t = 0;
  const a = 50;
  let n = e.next(t);
  for (; !n.done && t < oi; )
    t += a, n = e.next(t);
  return t >= oi ? 1 / 0 : t;
}
function j0(e) {
  return typeof e == "function";
}
function xc(e, t) {
  e.timeline = t, e.onfinish = null;
}
const N0 = (e) => Array.isArray(e) && typeof e[0] == "number", J3e = {
  linearEasing: void 0
};
function K3e(e, t) {
  const a = /* @__PURE__ */ l0(e);
  return () => {
    var n;
    return (n = J3e[t]) !== null && n !== void 0 ? n : a();
  };
}
const Vo = /* @__PURE__ */ K3e(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Gl = (e, t, a = 10) => {
  let n = "";
  const o = Math.max(Math.round(t / a), 2);
  for (let i = 0; i < o; i++)
    n += e(/* @__PURE__ */ va(0, o - 1, i)) + ", ";
  return `linear(${n.substring(0, n.length - 2)})`;
};
function $l(e) {
  return !!(typeof e == "function" && Vo() || !e || typeof e == "string" && (e in ri || Vo()) || N0(e) || Array.isArray(e) && e.every($l));
}
const en = ([e, t, a, n]) => `cubic-bezier(${e}, ${t}, ${a}, ${n})`, ri = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ en([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ en([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ en([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ en([0.33, 1.53, 0.69, 0.99])
};
function Ul(e, t) {
  if (e)
    return typeof e == "function" && Vo() ? Gl(e, t) : N0(e) ? en(e) : Array.isArray(e) ? e.map((a) => Ul(a, t) || ri.easeOut) : ri[e];
}
const St = {
  x: !1,
  y: !1
};
function Wl() {
  return St.x || St.y;
}
function X3e(e, t, a) {
  var n;
  if (e instanceof Element)
    return [e];
  if (typeof e == "string") {
    let o = document;
    const i = (n = void 0) !== null && n !== void 0 ? n : o.querySelectorAll(e);
    return i ? Array.from(i) : [];
  }
  return Array.from(e);
}
function Yl(e, t) {
  const a = X3e(e), n = new AbortController(), o = {
    passive: !0,
    ...t,
    signal: n.signal
  };
  return [a, o, () => n.abort()];
}
function Cc(e) {
  return (t) => {
    t.pointerType === "touch" || Wl() || e(t);
  };
}
function epe(e, t, a = {}) {
  const [n, o, i] = Yl(e, a), s = Cc((c) => {
    const { target: f } = c, d = t(c);
    if (typeof d != "function" || !f)
      return;
    const u = Cc((h) => {
      d(h), f.removeEventListener("pointerleave", u);
    });
    f.addEventListener("pointerleave", u, o);
  });
  return n.forEach((c) => {
    c.addEventListener("pointerenter", s, o);
  }), i;
}
const Ql = (e, t) => t ? e === t ? !0 : Ql(e, t.parentElement) : !1, A0 = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, tpe = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function ape(e) {
  return tpe.has(e.tagName) || e.tabIndex !== -1;
}
const tn = /* @__PURE__ */ new WeakSet();
function bc(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function c2(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const npe = (e, t) => {
  const a = e.currentTarget;
  if (!a)
    return;
  const n = bc(() => {
    if (tn.has(a))
      return;
    c2(a, "down");
    const o = bc(() => {
      c2(a, "up");
    }), i = () => c2(a, "cancel");
    a.addEventListener("keyup", o, t), a.addEventListener("blur", i, t);
  });
  a.addEventListener("keydown", n, t), a.addEventListener("blur", () => a.removeEventListener("keydown", n), t);
};
function Lc(e) {
  return A0(e) && !Wl();
}
function ope(e, t, a = {}) {
  const [n, o, i] = Yl(e, a), s = (c) => {
    const f = c.currentTarget;
    if (!Lc(c) || tn.has(f))
      return;
    tn.add(f);
    const d = t(c), u = (m, v) => {
      window.removeEventListener("pointerup", h), window.removeEventListener("pointercancel", y), !(!Lc(m) || !tn.has(f)) && (tn.delete(f), typeof d == "function" && d(m, { success: v }));
    }, h = (m) => {
      u(m, a.useGlobalTarget || Ql(f, m.target));
    }, y = (m) => {
      u(m, !1);
    };
    window.addEventListener("pointerup", h, o), window.addEventListener("pointercancel", y, o);
  };
  return n.forEach((c) => {
    !ape(c) && c.getAttribute("tabindex") === null && (c.tabIndex = 0), (a.useGlobalTarget ? window : c).addEventListener("pointerdown", s, o), c.addEventListener("focus", (d) => npe(d, o), o);
  }), i;
}
function rpe(e) {
  return e === "x" || e === "y" ? St[e] ? null : (St[e] = !0, () => {
    St[e] = !1;
  }) : St.x || St.y ? null : (St.x = St.y = !0, () => {
    St.x = St.y = !1;
  });
}
const Jl = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...Ta
]);
let xo;
function ipe() {
  xo = void 0;
}
const $t = {
  now: () => (xo === void 0 && $t.set(Ue.isProcessing || t3e.useManualTiming ? Ue.timestamp : performance.now()), xo),
  set: (e) => {
    xo = e, queueMicrotask(ipe);
  }
};
function S0(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function I0(e, t) {
  const a = e.indexOf(t);
  a > -1 && e.splice(a, 1);
}
class T0 {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return S0(this.subscriptions, t), () => I0(this.subscriptions, t);
  }
  notify(t, a, n) {
    const o = this.subscriptions.length;
    if (o)
      if (o === 1)
        this.subscriptions[0](t, a, n);
      else
        for (let i = 0; i < o; i++) {
          const s = this.subscriptions[i];
          s && s(t, a, n);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
function Kl(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const jc = 30, spe = (e) => !isNaN(parseFloat(e));
class cpe {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, a = {}) {
    this.version = "11.18.2", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (n, o = !0) => {
      const i = $t.now();
      this.updatedAt !== i && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(n), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), o && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = a.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = $t.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = spe(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && hr(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, a) {
    this.events[t] || (this.events[t] = new T0());
    const n = this.events[t].add(a);
    return t === "change" ? () => {
      n(), Se.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : n;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, a) {
    this.passiveEffect = t, this.stopPassiveEffect = a;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, a = !0) {
    !a || !this.passiveEffect ? this.updateAndNotify(t, a) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, a, n) {
    this.set(a), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - n;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, a = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, a && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = $t.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > jc)
      return 0;
    const a = Math.min(this.updatedAt - this.prevUpdatedAt, jc);
    return Kl(parseFloat(this.current) - parseFloat(this.prevFrameValue), a);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((a) => {
      this.hasAnimated = !0, this.animation = t(a), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function kn(e, t) {
  return new cpe(e, t);
}
function fpe(e, t, a) {
  e.hasValue(t) ? e.getValue(t).set(a) : e.addValue(t, kn(a));
}
function dpe(e, t) {
  const a = kr(e, t);
  let { transitionEnd: n = {}, transition: o = {}, ...i } = a || {};
  i = { ...i, ...n };
  for (const s in i) {
    const c = x3e(i[s]);
    fpe(e, s, c);
  }
}
function lpe(e) {
  return !!(Je(e) && e.add);
}
function ii(e, t) {
  const a = e.getValue("willChange");
  if (lpe(a))
    return a.add(t);
}
function Xl(e) {
  return e.props[Sl];
}
const eu = (e, t, a) => (((1 - 3 * a + 3 * t) * e + (3 * a - 6 * t)) * e + 3 * t) * e, upe = 1e-7, hpe = 12;
function ppe(e, t, a, n, o) {
  let i, s, c = 0;
  do
    s = t + (a - t) / 2, i = eu(s, n, o) - e, i > 0 ? a = s : t = s;
  while (Math.abs(i) > upe && ++c < hpe);
  return s;
}
function _n(e, t, a, n) {
  if (e === t && a === n)
    return st;
  const o = (i) => ppe(i, 0, 1, e, a);
  return (i) => i === 0 || i === 1 ? i : eu(o(i), t, n);
}
const tu = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, au = (e) => (t) => 1 - e(1 - t), nu = /* @__PURE__ */ _n(0.33, 1.53, 0.69, 0.99), z0 = /* @__PURE__ */ au(nu), ou = /* @__PURE__ */ tu(z0), ru = (e) => (e *= 2) < 1 ? 0.5 * z0(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), D0 = (e) => 1 - Math.sin(Math.acos(e)), iu = au(D0), su = tu(D0), cu = (e) => /^0[^.\s]+$/u.test(e);
function ype(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || cu(e) : !0;
}
const rn = (e) => Math.round(e * 1e5) / 1e5, _0 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function mpe(e) {
  return e == null;
}
const kpe = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, P0 = (e, t) => (a) => !!(typeof a == "string" && kpe.test(a) && a.startsWith(e) || t && !mpe(a) && Object.prototype.hasOwnProperty.call(a, t)), fu = (e, t, a) => (n) => {
  if (typeof n != "string")
    return n;
  const [o, i, s, c] = n.match(_0);
  return {
    [e]: parseFloat(o),
    [t]: parseFloat(i),
    [a]: parseFloat(s),
    alpha: c !== void 0 ? parseFloat(c) : 1
  };
}, gpe = (e) => e1(0, 255, e), f2 = {
  ...za,
  transform: (e) => Math.round(gpe(e))
}, _1 = {
  test: /* @__PURE__ */ P0("rgb", "red"),
  parse: /* @__PURE__ */ fu("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: a, alpha: n = 1 }) => "rgba(" + f2.transform(e) + ", " + f2.transform(t) + ", " + f2.transform(a) + ", " + rn(mn.transform(n)) + ")"
};
function vpe(e) {
  let t = "", a = "", n = "", o = "";
  return e.length > 5 ? (t = e.substring(1, 3), a = e.substring(3, 5), n = e.substring(5, 7), o = e.substring(7, 9)) : (t = e.substring(1, 2), a = e.substring(2, 3), n = e.substring(3, 4), o = e.substring(4, 5), t += t, a += a, n += n, o += o), {
    red: parseInt(t, 16),
    green: parseInt(a, 16),
    blue: parseInt(n, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const si = {
  test: /* @__PURE__ */ P0("#"),
  parse: vpe,
  transform: _1.transform
}, ca = {
  test: /* @__PURE__ */ P0("hsl", "hue"),
  parse: /* @__PURE__ */ fu("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: a, alpha: n = 1 }) => "hsla(" + Math.round(e) + ", " + Gt.transform(rn(t)) + ", " + Gt.transform(rn(a)) + ", " + rn(mn.transform(n)) + ")"
}, Qe = {
  test: (e) => _1.test(e) || si.test(e) || ca.test(e),
  parse: (e) => _1.test(e) ? _1.parse(e) : ca.test(e) ? ca.parse(e) : si.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? _1.transform(e) : ca.transform(e)
}, Mpe = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function wpe(e) {
  var t, a;
  return isNaN(e) && typeof e == "string" && (((t = e.match(_0)) === null || t === void 0 ? void 0 : t.length) || 0) + (((a = e.match(Mpe)) === null || a === void 0 ? void 0 : a.length) || 0) > 0;
}
const du = "number", lu = "color", xpe = "var", Cpe = "var(", Nc = "${}", bpe = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function gn(e) {
  const t = e.toString(), a = [], n = {
    color: [],
    number: [],
    var: []
  }, o = [];
  let i = 0;
  const c = t.replace(bpe, (f) => (Qe.test(f) ? (n.color.push(i), o.push(lu), a.push(Qe.parse(f))) : f.startsWith(Cpe) ? (n.var.push(i), o.push(xpe), a.push(f)) : (n.number.push(i), o.push(du), a.push(parseFloat(f))), ++i, Nc)).split(Nc);
  return { values: a, split: c, indexes: n, types: o };
}
function uu(e) {
  return gn(e).values;
}
function hu(e) {
  const { split: t, types: a } = gn(e), n = t.length;
  return (o) => {
    let i = "";
    for (let s = 0; s < n; s++)
      if (i += t[s], o[s] !== void 0) {
        const c = a[s];
        c === du ? i += rn(o[s]) : c === lu ? i += Qe.transform(o[s]) : i += o[s];
      }
    return i;
  };
}
const Lpe = (e) => typeof e == "number" ? 0 : e;
function jpe(e) {
  const t = uu(e);
  return hu(e)(t.map(Lpe));
}
const p1 = {
  test: wpe,
  parse: uu,
  createTransformer: hu,
  getAnimatableNone: jpe
}, Npe = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function Ape(e) {
  const [t, a] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [n] = a.match(_0) || [];
  if (!n)
    return e;
  const o = a.replace(n, "");
  let i = Npe.has(t) ? 1 : 0;
  return n !== a && (i *= 100), t + "(" + i + o + ")";
}
const Spe = /\b([a-z-]*)\(.*?\)/gu, ci = {
  ...p1,
  getAnimatableNone: (e) => {
    const t = e.match(Spe);
    return t ? t.map(Ape).join(" ") : e;
  }
}, Ipe = {
  ...v0,
  // Color props
  color: Qe,
  backgroundColor: Qe,
  outlineColor: Qe,
  fill: Qe,
  stroke: Qe,
  // Border props
  borderColor: Qe,
  borderTopColor: Qe,
  borderRightColor: Qe,
  borderBottomColor: Qe,
  borderLeftColor: Qe,
  filter: ci,
  WebkitFilter: ci
}, E0 = (e) => Ipe[e];
function pu(e, t) {
  let a = E0(e);
  return a !== ci && (a = p1), a.getAnimatableNone ? a.getAnimatableNone(t) : void 0;
}
const Tpe = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function zpe(e, t, a) {
  let n = 0, o;
  for (; n < e.length && !o; ) {
    const i = e[n];
    typeof i == "string" && !Tpe.has(i) && gn(i).values.length && (o = e[n]), n++;
  }
  if (o && a)
    for (const i of t)
      e[i] = pu(a, o);
}
const Ac = (e) => e === za || e === te, Sc = (e, t) => parseFloat(e.split(", ")[t]), Ic = (e, t) => (a, { transform: n }) => {
  if (n === "none" || !n)
    return 0;
  const o = n.match(/^matrix3d\((.+)\)$/u);
  if (o)
    return Sc(o[1], t);
  {
    const i = n.match(/^matrix\((.+)\)$/u);
    return i ? Sc(i[1], e) : 0;
  }
}, Dpe = /* @__PURE__ */ new Set(["x", "y", "z"]), _pe = Ta.filter((e) => !Dpe.has(e));
function Ppe(e) {
  const t = [];
  return _pe.forEach((a) => {
    const n = e.getValue(a);
    n !== void 0 && (t.push([a, n.get()]), n.set(a.startsWith("scale") ? 1 : 0));
  }), t;
}
const wa = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: a = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(a),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: a = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(a),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: Ic(4, 13),
  y: Ic(5, 14)
};
wa.translateX = wa.x;
wa.translateY = wa.y;
const E1 = /* @__PURE__ */ new Set();
let fi = !1, di = !1;
function yu() {
  if (di) {
    const e = Array.from(E1).filter((n) => n.needsMeasurement), t = new Set(e.map((n) => n.element)), a = /* @__PURE__ */ new Map();
    t.forEach((n) => {
      const o = Ppe(n);
      o.length && (a.set(n, o), n.render());
    }), e.forEach((n) => n.measureInitialState()), t.forEach((n) => {
      n.render();
      const o = a.get(n);
      o && o.forEach(([i, s]) => {
        var c;
        (c = n.getValue(i)) === null || c === void 0 || c.set(s);
      });
    }), e.forEach((n) => n.measureEndState()), e.forEach((n) => {
      n.suspendedScrollY !== void 0 && window.scrollTo(0, n.suspendedScrollY);
    });
  }
  di = !1, fi = !1, E1.forEach((e) => e.complete()), E1.clear();
}
function mu() {
  E1.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (di = !0);
  });
}
function Epe() {
  mu(), yu();
}
class R0 {
  constructor(t, a, n, o, i, s = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...t], this.onComplete = a, this.name = n, this.motionValue = o, this.element = i, this.isAsync = s;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (E1.add(this), fi || (fi = !0, Se.read(mu), Se.resolveKeyframes(yu))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: a, element: n, motionValue: o } = this;
    for (let i = 0; i < t.length; i++)
      if (t[i] === null)
        if (i === 0) {
          const s = o == null ? void 0 : o.get(), c = t[t.length - 1];
          if (s !== void 0)
            t[0] = s;
          else if (n && a) {
            const f = n.readValue(a, c);
            f != null && (t[0] = f);
          }
          t[0] === void 0 && (t[0] = c), o && s === void 0 && o.set(t[0]);
        } else
          t[i] = t[i - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), E1.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, E1.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const ku = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), Rpe = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function Hpe(e) {
  const t = Rpe.exec(e);
  if (!t)
    return [,];
  const [, a, n, o] = t;
  return [`--${a ?? n}`, o];
}
const Vpe = 4;
function gu(e, t, a = 1) {
  u1(a <= Vpe, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [n, o] = Hpe(e);
  if (!n)
    return;
  const i = window.getComputedStyle(t).getPropertyValue(n);
  if (i) {
    const s = i.trim();
    return ku(s) ? parseFloat(s) : s;
  }
  return g0(o) ? gu(o, t, a + 1) : o;
}
const vu = (e) => (t) => t.test(e), Ope = {
  test: (e) => e === "auto",
  parse: (e) => e
}, Mu = [za, te, Gt, i1, A3e, N3e, Ope], Tc = (e) => Mu.find(vu(e));
class wu extends R0 {
  constructor(t, a, n, o, i) {
    super(t, a, n, o, i, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: a, name: n } = this;
    if (!a || !a.current)
      return;
    super.readKeyframes();
    for (let f = 0; f < t.length; f++) {
      let d = t[f];
      if (typeof d == "string" && (d = d.trim(), g0(d))) {
        const u = gu(d, a.current);
        u !== void 0 && (t[f] = u), f === t.length - 1 && (this.finalKeyframe = d);
      }
    }
    if (this.resolveNoneKeyframes(), !Jl.has(n) || t.length !== 2)
      return;
    const [o, i] = t, s = Tc(o), c = Tc(i);
    if (s !== c)
      if (Ac(s) && Ac(c))
        for (let f = 0; f < t.length; f++) {
          const d = t[f];
          typeof d == "string" && (t[f] = parseFloat(d));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: a } = this, n = [];
    for (let o = 0; o < t.length; o++)
      ype(t[o]) && n.push(o);
    n.length && zpe(t, n, a);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: a, name: n } = this;
    if (!t || !t.current)
      return;
    n === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = wa[n](t.measureViewportBox(), window.getComputedStyle(t.current)), a[0] = this.measuredOrigin;
    const o = a[a.length - 1];
    o !== void 0 && t.getValue(n, o).jump(o, !1);
  }
  measureEndState() {
    var t;
    const { element: a, name: n, unresolvedKeyframes: o } = this;
    if (!a || !a.current)
      return;
    const i = a.getValue(n);
    i && i.jump(this.measuredOrigin, !1);
    const s = o.length - 1, c = o[s];
    o[s] = wa[n](a.measureViewportBox(), window.getComputedStyle(a.current)), c !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = c), !((t = this.removedTransforms) === null || t === void 0) && t.length && this.removedTransforms.forEach(([f, d]) => {
      a.getValue(f).set(d);
    }), this.resolveNoneKeyframes();
  }
}
const zc = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(p1.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function qpe(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let a = 0; a < e.length; a++)
    if (e[a] !== t)
      return !0;
}
function Bpe(e, t, a, n) {
  const o = e[0];
  if (o === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const i = e[e.length - 1], s = zc(o, t), c = zc(i, t);
  return Ia(s === c, `You are trying to animate ${t} from "${o}" to "${i}". ${o} is not an animatable value - to enable this animation set ${o} to a value animatable to ${i} via the \`style\` property.`), !s || !c ? !1 : qpe(e) || (a === "spring" || j0(a)) && n;
}
const Zpe = (e) => e !== null;
function gr(e, { repeat: t, repeatType: a = "loop" }, n) {
  const o = e.filter(Zpe), i = t && a !== "loop" && t % 2 === 1 ? 0 : o.length - 1;
  return !i || n === void 0 ? o[i] : n;
}
const Fpe = 40;
class xu {
  constructor({ autoplay: t = !0, delay: a = 0, type: n = "keyframes", repeat: o = 0, repeatDelay: i = 0, repeatType: s = "loop", ...c }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = $t.now(), this.options = {
      autoplay: t,
      delay: a,
      type: n,
      repeat: o,
      repeatDelay: i,
      repeatType: s,
      ...c
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > Fpe ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && Epe(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(t, a) {
    this.resolvedAt = $t.now(), this.hasAttemptedResolve = !0;
    const { name: n, type: o, velocity: i, delay: s, onComplete: c, onUpdate: f, isGenerator: d } = this.options;
    if (!d && !Bpe(t, n, o, i))
      if (s)
        this.options.duration = 0;
      else {
        f && f(gr(t, this.options, a)), c && c(), this.resolveFinishedPromise();
        return;
      }
    const u = this.initPlayback(t, a);
    u !== !1 && (this._resolved = {
      keyframes: t,
      finalKeyframe: a,
      ...u
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, a) {
    return this.currentFinishedPromise.then(t, a);
  }
  flatten() {
    this.options.type = "keyframes", this.options.ease = "linear";
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((t) => {
      this.resolveFinishedPromise = t;
    });
  }
}
const _e = (e, t, a) => e + (t - e) * a;
function d2(e, t, a) {
  return a < 0 && (a += 1), a > 1 && (a -= 1), a < 1 / 6 ? e + (t - e) * 6 * a : a < 1 / 2 ? t : a < 2 / 3 ? e + (t - e) * (2 / 3 - a) * 6 : e;
}
function Gpe({ hue: e, saturation: t, lightness: a, alpha: n }) {
  e /= 360, t /= 100, a /= 100;
  let o = 0, i = 0, s = 0;
  if (!t)
    o = i = s = a;
  else {
    const c = a < 0.5 ? a * (1 + t) : a + t - a * t, f = 2 * a - c;
    o = d2(f, c, e + 1 / 3), i = d2(f, c, e), s = d2(f, c, e - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(i * 255),
    blue: Math.round(s * 255),
    alpha: n
  };
}
function Oo(e, t) {
  return (a) => a > 0 ? t : e;
}
const l2 = (e, t, a) => {
  const n = e * e, o = a * (t * t - n) + n;
  return o < 0 ? 0 : Math.sqrt(o);
}, $pe = [si, _1, ca], Upe = (e) => $pe.find((t) => t.test(e));
function Dc(e) {
  const t = Upe(e);
  if (Ia(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`), !t)
    return !1;
  let a = t.parse(e);
  return t === ca && (a = Gpe(a)), a;
}
const _c = (e, t) => {
  const a = Dc(e), n = Dc(t);
  if (!a || !n)
    return Oo(e, t);
  const o = { ...a };
  return (i) => (o.red = l2(a.red, n.red, i), o.green = l2(a.green, n.green, i), o.blue = l2(a.blue, n.blue, i), o.alpha = _e(a.alpha, n.alpha, i), _1.transform(o));
}, Wpe = (e, t) => (a) => t(e(a)), Pn = (...e) => e.reduce(Wpe), li = /* @__PURE__ */ new Set(["none", "hidden"]);
function Ype(e, t) {
  return li.has(e) ? (a) => a <= 0 ? e : t : (a) => a >= 1 ? t : e;
}
function Qpe(e, t) {
  return (a) => _e(e, t, a);
}
function H0(e) {
  return typeof e == "number" ? Qpe : typeof e == "string" ? g0(e) ? Oo : Qe.test(e) ? _c : Xpe : Array.isArray(e) ? Cu : typeof e == "object" ? Qe.test(e) ? _c : Jpe : Oo;
}
function Cu(e, t) {
  const a = [...e], n = a.length, o = e.map((i, s) => H0(i)(i, t[s]));
  return (i) => {
    for (let s = 0; s < n; s++)
      a[s] = o[s](i);
    return a;
  };
}
function Jpe(e, t) {
  const a = { ...e, ...t }, n = {};
  for (const o in a)
    e[o] !== void 0 && t[o] !== void 0 && (n[o] = H0(e[o])(e[o], t[o]));
  return (o) => {
    for (const i in n)
      a[i] = n[i](o);
    return a;
  };
}
function Kpe(e, t) {
  var a;
  const n = [], o = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < t.values.length; i++) {
    const s = t.types[i], c = e.indexes[s][o[s]], f = (a = e.values[c]) !== null && a !== void 0 ? a : 0;
    n[i] = f, o[s]++;
  }
  return n;
}
const Xpe = (e, t) => {
  const a = p1.createTransformer(t), n = gn(e), o = gn(t);
  return n.indexes.var.length === o.indexes.var.length && n.indexes.color.length === o.indexes.color.length && n.indexes.number.length >= o.indexes.number.length ? li.has(e) && !o.values.length || li.has(t) && !n.values.length ? Ype(e, t) : Pn(Cu(Kpe(n, o), o.values), a) : (Ia(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), Oo(e, t));
};
function bu(e, t, a) {
  return typeof e == "number" && typeof t == "number" && typeof a == "number" ? _e(e, t, a) : H0(e)(e, t);
}
const eye = 5;
function Lu(e, t, a) {
  const n = Math.max(t - eye, 0);
  return Kl(a - e(n), t - n);
}
const De = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, Pc = 1e-3;
function tye({ duration: e = De.duration, bounce: t = De.bounce, velocity: a = De.velocity, mass: n = De.mass }) {
  let o, i;
  Ia(e <= /* @__PURE__ */ Ft(De.maxDuration), "Spring duration must be 10 seconds or less");
  let s = 1 - t;
  s = e1(De.minDamping, De.maxDamping, s), e = e1(De.minDuration, De.maxDuration, /* @__PURE__ */ Jt(e)), s < 1 ? (o = (d) => {
    const u = d * s, h = u * e, y = u - a, m = ui(d, s), v = Math.exp(-h);
    return Pc - y / m * v;
  }, i = (d) => {
    const h = d * s * e, y = h * a + a, m = Math.pow(s, 2) * Math.pow(d, 2) * e, v = Math.exp(-h), k = ui(Math.pow(d, 2), s);
    return (-o(d) + Pc > 0 ? -1 : 1) * ((y - m) * v) / k;
  }) : (o = (d) => {
    const u = Math.exp(-d * e), h = (d - a) * e + 1;
    return -1e-3 + u * h;
  }, i = (d) => {
    const u = Math.exp(-d * e), h = (a - d) * (e * e);
    return u * h;
  });
  const c = 5 / e, f = nye(o, i, c);
  if (e = /* @__PURE__ */ Ft(e), isNaN(f))
    return {
      stiffness: De.stiffness,
      damping: De.damping,
      duration: e
    };
  {
    const d = Math.pow(f, 2) * n;
    return {
      stiffness: d,
      damping: s * 2 * Math.sqrt(n * d),
      duration: e
    };
  }
}
const aye = 12;
function nye(e, t, a) {
  let n = a;
  for (let o = 1; o < aye; o++)
    n = n - e(n) / t(n);
  return n;
}
function ui(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const oye = ["duration", "bounce"], rye = ["stiffness", "damping", "mass"];
function Ec(e, t) {
  return t.some((a) => e[a] !== void 0);
}
function iye(e) {
  let t = {
    velocity: De.velocity,
    stiffness: De.stiffness,
    damping: De.damping,
    mass: De.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!Ec(e, rye) && Ec(e, oye))
    if (e.visualDuration) {
      const a = e.visualDuration, n = 2 * Math.PI / (a * 1.2), o = n * n, i = 2 * e1(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(o);
      t = {
        ...t,
        mass: De.mass,
        stiffness: o,
        damping: i
      };
    } else {
      const a = tye(e);
      t = {
        ...t,
        ...a,
        mass: De.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function ju(e = De.visualDuration, t = De.bounce) {
  const a = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: n, restDelta: o } = a;
  const i = a.keyframes[0], s = a.keyframes[a.keyframes.length - 1], c = { done: !1, value: i }, { stiffness: f, damping: d, mass: u, duration: h, velocity: y, isResolvedFromDuration: m } = iye({
    ...a,
    velocity: -/* @__PURE__ */ Jt(a.velocity || 0)
  }), v = y || 0, k = d / (2 * Math.sqrt(f * u)), g = s - i, M = /* @__PURE__ */ Jt(Math.sqrt(f / u)), w = Math.abs(g) < 5;
  n || (n = w ? De.restSpeed.granular : De.restSpeed.default), o || (o = w ? De.restDelta.granular : De.restDelta.default);
  let x;
  if (k < 1) {
    const L = ui(M, k);
    x = (N) => {
      const j = Math.exp(-k * M * N);
      return s - j * ((v + k * M * g) / L * Math.sin(L * N) + g * Math.cos(L * N));
    };
  } else if (k === 1)
    x = (L) => s - Math.exp(-M * L) * (g + (v + M * g) * L);
  else {
    const L = M * Math.sqrt(k * k - 1);
    x = (N) => {
      const j = Math.exp(-k * M * N), A = Math.min(L * N, 300);
      return s - j * ((v + k * M * g) * Math.sinh(A) + L * g * Math.cosh(A)) / L;
    };
  }
  const C = {
    calculatedDuration: m && h || null,
    next: (L) => {
      const N = x(L);
      if (m)
        c.done = L >= h;
      else {
        let j = 0;
        k < 1 && (j = L === 0 ? /* @__PURE__ */ Ft(v) : Lu(x, L, N));
        const A = Math.abs(j) <= n, D = Math.abs(s - N) <= o;
        c.done = A && D;
      }
      return c.value = c.done ? s : N, c;
    },
    toString: () => {
      const L = Math.min(Fl(C), oi), N = Gl((j) => C.next(L * j).value, L, 30);
      return L + "ms " + N;
    }
  };
  return C;
}
function Rc({ keyframes: e, velocity: t = 0, power: a = 0.8, timeConstant: n = 325, bounceDamping: o = 10, bounceStiffness: i = 500, modifyTarget: s, min: c, max: f, restDelta: d = 0.5, restSpeed: u }) {
  const h = e[0], y = {
    done: !1,
    value: h
  }, m = (A) => c !== void 0 && A < c || f !== void 0 && A > f, v = (A) => c === void 0 ? f : f === void 0 || Math.abs(c - A) < Math.abs(f - A) ? c : f;
  let k = a * t;
  const g = h + k, M = s === void 0 ? g : s(g);
  M !== g && (k = M - h);
  const w = (A) => -k * Math.exp(-A / n), x = (A) => M + w(A), C = (A) => {
    const D = w(A), H = x(A);
    y.done = Math.abs(D) <= d, y.value = y.done ? M : H;
  };
  let L, N;
  const j = (A) => {
    m(y.value) && (L = A, N = ju({
      keyframes: [y.value, v(y.value)],
      velocity: Lu(x, A, y.value),
      // TODO: This should be passing * 1000
      damping: o,
      stiffness: i,
      restDelta: d,
      restSpeed: u
    }));
  };
  return j(0), {
    calculatedDuration: null,
    next: (A) => {
      let D = !1;
      return !N && L === void 0 && (D = !0, C(A), j(A)), L !== void 0 && A >= L ? N.next(A - L) : (!D && C(A), y);
    }
  };
}
const sye = /* @__PURE__ */ _n(0.42, 0, 1, 1), cye = /* @__PURE__ */ _n(0, 0, 0.58, 1), Nu = /* @__PURE__ */ _n(0.42, 0, 0.58, 1), fye = (e) => Array.isArray(e) && typeof e[0] != "number", Hc = {
  linear: st,
  easeIn: sye,
  easeInOut: Nu,
  easeOut: cye,
  circIn: D0,
  circInOut: su,
  circOut: iu,
  backIn: z0,
  backInOut: ou,
  backOut: nu,
  anticipate: ru
}, Vc = (e) => {
  if (N0(e)) {
    u1(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, a, n, o] = e;
    return _n(t, a, n, o);
  } else if (typeof e == "string")
    return u1(Hc[e] !== void 0, `Invalid easing type '${e}'`), Hc[e];
  return e;
};
function dye(e, t, a) {
  const n = [], o = a || bu, i = e.length - 1;
  for (let s = 0; s < i; s++) {
    let c = o(e[s], e[s + 1]);
    if (t) {
      const f = Array.isArray(t) ? t[s] || st : t;
      c = Pn(f, c);
    }
    n.push(c);
  }
  return n;
}
function lye(e, t, { clamp: a = !0, ease: n, mixer: o } = {}) {
  const i = e.length;
  if (u1(i === t.length, "Both input and output ranges must be the same length"), i === 1)
    return () => t[0];
  if (i === 2 && t[0] === t[1])
    return () => t[1];
  const s = e[0] === e[1];
  e[0] > e[i - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const c = dye(t, n, o), f = c.length, d = (u) => {
    if (s && u < e[0])
      return t[0];
    let h = 0;
    if (f > 1)
      for (; h < e.length - 2 && !(u < e[h + 1]); h++)
        ;
    const y = /* @__PURE__ */ va(e[h], e[h + 1], u);
    return c[h](y);
  };
  return a ? (u) => d(e1(e[0], e[i - 1], u)) : d;
}
function uye(e, t) {
  const a = e[e.length - 1];
  for (let n = 1; n <= t; n++) {
    const o = /* @__PURE__ */ va(0, t, n);
    e.push(_e(a, 1, o));
  }
}
function hye(e) {
  const t = [0];
  return uye(t, e.length - 1), t;
}
function pye(e, t) {
  return e.map((a) => a * t);
}
function yye(e, t) {
  return e.map(() => t || Nu).splice(0, e.length - 1);
}
function qo({ duration: e = 300, keyframes: t, times: a, ease: n = "easeInOut" }) {
  const o = fye(n) ? n.map(Vc) : Vc(n), i = {
    done: !1,
    value: t[0]
  }, s = pye(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    a && a.length === t.length ? a : hye(t),
    e
  ), c = lye(s, t, {
    ease: Array.isArray(o) ? o : yye(t, o)
  });
  return {
    calculatedDuration: e,
    next: (f) => (i.value = c(f), i.done = f >= e, i)
  };
}
const mye = (e) => {
  const t = ({ timestamp: a }) => e(a);
  return {
    start: () => Se.update(t, !0),
    stop: () => h1(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Ue.isProcessing ? Ue.timestamp : $t.now()
  };
}, kye = {
  decay: Rc,
  inertia: Rc,
  tween: qo,
  keyframes: qo,
  spring: ju
}, gye = (e) => e / 100;
class V0 extends xu {
  constructor(t) {
    super(t), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: f } = this.options;
      f && f();
    };
    const { name: a, motionValue: n, element: o, keyframes: i } = this.options, s = (o == null ? void 0 : o.KeyframeResolver) || R0, c = (f, d) => this.onKeyframesResolved(f, d);
    this.resolver = new s(i, c, a, n, o), this.resolver.scheduleResolve();
  }
  flatten() {
    super.flatten(), this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
  }
  initPlayback(t) {
    const { type: a = "keyframes", repeat: n = 0, repeatDelay: o = 0, repeatType: i, velocity: s = 0 } = this.options, c = j0(a) ? a : kye[a] || qo;
    let f, d;
    c !== qo && typeof t[0] != "number" && (process.env.NODE_ENV !== "production" && u1(t.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${t}`), f = Pn(gye, bu(t[0], t[1])), t = [0, 100]);
    const u = c({ ...this.options, keyframes: t });
    i === "mirror" && (d = c({
      ...this.options,
      keyframes: [...t].reverse(),
      velocity: -s
    })), u.calculatedDuration === null && (u.calculatedDuration = Fl(u));
    const { calculatedDuration: h } = u, y = h + o, m = y * (n + 1) - o;
    return {
      generator: u,
      mirroredGenerator: d,
      mapPercentToKeyframes: f,
      calculatedDuration: h,
      resolvedDuration: y,
      totalDuration: m
    };
  }
  onPostResolved() {
    const { autoplay: t = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !t ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(t, a = !1) {
    const { resolved: n } = this;
    if (!n) {
      const { keyframes: A } = this.options;
      return { done: !0, value: A[A.length - 1] };
    }
    const { finalKeyframe: o, generator: i, mirroredGenerator: s, mapPercentToKeyframes: c, keyframes: f, calculatedDuration: d, totalDuration: u, resolvedDuration: h } = n;
    if (this.startTime === null)
      return i.next(0);
    const { delay: y, repeat: m, repeatType: v, repeatDelay: k, onUpdate: g } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - u / this.speed, this.startTime)), a ? this.currentTime = t : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(t - this.startTime) * this.speed;
    const M = this.currentTime - y * (this.speed >= 0 ? 1 : -1), w = this.speed >= 0 ? M < 0 : M > u;
    this.currentTime = Math.max(M, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = u);
    let x = this.currentTime, C = i;
    if (m) {
      const A = Math.min(this.currentTime, u) / h;
      let D = Math.floor(A), H = A % 1;
      !H && A >= 1 && (H = 1), H === 1 && D--, D = Math.min(D, m + 1), !!(D % 2) && (v === "reverse" ? (H = 1 - H, k && (H -= k / h)) : v === "mirror" && (C = s)), x = e1(0, 1, H) * h;
    }
    const L = w ? { done: !1, value: f[0] } : C.next(x);
    c && (L.value = c(L.value));
    let { done: N } = L;
    !w && d !== null && (N = this.speed >= 0 ? this.currentTime >= u : this.currentTime <= 0);
    const j = this.holdTime === null && (this.state === "finished" || this.state === "running" && N);
    return j && o !== void 0 && (L.value = gr(f, this.options, o)), g && g(L.value), j && this.finish(), L;
  }
  get duration() {
    const { resolved: t } = this;
    return t ? /* @__PURE__ */ Jt(t.calculatedDuration) : 0;
  }
  get time() {
    return /* @__PURE__ */ Jt(this.currentTime);
  }
  set time(t) {
    t = /* @__PURE__ */ Ft(t), this.currentTime = t, this.holdTime !== null || this.speed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const a = this.playbackSpeed !== t;
    this.playbackSpeed = t, a && (this.time = /* @__PURE__ */ Jt(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: t = mye, onPlay: a, startTime: n } = this.options;
    this.driver || (this.driver = t((i) => this.tick(i))), a && a();
    const o = this.driver.now();
    this.holdTime !== null ? this.startTime = o - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = o) : this.startTime = n ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var t;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (t = this.currentTime) !== null && t !== void 0 ? t : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: t } = this.options;
    t && t();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
}
const vye = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]);
function Mye(e, t, a, { delay: n = 0, duration: o = 300, repeat: i = 0, repeatType: s = "loop", ease: c = "easeInOut", times: f } = {}) {
  const d = { [t]: a };
  f && (d.offset = f);
  const u = Ul(c, o);
  return Array.isArray(u) && (d.easing = u), e.animate(d, {
    delay: n,
    duration: o,
    easing: Array.isArray(u) ? "linear" : u,
    fill: "both",
    iterations: i + 1,
    direction: s === "reverse" ? "alternate" : "normal"
  });
}
const wye = /* @__PURE__ */ l0(() => Object.hasOwnProperty.call(Element.prototype, "animate")), Bo = 10, xye = 2e4;
function Cye(e) {
  return j0(e.type) || e.type === "spring" || !$l(e.ease);
}
function bye(e, t) {
  const a = new V0({
    ...t,
    keyframes: e,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let n = { done: !1, value: e[0] };
  const o = [];
  let i = 0;
  for (; !n.done && i < xye; )
    n = a.sample(i), o.push(n.value), i += Bo;
  return {
    times: void 0,
    keyframes: o,
    duration: i - Bo,
    ease: "linear"
  };
}
const Au = {
  anticipate: ru,
  backInOut: ou,
  circInOut: su
};
function Lye(e) {
  return e in Au;
}
class Oc extends xu {
  constructor(t) {
    super(t);
    const { name: a, motionValue: n, element: o, keyframes: i } = this.options;
    this.resolver = new wu(i, (s, c) => this.onKeyframesResolved(s, c), a, n, o), this.resolver.scheduleResolve();
  }
  initPlayback(t, a) {
    let { duration: n = 300, times: o, ease: i, type: s, motionValue: c, name: f, startTime: d } = this.options;
    if (!c.owner || !c.owner.current)
      return !1;
    if (typeof i == "string" && Vo() && Lye(i) && (i = Au[i]), Cye(this.options)) {
      const { onComplete: h, onUpdate: y, motionValue: m, element: v, ...k } = this.options, g = bye(t, k);
      t = g.keyframes, t.length === 1 && (t[1] = t[0]), n = g.duration, o = g.times, i = g.ease, s = "keyframes";
    }
    const u = Mye(c.owner.current, f, t, { ...this.options, duration: n, times: o, ease: i });
    return u.startTime = d ?? this.calcStartTime(), this.pendingTimeline ? (xc(u, this.pendingTimeline), this.pendingTimeline = void 0) : u.onfinish = () => {
      const { onComplete: h } = this.options;
      c.set(gr(t, this.options, a)), h && h(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: u,
      duration: n,
      times: o,
      type: s,
      ease: i,
      keyframes: t
    };
  }
  get duration() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { duration: a } = t;
    return /* @__PURE__ */ Jt(a);
  }
  get time() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { animation: a } = t;
    return /* @__PURE__ */ Jt(a.currentTime || 0);
  }
  set time(t) {
    const { resolved: a } = this;
    if (!a)
      return;
    const { animation: n } = a;
    n.currentTime = /* @__PURE__ */ Ft(t);
  }
  get speed() {
    const { resolved: t } = this;
    if (!t)
      return 1;
    const { animation: a } = t;
    return a.playbackRate;
  }
  set speed(t) {
    const { resolved: a } = this;
    if (!a)
      return;
    const { animation: n } = a;
    n.playbackRate = t;
  }
  get state() {
    const { resolved: t } = this;
    if (!t)
      return "idle";
    const { animation: a } = t;
    return a.playState;
  }
  get startTime() {
    const { resolved: t } = this;
    if (!t)
      return null;
    const { animation: a } = t;
    return a.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(t) {
    if (!this._resolved)
      this.pendingTimeline = t;
    else {
      const { resolved: a } = this;
      if (!a)
        return st;
      const { animation: n } = a;
      xc(n, t);
    }
    return st;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: a } = t;
    a.playState === "finished" && this.updateFinishedPromise(), a.play();
  }
  pause() {
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: a } = t;
    a.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: a, keyframes: n, duration: o, type: i, ease: s, times: c } = t;
    if (a.playState === "idle" || a.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: d, onUpdate: u, onComplete: h, element: y, ...m } = this.options, v = new V0({
        ...m,
        keyframes: n,
        duration: o,
        type: i,
        ease: s,
        times: c,
        isGenerator: !0
      }), k = /* @__PURE__ */ Ft(this.time);
      d.setWithVelocity(v.sample(k - Bo).value, v.sample(k).value, Bo);
    }
    const { onStop: f } = this.options;
    f && f(), this.cancel();
  }
  complete() {
    const { resolved: t } = this;
    t && t.animation.finish();
  }
  cancel() {
    const { resolved: t } = this;
    t && t.animation.cancel();
  }
  static supports(t) {
    const { motionValue: a, name: n, repeatDelay: o, repeatType: i, damping: s, type: c } = t;
    if (!a || !a.owner || !(a.owner.current instanceof HTMLElement))
      return !1;
    const { onUpdate: f, transformTemplate: d } = a.owner.getProps();
    return wye() && n && vye.has(n) && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !f && !d && !o && i !== "mirror" && s !== 0 && c !== "inertia";
  }
}
const jye = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Nye = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), Aye = {
  type: "keyframes",
  duration: 0.8
}, Sye = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, Iye = (e, { keyframes: t }) => t.length > 2 ? Aye : G1.has(e) ? e.startsWith("scale") ? Nye(t[1]) : jye : Sye;
function Tye({ when: e, delay: t, delayChildren: a, staggerChildren: n, staggerDirection: o, repeat: i, repeatType: s, repeatDelay: c, from: f, elapsed: d, ...u }) {
  return !!Object.keys(u).length;
}
const O0 = (e, t, a, n = {}, o, i) => (s) => {
  const c = L0(n, e) || {}, f = c.delay || n.delay || 0;
  let { elapsed: d = 0 } = n;
  d = d - /* @__PURE__ */ Ft(f);
  let u = {
    keyframes: Array.isArray(a) ? a : [null, a],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...c,
    delay: -d,
    onUpdate: (y) => {
      t.set(y), c.onUpdate && c.onUpdate(y);
    },
    onComplete: () => {
      s(), c.onComplete && c.onComplete();
    },
    name: e,
    motionValue: t,
    element: i ? void 0 : o
  };
  Tye(c) || (u = {
    ...u,
    ...Iye(e, u)
  }), u.duration && (u.duration = /* @__PURE__ */ Ft(u.duration)), u.repeatDelay && (u.repeatDelay = /* @__PURE__ */ Ft(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let h = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (u.duration = 0, u.delay === 0 && (h = !0)), h && !i && t.get() !== void 0) {
    const y = gr(u.keyframes, c);
    if (y !== void 0)
      return Se.update(() => {
        u.onUpdate(y), u.onComplete();
      }), new Q3e([]);
  }
  return !i && Oc.supports(u) ? new Oc(u) : new V0(u);
};
function zye({ protectedKeys: e, needsAnimating: t }, a) {
  const n = e.hasOwnProperty(a) && t[a] !== !0;
  return t[a] = !1, n;
}
function Su(e, t, { delay: a = 0, transitionOverride: n, type: o } = {}) {
  var i;
  let { transition: s = e.getDefaultTransition(), transitionEnd: c, ...f } = t;
  n && (s = n);
  const d = [], u = o && e.animationState && e.animationState.getState()[o];
  for (const h in f) {
    const y = e.getValue(h, (i = e.latestValues[h]) !== null && i !== void 0 ? i : null), m = f[h];
    if (m === void 0 || u && zye(u, h))
      continue;
    const v = {
      delay: a,
      ...L0(s || {}, h)
    };
    let k = !1;
    if (window.MotionHandoffAnimation) {
      const M = Xl(e);
      if (M) {
        const w = window.MotionHandoffAnimation(M, h, Se);
        w !== null && (v.startTime = w, k = !0);
      }
    }
    ii(e, h), y.start(O0(h, y, m, e.shouldReduceMotion && Jl.has(h) ? { type: !1 } : v, e, k));
    const g = y.animation;
    g && d.push(g);
  }
  return c && Promise.all(d).then(() => {
    Se.update(() => {
      c && dpe(e, c);
    });
  }), d;
}
function hi(e, t, a = {}) {
  var n;
  const o = kr(e, t, a.type === "exit" ? (n = e.presenceContext) === null || n === void 0 ? void 0 : n.custom : void 0);
  let { transition: i = e.getDefaultTransition() || {} } = o || {};
  a.transitionOverride && (i = a.transitionOverride);
  const s = o ? () => Promise.all(Su(e, o, a)) : () => Promise.resolve(), c = e.variantChildren && e.variantChildren.size ? (d = 0) => {
    const { delayChildren: u = 0, staggerChildren: h, staggerDirection: y } = i;
    return Dye(e, t, u + d, h, y, a);
  } : () => Promise.resolve(), { when: f } = i;
  if (f) {
    const [d, u] = f === "beforeChildren" ? [s, c] : [c, s];
    return d().then(() => u());
  } else
    return Promise.all([s(), c(a.delay)]);
}
function Dye(e, t, a = 0, n = 0, o = 1, i) {
  const s = [], c = (e.variantChildren.size - 1) * n, f = o === 1 ? (d = 0) => d * n : (d = 0) => c - d * n;
  return Array.from(e.variantChildren).sort(_ye).forEach((d, u) => {
    d.notify("AnimationStart", t), s.push(hi(d, t, {
      ...i,
      delay: a + f(u)
    }).then(() => d.notify("AnimationComplete", t)));
  }), Promise.all(s);
}
function _ye(e, t) {
  return e.sortNodePosition(t);
}
function Pye(e, t, a = {}) {
  e.notify("AnimationStart", t);
  let n;
  if (Array.isArray(t)) {
    const o = t.map((i) => hi(e, i, a));
    n = Promise.all(o);
  } else if (typeof t == "string")
    n = hi(e, t, a);
  else {
    const o = typeof t == "function" ? kr(e, t, a.custom) : t;
    n = Promise.all(Su(e, o, a));
  }
  return n.then(() => {
    e.notify("AnimationComplete", t);
  });
}
const Eye = h0.length;
function Iu(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const a = e.parent ? Iu(e.parent) || {} : {};
    return e.props.initial !== void 0 && (a.initial = e.props.initial), a;
  }
  const t = {};
  for (let a = 0; a < Eye; a++) {
    const n = h0[a], o = e.props[n];
    (yn(o) || o === !1) && (t[n] = o);
  }
  return t;
}
const Rye = [...u0].reverse(), Hye = u0.length;
function Vye(e) {
  return (t) => Promise.all(t.map(({ animation: a, options: n }) => Pye(e, a, n)));
}
function Oye(e) {
  let t = Vye(e), a = qc(), n = !0;
  const o = (f) => (d, u) => {
    var h;
    const y = kr(e, u, f === "exit" ? (h = e.presenceContext) === null || h === void 0 ? void 0 : h.custom : void 0);
    if (y) {
      const { transition: m, transitionEnd: v, ...k } = y;
      d = { ...d, ...k, ...v };
    }
    return d;
  };
  function i(f) {
    t = f(e);
  }
  function s(f) {
    const { props: d } = e, u = Iu(e.parent) || {}, h = [], y = /* @__PURE__ */ new Set();
    let m = {}, v = 1 / 0;
    for (let g = 0; g < Hye; g++) {
      const M = Rye[g], w = a[M], x = d[M] !== void 0 ? d[M] : u[M], C = yn(x), L = M === f ? w.isActive : null;
      L === !1 && (v = g);
      let N = x === u[M] && x !== d[M] && C;
      if (N && n && e.manuallyAnimateOnMount && (N = !1), w.protectedKeys = { ...m }, // If it isn't active and hasn't *just* been set as inactive
      !w.isActive && L === null || // If we didn't and don't have any defined prop for this animation type
      !x && !w.prevProp || // Or if the prop doesn't define an animation
      yr(x) || typeof x == "boolean")
        continue;
      const j = qye(w.prevProp, x);
      let A = j || // If we're making this variant active, we want to always make it active
      M === f && w.isActive && !N && C || // If we removed a higher-priority variant (i is in reverse order)
      g > v && C, D = !1;
      const H = Array.isArray(x) ? x : [x];
      let Z = H.reduce(o(M), {});
      L === !1 && (Z = {});
      const { prevResolvedValues: R = {} } = w, _ = {
        ...R,
        ...Z
      }, T = (V) => {
        A = !0, y.has(V) && (D = !0, y.delete(V)), w.needsAnimating[V] = !0;
        const B = e.getValue(V);
        B && (B.liveStyle = !1);
      };
      for (const V in _) {
        const B = Z[V], Q = R[V];
        if (m.hasOwnProperty(V))
          continue;
        let me = !1;
        ni(B) && ni(Q) ? me = !Zl(B, Q) : me = B !== Q, me ? B != null ? T(V) : y.add(V) : B !== void 0 && y.has(V) ? T(V) : w.protectedKeys[V] = !0;
      }
      w.prevProp = x, w.prevResolvedValues = Z, w.isActive && (m = { ...m, ...Z }), n && e.blockInitialAnimation && (A = !1), A && (!(N && j) || D) && h.push(...H.map((V) => ({
        animation: V,
        options: { type: M }
      })));
    }
    if (y.size) {
      const g = {};
      y.forEach((M) => {
        const w = e.getBaseTarget(M), x = e.getValue(M);
        x && (x.liveStyle = !0), g[M] = w ?? null;
      }), h.push({ animation: g });
    }
    let k = !!h.length;
    return n && (d.initial === !1 || d.initial === d.animate) && !e.manuallyAnimateOnMount && (k = !1), n = !1, k ? t(h) : Promise.resolve();
  }
  function c(f, d) {
    var u;
    if (a[f].isActive === d)
      return Promise.resolve();
    (u = e.variantChildren) === null || u === void 0 || u.forEach((y) => {
      var m;
      return (m = y.animationState) === null || m === void 0 ? void 0 : m.setActive(f, d);
    }), a[f].isActive = d;
    const h = s(f);
    for (const y in a)
      a[y].protectedKeys = {};
    return h;
  }
  return {
    animateChanges: s,
    setActive: c,
    setAnimateFunction: i,
    getState: () => a,
    reset: () => {
      a = qc(), n = !0;
    }
  };
}
function qye(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !Zl(t, e) : !1;
}
function S1(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function qc() {
  return {
    animate: S1(!0),
    whileInView: S1(),
    whileHover: S1(),
    whileTap: S1(),
    whileDrag: S1(),
    whileFocus: S1(),
    exit: S1()
  };
}
class g1 {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class Bye extends g1 {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = Oye(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    yr(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: a } = this.node.prevProps || {};
    t !== a && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) === null || t === void 0 || t.call(this);
  }
}
let Zye = 0;
class Fye extends g1 {
  constructor() {
    super(...arguments), this.id = Zye++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: a } = this.node.presenceContext, { isPresent: n } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === n)
      return;
    const o = this.node.animationState.setActive("exit", !t);
    a && !t && o.then(() => a(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const Gye = {
  animation: {
    Feature: Bye
  },
  exit: {
    Feature: Fye
  }
};
function vn(e, t, a, n = { passive: !0 }) {
  return e.addEventListener(t, a, n), () => e.removeEventListener(t, a);
}
function En(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const $ye = (e) => (t) => A0(t) && e(t, En(t));
function sn(e, t, a, n) {
  return vn(e, t, $ye(a), n);
}
const Bc = (e, t) => Math.abs(e - t);
function Uye(e, t) {
  const a = Bc(e.x, t.x), n = Bc(e.y, t.y);
  return Math.sqrt(a ** 2 + n ** 2);
}
class Tu {
  constructor(t, a, { transformPagePoint: n, contextWindow: o, dragSnapToOrigin: i = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const h = h2(this.lastMoveEventInfo, this.history), y = this.startEvent !== null, m = Uye(h.offset, { x: 0, y: 0 }) >= 3;
      if (!y && !m)
        return;
      const { point: v } = h, { timestamp: k } = Ue;
      this.history.push({ ...v, timestamp: k });
      const { onStart: g, onMove: M } = this.handlers;
      y || (g && g(this.lastMoveEvent, h), this.startEvent = this.lastMoveEvent), M && M(this.lastMoveEvent, h);
    }, this.handlePointerMove = (h, y) => {
      this.lastMoveEvent = h, this.lastMoveEventInfo = u2(y, this.transformPagePoint), Se.update(this.updatePoint, !0);
    }, this.handlePointerUp = (h, y) => {
      this.end();
      const { onEnd: m, onSessionEnd: v, resumeAnimation: k } = this.handlers;
      if (this.dragSnapToOrigin && k && k(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const g = h2(h.type === "pointercancel" ? this.lastMoveEventInfo : u2(y, this.transformPagePoint), this.history);
      this.startEvent && m && m(h, g), v && v(h, g);
    }, !A0(t))
      return;
    this.dragSnapToOrigin = i, this.handlers = a, this.transformPagePoint = n, this.contextWindow = o || window;
    const s = En(t), c = u2(s, this.transformPagePoint), { point: f } = c, { timestamp: d } = Ue;
    this.history = [{ ...f, timestamp: d }];
    const { onSessionStart: u } = a;
    u && u(t, h2(c, this.history)), this.removeListeners = Pn(sn(this.contextWindow, "pointermove", this.handlePointerMove), sn(this.contextWindow, "pointerup", this.handlePointerUp), sn(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), h1(this.updatePoint);
  }
}
function u2(e, t) {
  return t ? { point: t(e.point) } : e;
}
function Zc(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function h2({ point: e }, t) {
  return {
    point: e,
    delta: Zc(e, zu(t)),
    offset: Zc(e, Wye(t)),
    velocity: Yye(t, 0.1)
  };
}
function Wye(e) {
  return e[0];
}
function zu(e) {
  return e[e.length - 1];
}
function Yye(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let a = e.length - 1, n = null;
  const o = zu(e);
  for (; a >= 0 && (n = e[a], !(o.timestamp - n.timestamp > /* @__PURE__ */ Ft(t))); )
    a--;
  if (!n)
    return { x: 0, y: 0 };
  const i = /* @__PURE__ */ Jt(o.timestamp - n.timestamp);
  if (i === 0)
    return { x: 0, y: 0 };
  const s = {
    x: (o.x - n.x) / i,
    y: (o.y - n.y) / i
  };
  return s.x === 1 / 0 && (s.x = 0), s.y === 1 / 0 && (s.y = 0), s;
}
const Du = 1e-4, Qye = 1 - Du, Jye = 1 + Du, _u = 0.01, Kye = 0 - _u, Xye = 0 + _u;
function yt(e) {
  return e.max - e.min;
}
function e6e(e, t, a) {
  return Math.abs(e - t) <= a;
}
function Fc(e, t, a, n = 0.5) {
  e.origin = n, e.originPoint = _e(t.min, t.max, e.origin), e.scale = yt(a) / yt(t), e.translate = _e(a.min, a.max, e.origin) - e.originPoint, (e.scale >= Qye && e.scale <= Jye || isNaN(e.scale)) && (e.scale = 1), (e.translate >= Kye && e.translate <= Xye || isNaN(e.translate)) && (e.translate = 0);
}
function cn(e, t, a, n) {
  Fc(e.x, t.x, a.x, n ? n.originX : void 0), Fc(e.y, t.y, a.y, n ? n.originY : void 0);
}
function Gc(e, t, a) {
  e.min = a.min + t.min, e.max = e.min + yt(t);
}
function t6e(e, t, a) {
  Gc(e.x, t.x, a.x), Gc(e.y, t.y, a.y);
}
function $c(e, t, a) {
  e.min = t.min - a.min, e.max = e.min + yt(t);
}
function fn(e, t, a) {
  $c(e.x, t.x, a.x), $c(e.y, t.y, a.y);
}
function a6e(e, { min: t, max: a }, n) {
  return t !== void 0 && e < t ? e = n ? _e(t, e, n.min) : Math.max(e, t) : a !== void 0 && e > a && (e = n ? _e(a, e, n.max) : Math.min(e, a)), e;
}
function Uc(e, t, a) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: a !== void 0 ? e.max + a - (e.max - e.min) : void 0
  };
}
function n6e(e, { top: t, left: a, bottom: n, right: o }) {
  return {
    x: Uc(e.x, a, o),
    y: Uc(e.y, t, n)
  };
}
function Wc(e, t) {
  let a = t.min - e.min, n = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([a, n] = [n, a]), { min: a, max: n };
}
function o6e(e, t) {
  return {
    x: Wc(e.x, t.x),
    y: Wc(e.y, t.y)
  };
}
function r6e(e, t) {
  let a = 0.5;
  const n = yt(e), o = yt(t);
  return o > n ? a = /* @__PURE__ */ va(t.min, t.max - n, e.min) : n > o && (a = /* @__PURE__ */ va(e.min, e.max - o, t.min)), e1(0, 1, a);
}
function i6e(e, t) {
  const a = {};
  return t.min !== void 0 && (a.min = t.min - e.min), t.max !== void 0 && (a.max = t.max - e.min), a;
}
const pi = 0.35;
function s6e(e = pi) {
  return e === !1 ? e = 0 : e === !0 && (e = pi), {
    x: Yc(e, "left", "right"),
    y: Yc(e, "top", "bottom")
  };
}
function Yc(e, t, a) {
  return {
    min: Qc(e, t),
    max: Qc(e, a)
  };
}
function Qc(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const Jc = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), fa = () => ({
  x: Jc(),
  y: Jc()
}), Kc = () => ({ min: 0, max: 0 }), He = () => ({
  x: Kc(),
  y: Kc()
});
function Ct(e) {
  return [e("x"), e("y")];
}
function Pu({ top: e, left: t, right: a, bottom: n }) {
  return {
    x: { min: t, max: a },
    y: { min: e, max: n }
  };
}
function c6e({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function f6e(e, t) {
  if (!t)
    return e;
  const a = t({ x: e.left, y: e.top }), n = t({ x: e.right, y: e.bottom });
  return {
    top: a.y,
    left: a.x,
    bottom: n.y,
    right: n.x
  };
}
function p2(e) {
  return e === void 0 || e === 1;
}
function yi({ scale: e, scaleX: t, scaleY: a }) {
  return !p2(e) || !p2(t) || !p2(a);
}
function z1(e) {
  return yi(e) || Eu(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function Eu(e) {
  return Xc(e.x) || Xc(e.y);
}
function Xc(e) {
  return e && e !== "0%";
}
function Zo(e, t, a) {
  const n = e - a, o = t * n;
  return a + o;
}
function ef(e, t, a, n, o) {
  return o !== void 0 && (e = Zo(e, o, n)), Zo(e, a, n) + t;
}
function mi(e, t = 0, a = 1, n, o) {
  e.min = ef(e.min, t, a, n, o), e.max = ef(e.max, t, a, n, o);
}
function Ru(e, { x: t, y: a }) {
  mi(e.x, t.translate, t.scale, t.originPoint), mi(e.y, a.translate, a.scale, a.originPoint);
}
const tf = 0.999999999999, af = 1.0000000000001;
function d6e(e, t, a, n = !1) {
  const o = a.length;
  if (!o)
    return;
  t.x = t.y = 1;
  let i, s;
  for (let c = 0; c < o; c++) {
    i = a[c], s = i.projectionDelta;
    const { visualElement: f } = i.options;
    f && f.props.style && f.props.style.display === "contents" || (n && i.options.layoutScroll && i.scroll && i !== i.root && la(e, {
      x: -i.scroll.offset.x,
      y: -i.scroll.offset.y
    }), s && (t.x *= s.x.scale, t.y *= s.y.scale, Ru(e, s)), n && z1(i.latestValues) && la(e, i.latestValues));
  }
  t.x < af && t.x > tf && (t.x = 1), t.y < af && t.y > tf && (t.y = 1);
}
function da(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function nf(e, t, a, n, o = 0.5) {
  const i = _e(e.min, e.max, o);
  mi(e, t, a, i, n);
}
function la(e, t) {
  nf(e.x, t.x, t.scaleX, t.scale, t.originX), nf(e.y, t.y, t.scaleY, t.scale, t.originY);
}
function Hu(e, t) {
  return Pu(f6e(e.getBoundingClientRect(), t));
}
function l6e(e, t, a) {
  const n = Hu(e, a), { scroll: o } = t;
  return o && (da(n.x, o.offset.x), da(n.y, o.offset.y)), n;
}
const Vu = ({ current: e }) => e ? e.ownerDocument.defaultView : null, u6e = /* @__PURE__ */ new WeakMap();
class h6e {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = He(), this.visualElement = t;
  }
  start(t, { snapToCursor: a = !1 } = {}) {
    const { presenceContext: n } = this.visualElement;
    if (n && n.isPresent === !1)
      return;
    const o = (u) => {
      const { dragSnapToOrigin: h } = this.getProps();
      h ? this.pauseAnimation() : this.stopAnimation(), a && this.snapToCursor(En(u).point);
    }, i = (u, h) => {
      const { drag: y, dragPropagation: m, onDragStart: v } = this.getProps();
      if (y && !m && (this.openDragLock && this.openDragLock(), this.openDragLock = rpe(y), !this.openDragLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), Ct((g) => {
        let M = this.getAxisMotionValue(g).get() || 0;
        if (Gt.test(M)) {
          const { projection: w } = this.visualElement;
          if (w && w.layout) {
            const x = w.layout.layoutBox[g];
            x && (M = yt(x) * (parseFloat(M) / 100));
          }
        }
        this.originPoint[g] = M;
      }), v && Se.postRender(() => v(u, h)), ii(this.visualElement, "transform");
      const { animationState: k } = this.visualElement;
      k && k.setActive("whileDrag", !0);
    }, s = (u, h) => {
      const { dragPropagation: y, dragDirectionLock: m, onDirectionLock: v, onDrag: k } = this.getProps();
      if (!y && !this.openDragLock)
        return;
      const { offset: g } = h;
      if (m && this.currentDirection === null) {
        this.currentDirection = p6e(g), this.currentDirection !== null && v && v(this.currentDirection);
        return;
      }
      this.updateAxis("x", h.point, g), this.updateAxis("y", h.point, g), this.visualElement.render(), k && k(u, h);
    }, c = (u, h) => this.stop(u, h), f = () => Ct((u) => {
      var h;
      return this.getAnimationState(u) === "paused" && ((h = this.getAxisMotionValue(u).animation) === null || h === void 0 ? void 0 : h.play());
    }), { dragSnapToOrigin: d } = this.getProps();
    this.panSession = new Tu(t, {
      onSessionStart: o,
      onStart: i,
      onMove: s,
      onSessionEnd: c,
      resumeAnimation: f
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: d,
      contextWindow: Vu(this.visualElement)
    });
  }
  stop(t, a) {
    const n = this.isDragging;
    if (this.cancel(), !n)
      return;
    const { velocity: o } = a;
    this.startAnimation(o);
    const { onDragEnd: i } = this.getProps();
    i && Se.postRender(() => i(t, a));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: a } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: n } = this.getProps();
    !n && this.openDragLock && (this.openDragLock(), this.openDragLock = null), a && a.setActive("whileDrag", !1);
  }
  updateAxis(t, a, n) {
    const { drag: o } = this.getProps();
    if (!n || !io(t, o, this.currentDirection))
      return;
    const i = this.getAxisMotionValue(t);
    let s = this.originPoint[t] + n[t];
    this.constraints && this.constraints[t] && (s = a6e(s, this.constraints[t], this.elastic[t])), i.set(s);
  }
  resolveConstraints() {
    var t;
    const { dragConstraints: a, dragElastic: n } = this.getProps(), o = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (t = this.visualElement.projection) === null || t === void 0 ? void 0 : t.layout, i = this.constraints;
    a && sa(a) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : a && o ? this.constraints = n6e(o.layoutBox, a) : this.constraints = !1, this.elastic = s6e(n), i !== this.constraints && o && this.constraints && !this.hasMutatedConstraints && Ct((s) => {
      this.constraints !== !1 && this.getAxisMotionValue(s) && (this.constraints[s] = i6e(o.layoutBox[s], this.constraints[s]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: a } = this.getProps();
    if (!t || !sa(t))
      return !1;
    const n = t.current;
    u1(n !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: o } = this.visualElement;
    if (!o || !o.layout)
      return !1;
    const i = l6e(n, o.root, this.visualElement.getTransformPagePoint());
    let s = o6e(o.layout.layoutBox, i);
    if (a) {
      const c = a(c6e(s));
      this.hasMutatedConstraints = !!c, c && (s = Pu(c));
    }
    return s;
  }
  startAnimation(t) {
    const { drag: a, dragMomentum: n, dragElastic: o, dragTransition: i, dragSnapToOrigin: s, onDragTransitionEnd: c } = this.getProps(), f = this.constraints || {}, d = Ct((u) => {
      if (!io(u, a, this.currentDirection))
        return;
      let h = f && f[u] || {};
      s && (h = { min: 0, max: 0 });
      const y = o ? 200 : 1e6, m = o ? 40 : 1e7, v = {
        type: "inertia",
        velocity: n ? t[u] : 0,
        bounceStiffness: y,
        bounceDamping: m,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...i,
        ...h
      };
      return this.startAxisValueAnimation(u, v);
    });
    return Promise.all(d).then(c);
  }
  startAxisValueAnimation(t, a) {
    const n = this.getAxisMotionValue(t);
    return ii(this.visualElement, t), n.start(O0(t, n, 0, a, this.visualElement, !1));
  }
  stopAnimation() {
    Ct((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    Ct((t) => {
      var a;
      return (a = this.getAxisMotionValue(t).animation) === null || a === void 0 ? void 0 : a.pause();
    });
  }
  getAnimationState(t) {
    var a;
    return (a = this.getAxisMotionValue(t).animation) === null || a === void 0 ? void 0 : a.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const a = `_drag${t.toUpperCase()}`, n = this.visualElement.getProps(), o = n[a];
    return o || this.visualElement.getValue(t, (n.initial ? n.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    Ct((a) => {
      const { drag: n } = this.getProps();
      if (!io(a, n, this.currentDirection))
        return;
      const { projection: o } = this.visualElement, i = this.getAxisMotionValue(a);
      if (o && o.layout) {
        const { min: s, max: c } = o.layout.layoutBox[a];
        i.set(t[a] - _e(s, c, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: a } = this.getProps(), { projection: n } = this.visualElement;
    if (!sa(a) || !n || !this.constraints)
      return;
    this.stopAnimation();
    const o = { x: 0, y: 0 };
    Ct((s) => {
      const c = this.getAxisMotionValue(s);
      if (c && this.constraints !== !1) {
        const f = c.get();
        o[s] = r6e({ min: f, max: f }, this.constraints[s]);
      }
    });
    const { transformTemplate: i } = this.visualElement.getProps();
    this.visualElement.current.style.transform = i ? i({}, "") : "none", n.root && n.root.updateScroll(), n.updateLayout(), this.resolveConstraints(), Ct((s) => {
      if (!io(s, t, null))
        return;
      const c = this.getAxisMotionValue(s), { min: f, max: d } = this.constraints[s];
      c.set(_e(f, d, o[s]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    u6e.set(this.visualElement, this);
    const t = this.visualElement.current, a = sn(t, "pointerdown", (f) => {
      const { drag: d, dragListener: u = !0 } = this.getProps();
      d && u && this.start(f);
    }), n = () => {
      const { dragConstraints: f } = this.getProps();
      sa(f) && f.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: o } = this.visualElement, i = o.addEventListener("measure", n);
    o && !o.layout && (o.root && o.root.updateScroll(), o.updateLayout()), Se.read(n);
    const s = vn(window, "resize", () => this.scalePositionWithinConstraints()), c = o.addEventListener("didUpdate", ({ delta: f, hasLayoutChanged: d }) => {
      this.isDragging && d && (Ct((u) => {
        const h = this.getAxisMotionValue(u);
        h && (this.originPoint[u] += f[u].translate, h.set(h.get() + f[u].translate));
      }), this.visualElement.render());
    });
    return () => {
      s(), a(), i(), c && c();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: a = !1, dragDirectionLock: n = !1, dragPropagation: o = !1, dragConstraints: i = !1, dragElastic: s = pi, dragMomentum: c = !0 } = t;
    return {
      ...t,
      drag: a,
      dragDirectionLock: n,
      dragPropagation: o,
      dragConstraints: i,
      dragElastic: s,
      dragMomentum: c
    };
  }
}
function io(e, t, a) {
  return (t === !0 || t === e) && (a === null || a === e);
}
function p6e(e, t = 10) {
  let a = null;
  return Math.abs(e.y) > t ? a = "y" : Math.abs(e.x) > t && (a = "x"), a;
}
class y6e extends g1 {
  constructor(t) {
    super(t), this.removeGroupControls = st, this.removeListeners = st, this.controls = new h6e(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || st;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const of = (e) => (t, a) => {
  e && Se.postRender(() => e(t, a));
};
class m6e extends g1 {
  constructor() {
    super(...arguments), this.removePointerDownListener = st;
  }
  onPointerDown(t) {
    this.session = new Tu(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Vu(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: a, onPan: n, onPanEnd: o } = this.node.getProps();
    return {
      onSessionStart: of(t),
      onStart: of(a),
      onMove: n,
      onEnd: (i, s) => {
        delete this.session, o && Se.postRender(() => o(i, s));
      }
    };
  }
  mount() {
    this.removePointerDownListener = sn(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const Co = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function rf(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const Ua = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (te.test(e))
        e = parseFloat(e);
      else
        return e;
    const a = rf(e, t.target.x), n = rf(e, t.target.y);
    return `${a}% ${n}%`;
  }
}, k6e = {
  correct: (e, { treeScale: t, projectionDelta: a }) => {
    const n = e, o = p1.parse(e);
    if (o.length > 5)
      return n;
    const i = p1.createTransformer(e), s = typeof o[0] != "number" ? 1 : 0, c = a.x.scale * t.x, f = a.y.scale * t.y;
    o[0 + s] /= c, o[1 + s] /= f;
    const d = _e(c, f, 0.5);
    return typeof o[2 + s] == "number" && (o[2 + s] /= d), typeof o[3 + s] == "number" && (o[3 + s] /= d), i(o);
  }
};
class g6e extends xd {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: a, switchLayoutGroup: n, layoutId: o } = this.props, { projection: i } = t;
    H3e(v6e), i && (a.group && a.group.add(i), n && n.register && o && n.register(i), i.root.didUpdate(), i.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), i.setOptions({
      ...i.options,
      onExitComplete: () => this.safeToRemove()
    })), Co.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: a, visualElement: n, drag: o, isPresent: i } = this.props, s = n.projection;
    return s && (s.isPresent = i, o || t.layoutDependency !== a || a === void 0 ? s.willUpdate() : this.safeToRemove(), t.isPresent !== i && (i ? s.promote() : s.relegate() || Se.postRender(() => {
      const c = s.getStack();
      (!c || !c.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), y0.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: a, switchLayoutGroup: n } = this.props, { projection: o } = t;
    o && (o.scheduleCheckAfterUnmount(), a && a.group && a.group.remove(o), n && n.deregister && n.deregister(o));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function Ou(e) {
  const [t, a] = Cl(), n = xe(s0);
  return l.jsx(g6e, { ...e, layoutGroup: n, switchLayoutGroup: xe(Il), isPresent: t, safeToRemove: a });
}
const v6e = {
  borderRadius: {
    ...Ua,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Ua,
  borderTopRightRadius: Ua,
  borderBottomLeftRadius: Ua,
  borderBottomRightRadius: Ua,
  boxShadow: k6e
};
function M6e(e, t, a) {
  const n = Je(e) ? e : kn(e);
  return n.start(O0("", n, t, a)), n.animation;
}
function w6e(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
const x6e = (e, t) => e.depth - t.depth;
class C6e {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    S0(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    I0(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(x6e), this.isDirty = !1, this.children.forEach(t);
  }
}
function b6e(e, t) {
  const a = $t.now(), n = ({ timestamp: o }) => {
    const i = o - a;
    i >= t && (h1(n), e(i - t));
  };
  return Se.read(n, !0), () => h1(n);
}
const qu = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], L6e = qu.length, sf = (e) => typeof e == "string" ? parseFloat(e) : e, cf = (e) => typeof e == "number" || te.test(e);
function j6e(e, t, a, n, o, i) {
  o ? (e.opacity = _e(
    0,
    // TODO Reinstate this if only child
    a.opacity !== void 0 ? a.opacity : 1,
    N6e(n)
  ), e.opacityExit = _e(t.opacity !== void 0 ? t.opacity : 1, 0, A6e(n))) : i && (e.opacity = _e(t.opacity !== void 0 ? t.opacity : 1, a.opacity !== void 0 ? a.opacity : 1, n));
  for (let s = 0; s < L6e; s++) {
    const c = `border${qu[s]}Radius`;
    let f = ff(t, c), d = ff(a, c);
    if (f === void 0 && d === void 0)
      continue;
    f || (f = 0), d || (d = 0), f === 0 || d === 0 || cf(f) === cf(d) ? (e[c] = Math.max(_e(sf(f), sf(d), n), 0), (Gt.test(d) || Gt.test(f)) && (e[c] += "%")) : e[c] = d;
  }
  (t.rotate || a.rotate) && (e.rotate = _e(t.rotate || 0, a.rotate || 0, n));
}
function ff(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const N6e = /* @__PURE__ */ Bu(0, 0.5, iu), A6e = /* @__PURE__ */ Bu(0.5, 0.95, st);
function Bu(e, t, a) {
  return (n) => n < e ? 0 : n > t ? 1 : a(/* @__PURE__ */ va(e, t, n));
}
function df(e, t) {
  e.min = t.min, e.max = t.max;
}
function wt(e, t) {
  df(e.x, t.x), df(e.y, t.y);
}
function lf(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
function uf(e, t, a, n, o) {
  return e -= t, e = Zo(e, 1 / a, n), o !== void 0 && (e = Zo(e, 1 / o, n)), e;
}
function S6e(e, t = 0, a = 1, n = 0.5, o, i = e, s = e) {
  if (Gt.test(t) && (t = parseFloat(t), t = _e(s.min, s.max, t / 100) - s.min), typeof t != "number")
    return;
  let c = _e(i.min, i.max, n);
  e === i && (c -= t), e.min = uf(e.min, t, a, c, o), e.max = uf(e.max, t, a, c, o);
}
function hf(e, t, [a, n, o], i, s) {
  S6e(e, t[a], t[n], t[o], t.scale, i, s);
}
const I6e = ["x", "scaleX", "originX"], T6e = ["y", "scaleY", "originY"];
function pf(e, t, a, n) {
  hf(e.x, t, I6e, a ? a.x : void 0, n ? n.x : void 0), hf(e.y, t, T6e, a ? a.y : void 0, n ? n.y : void 0);
}
function yf(e) {
  return e.translate === 0 && e.scale === 1;
}
function Zu(e) {
  return yf(e.x) && yf(e.y);
}
function mf(e, t) {
  return e.min === t.min && e.max === t.max;
}
function z6e(e, t) {
  return mf(e.x, t.x) && mf(e.y, t.y);
}
function kf(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function Fu(e, t) {
  return kf(e.x, t.x) && kf(e.y, t.y);
}
function gf(e) {
  return yt(e.x) / yt(e.y);
}
function vf(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
class D6e {
  constructor() {
    this.members = [];
  }
  add(t) {
    S0(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (I0(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const a = this.members[this.members.length - 1];
      a && this.promote(a);
    }
  }
  relegate(t) {
    const a = this.members.findIndex((o) => t === o);
    if (a === 0)
      return !1;
    let n;
    for (let o = a; o >= 0; o--) {
      const i = this.members[o];
      if (i.isPresent !== !1) {
        n = i;
        break;
      }
    }
    return n ? (this.promote(n), !0) : !1;
  }
  promote(t, a) {
    const n = this.lead;
    if (t !== n && (this.prevLead = n, this.lead = t, t.show(), n)) {
      n.instance && n.scheduleRender(), t.scheduleRender(), t.resumeFrom = n, a && (t.resumeFrom.preserveOpacity = !0), n.snapshot && (t.snapshot = n.snapshot, t.snapshot.latestValues = n.animationValues || n.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: o } = t.options;
      o === !1 && n.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: a, resumingFrom: n } = t;
      a.onExitComplete && a.onExitComplete(), n && n.options.onExitComplete && n.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function _6e(e, t, a) {
  let n = "";
  const o = e.x.translate / t.x, i = e.y.translate / t.y, s = (a == null ? void 0 : a.z) || 0;
  if ((o || i || s) && (n = `translate3d(${o}px, ${i}px, ${s}px) `), (t.x !== 1 || t.y !== 1) && (n += `scale(${1 / t.x}, ${1 / t.y}) `), a) {
    const { transformPerspective: d, rotate: u, rotateX: h, rotateY: y, skewX: m, skewY: v } = a;
    d && (n = `perspective(${d}px) ${n}`), u && (n += `rotate(${u}deg) `), h && (n += `rotateX(${h}deg) `), y && (n += `rotateY(${y}deg) `), m && (n += `skewX(${m}deg) `), v && (n += `skewY(${v}deg) `);
  }
  const c = e.x.scale * t.x, f = e.y.scale * t.y;
  return (c !== 1 || f !== 1) && (n += `scale(${c}, ${f})`), n || "none";
}
const D1 = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
}, an = typeof window < "u" && window.MotionDebug !== void 0, y2 = ["", "X", "Y", "Z"], P6e = { visibility: "hidden" }, Mf = 1e3;
let E6e = 0;
function m2(e, t, a, n) {
  const { latestValues: o } = t;
  o[e] && (a[e] = o[e], t.setStaticValue(e, 0), n && (n[e] = 0));
}
function Gu(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const a = Xl(t);
  if (window.MotionHasOptimisedAnimation(a, "transform")) {
    const { layout: o, layoutId: i } = e.options;
    window.MotionCancelOptimisedAnimation(a, "transform", Se, !(o || i));
  }
  const { parent: n } = e;
  n && !n.hasCheckedOptimisedAppear && Gu(n);
}
function $u({ attachResizeListener: e, defaultParent: t, measureScroll: a, checkIsScrollRoot: n, resetTransform: o }) {
  return class {
    constructor(s = {}, c = t == null ? void 0 : t()) {
      this.id = E6e++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, an && (D1.totalNodes = D1.resolvedTargetDeltas = D1.recalculatedProjection = 0), this.nodes.forEach(V6e), this.nodes.forEach(F6e), this.nodes.forEach(G6e), this.nodes.forEach(O6e), an && window.MotionDebug.record(D1);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = s, this.root = c ? c.root || c : this, this.path = c ? [...c.path, c] : [], this.parent = c, this.depth = c ? c.depth + 1 : 0;
      for (let f = 0; f < this.path.length; f++)
        this.path[f].shouldResetTransform = !0;
      this.root === this && (this.nodes = new C6e());
    }
    addEventListener(s, c) {
      return this.eventHandlers.has(s) || this.eventHandlers.set(s, new T0()), this.eventHandlers.get(s).add(c);
    }
    notifyListeners(s, ...c) {
      const f = this.eventHandlers.get(s);
      f && f.notify(...c);
    }
    hasListeners(s) {
      return this.eventHandlers.has(s);
    }
    /**
     * Lifecycles
     */
    mount(s, c = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = w6e(s), this.instance = s;
      const { layoutId: f, layout: d, visualElement: u } = this.options;
      if (u && !u.current && u.mount(s), this.root.nodes.add(this), this.parent && this.parent.children.add(this), c && (d || f) && (this.isLayoutDirty = !0), e) {
        let h;
        const y = () => this.root.updateBlockedByResize = !1;
        e(s, () => {
          this.root.updateBlockedByResize = !0, h && h(), h = b6e(y, 250), Co.hasAnimatedSinceResize && (Co.hasAnimatedSinceResize = !1, this.nodes.forEach(xf));
        });
      }
      f && this.root.registerSharedNode(f, this), this.options.animate !== !1 && u && (f || d) && this.addEventListener("didUpdate", ({ delta: h, hasLayoutChanged: y, hasRelativeTargetChanged: m, layout: v }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const k = this.options.transition || u.getDefaultTransition() || Q6e, { onLayoutAnimationStart: g, onLayoutAnimationComplete: M } = u.getProps(), w = !this.targetLayout || !Fu(this.targetLayout, v) || m, x = !y && m;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || x || y && (w || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(h, x);
          const C = {
            ...L0(k, "layout"),
            onPlay: g,
            onComplete: M
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (C.delay = 0, C.type = !1), this.startAnimation(C);
        } else
          y || xf(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = v;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const s = this.getStack();
      s && s.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, h1(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach($6e), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: s } = this.options;
      return s && s.getProps().transformTemplate;
    }
    willUpdate(s = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && Gu(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const h = this.path[u];
        h.shouldResetTransform = !0, h.updateScroll("snapshot"), h.options.layoutRoot && h.willUpdate(!1);
      }
      const { layoutId: c, layout: f } = this.options;
      if (c === void 0 && !f)
        return;
      const d = this.getTransformTemplate();
      this.prevTransformTemplateValue = d ? d(this.latestValues, "") : void 0, this.updateSnapshot(), s && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(wf);
        return;
      }
      this.isUpdating || this.nodes.forEach(B6e), this.isUpdating = !1, this.nodes.forEach(Z6e), this.nodes.forEach(R6e), this.nodes.forEach(H6e), this.clearAllSnapshots();
      const c = $t.now();
      Ue.delta = e1(0, 1e3 / 60, c - Ue.timestamp), Ue.timestamp = c, Ue.isProcessing = !0, s2.update.process(Ue), s2.preRender.process(Ue), s2.render.process(Ue), Ue.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, y0.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(q6e), this.sharedNodes.forEach(U6e);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Se.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Se.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let f = 0; f < this.path.length; f++)
          this.path[f].updateScroll();
      const s = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = He(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: c } = this.options;
      c && c.notify("LayoutMeasure", this.layout.layoutBox, s ? s.layoutBox : void 0);
    }
    updateScroll(s = "measure") {
      let c = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === s && (c = !1), c) {
        const f = n(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: s,
          isRoot: f,
          offset: a(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : f
        };
      }
    }
    resetTransform() {
      if (!o)
        return;
      const s = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, c = this.projectionDelta && !Zu(this.projectionDelta), f = this.getTransformTemplate(), d = f ? f(this.latestValues, "") : void 0, u = d !== this.prevTransformTemplateValue;
      s && (c || z1(this.latestValues) || u) && (o(this.instance, d), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(s = !0) {
      const c = this.measurePageBox();
      let f = this.removeElementScroll(c);
      return s && (f = this.removeTransform(f)), J6e(f), {
        animationId: this.root.animationId,
        measuredBox: c,
        layoutBox: f,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var s;
      const { visualElement: c } = this.options;
      if (!c)
        return He();
      const f = c.measureViewportBox();
      if (!(((s = this.scroll) === null || s === void 0 ? void 0 : s.wasRoot) || this.path.some(K6e))) {
        const { scroll: u } = this.root;
        u && (da(f.x, u.offset.x), da(f.y, u.offset.y));
      }
      return f;
    }
    removeElementScroll(s) {
      var c;
      const f = He();
      if (wt(f, s), !((c = this.scroll) === null || c === void 0) && c.wasRoot)
        return f;
      for (let d = 0; d < this.path.length; d++) {
        const u = this.path[d], { scroll: h, options: y } = u;
        u !== this.root && h && y.layoutScroll && (h.wasRoot && wt(f, s), da(f.x, h.offset.x), da(f.y, h.offset.y));
      }
      return f;
    }
    applyTransform(s, c = !1) {
      const f = He();
      wt(f, s);
      for (let d = 0; d < this.path.length; d++) {
        const u = this.path[d];
        !c && u.options.layoutScroll && u.scroll && u !== u.root && la(f, {
          x: -u.scroll.offset.x,
          y: -u.scroll.offset.y
        }), z1(u.latestValues) && la(f, u.latestValues);
      }
      return z1(this.latestValues) && la(f, this.latestValues), f;
    }
    removeTransform(s) {
      const c = He();
      wt(c, s);
      for (let f = 0; f < this.path.length; f++) {
        const d = this.path[f];
        if (!d.instance || !z1(d.latestValues))
          continue;
        yi(d.latestValues) && d.updateSnapshot();
        const u = He(), h = d.measurePageBox();
        wt(u, h), pf(c, d.latestValues, d.snapshot ? d.snapshot.layoutBox : void 0, u);
      }
      return z1(this.latestValues) && pf(c, this.latestValues), c;
    }
    setTargetDelta(s) {
      this.targetDelta = s, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(s) {
      this.options = {
        ...this.options,
        ...s,
        crossfade: s.crossfade !== void 0 ? s.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Ue.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(s = !1) {
      var c;
      const f = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = f.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = f.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = f.isSharedProjectionDirty);
      const d = !!this.resumingFrom || this !== f;
      if (!(s || d && this.isSharedProjectionDirty || this.isProjectionDirty || !((c = this.parent) === null || c === void 0) && c.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: h, layoutId: y } = this.options;
      if (!(!this.layout || !(h || y))) {
        if (this.resolvedRelativeTargetAt = Ue.timestamp, !this.targetDelta && !this.relativeTarget) {
          const m = this.getClosestProjectingParent();
          m && m.layout && this.animationProgress !== 1 ? (this.relativeParent = m, this.forceRelativeParentToResolveTarget(), this.relativeTarget = He(), this.relativeTargetOrigin = He(), fn(this.relativeTargetOrigin, this.layout.layoutBox, m.layout.layoutBox), wt(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = He(), this.targetWithTransforms = He()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), t6e(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : wt(this.target, this.layout.layoutBox), Ru(this.target, this.targetDelta)) : wt(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const m = this.getClosestProjectingParent();
            m && !!m.resumingFrom == !!this.resumingFrom && !m.options.layoutScroll && m.target && this.animationProgress !== 1 ? (this.relativeParent = m, this.forceRelativeParentToResolveTarget(), this.relativeTarget = He(), this.relativeTargetOrigin = He(), fn(this.relativeTargetOrigin, this.target, m.target), wt(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          an && D1.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || yi(this.parent.latestValues) || Eu(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var s;
      const c = this.getLead(), f = !!this.resumingFrom || this !== c;
      let d = !0;
      if ((this.isProjectionDirty || !((s = this.parent) === null || s === void 0) && s.isProjectionDirty) && (d = !1), f && (this.isSharedProjectionDirty || this.isTransformDirty) && (d = !1), this.resolvedRelativeTargetAt === Ue.timestamp && (d = !1), d)
        return;
      const { layout: u, layoutId: h } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || h))
        return;
      wt(this.layoutCorrected, this.layout.layoutBox);
      const y = this.treeScale.x, m = this.treeScale.y;
      d6e(this.layoutCorrected, this.treeScale, this.path, f), c.layout && !c.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (c.target = c.layout.layoutBox, c.targetWithTransforms = He());
      const { target: v } = c;
      if (!v) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (lf(this.prevProjectionDelta.x, this.projectionDelta.x), lf(this.prevProjectionDelta.y, this.projectionDelta.y)), cn(this.projectionDelta, this.layoutCorrected, v, this.latestValues), (this.treeScale.x !== y || this.treeScale.y !== m || !vf(this.projectionDelta.x, this.prevProjectionDelta.x) || !vf(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", v)), an && D1.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(s = !0) {
      var c;
      if ((c = this.options.visualElement) === null || c === void 0 || c.scheduleRender(), s) {
        const f = this.getStack();
        f && f.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = fa(), this.projectionDelta = fa(), this.projectionDeltaWithTransform = fa();
    }
    setAnimationOrigin(s, c = !1) {
      const f = this.snapshot, d = f ? f.latestValues : {}, u = { ...this.latestValues }, h = fa();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !c;
      const y = He(), m = f ? f.source : void 0, v = this.layout ? this.layout.source : void 0, k = m !== v, g = this.getStack(), M = !g || g.members.length <= 1, w = !!(k && !M && this.options.crossfade === !0 && !this.path.some(Y6e));
      this.animationProgress = 0;
      let x;
      this.mixTargetDelta = (C) => {
        const L = C / 1e3;
        Cf(h.x, s.x, L), Cf(h.y, s.y, L), this.setTargetDelta(h), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (fn(y, this.layout.layoutBox, this.relativeParent.layout.layoutBox), W6e(this.relativeTarget, this.relativeTargetOrigin, y, L), x && z6e(this.relativeTarget, x) && (this.isProjectionDirty = !1), x || (x = He()), wt(x, this.relativeTarget)), k && (this.animationValues = u, j6e(u, d, this.latestValues, L, w, M)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = L;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(s) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (h1(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Se.update(() => {
        Co.hasAnimatedSinceResize = !0, this.currentAnimation = M6e(0, Mf, {
          ...s,
          onUpdate: (c) => {
            this.mixTargetDelta(c), s.onUpdate && s.onUpdate(c);
          },
          onComplete: () => {
            s.onComplete && s.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const s = this.getStack();
      s && s.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Mf), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const s = this.getLead();
      let { targetWithTransforms: c, target: f, layout: d, latestValues: u } = s;
      if (!(!c || !f || !d)) {
        if (this !== s && this.layout && d && Uu(this.options.animationType, this.layout.layoutBox, d.layoutBox)) {
          f = this.target || He();
          const h = yt(this.layout.layoutBox.x);
          f.x.min = s.target.x.min, f.x.max = f.x.min + h;
          const y = yt(this.layout.layoutBox.y);
          f.y.min = s.target.y.min, f.y.max = f.y.min + y;
        }
        wt(c, f), la(c, u), cn(this.projectionDeltaWithTransform, this.layoutCorrected, c, u);
      }
    }
    registerSharedNode(s, c) {
      this.sharedNodes.has(s) || this.sharedNodes.set(s, new D6e()), this.sharedNodes.get(s).add(c);
      const d = c.options.initialPromotionConfig;
      c.promote({
        transition: d ? d.transition : void 0,
        preserveFollowOpacity: d && d.shouldPreserveFollowOpacity ? d.shouldPreserveFollowOpacity(c) : void 0
      });
    }
    isLead() {
      const s = this.getStack();
      return s ? s.lead === this : !0;
    }
    getLead() {
      var s;
      const { layoutId: c } = this.options;
      return c ? ((s = this.getStack()) === null || s === void 0 ? void 0 : s.lead) || this : this;
    }
    getPrevLead() {
      var s;
      const { layoutId: c } = this.options;
      return c ? (s = this.getStack()) === null || s === void 0 ? void 0 : s.prevLead : void 0;
    }
    getStack() {
      const { layoutId: s } = this.options;
      if (s)
        return this.root.sharedNodes.get(s);
    }
    promote({ needsReset: s, transition: c, preserveFollowOpacity: f } = {}) {
      const d = this.getStack();
      d && d.promote(this, f), s && (this.projectionDelta = void 0, this.needsReset = !0), c && this.setOptions({ transition: c });
    }
    relegate() {
      const s = this.getStack();
      return s ? s.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: s } = this.options;
      if (!s)
        return;
      let c = !1;
      const { latestValues: f } = s;
      if ((f.z || f.rotate || f.rotateX || f.rotateY || f.rotateZ || f.skewX || f.skewY) && (c = !0), !c)
        return;
      const d = {};
      f.z && m2("z", s, d, this.animationValues);
      for (let u = 0; u < y2.length; u++)
        m2(`rotate${y2[u]}`, s, d, this.animationValues), m2(`skew${y2[u]}`, s, d, this.animationValues);
      s.render();
      for (const u in d)
        s.setStaticValue(u, d[u]), this.animationValues && (this.animationValues[u] = d[u]);
      s.scheduleRender();
    }
    getProjectionStyles(s) {
      var c, f;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return P6e;
      const d = {
        visibility: ""
      }, u = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, d.opacity = "", d.pointerEvents = wo(s == null ? void 0 : s.pointerEvents) || "", d.transform = u ? u(this.latestValues, "") : "none", d;
      const h = this.getLead();
      if (!this.projectionDelta || !this.layout || !h.target) {
        const k = {};
        return this.options.layoutId && (k.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, k.pointerEvents = wo(s == null ? void 0 : s.pointerEvents) || ""), this.hasProjected && !z1(this.latestValues) && (k.transform = u ? u({}, "") : "none", this.hasProjected = !1), k;
      }
      const y = h.animationValues || h.latestValues;
      this.applyTransformsToTarget(), d.transform = _6e(this.projectionDeltaWithTransform, this.treeScale, y), u && (d.transform = u(y, d.transform));
      const { x: m, y: v } = this.projectionDelta;
      d.transformOrigin = `${m.origin * 100}% ${v.origin * 100}% 0`, h.animationValues ? d.opacity = h === this ? (f = (c = y.opacity) !== null && c !== void 0 ? c : this.latestValues.opacity) !== null && f !== void 0 ? f : 1 : this.preserveOpacity ? this.latestValues.opacity : y.opacityExit : d.opacity = h === this ? y.opacity !== void 0 ? y.opacity : "" : y.opacityExit !== void 0 ? y.opacityExit : 0;
      for (const k in Ho) {
        if (y[k] === void 0)
          continue;
        const { correct: g, applyTo: M } = Ho[k], w = d.transform === "none" ? y[k] : g(y[k], h);
        if (M) {
          const x = M.length;
          for (let C = 0; C < x; C++)
            d[M[C]] = w;
        } else
          d[k] = w;
      }
      return this.options.layoutId && (d.pointerEvents = h === this ? wo(s == null ? void 0 : s.pointerEvents) || "" : "none"), d;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((s) => {
        var c;
        return (c = s.currentAnimation) === null || c === void 0 ? void 0 : c.stop();
      }), this.root.nodes.forEach(wf), this.root.sharedNodes.clear();
    }
  };
}
function R6e(e) {
  e.updateLayout();
}
function H6e(e) {
  var t;
  const a = ((t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && a && e.hasListeners("didUpdate")) {
    const { layoutBox: n, measuredBox: o } = e.layout, { animationType: i } = e.options, s = a.source !== e.layout.source;
    i === "size" ? Ct((h) => {
      const y = s ? a.measuredBox[h] : a.layoutBox[h], m = yt(y);
      y.min = n[h].min, y.max = y.min + m;
    }) : Uu(i, a.layoutBox, n) && Ct((h) => {
      const y = s ? a.measuredBox[h] : a.layoutBox[h], m = yt(n[h]);
      y.max = y.min + m, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[h].max = e.relativeTarget[h].min + m);
    });
    const c = fa();
    cn(c, n, a.layoutBox);
    const f = fa();
    s ? cn(f, e.applyTransform(o, !0), a.measuredBox) : cn(f, n, a.layoutBox);
    const d = !Zu(c);
    let u = !1;
    if (!e.resumeFrom) {
      const h = e.getClosestProjectingParent();
      if (h && !h.resumeFrom) {
        const { snapshot: y, layout: m } = h;
        if (y && m) {
          const v = He();
          fn(v, a.layoutBox, y.layoutBox);
          const k = He();
          fn(k, n, m.layoutBox), Fu(v, k) || (u = !0), h.options.layoutRoot && (e.relativeTarget = k, e.relativeTargetOrigin = v, e.relativeParent = h);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: n,
      snapshot: a,
      delta: f,
      layoutDelta: c,
      hasLayoutChanged: d,
      hasRelativeTargetChanged: u
    });
  } else if (e.isLead()) {
    const { onExitComplete: n } = e.options;
    n && n();
  }
  e.options.transition = void 0;
}
function V6e(e) {
  an && D1.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function O6e(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function q6e(e) {
  e.clearSnapshot();
}
function wf(e) {
  e.clearMeasurements();
}
function B6e(e) {
  e.isLayoutDirty = !1;
}
function Z6e(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function xf(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function F6e(e) {
  e.resolveTargetDelta();
}
function G6e(e) {
  e.calcProjection();
}
function $6e(e) {
  e.resetSkewAndRotation();
}
function U6e(e) {
  e.removeLeadSnapshot();
}
function Cf(e, t, a) {
  e.translate = _e(t.translate, 0, a), e.scale = _e(t.scale, 1, a), e.origin = t.origin, e.originPoint = t.originPoint;
}
function bf(e, t, a, n) {
  e.min = _e(t.min, a.min, n), e.max = _e(t.max, a.max, n);
}
function W6e(e, t, a, n) {
  bf(e.x, t.x, a.x, n), bf(e.y, t.y, a.y, n);
}
function Y6e(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const Q6e = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Lf = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), jf = Lf("applewebkit/") && !Lf("chrome/") ? Math.round : st;
function Nf(e) {
  e.min = jf(e.min), e.max = jf(e.max);
}
function J6e(e) {
  Nf(e.x), Nf(e.y);
}
function Uu(e, t, a) {
  return e === "position" || e === "preserve-aspect" && !e6e(gf(t), gf(a), 0.2);
}
function K6e(e) {
  var t;
  return e !== e.root && ((t = e.scroll) === null || t === void 0 ? void 0 : t.wasRoot);
}
const X6e = $u({
  attachResizeListener: (e, t) => vn(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), k2 = {
  current: void 0
}, Wu = $u({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!k2.current) {
      const e = new X6e({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), k2.current = e;
    }
    return k2.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), e5e = {
  pan: {
    Feature: m6e
  },
  drag: {
    Feature: y6e,
    ProjectionNode: Wu,
    MeasureLayout: Ou
  }
};
function Af(e, t, a) {
  const { props: n } = e;
  e.animationState && n.whileHover && e.animationState.setActive("whileHover", a === "Start");
  const o = "onHover" + a, i = n[o];
  i && Se.postRender(() => i(t, En(t)));
}
class t5e extends g1 {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = epe(t, (a) => (Af(this.node, a, "Start"), (n) => Af(this.node, n, "End"))));
  }
  unmount() {
  }
}
class a5e extends g1 {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Pn(vn(this.node.current, "focus", () => this.onFocus()), vn(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function Sf(e, t, a) {
  const { props: n } = e;
  e.animationState && n.whileTap && e.animationState.setActive("whileTap", a === "Start");
  const o = "onTap" + (a === "End" ? "" : a), i = n[o];
  i && Se.postRender(() => i(t, En(t)));
}
class n5e extends g1 {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = ope(t, (a) => (Sf(this.node, a, "Start"), (n, { success: o }) => Sf(this.node, n, o ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const ki = /* @__PURE__ */ new WeakMap(), g2 = /* @__PURE__ */ new WeakMap(), o5e = (e) => {
  const t = ki.get(e.target);
  t && t(e);
}, r5e = (e) => {
  e.forEach(o5e);
};
function i5e({ root: e, ...t }) {
  const a = e || document;
  g2.has(a) || g2.set(a, {});
  const n = g2.get(a), o = JSON.stringify(t);
  return n[o] || (n[o] = new IntersectionObserver(r5e, { root: e, ...t })), n[o];
}
function s5e(e, t, a) {
  const n = i5e(t);
  return ki.set(e, a), n.observe(e), () => {
    ki.delete(e), n.unobserve(e);
  };
}
const c5e = {
  some: 0,
  all: 1
};
class f5e extends g1 {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: a, margin: n, amount: o = "some", once: i } = t, s = {
      root: a ? a.current : void 0,
      rootMargin: n,
      threshold: typeof o == "number" ? o : c5e[o]
    }, c = (f) => {
      const { isIntersecting: d } = f;
      if (this.isInView === d || (this.isInView = d, i && !d && this.hasEnteredView))
        return;
      d && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", d);
      const { onViewportEnter: u, onViewportLeave: h } = this.node.getProps(), y = d ? u : h;
      y && y(f);
    };
    return s5e(this.node.current, s, c);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: a } = this.node;
    ["amount", "margin", "root"].some(d5e(t, a)) && this.startObserver();
  }
  unmount() {
  }
}
function d5e({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (a) => e[a] !== t[a];
}
const l5e = {
  inView: {
    Feature: f5e
  },
  tap: {
    Feature: n5e
  },
  focus: {
    Feature: a5e
  },
  hover: {
    Feature: t5e
  }
}, u5e = {
  layout: {
    ProjectionNode: Wu,
    MeasureLayout: Ou
  }
}, gi = { current: null }, Yu = { current: !1 };
function h5e() {
  if (Yu.current = !0, !!d0)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => gi.current = e.matches;
      e.addListener(t), t();
    } else
      gi.current = !1;
}
const p5e = [...Mu, Qe, p1], y5e = (e) => p5e.find(vu(e)), If = /* @__PURE__ */ new WeakMap();
function m5e(e, t, a) {
  for (const n in t) {
    const o = t[n], i = a[n];
    if (Je(o))
      e.addValue(n, o), process.env.NODE_ENV === "development" && hr(o.version === "11.18.2", `Attempting to mix Motion versions ${o.version} with 11.18.2 may not work as expected.`);
    else if (Je(i))
      e.addValue(n, kn(o, { owner: e }));
    else if (i !== o)
      if (e.hasValue(n)) {
        const s = e.getValue(n);
        s.liveStyle === !0 ? s.jump(o) : s.hasAnimated || s.set(o);
      } else {
        const s = e.getStaticValue(n);
        e.addValue(n, kn(s !== void 0 ? s : o, { owner: e }));
      }
  }
  for (const n in a)
    t[n] === void 0 && e.removeValue(n);
  return t;
}
const Tf = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class k5e {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, a, n) {
    return {};
  }
  constructor({ parent: t, props: a, presenceContext: n, reducedMotionConfig: o, blockInitialAnimation: i, visualState: s }, c = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = R0, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const m = $t.now();
      this.renderScheduledAt < m && (this.renderScheduledAt = m, Se.render(this.render, !1, !0));
    };
    const { latestValues: f, renderState: d, onUpdate: u } = s;
    this.onUpdate = u, this.latestValues = f, this.baseTarget = { ...f }, this.initialValues = a.initial ? { ...f } : {}, this.renderState = d, this.parent = t, this.props = a, this.presenceContext = n, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = o, this.options = c, this.blockInitialAnimation = !!i, this.isControllingVariants = mr(a), this.isVariantNode = Al(a), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: h, ...y } = this.scrapeMotionValuesFromProps(a, {}, this);
    for (const m in y) {
      const v = y[m];
      f[m] !== void 0 && Je(v) && v.set(f[m], !1);
    }
  }
  mount(t) {
    this.current = t, If.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((a, n) => this.bindToMotionValue(n, a)), Yu.current || h5e(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : gi.current, process.env.NODE_ENV !== "production" && hr(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    If.delete(this.current), this.projection && this.projection.unmount(), h1(this.notifyUpdate), h1(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const a = this.features[t];
      a && (a.unmount(), a.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(t, a) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const n = G1.has(t), o = a.on("change", (c) => {
      this.latestValues[t] = c, this.props.onUpdate && Se.preRender(this.notifyUpdate), n && this.projection && (this.projection.isTransformDirty = !0);
    }), i = a.on("renderRequest", this.scheduleRender);
    let s;
    window.MotionCheckAppearSync && (s = window.MotionCheckAppearSync(this, t, a)), this.valueSubscriptions.set(t, () => {
      o(), i(), s && s(), a.owner && a.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in Ma) {
      const a = Ma[t];
      if (!a)
        continue;
      const { isEnabled: n, Feature: o } = a;
      if (!this.features[t] && o && n(this.props) && (this.features[t] = new o(this)), this.features[t]) {
        const i = this.features[t];
        i.isMounted ? i.update() : (i.mount(), i.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : He();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, a) {
    this.latestValues[t] = a;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, a) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = a;
    for (let n = 0; n < Tf.length; n++) {
      const o = Tf[n];
      this.propEventSubscriptions[o] && (this.propEventSubscriptions[o](), delete this.propEventSubscriptions[o]);
      const i = "on" + o, s = t[i];
      s && (this.propEventSubscriptions[o] = this.on(o, s));
    }
    this.prevMotionValues = m5e(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue(), this.onUpdate && this.onUpdate(this);
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const a = this.getClosestVariantNode();
    if (a)
      return a.variantChildren && a.variantChildren.add(t), () => a.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, a) {
    const n = this.values.get(t);
    a !== n && (n && this.removeValue(t), this.bindToMotionValue(t, a), this.values.set(t, a), this.latestValues[t] = a.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const a = this.valueSubscriptions.get(t);
    a && (a(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, a) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let n = this.values.get(t);
    return n === void 0 && a !== void 0 && (n = kn(a === null ? void 0 : a, { owner: this }), this.addValue(t, n)), n;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, a) {
    var n;
    let o = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : (n = this.getBaseTargetFromProps(this.props, t)) !== null && n !== void 0 ? n : this.readValueFromInstance(this.current, t, this.options);
    return o != null && (typeof o == "string" && (ku(o) || cu(o)) ? o = parseFloat(o) : !y5e(o) && p1.test(a) && (o = pu(t, a)), this.setBaseTarget(t, Je(o) ? o.get() : o)), Je(o) ? o.get() : o;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, a) {
    this.baseTarget[t] = a;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var a;
    const { initial: n } = this.props;
    let o;
    if (typeof n == "string" || typeof n == "object") {
      const s = k0(this.props, n, (a = this.presenceContext) === null || a === void 0 ? void 0 : a.custom);
      s && (o = s[t]);
    }
    if (n && o !== void 0)
      return o;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !Je(i) ? i : this.initialValues[t] !== void 0 && o === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, a) {
    return this.events[t] || (this.events[t] = new T0()), this.events[t].add(a);
  }
  notify(t, ...a) {
    this.events[t] && this.events[t].notify(...a);
  }
}
class Qu extends k5e {
  constructor() {
    super(...arguments), this.KeyframeResolver = wu;
  }
  sortInstanceNodePosition(t, a) {
    return t.compareDocumentPosition(a) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, a) {
    return t.style ? t.style[a] : void 0;
  }
  removeValueFromRenderState(t, { vars: a, style: n }) {
    delete a[t], delete n[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    Je(t) && (this.childSubscription = t.on("change", (a) => {
      this.current && (this.current.textContent = `${a}`);
    }));
  }
}
function g5e(e) {
  return window.getComputedStyle(e);
}
class v5e extends Qu {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = Rl;
  }
  readValueFromInstance(t, a) {
    if (G1.has(a)) {
      const n = E0(a);
      return n && n.default || 0;
    } else {
      const n = g5e(t), o = (_l(a) ? n.getPropertyValue(a) : n[a]) || 0;
      return typeof o == "string" ? o.trim() : o;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: a }) {
    return Hu(t, a);
  }
  build(t, a, n) {
    M0(t, a, n.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, a, n) {
    return b0(t, a, n);
  }
}
class M5e extends Qu {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = He;
  }
  getBaseTargetFromProps(t, a) {
    return t[a];
  }
  readValueFromInstance(t, a) {
    if (G1.has(a)) {
      const n = E0(a);
      return n && n.default || 0;
    }
    return a = Hl.has(a) ? a : p0(a), t.getAttribute(a);
  }
  scrapeMotionValuesFromProps(t, a, n) {
    return ql(t, a, n);
  }
  build(t, a, n) {
    w0(t, a, this.isSVGTag, n.transformTemplate);
  }
  renderInstance(t, a, n, o) {
    Vl(t, a, n, o);
  }
  mount(t) {
    this.isSVGTag = C0(t.tagName), super.mount(t);
  }
}
const w5e = (e, t) => m0(e) ? new M5e(t) : new v5e(t, {
  allowProjection: e !== Nn
}), x5e = /* @__PURE__ */ U3e({
  ...Gye,
  ...l5e,
  ...e5e,
  ...u5e
}, w5e), R1 = /* @__PURE__ */ c3e(x5e), C5e = xl, b5e = Ghe, L5e = $he, j5e = Yhe, N5e = Uhe, A5e = Whe, S5e = Lt("", {
  variants: {
    position: {
      bottom: "-my-1",
      top: "-my-1",
      right: "-mx-1",
      left: "-mx-1"
    },
    beakAlignment: {
      start: "start",
      center: "center",
      end: "end"
    },
    defaultVariants: {
      variant: "bottom",
      beakPosition: "center"
    }
  }
}), v2 = {
  top: {
    initial: { opacity: 0 },
    animate: { opacity: 1, y: -5 },
    exit: { opacity: 0, y: 0, transition: { ease: "easeInOut", duration: 0.1 } }
  },
  bottom: {
    initial: { opacity: 0 },
    animate: { opacity: 1, y: 5 },
    exit: { opacity: 0, y: 0, transition: { ease: "easeInOut", duration: 0.1 } }
  },
  left: {
    initial: { opacity: 0 },
    animate: { opacity: 1, x: -5 },
    exit: { opacity: 0, x: 0, transition: { ease: "easeInOut", duration: 0.1 } }
  },
  right: {
    initial: { opacity: 0 },
    animate: { opacity: 1, x: 5 },
    exit: { opacity: 0, x: 0, transition: { ease: "easeInOut", duration: 0.1 } }
  }
}, I5e = p.forwardRef(
  ({ children: e, className: t, text: a, position: n, beakAlignment: o, sideOffset: i = 5, ...s }, c) => {
    const f = ({
      position: d,
      beakAlignment: u
    }) => {
      const h = d === "bottom" || d === "top", y = d === "right" || d === "left";
      return h && u === "start" ? "[&>span]:!left-[10%]" : y && u === "start" ? "[&>span]:!top-[20%]" : h && u === "end" ? "[&>span]:!left-[80%]" : y && u === "end" ? "[&>span]:!top-[60%]" : y && u === "center" ? "my-0 -mx-1" : "-my-1";
    };
    return /* @__PURE__ */ l.jsx(C5e, { children: /* @__PURE__ */ l.jsxs(b5e, { children: [
      /* @__PURE__ */ l.jsx(
        L5e,
        {
          "data-testid": "tooltip-trigger",
          onClick: (d) => {
            d.currentTarget.blur();
          },
          children: e
        }
      ),
      /* @__PURE__ */ l.jsx(N5e, { children: /* @__PURE__ */ l.jsx(
        R1.div,
        {
          ref: c,
          initial: v2[n || "top"].initial,
          animate: v2[n || "top"].animate,
          exit: v2[n || "top"].exit,
          transition: {
            duration: 0.1,
            ease: "easeInOut"
          },
          className: S("z-[999] absolute", {
            hidden: !a
          }),
          children: /* @__PURE__ */ l.jsxs(
            A5e,
            {
              sideOffset: i,
              className: S(
                "max-w-sm min-h-[2vh] overflow-hidden rounded color-bg-default-inverse dark:bg-[#000] p-2 text-helper-text-sm color-text-inverse",
                S5e({ position: n, className: t }),
                f({ position: n, beakAlignment: o }),
                t
              ),
              ...s,
              side: n || "top",
              align: o || "center",
              children: [
                /* @__PURE__ */ l.jsx(p.Fragment, { children: a }),
                /* @__PURE__ */ l.jsx(j5e, { width: 18, height: 9 })
              ]
            }
          )
        }
      ) })
    ] }) });
  }
);
I5e.displayName = "Tooltip";
const T5e = Lt(
  "inline-flex items-center rounded-sm border px-2 py-1 h-8 text-helper-text-sm color-text-default transition-colors focus:outline-none focus:ring-2 focus:ring-focused focus:ring-offset-2",
  {
    variants: {
      variant: {
        gray: "border-transparent color-bg-tertiary hover:brightness-95",
        brand: "border-transparent color-bg-brand hover:color-bg-brand-hover",
        transparent: "border-transparent bg-transparent hover:color-bg-secondary-hover color-text-secondary",
        success: "border-transparent color-bg-success-light hover:brightness-95 color-text-success font-medium",
        danger: "border-transparent color-bg-danger-light hover:brightness-95 color-text-danger font-medium"
      }
    },
    defaultVariants: {
      variant: "gray"
    }
  }
), Ju = p.forwardRef(
  ({ className: e, variant: t, color: a, ...n }, o) => /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: S(T5e({ variant: t }), e),
      role: "tag",
      ...n,
      ref: o,
      children: [
        n.icon && /* @__PURE__ */ l.jsx(
          Ce,
          {
            name: n.icon,
            size: "sm",
            fill: "transparent",
            className: "mr-2"
          }
        ),
        n.children,
        n.isRemovable && /* @__PURE__ */ l.jsx(
          ar,
          {
            icon: "X",
            variant: "ghost",
            size: "sm",
            className: S(
              "ml-1 p-0 min-w-4 hover:bg-transparent",
              t === "transparent" && "color-text-secondary",
              a && c5(a) && "text-white"
            ),
            onClick: n.onRemove,
            "aria-label": "Remove tag"
          }
        )
      ]
    }
  )
);
Ju.displayName = "Tag";
const Zwe = ({
  tags: e,
  selectedTags: t,
  onAddTag: a,
  isPreviewMode: n
}) => {
  const [o, i] = ve(""), [s, c] = ve(!1), f = Le(null), d = (m) => {
    i(m), c(!0);
  }, u = (m) => {
    const v = e.find(
      (k) => k.name.toLowerCase() === m.toLowerCase()
    );
    v && a(v), i(""), c(!1);
  }, h = () => {
    if (o.trim()) {
      const m = e.find(
        (v) => v.name.toLowerCase() === o.toLowerCase()
      );
      m && a(m), i("");
    }
    c(!1);
  }, y = (m) => t.some(
    (v) => v.name.toLowerCase() === m.toLowerCase()
  );
  return n ? null : /* @__PURE__ */ l.jsx("div", { ref: f, children: /* @__PURE__ */ l.jsxs(Ls, { open: s, onOpenChange: c, children: [
    /* @__PURE__ */ l.jsx(js, { asChild: !0, children: /* @__PURE__ */ l.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ l.jsxs(
      zt,
      {
        onClick: h,
        size: "md",
        variant: "ghost",
        className: "min-w-fit !h-6 px-2",
        children: [
          /* @__PURE__ */ l.jsx(Ce, { name: "Plus", size: "sm", className: "mr-1 text-[#77818A]" }),
          /* @__PURE__ */ l.jsx("span", { className: "text-[#77818A] text-helper-text-sm", children: "Add Tag" })
        ]
      }
    ) }) }),
    /* @__PURE__ */ l.jsx(
      Er,
      {
        className: "w-52",
        align: "center",
        container: f.current,
        children: /* @__PURE__ */ l.jsxs(Ws, { children: [
          /* @__PURE__ */ l.jsx(
            r6,
            {
              placeholder: "Search tags...",
              value: o,
              onValueChange: d
            }
          ),
          /* @__PURE__ */ l.jsxs(i6, { className: "overflow-y-auto max-h-40", children: [
            /* @__PURE__ */ l.jsx(s6, { children: "No tags found" }),
            /* @__PURE__ */ l.jsx(c6, { children: e.filter(
              (m) => m.name.toLowerCase().includes(o.toLowerCase())
            ).map((m, v) => /* @__PURE__ */ l.jsx(
              f6,
              {
                value: m.name,
                onSelect: u,
                className: S(
                  y(m.name) ? "opacity-50 pointer-events-none" : ""
                ),
                children: m.name
              },
              v
            )) })
          ] })
        ] })
      }
    )
  ] }) });
}, z5e = {
  Camera: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9ZM10 13C10 11.8954 10.8954 11 12 11C13.1046 11 14 11.8954 14 13C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.5 3C9.20322 3 8.92177 3.13182 8.73178 3.35982L6.53162 6H4C3.20435 6 2.44129 6.31607 1.87868 6.87868C1.31607 7.44129 1 8.20435 1 9V18C1 18.7956 1.31607 19.5587 1.87868 20.1213C2.44129 20.6839 3.20435 21 4 21H20C20.7957 21 21.5587 20.6839 22.1213 20.1213C22.6839 19.5587 23 18.7957 23 18V9C23 8.20435 22.6839 7.44129 22.1213 6.87868C21.5587 6.31607 20.7957 6 20 6H17.4684L15.2682 3.35982C15.0782 3.13182 14.7968 3 14.5 3H9.5ZM7.76822 7.64018L9.96837 5H14.0316L16.2318 7.64018C16.4218 7.86818 16.7032 8 17 8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V18C21 18.2652 20.8946 18.5196 20.7071 18.7071C20.5196 18.8946 20.2652 19 20 19H4C3.73478 19 3.48043 18.8946 3.29289 18.7071C3.10536 18.5196 3 18.2652 3 18V9C3 8.73478 3.10536 8.48043 3.29289 8.29289C3.48043 8.10536 3.73478 8 4 8H7C7.29678 8 7.57823 7.86818 7.76822 7.64018Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Check: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.7071 5.29289C21.0976 5.68342 21.0976 6.31658 20.7071 6.70711L9.70711 17.7071C9.31658 18.0976 8.68342 18.0976 8.29289 17.7071L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929C3.68342 10.9024 4.31658 10.9024 4.70711 11.2929L9 15.5858L19.2929 5.29289C19.6834 4.90237 20.3166 4.90237 20.7071 5.29289Z",
          fill: e,
          stroke: "none"
        }
      )
    }
  ),
  CheckboxEmpty: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H5ZM2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5Z",
          fill: e,
          stroke: "none"
        }
      )
    }
  ),
  Comment: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 4C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V18.5858L6.29289 16.2929C6.48043 16.1054 6.73478 16 7 16H19C19.2652 16 19.5196 15.8946 19.7071 15.7071C19.8946 15.5196 20 15.2652 20 15V5C20 4.73478 19.8946 4.48043 19.7071 4.29289C19.5196 4.10536 19.2652 4 19 4H5ZM2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H19C19.7957 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V15C22 15.7957 21.6839 16.5587 21.1213 17.1213C20.5587 17.6839 19.7957 18 19 18H7.41421L3.70711 21.7071C3.42111 21.9931 2.99099 22.0787 2.61732 21.9239C2.24364 21.7691 2 21.4045 2 21V5C2 4.20435 2.31607 3.44129 2.87868 2.87868ZM6 8C6 7.44772 6.44772 7 7 7H13C13.5523 7 14 7.44772 14 8C14 8.55228 13.5523 9 13 9H7C6.44772 9 6 8.55228 6 8ZM7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H7Z",
          fill: e,
          stroke: "none"
        }
      )
    }
  ),
  ExternalLink: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14 3C14 2.44772 14.4477 2 15 2H21C21.5523 2 22 2.44772 22 3V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V4H15C14.4477 4 14 3.55228 14 3Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071C8.90237 14.3166 8.90237 13.6834 9.29289 13.2929L20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5 7C4.73478 7 4.48043 7.10536 4.29289 7.29289C4.10536 7.48043 4 7.73478 4 8V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H16C16.2652 20 16.5196 19.8946 16.7071 19.7071C16.8946 19.5196 17 19.2652 17 19V13C17 12.4477 17.4477 12 18 12C18.5523 12 19 12.4477 19 13V19C19 19.7957 18.6839 20.5587 18.1213 21.1213C17.5587 21.6839 16.7957 22 16 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V8C2 7.20435 2.31607 6.44129 2.87868 5.87868C3.44129 5.31607 4.20435 5 5 5H11C11.5523 5 12 5.44772 12 6C12 6.55228 11.5523 7 11 7H5Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  FilePlus: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 1C5.20435 1 4.44129 1.31607 3.87868 1.87868C3.31607 2.44129 3 3.20435 3 4V8C3 8.55228 3.44772 9 4 9C4.55228 9 5 8.55228 5 8V4C5 3.73478 5.10536 3.48043 5.29289 3.29289C5.48043 3.10536 5.73478 3 6 3H13V6C13 6.79565 13.3161 7.55871 13.8787 8.12132C14.4413 8.68393 15.2044 9 16 9H19V20C19 20.2652 18.8946 20.5196 18.7071 20.7071C18.5196 20.8946 18.2652 21 18 21H4C3.44772 21 3 21.4477 3 22C3 22.5523 3.44772 23 4 23H18C18.7957 23 19.5587 22.6839 20.1213 22.1213C20.6839 21.5587 21 20.7957 21 20V7C21 6.73478 20.8946 6.48043 20.7071 6.29289L15.7071 1.29289C15.5196 1.10536 15.2652 1 15 1H6ZM15 3.41421V6C15 6.26522 15.1054 6.51957 15.2929 6.70711C15.4804 6.89464 15.7348 7 16 7H18.5858L15 3.41421Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M2 15C2 14.4477 2.44772 14 3 14H5V12C5 11.4477 5.44772 11 6 11C6.55228 11 7 11.4477 7 12V14H9C9.55228 14 10 14.4477 10 15C10 15.5523 9.55228 16 9 16H7V18C7 18.5523 6.55228 19 6 19C5.44772 19 5 18.5523 5 18V16H3C2.44772 16 2 15.5523 2 15Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  FileText: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M8 8C7.44772 8 7 8.44772 7 9C7 9.55229 7.44772 10 8 10H10C10.5523 10 11 9.55229 11 9C11 8.44772 10.5523 8 10 8H8Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M7 13C7 12.4477 7.44772 12 8 12H16C16.5523 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14H8C7.44772 14 7 13.5523 7 13Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M8 16C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18H16C16.5523 18 17 17.5523 17 17C17 16.4477 16.5523 16 16 16H8Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.87868 1.87868C4.44129 1.31607 5.20435 1 6 1H15C15.2652 1 15.5196 1.10536 15.7071 1.29289L20.7071 6.29289C20.8946 6.48043 21 6.73478 21 7V20C21 20.7957 20.6839 21.5587 20.1213 22.1213C19.5587 22.6839 18.7957 23 18 23H6C5.20435 23 4.44129 22.6839 3.87868 22.1213C3.31607 21.5587 3 20.7957 3 20V4C3 3.20435 3.31607 2.44129 3.87868 1.87868ZM6 3H13V6C13 6.79565 13.3161 7.55871 13.8787 8.12132C14.4413 8.68393 15.2044 9 16 9H19V20C19 20.2652 18.8946 20.5196 18.7071 20.7071C18.5196 20.8946 18.2652 21 18 21H6C5.73478 21 5.48043 20.8946 5.29289 20.7071C5.10536 20.5196 5 20.2652 5 20V4C5 3.73478 5.10536 3.48043 5.29289 3.29289C5.48043 3.10536 5.73478 3 6 3ZM16 7H18.5858L15 3.41421V6C15 6.26522 15.1054 6.51957 15.2929 6.70711C15.4804 6.89464 15.7348 7 16 7Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Download: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M13 3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V12.5858L7.70711 9.29289C7.31658 8.90237 6.68342 8.90237 6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071L11.2922 15.7064C11.2946 15.7088 11.297 15.7112 11.2995 15.7136C11.3938 15.8063 11.502 15.8764 11.6172 15.9241C11.7343 15.9727 11.8625 15.9996 11.997 16L12 16L12.003 16C12.2746 15.9992 12.5208 15.8901 12.7005 15.7136C12.703 15.7112 12.7054 15.7088 12.7078 15.7064L17.7071 10.7071C18.0976 10.3166 18.0976 9.68342 17.7071 9.29289C17.3166 8.90237 16.6834 8.90237 16.2929 9.29289L13 12.5858V3Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M3 14C3.55228 14 4 14.4477 4 15V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V15C2 14.4477 2.44772 14 3 14Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Grid: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 2C2.89543 2 2 2.89543 2 4V9C2 10.1046 2.89543 11 4 11H9C10.1046 11 11 10.1046 11 9V4C11 2.89543 10.1046 2 9 2H4ZM4 4H9V9H4V4Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15 2C13.8954 2 13 2.89543 13 4V9C13 10.1046 13.8954 11 15 11H20C21.1046 11 22 10.1046 22 9V4C22 2.89543 21.1046 2 20 2H15ZM15 4H20V9H15V4Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13 15C13 13.8954 13.8954 13 15 13H20C21.1046 13 22 13.8954 22 15V20C22 21.1046 21.1046 22 20 22H15C13.8954 22 13 21.1046 13 20V15ZM20 15H15V20H20V15Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 13C2.89543 13 2 13.8954 2 15V20C2 21.1046 2.89543 22 4 22H9C10.1046 22 11 21.1046 11 20V15C11 13.8954 10.1046 13 9 13H4ZM4 15H9V20H4V15Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Heart: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.90381 3.90381C4.12279 2.68482 5.77609 2 7.5 2C8.48018 2 9.37318 2.14018 10.2468 2.52068C10.8597 2.78762 11.4321 3.15937 12 3.63935C12.5679 3.15937 13.1403 2.78762 13.7532 2.52068C14.6268 2.14018 15.5198 2 16.5 2C18.2239 2 19.8772 2.68482 21.0962 3.90381C22.3152 5.12279 23 6.77609 23 8.5C23 11.2418 21.1906 13.2531 19.7035 14.7107L12.7071 21.7071C12.3166 22.0976 11.6834 22.0976 11.2929 21.7071L4.29885 14.7131C2.79442 13.258 1 11.2494 1 8.5C1 6.77609 1.68482 5.12279 2.90381 3.90381ZM7.5 4C6.30653 4 5.16193 4.47411 4.31802 5.31802C3.47411 6.16193 3 7.30653 3 8.5C3 10.3469 4.2007 11.8365 5.69502 13.281L5.70711 13.2929L12 19.5858L18.3001 13.2857C19.7923 11.8235 21 10.3359 21 8.5C21 7.30653 20.5259 6.16193 19.682 5.31802C18.8381 4.47411 17.6935 4 16.5 4C15.7202 4 15.1132 4.10982 14.5518 4.35432C13.984 4.60163 13.4001 5.0141 12.7071 5.70711C12.3166 6.09763 11.6834 6.09763 11.2929 5.70711C10.5999 5.0141 10.016 4.60163 9.44819 4.35432C8.88682 4.10982 8.27982 4 7.5 4Z",
          fill: e,
          stroke: "none"
        }
      )
    }
  ),
  HeartBeat: ({ width: e, height: t, ...a }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: e,
      height: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...a,
      children: [
        /* @__PURE__ */ l.jsx("rect", { y: "1", width: "24", height: "22", fill: "url(#pattern0_246_1680)" }),
        /* @__PURE__ */ l.jsxs("defs", { children: [
          /* @__PURE__ */ l.jsx(
            "pattern",
            {
              id: "pattern0_246_1680",
              patternContentUnits: "objectBoundingBox",
              width: "1",
              height: "1",
              children: /* @__PURE__ */ l.jsx(
                "use",
                {
                  xlinkHref: "#image0_246_1680",
                  transform: "matrix(0.0139394 0 0 0.0152066 -0.545455 -0.640496)"
                }
              )
            }
          ),
          /* @__PURE__ */ l.jsx(
            "image",
            {
              id: "image0_246_1680",
              width: "150",
              height: "150",
              xlinkHref: "data:image/png;base64,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"
            }
          )
        ] })
      ]
    }
  ),
  ImagePlus: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M20 2C20 1.44772 19.5523 1 19 1C18.4477 1 18 1.44772 18 2V4H16C15.4477 4 15 4.44772 15 5C15 5.55228 15.4477 6 16 6H18V8C18 8.55228 18.4477 9 19 9C19.5523 9 20 8.55228 20 8V6H22C22.5523 6 23 5.55228 23 5C23 4.44772 22.5523 4 22 4H20V2Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5 4C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H5.58579L14.379 11.2068C14.9416 10.6444 15.7045 10.3284 16.5 10.3284C17.2955 10.3284 18.0584 10.6444 18.621 11.2068L20 12.5858V12C20 11.4477 20.4477 11 21 11C21.5523 11 22 11.4477 22 12V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H12C12.5523 2 13 2.44772 13 3C13 3.55228 12.5523 4 12 4H5ZM8.41422 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V15.4142L17.207 12.6212C17.0195 12.4338 16.7651 12.3284 16.5 12.3284C16.2349 12.3284 15.9806 12.4337 15.7931 12.6211L8.41422 20Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 9C6 7.34315 7.34315 6 9 6C10.6569 6 12 7.34315 12 9C12 10.6569 10.6569 12 9 12C7.34315 12 6 10.6569 6 9ZM9 8C8.44772 8 8 8.44772 8 9C8 9.55228 8.44772 10 9 10C9.55228 10 10 9.55228 10 9C10 8.44772 9.55228 8 9 8Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  InfoCircle: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9H12.01C12.5623 9 13.01 8.55228 13.01 8C13.01 7.44772 12.5623 7 12.01 7H12Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Dashboard: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 2C2.89543 2 2 2.89543 2 4V11C2 12.1046 2.89543 13 4 13H9C10.1046 13 11 12.1046 11 11V4C11 2.89543 10.1046 2 9 2H4ZM4 4H9V11H4V4Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15 2C13.8954 2 13 2.89543 13 4V7C13 8.10457 13.8954 9 15 9H20C21.1046 9 22 8.10457 22 7V4C22 2.89543 21.1046 2 20 2H15ZM15 4H20V7H15V4Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13 13C13 11.8954 13.8954 11 15 11H20C21.1046 11 22 11.8954 22 13V20C22 21.1046 21.1046 22 20 22H15C13.8954 22 13 21.1046 13 20V13ZM20 13H15V20H20V13Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 15C2.89543 15 2 15.8954 2 17V20C2 21.1046 2.89543 22 4 22H9C10.1046 22 11 21.1046 11 20V17C11 15.8954 10.1046 15 9 15H4ZM4 17H9V20H4V17Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Link: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M16.9957 1.06666C15.4225 1.05299 13.9069 1.65776 12.7753 2.75071L12.765 2.76083L11.045 4.47083C10.6533 4.86021 10.6514 5.49338 11.0408 5.88504C11.4302 6.2767 12.0634 6.27855 12.455 5.88916L14.1696 4.18453C14.9235 3.4589 15.9318 3.05749 16.9783 3.06659C18.0271 3.0757 19.0304 3.49638 19.772 4.23801C20.5136 4.97964 20.9343 5.98289 20.9434 7.03168C20.9525 8.07773 20.5514 9.0856 19.8264 9.83937L16.8329 12.8329C16.4274 13.2385 15.9392 13.5524 15.4018 13.7528C14.8644 13.9533 14.2902 14.0359 13.7181 13.9949C13.146 13.9539 12.5894 13.7904 12.086 13.5154C11.5826 13.2404 11.1443 12.8603 10.8008 12.401C10.47 11.9588 9.84327 11.8684 9.40102 12.1992C8.95877 12.53 8.86843 13.1567 9.19923 13.599C9.71458 14.2879 10.3721 14.858 11.1271 15.2705C11.8821 15.683 12.717 15.9283 13.5752 15.9898C14.4334 16.0512 15.2947 15.9274 16.1008 15.6267C16.907 15.326 17.639 14.8555 18.2472 14.247L21.2471 11.2471L21.2593 11.2347C22.3522 10.1031 22.957 8.58748 22.9433 7.0143C22.9297 5.44112 22.2986 3.93624 21.1862 2.8238C20.0737 1.71135 18.5689 1.08033 16.9957 1.06666Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M10.4248 8.01023C9.56663 7.94877 8.70528 8.07259 7.89917 8.3733C7.09311 8.67398 6.36102 9.14461 5.75278 9.75303L2.75291 12.7529L2.74073 12.7653C1.64778 13.8969 1.04301 15.4125 1.05668 16.9857C1.07035 18.5589 1.70137 20.0638 2.81382 21.1762C3.92627 22.2887 5.43114 22.9197 7.00432 22.9333C8.5775 22.947 10.0931 22.3422 11.2247 21.2493L11.2371 21.2371L12.9471 19.5271C13.3376 19.1366 13.3376 18.5034 12.9471 18.1129C12.5566 17.7224 11.9234 17.7224 11.5329 18.1129L9.82938 19.8164C9.07561 20.5415 8.06775 20.9425 7.0217 20.9334C5.97291 20.9243 4.96966 20.5036 4.22803 19.762C3.4864 19.0204 3.06572 18.0171 3.05661 16.9683C3.04752 15.9223 3.44857 14.9144 4.17361 14.1606L7.16725 11.167C7.57276 10.7613 8.06077 10.4476 8.59818 10.2472C9.13558 10.0467 9.70982 9.96415 10.2819 10.0051C10.854 10.0461 11.4107 10.2096 11.914 10.4846C12.4174 10.7596 12.8557 11.1397 13.1993 11.599C13.5301 12.0412 14.1567 12.1316 14.599 11.8008C15.0412 11.47 15.1316 10.8433 14.8008 10.401C14.2854 9.71208 13.628 9.14201 12.8729 8.72951C12.1179 8.317 11.283 8.07169 10.4248 8.01023Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  List: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M3 5C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7H3.01C3.56228 7 4.01 6.55228 4.01 6C4.01 5.44772 3.56228 5 3.01 5H3Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5H8Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H8Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M7 18C7 17.4477 7.44772 17 8 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H8C7.44772 19 7 18.5523 7 18Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M2 12C2 11.4477 2.44772 11 3 11H3.01C3.56228 11 4.01 11.4477 4.01 12C4.01 12.5523 3.56228 13 3.01 13H3C2.44772 13 2 12.5523 2 12Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M3 17C2.44772 17 2 17.4477 2 18C2 18.5523 2.44772 19 3 19H3.01C3.56228 19 4.01 18.5523 4.01 18C4.01 17.4477 3.56228 17 3.01 17H3Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Notification: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 3C10.6739 3 9.40215 3.52678 8.46447 4.46447C7.52679 5.40215 7 6.67392 7 8C7 11.6473 6.21707 14.0654 5.3779 15.6039C5.3018 15.7434 5.22541 15.8753 5.14933 16H18.8507C18.7746 15.8753 18.6982 15.7434 18.6221 15.6039C17.7829 14.0654 17 11.6473 17 8C17 6.67392 16.4732 5.40215 15.5355 4.46447C14.5979 3.52678 13.3261 3 12 3ZM21.5663 16.1758C21.5656 16.1753 21.5647 16.1746 21.5635 16.1737C21.5558 16.168 21.5379 16.1544 21.5113 16.1322C21.4581 16.0878 21.3697 16.0091 21.2572 15.8904C21.0328 15.6535 20.7097 15.2544 20.3779 14.6461C19.7171 13.4346 19 11.3527 19 8C19 6.14349 18.2625 4.36301 16.9497 3.05025C15.637 1.7375 13.8565 1 12 1C10.1435 1 8.36301 1.7375 7.05025 3.05025C5.7375 4.36301 5 6.14348 5 8C5 11.3527 4.28293 13.4346 3.62211 14.6461C3.29031 15.2544 2.96723 15.6535 2.7428 15.8904C2.63032 16.0091 2.54194 16.0878 2.48872 16.1322C2.4621 16.1544 2.44425 16.168 2.43655 16.1737C2.43535 16.1746 2.43439 16.1753 2.43369 16.1758C2.07521 16.4221 1.91657 16.8725 2.04291 17.2898C2.17061 17.7115 2.55933 18 3 18H21C21.4407 18 21.8294 17.7115 21.9571 17.2898C22.0834 16.8725 21.9248 16.4221 21.5663 16.1758Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.81822 20.1237C10.3022 19.8576 10.9102 20.0343 11.1763 20.5182C11.2574 20.6657 11.3766 20.7887 11.5215 20.8744C11.6664 20.9601 11.8317 21.0053 12 21.0053C12.1683 21.0053 12.3336 20.9601 12.4785 20.8744C12.6234 20.7887 12.7426 20.6657 12.8237 20.5182C13.0898 20.0343 13.6978 19.8576 14.1818 20.1237C14.6657 20.3898 14.8424 20.9978 14.5763 21.4818C14.3226 21.9432 13.9497 22.3279 13.4965 22.5959C13.0434 22.8639 12.5265 23.0053 12 23.0053C11.4735 23.0053 10.9567 22.8639 10.5035 22.5959C10.0503 22.3279 9.67738 21.9432 9.42371 21.4818C9.15763 20.9978 9.33425 20.3898 9.81822 20.1237Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  PanelLeft: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 22C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5ZM5 4C4.44772 4 4 4.44772 4 5V8H20V5C20 4.44772 19.5523 4 19 4H5ZM8 10H4V19C4 19.5523 4.44772 20 5 20H8V10ZM10 20V10H20V19C20 19.5523 19.5523 20 19 20H10Z",
          fill: e,
          stroke: "none"
        }
      )
    }
  ),
  Paperclip: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.2885 3.88273C16.7243 3.31954 15.9595 3.00354 15.1623 3.00424C14.3652 3.00495 13.6009 3.3223 13.0377 3.88649L4.46709 12.4571C3.52878 13.3954 3.00165 14.668 3.00165 15.995C3.00165 17.322 3.52878 18.5946 4.46709 19.5329C5.4054 20.4712 6.67802 20.9983 8.00498 20.9983C9.33195 20.9983 10.6046 20.4712 11.5429 19.5329L20.7329 10.3429C21.1234 9.95237 21.7566 9.95237 22.1471 10.3429C22.5376 10.7334 22.5376 11.3666 22.1471 11.7571L12.9571 20.9471C11.6437 22.2605 9.86238 22.9983 8.00498 22.9983C6.14758 22.9983 4.36626 22.2605 3.05288 20.9471C1.7395 19.6337 1.00165 17.8524 1.00165 15.995C1.00165 14.1376 1.7395 12.3563 3.05288 11.0429L11.6223 2.47352C12.5601 1.53432 13.8333 1.00542 15.1606 1.00424C16.4882 1.00307 17.7619 1.52934 18.7015 2.46727C19.6411 3.40521 20.1696 4.67798 20.1707 6.00559C20.1719 7.33319 19.6456 8.60689 18.7077 9.54649L10.1171 18.1171C9.55427 18.6799 8.79093 18.9961 7.99498 18.9961C7.19904 18.9961 6.43569 18.6799 5.87288 18.1171C5.31006 17.5543 4.99387 16.7909 4.99387 15.995C4.99387 15.1991 5.31006 14.4357 5.87288 13.8729L14.3633 5.39248C14.754 5.00219 15.3872 5.00256 15.7775 5.39331C16.1678 5.78407 16.1674 6.41723 15.7767 6.80753L7.28709 15.2871C7.09961 15.4748 6.99387 15.7297 6.99387 15.995C6.99387 16.2605 7.09935 16.5152 7.28709 16.7029C7.47484 16.8906 7.72947 16.9961 7.99498 16.9961C8.2605 16.9961 8.51513 16.8906 8.70288 16.7029L17.2923 8.13352L17.2931 8.13266C17.8558 7.56856 18.1714 6.80412 18.1707 6.00735C18.17 5.21017 17.8527 4.44593 17.2885 3.88273Z",
          fill: e,
          stroke: "none"
        }
      )
    }
  ),
  PenLine: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11 20C11 19.4477 11.4477 19 12 19H21C21.5523 19 22 19.4477 22 20C22 20.5523 21.5523 21 21 21H12C11.4477 21 11 20.5523 11 20Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18 3.87869C17.7026 3.87869 17.4174 3.99683 17.2071 4.20712L4.90299 16.5113L4.37439 18.6256L6.48877 18.097L18.7929 5.79291C18.897 5.68878 18.9796 5.56517 19.036 5.42912C19.0923 5.29308 19.1213 5.14727 19.1213 5.00001C19.1213 4.85276 19.0923 4.70695 19.036 4.5709C18.9796 4.43486 18.897 4.31124 18.7929 4.20712C18.6888 4.103 18.5652 4.0204 18.4291 3.96405C18.2931 3.9077 18.1473 3.87869 18 3.87869ZM15.7929 2.79291C16.3783 2.20754 17.1722 1.87869 18 1.87869C18.4099 1.87869 18.8158 1.95943 19.1945 2.11629C19.5732 2.27315 19.9173 2.50306 20.2071 2.79291C20.497 3.08275 20.7269 3.42684 20.8837 3.80554C21.0406 4.18423 21.1213 4.59011 21.1213 5.00001C21.1213 5.40991 21.0406 5.81579 20.8837 6.19449C20.7269 6.57319 20.497 6.91728 20.2071 7.20712L7.70713 19.7071C7.57897 19.8353 7.41839 19.9262 7.24256 19.9702L3.24256 20.9702C2.90178 21.0553 2.54129 20.9555 2.29291 20.7071C2.04453 20.4587 1.94468 20.0983 2.02988 19.7575L3.02988 15.7575C3.07384 15.5816 3.16476 15.4211 3.29291 15.2929L15.7929 2.79291Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Pencil: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.2893 4.29655L14.2929 4.29289L14.2965 4.28926L16.2657 2.32007C16.605 1.92848 17.0203 1.60944 17.4865 1.38197C17.9661 1.14796 18.4891 1.01587 19.0224 0.993861C19.5557 0.971855 20.088 1.0604 20.5852 1.25403C21.0825 1.44766 21.5343 1.74225 21.9114 2.11941C22.2886 2.49659 22.5829 2.94809 22.7752 3.44534C22.9676 3.94261 23.0535 4.47445 23.0274 5.00687C23.0014 5.53929 22.8639 6.06023 22.624 6.53643C22.392 6.99707 22.0692 7.40589 21.6754 7.73886L8.20713 21.2071C8.08407 21.3302 7.93104 21.419 7.76314 21.4648L2.26314 22.9648C1.91693 23.0592 1.54667 22.9609 1.29292 22.7071C1.03917 22.4534 0.940838 22.0831 1.03526 21.7369L2.53526 16.2369C2.58105 16.069 2.66986 15.9159 2.79292 15.7929L14.2893 4.29655ZM19.1049 2.99216C19.3627 2.98152 19.6197 3.02435 19.8596 3.11774C20.0994 3.21112 20.3165 3.35289 20.4972 3.53362C20.6779 3.71434 20.8183 3.93003 20.9099 4.16673C21.0014 4.40342 21.0422 4.65621 21.0298 4.90908C21.0174 5.16195 20.9522 5.40974 20.8378 5.63669C20.7235 5.86367 20.5625 6.06504 20.3648 6.22768C20.3398 6.24824 20.3158 6.27 20.2929 6.29289L19 7.58579L16.4142 5.00001L17.7071 3.7071C17.7267 3.68751 17.7455 3.66711 17.7634 3.64596C17.9282 3.45116 18.1325 3.29212 18.3636 3.17939C18.5946 3.06665 18.8471 3.0028 19.1049 2.99216ZM17.5858 9.00001L6.9807 19.6051L3.42524 20.5748L4.39491 17.0193L15 6.41422L17.5858 9.00001Z",
          fill: e,
          stroke: "none"
        }
      )
    }
  ),
  Placeholder: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22.7906 14.1468L20.8286 13.7586C20.9409 13.1915 21 12.6036 21 12C21 11.3964 20.9409 10.8085 20.8286 10.2414L22.7906 9.85322C22.928 10.5475 23 11.2654 23 12C23 12.7346 22.928 13.4525 22.7906 14.1468ZM21.1472 5.88823L19.4853 7.00087C18.8276 6.01854 17.9815 5.17237 16.9991 4.51472L18.1118 2.85278C19.3113 3.65587 20.3441 4.68866 21.1472 5.88823ZM14.1468 1.20937C13.4525 1.07202 12.7346 1 12 1C11.2654 1 10.5475 1.07202 9.85322 1.20937L10.2414 3.17135C10.8085 3.05914 11.3964 3 12 3C12.6036 3 13.1915 3.05914 13.7586 3.17135L14.1468 1.20937ZM5.88823 2.85278L7.00087 4.51472C6.01854 5.17237 5.17237 6.01854 4.51472 7.00087L2.85278 5.88823C3.65587 4.68866 4.68866 3.65587 5.88823 2.85278ZM1.20937 9.85322C1.07202 10.5475 1 11.2654 1 12C1 12.7346 1.07202 13.4525 1.20937 14.1468L3.17135 13.7586C3.05914 13.1915 3 12.6036 3 12C3 11.3964 3.05914 10.8085 3.17135 10.2414L1.20937 9.85322ZM2.85278 18.1118L4.51472 16.9991C5.17237 17.9815 6.01854 18.8276 7.00087 19.4853L5.88823 21.1472C4.68866 20.3441 3.65587 19.3113 2.85278 18.1118ZM9.85322 22.7906L10.2414 20.8286C10.8085 20.9409 11.3964 21 12 21C12.6036 21 13.1915 20.9409 13.7586 20.8286L14.1468 22.7906C13.4525 22.928 12.7346 23 12 23C11.2654 23 10.5475 22.928 9.85322 22.7906ZM18.1118 21.1472L16.9991 19.4853C17.9815 18.8276 18.8276 17.9815 19.4853 16.9991L21.1472 18.1118C20.3441 19.3113 19.3113 20.3441 18.1118 21.1472Z",
          fill: e,
          stroke: "none"
        }
      )
    }
  ),
  Play: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          d: "M6.54076 2.15882C6.23305 1.96101 5.84189 1.947 5.52081 2.12229C5.19974 2.29758 5 2.63419 5 3V21C5 21.3658 5.19974 21.7024 5.52081 21.8777C5.84189 22.053 6.23305 22.039 6.54076 21.8412L20.5408 12.8412C20.827 12.6572 21 12.3403 21 12C21 11.6597 20.827 11.3428 20.5408 11.1588L6.54076 2.15882Z",
          fill: e,
          stroke: "none"
        }
      )
    }
  ),
  Plus: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          d: "M13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H11V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H13V5Z",
          fill: e,
          stroke: "none"
        }
      )
    }
  ),
  Question: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M12.2581 8.02434C11.7926 7.94449 11.3138 8.03197 10.9066 8.27129C10.4994 8.5106 10.1901 8.88631 10.0333 9.33187C9.85006 9.85286 9.27914 10.1266 8.75815 9.94336C8.23716 9.76008 7.96339 9.18917 8.14666 8.66818C8.46013 7.77707 9.07886 7.02565 9.89327 6.54702C10.7077 6.06839 11.6652 5.89343 12.5962 6.05313C13.5273 6.21283 14.3717 6.69688 14.9801 7.41955C15.5883 8.14207 15.9213 9.0565 15.92 10.0009C15.9195 11.5313 14.7849 12.5419 13.9747 13.0821C13.5391 13.3725 13.1105 13.586 12.7949 13.7263C12.6356 13.7971 12.5015 13.8508 12.4049 13.8876C12.3565 13.9061 12.3173 13.9204 12.2887 13.9305L12.254 13.9427L12.2429 13.9465L12.239 13.9478L12.2375 13.9483C12.2375 13.9483 12.2362 13.9487 11.92 13L12.2362 13.9487C11.7123 14.1234 11.146 13.8402 10.9713 13.3162C10.7968 12.7927 11.0794 12.2267 11.6027 12.0517L11.6187 12.0461C11.6341 12.0406 11.6593 12.0315 11.6929 12.0187C11.7603 11.993 11.8606 11.9529 11.9826 11.8987C12.2294 11.789 12.5509 11.6276 12.8653 11.418C13.5549 10.9582 13.92 10.4692 13.92 10L13.92 9.99853C13.9207 9.52621 13.7542 9.06889 13.45 8.70755C13.1459 8.34622 12.7236 8.10419 12.2581 8.02434Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18H12.01C12.5623 18 13.01 17.5523 13.01 17C13.01 16.4477 12.5623 16 12.01 16H12Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Search: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.9929 15.9929C16.3834 15.6024 17.0166 15.6024 17.4071 15.9929L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L15.9929 17.4071C15.6024 17.0166 15.6024 16.3834 15.9929 15.9929Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Section: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M4 2C2.89543 2 2 2.89543 2 4V9C2 10.1046 2.89543 11 4 11H20C21.1046 11 22 10.1046 22 9V4C22 2.89543 21.1046 2 20 2H4Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2 15C2 13.8954 2.89543 13 4 13H9C10.1046 13 11 13.8954 11 15V20C11 21.1046 10.1046 22 9 22H4C2.89543 22 2 21.1046 2 20V15ZM9 15H4V20H9V15Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15 13C13.8954 13 13 13.8954 13 15V20C13 21.1046 13.8954 22 15 22H20C21.1046 22 22 21.1046 22 20V15C22 13.8954 21.1046 13 20 13H15ZM15 15H20V20H15V15Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Settings: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 3C4.79086 3 3 4.79086 3 7C3 9.20914 4.79086 11 7 11C8.86658 11 10.4345 9.72147 10.8759 7.99238C10.9166 7.99741 10.958 8 11 8H20C20.5523 8 21 7.55228 21 7C21 6.44772 20.5523 6 20 6H11C10.958 6 10.9166 6.00259 10.8759 6.00762C10.4345 4.27853 8.86658 3 7 3ZM5 7C5 5.89543 5.89543 5 7 5C8.10457 5 9 5.89543 9 7C9 8.10457 8.10457 9 7 9C5.89543 9 5 8.10457 5 7Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5 16C4.44772 16 4 16.4477 4 17C4 17.5523 4.44772 18 5 18H13.126C13.5701 19.7252 15.1362 21 17 21C19.2091 21 21 19.2091 21 17C21 14.7909 19.2091 13 17 13C15.1362 13 13.5701 14.2748 13.126 16H5ZM17 19C15.8954 19 15 18.1046 15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17C19 18.1046 18.1046 19 17 19Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Share2: I.forwardRef(
    ({ fill: e, width: t, height: a, ...n }, o) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        ref: o,
        width: t,
        height: a,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        ...n,
        children: [
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M4 11C4.55228 11 5 11.4477 5 12V20C5 20.2652 5.10536 20.5196 5.29289 20.7071C5.48043 20.8946 5.73478 21 6 21H18C18.2652 21 18.5196 20.8946 18.7071 20.7071C18.8946 20.5196 19 20.2652 19 20V12C19 11.4477 19.4477 11 20 11C20.5523 11 21 11.4477 21 12V20C21 20.7957 20.6839 21.5587 20.1213 22.1213C19.5587 22.6839 18.7957 23 18 23H6C5.20435 23 4.44129 22.6839 3.87868 22.1213C3.31607 21.5587 3 20.7957 3 20V12C3 11.4477 3.44772 11 4 11Z",
              fill: e,
              stroke: "none"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.2929 1.29289C11.6834 0.902369 12.3166 0.902369 12.7071 1.29289L16.7071 5.29289C17.0976 5.68342 17.0976 6.31658 16.7071 6.70711C16.3166 7.09763 15.6834 7.09763 15.2929 6.70711L12 3.41421L8.70711 6.70711C8.31658 7.09763 7.68342 7.09763 7.29289 6.70711C6.90237 6.31658 6.90237 5.68342 7.29289 5.29289L11.2929 1.29289Z",
              fill: e,
              stroke: "none"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12 1C12.5523 1 13 1.44772 13 2V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V2C11 1.44772 11.4477 1 12 1Z",
              fill: e,
              stroke: "none"
            }
          )
        ]
      }
    )
  ),
  Share: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.1581 7.81486C15.883 8.54668 16.8885 9 18 9C20.2091 9 22 7.20914 22 5C22 2.79086 20.2091 1 18 1C15.7909 1 14 2.79086 14 5C14 5.37702 14.0522 5.74186 14.1497 6.08769L8.84194 9.18515C8.11704 8.45332 7.11146 8 6 8C3.79086 8 2 9.79086 2 12C2 14.2091 3.79086 16 6 16C7.11166 16 8.11741 15.5465 8.84234 14.8145L14.1509 17.9079C14.0526 18.255 14 18.6214 14 19C14 21.2091 15.7909 23 18 23C20.2091 23 22 21.2091 22 19C22 16.7909 20.2091 15 18 15C16.8902 15 15.886 15.452 15.1613 16.1819L9.8505 13.0871C9.94789 12.7415 10 12.3768 10 12C10 11.623 9.94784 11.2582 9.85034 10.9123L15.1581 7.81486ZM18 3C16.8954 3 16 3.89543 16 5C16 5.34734 16.0885 5.674 16.2443 5.95864C16.2545 5.97406 16.2643 5.98984 16.2737 6.00598C16.283 6.02201 16.2919 6.03818 16.3003 6.05449C16.6531 6.62211 17.2824 7 18 7C19.1046 7 20 6.10457 20 5C20 3.89543 19.1046 3 18 3ZM7.69965 10.9454C7.70804 10.9617 7.71692 10.978 7.72631 10.994C7.73576 11.0102 7.7456 11.0261 7.7558 11.0415C7.91149 11.3261 8 11.6527 8 12C8 12.3473 7.91147 12.6739 7.75575 12.9586C7.74545 12.9742 7.73552 12.9902 7.72599 13.0065C7.71674 13.0224 7.70798 13.0384 7.69971 13.0546C7.34681 13.6221 6.71753 14 6 14C4.89543 14 4 13.1046 4 12C4 10.8954 4.89543 10 6 10C6.71749 10 7.34674 10.3778 7.69965 10.9454ZM16 19C16 18.6749 16.0776 18.3678 16.2153 18.0965C16.24 18.064 16.2629 18.0296 16.284 17.9935C16.3042 17.9588 16.3221 17.9235 16.3377 17.8875C16.6966 17.3523 17.3072 17 18 17C19.1046 17 20 17.8954 20 19C20 20.1046 19.1046 21 18 21C16.8954 21 16 20.1046 16 19Z",
          fill: e,
          stroke: "none"
        }
      )
    }
  ),
  Facebook: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.7574 2.75736C11.8826 1.63214 13.4087 1 15 1H18C18.5523 1 19 1.44772 19 2V6C19 6.55228 18.5523 7 18 7H15V9H18C18.3079 9 18.5987 9.14187 18.7882 9.38459C18.9777 9.6273 19.0448 9.94379 18.9701 10.2425L17.9701 14.2425C17.8589 14.6877 17.4589 15 17 15H15V22C15 22.5523 14.5523 23 14 23H10C9.44772 23 9 22.5523 9 22V15H7C6.44772 15 6 14.5523 6 14V10C6 9.44772 6.44772 9 7 9H9V7C9 5.4087 9.63214 3.88258 10.7574 2.75736ZM15 3C13.9391 3 12.9217 3.42143 12.1716 4.17157C11.4214 4.92172 11 5.93913 11 7V10C11 10.5523 10.5523 11 10 11H8V13H10C10.5523 13 11 13.4477 11 14V21H13V14C13 13.4477 13.4477 13 14 13H16.2192L16.7192 11H14C13.4477 11 13 10.5523 13 10V7C13 6.46957 13.2107 5.96086 13.5858 5.58579C13.9609 5.21071 14.4696 5 15 5H17V3H15Z",
          fill: e,
          stroke: "none"
        }
      )
    }
  ),
  Instagram: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.74012 7.51843C10.6736 7.03406 11.7361 6.85637 12.7764 7.01063C13.8375 7.16799 14.82 7.66246 15.5785 8.42101C16.3371 9.17957 16.8315 10.162 16.9889 11.2231C17.1432 12.2634 16.9655 13.3259 16.4811 14.2594C15.9967 15.1929 15.2303 15.9499 14.2909 16.4227C13.3515 16.8955 12.287 17.0601 11.2486 16.893C10.2103 16.726 9.25109 16.2357 8.50744 15.4921C7.76379 14.7484 7.27356 13.7892 7.10648 12.7509C6.9394 11.7126 7.10397 10.648 7.5768 9.7086C8.04963 8.7692 8.80662 8.00281 9.74012 7.51843ZM12.483 8.989C11.8588 8.89644 11.2214 9.00305 10.6613 9.29368C10.1012 9.5843 9.64697 10.0441 9.36327 10.6078C9.07957 11.1714 8.98083 11.8102 9.08108 12.4332C9.18132 13.0562 9.47546 13.6317 9.92165 14.0779C10.3678 14.5241 10.9434 14.8182 11.5664 14.9184C12.1894 15.0187 12.8281 14.9199 13.3917 14.6363C13.9554 14.3526 14.4152 13.8984 14.7058 13.3383C14.9965 12.7782 15.1031 12.1407 15.0105 11.5165C14.9161 10.8798 14.6194 10.2904 14.1643 9.83523C13.7092 9.3801 13.1197 9.08341 12.483 8.989Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M17.5 5.5C16.9477 5.5 16.5 5.94772 16.5 6.5C16.5 7.05228 16.9477 7.5 17.5 7.5H17.51C18.0623 7.5 18.51 7.05228 18.51 6.5C18.51 5.94772 18.0623 5.5 17.51 5.5H17.5Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 7C1 3.68629 3.68629 1 7 1H17C20.3137 1 23 3.68629 23 7V17C23 20.3137 20.3137 23 17 23H7C3.68629 23 1 20.3137 1 17V7ZM7 3C4.79086 3 3 4.79086 3 7V17C3 19.2091 4.79086 21 7 21H17C19.2091 21 21 19.2091 21 17V7C21 4.79086 19.2091 3 17 3H7Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Linkedin: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 1C2.34315 1 1 2.34315 1 4C1 5.65685 2.34315 7 4 7C5.65685 7 7 5.65685 7 4C7 2.34315 5.65685 1 4 1ZM3 4C3 3.44772 3.44772 3 4 3C4.55228 3 5 3.44772 5 4C5 4.55228 4.55228 5 4 5C3.44772 5 3 4.55228 3 4Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.0503 9.05025C12.363 7.7375 14.1435 7 16 7C17.8565 7 19.637 7.7375 20.9497 9.05025C22.2625 10.363 23 12.1435 23 14V21C23 21.5523 22.5523 22 22 22H18C17.4477 22 17 21.5523 17 21V14C17 13.7348 16.8946 13.4804 16.7071 13.2929C16.5196 13.1054 16.2652 13 16 13C15.7348 13 15.4804 13.1054 15.2929 13.2929C15.1054 13.4804 15 13.7348 15 14V21C15 21.5523 14.5523 22 14 22H10C9.44771 22 9 21.5523 9 21V14C9 12.1435 9.7375 10.363 11.0503 9.05025ZM16 9C14.6739 9 13.4021 9.52678 12.4645 10.4645C11.5268 11.4021 11 12.6739 11 14V20H13V14C13 13.2043 13.3161 12.4413 13.8787 11.8787C14.4413 11.3161 15.2043 11 16 11C16.7957 11 17.5587 11.3161 18.1213 11.8787C18.6839 12.4413 19 13.2043 19 14V20H21V14C21 12.6739 20.4732 11.4021 19.5355 10.4645C18.5979 9.52678 17.3261 9 16 9Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 9C1 8.44772 1.44772 8 2 8H6C6.55228 8 7 8.44772 7 9V21C7 21.5523 6.55228 22 6 22H2C1.44772 22 1 21.5523 1 21V9ZM3 10V20H5V10H3Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  X: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          d: "M18.244 2.25H21.552L14.325 10.51L22.827 21.75H16.17L10.956 14.933L4.99 21.75H1.68L9.41 12.915L1.254 2.25H8.08L12.793 8.481L18.244 2.25ZM17.083 19.77H18.916L7.084 4.126H5.117L17.083 19.77Z",
          fill: e,
          stroke: "none"
        }
      )
    }
  ),
  Trash: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M10 10C10.5523 10 11 10.4477 11 11V17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17V11C9 10.4477 9.44772 10 10 10Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11V17C13 17.5523 13.4477 18 14 18C14.5523 18 15 17.5523 15 17V11Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 5V4C7 3.17477 7.40255 2.43324 7.91789 1.91789C8.43324 1.40255 9.17477 1 10 1H14C14.8252 1 15.5668 1.40255 16.0821 1.91789C16.5975 2.43324 17 3.17477 17 4V5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H20V20C20 20.8252 19.5975 21.5668 19.0821 22.0821C18.5668 22.5975 17.8252 23 17 23H7C6.17477 23 5.43324 22.5975 4.91789 22.0821C4.40255 21.5668 4 20.8252 4 20V7H3C2.44772 7 2 6.55228 2 6C2 5.44772 2.44772 5 3 5H7ZM9 4C9 3.82523 9.09745 3.56676 9.33211 3.33211C9.56676 3.09745 9.82523 3 10 3H14C14.1748 3 14.4332 3.09745 14.6679 3.33211C14.9025 3.56676 15 3.82523 15 4V5H9V4ZM6 7V20C6 20.1748 6.09745 20.4332 6.33211 20.6679C6.56676 20.9025 6.82523 21 7 21H17C17.1748 21 17.4332 20.9025 17.6679 20.6679C17.9025 20.4332 18 20.1748 18 20V7H6Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Type: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          d: "M3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V7C21 7.55228 20.5523 8 20 8C19.4477 8 19 7.55228 19 7V5H13V19H15C15.5523 19 16 19.4477 16 20C16 20.5523 15.5523 21 15 21H9C8.44772 21 8 20.5523 8 20C8 19.4477 8.44772 19 9 19H11V5H5V7C5 7.55228 4.55228 8 4 8C3.44772 8 3 7.55228 3 7V4Z",
          fill: e,
          stroke: "none"
        }
      )
    }
  ),
  Upload: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3 14C3.55228 14 4 14.4477 4 15V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V15C2 14.4477 2.44772 14 3 14Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.2929 2.29289C11.6834 1.90237 12.3166 1.90237 12.7071 2.29289L17.7071 7.29289C18.0976 7.68342 18.0976 8.31658 17.7071 8.70711C17.3166 9.09763 16.6834 9.09763 16.2929 8.70711L12 4.41421L7.70711 8.70711C7.31658 9.09763 6.68342 9.09763 6.29289 8.70711C5.90237 8.31658 5.90237 7.68342 6.29289 7.29289L11.2929 2.29289Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 2C12.5523 2 13 2.44772 13 3V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V3C11 2.44772 11.4477 2 12 2Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Users: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsxs(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: [
        /* @__PURE__ */ l.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 8C16 9.94452 15.075 11.673 13.641 12.7694C14.6465 13.2142 15.5715 13.8436 16.364 14.636C18.0518 16.3239 19 18.6131 19 21C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21C17 19.1435 16.2625 17.363 14.9497 16.0503C13.637 14.7375 11.8565 14 10 14C8.14348 14 6.36301 14.7375 5.05025 16.0503C3.7375 17.363 3 19.1435 3 21C3 21.5523 2.55228 22 2 22C1.44772 22 1 21.5523 1 21C1 18.6131 1.94821 16.3239 3.63604 14.636C4.4285 13.8436 5.35354 13.2142 6.35901 12.7694C4.92501 11.673 4 9.94452 4 8C4 4.68629 6.68629 2 10 2C13.3137 2 16 4.68629 16 8ZM10 4C7.79086 4 6 5.79086 6 8C6 10.2091 7.79086 12 10 12C12.2091 12 14 10.2091 14 8C14 5.79086 12.2091 4 10 4Z",
            fill: e,
            stroke: "none"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M18.0601 2.83989C17.5851 2.55815 16.9716 2.71484 16.6899 3.18986C16.4082 3.66487 16.5648 4.27835 17.0399 4.56008C17.6054 4.89549 18.0795 5.36513 18.4202 5.92744C18.761 6.48975 18.9579 7.12739 18.9935 7.78392C19.0291 8.44046 18.9023 9.09564 18.6243 9.6915C18.3464 10.2874 17.9258 10.8055 17.3999 11.2001C17.1481 11.389 17 11.6853 17 12.0001C17 12.3148 17.1482 12.6111 17.4 12.8C19.186 14.1395 21 16.9892 21 20C21 20.5523 21.4477 21 22 21C22.5523 21 23 20.5523 23 20C23 16.7784 21.3686 13.7948 19.4971 11.9717C19.876 11.5425 20.193 11.0597 20.4368 10.537C20.8537 9.64323 21.0439 8.66045 20.9905 7.67565C20.9372 6.69085 20.6418 5.73439 20.1307 4.89093C19.6196 4.04746 18.9084 3.343 18.0601 2.83989Z",
            fill: e,
            stroke: "none"
          }
        )
      ]
    }
  ),
  Close: ({ fill: e, width: t, height: a, ...n }) => /* @__PURE__ */ l.jsx(
    "svg",
    {
      width: t,
      height: a,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      ...n,
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          d: "M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z",
          fill: e,
          stroke: "none"
        }
      )
    }
  )
}, D5e = Lt("object-contain", {
  variants: {
    size: {
      sm: "w-4",
      md: "w-6",
      lg: "w-8"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), _5e = Et(
  ({
    name: e,
    size: t = "md",
    // Default size
    fill: a = "none",
    // Default fill
    stroke: n = "none",
    // Default stroke
    className: o,
    ...i
  }, s) => {
    const c = z5e[e];
    if (!c)
      return console.error(`Icon "${e}" not found`), null;
    const f = t === "sm" ? 16 : t === "md" ? 24 : t === "lg" ? 32 : 24, d = {
      width: f,
      height: f,
      fill: a,
      name: e,
      stroke: n,
      className: S(D5e({ size: t }), o),
      ref: s,
      // Attach the ref here
      ...i
    };
    return /* @__PURE__ */ l.jsx(c, { ...d, ref: s });
  }
);
_5e.displayName = "Icon";
const Fwe = ({
  checked: e,
  onCheckedChange: t,
  className: a,
  disabled: n
}) => /* @__PURE__ */ l.jsxs("div", { className: "flex w-fit", children: [
  /* @__PURE__ */ l.jsx(
    "input",
    {
      className: S(
        "relative cursor-pointer peer shrink-0 appearance-none peer h-[18px] w-[18px] rounded-sm border color-border-active checked:color-bg-default-inverse checked:border-0 checked:color-text-inverse ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused focus-visible:ring-offset-2",
        n && "cursor-not-allowed opacity-30 pointer-events-none",
        a
      ),
      type: "checkbox",
      onChange: t,
      checked: e,
      disabled: n
    }
  ),
  /* @__PURE__ */ l.jsx(
    "svg",
    {
      className: "absolute h-[18px] w-[18px] pointer-events-none hidden peer-checked:block stroke-white dark:stroke-black outline-none p-[4px]",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: /* @__PURE__ */ l.jsx("polyline", { points: "20 6 9 17 4 12" })
    }
  )
] });
function vr(e) {
  const t = e + "CollectionProvider", [a, n] = at(t), [o, i] = a(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (m) => {
    const { scope: v, children: k } = m, g = I.useRef(null), M = I.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ l.jsx(o, { scope: v, itemMap: M, collectionRef: g, children: k });
  };
  s.displayName = t;
  const c = e + "CollectionSlot", f = I.forwardRef(
    (m, v) => {
      const { scope: k, children: g } = m, M = i(c, k), w = ye(v, M.collectionRef);
      return /* @__PURE__ */ l.jsx(c1, { ref: w, children: g });
    }
  );
  f.displayName = c;
  const d = e + "CollectionItemSlot", u = "data-radix-collection-item", h = I.forwardRef(
    (m, v) => {
      const { scope: k, children: g, ...M } = m, w = I.useRef(null), x = ye(v, w), C = i(d, k);
      return I.useEffect(() => (C.itemMap.set(w, { ref: w, ...M }), () => void C.itemMap.delete(w))), /* @__PURE__ */ l.jsx(c1, { [u]: "", ref: x, children: g });
    }
  );
  h.displayName = d;
  function y(m) {
    const v = i(e + "CollectionConsumer", m);
    return I.useCallback(() => {
      const g = v.collectionRef.current;
      if (!g) return [];
      const M = Array.from(g.querySelectorAll(`[${u}]`));
      return Array.from(v.itemMap.values()).sort(
        (C, L) => M.indexOf(C.ref.current) - M.indexOf(L.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: s, Slot: f, ItemSlot: h },
    y,
    n
  ];
}
var Ku = p.createContext(void 0), P5e = (e) => {
  const { dir: t, children: a } = e;
  return /* @__PURE__ */ l.jsx(Ku.Provider, { value: t, children: a });
};
function Rn(e) {
  const t = p.useContext(Ku);
  return e || t || "ltr";
}
var E5e = P5e, M2 = "rovingFocusGroup.onEntryFocus", R5e = { bubbles: !1, cancelable: !0 }, Mr = "RovingFocusGroup", [vi, Xu, H5e] = vr(Mr), [V5e, wr] = at(
  Mr,
  [H5e]
), [O5e, q5e] = V5e(Mr), e4 = p.forwardRef(
  (e, t) => /* @__PURE__ */ l.jsx(vi.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ l.jsx(vi.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ l.jsx(B5e, { ...e, ref: t }) }) })
);
e4.displayName = Mr;
var B5e = p.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: a,
    orientation: n,
    loop: o = !1,
    dir: i,
    currentTabStopId: s,
    defaultCurrentTabStopId: c,
    onCurrentTabStopIdChange: f,
    onEntryFocus: d,
    preventScrollOnEntryFocus: u = !1,
    ...h
  } = e, y = p.useRef(null), m = ye(t, y), v = Rn(i), [k = null, g] = ft({
    prop: s,
    defaultProp: c,
    onChange: f
  }), [M, w] = p.useState(!1), x = ct(d), C = Xu(a), L = p.useRef(!1), [N, j] = p.useState(0);
  return p.useEffect(() => {
    const A = y.current;
    if (A)
      return A.addEventListener(M2, x), () => A.removeEventListener(M2, x);
  }, [x]), /* @__PURE__ */ l.jsx(
    O5e,
    {
      scope: a,
      orientation: n,
      dir: v,
      loop: o,
      currentTabStopId: k,
      onItemFocus: p.useCallback(
        (A) => g(A),
        [g]
      ),
      onItemShiftTab: p.useCallback(() => w(!0), []),
      onFocusableItemAdd: p.useCallback(
        () => j((A) => A + 1),
        []
      ),
      onFocusableItemRemove: p.useCallback(
        () => j((A) => A - 1),
        []
      ),
      children: /* @__PURE__ */ l.jsx(
        Y.div,
        {
          tabIndex: M || N === 0 ? -1 : 0,
          "data-orientation": n,
          ...h,
          ref: m,
          style: { outline: "none", ...e.style },
          onMouseDown: F(e.onMouseDown, () => {
            L.current = !0;
          }),
          onFocus: F(e.onFocus, (A) => {
            const D = !L.current;
            if (A.target === A.currentTarget && D && !M) {
              const H = new CustomEvent(M2, R5e);
              if (A.currentTarget.dispatchEvent(H), !H.defaultPrevented) {
                const Z = C().filter((q) => q.focusable), R = Z.find((q) => q.active), _ = Z.find((q) => q.id === k), G = [R, _, ...Z].filter(
                  Boolean
                ).map((q) => q.ref.current);
                n4(G, u);
              }
            }
            L.current = !1;
          }),
          onBlur: F(e.onBlur, () => w(!1))
        }
      )
    }
  );
}), t4 = "RovingFocusGroupItem", a4 = p.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: a,
      focusable: n = !0,
      active: o = !1,
      tabStopId: i,
      ...s
    } = e, c = $e(), f = i || c, d = q5e(t4, a), u = d.currentTabStopId === f, h = Xu(a), { onFocusableItemAdd: y, onFocusableItemRemove: m } = d;
    return p.useEffect(() => {
      if (n)
        return y(), () => m();
    }, [n, y, m]), /* @__PURE__ */ l.jsx(
      vi.ItemSlot,
      {
        scope: a,
        id: f,
        focusable: n,
        active: o,
        children: /* @__PURE__ */ l.jsx(
          Y.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": d.orientation,
            ...s,
            ref: t,
            onMouseDown: F(e.onMouseDown, (v) => {
              n ? d.onItemFocus(f) : v.preventDefault();
            }),
            onFocus: F(e.onFocus, () => d.onItemFocus(f)),
            onKeyDown: F(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const k = G5e(v, d.orientation, d.dir);
              if (k !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let M = h().filter((w) => w.focusable).map((w) => w.ref.current);
                if (k === "last") M.reverse();
                else if (k === "prev" || k === "next") {
                  k === "prev" && M.reverse();
                  const w = M.indexOf(v.currentTarget);
                  M = d.loop ? $5e(M, w + 1) : M.slice(w + 1);
                }
                setTimeout(() => n4(M));
              }
            })
          }
        )
      }
    );
  }
);
a4.displayName = t4;
var Z5e = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function F5e(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function G5e(e, t, a) {
  const n = F5e(e.key, a);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(n)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(n)))
    return Z5e[n];
}
function n4(e, t = !1) {
  const a = document.activeElement;
  for (const n of e)
    if (n === a || (n.focus({ preventScroll: t }), document.activeElement !== a)) return;
}
function $5e(e, t) {
  return e.map((a, n) => e[(t + n) % e.length]);
}
var o4 = e4, r4 = a4, q0 = "Tabs", [U5e, Gwe] = at(q0, [
  wr
]), i4 = wr(), [W5e, B0] = U5e(q0), s4 = p.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: a,
      value: n,
      onValueChange: o,
      defaultValue: i,
      orientation: s = "horizontal",
      dir: c,
      activationMode: f = "automatic",
      ...d
    } = e, u = Rn(c), [h, y] = ft({
      prop: n,
      onChange: o,
      defaultProp: i
    });
    return /* @__PURE__ */ l.jsx(
      W5e,
      {
        scope: a,
        baseId: $e(),
        value: h,
        onValueChange: y,
        orientation: s,
        dir: u,
        activationMode: f,
        children: /* @__PURE__ */ l.jsx(
          Y.div,
          {
            dir: u,
            "data-orientation": s,
            ...d,
            ref: t
          }
        )
      }
    );
  }
);
s4.displayName = q0;
var c4 = "TabsList", f4 = p.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, loop: n = !0, ...o } = e, i = B0(c4, a), s = i4(a);
    return /* @__PURE__ */ l.jsx(
      o4,
      {
        asChild: !0,
        ...s,
        orientation: i.orientation,
        dir: i.dir,
        loop: n,
        children: /* @__PURE__ */ l.jsx(
          Y.div,
          {
            role: "tablist",
            "aria-orientation": i.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
f4.displayName = c4;
var d4 = "TabsTrigger", l4 = p.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, value: n, disabled: o = !1, ...i } = e, s = B0(d4, a), c = i4(a), f = p4(s.baseId, n), d = y4(s.baseId, n), u = n === s.value;
    return /* @__PURE__ */ l.jsx(
      r4,
      {
        asChild: !0,
        ...c,
        focusable: !o,
        active: u,
        children: /* @__PURE__ */ l.jsx(
          Y.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": d,
            "data-state": u ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: f,
            ...i,
            ref: t,
            onMouseDown: F(e.onMouseDown, (h) => {
              !o && h.button === 0 && h.ctrlKey === !1 ? s.onValueChange(n) : h.preventDefault();
            }),
            onKeyDown: F(e.onKeyDown, (h) => {
              [" ", "Enter"].includes(h.key) && s.onValueChange(n);
            }),
            onFocus: F(e.onFocus, () => {
              const h = s.activationMode !== "manual";
              !u && !o && h && s.onValueChange(n);
            })
          }
        )
      }
    );
  }
);
l4.displayName = d4;
var u4 = "TabsContent", h4 = p.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, value: n, forceMount: o, children: i, ...s } = e, c = B0(u4, a), f = p4(c.baseId, n), d = y4(c.baseId, n), u = n === c.value, h = p.useRef(u);
    return p.useEffect(() => {
      const y = requestAnimationFrame(() => h.current = !1);
      return () => cancelAnimationFrame(y);
    }, []), /* @__PURE__ */ l.jsx(mt, { present: o || u, children: ({ present: y }) => /* @__PURE__ */ l.jsx(
      Y.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": c.orientation,
        role: "tabpanel",
        "aria-labelledby": f,
        hidden: !y,
        id: d,
        tabIndex: 0,
        ...s,
        ref: t,
        style: {
          ...e.style,
          animationDuration: h.current ? "0s" : void 0
        },
        children: y && i
      }
    ) });
  }
);
h4.displayName = u4;
function p4(e, t) {
  return `${e}-trigger-${t}`;
}
function y4(e, t) {
  return `${e}-content-${t}`;
}
var Y5e = s4, m4 = f4, k4 = l4, g4 = h4;
const Q5e = Y5e, v4 = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  m4,
  {
    ref: a,
    className: S(
      "inline-flex h-9 items-center justify-center bg-none p-1 color-text-secondary",
      e
    ),
    ...t
  }
));
v4.displayName = m4.displayName;
const Mi = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  k4,
  {
    ref: a,
    className: S(
      "inline-flex items-center justify-center whitespace-nowrap h-[38px] px-3 py-1 text-heading-xsm color-text-secondary ring-offset-2 transition-all focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused disabled:pointer-events-none disabled:color-text-disabled hover:color-bg-default-hover data-[state=active]:color-text-default border-b-2 border-transparent data-[state=active]:color-border-active dark:data-[state=active]:color-border-light",
      e
    ),
    "data-testid": "tabs-trigger",
    ...t
  }
));
Mi.displayName = k4.displayName;
const M4 = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  g4,
  {
    ref: a,
    className: S(
      "mt-2 color-text-default ring-offset-2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused",
      e
    ),
    ...t
  }
));
M4.displayName = g4.displayName;
const J5e = p.forwardRef(
  ({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
    "div",
    {
      ref: a,
      className: S(
        "rounded-xl color-bg-secondary hover:color-bg-default-hover color-text-default p-5 transition-colors w-full h-full",
        e
      ),
      ...t
    }
  )
);
J5e.displayName = "Card";
const K5e = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx("div", { ref: a, className: S("flex flex-col space-y-4", e), ...t }));
K5e.displayName = "CardHeader";
const X5e = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx("h3", { ref: a, className: S("", e), ...t }));
X5e.displayName = "CardTitle";
const e8e = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx("p", { ref: a, className: S("text-body-sm", e), ...t }));
e8e.displayName = "CardDescription";
const t8e = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx("div", { ref: a, className: S("p-6 pt-0", e), ...t }));
t8e.displayName = "CardContent";
const a8e = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx("div", { ref: a, className: S("flex items-center", e), ...t }));
a8e.displayName = "CardFooter";
const xr = I.forwardRef(
  ({
    options: e,
    container: t,
    setCurrentState: a,
    currentState: n,
    showActiveState: o = !0,
    disabled: i,
    contentType: s = "icon",
    ...c
  }, f) => {
    const [d, u] = ve(n), h = (y) => {
      !i && u(y), !i && a(y);
    };
    return /* @__PURE__ */ l.jsx(
      "div",
      {
        ref: f,
        className: S(
          "h-[52px] p-2 color-bg-default flex justify-center items-center gap-1 rounded-xl",
          {
            "color-border-default border-[0.5px] shadow-elevation-3": t
          }
        ),
        ...c,
        children: e.map((y, m) => /* @__PURE__ */ l.jsx(
          "div",
          {
            onClick: () => h(m),
            className: S(
              "h-9 flex justify-center items-center rounded cursor-pointer transition-colors",
              {
                "color-bg-brand hover:color-bg-brand-hover color-text-inverse": o && d === m,
                "hover:color-bg-default-hover color-text-default": o && d !== m,
                "cursor-not-allowed color-bg-disabled color-text-disabled": i,
                "w-9": s === "icon",
                "w-fit px-2": s === "text"
              }
            ),
            children: y
          },
          m
        ))
      }
    );
  }
);
xr.displayName = "SegmentedControl";
var Z0 = "Collapsible", [n8e, w4] = at(Z0), [o8e, F0] = n8e(Z0), x4 = p.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: a,
      open: n,
      defaultOpen: o,
      disabled: i,
      onOpenChange: s,
      ...c
    } = e, [f = !1, d] = ft({
      prop: n,
      defaultProp: o,
      onChange: s
    });
    return /* @__PURE__ */ l.jsx(
      o8e,
      {
        scope: a,
        disabled: i,
        contentId: $e(),
        open: f,
        onOpenToggle: p.useCallback(() => d((u) => !u), [d]),
        children: /* @__PURE__ */ l.jsx(
          Y.div,
          {
            "data-state": $0(f),
            "data-disabled": i ? "" : void 0,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
x4.displayName = Z0;
var C4 = "CollapsibleTrigger", b4 = p.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: a, ...n } = e, o = F0(C4, a);
    return /* @__PURE__ */ l.jsx(
      Y.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": $0(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...n,
        ref: t,
        onClick: F(e.onClick, o.onOpenToggle)
      }
    );
  }
);
b4.displayName = C4;
var G0 = "CollapsibleContent", L4 = p.forwardRef(
  (e, t) => {
    const { forceMount: a, ...n } = e, o = F0(G0, e.__scopeCollapsible);
    return /* @__PURE__ */ l.jsx(mt, { present: a || o.open, children: ({ present: i }) => /* @__PURE__ */ l.jsx(r8e, { ...n, ref: t, present: i }) });
  }
);
L4.displayName = G0;
var r8e = p.forwardRef((e, t) => {
  const { __scopeCollapsible: a, present: n, children: o, ...i } = e, s = F0(G0, a), [c, f] = p.useState(n), d = p.useRef(null), u = ye(t, d), h = p.useRef(0), y = h.current, m = p.useRef(0), v = m.current, k = s.open || c, g = p.useRef(k), M = p.useRef(void 0);
  return p.useEffect(() => {
    const w = requestAnimationFrame(() => g.current = !1);
    return () => cancelAnimationFrame(w);
  }, []), We(() => {
    const w = d.current;
    if (w) {
      M.current = M.current || {
        transitionDuration: w.style.transitionDuration,
        animationName: w.style.animationName
      }, w.style.transitionDuration = "0s", w.style.animationName = "none";
      const x = w.getBoundingClientRect();
      h.current = x.height, m.current = x.width, g.current || (w.style.transitionDuration = M.current.transitionDuration, w.style.animationName = M.current.animationName), f(n);
    }
  }, [s.open, n]), /* @__PURE__ */ l.jsx(
    Y.div,
    {
      "data-state": $0(s.open),
      "data-disabled": s.disabled ? "" : void 0,
      id: s.contentId,
      hidden: !k,
      ...i,
      ref: u,
      style: {
        "--radix-collapsible-content-height": y ? `${y}px` : void 0,
        "--radix-collapsible-content-width": v ? `${v}px` : void 0,
        ...e.style
      },
      children: k && o
    }
  );
});
function $0(e) {
  return e ? "open" : "closed";
}
var i8e = x4, s8e = b4, c8e = L4, t1 = "Accordion", f8e = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [U0, d8e, l8e] = vr(t1), [Cr, $we] = at(t1, [
  l8e,
  w4
]), W0 = w4(), j4 = I.forwardRef(
  (e, t) => {
    const { type: a, ...n } = e, o = n, i = n;
    return /* @__PURE__ */ l.jsx(U0.Provider, { scope: e.__scopeAccordion, children: a === "multiple" ? /* @__PURE__ */ l.jsx(y8e, { ...i, ref: t }) : /* @__PURE__ */ l.jsx(p8e, { ...o, ref: t }) });
  }
);
j4.displayName = t1;
var [N4, u8e] = Cr(t1), [A4, h8e] = Cr(
  t1,
  { collapsible: !1 }
), p8e = I.forwardRef(
  (e, t) => {
    const {
      value: a,
      defaultValue: n,
      onValueChange: o = () => {
      },
      collapsible: i = !1,
      ...s
    } = e, [c, f] = ft({
      prop: a,
      defaultProp: n,
      onChange: o
    });
    return /* @__PURE__ */ l.jsx(
      N4,
      {
        scope: e.__scopeAccordion,
        value: c ? [c] : [],
        onItemOpen: f,
        onItemClose: I.useCallback(() => i && f(""), [i, f]),
        children: /* @__PURE__ */ l.jsx(A4, { scope: e.__scopeAccordion, collapsible: i, children: /* @__PURE__ */ l.jsx(S4, { ...s, ref: t }) })
      }
    );
  }
), y8e = I.forwardRef((e, t) => {
  const {
    value: a,
    defaultValue: n,
    onValueChange: o = () => {
    },
    ...i
  } = e, [s = [], c] = ft({
    prop: a,
    defaultProp: n,
    onChange: o
  }), f = I.useCallback(
    (u) => c((h = []) => [...h, u]),
    [c]
  ), d = I.useCallback(
    (u) => c((h = []) => h.filter((y) => y !== u)),
    [c]
  );
  return /* @__PURE__ */ l.jsx(
    N4,
    {
      scope: e.__scopeAccordion,
      value: s,
      onItemOpen: f,
      onItemClose: d,
      children: /* @__PURE__ */ l.jsx(A4, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ l.jsx(S4, { ...i, ref: t }) })
    }
  );
}), [m8e, br] = Cr(t1), S4 = I.forwardRef(
  (e, t) => {
    const { __scopeAccordion: a, disabled: n, dir: o, orientation: i = "vertical", ...s } = e, c = I.useRef(null), f = ye(c, t), d = d8e(a), h = Rn(o) === "ltr", y = F(e.onKeyDown, (m) => {
      var A;
      if (!f8e.includes(m.key)) return;
      const v = m.target, k = d().filter((D) => {
        var H;
        return !((H = D.ref.current) != null && H.disabled);
      }), g = k.findIndex((D) => D.ref.current === v), M = k.length;
      if (g === -1) return;
      m.preventDefault();
      let w = g;
      const x = 0, C = M - 1, L = () => {
        w = g + 1, w > C && (w = x);
      }, N = () => {
        w = g - 1, w < x && (w = C);
      };
      switch (m.key) {
        case "Home":
          w = x;
          break;
        case "End":
          w = C;
          break;
        case "ArrowRight":
          i === "horizontal" && (h ? L() : N());
          break;
        case "ArrowDown":
          i === "vertical" && L();
          break;
        case "ArrowLeft":
          i === "horizontal" && (h ? N() : L());
          break;
        case "ArrowUp":
          i === "vertical" && N();
          break;
      }
      const j = w % M;
      (A = k[j].ref.current) == null || A.focus();
    });
    return /* @__PURE__ */ l.jsx(
      m8e,
      {
        scope: a,
        disabled: n,
        direction: o,
        orientation: i,
        children: /* @__PURE__ */ l.jsx(U0.Slot, { scope: a, children: /* @__PURE__ */ l.jsx(
          Y.div,
          {
            ...s,
            "data-orientation": i,
            ref: f,
            onKeyDown: n ? void 0 : y
          }
        ) })
      }
    );
  }
), Fo = "AccordionItem", [k8e, Y0] = Cr(Fo), I4 = I.forwardRef(
  (e, t) => {
    const { __scopeAccordion: a, value: n, ...o } = e, i = br(Fo, a), s = u8e(Fo, a), c = W0(a), f = $e(), d = n && s.value.includes(n) || !1, u = i.disabled || e.disabled;
    return /* @__PURE__ */ l.jsx(
      k8e,
      {
        scope: a,
        open: d,
        disabled: u,
        triggerId: f,
        children: /* @__PURE__ */ l.jsx(
          i8e,
          {
            "data-orientation": i.orientation,
            "data-state": E4(d),
            ...c,
            ...o,
            ref: t,
            disabled: u,
            open: d,
            onOpenChange: (h) => {
              h ? s.onItemOpen(n) : s.onItemClose(n);
            }
          }
        )
      }
    );
  }
);
I4.displayName = Fo;
var T4 = "AccordionHeader", z4 = I.forwardRef(
  (e, t) => {
    const { __scopeAccordion: a, ...n } = e, o = br(t1, a), i = Y0(T4, a);
    return /* @__PURE__ */ l.jsx(
      Y.h3,
      {
        "data-orientation": o.orientation,
        "data-state": E4(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        ...n,
        ref: t
      }
    );
  }
);
z4.displayName = T4;
var wi = "AccordionTrigger", D4 = I.forwardRef(
  (e, t) => {
    const { __scopeAccordion: a, ...n } = e, o = br(t1, a), i = Y0(wi, a), s = h8e(wi, a), c = W0(a);
    return /* @__PURE__ */ l.jsx(U0.ItemSlot, { scope: a, children: /* @__PURE__ */ l.jsx(
      s8e,
      {
        "aria-disabled": i.open && !s.collapsible || void 0,
        "data-orientation": o.orientation,
        id: i.triggerId,
        ...c,
        ...n,
        ref: t
      }
    ) });
  }
);
D4.displayName = wi;
var _4 = "AccordionContent", P4 = I.forwardRef(
  (e, t) => {
    const { __scopeAccordion: a, ...n } = e, o = br(t1, a), i = Y0(_4, a), s = W0(a);
    return /* @__PURE__ */ l.jsx(
      c8e,
      {
        role: "region",
        "aria-labelledby": i.triggerId,
        "data-orientation": o.orientation,
        ...s,
        ...n,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
P4.displayName = _4;
function E4(e) {
  return e ? "open" : "closed";
}
var g8e = j4, v8e = I4, M8e = z4, R4 = D4, H4 = P4, w2 = "focusScope.autoFocusOnMount", x2 = "focusScope.autoFocusOnUnmount", zf = { bubbles: !1, cancelable: !0 }, w8e = "FocusScope", $1 = p.forwardRef((e, t) => {
  const {
    loop: a = !1,
    trapped: n = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...s
  } = e, [c, f] = p.useState(null), d = ct(o), u = ct(i), h = p.useRef(null), y = ye(t, (k) => f(k)), m = p.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  p.useEffect(() => {
    if (n) {
      let k = function(x) {
        if (m.paused || !c) return;
        const C = x.target;
        c.contains(C) ? h.current = C : s1(h.current, { select: !0 });
      }, g = function(x) {
        if (m.paused || !c) return;
        const C = x.relatedTarget;
        C !== null && (c.contains(C) || s1(h.current, { select: !0 }));
      }, M = function(x) {
        if (document.activeElement === document.body)
          for (const L of x)
            L.removedNodes.length > 0 && s1(c);
      };
      document.addEventListener("focusin", k), document.addEventListener("focusout", g);
      const w = new MutationObserver(M);
      return c && w.observe(c, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", k), document.removeEventListener("focusout", g), w.disconnect();
      };
    }
  }, [n, c, m.paused]), p.useEffect(() => {
    if (c) {
      _f.add(m);
      const k = document.activeElement;
      if (!c.contains(k)) {
        const M = new CustomEvent(w2, zf);
        c.addEventListener(w2, d), c.dispatchEvent(M), M.defaultPrevented || (x8e(N8e(V4(c)), { select: !0 }), document.activeElement === k && s1(c));
      }
      return () => {
        c.removeEventListener(w2, d), setTimeout(() => {
          const M = new CustomEvent(x2, zf);
          c.addEventListener(x2, u), c.dispatchEvent(M), M.defaultPrevented || s1(k ?? document.body, { select: !0 }), c.removeEventListener(x2, u), _f.remove(m);
        }, 0);
      };
    }
  }, [c, d, u, m]);
  const v = p.useCallback(
    (k) => {
      if (!a && !n || m.paused) return;
      const g = k.key === "Tab" && !k.altKey && !k.ctrlKey && !k.metaKey, M = document.activeElement;
      if (g && M) {
        const w = k.currentTarget, [x, C] = C8e(w);
        x && C ? !k.shiftKey && M === C ? (k.preventDefault(), a && s1(x, { select: !0 })) : k.shiftKey && M === x && (k.preventDefault(), a && s1(C, { select: !0 })) : M === w && k.preventDefault();
      }
    },
    [a, n, m.paused]
  );
  return /* @__PURE__ */ l.jsx(Y.div, { tabIndex: -1, ...s, ref: y, onKeyDown: v });
});
$1.displayName = w8e;
function x8e(e, { select: t = !1 } = {}) {
  const a = document.activeElement;
  for (const n of e)
    if (s1(n, { select: t }), document.activeElement !== a) return;
}
function C8e(e) {
  const t = V4(e), a = Df(t, e), n = Df(t.reverse(), e);
  return [a, n];
}
function V4(e) {
  const t = [], a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const o = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || o ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; a.nextNode(); ) t.push(a.currentNode);
  return t;
}
function Df(e, t) {
  for (const a of e)
    if (!b8e(a, { upTo: t })) return a;
}
function b8e(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function L8e(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function s1(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const a = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== a && L8e(e) && t && e.select();
  }
}
var _f = j8e();
function j8e() {
  let e = [];
  return {
    add(t) {
      const a = e[0];
      t !== a && (a == null || a.pause()), e = Pf(e, t), e.unshift(t);
    },
    remove(t) {
      var a;
      e = Pf(e, t), (a = e[0]) == null || a.resume();
    }
  };
}
function Pf(e, t) {
  const a = [...e], n = a.indexOf(t);
  return n !== -1 && a.splice(n, 1), a;
}
function N8e(e) {
  return e.filter((t) => t.tagName !== "A");
}
var C2 = 0;
function Q0() {
  p.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Ef()), document.body.insertAdjacentElement("beforeend", e[1] ?? Ef()), C2++, () => {
      C2 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), C2--;
    };
  }, []);
}
function Ef() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Bt = function() {
  return Bt = Object.assign || function(t) {
    for (var a, n = 1, o = arguments.length; n < o; n++) {
      a = arguments[n];
      for (var i in a) Object.prototype.hasOwnProperty.call(a, i) && (t[i] = a[i]);
    }
    return t;
  }, Bt.apply(this, arguments);
};
function O4(e, t) {
  var a = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (a[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (a[n[o]] = e[n[o]]);
  return a;
}
function A8e(e, t, a) {
  if (a || arguments.length === 2) for (var n = 0, o = t.length, i; n < o; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var bo = "right-scroll-bar-position", Lo = "width-before-scroll-bar", S8e = "with-scroll-bars-hidden", I8e = "--removed-body-scroll-bar-size";
function b2(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function T8e(e, t) {
  var a = ve(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return a.value;
        },
        set current(n) {
          var o = a.value;
          o !== n && (a.value = n, a.callback(n, o));
        }
      }
    };
  })[0];
  return a.callback = t, a.facade;
}
var z8e = typeof window < "u" ? p.useLayoutEffect : p.useEffect, Rf = /* @__PURE__ */ new WeakMap();
function D8e(e, t) {
  var a = T8e(null, function(n) {
    return e.forEach(function(o) {
      return b2(o, n);
    });
  });
  return z8e(function() {
    var n = Rf.get(a);
    if (n) {
      var o = new Set(n), i = new Set(e), s = a.current;
      o.forEach(function(c) {
        i.has(c) || b2(c, null);
      }), i.forEach(function(c) {
        o.has(c) || b2(c, s);
      });
    }
    Rf.set(a, e);
  }, [e]), a;
}
function _8e(e) {
  return e;
}
function P8e(e, t) {
  t === void 0 && (t = _8e);
  var a = [], n = !1, o = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return a.length ? a[a.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, n);
      return a.push(s), function() {
        a = a.filter(function(c) {
          return c !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (n = !0; a.length; ) {
        var s = a;
        a = [], s.forEach(i);
      }
      a = {
        push: function(c) {
          return i(c);
        },
        filter: function() {
          return a;
        }
      };
    },
    assignMedium: function(i) {
      n = !0;
      var s = [];
      if (a.length) {
        var c = a;
        a = [], c.forEach(i), s = a;
      }
      var f = function() {
        var u = s;
        s = [], u.forEach(i);
      }, d = function() {
        return Promise.resolve().then(f);
      };
      d(), a = {
        push: function(u) {
          s.push(u), d();
        },
        filter: function(u) {
          return s = s.filter(u), a;
        }
      };
    }
  };
  return o;
}
function E8e(e) {
  e === void 0 && (e = {});
  var t = P8e(null);
  return t.options = Bt({ async: !0, ssr: !1 }, e), t;
}
var q4 = function(e) {
  var t = e.sideCar, a = O4(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return p.createElement(n, Bt({}, a));
};
q4.isSideCarExport = !0;
function R8e(e, t) {
  return e.useMedium(t), q4;
}
var B4 = E8e(), L2 = function() {
}, Lr = p.forwardRef(function(e, t) {
  var a = p.useRef(null), n = p.useState({
    onScrollCapture: L2,
    onWheelCapture: L2,
    onTouchMoveCapture: L2
  }), o = n[0], i = n[1], s = e.forwardProps, c = e.children, f = e.className, d = e.removeScrollBar, u = e.enabled, h = e.shards, y = e.sideCar, m = e.noIsolation, v = e.inert, k = e.allowPinchZoom, g = e.as, M = g === void 0 ? "div" : g, w = e.gapMode, x = O4(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), C = y, L = D8e([a, t]), N = Bt(Bt({}, x), o);
  return p.createElement(
    p.Fragment,
    null,
    u && p.createElement(C, { sideCar: B4, removeScrollBar: d, shards: h, noIsolation: m, inert: v, setCallbacks: i, allowPinchZoom: !!k, lockRef: a, gapMode: w }),
    s ? p.cloneElement(p.Children.only(c), Bt(Bt({}, N), { ref: L })) : p.createElement(M, Bt({}, N, { className: f, ref: L }), c)
  );
});
Lr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Lr.classNames = {
  fullWidth: Lo,
  zeroRight: bo
};
var H8e = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function V8e() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = H8e();
  return t && e.setAttribute("nonce", t), e;
}
function O8e(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function q8e(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var B8e = function() {
  var e = 0, t = null;
  return {
    add: function(a) {
      e == 0 && (t = V8e()) && (O8e(t, a), q8e(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Z8e = function() {
  var e = B8e();
  return function(t, a) {
    p.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && a]);
  };
}, Z4 = function() {
  var e = Z8e(), t = function(a) {
    var n = a.styles, o = a.dynamic;
    return e(n, o), null;
  };
  return t;
}, F8e = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, j2 = function(e) {
  return parseInt(e || "", 10) || 0;
}, G8e = function(e) {
  var t = window.getComputedStyle(document.body), a = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [j2(a), j2(n), j2(o)];
}, $8e = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return F8e;
  var t = G8e(e), a = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - a + t[2] - t[0])
  };
}, U8e = Z4(), pa = "data-scroll-locked", W8e = function(e, t, a, n) {
  var o = e.left, i = e.top, s = e.right, c = e.gap;
  return a === void 0 && (a = "margin"), `
  .`.concat(S8e, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(c, "px ").concat(n, `;
  }
  body[`).concat(pa, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    a === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(n, `;
    `),
    a === "padding" && "padding-right: ".concat(c, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(bo, ` {
    right: `).concat(c, "px ").concat(n, `;
  }
  
  .`).concat(Lo, ` {
    margin-right: `).concat(c, "px ").concat(n, `;
  }
  
  .`).concat(bo, " .").concat(bo, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Lo, " .").concat(Lo, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(pa, `] {
    `).concat(I8e, ": ").concat(c, `px;
  }
`);
}, Hf = function() {
  var e = parseInt(document.body.getAttribute(pa) || "0", 10);
  return isFinite(e) ? e : 0;
}, Y8e = function() {
  p.useEffect(function() {
    return document.body.setAttribute(pa, (Hf() + 1).toString()), function() {
      var e = Hf() - 1;
      e <= 0 ? document.body.removeAttribute(pa) : document.body.setAttribute(pa, e.toString());
    };
  }, []);
}, Q8e = function(e) {
  var t = e.noRelative, a = e.noImportant, n = e.gapMode, o = n === void 0 ? "margin" : n;
  Y8e();
  var i = p.useMemo(function() {
    return $8e(o);
  }, [o]);
  return p.createElement(U8e, { styles: W8e(i, !t, o, a ? "" : "!important") });
}, xi = !1;
if (typeof window < "u")
  try {
    var so = Object.defineProperty({}, "passive", {
      get: function() {
        return xi = !0, !0;
      }
    });
    window.addEventListener("test", so, so), window.removeEventListener("test", so, so);
  } catch {
    xi = !1;
  }
var ta = xi ? { passive: !1 } : !1, J8e = function(e) {
  return e.tagName === "TEXTAREA";
}, F4 = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var a = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    a[t] !== "hidden" && // contains scroll inside self
    !(a.overflowY === a.overflowX && !J8e(e) && a[t] === "visible")
  );
}, K8e = function(e) {
  return F4(e, "overflowY");
}, X8e = function(e) {
  return F4(e, "overflowX");
}, Vf = function(e, t) {
  var a = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var o = G4(e, n);
    if (o) {
      var i = $4(e, n), s = i[1], c = i[2];
      if (s > c)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== a.body);
  return !1;
}, e9e = function(e) {
  var t = e.scrollTop, a = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    a,
    n
  ];
}, t9e = function(e) {
  var t = e.scrollLeft, a = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    a,
    n
  ];
}, G4 = function(e, t) {
  return e === "v" ? K8e(t) : X8e(t);
}, $4 = function(e, t) {
  return e === "v" ? e9e(t) : t9e(t);
}, a9e = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, n9e = function(e, t, a, n, o) {
  var i = a9e(e, window.getComputedStyle(t).direction), s = i * n, c = a.target, f = t.contains(c), d = !1, u = s > 0, h = 0, y = 0;
  do {
    var m = $4(e, c), v = m[0], k = m[1], g = m[2], M = k - g - i * v;
    (v || M) && G4(e, c) && (h += M, y += v), c instanceof ShadowRoot ? c = c.host : c = c.parentNode;
  } while (
    // portaled content
    !f && c !== document.body || // self content
    f && (t.contains(c) || t === c)
  );
  return (u && Math.abs(h) < 1 || !u && Math.abs(y) < 1) && (d = !0), d;
}, co = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Of = function(e) {
  return [e.deltaX, e.deltaY];
}, qf = function(e) {
  return e && "current" in e ? e.current : e;
}, o9e = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, r9e = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, i9e = 0, aa = [];
function s9e(e) {
  var t = p.useRef([]), a = p.useRef([0, 0]), n = p.useRef(), o = p.useState(i9e++)[0], i = p.useState(Z4)[0], s = p.useRef(e);
  p.useEffect(function() {
    s.current = e;
  }, [e]), p.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var k = A8e([e.lockRef.current], (e.shards || []).map(qf), !0).filter(Boolean);
      return k.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), k.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = p.useCallback(function(k, g) {
    if ("touches" in k && k.touches.length === 2 || k.type === "wheel" && k.ctrlKey)
      return !s.current.allowPinchZoom;
    var M = co(k), w = a.current, x = "deltaX" in k ? k.deltaX : w[0] - M[0], C = "deltaY" in k ? k.deltaY : w[1] - M[1], L, N = k.target, j = Math.abs(x) > Math.abs(C) ? "h" : "v";
    if ("touches" in k && j === "h" && N.type === "range")
      return !1;
    var A = Vf(j, N);
    if (!A)
      return !0;
    if (A ? L = j : (L = j === "v" ? "h" : "v", A = Vf(j, N)), !A)
      return !1;
    if (!n.current && "changedTouches" in k && (x || C) && (n.current = L), !L)
      return !0;
    var D = n.current || L;
    return n9e(D, g, k, D === "h" ? x : C);
  }, []), f = p.useCallback(function(k) {
    var g = k;
    if (!(!aa.length || aa[aa.length - 1] !== i)) {
      var M = "deltaY" in g ? Of(g) : co(g), w = t.current.filter(function(L) {
        return L.name === g.type && (L.target === g.target || g.target === L.shadowParent) && o9e(L.delta, M);
      })[0];
      if (w && w.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!w) {
        var x = (s.current.shards || []).map(qf).filter(Boolean).filter(function(L) {
          return L.contains(g.target);
        }), C = x.length > 0 ? c(g, x[0]) : !s.current.noIsolation;
        C && g.cancelable && g.preventDefault();
      }
    }
  }, []), d = p.useCallback(function(k, g, M, w) {
    var x = { name: k, delta: g, target: M, should: w, shadowParent: c9e(M) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== x;
      });
    }, 1);
  }, []), u = p.useCallback(function(k) {
    a.current = co(k), n.current = void 0;
  }, []), h = p.useCallback(function(k) {
    d(k.type, Of(k), k.target, c(k, e.lockRef.current));
  }, []), y = p.useCallback(function(k) {
    d(k.type, co(k), k.target, c(k, e.lockRef.current));
  }, []);
  p.useEffect(function() {
    return aa.push(i), e.setCallbacks({
      onScrollCapture: h,
      onWheelCapture: h,
      onTouchMoveCapture: y
    }), document.addEventListener("wheel", f, ta), document.addEventListener("touchmove", f, ta), document.addEventListener("touchstart", u, ta), function() {
      aa = aa.filter(function(k) {
        return k !== i;
      }), document.removeEventListener("wheel", f, ta), document.removeEventListener("touchmove", f, ta), document.removeEventListener("touchstart", u, ta);
    };
  }, []);
  var m = e.removeScrollBar, v = e.inert;
  return p.createElement(
    p.Fragment,
    null,
    v ? p.createElement(i, { styles: r9e(o) }) : null,
    m ? p.createElement(Q8e, { gapMode: e.gapMode }) : null
  );
}
function c9e(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const f9e = R8e(B4, s9e);
var jr = p.forwardRef(function(e, t) {
  return p.createElement(Lr, Bt({}, e, { ref: t, sideCar: f9e }));
});
jr.classNames = Lr.classNames;
var d9e = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, na = /* @__PURE__ */ new WeakMap(), fo = /* @__PURE__ */ new WeakMap(), lo = {}, N2 = 0, U4 = function(e) {
  return e && (e.host || U4(e.parentNode));
}, l9e = function(e, t) {
  return t.map(function(a) {
    if (e.contains(a))
      return a;
    var n = U4(a);
    return n && e.contains(n) ? n : (console.error("aria-hidden", a, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(a) {
    return !!a;
  });
}, u9e = function(e, t, a, n) {
  var o = l9e(t, Array.isArray(e) ? e : [e]);
  lo[a] || (lo[a] = /* @__PURE__ */ new WeakMap());
  var i = lo[a], s = [], c = /* @__PURE__ */ new Set(), f = new Set(o), d = function(h) {
    !h || c.has(h) || (c.add(h), d(h.parentNode));
  };
  o.forEach(d);
  var u = function(h) {
    !h || f.has(h) || Array.prototype.forEach.call(h.children, function(y) {
      if (c.has(y))
        u(y);
      else
        try {
          var m = y.getAttribute(n), v = m !== null && m !== "false", k = (na.get(y) || 0) + 1, g = (i.get(y) || 0) + 1;
          na.set(y, k), i.set(y, g), s.push(y), k === 1 && v && fo.set(y, !0), g === 1 && y.setAttribute(a, "true"), v || y.setAttribute(n, "true");
        } catch (M) {
          console.error("aria-hidden: cannot operate on ", y, M);
        }
    });
  };
  return u(t), c.clear(), N2++, function() {
    s.forEach(function(h) {
      var y = na.get(h) - 1, m = i.get(h) - 1;
      na.set(h, y), i.set(h, m), y || (fo.has(h) || h.removeAttribute(n), fo.delete(h)), m || h.removeAttribute(a);
    }), N2--, N2 || (na = /* @__PURE__ */ new WeakMap(), na = /* @__PURE__ */ new WeakMap(), fo = /* @__PURE__ */ new WeakMap(), lo = {});
  };
}, J0 = function(e, t, a) {
  a === void 0 && (a = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), o = d9e(e);
  return o ? (n.push.apply(n, Array.from(o.querySelectorAll("[aria-live]"))), u9e(n, o, a, "aria-hidden")) : function() {
    return null;
  };
}, K0 = "Dialog", [W4, Uwe] = at(K0), [h9e, Rt] = W4(K0), Y4 = (e) => {
  const {
    __scopeDialog: t,
    children: a,
    open: n,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !0
  } = e, c = p.useRef(null), f = p.useRef(null), [d = !1, u] = ft({
    prop: n,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ l.jsx(
    h9e,
    {
      scope: t,
      triggerRef: c,
      contentRef: f,
      contentId: $e(),
      titleId: $e(),
      descriptionId: $e(),
      open: d,
      onOpenChange: u,
      onOpenToggle: p.useCallback(() => u((h) => !h), [u]),
      modal: s,
      children: a
    }
  );
};
Y4.displayName = K0;
var Q4 = "DialogTrigger", J4 = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...n } = e, o = Rt(Q4, a), i = ye(t, o.triggerRef);
    return /* @__PURE__ */ l.jsx(
      Y.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": ts(o.open),
        ...n,
        ref: i,
        onClick: F(e.onClick, o.onOpenToggle)
      }
    );
  }
);
J4.displayName = Q4;
var X0 = "DialogPortal", [p9e, K4] = W4(X0, {
  forceMount: void 0
}), X4 = (e) => {
  const { __scopeDialog: t, forceMount: a, children: n, container: o } = e, i = Rt(X0, t);
  return /* @__PURE__ */ l.jsx(p9e, { scope: t, forceMount: a, children: p.Children.map(n, (s) => /* @__PURE__ */ l.jsx(mt, { present: a || i.open, children: /* @__PURE__ */ l.jsx(Sa, { asChild: !0, container: o, children: s }) })) });
};
X4.displayName = X0;
var Go = "DialogOverlay", eh = p.forwardRef(
  (e, t) => {
    const a = K4(Go, e.__scopeDialog), { forceMount: n = a.forceMount, ...o } = e, i = Rt(Go, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ l.jsx(mt, { present: n || i.open, children: /* @__PURE__ */ l.jsx(y9e, { ...o, ref: t }) }) : null;
  }
);
eh.displayName = Go;
var y9e = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...n } = e, o = Rt(Go, a);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ l.jsx(jr, { as: c1, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ l.jsx(
        Y.div,
        {
          "data-state": ts(o.open),
          ...n,
          ref: t,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), O1 = "DialogContent", th = p.forwardRef(
  (e, t) => {
    const a = K4(O1, e.__scopeDialog), { forceMount: n = a.forceMount, ...o } = e, i = Rt(O1, e.__scopeDialog);
    return /* @__PURE__ */ l.jsx(mt, { present: n || i.open, children: i.modal ? /* @__PURE__ */ l.jsx(m9e, { ...o, ref: t }) : /* @__PURE__ */ l.jsx(k9e, { ...o, ref: t }) });
  }
);
th.displayName = O1;
var m9e = p.forwardRef(
  (e, t) => {
    const a = Rt(O1, e.__scopeDialog), n = p.useRef(null), o = ye(t, a.contentRef, n);
    return p.useEffect(() => {
      const i = n.current;
      if (i) return J0(i);
    }, []), /* @__PURE__ */ l.jsx(
      ah,
      {
        ...e,
        ref: o,
        trapFocus: a.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: F(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), (s = a.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: F(e.onPointerDownOutside, (i) => {
          const s = i.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || c) && i.preventDefault();
        }),
        onFocusOutside: F(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), k9e = p.forwardRef(
  (e, t) => {
    const a = Rt(O1, e.__scopeDialog), n = p.useRef(!1), o = p.useRef(!1);
    return /* @__PURE__ */ l.jsx(
      ah,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var s, c;
          (s = e.onCloseAutoFocus) == null || s.call(e, i), i.defaultPrevented || (n.current || (c = a.triggerRef.current) == null || c.focus(), i.preventDefault()), n.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var f, d;
          (f = e.onInteractOutside) == null || f.call(e, i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = i.target;
          ((d = a.triggerRef.current) == null ? void 0 : d.contains(s)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), ah = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, trapFocus: n, onOpenAutoFocus: o, onCloseAutoFocus: i, ...s } = e, c = Rt(O1, a), f = p.useRef(null), d = ye(t, f);
    return Q0(), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        $1,
        {
          asChild: !0,
          loop: !0,
          trapped: n,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ l.jsx(
            F1,
            {
              role: "dialog",
              id: c.contentId,
              "aria-describedby": c.descriptionId,
              "aria-labelledby": c.titleId,
              "data-state": ts(c.open),
              ...s,
              ref: d,
              onDismiss: () => c.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
        /* @__PURE__ */ l.jsx(g9e, { titleId: c.titleId }),
        /* @__PURE__ */ l.jsx(M9e, { contentRef: f, descriptionId: c.descriptionId })
      ] })
    ] });
  }
), es = "DialogTitle", nh = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...n } = e, o = Rt(es, a);
    return /* @__PURE__ */ l.jsx(Y.h2, { id: o.titleId, ...n, ref: t });
  }
);
nh.displayName = es;
var oh = "DialogDescription", rh = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...n } = e, o = Rt(oh, a);
    return /* @__PURE__ */ l.jsx(Y.p, { id: o.descriptionId, ...n, ref: t });
  }
);
rh.displayName = oh;
var ih = "DialogClose", sh = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...n } = e, o = Rt(ih, a);
    return /* @__PURE__ */ l.jsx(
      Y.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: F(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
sh.displayName = ih;
function ts(e) {
  return e ? "open" : "closed";
}
var ch = "DialogTitleWarning", [Wwe, fh] = e4e(ch, {
  contentName: O1,
  titleName: es,
  docsSlug: "dialog"
}), g9e = ({ titleId: e }) => {
  const t = fh(ch), a = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return p.useEffect(() => {
    e && (document.getElementById(e) || console.error(a));
  }, [a, e]), null;
}, v9e = "DialogDescriptionWarning", M9e = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${fh(v9e).contentName}}.`;
  return p.useEffect(() => {
    var i;
    const o = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
}, Nr = Y4, as = J4, Ar = X4, Da = eh, _a = th, Hn = nh, Vn = rh, Sr = sh, A2, ns = "HoverCard", [dh, Ywe] = at(ns, [
  k1
]), Ir = k1(), [w9e, os] = dh(ns), lh = (e) => {
  const {
    __scopeHoverCard: t,
    children: a,
    open: n,
    defaultOpen: o,
    onOpenChange: i,
    openDelay: s = 700,
    closeDelay: c = 300
  } = e, f = Ir(t), d = p.useRef(0), u = p.useRef(0), h = p.useRef(!1), y = p.useRef(!1), [m = !1, v] = ft({
    prop: n,
    defaultProp: o,
    onChange: i
  }), k = p.useCallback(() => {
    clearTimeout(u.current), d.current = window.setTimeout(() => v(!0), s);
  }, [s, v]), g = p.useCallback(() => {
    clearTimeout(d.current), !h.current && !y.current && (u.current = window.setTimeout(() => v(!1), c));
  }, [c, v]), M = p.useCallback(() => v(!1), [v]);
  return p.useEffect(() => () => {
    clearTimeout(d.current), clearTimeout(u.current);
  }, []), /* @__PURE__ */ l.jsx(
    w9e,
    {
      scope: t,
      open: m,
      onOpenChange: v,
      onOpen: k,
      onClose: g,
      onDismiss: M,
      hasSelectionRef: h,
      isPointerDownOnContentRef: y,
      children: /* @__PURE__ */ l.jsx(ir, { ...f, children: a })
    }
  );
};
lh.displayName = ns;
var uh = "HoverCardTrigger", hh = p.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: a, ...n } = e, o = os(uh, a), i = Ir(a);
    return /* @__PURE__ */ l.jsx(In, { asChild: !0, ...i, children: /* @__PURE__ */ l.jsx(
      Y.a,
      {
        "data-state": o.open ? "open" : "closed",
        ...n,
        ref: t,
        onPointerEnter: F(e.onPointerEnter, Uo(o.onOpen)),
        onPointerLeave: F(e.onPointerLeave, Uo(o.onClose)),
        onFocus: F(e.onFocus, o.onOpen),
        onBlur: F(e.onBlur, o.onClose),
        onTouchStart: F(e.onTouchStart, (s) => s.preventDefault())
      }
    ) });
  }
);
hh.displayName = uh;
var x9e = "HoverCardPortal", [Qwe, C9e] = dh(x9e, {
  forceMount: void 0
}), $o = "HoverCardContent", ph = p.forwardRef(
  (e, t) => {
    const a = C9e($o, e.__scopeHoverCard), { forceMount: n = a.forceMount, ...o } = e, i = os($o, e.__scopeHoverCard);
    return /* @__PURE__ */ l.jsx(mt, { present: n || i.open, children: /* @__PURE__ */ l.jsx(
      b9e,
      {
        "data-state": i.open ? "open" : "closed",
        ...o,
        onPointerEnter: F(e.onPointerEnter, Uo(i.onOpen)),
        onPointerLeave: F(e.onPointerLeave, Uo(i.onClose)),
        ref: t
      }
    ) });
  }
);
ph.displayName = $o;
var b9e = p.forwardRef((e, t) => {
  const {
    __scopeHoverCard: a,
    onEscapeKeyDown: n,
    onPointerDownOutside: o,
    onFocusOutside: i,
    onInteractOutside: s,
    ...c
  } = e, f = os($o, a), d = Ir(a), u = p.useRef(null), h = ye(t, u), [y, m] = p.useState(!1);
  return p.useEffect(() => {
    if (y) {
      const v = document.body;
      return A2 = v.style.userSelect || v.style.webkitUserSelect, v.style.userSelect = "none", v.style.webkitUserSelect = "none", () => {
        v.style.userSelect = A2, v.style.webkitUserSelect = A2;
      };
    }
  }, [y]), p.useEffect(() => {
    if (u.current) {
      const v = () => {
        m(!1), f.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          var g;
          ((g = document.getSelection()) == null ? void 0 : g.toString()) !== "" && (f.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", v), () => {
        document.removeEventListener("pointerup", v), f.hasSelectionRef.current = !1, f.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [f.isPointerDownOnContentRef, f.hasSelectionRef]), p.useEffect(() => {
    u.current && N9e(u.current).forEach((k) => k.setAttribute("tabindex", "-1"));
  }), /* @__PURE__ */ l.jsx(
    F1,
    {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onInteractOutside: s,
      onEscapeKeyDown: n,
      onPointerDownOutside: o,
      onFocusOutside: F(i, (v) => {
        v.preventDefault();
      }),
      onDismiss: f.onDismiss,
      children: /* @__PURE__ */ l.jsx(
        sr,
        {
          ...d,
          ...c,
          onPointerDown: F(c.onPointerDown, (v) => {
            v.currentTarget.contains(v.target) && m(!0), f.hasSelectionRef.current = !1, f.isPointerDownOnContentRef.current = !0;
          }),
          ref: h,
          style: {
            ...c.style,
            userSelect: y ? "text" : void 0,
            // Safari requires prefix
            WebkitUserSelect: y ? "text" : void 0,
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      )
    }
  );
}), L9e = "HoverCardArrow", j9e = p.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: a, ...n } = e, o = Ir(a);
    return /* @__PURE__ */ l.jsx(cr, { ...o, ...n, ref: t });
  }
);
j9e.displayName = L9e;
function Uo(e) {
  return (t) => t.pointerType === "touch" ? void 0 : e();
}
function N9e(e) {
  const t = [], a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; a.nextNode(); ) t.push(a.currentNode);
  return t;
}
var A9e = lh, S9e = hh, yh = ph, rs = "Popover", [mh, Jwe] = at(rs, [
  k1
]), On = k1(), [I9e, v1] = mh(rs), kh = (e) => {
  const {
    __scopePopover: t,
    children: a,
    open: n,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !1
  } = e, c = On(t), f = p.useRef(null), [d, u] = p.useState(!1), [h = !1, y] = ft({
    prop: n,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ l.jsx(ir, { ...c, children: /* @__PURE__ */ l.jsx(
    I9e,
    {
      scope: t,
      contentId: $e(),
      triggerRef: f,
      open: h,
      onOpenChange: y,
      onOpenToggle: p.useCallback(() => y((m) => !m), [y]),
      hasCustomAnchor: d,
      onCustomAnchorAdd: p.useCallback(() => u(!0), []),
      onCustomAnchorRemove: p.useCallback(() => u(!1), []),
      modal: s,
      children: a
    }
  ) });
};
kh.displayName = rs;
var gh = "PopoverAnchor", vh = p.forwardRef(
  (e, t) => {
    const { __scopePopover: a, ...n } = e, o = v1(gh, a), i = On(a), { onCustomAnchorAdd: s, onCustomAnchorRemove: c } = o;
    return p.useEffect(() => (s(), () => c()), [s, c]), /* @__PURE__ */ l.jsx(In, { ...i, ...n, ref: t });
  }
);
vh.displayName = gh;
var Mh = "PopoverTrigger", wh = p.forwardRef(
  (e, t) => {
    const { __scopePopover: a, ...n } = e, o = v1(Mh, a), i = On(a), s = ye(t, o.triggerRef), c = /* @__PURE__ */ l.jsx(
      Y.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Nh(o.open),
        ...n,
        ref: s,
        onClick: F(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? c : /* @__PURE__ */ l.jsx(In, { asChild: !0, ...i, children: c });
  }
);
wh.displayName = Mh;
var is = "PopoverPortal", [T9e, z9e] = mh(is, {
  forceMount: void 0
}), xh = (e) => {
  const { __scopePopover: t, forceMount: a, children: n, container: o } = e, i = v1(is, t);
  return /* @__PURE__ */ l.jsx(T9e, { scope: t, forceMount: a, children: /* @__PURE__ */ l.jsx(mt, { present: a || i.open, children: /* @__PURE__ */ l.jsx(Sa, { asChild: !0, container: o, children: n }) }) });
};
xh.displayName = is;
var xa = "PopoverContent", Ch = p.forwardRef(
  (e, t) => {
    const a = z9e(xa, e.__scopePopover), { forceMount: n = a.forceMount, ...o } = e, i = v1(xa, e.__scopePopover);
    return /* @__PURE__ */ l.jsx(mt, { present: n || i.open, children: i.modal ? /* @__PURE__ */ l.jsx(D9e, { ...o, ref: t }) : /* @__PURE__ */ l.jsx(_9e, { ...o, ref: t }) });
  }
);
Ch.displayName = xa;
var D9e = p.forwardRef(
  (e, t) => {
    const a = v1(xa, e.__scopePopover), n = p.useRef(null), o = ye(t, n), i = p.useRef(!1);
    return p.useEffect(() => {
      const s = n.current;
      if (s) return J0(s);
    }, []), /* @__PURE__ */ l.jsx(jr, { as: c1, allowPinchZoom: !0, children: /* @__PURE__ */ l.jsx(
      bh,
      {
        ...e,
        ref: o,
        trapFocus: a.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: F(e.onCloseAutoFocus, (s) => {
          var c;
          s.preventDefault(), i.current || (c = a.triggerRef.current) == null || c.focus();
        }),
        onPointerDownOutside: F(
          e.onPointerDownOutside,
          (s) => {
            const c = s.detail.originalEvent, f = c.button === 0 && c.ctrlKey === !0, d = c.button === 2 || f;
            i.current = d;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: F(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), _9e = p.forwardRef(
  (e, t) => {
    const a = v1(xa, e.__scopePopover), n = p.useRef(!1), o = p.useRef(!1);
    return /* @__PURE__ */ l.jsx(
      bh,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var s, c;
          (s = e.onCloseAutoFocus) == null || s.call(e, i), i.defaultPrevented || (n.current || (c = a.triggerRef.current) == null || c.focus(), i.preventDefault()), n.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var f, d;
          (f = e.onInteractOutside) == null || f.call(e, i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = i.target;
          ((d = a.triggerRef.current) == null ? void 0 : d.contains(s)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), bh = p.forwardRef(
  (e, t) => {
    const {
      __scopePopover: a,
      trapFocus: n,
      onOpenAutoFocus: o,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: c,
      onPointerDownOutside: f,
      onFocusOutside: d,
      onInteractOutside: u,
      ...h
    } = e, y = v1(xa, a), m = On(a);
    return Q0(), /* @__PURE__ */ l.jsx(
      $1,
      {
        asChild: !0,
        loop: !0,
        trapped: n,
        onMountAutoFocus: o,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ l.jsx(
          F1,
          {
            asChild: !0,
            disableOutsidePointerEvents: s,
            onInteractOutside: u,
            onEscapeKeyDown: c,
            onPointerDownOutside: f,
            onFocusOutside: d,
            onDismiss: () => y.onOpenChange(!1),
            children: /* @__PURE__ */ l.jsx(
              sr,
              {
                "data-state": Nh(y.open),
                role: "dialog",
                id: y.contentId,
                ...m,
                ...h,
                ref: t,
                style: {
                  ...h.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Lh = "PopoverClose", jh = p.forwardRef(
  (e, t) => {
    const { __scopePopover: a, ...n } = e, o = v1(Lh, a);
    return /* @__PURE__ */ l.jsx(
      Y.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: F(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
jh.displayName = Lh;
var P9e = "PopoverArrow", E9e = p.forwardRef(
  (e, t) => {
    const { __scopePopover: a, ...n } = e, o = On(a);
    return /* @__PURE__ */ l.jsx(cr, { ...o, ...n, ref: t });
  }
);
E9e.displayName = P9e;
function Nh(e) {
  return e ? "open" : "closed";
}
var R9e = kh, H9e = vh, V9e = wh, O9e = xh, Ah = Ch, q9e = jh, ss = "Radio", [B9e, Sh] = at(ss), [Z9e, F9e] = B9e(ss), Ih = p.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: a,
      name: n,
      checked: o = !1,
      required: i,
      disabled: s,
      value: c = "on",
      onCheck: f,
      form: d,
      ...u
    } = e, [h, y] = p.useState(null), m = ye(t, (g) => y(g)), v = p.useRef(!1), k = h ? d || !!h.closest("form") : !0;
    return /* @__PURE__ */ l.jsxs(Z9e, { scope: a, checked: o, disabled: s, children: [
      /* @__PURE__ */ l.jsx(
        Y.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": Dh(o),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: c,
          ...u,
          ref: m,
          onClick: F(e.onClick, (g) => {
            o || f == null || f(), k && (v.current = g.isPropagationStopped(), v.current || g.stopPropagation());
          })
        }
      ),
      k && /* @__PURE__ */ l.jsx(
        G9e,
        {
          control: h,
          bubbles: !v.current,
          name: n,
          value: c,
          checked: o,
          required: i,
          disabled: s,
          form: d,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Ih.displayName = ss;
var Th = "RadioIndicator", zh = p.forwardRef(
  (e, t) => {
    const { __scopeRadio: a, forceMount: n, ...o } = e, i = F9e(Th, a);
    return /* @__PURE__ */ l.jsx(mt, { present: n || i.checked, children: /* @__PURE__ */ l.jsx(
      Y.span,
      {
        "data-state": Dh(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    ) });
  }
);
zh.displayName = Th;
var G9e = (e) => {
  const { control: t, checked: a, bubbles: n = !0, ...o } = e, i = p.useRef(null), s = $i(a), c = Ui(t);
  return p.useEffect(() => {
    const f = i.current, d = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(d, "checked").set;
    if (s !== a && h) {
      const y = new Event("click", { bubbles: n });
      h.call(f, a), f.dispatchEvent(y);
    }
  }, [s, a, n]), /* @__PURE__ */ l.jsx(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: a,
      ...o,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...c,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Dh(e) {
  return e ? "checked" : "unchecked";
}
var $9e = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], cs = "RadioGroup", [U9e, Kwe] = at(cs, [
  wr,
  Sh
]), _h = wr(), Ph = Sh(), [W9e, Y9e] = U9e(cs), Eh = p.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: a,
      name: n,
      defaultValue: o,
      value: i,
      required: s = !1,
      disabled: c = !1,
      orientation: f,
      dir: d,
      loop: u = !0,
      onValueChange: h,
      ...y
    } = e, m = _h(a), v = Rn(d), [k, g] = ft({
      prop: i,
      defaultProp: o,
      onChange: h
    });
    return /* @__PURE__ */ l.jsx(
      W9e,
      {
        scope: a,
        name: n,
        required: s,
        disabled: c,
        value: k,
        onValueChange: g,
        children: /* @__PURE__ */ l.jsx(
          o4,
          {
            asChild: !0,
            ...m,
            orientation: f,
            dir: v,
            loop: u,
            children: /* @__PURE__ */ l.jsx(
              Y.div,
              {
                role: "radiogroup",
                "aria-required": s,
                "aria-orientation": f,
                "data-disabled": c ? "" : void 0,
                dir: v,
                ...y,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
Eh.displayName = cs;
var Rh = "RadioGroupItem", Hh = p.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: a, disabled: n, ...o } = e, i = Y9e(Rh, a), s = i.disabled || n, c = _h(a), f = Ph(a), d = p.useRef(null), u = ye(t, d), h = i.value === o.value, y = p.useRef(!1);
    return p.useEffect(() => {
      const m = (k) => {
        $9e.includes(k.key) && (y.current = !0);
      }, v = () => y.current = !1;
      return document.addEventListener("keydown", m), document.addEventListener("keyup", v), () => {
        document.removeEventListener("keydown", m), document.removeEventListener("keyup", v);
      };
    }, []), /* @__PURE__ */ l.jsx(
      r4,
      {
        asChild: !0,
        ...c,
        focusable: !s,
        active: h,
        children: /* @__PURE__ */ l.jsx(
          Ih,
          {
            disabled: s,
            required: i.required,
            checked: h,
            ...f,
            ...o,
            name: i.name,
            ref: u,
            onCheck: () => i.onValueChange(o.value),
            onKeyDown: F((m) => {
              m.key === "Enter" && m.preventDefault();
            }),
            onFocus: F(o.onFocus, () => {
              var m;
              y.current && ((m = d.current) == null || m.click());
            })
          }
        )
      }
    );
  }
);
Hh.displayName = Rh;
var Q9e = "RadioGroupIndicator", Vh = p.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: a, ...n } = e, o = Ph(a);
    return /* @__PURE__ */ l.jsx(zh, { ...o, ...n, ref: t });
  }
);
Vh.displayName = Q9e;
var Oh = Eh, qh = Hh, J9e = Vh;
function Bf(e, [t, a]) {
  return Math.min(a, Math.max(t, e));
}
var K9e = [" ", "Enter", "ArrowUp", "ArrowDown"], X9e = [" ", "Enter"], qn = "Select", [Tr, zr, e7e] = vr(qn), [Pa, Xwe] = at(qn, [
  e7e,
  k1
]), Dr = k1(), [t7e, M1] = Pa(qn), [a7e, n7e] = Pa(qn), Bh = (e) => {
  const {
    __scopeSelect: t,
    children: a,
    open: n,
    defaultOpen: o,
    onOpenChange: i,
    value: s,
    defaultValue: c,
    onValueChange: f,
    dir: d,
    name: u,
    autoComplete: h,
    disabled: y,
    required: m,
    form: v
  } = e, k = Dr(t), [g, M] = p.useState(null), [w, x] = p.useState(null), [C, L] = p.useState(!1), N = Rn(d), [j = !1, A] = ft({
    prop: n,
    defaultProp: o,
    onChange: i
  }), [D, H] = ft({
    prop: s,
    defaultProp: c,
    onChange: f
  }), Z = p.useRef(null), R = g ? v || !!g.closest("form") : !0, [_, T] = p.useState(/* @__PURE__ */ new Set()), G = Array.from(_).map((q) => q.props.value).join(";");
  return /* @__PURE__ */ l.jsx(ir, { ...k, children: /* @__PURE__ */ l.jsxs(
    t7e,
    {
      required: m,
      scope: t,
      trigger: g,
      onTriggerChange: M,
      valueNode: w,
      onValueNodeChange: x,
      valueNodeHasChildren: C,
      onValueNodeHasChildrenChange: L,
      contentId: $e(),
      value: D,
      onValueChange: H,
      open: j,
      onOpenChange: A,
      dir: N,
      triggerPointerDownPosRef: Z,
      disabled: y,
      children: [
        /* @__PURE__ */ l.jsx(Tr.Provider, { scope: t, children: /* @__PURE__ */ l.jsx(
          a7e,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: p.useCallback((q) => {
              T((V) => new Set(V).add(q));
            }, []),
            onNativeOptionRemove: p.useCallback((q) => {
              T((V) => {
                const B = new Set(V);
                return B.delete(q), B;
              });
            }, []),
            children: a
          }
        ) }),
        R ? /* @__PURE__ */ l.jsxs(
          p3,
          {
            "aria-hidden": !0,
            required: m,
            tabIndex: -1,
            name: u,
            autoComplete: h,
            value: D,
            onChange: (q) => H(q.target.value),
            disabled: y,
            form: v,
            children: [
              D === void 0 ? /* @__PURE__ */ l.jsx("option", { value: "" }) : null,
              Array.from(_)
            ]
          },
          G
        ) : null
      ]
    }
  ) });
};
Bh.displayName = qn;
var Zh = "SelectTrigger", Fh = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, disabled: n = !1, ...o } = e, i = Dr(a), s = M1(Zh, a), c = s.disabled || n, f = ye(t, s.onTriggerChange), d = zr(a), u = p.useRef("touch"), [h, y, m] = y3((k) => {
      const g = d().filter((x) => !x.disabled), M = g.find((x) => x.value === s.value), w = m3(g, k, M);
      w !== void 0 && s.onValueChange(w.value);
    }), v = (k) => {
      c || (s.onOpenChange(!0), m()), k && (s.triggerPointerDownPosRef.current = {
        x: Math.round(k.pageX),
        y: Math.round(k.pageY)
      });
    };
    return /* @__PURE__ */ l.jsx(In, { asChild: !0, ...i, children: /* @__PURE__ */ l.jsx(
      Y.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": s.contentId,
        "aria-expanded": s.open,
        "aria-required": s.required,
        "aria-autocomplete": "none",
        dir: s.dir,
        "data-state": s.open ? "open" : "closed",
        disabled: c,
        "data-disabled": c ? "" : void 0,
        "data-placeholder": h3(s.value) ? "" : void 0,
        ...o,
        ref: f,
        onClick: F(o.onClick, (k) => {
          k.currentTarget.focus(), u.current !== "mouse" && v(k);
        }),
        onPointerDown: F(o.onPointerDown, (k) => {
          u.current = k.pointerType;
          const g = k.target;
          g.hasPointerCapture(k.pointerId) && g.releasePointerCapture(k.pointerId), k.button === 0 && k.ctrlKey === !1 && k.pointerType === "mouse" && (v(k), k.preventDefault());
        }),
        onKeyDown: F(o.onKeyDown, (k) => {
          const g = h.current !== "";
          !(k.ctrlKey || k.altKey || k.metaKey) && k.key.length === 1 && y(k.key), !(g && k.key === " ") && K9e.includes(k.key) && (v(), k.preventDefault());
        })
      }
    ) });
  }
);
Fh.displayName = Zh;
var Gh = "SelectValue", $h = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, className: n, style: o, children: i, placeholder: s = "", ...c } = e, f = M1(Gh, a), { onValueNodeHasChildrenChange: d } = f, u = i !== void 0, h = ye(t, f.onValueNodeChange);
    return We(() => {
      d(u);
    }, [d, u]), /* @__PURE__ */ l.jsx(
      Y.span,
      {
        ...c,
        ref: h,
        style: { pointerEvents: "none" },
        children: h3(f.value) ? /* @__PURE__ */ l.jsx(l.Fragment, { children: s }) : i
      }
    );
  }
);
$h.displayName = Gh;
var o7e = "SelectIcon", Uh = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, children: n, ...o } = e;
    return /* @__PURE__ */ l.jsx(Y.span, { "aria-hidden": !0, ...o, ref: t, children: n || "▼" });
  }
);
Uh.displayName = o7e;
var r7e = "SelectPortal", Wh = (e) => /* @__PURE__ */ l.jsx(Sa, { asChild: !0, ...e });
Wh.displayName = r7e;
var q1 = "SelectContent", Yh = p.forwardRef(
  (e, t) => {
    const a = M1(q1, e.__scopeSelect), [n, o] = p.useState();
    if (We(() => {
      o(new DocumentFragment());
    }, []), !a.open) {
      const i = n;
      return i ? An.createPortal(
        /* @__PURE__ */ l.jsx(Qh, { scope: e.__scopeSelect, children: /* @__PURE__ */ l.jsx(Tr.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ l.jsx("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ l.jsx(Jh, { ...e, ref: t });
  }
);
Yh.displayName = q1;
var It = 10, [Qh, w1] = Pa(q1), i7e = "SelectContentImpl", Jh = p.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: a,
      position: n = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: i,
      onPointerDownOutside: s,
      //
      // PopperContent props
      side: c,
      sideOffset: f,
      align: d,
      alignOffset: u,
      arrowPadding: h,
      collisionBoundary: y,
      collisionPadding: m,
      sticky: v,
      hideWhenDetached: k,
      avoidCollisions: g,
      //
      ...M
    } = e, w = M1(q1, a), [x, C] = p.useState(null), [L, N] = p.useState(null), j = ye(t, (O) => C(O)), [A, D] = p.useState(null), [H, Z] = p.useState(
      null
    ), R = zr(a), [_, T] = p.useState(!1), G = p.useRef(!1);
    p.useEffect(() => {
      if (x) return J0(x);
    }, [x]), Q0();
    const q = p.useCallback(
      (O) => {
        const [X, ...re] = R().map((ke) => ke.ref.current), [ie] = re.slice(-1), fe = document.activeElement;
        for (const ke of O)
          if (ke === fe || (ke == null || ke.scrollIntoView({ block: "nearest" }), ke === X && L && (L.scrollTop = 0), ke === ie && L && (L.scrollTop = L.scrollHeight), ke == null || ke.focus(), document.activeElement !== fe)) return;
      },
      [R, L]
    ), V = p.useCallback(
      () => q([A, x]),
      [q, A, x]
    );
    p.useEffect(() => {
      _ && V();
    }, [_, V]);
    const { onOpenChange: B, triggerPointerDownPosRef: Q } = w;
    p.useEffect(() => {
      if (x) {
        let O = { x: 0, y: 0 };
        const X = (ie) => {
          var fe, ke;
          O = {
            x: Math.abs(Math.round(ie.pageX) - (((fe = Q.current) == null ? void 0 : fe.x) ?? 0)),
            y: Math.abs(Math.round(ie.pageY) - (((ke = Q.current) == null ? void 0 : ke.y) ?? 0))
          };
        }, re = (ie) => {
          O.x <= 10 && O.y <= 10 ? ie.preventDefault() : x.contains(ie.target) || B(!1), document.removeEventListener("pointermove", X), Q.current = null;
        };
        return Q.current !== null && (document.addEventListener("pointermove", X), document.addEventListener("pointerup", re, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", X), document.removeEventListener("pointerup", re, { capture: !0 });
        };
      }
    }, [x, B, Q]), p.useEffect(() => {
      const O = () => B(!1);
      return window.addEventListener("blur", O), window.addEventListener("resize", O), () => {
        window.removeEventListener("blur", O), window.removeEventListener("resize", O);
      };
    }, [B]);
    const [me, be] = y3((O) => {
      const X = R().filter((fe) => !fe.disabled), re = X.find((fe) => fe.ref.current === document.activeElement), ie = m3(X, O, re);
      ie && setTimeout(() => ie.ref.current.focus());
    }), z = p.useCallback(
      (O, X, re) => {
        const ie = !G.current && !re;
        (w.value !== void 0 && w.value === X || ie) && (D(O), ie && (G.current = !0));
      },
      [w.value]
    ), W = p.useCallback(() => x == null ? void 0 : x.focus(), [x]), K = p.useCallback(
      (O, X, re) => {
        const ie = !G.current && !re;
        (w.value !== void 0 && w.value === X || ie) && Z(O);
      },
      [w.value]
    ), U = n === "popper" ? Ci : Kh, ne = U === Ci ? {
      side: c,
      sideOffset: f,
      align: d,
      alignOffset: u,
      arrowPadding: h,
      collisionBoundary: y,
      collisionPadding: m,
      sticky: v,
      hideWhenDetached: k,
      avoidCollisions: g
    } : {};
    return /* @__PURE__ */ l.jsx(
      Qh,
      {
        scope: a,
        content: x,
        viewport: L,
        onViewportChange: N,
        itemRefCallback: z,
        selectedItem: A,
        onItemLeave: W,
        itemTextRefCallback: K,
        focusSelectedItem: V,
        selectedItemText: H,
        position: n,
        isPositioned: _,
        searchRef: me,
        children: /* @__PURE__ */ l.jsx(jr, { as: c1, allowPinchZoom: !0, children: /* @__PURE__ */ l.jsx(
          $1,
          {
            asChild: !0,
            trapped: w.open,
            onMountAutoFocus: (O) => {
              O.preventDefault();
            },
            onUnmountAutoFocus: F(o, (O) => {
              var X;
              (X = w.trigger) == null || X.focus({ preventScroll: !0 }), O.preventDefault();
            }),
            children: /* @__PURE__ */ l.jsx(
              F1,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: s,
                onFocusOutside: (O) => O.preventDefault(),
                onDismiss: () => w.onOpenChange(!1),
                children: /* @__PURE__ */ l.jsx(
                  U,
                  {
                    role: "listbox",
                    id: w.contentId,
                    "data-state": w.open ? "open" : "closed",
                    dir: w.dir,
                    onContextMenu: (O) => O.preventDefault(),
                    ...M,
                    ...ne,
                    onPlaced: () => T(!0),
                    ref: j,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...M.style
                    },
                    onKeyDown: F(M.onKeyDown, (O) => {
                      const X = O.ctrlKey || O.altKey || O.metaKey;
                      if (O.key === "Tab" && O.preventDefault(), !X && O.key.length === 1 && be(O.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(O.key)) {
                        let ie = R().filter((fe) => !fe.disabled).map((fe) => fe.ref.current);
                        if (["ArrowUp", "End"].includes(O.key) && (ie = ie.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(O.key)) {
                          const fe = O.target, ke = ie.indexOf(fe);
                          ie = ie.slice(ke + 1);
                        }
                        setTimeout(() => q(ie)), O.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Jh.displayName = i7e;
var s7e = "SelectItemAlignedPosition", Kh = p.forwardRef((e, t) => {
  const { __scopeSelect: a, onPlaced: n, ...o } = e, i = M1(q1, a), s = w1(q1, a), [c, f] = p.useState(null), [d, u] = p.useState(null), h = ye(t, (j) => u(j)), y = zr(a), m = p.useRef(!1), v = p.useRef(!0), { viewport: k, selectedItem: g, selectedItemText: M, focusSelectedItem: w } = s, x = p.useCallback(() => {
    if (i.trigger && i.valueNode && c && d && k && g && M) {
      const j = i.trigger.getBoundingClientRect(), A = d.getBoundingClientRect(), D = i.valueNode.getBoundingClientRect(), H = M.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const fe = H.left - A.left, ke = D.left - fe, Fe = j.left - ke, J = j.width + Fe, lt = Math.max(J, A.width), nt = window.innerWidth - It, gt = Bf(ke, [
          It,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(It, nt - lt)
        ]);
        c.style.minWidth = J + "px", c.style.left = gt + "px";
      } else {
        const fe = A.right - H.right, ke = window.innerWidth - D.right - fe, Fe = window.innerWidth - j.right - ke, J = j.width + Fe, lt = Math.max(J, A.width), nt = window.innerWidth - It, gt = Bf(ke, [
          It,
          Math.max(It, nt - lt)
        ]);
        c.style.minWidth = J + "px", c.style.right = gt + "px";
      }
      const Z = y(), R = window.innerHeight - It * 2, _ = k.scrollHeight, T = window.getComputedStyle(d), G = parseInt(T.borderTopWidth, 10), q = parseInt(T.paddingTop, 10), V = parseInt(T.borderBottomWidth, 10), B = parseInt(T.paddingBottom, 10), Q = G + q + _ + B + V, me = Math.min(g.offsetHeight * 5, Q), be = window.getComputedStyle(k), z = parseInt(be.paddingTop, 10), W = parseInt(be.paddingBottom, 10), K = j.top + j.height / 2 - It, U = R - K, ne = g.offsetHeight / 2, O = g.offsetTop + ne, X = G + q + O, re = Q - X;
      if (X <= K) {
        const fe = Z.length > 0 && g === Z[Z.length - 1].ref.current;
        c.style.bottom = "0px";
        const ke = d.clientHeight - k.offsetTop - k.offsetHeight, Fe = Math.max(
          U,
          ne + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (fe ? W : 0) + ke + V
        ), J = X + Fe;
        c.style.height = J + "px";
      } else {
        const fe = Z.length > 0 && g === Z[0].ref.current;
        c.style.top = "0px";
        const Fe = Math.max(
          K,
          G + k.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (fe ? z : 0) + ne
        ) + re;
        c.style.height = Fe + "px", k.scrollTop = X - K + k.offsetTop;
      }
      c.style.margin = `${It}px 0`, c.style.minHeight = me + "px", c.style.maxHeight = R + "px", n == null || n(), requestAnimationFrame(() => m.current = !0);
    }
  }, [
    y,
    i.trigger,
    i.valueNode,
    c,
    d,
    k,
    g,
    M,
    i.dir,
    n
  ]);
  We(() => x(), [x]);
  const [C, L] = p.useState();
  We(() => {
    d && L(window.getComputedStyle(d).zIndex);
  }, [d]);
  const N = p.useCallback(
    (j) => {
      j && v.current === !0 && (x(), w == null || w(), v.current = !1);
    },
    [x, w]
  );
  return /* @__PURE__ */ l.jsx(
    f7e,
    {
      scope: a,
      contentWrapper: c,
      shouldExpandOnScrollRef: m,
      onScrollButtonChange: N,
      children: /* @__PURE__ */ l.jsx(
        "div",
        {
          ref: f,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: C
          },
          children: /* @__PURE__ */ l.jsx(
            Y.div,
            {
              ...o,
              ref: h,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
Kh.displayName = s7e;
var c7e = "SelectPopperPosition", Ci = p.forwardRef((e, t) => {
  const {
    __scopeSelect: a,
    align: n = "start",
    collisionPadding: o = It,
    ...i
  } = e, s = Dr(a);
  return /* @__PURE__ */ l.jsx(
    sr,
    {
      ...s,
      ...i,
      ref: t,
      align: n,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Ci.displayName = c7e;
var [f7e, fs] = Pa(q1, {}), bi = "SelectViewport", Xh = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, nonce: n, ...o } = e, i = w1(bi, a), s = fs(bi, a), c = ye(t, i.onViewportChange), f = p.useRef(0);
    return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ l.jsx(Tr.Slot, { scope: a, children: /* @__PURE__ */ l.jsx(
        Y.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: c,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: F(o.onScroll, (d) => {
            const u = d.currentTarget, { contentWrapper: h, shouldExpandOnScrollRef: y } = s;
            if (y != null && y.current && h) {
              const m = Math.abs(f.current - u.scrollTop);
              if (m > 0) {
                const v = window.innerHeight - It * 2, k = parseFloat(h.style.minHeight), g = parseFloat(h.style.height), M = Math.max(k, g);
                if (M < v) {
                  const w = M + m, x = Math.min(v, w), C = w - x;
                  h.style.height = x + "px", h.style.bottom === "0px" && (u.scrollTop = C > 0 ? C : 0, h.style.justifyContent = "flex-end");
                }
              }
            }
            f.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Xh.displayName = bi;
var e3 = "SelectGroup", [d7e, l7e] = Pa(e3), t3 = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, ...n } = e, o = $e();
    return /* @__PURE__ */ l.jsx(d7e, { scope: a, id: o, children: /* @__PURE__ */ l.jsx(Y.div, { role: "group", "aria-labelledby": o, ...n, ref: t }) });
  }
);
t3.displayName = e3;
var a3 = "SelectLabel", n3 = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, ...n } = e, o = l7e(a3, a);
    return /* @__PURE__ */ l.jsx(Y.div, { id: o.id, ...n, ref: t });
  }
);
n3.displayName = a3;
var Wo = "SelectItem", [u7e, o3] = Pa(Wo), r3 = p.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: a,
      value: n,
      disabled: o = !1,
      textValue: i,
      ...s
    } = e, c = M1(Wo, a), f = w1(Wo, a), d = c.value === n, [u, h] = p.useState(i ?? ""), [y, m] = p.useState(!1), v = ye(
      t,
      (w) => {
        var x;
        return (x = f.itemRefCallback) == null ? void 0 : x.call(f, w, n, o);
      }
    ), k = $e(), g = p.useRef("touch"), M = () => {
      o || (c.onValueChange(n), c.onOpenChange(!1));
    };
    if (n === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ l.jsx(
      u7e,
      {
        scope: a,
        value: n,
        disabled: o,
        textId: k,
        isSelected: d,
        onItemTextChange: p.useCallback((w) => {
          h((x) => x || ((w == null ? void 0 : w.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ l.jsx(
          Tr.ItemSlot,
          {
            scope: a,
            value: n,
            disabled: o,
            textValue: u,
            children: /* @__PURE__ */ l.jsx(
              Y.div,
              {
                role: "option",
                "aria-labelledby": k,
                "data-highlighted": y ? "" : void 0,
                "aria-selected": d && y,
                "data-state": d ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...s,
                ref: v,
                onFocus: F(s.onFocus, () => m(!0)),
                onBlur: F(s.onBlur, () => m(!1)),
                onClick: F(s.onClick, () => {
                  g.current !== "mouse" && M();
                }),
                onPointerUp: F(s.onPointerUp, () => {
                  g.current === "mouse" && M();
                }),
                onPointerDown: F(s.onPointerDown, (w) => {
                  g.current = w.pointerType;
                }),
                onPointerMove: F(s.onPointerMove, (w) => {
                  var x;
                  g.current = w.pointerType, o ? (x = f.onItemLeave) == null || x.call(f) : g.current === "mouse" && w.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: F(s.onPointerLeave, (w) => {
                  var x;
                  w.currentTarget === document.activeElement && ((x = f.onItemLeave) == null || x.call(f));
                }),
                onKeyDown: F(s.onKeyDown, (w) => {
                  var C;
                  ((C = f.searchRef) == null ? void 0 : C.current) !== "" && w.key === " " || (X9e.includes(w.key) && M(), w.key === " " && w.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
r3.displayName = Wo;
var nn = "SelectItemText", i3 = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, className: n, style: o, ...i } = e, s = M1(nn, a), c = w1(nn, a), f = o3(nn, a), d = n7e(nn, a), [u, h] = p.useState(null), y = ye(
      t,
      (M) => h(M),
      f.onItemTextChange,
      (M) => {
        var w;
        return (w = c.itemTextRefCallback) == null ? void 0 : w.call(c, M, f.value, f.disabled);
      }
    ), m = u == null ? void 0 : u.textContent, v = p.useMemo(
      () => /* @__PURE__ */ l.jsx("option", { value: f.value, disabled: f.disabled, children: m }, f.value),
      [f.disabled, f.value, m]
    ), { onNativeOptionAdd: k, onNativeOptionRemove: g } = d;
    return We(() => (k(v), () => g(v)), [k, g, v]), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(Y.span, { id: f.textId, ...i, ref: y }),
      f.isSelected && s.valueNode && !s.valueNodeHasChildren ? An.createPortal(i.children, s.valueNode) : null
    ] });
  }
);
i3.displayName = nn;
var s3 = "SelectItemIndicator", c3 = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, ...n } = e;
    return o3(s3, a).isSelected ? /* @__PURE__ */ l.jsx(Y.span, { "aria-hidden": !0, ...n, ref: t }) : null;
  }
);
c3.displayName = s3;
var Li = "SelectScrollUpButton", f3 = p.forwardRef((e, t) => {
  const a = w1(Li, e.__scopeSelect), n = fs(Li, e.__scopeSelect), [o, i] = p.useState(!1), s = ye(t, n.onScrollButtonChange);
  return We(() => {
    if (a.viewport && a.isPositioned) {
      let c = function() {
        const d = f.scrollTop > 0;
        i(d);
      };
      const f = a.viewport;
      return c(), f.addEventListener("scroll", c), () => f.removeEventListener("scroll", c);
    }
  }, [a.viewport, a.isPositioned]), o ? /* @__PURE__ */ l.jsx(
    l3,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: c, selectedItem: f } = a;
        c && f && (c.scrollTop = c.scrollTop - f.offsetHeight);
      }
    }
  ) : null;
});
f3.displayName = Li;
var ji = "SelectScrollDownButton", d3 = p.forwardRef((e, t) => {
  const a = w1(ji, e.__scopeSelect), n = fs(ji, e.__scopeSelect), [o, i] = p.useState(!1), s = ye(t, n.onScrollButtonChange);
  return We(() => {
    if (a.viewport && a.isPositioned) {
      let c = function() {
        const d = f.scrollHeight - f.clientHeight, u = Math.ceil(f.scrollTop) < d;
        i(u);
      };
      const f = a.viewport;
      return c(), f.addEventListener("scroll", c), () => f.removeEventListener("scroll", c);
    }
  }, [a.viewport, a.isPositioned]), o ? /* @__PURE__ */ l.jsx(
    l3,
    {
      ...e,
      ref: s,
      onAutoScroll: () => {
        const { viewport: c, selectedItem: f } = a;
        c && f && (c.scrollTop = c.scrollTop + f.offsetHeight);
      }
    }
  ) : null;
});
d3.displayName = ji;
var l3 = p.forwardRef((e, t) => {
  const { __scopeSelect: a, onAutoScroll: n, ...o } = e, i = w1("SelectScrollButton", a), s = p.useRef(null), c = zr(a), f = p.useCallback(() => {
    s.current !== null && (window.clearInterval(s.current), s.current = null);
  }, []);
  return p.useEffect(() => () => f(), [f]), We(() => {
    var u;
    const d = c().find((h) => h.ref.current === document.activeElement);
    (u = d == null ? void 0 : d.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [c]), /* @__PURE__ */ l.jsx(
    Y.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: F(o.onPointerDown, () => {
        s.current === null && (s.current = window.setInterval(n, 50));
      }),
      onPointerMove: F(o.onPointerMove, () => {
        var d;
        (d = i.onItemLeave) == null || d.call(i), s.current === null && (s.current = window.setInterval(n, 50));
      }),
      onPointerLeave: F(o.onPointerLeave, () => {
        f();
      })
    }
  );
}), h7e = "SelectSeparator", u3 = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, ...n } = e;
    return /* @__PURE__ */ l.jsx(Y.div, { "aria-hidden": !0, ...n, ref: t });
  }
);
u3.displayName = h7e;
var Ni = "SelectArrow", p7e = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, ...n } = e, o = Dr(a), i = M1(Ni, a), s = w1(Ni, a);
    return i.open && s.position === "popper" ? /* @__PURE__ */ l.jsx(cr, { ...o, ...n, ref: t }) : null;
  }
);
p7e.displayName = Ni;
function h3(e) {
  return e === "" || e === void 0;
}
var p3 = p.forwardRef(
  (e, t) => {
    const { value: a, ...n } = e, o = p.useRef(null), i = ye(t, o), s = $i(a);
    return p.useEffect(() => {
      const c = o.current, f = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        f,
        "value"
      ).set;
      if (s !== a && u) {
        const h = new Event("change", { bubbles: !0 });
        u.call(c, a), c.dispatchEvent(h);
      }
    }, [s, a]), /* @__PURE__ */ l.jsx(Tn, { asChild: !0, children: /* @__PURE__ */ l.jsx("select", { ...n, ref: i, defaultValue: a }) });
  }
);
p3.displayName = "BubbleSelect";
function y3(e) {
  const t = ct(e), a = p.useRef(""), n = p.useRef(0), o = p.useCallback(
    (s) => {
      const c = a.current + s;
      t(c), function f(d) {
        a.current = d, window.clearTimeout(n.current), d !== "" && (n.current = window.setTimeout(() => f(""), 1e3));
      }(c);
    },
    [t]
  ), i = p.useCallback(() => {
    a.current = "", window.clearTimeout(n.current);
  }, []);
  return p.useEffect(() => () => window.clearTimeout(n.current), []), [a, o, i];
}
function m3(e, t, a) {
  const o = t.length > 1 && Array.from(t).every((d) => d === t[0]) ? t[0] : t, i = a ? e.indexOf(a) : -1;
  let s = y7e(e, Math.max(i, 0));
  o.length === 1 && (s = s.filter((d) => d !== a));
  const f = s.find(
    (d) => d.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return f !== a ? f : void 0;
}
function y7e(e, t) {
  return e.map((a, n) => e[(t + n) % e.length]);
}
var m7e = Bh, k3 = Fh, k7e = $h, g7e = Uh, v7e = Wh, g3 = Yh, M7e = Xh, w7e = t3, v3 = n3, M3 = r3, x7e = i3, C7e = c3, w3 = f3, x3 = d3, C3 = u3, ds = "ToastProvider", [ls, b7e, L7e] = vr("Toast"), [b3, exe] = at("Toast", [L7e]), [j7e, _r] = b3(ds), L3 = (e) => {
  const {
    __scopeToast: t,
    label: a = "Notification",
    duration: n = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: i = 50,
    children: s
  } = e, [c, f] = p.useState(null), [d, u] = p.useState(0), h = p.useRef(!1), y = p.useRef(!1);
  return a.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${ds}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ l.jsx(ls.Provider, { scope: t, children: /* @__PURE__ */ l.jsx(
    j7e,
    {
      scope: t,
      label: a,
      duration: n,
      swipeDirection: o,
      swipeThreshold: i,
      toastCount: d,
      viewport: c,
      onViewportChange: f,
      onToastAdd: p.useCallback(() => u((m) => m + 1), []),
      onToastRemove: p.useCallback(() => u((m) => m - 1), []),
      isFocusedToastEscapeKeyDownRef: h,
      isClosePausedRef: y,
      children: s
    }
  ) });
};
L3.displayName = ds;
var j3 = "ToastViewport", N7e = ["F8"], Ai = "toast.viewportPause", Si = "toast.viewportResume", N3 = p.forwardRef(
  (e, t) => {
    const {
      __scopeToast: a,
      hotkey: n = N7e,
      label: o = "Notifications ({hotkey})",
      ...i
    } = e, s = _r(j3, a), c = b7e(a), f = p.useRef(null), d = p.useRef(null), u = p.useRef(null), h = p.useRef(null), y = ye(t, h, s.onViewportChange), m = n.join("+").replace(/Key/g, "").replace(/Digit/g, ""), v = s.toastCount > 0;
    p.useEffect(() => {
      const g = (M) => {
        var x;
        n.length !== 0 && n.every((C) => M[C] || M.code === C) && ((x = h.current) == null || x.focus());
      };
      return document.addEventListener("keydown", g), () => document.removeEventListener("keydown", g);
    }, [n]), p.useEffect(() => {
      const g = f.current, M = h.current;
      if (v && g && M) {
        const w = () => {
          if (!s.isClosePausedRef.current) {
            const N = new CustomEvent(Ai);
            M.dispatchEvent(N), s.isClosePausedRef.current = !0;
          }
        }, x = () => {
          if (s.isClosePausedRef.current) {
            const N = new CustomEvent(Si);
            M.dispatchEvent(N), s.isClosePausedRef.current = !1;
          }
        }, C = (N) => {
          !g.contains(N.relatedTarget) && x();
        }, L = () => {
          g.contains(document.activeElement) || x();
        };
        return g.addEventListener("focusin", w), g.addEventListener("focusout", C), g.addEventListener("pointermove", w), g.addEventListener("pointerleave", L), window.addEventListener("blur", w), window.addEventListener("focus", x), () => {
          g.removeEventListener("focusin", w), g.removeEventListener("focusout", C), g.removeEventListener("pointermove", w), g.removeEventListener("pointerleave", L), window.removeEventListener("blur", w), window.removeEventListener("focus", x);
        };
      }
    }, [v, s.isClosePausedRef]);
    const k = p.useCallback(
      ({ tabbingDirection: g }) => {
        const w = c().map((x) => {
          const C = x.ref.current, L = [C, ...O7e(C)];
          return g === "forwards" ? L : L.reverse();
        });
        return (g === "forwards" ? w.reverse() : w).flat();
      },
      [c]
    );
    return p.useEffect(() => {
      const g = h.current;
      if (g) {
        const M = (w) => {
          var L, N, j;
          const x = w.altKey || w.ctrlKey || w.metaKey;
          if (w.key === "Tab" && !x) {
            const A = document.activeElement, D = w.shiftKey;
            if (w.target === g && D) {
              (L = d.current) == null || L.focus();
              return;
            }
            const R = k({ tabbingDirection: D ? "backwards" : "forwards" }), _ = R.findIndex((T) => T === A);
            S2(R.slice(_ + 1)) ? w.preventDefault() : D ? (N = d.current) == null || N.focus() : (j = u.current) == null || j.focus();
          }
        };
        return g.addEventListener("keydown", M), () => g.removeEventListener("keydown", M);
      }
    }, [c, k]), /* @__PURE__ */ l.jsxs(
      k4e,
      {
        ref: f,
        role: "region",
        "aria-label": o.replace("{hotkey}", m),
        tabIndex: -1,
        style: { pointerEvents: v ? void 0 : "none" },
        children: [
          v && /* @__PURE__ */ l.jsx(
            Ii,
            {
              ref: d,
              onFocusFromOutsideViewport: () => {
                const g = k({
                  tabbingDirection: "forwards"
                });
                S2(g);
              }
            }
          ),
          /* @__PURE__ */ l.jsx(ls.Slot, { scope: a, children: /* @__PURE__ */ l.jsx(Y.ol, { tabIndex: -1, ...i, ref: y }) }),
          v && /* @__PURE__ */ l.jsx(
            Ii,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const g = k({
                  tabbingDirection: "backwards"
                });
                S2(g);
              }
            }
          )
        ]
      }
    );
  }
);
N3.displayName = j3;
var A3 = "ToastFocusProxy", Ii = p.forwardRef(
  (e, t) => {
    const { __scopeToast: a, onFocusFromOutsideViewport: n, ...o } = e, i = _r(A3, a);
    return /* @__PURE__ */ l.jsx(
      Tn,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (s) => {
          var d;
          const c = s.relatedTarget;
          !((d = i.viewport) != null && d.contains(c)) && n();
        }
      }
    );
  }
);
Ii.displayName = A3;
var Pr = "Toast", A7e = "toast.swipeStart", S7e = "toast.swipeMove", I7e = "toast.swipeCancel", T7e = "toast.swipeEnd", S3 = p.forwardRef(
  (e, t) => {
    const { forceMount: a, open: n, defaultOpen: o, onOpenChange: i, ...s } = e, [c = !0, f] = ft({
      prop: n,
      defaultProp: o,
      onChange: i
    });
    return /* @__PURE__ */ l.jsx(mt, { present: a || c, children: /* @__PURE__ */ l.jsx(
      _7e,
      {
        open: c,
        ...s,
        ref: t,
        onClose: () => f(!1),
        onPause: ct(e.onPause),
        onResume: ct(e.onResume),
        onSwipeStart: F(e.onSwipeStart, (d) => {
          d.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: F(e.onSwipeMove, (d) => {
          const { x: u, y: h } = d.detail.delta;
          d.currentTarget.setAttribute("data-swipe", "move"), d.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${u}px`), d.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${h}px`);
        }),
        onSwipeCancel: F(e.onSwipeCancel, (d) => {
          d.currentTarget.setAttribute("data-swipe", "cancel"), d.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), d.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), d.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), d.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: F(e.onSwipeEnd, (d) => {
          const { x: u, y: h } = d.detail.delta;
          d.currentTarget.setAttribute("data-swipe", "end"), d.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), d.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), d.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${u}px`), d.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${h}px`), f(!1);
        })
      }
    ) });
  }
);
S3.displayName = Pr;
var [z7e, D7e] = b3(Pr, {
  onClose() {
  }
}), _7e = p.forwardRef(
  (e, t) => {
    const {
      __scopeToast: a,
      type: n = "foreground",
      duration: o,
      open: i,
      onClose: s,
      onEscapeKeyDown: c,
      onPause: f,
      onResume: d,
      onSwipeStart: u,
      onSwipeMove: h,
      onSwipeCancel: y,
      onSwipeEnd: m,
      ...v
    } = e, k = _r(Pr, a), [g, M] = p.useState(null), w = ye(t, (T) => M(T)), x = p.useRef(null), C = p.useRef(null), L = o || k.duration, N = p.useRef(0), j = p.useRef(L), A = p.useRef(0), { onToastAdd: D, onToastRemove: H } = k, Z = ct(() => {
      var G;
      (g == null ? void 0 : g.contains(document.activeElement)) && ((G = k.viewport) == null || G.focus()), s();
    }), R = p.useCallback(
      (T) => {
        !T || T === 1 / 0 || (window.clearTimeout(A.current), N.current = (/* @__PURE__ */ new Date()).getTime(), A.current = window.setTimeout(Z, T));
      },
      [Z]
    );
    p.useEffect(() => {
      const T = k.viewport;
      if (T) {
        const G = () => {
          R(j.current), d == null || d();
        }, q = () => {
          const V = (/* @__PURE__ */ new Date()).getTime() - N.current;
          j.current = j.current - V, window.clearTimeout(A.current), f == null || f();
        };
        return T.addEventListener(Ai, q), T.addEventListener(Si, G), () => {
          T.removeEventListener(Ai, q), T.removeEventListener(Si, G);
        };
      }
    }, [k.viewport, L, f, d, R]), p.useEffect(() => {
      i && !k.isClosePausedRef.current && R(L);
    }, [i, L, k.isClosePausedRef, R]), p.useEffect(() => (D(), () => H()), [D, H]);
    const _ = p.useMemo(() => g ? E3(g) : null, [g]);
    return k.viewport ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      _ && /* @__PURE__ */ l.jsx(
        P7e,
        {
          __scopeToast: a,
          role: "status",
          "aria-live": n === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: _
        }
      ),
      /* @__PURE__ */ l.jsx(z7e, { scope: a, onClose: Z, children: An.createPortal(
        /* @__PURE__ */ l.jsx(ls.ItemSlot, { scope: a, children: /* @__PURE__ */ l.jsx(
          m4e,
          {
            asChild: !0,
            onEscapeKeyDown: F(c, () => {
              k.isFocusedToastEscapeKeyDownRef.current || Z(), k.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ l.jsx(
              Y.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": i ? "open" : "closed",
                "data-swipe-direction": k.swipeDirection,
                ...v,
                ref: w,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: F(e.onKeyDown, (T) => {
                  T.key === "Escape" && (c == null || c(T.nativeEvent), T.nativeEvent.defaultPrevented || (k.isFocusedToastEscapeKeyDownRef.current = !0, Z()));
                }),
                onPointerDown: F(e.onPointerDown, (T) => {
                  T.button === 0 && (x.current = { x: T.clientX, y: T.clientY });
                }),
                onPointerMove: F(e.onPointerMove, (T) => {
                  if (!x.current) return;
                  const G = T.clientX - x.current.x, q = T.clientY - x.current.y, V = !!C.current, B = ["left", "right"].includes(k.swipeDirection), Q = ["left", "up"].includes(k.swipeDirection) ? Math.min : Math.max, me = B ? Q(0, G) : 0, be = B ? 0 : Q(0, q), z = T.pointerType === "touch" ? 10 : 2, W = { x: me, y: be }, K = { originalEvent: T, delta: W };
                  V ? (C.current = W, uo(S7e, h, K, {
                    discrete: !1
                  })) : Zf(W, k.swipeDirection, z) ? (C.current = W, uo(A7e, u, K, {
                    discrete: !1
                  }), T.target.setPointerCapture(T.pointerId)) : (Math.abs(G) > z || Math.abs(q) > z) && (x.current = null);
                }),
                onPointerUp: F(e.onPointerUp, (T) => {
                  const G = C.current, q = T.target;
                  if (q.hasPointerCapture(T.pointerId) && q.releasePointerCapture(T.pointerId), C.current = null, x.current = null, G) {
                    const V = T.currentTarget, B = { originalEvent: T, delta: G };
                    Zf(G, k.swipeDirection, k.swipeThreshold) ? uo(T7e, m, B, {
                      discrete: !0
                    }) : uo(
                      I7e,
                      y,
                      B,
                      {
                        discrete: !0
                      }
                    ), V.addEventListener("click", (Q) => Q.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        k.viewport
      ) })
    ] }) : null;
  }
), P7e = (e) => {
  const { __scopeToast: t, children: a, ...n } = e, o = _r(Pr, t), [i, s] = p.useState(!1), [c, f] = p.useState(!1);
  return H7e(() => s(!0)), p.useEffect(() => {
    const d = window.setTimeout(() => f(!0), 1e3);
    return () => window.clearTimeout(d);
  }, []), c ? null : /* @__PURE__ */ l.jsx(Sa, { asChild: !0, children: /* @__PURE__ */ l.jsx(Tn, { ...n, children: i && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    o.label,
    " ",
    a
  ] }) }) });
}, E7e = "ToastTitle", I3 = p.forwardRef(
  (e, t) => {
    const { __scopeToast: a, ...n } = e;
    return /* @__PURE__ */ l.jsx(Y.div, { ...n, ref: t });
  }
);
I3.displayName = E7e;
var R7e = "ToastDescription", T3 = p.forwardRef(
  (e, t) => {
    const { __scopeToast: a, ...n } = e;
    return /* @__PURE__ */ l.jsx(Y.div, { ...n, ref: t });
  }
);
T3.displayName = R7e;
var z3 = "ToastAction", D3 = p.forwardRef(
  (e, t) => {
    const { altText: a, ...n } = e;
    return a.trim() ? /* @__PURE__ */ l.jsx(P3, { altText: a, asChild: !0, children: /* @__PURE__ */ l.jsx(us, { ...n, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${z3}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
D3.displayName = z3;
var _3 = "ToastClose", us = p.forwardRef(
  (e, t) => {
    const { __scopeToast: a, ...n } = e, o = D7e(_3, a);
    return /* @__PURE__ */ l.jsx(P3, { asChild: !0, children: /* @__PURE__ */ l.jsx(
      Y.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: F(e.onClick, o.onClose)
      }
    ) });
  }
);
us.displayName = _3;
var P3 = p.forwardRef((e, t) => {
  const { __scopeToast: a, altText: n, ...o } = e;
  return /* @__PURE__ */ l.jsx(
    Y.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": n || void 0,
      ...o,
      ref: t
    }
  );
});
function E3(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((n) => {
    if (n.nodeType === n.TEXT_NODE && n.textContent && t.push(n.textContent), V7e(n)) {
      const o = n.ariaHidden || n.hidden || n.style.display === "none", i = n.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (i) {
          const s = n.dataset.radixToastAnnounceAlt;
          s && t.push(s);
        } else
          t.push(...E3(n));
    }
  }), t;
}
function uo(e, t, a, { discrete: n }) {
  const o = a.originalEvent.currentTarget, i = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: a });
  t && o.addEventListener(e, t, { once: !0 }), n ? Pd(o, i) : o.dispatchEvent(i);
}
var Zf = (e, t, a = 0) => {
  const n = Math.abs(e.x), o = Math.abs(e.y), i = n > o;
  return t === "left" || t === "right" ? i && n > a : !i && o > a;
};
function H7e(e = () => {
}) {
  const t = ct(e);
  We(() => {
    let a = 0, n = 0;
    return a = window.requestAnimationFrame(() => n = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(a), window.cancelAnimationFrame(n);
    };
  }, [t]);
}
function V7e(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function O7e(e) {
  const t = [], a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const o = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || o ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; a.nextNode(); ) t.push(a.currentNode);
  return t;
}
function S2(e) {
  const t = document.activeElement;
  return e.some((a) => a === t ? !0 : (a.focus(), document.activeElement !== t));
}
var q7e = L3, R3 = N3, H3 = S3, V3 = I3, O3 = T3, q3 = D3, B3 = us, Z3 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function a() {
      for (var i = "", s = 0; s < arguments.length; s++) {
        var c = arguments[s];
        c && (i = o(i, n(c)));
      }
      return i;
    }
    function n(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return a.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var s = "";
      for (var c in i)
        t.call(i, c) && i[c] && (s = o(s, c));
      return s;
    }
    function o(i, s) {
      return s ? i ? i + " " + s : i + s : i;
    }
    e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
  })();
})(Z3);
var B7e = Z3.exports;
const P1 = /* @__PURE__ */ N6(B7e), F3 = { asChild: { type: "boolean" } }, Z7e = { width: { type: "string", className: "rt-r-w", customProperties: ["--width"], responsive: !0 }, minWidth: { type: "string", className: "rt-r-min-w", customProperties: ["--min-width"], responsive: !0 }, maxWidth: { type: "string", className: "rt-r-max-w", customProperties: ["--max-width"], responsive: !0 } }, F7e = { height: { type: "string", className: "rt-r-h", customProperties: ["--height"], responsive: !0 }, minHeight: { type: "string", className: "rt-r-min-h", customProperties: ["--min-height"], responsive: !0 }, maxHeight: { type: "string", className: "rt-r-max-h", customProperties: ["--max-height"], responsive: !0 } }, hs = ["initial", "xs", "sm", "md", "lg", "xl"];
function G3(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function dn(e) {
  return typeof e == "object" && Object.keys(e).some((t) => hs.includes(t));
}
function G7e({ className: e, customProperties: t, ...a }) {
  const n = $3({ allowArbitraryValues: !0, className: e, ...a }), o = $7e({ customProperties: t, ...a });
  return [n, o];
}
function $3({ allowArbitraryValues: e, value: t, className: a, propValues: n, parseValue: o = (i) => i }) {
  const i = [];
  if (t) {
    if (typeof t == "string" && n.includes(t)) return Ff(a, t, o);
    if (dn(t)) {
      const s = t;
      for (const c in s) {
        if (!G3(s, c) || !hs.includes(c)) continue;
        const f = s[c];
        if (f !== void 0) {
          if (n.includes(f)) {
            const d = Ff(a, f, o), u = c === "initial" ? d : `${c}:${d}`;
            i.push(u);
          } else if (e) {
            const d = c === "initial" ? a : `${c}:${a}`;
            i.push(d);
          }
        }
      }
      return i.join(" ");
    }
    if (e) return a;
  }
}
function Ff(e, t, a) {
  const n = e ? "-" : "", o = a(t), i = o == null ? void 0 : o.startsWith("-"), s = i ? "-" : "", c = i ? o == null ? void 0 : o.substring(1) : o;
  return `${s}${e}${n}${c}`;
}
function $7e({ customProperties: e, value: t, propValues: a, parseValue: n = (o) => o }) {
  let o = {};
  if (!(!t || typeof t == "string" && a.includes(t))) {
    if (typeof t == "string" && (o = Object.fromEntries(e.map((i) => [i, t]))), dn(t)) {
      const i = t;
      for (const s in i) {
        if (!G3(i, s) || !hs.includes(s)) continue;
        const c = i[s];
        if (!a.includes(c)) for (const f of e) o = { [s === "initial" ? f : `${f}-${s}`]: c, ...o };
      }
    }
    for (const i in o) {
      const s = o[i];
      s !== void 0 && (o[i] = n(s));
    }
    return o;
  }
}
function Gf(...e) {
  let t = {};
  for (const a of e) a && (t = { ...t, ...a });
  return Object.keys(t).length ? t : void 0;
}
function U7e(...e) {
  return Object.assign({}, ...e);
}
function U3(e, ...t) {
  let a, n;
  const o = { ...e }, i = U7e(...t);
  for (const s in i) {
    let c = o[s];
    const f = i[s];
    if (f.default !== void 0 && c === void 0 && (c = f.default), f.type === "enum" && ![f.default, ...f.values].includes(c) && !dn(c) && (c = f.default), o[s] = c, "className" in f && f.className) {
      delete o[s];
      const d = "responsive" in f;
      if (!c || dn(c) && !d) continue;
      if (dn(c) && (f.default !== void 0 && c.initial === void 0 && (c.initial = f.default), f.type === "enum" && ([f.default, ...f.values].includes(c.initial) || (c.initial = f.default))), f.type === "enum") {
        const u = $3({ allowArbitraryValues: !1, value: c, className: f.className, propValues: f.values, parseValue: f.parseValue });
        a = P1(a, u);
        continue;
      }
      if (f.type === "string" || f.type === "enum | string") {
        const u = f.type === "string" ? [] : f.values, [h, y] = G7e({ className: f.className, customProperties: f.customProperties, propValues: u, parseValue: f.parseValue, value: c });
        n = Gf(n, y), a = P1(a, h);
        continue;
      }
      if (f.type === "boolean" && c) {
        a = P1(a, f.className);
        continue;
      }
    }
  }
  return o.className = P1(a, e.className), o.style = Gf(n, e.style), o;
}
const I1 = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "-1", "-2", "-3", "-4", "-5", "-6", "-7", "-8", "-9"], W3 = { m: { type: "enum | string", values: I1, responsive: !0, className: "rt-r-m", customProperties: ["--m"] }, mx: { type: "enum | string", values: I1, responsive: !0, className: "rt-r-mx", customProperties: ["--ml", "--mr"] }, my: { type: "enum | string", values: I1, responsive: !0, className: "rt-r-my", customProperties: ["--mt", "--mb"] }, mt: { type: "enum | string", values: I1, responsive: !0, className: "rt-r-mt", customProperties: ["--mt"] }, mr: { type: "enum | string", values: I1, responsive: !0, className: "rt-r-mr", customProperties: ["--mr"] }, mb: { type: "enum | string", values: I1, responsive: !0, className: "rt-r-mb", customProperties: ["--mb"] }, ml: { type: "enum | string", values: I1, responsive: !0, className: "rt-r-ml", customProperties: ["--ml"] } };
function W7e(e) {
  switch (e) {
    case "tomato":
    case "red":
    case "ruby":
    case "crimson":
    case "pink":
    case "plum":
    case "purple":
    case "violet":
      return "mauve";
    case "iris":
    case "indigo":
    case "blue":
    case "sky":
    case "cyan":
      return "slate";
    case "teal":
    case "jade":
    case "mint":
    case "green":
      return "sage";
    case "grass":
    case "lime":
      return "olive";
    case "yellow":
    case "amber":
    case "orange":
    case "brown":
    case "gold":
    case "bronze":
      return "sand";
    case "gray":
      return "gray";
  }
}
const ut = { hasBackground: { default: !0 }, appearance: { default: "inherit" }, accentColor: { default: "indigo" }, grayColor: { default: "auto" }, panelBackground: { default: "translucent" }, radius: { default: "medium" }, scaling: { default: "100%" } }, oa = () => {
}, Ti = p.createContext(void 0), Y3 = p.forwardRef((e, t) => p.useContext(Ti) === void 0 ? p.createElement(xl, { delayDuration: 200 }, p.createElement(E5e, { dir: "ltr" }, p.createElement(Q3, { ...e, ref: t }))) : p.createElement(ps, { ...e, ref: t }));
Y3.displayName = "Theme";
const Q3 = p.forwardRef((e, t) => {
  const { appearance: a = ut.appearance.default, accentColor: n = ut.accentColor.default, grayColor: o = ut.grayColor.default, panelBackground: i = ut.panelBackground.default, radius: s = ut.radius.default, scaling: c = ut.scaling.default, hasBackground: f = ut.hasBackground.default, ...d } = e, [u, h] = p.useState(a);
  p.useEffect(() => h(a), [a]);
  const [y, m] = p.useState(n);
  p.useEffect(() => m(n), [n]);
  const [v, k] = p.useState(o);
  p.useEffect(() => k(o), [o]);
  const [g, M] = p.useState(i);
  p.useEffect(() => M(i), [i]);
  const [w, x] = p.useState(s);
  p.useEffect(() => x(s), [s]);
  const [C, L] = p.useState(c);
  return p.useEffect(() => L(c), [c]), p.createElement(ps, { ...d, ref: t, isRoot: !0, hasBackground: f, appearance: u, accentColor: y, grayColor: v, panelBackground: g, radius: w, scaling: C, onAppearanceChange: h, onAccentColorChange: m, onGrayColorChange: k, onPanelBackgroundChange: M, onRadiusChange: x, onScalingChange: L });
});
Q3.displayName = "ThemeRoot";
const ps = p.forwardRef((e, t) => {
  const a = p.useContext(Ti), { asChild: n, isRoot: o, hasBackground: i, appearance: s = (a == null ? void 0 : a.appearance) ?? ut.appearance.default, accentColor: c = (a == null ? void 0 : a.accentColor) ?? ut.accentColor.default, grayColor: f = (a == null ? void 0 : a.resolvedGrayColor) ?? ut.grayColor.default, panelBackground: d = (a == null ? void 0 : a.panelBackground) ?? ut.panelBackground.default, radius: u = (a == null ? void 0 : a.radius) ?? ut.radius.default, scaling: h = (a == null ? void 0 : a.scaling) ?? ut.scaling.default, onAppearanceChange: y = oa, onAccentColorChange: m = oa, onGrayColorChange: v = oa, onPanelBackgroundChange: k = oa, onRadiusChange: g = oa, onScalingChange: M = oa, ...w } = e, x = n ? _d : "div", C = f === "auto" ? W7e(c) : f, L = e.appearance === "light" || e.appearance === "dark", N = i === void 0 ? o || L : i;
  return p.createElement(Ti.Provider, { value: p.useMemo(() => ({ appearance: s, accentColor: c, grayColor: f, resolvedGrayColor: C, panelBackground: d, radius: u, scaling: h, onAppearanceChange: y, onAccentColorChange: m, onGrayColorChange: v, onPanelBackgroundChange: k, onRadiusChange: g, onScalingChange: M }), [s, c, f, C, d, u, h, y, m, v, k, g, M]) }, p.createElement(x, { "data-is-root-theme": o ? "true" : "false", "data-accent-color": c, "data-gray-color": C, "data-has-background": N ? "true" : "false", "data-panel-background": d, "data-radius": u, "data-scaling": h, ref: t, ...w, className: P1("radix-themes", { light: s === "light", dark: s === "dark" }, w.className) }));
});
ps.displayName = "ThemeImpl";
const J3 = _d, Y7e = ["div", "span"], Q7e = ["none", "inline", "inline-block", "block", "contents"], J7e = { as: { type: "enum", values: Y7e, default: "div" }, ...F3, display: { type: "enum", className: "rt-r-display", values: Q7e, responsive: !0 } }, T1 = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], K7e = { p: { type: "enum | string", className: "rt-r-p", customProperties: ["--p"], values: T1, responsive: !0 }, px: { type: "enum | string", className: "rt-r-px", customProperties: ["--pl", "--pr"], values: T1, responsive: !0 }, py: { type: "enum | string", className: "rt-r-py", customProperties: ["--pt", "--pb"], values: T1, responsive: !0 }, pt: { type: "enum | string", className: "rt-r-pt", customProperties: ["--pt"], values: T1, responsive: !0 }, pr: { type: "enum | string", className: "rt-r-pr", customProperties: ["--pr"], values: T1, responsive: !0 }, pb: { type: "enum | string", className: "rt-r-pb", customProperties: ["--pb"], values: T1, responsive: !0 }, pl: { type: "enum | string", className: "rt-r-pl", customProperties: ["--pl"], values: T1, responsive: !0 } }, I2 = ["visible", "hidden", "clip", "scroll", "auto"], X7e = ["static", "relative", "absolute", "fixed", "sticky"], Wa = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "-1", "-2", "-3", "-4", "-5", "-6", "-7", "-8", "-9"], eme = ["0", "1"], tme = ["0", "1"], K3 = { ...K7e, ...Z7e, ...F7e, position: { type: "enum", className: "rt-r-position", values: X7e, responsive: !0 }, inset: { type: "enum | string", className: "rt-r-inset", customProperties: ["--inset"], values: Wa, responsive: !0 }, top: { type: "enum | string", className: "rt-r-top", customProperties: ["--top"], values: Wa, responsive: !0 }, right: { type: "enum | string", className: "rt-r-right", customProperties: ["--right"], values: Wa, responsive: !0 }, bottom: { type: "enum | string", className: "rt-r-bottom", customProperties: ["--bottom"], values: Wa, responsive: !0 }, left: { type: "enum | string", className: "rt-r-left", customProperties: ["--left"], values: Wa, responsive: !0 }, overflow: { type: "enum", className: "rt-r-overflow", values: I2, responsive: !0 }, overflowX: { type: "enum", className: "rt-r-ox", values: I2, responsive: !0 }, overflowY: { type: "enum", className: "rt-r-oy", values: I2, responsive: !0 }, flexBasis: { type: "string", className: "rt-r-fb", customProperties: ["--flex-basis"], responsive: !0 }, flexShrink: { type: "enum | string", className: "rt-r-fs", customProperties: ["--flex-shrink"], values: eme, responsive: !0 }, flexGrow: { type: "enum | string", className: "rt-r-fg", customProperties: ["--flex-grow"], values: tme, responsive: !0 }, gridArea: { type: "string", className: "rt-r-ga", customProperties: ["--grid-area"], responsive: !0 }, gridColumn: { type: "string", className: "rt-r-gc", customProperties: ["--grid-column"], responsive: !0 }, gridColumnStart: { type: "string", className: "rt-r-gcs", customProperties: ["--grid-column-start"], responsive: !0 }, gridColumnEnd: { type: "string", className: "rt-r-gce", customProperties: ["--grid-column-end"], responsive: !0 }, gridRow: { type: "string", className: "rt-r-gr", customProperties: ["--grid-row"], responsive: !0 }, gridRowStart: { type: "string", className: "rt-r-grs", customProperties: ["--grid-row-start"], responsive: !0 }, gridRowEnd: { type: "string", className: "rt-r-gre", customProperties: ["--grid-row-end"], responsive: !0 } }, ys = p.forwardRef((e, t) => {
  const { className: a, asChild: n, as: o = "div", ...i } = U3(e, J7e, K3, W3);
  return p.createElement(n ? J3 : o, { ...i, ref: t, className: P1("rt-Box", a) });
});
ys.displayName = "Box";
const T2 = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], ame = { gap: { type: "enum | string", className: "rt-r-gap", customProperties: ["--gap"], values: T2, responsive: !0 }, gapX: { type: "enum | string", className: "rt-r-cg", customProperties: ["--column-gap"], values: T2, responsive: !0 }, gapY: { type: "enum | string", className: "rt-r-rg", customProperties: ["--row-gap"], values: T2, responsive: !0 } }, nme = ["div", "span"], ome = ["none", "inline-grid", "grid"], rme = ["1", "2", "3", "4", "5", "6", "7", "8", "9"], ime = ["1", "2", "3", "4", "5", "6", "7", "8", "9"], sme = ["row", "column", "dense", "row-dense", "column-dense"], cme = ["start", "center", "end", "baseline", "stretch"], fme = ["start", "center", "end", "between"], X3 = { as: { type: "enum", values: nme, default: "div" }, ...F3, display: { type: "enum", className: "rt-r-display", values: ome, responsive: !0 }, areas: { type: "string", className: "rt-r-gta", customProperties: ["--grid-template-areas"], responsive: !0 }, columns: { type: "enum | string", className: "rt-r-gtc", customProperties: ["--grid-template-columns"], values: rme, parseValue: $f, responsive: !0 }, rows: { type: "enum | string", className: "rt-r-gtr", customProperties: ["--grid-template-rows"], values: ime, parseValue: $f, responsive: !0 }, flow: { type: "enum", className: "rt-r-gaf", values: sme, responsive: !0 }, align: { type: "enum", className: "rt-r-ai", values: cme, responsive: !0 }, justify: { type: "enum", className: "rt-r-jc", values: fme, parseValue: dme, responsive: !0 }, ...ame };
function $f(e) {
  return X3.columns.values.includes(e) ? e : e != null && e.match(/^\d+$/) ? `repeat(${e}, minmax(0, 1fr))` : e;
}
function dme(e) {
  return e === "between" ? "space-between" : e;
}
const ep = p.forwardRef((e, t) => {
  const { className: a, asChild: n, as: o = "div", ...i } = U3(e, X3, K3, W3);
  return p.createElement(n ? J3 : o, { ...i, ref: t, className: P1("rt-Grid", a) });
});
ep.displayName = "Grid";
const lme = I.forwardRef(({ children: e, size: t, liked: a, onLike: n, onClick: o, ...i }, s) => {
  const c = [
    /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(Ce, { name: "Share", size: "md" }) }),
    /* @__PURE__ */ l.jsx("div", { onClick: n, children: /* @__PURE__ */ l.jsx(
      Ce,
      {
        name: "Heart",
        size: "md",
        fill: a ? "red" : "none",
        stroke: a ? "red" : "currentColor"
      }
    ) })
  ];
  return /* @__PURE__ */ l.jsx(
    ys,
    {
      onClick: o,
      ref: s,
      className: "w-full h-full",
      gridColumn: {
        initial: t === "sm" ? "span 2" : "span 4",
        md: t === "sm" ? "span 1" : t === "md" ? "span 2" : "span 3"
      },
      gridRow: {
        initial: t === "sm" || t === "md" ? "span 2" : "span 4",
        md: t === "sm" || t === "md" ? "span 2" : "span 4"
      },
      style: {
        minWidth: t === "sm" ? "156px" : "328px",
        minHeight: t === "sm" || t === "md" ? "212px" : "440px",
        maxHeight: t === "sm" || t === "md" ? "212px" : "440px"
      },
      ...i,
      children: /* @__PURE__ */ l.jsxs("div", { className: "w-full h-full relative cursor-pointer group", children: [
        e,
        /* @__PURE__ */ l.jsx(
          "div",
          {
            onClick: (f) => {
              f.stopPropagation();
            },
            className: S(
              " absolute z-10 -bottom-6 left-1/2 transform -translate-x-1/2 hover:cursor-pointer group-hover:opacity-100 opacity-0 transition-opacity duration-300"
            ),
            children: /* @__PURE__ */ l.jsx(
              xr,
              {
                showActiveState: !1,
                options: c,
                container: !0,
                setCurrentState: () => null
              }
            )
          }
        )
      ] })
    }
  );
});
lme.displayName = "CardInteractionWrapper";
const ho = {
  0: "sm",
  1: "md",
  2: "lg"
}, z2 = {
  initial: { scale: 0.8, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: { scale: 0.8, opacity: 0 },
  transition: {
    type: "spring",
    damping: 30,
    stiffness: 200,
    duration: 0.1
  }
}, ume = I.forwardRef(
  ({
    defaultSize: e,
    deleteFunction: t,
    children: a,
    isDragging: n = !1,
    onSizeChange: o,
    isAnimated: i = !1,
    ...s
  }, c) => {
    const [f, d] = ve(e), [u, h] = ve(
      Object.keys(ho).findIndex(
        (m) => ho[m] === e
      )
    ), y = [
      /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(Ce, { fill: "none", name: "Square", size: "sm" }) }),
      /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(Ce, { fill: "none", name: "RectangleHorizontal" }) }),
      /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(Ce, { fill: "none", name: "Square", size: "md" }) })
    ];
    return Ne(() => {
      d(ho[u]), o == null || o(ho[u]);
    }, [u]), /* @__PURE__ */ l.jsxs(
      ys,
      {
        ref: c,
        className: "w-full h-full relative group",
        gridColumn: {
          initial: f === "sm" ? "span 2" : "span 4",
          md: f === "sm" ? "span 1" : f === "md" ? "span 2" : "span 3"
        },
        gridRow: {
          initial: f === "sm" || f === "md" ? "span 2" : "span 4",
          md: f === "sm" || f === "md" ? "span 2" : "span 4"
        },
        style: {
          minWidth: f === "sm" ? "156px" : "328px",
          minHeight: f === "sm" || f === "md" ? "212px" : "440px",
          maxHeight: f === "sm" || f === "md" ? "212px" : "440px"
        },
        ...s,
        children: [
          /* @__PURE__ */ l.jsx(
            R1.div,
            {
              ...z2,
              layout: i,
              className: "w-full h-full relative",
              children: a(f)
            }
          ),
          /* @__PURE__ */ l.jsx(
            R1.div,
            {
              ...z2,
              layout: "size",
              className: S(
                "absolute -top-4 -left-4 group-hover:visible invisible group-hover:opacity-100 opacity-0 transition-opacity duration-300",
                n && "invisible"
              ),
              children: /* @__PURE__ */ l.jsx(
                ar,
                {
                  onClick: t,
                  icon: "Trash2",
                  variant: "ghost",
                  size: "md",
                  rounded: !0,
                  elevation: 3,
                  className: "color-bg-default"
                }
              )
            }
          ),
          /* @__PURE__ */ l.jsx(
            R1.div,
            {
              ...z2,
              layout: "size",
              className: S(
                "absolute z-10 -bottom-6 left-1/2 transform invisible -translate-x-1/2 group-hover:visible group-hover:opacity-100 opacity-0 transition-opacity duration-300",
                n && "invisible"
              ),
              children: /* @__PURE__ */ l.jsx(
                xr,
                {
                  options: y,
                  container: !0,
                  currentState: u,
                  setCurrentState: h
                }
              )
            }
          )
        ]
      }
    );
  }
);
ume.displayName = "CardControlWrapper";
const hme = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ l.jsx(
  "table",
  {
    ref: a,
    className: S(
      "w-full caption-bottom text-body-sm color-text-default",
      e
    ),
    ...t
  }
) }));
hme.displayName = "Table";
const pme = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  "thead",
  {
    ref: a,
    className: S("[&_tr]:border-b [&_tr]:color-border-default", e),
    ...t
  }
));
pme.displayName = "TableHeader";
const yme = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  "tbody",
  {
    ref: a,
    className: S("[&_tr:last-child]:border-0", e),
    ...t
  }
));
yme.displayName = "TableBody";
const mme = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  "tfoot",
  {
    ref: a,
    className: S(
      "border-t color-border-default color-bg-secondary color-text-secondary [&>tr]:last:border-b-0",
      e
    ),
    ...t
  }
));
mme.displayName = "TableFooter";
const kme = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  "tr",
  {
    ref: a,
    className: S(
      "border-b color-border-default transition-colors hover:color-bg-default-hover data-[state=selected]:color-bg-default-selected",
      e
    ),
    ...t
  }
));
kme.displayName = "TableRow";
const gme = p.forwardRef(
  ({ className: e, children: t, enableSorting: a, sortOrder: n, ...o }, i) => /* @__PURE__ */ l.jsx(
    "th",
    {
      ref: i,
      className: S(
        "h-12 py-4 px-2 text-left align-middle text-heading-xsm color-text-secondary color-border-default border-b [&:has([role=checkbox])]:pr-0",
        {
          "cursor-pointer": a
        },
        e
      ),
      ...o,
      children: /* @__PURE__ */ l.jsxs("div", { className: "flex justify-start items-center gap-2", children: [
        t,
        a && /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col justify-center items-center", children: [
          /* @__PURE__ */ l.jsx(
            Y2,
            {
              size: 7,
              className: S(
                "-rotate-90 color-icon-secondary",
                n === "asc" && "color-icon-default"
              )
            }
          ),
          /* @__PURE__ */ l.jsx(
            Y2,
            {
              size: 7,
              className: S(
                "rotate-90 color-icon-secondary",
                n === "desc" && "color-icon-default"
              )
            }
          )
        ] })
      ] })
    }
  )
);
gme.displayName = "TableHead";
const vme = p.forwardRef(({ className: e, children: t, ...a }, n) => {
  const o = typeof t == "string" ? "min-w-[200px]" : "w-fit";
  return /* @__PURE__ */ l.jsx(
    "td",
    {
      ref: n,
      className: S(
        "h-12 py-4 px-2 align-middle text-body-sm color-text-default [&:has([role=checkbox])]:pr-0",
        o,
        e
      ),
      ...a,
      children: t
    }
  );
});
vme.displayName = "TableCell";
const Mme = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  "caption",
  {
    ref: a,
    className: S("mt-4 text-body-sm color-text-secondary", e),
    ...t
  }
));
Mme.displayName = "TableCaption";
const txe = (e) => /* @__PURE__ */ l.jsx(Y3, { children: /* @__PURE__ */ l.jsx(ep, { ...e }) }), wme = "data:image/svg+xml,%3csvg%20width='152'%20height='176'%20viewBox='0%200%20152%20176'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Animation%20placeholder'%3e%3crect%20id='Shape'%20x='62.5'%20y='2'%20width='87'%20height='112'%20fill='%23FFDF0A'%20stroke='black'%20stroke-width='4'/%3e%3crect%20id='Shape_2'%20x='50.5'%20y='14'%20width='87'%20height='112'%20fill='%23FFDF0A'%20stroke='black'%20stroke-width='4'/%3e%3crect%20id='Shape_3'%20x='38.5'%20y='26'%20width='87'%20height='112'%20fill='%23FFDF0A'%20stroke='black'%20stroke-width='4'/%3e%3crect%20id='Shape_4'%20x='26.5'%20y='38'%20width='87'%20height='112'%20fill='%23FFDF0A'%20stroke='black'%20stroke-width='4'/%3e%3crect%20id='Shape_5'%20x='14.5'%20y='50'%20width='87'%20height='112'%20fill='%23FFDF0A'%20stroke='black'%20stroke-width='4'/%3e%3crect%20id='Shape_6'%20x='2.5'%20y='62'%20width='87'%20height='112'%20fill='%23FFDF0A'%20stroke='black'%20stroke-width='4'/%3e%3cg%20id='Face'%3e%3ccircle%20id='Shape_7'%20cx='28.5'%20cy='96'%20r='6'%20fill='black'/%3e%3cpath%20id='Shape_8'%20d='M63.5%20114C63.5%20119.039%2061.4982%20123.872%2057.935%20127.435C54.3718%20130.998%2049.5391%20133%2044.5%20133C39.4609%20133%2034.6282%20130.998%2031.065%20127.435C27.5018%20123.872%2025.5%20119.039%2025.5%20114L44.5%20114H63.5Z'%20fill='black'/%3e%3ccircle%20id='Shape_9'%20cx='53.5'%20cy='96'%20r='6'%20fill='black'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", xme = "data:image/gif;base64,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", axe = ({ text: e = "Loading..." }) => /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col items-center justify-center h-full gap-4 color-text-default", children: [
  /* @__PURE__ */ l.jsx("img", { src: xme, height: 140, width: 140, alt: "fileverse logo" }),
  /* @__PURE__ */ l.jsx("p", { className: "text-heading-sm-bold", children: e })
] }), nxe = ({ text: e = "Loading..." }) => /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col items-center justify-center h-full gap-4 color-text-default", children: [
  /* @__PURE__ */ l.jsx("img", { src: wme, alt: "fileverse logo" }),
  /* @__PURE__ */ l.jsx("p", { className: "text-heading-sm-bold", children: e })
] }), Cme = I.forwardRef(
  ({
    children: e,
    className: t,
    title: a,
    setTitle: n,
    setCurrentLayoutMode: o,
    viewMode: i,
    isDragging: s,
    onRemoveSection: c,
    ...f
  }, d) => {
    const u = [
      /* @__PURE__ */ l.jsx(
        "div",
        {
          onClick: () => o(Bi.LIST),
          "data-testid": "list-mode-button",
          className: "color-text-default",
          children: /* @__PURE__ */ l.jsx(
            Ce,
            {
              fill: "none",
              name: "List",
              className: "color-text-default hover:color-text-default-hover transition-colors"
            }
          )
        }
      ),
      /* @__PURE__ */ l.jsx(
        "div",
        {
          onClick: () => o(Bi.CARD),
          "data-testid": "card-mode-button",
          className: "color-text-default",
          children: /* @__PURE__ */ l.jsx(
            Ce,
            {
              fill: "none",
              name: "LayoutGrid",
              className: "color-text-default hover:color-text-default-hover transition-colors"
            }
          )
        }
      )
    ], { onMouseEnter: h, onMouseLeave: y, isActive: m } = Dwe({});
    return /* @__PURE__ */ l.jsxs(
      "section",
      {
        ref: d,
        className: S(
          "relative w-full color-bg-default p-4 flex flex-col gap-6 rounded-xl",
          t
        ),
        ...f,
        children: [
          !s && /* @__PURE__ */ l.jsxs(
            "div",
            {
              className: S(
                "w-full flex justify-between items-center py-2 px-5 rounded-xl border border-dashed transition-colors duration-200 ease-in-out",
                !i && m ? "border-default" : "border-transparent"
              ),
              onMouseEnter: h,
              onMouseLeave: y,
              children: [
                i ? /* @__PURE__ */ l.jsx("p", { className: "text-heading-md", children: a }) : n && /* @__PURE__ */ l.jsx(
                  Hd,
                  {
                    className: "text-heading-md border-none outline-none",
                    defaultValue: a,
                    onChange: (v) => n(v.target.value)
                  }
                ),
                /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
                  xr,
                  {
                    options: u,
                    container: !1,
                    currentState: 1,
                    setCurrentState: () => null
                  }
                ) }),
                !i && m && /* @__PURE__ */ l.jsx("div", { className: S("absolute -top-1 -left-1"), children: /* @__PURE__ */ l.jsx(
                  ar,
                  {
                    onClick: c,
                    icon: "Trash2",
                    variant: "ghost",
                    size: "md",
                    rounded: !0,
                    elevation: 3,
                    className: "color-bg-default"
                  }
                ) })
              ]
            }
          ),
          e
        ]
      }
    );
  }
);
Cme.displayName = "Section";
const bme = I.forwardRef(({ options: e, alignment: t = "vertical", className: a, ...n }, o) => /* @__PURE__ */ l.jsx(
  "div",
  {
    ref: o,
    className: S(
      "p-2 color-bg-default flex justify-center items-center gap-4 rounded-xl color-border-default border-[0.5px] shadow-elevation-4",
      { "flex-col w-[68px] px-6 py-4": t === "horizontal" },
      { "h-[68px] py-6 px-4": t === "vertical" },
      a
    ),
    ...n,
    children: e.map((i, s) => /* @__PURE__ */ l.jsxs(
      "div",
      {
        className: S("flex justify-center items-center gap-4", {
          "flex-col": t === "horizontal"
        }),
        children: [
          /* @__PURE__ */ l.jsx(
            "div",
            {
              className: S("flex gap-2", {
                "flex-col": t === "horizontal"
              }),
              children: i.map((c, f) => /* @__PURE__ */ l.jsx(
                "span",
                {
                  className: "min-w-9 min-h-9 hover:color-button-secondary-hover hover:cursor-pointer transition-colors rounded-[4px]",
                  children: c
                },
                f
              ))
            }
          ),
          s !== e.length - 1 && /* @__PURE__ */ l.jsx(m6, { direction: t, size: "lg" })
        ]
      },
      s
    ))
  }
));
bme.displayName = "FloatingToolbar";
function Lme(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], a = document.createElement("style");
  a.type = "text/css", t.appendChild(a), a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(document.createTextNode(e));
}
const tp = I.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), Bn = () => {
  const e = I.useContext(tp);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
Lme(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function jme() {
  const e = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(e) && /Mobile/.test(e) || // Android Firefox
  /FxiOS/.test(e));
}
function Nme() {
  return ms(/^Mac/);
}
function Ame() {
  return ms(/^iPhone/);
}
function Uf() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function Sme() {
  return ms(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Nme() && navigator.maxTouchPoints > 1;
}
function ap() {
  return Ame() || Sme();
}
function ms(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const Ime = 24, Tme = typeof window < "u" ? er : Ne;
function Wf(...e) {
  return (...t) => {
    for (let a of e)
      typeof a == "function" && a(...t);
  };
}
const D2 = typeof document < "u" && window.visualViewport;
function Yf(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function np(e) {
  for (Yf(e) && (e = e.parentElement); e && !Yf(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const zme = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let po = 0, _2;
function Dme(e = {}) {
  let { isDisabled: t } = e;
  Tme(() => {
    if (!t)
      return po++, po === 1 && ap() && (_2 = _me()), () => {
        po--, po === 0 && (_2 == null || _2());
      };
  }, [
    t
  ]);
}
function _me() {
  let e, t = 0, a = (h) => {
    e = np(h.target), !(e === document.documentElement && e === document.body) && (t = h.changedTouches[0].pageY);
  }, n = (h) => {
    if (!e || e === document.documentElement || e === document.body) {
      h.preventDefault();
      return;
    }
    let y = h.changedTouches[0].pageY, m = e.scrollTop, v = e.scrollHeight - e.clientHeight;
    v !== 0 && ((m <= 0 && y > t || m >= v && y < t) && h.preventDefault(), t = y);
  }, o = (h) => {
    let y = h.target;
    zi(y) && y !== document.activeElement && (h.preventDefault(), y.style.transform = "translateY(-2000px)", y.focus(), requestAnimationFrame(() => {
      y.style.transform = "";
    }));
  }, i = (h) => {
    let y = h.target;
    zi(y) && (y.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      y.style.transform = "", D2 && (D2.height < window.innerHeight ? requestAnimationFrame(() => {
        Qf(y);
      }) : D2.addEventListener("resize", () => Qf(y), {
        once: !0
      }));
    }));
  }, s = () => {
    window.scrollTo(0, 0);
  }, c = window.pageXOffset, f = window.pageYOffset, d = Wf(Pme(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let u = Wf(Ya(document, "touchstart", a, {
    passive: !1,
    capture: !0
  }), Ya(document, "touchmove", n, {
    passive: !1,
    capture: !0
  }), Ya(document, "touchend", o, {
    passive: !1,
    capture: !0
  }), Ya(document, "focus", i, !0), Ya(window, "scroll", s));
  return () => {
    d(), u(), window.scrollTo(c, f);
  };
}
function Pme(e, t, a) {
  let n = e.style[t];
  return e.style[t] = a, () => {
    e.style[t] = n;
  };
}
function Ya(e, t, a, n) {
  return e.addEventListener(t, a, n), () => {
    e.removeEventListener(t, a, n);
  };
}
function Qf(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let a = np(e);
    if (a !== document.documentElement && a !== document.body && a !== e) {
      let n = a.getBoundingClientRect().top, o = e.getBoundingClientRect().top, i = e.getBoundingClientRect().bottom;
      const s = a.getBoundingClientRect().bottom + Ime;
      i > s && (a.scrollTop += o - n);
    }
    e = a.parentElement;
  }
}
function zi(e) {
  return e instanceof HTMLInputElement && !zme.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function Eme(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Rme(...e) {
  return (t) => e.forEach((a) => Eme(a, t));
}
function op(...e) {
  return p.useCallback(Rme(...e), e);
}
const rp = /* @__PURE__ */ new WeakMap();
function Ze(e, t, a = !1) {
  if (!e || !(e instanceof HTMLElement)) return;
  let n = {};
  Object.entries(t).forEach(([o, i]) => {
    if (o.startsWith("--")) {
      e.style.setProperty(o, i);
      return;
    }
    n[o] = e.style[o], e.style[o] = i;
  }), !a && rp.set(e, n);
}
function Hme(e, t) {
  if (!e || !(e instanceof HTMLElement)) return;
  let a = rp.get(e);
  a && (e.style[t] = a[t]);
}
const qe = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function yo(e, t) {
  if (!e)
    return null;
  const a = window.getComputedStyle(e), n = (
    // @ts-ignore
    a.transform || a.webkitTransform || a.mozTransform
  );
  let o = n.match(/^matrix3d\((.+)\)$/);
  return o ? parseFloat(o[1].split(", ")[qe(t) ? 13 : 12]) : (o = n.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[qe(t) ? 5 : 4]) : null);
}
function Vme(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function P2(e, t) {
  if (!e) return () => {
  };
  const a = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = a;
  };
}
function Ome(...e) {
  return (...t) => {
    for (const a of e)
      typeof a == "function" && a(...t);
  };
}
const ze = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, ip = 0.4, qme = 0.25, Bme = 100, sp = 8, mo = 16, Di = 26, E2 = "vaul-dragging";
function cp(e) {
  const t = I.useRef(e);
  return I.useEffect(() => {
    t.current = e;
  }), I.useMemo(() => (...a) => t.current == null ? void 0 : t.current.call(t, ...a), []);
}
function Zme({ defaultProp: e, onChange: t }) {
  const a = I.useState(e), [n] = a, o = I.useRef(n), i = cp(t);
  return I.useEffect(() => {
    o.current !== n && (i(n), o.current = n);
  }, [
    n,
    o,
    i
  ]), a;
}
function fp({ prop: e, defaultProp: t, onChange: a = () => {
} }) {
  const [n, o] = Zme({
    defaultProp: t,
    onChange: a
  }), i = e !== void 0, s = i ? e : n, c = cp(a), f = I.useCallback((d) => {
    if (i) {
      const h = typeof d == "function" ? d(e) : d;
      h !== e && c(h);
    } else
      o(d);
  }, [
    i,
    e,
    o,
    c
  ]);
  return [
    s,
    f
  ];
}
function Fme({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: a, drawerRef: n, overlayRef: o, fadeFromIndex: i, onSnapPointChange: s, direction: c = "bottom", container: f, snapToSequentialPoint: d }) {
  const [u, h] = fp({
    prop: e,
    defaultProp: a == null ? void 0 : a[0],
    onChange: t
  }), [y, m] = I.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  I.useEffect(() => {
    function j() {
      m({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", j), () => window.removeEventListener("resize", j);
  }, []);
  const v = I.useMemo(() => u === (a == null ? void 0 : a[a.length - 1]) || null, [
    a,
    u
  ]), k = I.useMemo(() => {
    var j;
    return (j = a == null ? void 0 : a.findIndex((A) => A === u)) != null ? j : null;
  }, [
    a,
    u
  ]), g = a && a.length > 0 && (i || i === 0) && !Number.isNaN(i) && a[i] === u || !a, M = I.useMemo(() => {
    const j = f ? {
      width: f.getBoundingClientRect().width,
      height: f.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var A;
    return (A = a == null ? void 0 : a.map((D) => {
      const H = typeof D == "string";
      let Z = 0;
      if (H && (Z = parseInt(D, 10)), qe(c)) {
        const _ = H ? Z : y ? D * j.height : 0;
        return y ? c === "bottom" ? j.height - _ : -j.height + _ : _;
      }
      const R = H ? Z : y ? D * j.width : 0;
      return y ? c === "right" ? j.width - R : -j.width + R : R;
    })) != null ? A : [];
  }, [
    a,
    y,
    f
  ]), w = I.useMemo(() => k !== null ? M == null ? void 0 : M[k] : null, [
    M,
    k
  ]), x = I.useCallback((j) => {
    var A;
    const D = (A = M == null ? void 0 : M.findIndex((H) => H === j)) != null ? A : null;
    s(D), Ze(n.current, {
      transition: `transform ${ze.DURATION}s cubic-bezier(${ze.EASE.join(",")})`,
      transform: qe(c) ? `translate3d(0, ${j}px, 0)` : `translate3d(${j}px, 0, 0)`
    }), M && D !== M.length - 1 && i !== void 0 && D !== i && D < i ? Ze(o.current, {
      transition: `opacity ${ze.DURATION}s cubic-bezier(${ze.EASE.join(",")})`,
      opacity: "0"
    }) : Ze(o.current, {
      transition: `opacity ${ze.DURATION}s cubic-bezier(${ze.EASE.join(",")})`,
      opacity: "1"
    }), h(a == null ? void 0 : a[Math.max(D, 0)]);
  }, [
    n.current,
    a,
    M,
    i,
    o,
    h
  ]);
  I.useEffect(() => {
    if (u || e) {
      var j;
      const A = (j = a == null ? void 0 : a.findIndex((D) => D === e || D === u)) != null ? j : -1;
      M && A !== -1 && typeof M[A] == "number" && x(M[A]);
    }
  }, [
    u,
    e,
    a,
    M,
    x
  ]);
  function C({ draggedDistance: j, closeDrawer: A, velocity: D, dismissible: H }) {
    if (i === void 0) return;
    const Z = c === "bottom" || c === "right" ? (w ?? 0) - j : (w ?? 0) + j, R = k === i - 1, _ = k === 0, T = j > 0;
    if (R && Ze(o.current, {
      transition: `opacity ${ze.DURATION}s cubic-bezier(${ze.EASE.join(",")})`
    }), !d && D > 2 && !T) {
      H ? A() : x(M[0]);
      return;
    }
    if (!d && D > 2 && T && M && a) {
      x(M[a.length - 1]);
      return;
    }
    const G = M == null ? void 0 : M.reduce((V, B) => typeof V != "number" || typeof B != "number" ? V : Math.abs(B - Z) < Math.abs(V - Z) ? B : V), q = qe(c) ? window.innerHeight : window.innerWidth;
    if (D > ip && Math.abs(j) < q * 0.4) {
      const V = T ? 1 : -1;
      if (V > 0 && v && a) {
        x(M[a.length - 1]);
        return;
      }
      if (_ && V < 0 && H && A(), k === null) return;
      x(M[k + V]);
      return;
    }
    x(G);
  }
  function L({ draggedDistance: j }) {
    if (w === null) return;
    const A = c === "bottom" || c === "right" ? w - j : w + j;
    (c === "bottom" || c === "right") && A < M[M.length - 1] || (c === "top" || c === "left") && A > M[M.length - 1] || Ze(n.current, {
      transform: qe(c) ? `translate3d(0, ${A}px, 0)` : `translate3d(${A}px, 0, 0)`
    });
  }
  function N(j, A) {
    if (!a || typeof k != "number" || !M || i === void 0) return null;
    const D = k === i - 1;
    if (k >= i && A)
      return 0;
    if (D && !A) return 1;
    if (!g && !D) return null;
    const Z = D ? k + 1 : k - 1, R = D ? M[Z] - M[Z - 1] : M[Z + 1] - M[Z], _ = j / Math.abs(R);
    return D ? 1 - _ : _;
  }
  return {
    isLastSnapPoint: v,
    activeSnapPoint: u,
    shouldFade: g,
    getPercentageDragged: N,
    setActiveSnapPoint: h,
    activeSnapPointIndex: k,
    onRelease: C,
    onDrag: L,
    snapPointsOffset: M
  };
}
const Gme = () => () => {
};
function $me() {
  const { direction: e, isOpen: t, shouldScaleBackground: a, setBackgroundColorOnScale: n, noBodyStyles: o } = Bn(), i = I.useRef(null), s = Ke(() => document.body.style.backgroundColor, []);
  function c() {
    return (window.innerWidth - Di) / window.innerWidth;
  }
  I.useEffect(() => {
    if (t && a) {
      i.current && clearTimeout(i.current);
      const f = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!f) return;
      Ome(n && !o ? P2(document.body, {
        background: "black"
      }) : Gme, P2(f, {
        transformOrigin: qe(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${ze.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${ze.EASE.join(",")})`
      }));
      const d = P2(f, {
        borderRadius: `${sp}px`,
        overflow: "hidden",
        ...qe(e) ? {
          transform: `scale(${c()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${c()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        d(), i.current = window.setTimeout(() => {
          s ? document.body.style.background = s : document.body.style.removeProperty("background");
        }, ze.DURATION * 1e3);
      };
    }
  }, [
    t,
    a,
    s
  ]);
}
let Qa = null;
function Ume({ isOpen: e, modal: t, nested: a, hasBeenOpened: n, preventScrollRestoration: o, noBodyStyles: i }) {
  const [s, c] = I.useState(() => typeof window < "u" ? window.location.href : ""), f = I.useRef(0), d = I.useCallback(() => {
    if (Uf() && Qa === null && e && !i) {
      Qa = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: h, innerHeight: y } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-f.current}px`,
        left: `${-h}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const m = y - window.innerHeight;
        m && f.current >= y && (document.body.style.top = `${-(f.current + m)}px`);
      }), 300);
    }
  }, [
    e
  ]), u = I.useCallback(() => {
    if (Uf() && Qa !== null && !i) {
      const h = -parseInt(document.body.style.top, 10), y = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, Qa), window.requestAnimationFrame(() => {
        if (o && s !== window.location.href) {
          c(window.location.href);
          return;
        }
        window.scrollTo(y, h);
      }), Qa = null;
    }
  }, [
    s
  ]);
  return I.useEffect(() => {
    function h() {
      f.current = window.scrollY;
    }
    return h(), window.addEventListener("scroll", h), () => {
      window.removeEventListener("scroll", h);
    };
  }, []), I.useEffect(() => {
    if (t)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || u();
      };
  }, [
    t,
    u
  ]), I.useEffect(() => {
    a || !n || (e ? (!window.matchMedia("(display-mode: standalone)").matches && d(), t || window.setTimeout(() => {
      u();
    }, 500)) : u());
  }, [
    e,
    n,
    s,
    t,
    a,
    d,
    u
  ]), {
    restorePositionSetting: u
  };
}
function Wme({ open: e, onOpenChange: t, children: a, onDrag: n, onRelease: o, snapPoints: i, shouldScaleBackground: s = !1, setBackgroundColorOnScale: c = !0, closeThreshold: f = qme, scrollLockTimeout: d = Bme, dismissible: u = !0, handleOnly: h = !1, fadeFromIndex: y = i && i.length - 1, activeSnapPoint: m, setActiveSnapPoint: v, fixed: k, modal: g = !0, onClose: M, nested: w, noBodyStyles: x = !1, direction: C = "bottom", defaultOpen: L = !1, disablePreventScroll: N = !0, snapToSequentialPoint: j = !1, preventScrollRestoration: A = !1, repositionInputs: D = !0, onAnimationEnd: H, container: Z, autoFocus: R = !1 }) {
  var _, T;
  const [G = !1, q] = fp({
    defaultProp: L,
    prop: e,
    onChange: (ee) => {
      t == null || t(ee), !ee && !w && Jn(), setTimeout(() => {
        H == null || H(ee);
      }, ze.DURATION * 1e3), ee && !g && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), ee || (document.body.style.pointerEvents = "auto");
    }
  }), [V, B] = I.useState(!1), [Q, me] = I.useState(!1), [be, z] = I.useState(!1), W = I.useRef(null), K = I.useRef(null), U = I.useRef(null), ne = I.useRef(null), O = I.useRef(null), X = I.useRef(!1), re = I.useRef(null), ie = I.useRef(0), fe = I.useRef(!1), ke = I.useRef(!L), Fe = I.useRef(0), J = I.useRef(null), lt = I.useRef(((_ = J.current) == null ? void 0 : _.getBoundingClientRect().height) || 0), nt = I.useRef(((T = J.current) == null ? void 0 : T.getBoundingClientRect().width) || 0), gt = I.useRef(0), K1 = I.useCallback((ee) => {
    i && ee === L1.length - 1 && (K.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: At, activeSnapPointIndex: a1, setActiveSnapPoint: Yn, onRelease: Ha, snapPointsOffset: L1, onDrag: Jr, shouldFade: Va, getPercentageDragged: Qn } = Fme({
    snapPoints: i,
    activeSnapPointProp: m,
    setActiveSnapPointProp: v,
    drawerRef: J,
    fadeFromIndex: y,
    overlayRef: W,
    onSnapPointChange: K1,
    direction: C,
    container: Z,
    snapToSequentialPoint: j
  });
  Dme({
    isDisabled: !G || Q || !g || be || !V || !D || !N
  });
  const { restorePositionSetting: Jn } = Ume({
    isOpen: G,
    modal: g,
    nested: w ?? !1,
    hasBeenOpened: V,
    preventScrollRestoration: A,
    noBodyStyles: x
  });
  function X1() {
    return (window.innerWidth - Di) / window.innerWidth;
  }
  function Kn(ee) {
    var de, Me;
    !u && !i || J.current && !J.current.contains(ee.target) || (lt.current = ((de = J.current) == null ? void 0 : de.getBoundingClientRect().height) || 0, nt.current = ((Me = J.current) == null ? void 0 : Me.getBoundingClientRect().width) || 0, me(!0), U.current = /* @__PURE__ */ new Date(), ap() && window.addEventListener("touchend", () => X.current = !1, {
      once: !0
    }), ee.target.setPointerCapture(ee.pointerId), ie.current = qe(C) ? ee.pageY : ee.pageX);
  }
  function Oa(ee, de) {
    var Me;
    let le = ee;
    const Ie = (Me = window.getSelection()) == null ? void 0 : Me.toString(), Ye = J.current ? yo(J.current, C) : null, Ge = /* @__PURE__ */ new Date();
    if (le.tagName === "SELECT" || le.hasAttribute("data-vaul-no-drag") || le.closest("[data-vaul-no-drag]"))
      return !1;
    if (C === "right" || C === "left")
      return !0;
    if (K.current && Ge.getTime() - K.current.getTime() < 500)
      return !1;
    if (Ye !== null && (C === "bottom" ? Ye > 0 : Ye < 0))
      return !0;
    if (Ie && Ie.length > 0)
      return !1;
    if (O.current && Ge.getTime() - O.current.getTime() < d && Ye === 0 || de)
      return O.current = Ge, !1;
    for (; le; ) {
      if (le.scrollHeight > le.clientHeight) {
        if (le.scrollTop !== 0)
          return O.current = /* @__PURE__ */ new Date(), !1;
        if (le.getAttribute("role") === "dialog")
          return !0;
      }
      le = le.parentNode;
    }
    return !0;
  }
  function Kr(ee) {
    if (J.current && Q) {
      const de = C === "bottom" || C === "right" ? 1 : -1, Me = (ie.current - (qe(C) ? ee.pageY : ee.pageX)) * de, le = Me > 0, Ie = i && !u && !le;
      if (Ie && a1 === 0) return;
      const Ye = Math.abs(Me), Ge = document.querySelector("[data-vaul-drawer-wrapper]"), Vt = C === "bottom" || C === "top" ? lt.current : nt.current;
      let ot = Ye / Vt;
      const Ot = Qn(Ye, le);
      if (Ot !== null && (ot = Ot), Ie && ot >= 1 || !X.current && !Oa(ee.target, le)) return;
      if (J.current.classList.add(E2), X.current = !0, Ze(J.current, {
        transition: "none"
      }), Ze(W.current, {
        transition: "none"
      }), i && Jr({
        draggedDistance: Me
      }), le && !i) {
        const vt = Vme(Me), N1 = Math.min(vt * -1, 0) * de;
        Ze(J.current, {
          transform: qe(C) ? `translate3d(0, ${N1}px, 0)` : `translate3d(${N1}px, 0, 0)`
        });
        return;
      }
      const qt = 1 - ot;
      if ((Va || y && a1 === y - 1) && (n == null || n(ee, ot), Ze(W.current, {
        opacity: `${qt}`,
        transition: "none"
      }, !0)), Ge && W.current && s) {
        const vt = Math.min(X1() + ot * (1 - X1()), 1), N1 = 8 - ot * 8, Ba = Math.max(0, 14 - ot * 14);
        Ze(Ge, {
          borderRadius: `${N1}px`,
          transform: qe(C) ? `scale(${vt}) translate3d(0, ${Ba}px, 0)` : `scale(${vt}) translate3d(${Ba}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!i) {
        const vt = Ye * de;
        Ze(J.current, {
          transform: qe(C) ? `translate3d(0, ${vt}px, 0)` : `translate3d(${vt}px, 0, 0)`
        });
      }
    }
  }
  I.useEffect(() => {
    window.requestAnimationFrame(() => {
      ke.current = !0;
    });
  }, []), I.useEffect(() => {
    var ee;
    function de() {
      if (!J.current || !D) return;
      const Me = document.activeElement;
      if (zi(Me) || fe.current) {
        var le;
        const Ie = ((le = window.visualViewport) == null ? void 0 : le.height) || 0, Ye = window.innerHeight;
        let Ge = Ye - Ie;
        const Vt = J.current.getBoundingClientRect().height || 0, ot = Vt > Ye * 0.8;
        gt.current || (gt.current = Vt);
        const Ot = J.current.getBoundingClientRect().top;
        if (Math.abs(Fe.current - Ge) > 60 && (fe.current = !fe.current), i && i.length > 0 && L1 && a1) {
          const qt = L1[a1] || 0;
          Ge += qt;
        }
        if (Fe.current = Ge, Vt > Ie || fe.current) {
          const qt = J.current.getBoundingClientRect().height;
          let vt = qt;
          qt > Ie && (vt = Ie - (ot ? Ot : Di)), k ? J.current.style.height = `${qt - Math.max(Ge, 0)}px` : J.current.style.height = `${Math.max(vt, Ie - Ot)}px`;
        } else jme() || (J.current.style.height = `${gt.current}px`);
        i && i.length > 0 && !fe.current ? J.current.style.bottom = "0px" : J.current.style.bottom = `${Math.max(Ge, 0)}px`;
      }
    }
    return (ee = window.visualViewport) == null || ee.addEventListener("resize", de), () => {
      var Me;
      return (Me = window.visualViewport) == null ? void 0 : Me.removeEventListener("resize", de);
    };
  }, [
    a1,
    i,
    L1
  ]);
  function j1(ee) {
    Xr(), M == null || M(), ee || q(!1), setTimeout(() => {
      i && Yn(i[0]);
    }, ze.DURATION * 1e3);
  }
  function Xn() {
    if (!J.current) return;
    const ee = document.querySelector("[data-vaul-drawer-wrapper]"), de = yo(J.current, C);
    Ze(J.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${ze.DURATION}s cubic-bezier(${ze.EASE.join(",")})`
    }), Ze(W.current, {
      transition: `opacity ${ze.DURATION}s cubic-bezier(${ze.EASE.join(",")})`,
      opacity: "1"
    }), s && de && de > 0 && G && Ze(ee, {
      borderRadius: `${sp}px`,
      overflow: "hidden",
      ...qe(C) ? {
        transform: `scale(${X1()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${X1()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${ze.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${ze.EASE.join(",")})`
    }, !0);
  }
  function Xr() {
    !Q || !J.current || (J.current.classList.remove(E2), X.current = !1, me(!1), ne.current = /* @__PURE__ */ new Date());
  }
  function e2(ee) {
    if (!Q || !J.current) return;
    J.current.classList.remove(E2), X.current = !1, me(!1), ne.current = /* @__PURE__ */ new Date();
    const de = yo(J.current, C);
    if (!ee || !Oa(ee.target, !1) || !de || Number.isNaN(de) || U.current === null) return;
    const Me = ne.current.getTime() - U.current.getTime(), le = ie.current - (qe(C) ? ee.pageY : ee.pageX), Ie = Math.abs(le) / Me;
    if (Ie > 0.05 && (z(!0), setTimeout(() => {
      z(!1);
    }, 200)), i) {
      Ha({
        draggedDistance: le * (C === "bottom" || C === "right" ? 1 : -1),
        closeDrawer: j1,
        velocity: Ie,
        dismissible: u
      }), o == null || o(ee, !0);
      return;
    }
    if (C === "bottom" || C === "right" ? le > 0 : le < 0) {
      Xn(), o == null || o(ee, !0);
      return;
    }
    if (Ie > ip) {
      j1(), o == null || o(ee, !1);
      return;
    }
    var Ye;
    const Ge = Math.min((Ye = J.current.getBoundingClientRect().height) != null ? Ye : 0, window.innerHeight);
    var Vt;
    const ot = Math.min((Vt = J.current.getBoundingClientRect().width) != null ? Vt : 0, window.innerWidth), Ot = C === "left" || C === "right";
    if (Math.abs(de) >= (Ot ? ot : Ge) * f) {
      j1(), o == null || o(ee, !1);
      return;
    }
    o == null || o(ee, !0), Xn();
  }
  I.useEffect(() => (G && (Ze(document.documentElement, {
    scrollBehavior: "auto"
  }), K.current = /* @__PURE__ */ new Date()), () => {
    Hme(document.documentElement, "scrollBehavior");
  }), [
    G
  ]);
  function t2(ee) {
    const de = ee ? (window.innerWidth - mo) / window.innerWidth : 1, Me = ee ? -16 : 0;
    re.current && window.clearTimeout(re.current), Ze(J.current, {
      transition: `transform ${ze.DURATION}s cubic-bezier(${ze.EASE.join(",")})`,
      transform: qe(C) ? `scale(${de}) translate3d(0, ${Me}px, 0)` : `scale(${de}) translate3d(${Me}px, 0, 0)`
    }), !ee && J.current && (re.current = setTimeout(() => {
      const le = yo(J.current, C);
      Ze(J.current, {
        transition: "none",
        transform: qe(C) ? `translate3d(0, ${le}px, 0)` : `translate3d(${le}px, 0, 0)`
      });
    }, 500));
  }
  function a2(ee, de) {
    if (de < 0) return;
    const Me = (window.innerWidth - mo) / window.innerWidth, le = Me + de * (1 - Me), Ie = -16 + de * mo;
    Ze(J.current, {
      transform: qe(C) ? `scale(${le}) translate3d(0, ${Ie}px, 0)` : `scale(${le}) translate3d(${Ie}px, 0, 0)`,
      transition: "none"
    });
  }
  function qa(ee, de) {
    const Me = qe(C) ? window.innerHeight : window.innerWidth, le = de ? (Me - mo) / Me : 1, Ie = de ? -16 : 0;
    de && Ze(J.current, {
      transition: `transform ${ze.DURATION}s cubic-bezier(${ze.EASE.join(",")})`,
      transform: qe(C) ? `scale(${le}) translate3d(0, ${Ie}px, 0)` : `scale(${le}) translate3d(${Ie}px, 0, 0)`
    });
  }
  return I.useEffect(() => {
    g || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    g
  ]), /* @__PURE__ */ I.createElement(Nr, {
    defaultOpen: L,
    onOpenChange: (ee) => {
      !u && !ee || (ee ? B(!0) : j1(!0), q(ee));
    },
    open: G
  }, /* @__PURE__ */ I.createElement(tp.Provider, {
    value: {
      activeSnapPoint: At,
      snapPoints: i,
      setActiveSnapPoint: Yn,
      drawerRef: J,
      overlayRef: W,
      onOpenChange: t,
      onPress: Kn,
      onRelease: e2,
      onDrag: Kr,
      dismissible: u,
      shouldAnimate: ke,
      handleOnly: h,
      isOpen: G,
      isDragging: Q,
      shouldFade: Va,
      closeDrawer: j1,
      onNestedDrag: a2,
      onNestedOpenChange: t2,
      onNestedRelease: qa,
      keyboardIsOpen: fe,
      modal: g,
      snapPointsOffset: L1,
      activeSnapPointIndex: a1,
      direction: C,
      shouldScaleBackground: s,
      setBackgroundColorOnScale: c,
      noBodyStyles: x,
      container: Z,
      autoFocus: R
    }
  }, a));
}
const dp = /* @__PURE__ */ I.forwardRef(function({ ...e }, t) {
  const { overlayRef: a, snapPoints: n, onRelease: o, shouldFade: i, isOpen: s, modal: c, shouldAnimate: f } = Bn(), d = op(t, a), u = n && n.length > 0;
  if (!c)
    return null;
  const h = I.useCallback((y) => o(y), [
    o
  ]);
  return /* @__PURE__ */ I.createElement(Da, {
    onMouseUp: h,
    ref: d,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": s && u ? "true" : "false",
    "data-vaul-snap-points-overlay": s && i ? "true" : "false",
    "data-vaul-animate": f != null && f.current ? "true" : "false",
    ...e
  });
});
dp.displayName = "Drawer.Overlay";
const lp = /* @__PURE__ */ I.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: a, ...n }, o) {
  const { drawerRef: i, onPress: s, onRelease: c, onDrag: f, keyboardIsOpen: d, snapPointsOffset: u, activeSnapPointIndex: h, modal: y, isOpen: m, direction: v, snapPoints: k, container: g, handleOnly: M, shouldAnimate: w, autoFocus: x } = Bn(), [C, L] = I.useState(!1), N = op(o, i), j = I.useRef(null), A = I.useRef(null), D = I.useRef(!1), H = k && k.length > 0;
  $me();
  const Z = (_, T, G = 0) => {
    if (D.current) return !0;
    const q = Math.abs(_.y), V = Math.abs(_.x), B = V > q, Q = [
      "bottom",
      "right"
    ].includes(T) ? 1 : -1;
    if (T === "left" || T === "right") {
      if (!(_.x * Q < 0) && V >= 0 && V <= G)
        return B;
    } else if (!(_.y * Q < 0) && q >= 0 && q <= G)
      return !B;
    return D.current = !0, !0;
  };
  I.useEffect(() => {
    H && window.requestAnimationFrame(() => {
      L(!0);
    });
  }, []);
  function R(_) {
    j.current = null, D.current = !1, c(_);
  }
  return /* @__PURE__ */ I.createElement(_a, {
    "data-vaul-drawer-direction": v,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": C ? "true" : "false",
    "data-vaul-snap-points": m && H ? "true" : "false",
    "data-vaul-custom-container": g ? "true" : "false",
    "data-vaul-animate": w != null && w.current ? "true" : "false",
    ...n,
    ref: N,
    style: u && u.length > 0 ? {
      "--snap-point-height": `${u[h ?? 0]}px`,
      ...t
    } : t,
    onPointerDown: (_) => {
      M || (n.onPointerDown == null || n.onPointerDown.call(n, _), j.current = {
        x: _.pageX,
        y: _.pageY
      }, s(_));
    },
    onOpenAutoFocus: (_) => {
      a == null || a(_), x || _.preventDefault();
    },
    onPointerDownOutside: (_) => {
      if (e == null || e(_), !y || _.defaultPrevented) {
        _.preventDefault();
        return;
      }
      d.current && (d.current = !1);
    },
    onFocusOutside: (_) => {
      if (!y) {
        _.preventDefault();
        return;
      }
    },
    onPointerMove: (_) => {
      if (A.current = _, M || (n.onPointerMove == null || n.onPointerMove.call(n, _), !j.current)) return;
      const T = _.pageY - j.current.y, G = _.pageX - j.current.x, q = _.pointerType === "touch" ? 10 : 2;
      Z({
        x: G,
        y: T
      }, v, q) ? f(_) : (Math.abs(G) > q || Math.abs(T) > q) && (j.current = null);
    },
    onPointerUp: (_) => {
      n.onPointerUp == null || n.onPointerUp.call(n, _), j.current = null, D.current = !1, c(_);
    },
    onPointerOut: (_) => {
      n.onPointerOut == null || n.onPointerOut.call(n, _), R(A.current);
    },
    onContextMenu: (_) => {
      n.onContextMenu == null || n.onContextMenu.call(n, _), A.current && R(A.current);
    }
  });
});
lp.displayName = "Drawer.Content";
const Yme = 250, Qme = 120, Jme = /* @__PURE__ */ I.forwardRef(function({ preventCycle: e = !1, children: t, ...a }, n) {
  const { closeDrawer: o, isDragging: i, snapPoints: s, activeSnapPoint: c, setActiveSnapPoint: f, dismissible: d, handleOnly: u, isOpen: h, onPress: y, onDrag: m } = Bn(), v = I.useRef(null), k = I.useRef(!1);
  function g() {
    if (k.current) {
      x();
      return;
    }
    window.setTimeout(() => {
      M();
    }, Qme);
  }
  function M() {
    if (i || e || k.current) {
      x();
      return;
    }
    if (x(), !s || s.length === 0) {
      d || o();
      return;
    }
    if (c === s[s.length - 1] && d) {
      o();
      return;
    }
    const L = s.findIndex((j) => j === c);
    if (L === -1) return;
    const N = s[L + 1];
    f(N);
  }
  function w() {
    v.current = window.setTimeout(() => {
      k.current = !0;
    }, Yme);
  }
  function x() {
    v.current && window.clearTimeout(v.current), k.current = !1;
  }
  return /* @__PURE__ */ I.createElement("div", {
    onClick: g,
    onPointerCancel: x,
    onPointerDown: (C) => {
      u && y(C), w();
    },
    onPointerMove: (C) => {
      u && m(C);
    },
    // onPointerUp is already handled by the content component
    ref: n,
    "data-vaul-drawer-visible": h ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...a
  }, /* @__PURE__ */ I.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
Jme.displayName = "Drawer.Handle";
function Kme(e) {
  const t = Bn(), { container: a = t.container, ...n } = e;
  return /* @__PURE__ */ I.createElement(Ar, {
    container: a,
    ...n
  });
}
const Ht = {
  Root: Wme,
  Content: lp,
  Overlay: dp,
  Trigger: as,
  Portal: Kme,
  Close: Sr,
  Title: Hn,
  Description: Vn
}, up = Nr, oxe = as, Xme = Ar, hp = Sr, pp = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  Da,
  {
    ref: a,
    className: he(
      "fixed inset-0 z-50 color-utility-overlay data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
pp.displayName = Da.displayName;
const ks = p.forwardRef(
  ({
    className: e,
    children: t,
    hasCloseIcon: a,
    dismissable: n = !0,
    overlayClasses: o,
    ...i
  }, s) => /* @__PURE__ */ l.jsxs(Xme, { children: [
    /* @__PURE__ */ l.jsx(pp, { className: o }),
    /* @__PURE__ */ l.jsx($1, { trapped: !1, children: /* @__PURE__ */ l.jsxs(
      _a,
      {
        ref: s,
        onInteractOutside: (c) => {
          n || c.preventDefault();
        },
        className: he(
          "max-w-lg fixed left-[50%] top-[50%] z-50 grid w-full translate-x-[-50%] translate-y-[-50%] gap-3 border color-bg-default shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] rounded sm:rounded-lg",
          e
        ),
        ...i,
        children: [
          t,
          a && /* @__PURE__ */ l.jsx(hp, { className: "absolute top-3 right-4 rounded-sm ring-offset-white hover:color-bg-default-hover p-1 transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused focus-visible:ring-offset-2 disabled:pointer-events-none data-[state=open]:color-bg-default-selected data-[state=open]:color-text-default", children: /* @__PURE__ */ l.jsx(Ce, { name: "X", className: "h-5 w-5" }) })
        ]
      }
    ) })
  ] })
);
ks.displayName = _a.displayName;
const yp = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.jsx("div", { className: he("flex flex-col space-y-1.5 text-left", e), ...t });
yp.displayName = "DialogHeader";
const mp = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: he(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
mp.displayName = "DialogFooter";
const kp = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  Hn,
  {
    ref: a,
    className: he("text-heading-md", e),
    ...t
  }
));
kp.displayName = Hn.displayName;
const gp = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  Vn,
  {
    ref: a,
    className: he("text-body-sm color-text-secondary", e),
    ...t
  }
));
gp.displayName = Vn.displayName;
const gs = ({
  shouldScaleBackground: e = !0,
  ...t
}) => /* @__PURE__ */ l.jsx(Ht.Root, { shouldScaleBackground: e, ...t });
gs.displayName = "Drawer";
const rxe = Ht.Trigger, eke = Ht.Portal, vs = Ht.Close, vp = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  Ht.Overlay,
  {
    ref: a,
    className: he(
      "fixed inset-0 z-50 color-utility-overlay data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
vp.displayName = Ht.Overlay.displayName;
const Ms = p.forwardRef(
  ({ className: e, children: t, hasCloseIcon: a, overlayClasses: n, onClose: o, ...i }, s) => /* @__PURE__ */ l.jsxs(eke, { children: [
    /* @__PURE__ */ l.jsx(vp, { className: n }),
    /* @__PURE__ */ l.jsx($1, { trapped: !1, children: /* @__PURE__ */ l.jsxs(
      Ht.Content,
      {
        ref: s,
        className: he(
          "fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col gap-4 rounded-t-[10px] border color-bg-default",
          e
        ),
        ...i,
        children: [
          t,
          a && /* @__PURE__ */ l.jsx(
            vs,
            {
              onClick: () => o == null ? void 0 : o(!1),
              className: "absolute top-3 right-4 rounded-sm ring-offset-white hover:color-bg-default-hover p-1 transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused focus-visible:ring-offset-2 disabled:pointer-events-none data-[state=open]:color-bg-default-selected data-[state=open]:color-text-default",
              children: /* @__PURE__ */ l.jsx(Ce, { name: "X", className: "h-5 w-5" })
            }
          )
        ]
      }
    ) })
  ] })
);
Ms.displayName = "DrawerContent";
const ws = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.jsx("div", { className: he("flex flex-col space-y-1.5 text-left", e), ...t });
ws.displayName = "DrawerHeader";
const xs = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.jsx("div", { className: he("flex gap-2", e), ...t });
xs.displayName = "DrawerFooter";
const Cs = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  Ht.Title,
  {
    ref: a,
    className: he("text-heading-md", e),
    ...t
  }
));
Cs.displayName = Ht.Title.displayName;
const bs = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  Ht.Description,
  {
    ref: a,
    className: he("text-body-sm color-text-secondary", e),
    ...t
  }
));
bs.displayName = Ht.Description.displayName;
var tke = typeof eo == "object" && eo && eo.Object === Object && eo, ake = typeof self == "object" && self && self.Object === Object && self;
tke || ake || Function("return this")();
var nke = typeof window < "u" ? er : Ne, oke = typeof window > "u";
function rke(e, {
  defaultValue: t = !1,
  initializeWithValue: a = !0
} = {}) {
  const n = (c) => oke ? t : window.matchMedia(c).matches, [o, i] = ve(() => a ? n(e) : t);
  function s() {
    i(n(e));
  }
  return nke(() => {
    const c = window.matchMedia(e);
    return s(), c.addListener ? c.addListener(s) : c.addEventListener("change", s), () => {
      c.removeListener ? c.removeListener(s) : c.removeEventListener("change", s);
    };
  }, [e]), o;
}
const ixe = ({
  open: e,
  onOpenChange: t,
  title: a,
  description: n,
  content: o,
  primaryAction: i,
  secondaryAction: s,
  className: c,
  contentClassName: f,
  disableOutsideClick: d,
  hasCloseIcon: u,
  overlayClasses: h,
  noOverlay: y
}) => rke("(max-width: 768px)") ? /* @__PURE__ */ l.jsx(
  gs,
  {
    dismissible: !d,
    open: e,
    onOpenChange: (v) => {
      d || t(v);
    },
    children: /* @__PURE__ */ l.jsxs(
      Ms,
      {
        className: he("w-full pb-4", c),
        hasCloseIcon: u,
        onClose: t,
        overlayClasses: he(h, { "bg-transparent": y }),
        children: [
          a && /* @__PURE__ */ l.jsx(ws, { className: "px-4 pt-4", children: /* @__PURE__ */ l.jsx(Cs, { className: "text-left text-heading-md", children: a }) }),
          /* @__PURE__ */ l.jsxs(
            "div",
            {
              className: he(
                "flex flex-col gap-4 w-full h-full border-t-[1px] text-body-sm color-text-default",
                {
                  "px-4 pt-4 pb-2": !f
                },
                f
              ),
              children: [
                /* @__PURE__ */ l.jsx(bs, { className: "hidden" }),
                n && /* @__PURE__ */ l.jsx("p", { children: n }),
                o && o
              ]
            }
          ),
          (s || i) && /* @__PURE__ */ l.jsxs(xs, { className: "px-6 gap-2 w-full", children: [
            s && /* @__PURE__ */ l.jsx(vs, { asChild: !0, children: /* @__PURE__ */ l.jsx(
              zt,
              {
                disabled: s == null ? void 0 : s.isLoading,
                isLoading: s == null ? void 0 : s.isLoading,
                className: s == null ? void 0 : s.className,
                variant: (s == null ? void 0 : s.variant) || "ghost",
                onClick: s == null ? void 0 : s.onClick,
                children: s == null ? void 0 : s.label
              }
            ) }),
            i && /* @__PURE__ */ l.jsx(
              zt,
              {
                disabled: i == null ? void 0 : i.isLoading,
                isLoading: i == null ? void 0 : i.isLoading,
                className: i == null ? void 0 : i.className,
                variant: (i == null ? void 0 : i.variant) || "default",
                onClick: i == null ? void 0 : i.onClick,
                children: i == null ? void 0 : i.label
              }
            )
          ] })
        ]
      }
    )
  }
) : /* @__PURE__ */ l.jsx(up, { open: e, onOpenChange: t, children: /* @__PURE__ */ l.jsxs(
  ks,
  {
    className: he("pb-4", c),
    dismissable: !d,
    hasCloseIcon: u,
    overlayClasses: he(h, { "bg-transparent": y }),
    children: [
      a && /* @__PURE__ */ l.jsx(yp, { className: "px-4 pt-4", children: /* @__PURE__ */ l.jsx(kp, { className: "text-heading-md", children: a }) }),
      /* @__PURE__ */ l.jsxs(
        "div",
        {
          className: he(
            "flex flex-col gap-2 w-full h-full border-t-[1px] text-body-sm color-text-default",
            {
              "px-4 pt-4 pb-2": !f
            },
            f
          ),
          children: [
            /* @__PURE__ */ l.jsx(gp, { className: "hidden" }),
            n && /* @__PURE__ */ l.jsx("p", { children: n }),
            o && o
          ]
        }
      ),
      (s || i) && /* @__PURE__ */ l.jsxs(mp, { className: "px-4 gap-2", children: [
        s && /* @__PURE__ */ l.jsx(hp, { asChild: !0, children: /* @__PURE__ */ l.jsx(
          zt,
          {
            disabled: s == null ? void 0 : s.isLoading,
            isLoading: s == null ? void 0 : s.isLoading,
            className: s == null ? void 0 : s.className,
            variant: (s == null ? void 0 : s.variant) || "ghost",
            onClick: s == null ? void 0 : s.onClick,
            children: s == null ? void 0 : s.label
          }
        ) }),
        i && /* @__PURE__ */ l.jsx(
          zt,
          {
            disabled: i == null ? void 0 : i.isLoading,
            isLoading: i == null ? void 0 : i.isLoading,
            className: i == null ? void 0 : i.className,
            variant: (i == null ? void 0 : i.variant) || "default",
            onClick: i == null ? void 0 : i.onClick,
            children: i == null ? void 0 : i.label
          }
        )
      ] })
    ]
  }
) }), ike = Lt("", {
  variants: {
    size: {
      sm: "py-1",
      md: "py-2",
      lg: "py-3"
    },
    disabled: {
      true: "cursor-not-allowed disabled:color-text-disabled",
      false: ""
    }
  },
  defaultVariants: {
    size: "md",
    disabled: !1
  }
}), ske = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  g8e,
  {
    ref: a,
    className: S("w-[400px]", e),
    ...t
  }
));
ske.displayName = "Accordion";
const cke = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  v8e,
  {
    ref: a,
    className: S("border-b", e),
    ...t
  }
));
cke.displayName = "AccordionItem";
const fke = p.forwardRef(({ className: e, children: t, size: a, disabled: n, ...o }, i) => /* @__PURE__ */ l.jsx(M8e, { className: "flex", children: /* @__PURE__ */ l.jsxs(
  R4,
  {
    ref: i,
    className: S(
      "flex flex-1 items-center justify-between px-4 color-text-default text-heading-xsm transition-all hover:color-bg-default-hover [&[data-state=open]>svg]:rotate-180",
      ike({ size: a, disabled: n }),
      e
    ),
    disabled: n,
    ...o,
    children: [
      t,
      /* @__PURE__ */ l.jsx(
        tr,
        {
          className: S(
            "h-4 w-4 shrink-0 color-text-default transition-transform duration-200",
            n ? "color-text-disabled" : "color-text-default"
          )
        }
      )
    ]
  }
) }));
fke.displayName = R4.displayName;
const dke = p.forwardRef(({ className: e, children: t, ...a }, n) => /* @__PURE__ */ l.jsx(
  H4,
  {
    ref: n,
    className: "px-4 overflow-hidden text-body-sm color-text-default data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
    ...a,
    children: /* @__PURE__ */ l.jsx("div", { className: S("pb-6 pt-2", e), children: t })
  }
));
dke.displayName = H4.displayName;
const Mp = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  Oh,
  {
    className: S("grid gap-2", e),
    ...t,
    ref: a
  }
));
Mp.displayName = Oh.displayName;
const wp = p.forwardRef(({ className: e, disabled: t, size: a, ...n }, o) => /* @__PURE__ */ l.jsx(
  qh,
  {
    ref: o,
    className: S(
      "flex items-center justify-center aspect-square rounded-full border-2 color-border-active color-text-default hover:color-bg-default-hover transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-focused focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:color-border-disabled",
      {
        "w-[16px]": a === "sm",
        "w-[20px]": a === "lg"
      },
      e
    ),
    disabled: t,
    ...n,
    children: /* @__PURE__ */ l.jsx(
      J9e,
      {
        className: S(
          "rounded-full aspect-square flex items-center justify-center",
          t ? "color-icon-disabled dark:color-bg-disabled" : "color-bg-default-inverse",
          {
            "w-[8px]": a === "sm",
            "w-[12px]": a === "lg"
          }
        )
      }
    )
  }
));
wp.displayName = qh.displayName;
const lke = ({
  id: e,
  label: t,
  description: a,
  selectedValue: n,
  value: o,
  content: i,
  size: s
}) => {
  const c = Le(null), f = () => {
    c.current && c.current.click();
  };
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(
      R1.div,
      {
        initial: !1,
        className: S(
          "flex items-center p-4 border color-border-default rounded-lg cursor-pointer transition-colors",
          n === o ? "color-bg-default-selected" : "color-bg-default"
        ),
        onClick: f,
        children: /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ l.jsxs(
            "span",
            {
              className: S(
                "inline-flex items-center",
                s === "lg" ? "gap-2" : "gap-1"
              ),
              children: [
                /* @__PURE__ */ l.jsx(
                  wp,
                  {
                    ref: c,
                    id: `rc-item-${e}`,
                    value: o,
                    size: s
                  }
                ),
                /* @__PURE__ */ l.jsx(
                  Z1,
                  {
                    htmlFor: `rc-item-${e}`,
                    className: S({
                      "text-helper-text-sm": s === "sm",
                      "text-heading-xsm": s === "lg"
                    }),
                    children: t
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ l.jsx(
            "p",
            {
              className: S(
                "color-text-secondary color-text-default",
                s === "lg" ? "text-body-sm" : "text-helper-text-sm"
              ),
              children: a
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ l.jsx(e3e, { initial: !1, children: i && n === o && /* @__PURE__ */ l.jsx(uke, { content: i }) })
  ] });
}, sxe = Et(
  ({ items: e, className: t, size: a = "lg", content: n, selectedValue: o, setSelectedValue: i }, s) => !e || e.length === 0 ? null : /* @__PURE__ */ l.jsx(
    Mp,
    {
      ref: s,
      defaultValue: o,
      className: S("space-y-2 h-full", t),
      onValueChange: (c) => i(c),
      children: e.map((c, f) => /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
        lke,
        {
          id: c.id,
          value: c.value,
          description: c.description,
          label: c.label,
          selectedValue: o,
          size: a,
          content: n ? n(o) : null
        }
      ) }, f))
    }
  )
), uke = ({ content: e }) => {
  const [t, a] = ve(0), n = Le(null);
  return Ne(() => {
    e && n.current ? a(n.current.scrollHeight) : a(0);
  }, [e]), /* @__PURE__ */ l.jsx(
    R1.div,
    {
      ref: n,
      initial: { height: 0, opacity: 0 },
      animate: { height: e ? t : 0, opacity: e ? 1 : 0 },
      exit: { height: 0, opacity: 0 },
      transition: { duration: 0.3 },
      className: "overflow-hidden",
      children: /* @__PURE__ */ l.jsx("div", { className: "p-4 flex flex-col gap-4", children: e })
    }
  );
}, cxe = Et(({ label: e, description: t, checked: a, onChange: n, size: o = "lg" }, i) => /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col gap-2 w-full", ref: i, children: [
  /* @__PURE__ */ l.jsxs("div", { className: "flex justify-between items-center", children: [
    /* @__PURE__ */ l.jsx(
      Z1,
      {
        htmlFor: "dynamic-content",
        className: S({
          "text-helper-text-sm": o === "sm",
          "text-heading-xsm": o === "lg"
        }),
        children: e
      }
    ),
    /* @__PURE__ */ l.jsx(
      Yi,
      {
        id: "dynamic-content",
        defaultChecked: a,
        onCheckedChange: n
      }
    )
  ] }),
  /* @__PURE__ */ l.jsx(
    "p",
    {
      className: S(
        "color-text-secondary color-text-default w-[85%]",
        o === "lg" ? "text-body-sm" : "text-helper-text-sm"
      ),
      children: t
    }
  )
] })), fxe = I.forwardRef(
  ({
    isActive: e,
    isCompleted: t,
    firstStep: a,
    lastStep: n,
    stepNumber: o,
    title: i,
    className: s,
    type: c,
    layout: f,
    stepContent: d,
    isLoading: u,
    ...h
  }, y) => /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: he(
        "flex w-full h-full justify-center gap-2",
        f === "vertical" ? "flex-row relative items-start" : "flex-col items-center",
        s
      ),
      ref: y,
      ...h,
      children: [
        /* @__PURE__ */ l.jsxs(
          "div",
          {
            className: he("flex w-full items-center justify-center", {
              "flex-col flex-[0.05] relative h-full": f === "vertical",
              "!h-[4rem]": f === "vertical" && t,
              "translate-x-1/2 right-4 relative": f === "horizontal"
            }),
            children: [
              /* @__PURE__ */ l.jsx(
                "div",
                {
                  className: he(
                    "flex h-8 w-8 flex-none flex-col items-center justify-center gap-2 rounded-full",
                    { "color-bg-default-inverse": t || e || a },
                    { "color-bg-tertiary": !t || !e }
                  ),
                  children: o ? /* @__PURE__ */ l.jsx(
                    "span",
                    {
                      className: he("text-body-md-bold", {
                        "color-icon-inverse": t || e || a,
                        "color-icon-secondary": !t || !e
                      }),
                      children: t ? /* @__PURE__ */ l.jsx(Gi, { size: "16px", className: "color-icon-inverse" }) : o
                    }
                  ) : null
                }
              ),
              /* @__PURE__ */ l.jsx(
                "div",
                {
                  id: "step-line",
                  className: he(
                    "flex grow shrink-0 basis-0 flex-col items-center gap-2 border",
                    {
                      "border-transparent": n && f === "horizontal" || f === "vertical" && n && t,
                      "color-border-active": t,
                      "color-border-default": !t,
                      "border-solid": c === "solid",
                      "border-dashed": c === "dashed",
                      "h-full": f === "vertical"
                    }
                  )
                }
              )
            ]
          }
        ),
        i ? /* @__PURE__ */ l.jsx(
          "div",
          {
            id: "step-content",
            className: he("text-heading-xsm flex flex-col w-full h-full", {
              "color-text-default": t || e || a,
              "color-text-secondary": !e && !t,
              "flex-1 text-left relative gap-4 py-2": f === "vertical",
              "text-center": f === "horizontal",
              "opacity-50 pointer-events-none": !e && !a && !t
            }),
            children: f === "vertical" ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
              /* @__PURE__ */ l.jsxs("span", { className: "inline-flex gap-2 items-center", children: [
                i,
                u && /* @__PURE__ */ l.jsx(
                  Ce,
                  {
                    name: "LoaderCircle",
                    size: "sm",
                    className: "animate-spin",
                    fill: "transparent",
                    stroke: "currentColor"
                  }
                )
              ] }),
              d && !t && e ? d : null
            ] }) : /* @__PURE__ */ l.jsx(
              "div",
              {
                className: he(
                  "absolute flex flex-col gap-4 top-1/2 left-1/2 -translate-x-1/2 translate-y-1/4 transform max-w-sm",
                  {
                    hidden: !e && !t
                  }
                ),
                children: d && !t ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                  i,
                  d
                ] }) : null
              }
            )
          }
        ) : null
      ]
    }
  )
), dxe = I.forwardRef(
  ({ children: e, className: t, layout: a = "horizontal", ...n }, o) => e ? /* @__PURE__ */ l.jsx(
    "div",
    {
      className: he(
        "flex items-center justify-center",
        {
          "flex-col w-full max-w-sm": a === "vertical",
          "w-full": a === "horizontal"
        },
        t
      ),
      ref: o,
      ...n,
      children: I.Children.map(
        e,
        (i) => I.isValidElement(i) ? I.cloneElement(i, { layout: a }) : i
      )
    }
  ) : null
), hke = Nr, lxe = as, pke = Sr, yke = Ar, xp = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  Da,
  {
    className: S(
      "fixed inset-0 z-50 color-utility-overlay data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: a
  }
));
xp.displayName = Da.displayName;
const mke = Lt(
  "fixed z-50 gap-4 color-bg-default p-4 shadow-elevation-4 transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4 data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), Cp = p.forwardRef(
  ({
    side: e = "right",
    className: t,
    overlayClasses: a,
    dismissible: n = !0,
    hideCloseButton: o = !1,
    children: i,
    ...s
  }, c) => {
    const f = p.useRef(null), d = p.useRef(0), u = p.useRef(0), h = (m) => {
      d.current = m.touches[0].clientX, u.current = m.touches[0].clientY;
    }, y = (m) => {
      var w, x, C, L;
      const v = m.changedTouches[0].clientX, k = m.changedTouches[0].clientY, g = v - d.current, M = k - u.current;
      e === "left" && g < -50 ? (w = f.current) == null || w.click() : e === "right" && g > 50 ? (x = f.current) == null || x.click() : e === "bottom" && M > 50 ? (C = f.current) == null || C.click() : e === "top" && M < -50 && ((L = f.current) == null || L.click());
    };
    return /* @__PURE__ */ l.jsxs(yke, { children: [
      /* @__PURE__ */ l.jsx(xp, { className: a }),
      /* @__PURE__ */ l.jsx($1, { trapped: !1, children: /* @__PURE__ */ l.jsxs(
        _a,
        {
          ref: c,
          className: S(mke({ side: e }), t),
          ...s,
          onTouchStart: h,
          onTouchEnd: y,
          children: [
            !o && /* @__PURE__ */ l.jsx(
              Sr,
              {
                ref: f,
                className: "absolute right-4 top-3 rounded-sm ring-offset-white hover:color-bg-default-hover p-1 transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused focus-visible:ring-offset-2 disabled:pointer-events-none data-[state=open]:color-bg-default-selected data-[state=open]:color-text-default",
                children: n && /* @__PURE__ */ l.jsx(Ce, { name: "X", className: "h-5 w-5" })
              }
            ),
            i
          ]
        }
      ) })
    ] });
  }
);
Cp.displayName = _a.displayName;
const bp = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.jsx("div", { className: S("flex flex-col space-y-4 text-left", e), ...t });
bp.displayName = "SheetHeader";
const kke = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: S(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
kke.displayName = "SheetFooter";
const Lp = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  Hn,
  {
    ref: a,
    className: S("text-heading-md", e),
    ...t
  }
));
Lp.displayName = Hn.displayName;
const gke = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  Vn,
  {
    ref: a,
    className: S("text-body-sm color-text-secondary", e),
    ...t
  }
));
gke.displayName = Vn.displayName;
const uxe = ({
  open: e,
  onOpenChange: t,
  title: a,
  titleIcon: n,
  content: o,
  className: i,
  headerClassName: s,
  side: c = "left",
  noOverlay: f = !1,
  overlayClasses: d,
  rounded: u = !1,
  dismissible: h
}) => /* @__PURE__ */ l.jsx(hke, { open: e, onOpenChange: t, children: /* @__PURE__ */ l.jsxs(
  Cp,
  {
    className: he(
      {
        "rounded-b-lg": u && c === "top",
        "rounded-l-lg": u && c === "right",
        "rounded-t-lg": u && c === "bottom",
        "rounded-r-lg": u && c === "left"
      },
      i
    ),
    side: c,
    overlayClasses: he(d, { "bg-transparent": f }),
    dismissible: h,
    hideCloseButton: n === "X",
    children: [
      a && /* @__PURE__ */ l.jsx(bp, { className: s, children: /* @__PURE__ */ l.jsxs(Lp, { className: "text-heading-sm inline-flex gap-2 items-center", children: [
        n && (n !== "X" ? /* @__PURE__ */ l.jsx(Ce, { name: n, size: "md" }) : /* @__PURE__ */ l.jsx(pke, { className: "rounded-sm ring-offset-white hover:color-bg-default-hover p-1 transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused focus-visible:ring-offset-2 disabled:pointer-events-none data-[state=open]:color-bg-default-selected data-[state=open]:color-text-default", children: /* @__PURE__ */ l.jsx(Ce, { name: n, size: "md" }) })),
        a
      ] }) }),
      o
    ]
  }
) }), hxe = ({
  title: e,
  open: t = !1,
  onOpenChange: a,
  content: n,
  className: o,
  headerClassName: i,
  contentClassName: s,
  side: c = "right",
  rounded: f = !1,
  dismissible: d = !0
}) => {
  const u = () => {
    a && a(!1);
  };
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: S(
        `fixed z-10 transition-transform duration-300 ${t ? "translate-x-0" : "translate-x-full"} ${c === "right" ? "right-0 top-0 bottom-0" : ""} ${c === "left" ? "left-0 top-0 bottom-0" : ""} ${c === "top" ? "top-0 left-0 right-0" : ""} ${c === "bottom" ? "bottom-0 left-0 right-0" : ""} min-w-[300px] ${f ? "rounded-[16px]" : ""}`,
        o
      ),
      children: /* @__PURE__ */ l.jsxs(
        "div",
        {
          className: S(
            "color-bg-default h-full w-full p-4 flex flex-col",
            s
          ),
          children: [
            e && /* @__PURE__ */ l.jsx("div", { className: i, children: /* @__PURE__ */ l.jsx("h2", { className: "text-heading-sm color-text-default flex items-center gap-2", children: e }) }),
            d && /* @__PURE__ */ l.jsx(
              ar,
              {
                onClick: u,
                className: "absolute right-4 top-3 rounded-sm min-w-7 min-h-7 h-7 w-7 p-1",
                icon: "X",
                variant: "ghost",
                size: "md"
              }
            ),
            /* @__PURE__ */ l.jsx("div", { className: "color-text-default", children: n })
          ]
        }
      )
    }
  );
}, Ls = R9e, js = V9e, pxe = H9e, yxe = q9e, Er = p.forwardRef(
  ({ className: e, align: t = "center", sideOffset: a = 4, elevation: n, container: o, ...i }, s) => /* @__PURE__ */ l.jsx(O9e, { container: o, children: /* @__PURE__ */ l.jsx(
    Ah,
    {
      ref: s,
      align: t,
      sideOffset: a,
      className: S(
        "z-50 rounded-md color-bg-default color-text-default outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        n ? `shadow-elevation-${n}` : "border",
        e
      ),
      ...i
    }
  ) })
);
Er.displayName = Ah.displayName;
const mxe = ({
  content: e,
  anchorTrigger: t,
  className: a,
  triggerClassName: n,
  ...o
}) => {
  const i = (s) => {
    I.isValidElement(t) && t.props.onClick && t.props.onClick(s);
  };
  return /* @__PURE__ */ l.jsxs(Ls, { children: [
    /* @__PURE__ */ l.jsx(js, { onClick: i, className: n, children: t }),
    /* @__PURE__ */ l.jsx(Er, { ...o, className: a, children: e })
  ] });
}, kxe = ({
  content: e,
  anchorTrigger: t,
  controlled: a = !1,
  isOpen: n,
  onClose: o,
  ...i
}) => {
  const [s, c] = ve(!1), f = Ve(
    (h) => {
      a || (c((y) => !y), I.isValidElement(t) && t.props.onClick && t.props.onClick(h));
    },
    [a, t]
  ), d = Ve(
    (h) => {
      const y = h.target;
      !y.closest(".popover-trigger") && !y.closest(".popover-content") && (a || c(!1), o == null || o());
    },
    [a, o]
  );
  I.useEffect(() => (document.addEventListener("click", d), () => {
    document.removeEventListener("click", d);
  }), [d]);
  const u = a ? n : s;
  return /* @__PURE__ */ l.jsxs(Ls, { open: u, onOpenChange: c, children: [
    /* @__PURE__ */ l.jsx(js, { className: "popover-trigger", onClick: f, children: t }),
    /* @__PURE__ */ l.jsx(Er, { className: "popover-content", ...i, children: e })
  ] });
}, vke = m7e, Mke = w7e, wke = k7e, jp = p.forwardRef(({ className: e, children: t, ...a }, n) => /* @__PURE__ */ l.jsxs(
  k3,
  {
    ref: n,
    className: S(
      "flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border color-border-default color-bg-default color-text-default px-3 py-2 text-body-sm ring-offset-2 placeholder:color-text-disabled focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focused disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 [&[data-state=open]>svg]:rotate-180 transition-all hover:color-border-hover",
      e
    ),
    ...a,
    children: [
      t,
      /* @__PURE__ */ l.jsx(g7e, { asChild: !0, children: /* @__PURE__ */ l.jsx(tr, { className: "h-4 w-4 shrink-0 color-text-secondary transition-transform duration-200" }) })
    ]
  }
));
jp.displayName = k3.displayName;
const Np = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  w3,
  {
    ref: a,
    className: S("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ l.jsx(Td, { className: "h-4 w-4 shrink-0 color-text-default" })
  }
));
Np.displayName = w3.displayName;
const Ap = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  x3,
  {
    ref: a,
    className: S("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ l.jsx(tr, { className: "h-4 w-4 shrink-0 color-text-default" })
  }
));
Ap.displayName = x3.displayName;
const Sp = p.forwardRef(
  ({ className: e, children: t, position: a = "popper", sideOffset: n, alignOffset: o, ...i }, s) => /* @__PURE__ */ l.jsx(v7e, { children: /* @__PURE__ */ l.jsxs(
    g3,
    {
      ref: s,
      className: S(
        "relative z-50 max-h-96 overflow-hidden rounded-md border color-border-default color-bg-default color-text-default shadow-elevation-3 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        a === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: a,
      sideOffset: n,
      alignOffset: o,
      ...i,
      children: [
        /* @__PURE__ */ l.jsx(Np, {}),
        /* @__PURE__ */ l.jsx(
          M7e,
          {
            className: S(
              "p-1",
              a === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
            ),
            children: t
          }
        ),
        /* @__PURE__ */ l.jsx(Ap, {})
      ]
    }
  ) })
);
Sp.displayName = g3.displayName;
const Ip = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  v3,
  {
    ref: a,
    className: S(
      "px-1 py-1.5 color-text-disabled text-helper-text-sm font-medium",
      e
    ),
    ...t
  }
));
Ip.displayName = v3.displayName;
const Tp = p.forwardRef(({ className: e, children: t, ...a }, n) => /* @__PURE__ */ l.jsxs(
  M3,
  {
    ref: n,
    className: S(
      "relative flex w-full cursor-pointer select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-body-sm outline-none color-text-default data-[disabled]:color-text-disabled data-[disabled]:pointer-events-none data-[highlighted]:color-bg-default-selected data-[highlighted]:color-text-default",
      e
    ),
    ...a,
    children: [
      /* @__PURE__ */ l.jsx("span", { className: "absolute right-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ l.jsx(C7e, { children: /* @__PURE__ */ l.jsx(Gi, { className: "h-4 w-4 color-text-default" }) }) }),
      /* @__PURE__ */ l.jsx(x7e, { children: t })
    ]
  }
));
Tp.displayName = M3.displayName;
const xke = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  C3,
  {
    ref: a,
    className: S("-mx-1 my-1 h-px color-bg-disabled", e),
    ...t
  }
));
xke.displayName = C3.displayName;
const gxe = ({
  id: e,
  label: t,
  triggerClassName: a,
  contentClassName: n,
  className: o,
  placeholder: i = "Select an option",
  defaultValue: s,
  onValueChange: c,
  disabled: f = !1,
  items: d,
  sideOffset: u = 0,
  alignOffset: h = 0
}) => !d || d.length === 0 ? null : /* @__PURE__ */ l.jsx(
  vke,
  {
    defaultValue: s,
    disabled: f,
    onValueChange: c,
    children: /* @__PURE__ */ l.jsxs("div", { className: he(o), children: [
      /* @__PURE__ */ l.jsx(jp, { className: he(a), children: /* @__PURE__ */ l.jsx(wke, { placeholder: i, id: e }) }),
      /* @__PURE__ */ l.jsx(
        Sp,
        {
          className: he(n),
          sideOffset: u,
          alignOffset: h,
          children: /* @__PURE__ */ l.jsxs(Mke, { children: [
            t && /* @__PURE__ */ l.jsx(Ip, { children: t }),
            d.map((y) => /* @__PURE__ */ l.jsx(Tp, { value: y.value, children: /* @__PURE__ */ l.jsxs(
              "div",
              {
                className: he("flex items-center", {
                  "gap-4": y.icon,
                  "gap-2": !y.icon
                }),
                children: [
                  y.icon === void 0 && y.avatar === void 0 ? null : y.icon ? /* @__PURE__ */ l.jsx(Ce, { size: "sm", name: y.icon, className: "min-w-fit" }) : y.avatar ? /* @__PURE__ */ l.jsx(
                    zo,
                    {
                      size: "lg",
                      src: y.avatar || "",
                      alt: y.label || "Untitled",
                      content: "image",
                      variant: "rounded",
                      className: "min-w-10 aspect-square"
                    }
                  ) : /* @__PURE__ */ l.jsx(
                    zo,
                    {
                      size: "lg",
                      alt: y.label || "Untitled",
                      content: "text",
                      variant: "rounded",
                      className: "min-w-10 aspect-square"
                    }
                  ),
                  /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col gap-2", children: [
                    /* @__PURE__ */ l.jsxs("span", { className: he("flex items-center gap-2"), children: [
                      /* @__PURE__ */ l.jsx(Z1, { className: "text-body-sm", children: y.label }),
                      y.pro && /* @__PURE__ */ l.jsx(
                        Ju,
                        {
                          variant: "gray",
                          className: "text-[10px] !py-[2px] !px-1 !h-auto",
                          children: "Upgrade plan"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ l.jsx("p", { className: "color-text-secondary text-helper-text-sm max-w-[70vw] sm:max-w-fit", children: y.description })
                  ] })
                ]
              }
            ) }, y.value))
          ] })
        }
      )
    ] })
  }
), Cke = Lt(
  "relative w-full rounded-md px-4 py-2 text-body-sm flex gap-4 items-center [&>svg]:color-text-default",
  {
    variants: {
      variant: {
        default: "border color-border-default color-bg-default color-text-default",
        danger: "color-bg-danger-light color-text-danger [&>svg]:color-text-danger"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), zp = p.forwardRef(({ className: e, variant: t, ...a }, n) => /* @__PURE__ */ l.jsx(
  "div",
  {
    ref: n,
    role: "alert",
    className: S(Cke({ variant: t }), e),
    ...a
  }
));
zp.displayName = "Alert";
const Dp = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx("h5", { ref: a, className: S("mb-1 text-heading-xsm", e), ...t }));
Dp.displayName = "AlertTitle";
const _p = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  "div",
  {
    ref: a,
    className: S("text-body-sm [&_p]:leading-relaxed", e),
    ...t
  }
));
_p.displayName = "AlertDescription";
const vxe = ({
  title: e,
  description: t,
  variant: a,
  icon: n,
  className: o,
  iconClassName: i,
  ...s
}) => /* @__PURE__ */ l.jsxs(zp, { variant: a, className: o, ...s, children: [
  /* @__PURE__ */ l.jsx(
    Ce,
    {
      size: "md",
      name: n,
      className: S("min-w-fit", i)
    }
  ),
  /* @__PURE__ */ l.jsxs("div", { children: [
    e && /* @__PURE__ */ l.jsx(Dp, { children: e }),
    /* @__PURE__ */ l.jsx(_p, { children: t })
  ] })
] });
function _i(e) {
  return [].concat(e);
}
function Ns(e) {
  return e.startsWith(":");
}
function Pp(e) {
  return Rr(e) && (e === "*" || e.length > 1 && ":>~.+*".includes(e.slice(0, 1)) || Vp(e));
}
function Ep(e, t) {
  return (Rr(t) || typeof t == "number") && !Hp(e) && !Ns(e) && !Rp(e);
}
function Rp(e) {
  return e.startsWith("@media");
}
function bke(e) {
  return e === ".";
}
function Hp(e) {
  return e === "--";
}
function Rr(e) {
  return e + "" === e;
}
function Vp(e) {
  return Rr(e) && (e.startsWith("&") || Ns(e));
}
function Yo(e, t = "") {
  return e.filter(Boolean).join(t);
}
function Op(e, t) {
  let a = 0;
  if (t.length === 0)
    return a.toString();
  for (let n = 0; n < t.length; n++) {
    const o = t.charCodeAt(n);
    a = (a << 5) - a + o, a = a & a;
  }
  return `${e ?? "cl"}_${a.toString(36)}`;
}
function Lke(e, t) {
  return e === "content" ? `"${t}"` : t;
}
function jke(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function Jf(e, t) {
  return `${e}:${t}`;
}
function Nke(e) {
  return e ? `.${e}` : "";
}
function Ake(e, t) {
  return e ? `${e}
${t}` : t;
}
var qp = class Bp {
  constructor(t, a, n, o) {
    this.sheet = t, this.property = a, this.value = n, this.selector = o, this.property = a, this.value = n, this.joined = Jf(a, n);
    const i = this.selector.preconditions.concat(
      this.selector.postconditions
    );
    this.hash = this.selector.hasConditions ? this.selector.scopeClassName : Op(this.sheet.name, this.joined), this.key = Yo([this.joined, i, this.hash]);
  }
  toString() {
    let t = Pi(this.selector.preconditions, {
      right: this.hash
    });
    return t = Pi(this.selector.postconditions, {
      left: t
    }), `${t} {${Bp.genRule(this.property, this.value)}}`;
  }
  static genRule(t, a) {
    const n = jke(t);
    return Jf(
      n,
      Lke(t, a)
    ) + ";";
  }
};
function Pi(e, { left: t = "", right: a = "" } = {}) {
  const n = e.reduce((o, i) => Ns(i) ? o + i : Vp(i) ? o + i.slice(1) : Yo([o, i], " "), t);
  return Yo([n, Nke(a)], " ");
}
var Ske = class jo {
  constructor(t, a = null, {
    preconditions: n,
    postconditions: o
  } = {}) {
    this.sheet = t, this.preconditions = [], this.scopeClassName = null, this.scopeName = null, this.postconditions = [], this.preconditions = n ? _i(n) : [], this.postconditions = o ? _i(o) : [], this.setScope(a);
  }
  setScope(t) {
    return t ? (this.scopeClassName || (this.scopeName = t, this.scopeClassName = Op(
      this.sheet.name,
      // adding the count guarantees uniqueness across style.create calls
      t + this.sheet.count
    )), this) : this;
  }
  get hasConditions() {
    return this.preconditions.length > 0 || this.postconditions.length > 0;
  }
  addScope(t) {
    return new jo(this.sheet, t, {
      preconditions: this.preconditions,
      postconditions: this.postconditions
    });
  }
  addPrecondition(t) {
    return new jo(this.sheet, this.scopeClassName, {
      postconditions: this.postconditions,
      preconditions: this.preconditions.concat(t)
    });
  }
  addPostcondition(t) {
    return new jo(this.sheet, this.scopeClassName, {
      preconditions: this.preconditions,
      postconditions: this.postconditions.concat(t)
    });
  }
  createRule(t, a) {
    return new qp(this.sheet, t, a, this);
  }
}, Ike = class {
  constructor(e, t) {
    this.name = e, this.rootNode = t, this.storedStyles = {}, this.storedClasses = {}, this.style = "", this.count = 0, this.id = `flairup-${e}`, this.styleTag = this.createStyleTag();
  }
  getStyle() {
    return this.style;
  }
  append(e) {
    this.style = Ake(this.style, e);
  }
  apply() {
    this.count++, this.styleTag && (this.styleTag.innerHTML = this.style);
  }
  isApplied() {
    return !!this.styleTag;
  }
  createStyleTag() {
    if (typeof document > "u" || this.isApplied() || // Explicitly disallow mounting to the DOM
    this.rootNode === null)
      return this.styleTag;
    const e = document.createElement("style");
    return e.type = "text/css", e.id = this.id, (this.rootNode ?? document.head).appendChild(e), e;
  }
  addRule(e) {
    const t = this.storedClasses[e.key];
    return Rr(t) ? t : (this.storedClasses[e.key] = e.hash, this.storedStyles[e.hash] = [e.property, e.value], this.append(e.toString()), e.hash);
  }
};
function As(e, t) {
  for (const a in e)
    t(a.trim(), e[a]);
}
function pe(...e) {
  const t = e.reduce((a, n) => (n instanceof Set ? a.push(...n) : typeof n == "string" ? a.push(n) : Array.isArray(n) ? a.push(pe(...n)) : typeof n == "object" && Object.entries(n).forEach(([o, i]) => {
    i && a.push(o);
  }), a), []);
  return Yo(t, " ").trim();
}
function Tke(e, t) {
  const a = new Ike(e, t);
  return {
    create: n,
    getStyle: a.getStyle.bind(a),
    isApplied: a.isApplied.bind(a)
  };
  function n(o) {
    const i = {};
    return Zp(a, o, new Ske(a)).forEach(
      ([c, f, d]) => {
        Hr(a, f, d).forEach(
          (u) => {
            s(c, u);
          }
        );
      }
    ), a.apply(), i;
    function s(c, f) {
      i[c] = i[c] ?? /* @__PURE__ */ new Set(), i[c].add(f);
    }
  }
}
function Zp(e, t, a) {
  const n = [];
  return As(t, (o, i) => {
    if (Pp(o))
      return Zp(
        e,
        i,
        a.addPrecondition(o)
      ).forEach((s) => n.push(s));
    n.push([o, t[o], a.addScope(o)]);
  }), n;
}
function Hr(e, t, a) {
  const n = /* @__PURE__ */ new Set();
  return As(t, (o, i) => {
    let s = [];
    if (Pp(o))
      s = Hr(
        e,
        i,
        a.addPostcondition(o)
      );
    else if (bke(o))
      s = _i(i);
    else if (Rp(o))
      s = Dke(e, i, o, a);
    else if (Hp(o))
      s = zke(e, i, a);
    else if (Ep(o, i)) {
      const c = a.createRule(o, i);
      e.addRule(c), n.add(c.hash);
    }
    return Fp(s, n);
  }), n;
}
function Fp(e, t) {
  return e.forEach((a) => t.add(a)), t;
}
function zke(e, t, a) {
  const n = /* @__PURE__ */ new Set(), o = [];
  if (As(t, (i, s) => {
    if (Ep(i, s)) {
      o.push(qp.genRule(i, s));
      return;
    }
    const c = Hr(e, s ?? {}, a);
    Fp(c, n);
  }), !a.scopeClassName)
    return n;
  if (o.length) {
    const i = o.join(" ");
    e.append(
      `${Pi(a.preconditions, {
        right: a.scopeClassName
      })} {${i}}`
    );
  }
  return n.add(a.scopeClassName), n;
}
function Dke(e, t, a, n) {
  e.append(a + " {");
  const o = Hr(e, t, n);
  return e.append("}"), o;
}
function Pe() {
  return Pe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];
      for (var n in a)
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
    }
    return e;
  }, Pe.apply(this, arguments);
}
function _ke(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Ei(e, t);
}
function Ei(e, t) {
  return Ei = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Ei(e, t);
}
function Gp(e, t) {
  if (e == null) return {};
  var a = {}, n = Object.keys(e), o, i;
  for (i = 0; i < n.length; i++)
    o = n[i], !(t.indexOf(o) >= 0) && (a[o] = e[o]);
  return a;
}
function Pke(e, t) {
  if (e) {
    if (typeof e == "string") return Kf(e, t);
    var a = Object.prototype.toString.call(e).slice(8, -1);
    if (a === "Object" && e.constructor && (a = e.constructor.name), a === "Map" || a === "Set") return Array.from(e);
    if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return Kf(e, t);
  }
}
function Kf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
  return n;
}
function Eke(e, t) {
  var a = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (a) return (a = a.call(e)).next.bind(a);
  if (Array.isArray(e) || (a = Pke(e)) || t) {
    a && (e = a);
    var n = 0;
    return function() {
      return n >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[n++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var ce;
(function(e) {
  e.hiddenOnSearch = "epr-hidden-on-search", e.searchActive = "epr-search-active", e.hidden = "epr-hidden", e.visible = "epr-visible", e.active = "epr-active", e.emoji = "epr-emoji", e.category = "epr-emoji-category", e.label = "epr-emoji-category-label", e.categoryContent = "epr-emoji-category-content", e.emojiHasVariations = "epr-emoji-has-variations", e.scrollBody = "epr-body", e.emojiList = "epr-emoji-list", e.external = "__EmojiPicker__", e.emojiPicker = "EmojiPickerReact", e.open = "epr-open", e.vertical = "epr-vertical", e.horizontal = "epr-horizontal", e.variationPicker = "epr-emoji-variation-picker", e.darkTheme = "epr-dark-theme", e.autoTheme = "epr-auto-theme";
})(ce || (ce = {}));
function Xe() {
  for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
    t[a] = arguments[a];
  return t.map(function(n) {
    return "." + n;
  }).join("");
}
var Te = /* @__PURE__ */ Tke("epr", null), No = {
  display: "none",
  opacity: "0",
  pointerEvents: "none",
  visibility: "hidden",
  overflow: "hidden"
}, Ss = /* @__PURE__ */ Te.create({
  hidden: /* @__PURE__ */ Pe({
    ".": ce.hidden
  }, No)
}), Rke = /* @__PURE__ */ Cd(function() {
  return P("style", {
    suppressHydrationWarning: !0,
    dangerouslySetInnerHTML: {
      __html: Te.getStyle()
    }
  });
}), U1 = /* @__PURE__ */ Te.create({
  ".epr-main": {
    ":has(input:not(:placeholder-shown))": {
      categoryBtn: {
        ":hover": {
          opacity: "1",
          backgroundPositionY: "var(--epr-category-navigation-button-size)"
        }
      },
      hiddenOnSearch: /* @__PURE__ */ Pe({
        ".": ce.hiddenOnSearch
      }, No)
    },
    ":has(input(:placeholder-shown))": {
      visibleOnSearchOnly: No
    }
  },
  hiddenOnReactions: {
    transition: "all 0.5s ease-in-out"
  },
  ".epr-reactions": {
    hiddenOnReactions: {
      height: "0px",
      width: "0px",
      opacity: "0",
      pointerEvents: "none",
      overflow: "hidden"
    }
  },
  ".EmojiPickerReact:not(.epr-search-active)": {
    categoryBtn: {
      ":hover": {
        opacity: "1",
        backgroundPositionY: "var(--epr-category-navigation-button-size)"
      },
      "&.epr-active": {
        opacity: "1",
        backgroundPositionY: "var(--epr-category-navigation-button-size)"
      }
    },
    visibleOnSearchOnly: /* @__PURE__ */ Pe({
      ".": "epr-visible-on-search-only"
    }, No)
  }
});
function y1(e, t) {
  var a, n;
  return {
    ".epr-dark-theme": (a = {}, a[e] = t, a),
    ".epr-auto-theme": (n = {}, n[e] = {
      "@media (prefers-color-scheme: dark)": t
    }, n)
  };
}
function $p(e, t) {
  var a, n, o = (a = e.customEmojis) != null ? a : [], i = (n = t.customEmojis) != null ? n : [];
  return e.open === t.open && e.emojiVersion === t.emojiVersion && e.reactionsDefaultOpen === t.reactionsDefaultOpen && e.searchPlaceHolder === t.searchPlaceHolder && e.searchPlaceholder === t.searchPlaceholder && e.defaultSkinTone === t.defaultSkinTone && e.skinTonesDisabled === t.skinTonesDisabled && e.autoFocusSearch === t.autoFocusSearch && e.emojiStyle === t.emojiStyle && e.theme === t.theme && e.suggestedEmojisMode === t.suggestedEmojisMode && e.lazyLoadEmojis === t.lazyLoadEmojis && e.className === t.className && e.height === t.height && e.width === t.width && e.style === t.style && e.searchDisabled === t.searchDisabled && e.skinTonePickerLocation === t.skinTonePickerLocation && o.length === i.length;
}
var Hke = [
  "1f44d",
  "2764-fe0f",
  "1f603",
  "1f622",
  "1f64f",
  "1f44e",
  "1f621"
  // 😡
], Mn;
(function(e) {
  e.RECENT = "recent", e.FREQUENT = "frequent";
})(Mn || (Mn = {}));
var it;
(function(e) {
  e.NATIVE = "native", e.APPLE = "apple", e.TWITTER = "twitter", e.GOOGLE = "google", e.FACEBOOK = "facebook";
})(it || (it = {}));
var wn;
(function(e) {
  e.DARK = "dark", e.LIGHT = "light", e.AUTO = "auto";
})(wn || (wn = {}));
var Tt;
(function(e) {
  e.NEUTRAL = "neutral", e.LIGHT = "1f3fb", e.MEDIUM_LIGHT = "1f3fc", e.MEDIUM = "1f3fd", e.MEDIUM_DARK = "1f3fe", e.DARK = "1f3ff";
})(Tt || (Tt = {}));
var se;
(function(e) {
  e.SUGGESTED = "suggested", e.CUSTOM = "custom", e.SMILEYS_PEOPLE = "smileys_people", e.ANIMALS_NATURE = "animals_nature", e.FOOD_DRINK = "food_drink", e.TRAVEL_PLACES = "travel_places", e.ACTIVITIES = "activities", e.OBJECTS = "objects", e.SYMBOLS = "symbols", e.FLAGS = "flags";
})(se || (se = {}));
var Ca;
(function(e) {
  e.SEARCH = "SEARCH", e.PREVIEW = "PREVIEW";
})(Ca || (Ca = {}));
var xt, Vke = [se.SUGGESTED, se.CUSTOM, se.SMILEYS_PEOPLE, se.ANIMALS_NATURE, se.FOOD_DRINK, se.TRAVEL_PLACES, se.ACTIVITIES, se.OBJECTS, se.SYMBOLS, se.FLAGS], Oke = {
  name: "Recently Used",
  category: se.SUGGESTED
}, Up = (xt = {}, xt[se.SUGGESTED] = {
  category: se.SUGGESTED,
  name: "Frequently Used"
}, xt[se.CUSTOM] = {
  category: se.CUSTOM,
  name: "Custom Emojis"
}, xt[se.SMILEYS_PEOPLE] = {
  category: se.SMILEYS_PEOPLE,
  name: "Smileys & People"
}, xt[se.ANIMALS_NATURE] = {
  category: se.ANIMALS_NATURE,
  name: "Animals & Nature"
}, xt[se.FOOD_DRINK] = {
  category: se.FOOD_DRINK,
  name: "Food & Drink"
}, xt[se.TRAVEL_PLACES] = {
  category: se.TRAVEL_PLACES,
  name: "Travel & Places"
}, xt[se.ACTIVITIES] = {
  category: se.ACTIVITIES,
  name: "Activities"
}, xt[se.OBJECTS] = {
  category: se.OBJECTS,
  name: "Objects"
}, xt[se.SYMBOLS] = {
  category: se.SYMBOLS,
  name: "Symbols"
}, xt[se.FLAGS] = {
  category: se.FLAGS,
  name: "Flags"
}, xt);
function Wp(e) {
  return Vke.map(function(t) {
    return Pe({}, Up[t], e && e[t] && e[t]);
  });
}
function Is(e) {
  return e.category;
}
function Yp(e) {
  return e.name;
}
function qke(e, t) {
  var a;
  e === void 0 && (e = []), t === void 0 && (t = {});
  var n = {};
  t.suggestionMode === Mn.RECENT && (n[se.SUGGESTED] = Oke);
  var o = Wp(n);
  return (a = e) != null && a.length ? e.map(function(i) {
    return typeof i == "string" ? Xf(i, n[i]) : Pe({}, Xf(i.category, n[i.category]), i);
  }) : o;
}
function Xf(e, t) {
  return t === void 0 && (t = {}), Object.assign(Up[e], t);
}
var Bke = "https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/", Zke = "https://cdn.jsdelivr.net/npm/emoji-datasource-facebook/img/facebook/64/", Fke = "https://cdn.jsdelivr.net/npm/emoji-datasource-twitter/img/twitter/64/", Gke = "https://cdn.jsdelivr.net/npm/emoji-datasource-google/img/google/64/";
function $ke(e) {
  switch (e) {
    case it.TWITTER:
      return Fke;
    case it.GOOGLE:
      return Gke;
    case it.FACEBOOK:
      return Zke;
    case it.APPLE:
    default:
      return Bke;
  }
}
var Uke = [], Wke = [
  {
    n: [
      "grinning",
      "grinning face"
    ],
    u: "1f600",
    a: "1.0"
  },
  {
    n: [
      "smiley",
      "smiling face with open mouth"
    ],
    u: "1f603",
    a: "0.6"
  },
  {
    n: [
      "smile",
      "smiling face with open mouth and smiling eyes"
    ],
    u: "1f604",
    a: "0.6"
  },
  {
    n: [
      "grin",
      "grinning face with smiling eyes"
    ],
    u: "1f601",
    a: "0.6"
  },
  {
    n: [
      "laughing",
      "satisfied",
      "smiling face with open mouth and tightly-closed eyes"
    ],
    u: "1f606",
    a: "0.6"
  },
  {
    n: [
      "sweat smile",
      "smiling face with open mouth and cold sweat"
    ],
    u: "1f605",
    a: "0.6"
  },
  {
    n: [
      "rolling on the floor laughing"
    ],
    u: "1f923",
    a: "3.0"
  },
  {
    n: [
      "joy",
      "face with tears of joy"
    ],
    u: "1f602",
    a: "0.6"
  },
  {
    n: [
      "slightly smiling face"
    ],
    u: "1f642",
    a: "1.0"
  },
  {
    n: [
      "upside-down face",
      "upside down face"
    ],
    u: "1f643",
    a: "1.0"
  },
  {
    n: [
      "melting face"
    ],
    u: "1fae0",
    a: "14.0"
  },
  {
    n: [
      "wink",
      "winking face"
    ],
    u: "1f609",
    a: "0.6"
  },
  {
    n: [
      "blush",
      "smiling face with smiling eyes"
    ],
    u: "1f60a",
    a: "0.6"
  },
  {
    n: [
      "innocent",
      "smiling face with halo"
    ],
    u: "1f607",
    a: "1.0"
  },
  {
    n: [
      "smiling face with 3 hearts",
      "smiling face with smiling eyes and three hearts"
    ],
    u: "1f970",
    a: "11.0"
  },
  {
    n: [
      "heart eyes",
      "smiling face with heart-shaped eyes"
    ],
    u: "1f60d",
    a: "0.6"
  },
  {
    n: [
      "star-struck",
      "grinning face with star eyes"
    ],
    u: "1f929",
    a: "5.0"
  },
  {
    n: [
      "kissing heart",
      "face throwing a kiss"
    ],
    u: "1f618",
    a: "0.6"
  },
  {
    n: [
      "kissing",
      "kissing face"
    ],
    u: "1f617",
    a: "1.0"
  },
  {
    n: [
      "relaxed",
      "white smiling face"
    ],
    u: "263a-fe0f",
    a: "0.6"
  },
  {
    n: [
      "kissing closed eyes",
      "kissing face with closed eyes"
    ],
    u: "1f61a",
    a: "0.6"
  },
  {
    n: [
      "kissing smiling eyes",
      "kissing face with smiling eyes"
    ],
    u: "1f619",
    a: "1.0"
  },
  {
    n: [
      "smiling face with tear"
    ],
    u: "1f972",
    a: "13.0"
  },
  {
    n: [
      "yum",
      "face savouring delicious food"
    ],
    u: "1f60b",
    a: "0.6"
  },
  {
    n: [
      "stuck out tongue",
      "face with stuck-out tongue"
    ],
    u: "1f61b",
    a: "1.0"
  },
  {
    n: [
      "stuck out tongue winking eye",
      "face with stuck-out tongue and winking eye"
    ],
    u: "1f61c",
    a: "0.6"
  },
  {
    n: [
      "zany face",
      "grinning face with one large and one small eye"
    ],
    u: "1f92a",
    a: "5.0"
  },
  {
    n: [
      "stuck out tongue closed eyes",
      "face with stuck-out tongue and tightly-closed eyes"
    ],
    u: "1f61d",
    a: "0.6"
  },
  {
    n: [
      "money-mouth face",
      "money mouth face"
    ],
    u: "1f911",
    a: "1.0"
  },
  {
    n: [
      "hugging face"
    ],
    u: "1f917",
    a: "1.0"
  },
  {
    n: [
      "face with hand over mouth",
      "smiling face with smiling eyes and hand covering mouth"
    ],
    u: "1f92d",
    a: "5.0"
  },
  {
    n: [
      "face with open eyes and hand over mouth"
    ],
    u: "1fae2",
    a: "14.0"
  },
  {
    n: [
      "face with peeking eye"
    ],
    u: "1fae3",
    a: "14.0"
  },
  {
    n: [
      "shushing face",
      "face with finger covering closed lips"
    ],
    u: "1f92b",
    a: "5.0"
  },
  {
    n: [
      "thinking face"
    ],
    u: "1f914",
    a: "1.0"
  },
  {
    n: [
      "saluting face"
    ],
    u: "1fae1",
    a: "14.0"
  },
  {
    n: [
      "zipper-mouth face",
      "zipper mouth face"
    ],
    u: "1f910",
    a: "1.0"
  },
  {
    n: [
      "face with raised eyebrow",
      "face with one eyebrow raised"
    ],
    u: "1f928",
    a: "5.0"
  },
  {
    n: [
      "neutral face"
    ],
    u: "1f610",
    a: "0.7"
  },
  {
    n: [
      "expressionless",
      "expressionless face"
    ],
    u: "1f611",
    a: "1.0"
  },
  {
    n: [
      "no mouth",
      "face without mouth"
    ],
    u: "1f636",
    a: "1.0"
  },
  {
    n: [
      "dotted line face"
    ],
    u: "1fae5",
    a: "14.0"
  },
  {
    n: [
      "face in clouds"
    ],
    u: "1f636-200d-1f32b-fe0f",
    a: "13.1"
  },
  {
    n: [
      "smirk",
      "smirking face"
    ],
    u: "1f60f",
    a: "0.6"
  },
  {
    n: [
      "unamused",
      "unamused face"
    ],
    u: "1f612",
    a: "0.6"
  },
  {
    n: [
      "face with rolling eyes"
    ],
    u: "1f644",
    a: "1.0"
  },
  {
    n: [
      "grimacing",
      "grimacing face"
    ],
    u: "1f62c",
    a: "1.0"
  },
  {
    n: [
      "face exhaling"
    ],
    u: "1f62e-200d-1f4a8",
    a: "13.1"
  },
  {
    n: [
      "lying face"
    ],
    u: "1f925",
    a: "3.0"
  },
  {
    n: [
      "relieved",
      "relieved face"
    ],
    u: "1f60c",
    a: "0.6"
  },
  {
    n: [
      "pensive",
      "pensive face"
    ],
    u: "1f614",
    a: "0.6"
  },
  {
    n: [
      "sleepy",
      "sleepy face"
    ],
    u: "1f62a",
    a: "0.6"
  },
  {
    n: [
      "drooling face"
    ],
    u: "1f924",
    a: "3.0"
  },
  {
    n: [
      "sleeping",
      "sleeping face"
    ],
    u: "1f634",
    a: "1.0"
  },
  {
    n: [
      "mask",
      "face with medical mask"
    ],
    u: "1f637",
    a: "0.6"
  },
  {
    n: [
      "face with thermometer"
    ],
    u: "1f912",
    a: "1.0"
  },
  {
    n: [
      "face with head-bandage",
      "face with head bandage"
    ],
    u: "1f915",
    a: "1.0"
  },
  {
    n: [
      "nauseated face"
    ],
    u: "1f922",
    a: "3.0"
  },
  {
    n: [
      "face vomiting",
      "face with open mouth vomiting"
    ],
    u: "1f92e",
    a: "5.0"
  },
  {
    n: [
      "sneezing face"
    ],
    u: "1f927",
    a: "3.0"
  },
  {
    n: [
      "hot face",
      "overheated face"
    ],
    u: "1f975",
    a: "11.0"
  },
  {
    n: [
      "cold face",
      "freezing face"
    ],
    u: "1f976",
    a: "11.0"
  },
  {
    n: [
      "woozy face",
      "face with uneven eyes and wavy mouth"
    ],
    u: "1f974",
    a: "11.0"
  },
  {
    n: [
      "dizzy face"
    ],
    u: "1f635",
    a: "0.6"
  },
  {
    n: [
      "face with spiral eyes"
    ],
    u: "1f635-200d-1f4ab",
    a: "13.1"
  },
  {
    n: [
      "exploding head",
      "shocked face with exploding head"
    ],
    u: "1f92f",
    a: "5.0"
  },
  {
    n: [
      "face with cowboy hat"
    ],
    u: "1f920",
    a: "3.0"
  },
  {
    n: [
      "partying face",
      "face with party horn and party hat"
    ],
    u: "1f973",
    a: "11.0"
  },
  {
    n: [
      "disguised face"
    ],
    u: "1f978",
    a: "13.0"
  },
  {
    n: [
      "sunglasses",
      "smiling face with sunglasses"
    ],
    u: "1f60e",
    a: "1.0"
  },
  {
    n: [
      "nerd face"
    ],
    u: "1f913",
    a: "1.0"
  },
  {
    n: [
      "face with monocle"
    ],
    u: "1f9d0",
    a: "5.0"
  },
  {
    n: [
      "confused",
      "confused face"
    ],
    u: "1f615",
    a: "1.0"
  },
  {
    n: [
      "face with diagonal mouth"
    ],
    u: "1fae4",
    a: "14.0"
  },
  {
    n: [
      "worried",
      "worried face"
    ],
    u: "1f61f",
    a: "1.0"
  },
  {
    n: [
      "slightly frowning face"
    ],
    u: "1f641",
    a: "1.0"
  },
  {
    n: [
      "frowning face",
      "white frowning face"
    ],
    u: "2639-fe0f",
    a: "0.7"
  },
  {
    n: [
      "open mouth",
      "face with open mouth"
    ],
    u: "1f62e",
    a: "1.0"
  },
  {
    n: [
      "hushed",
      "hushed face"
    ],
    u: "1f62f",
    a: "1.0"
  },
  {
    n: [
      "astonished",
      "astonished face"
    ],
    u: "1f632",
    a: "0.6"
  },
  {
    n: [
      "flushed",
      "flushed face"
    ],
    u: "1f633",
    a: "0.6"
  },
  {
    n: [
      "pleading face",
      "face with pleading eyes"
    ],
    u: "1f97a",
    a: "11.0"
  },
  {
    n: [
      "face holding back tears"
    ],
    u: "1f979",
    a: "14.0"
  },
  {
    n: [
      "frowning",
      "frowning face with open mouth"
    ],
    u: "1f626",
    a: "1.0"
  },
  {
    n: [
      "anguished",
      "anguished face"
    ],
    u: "1f627",
    a: "1.0"
  },
  {
    n: [
      "fearful",
      "fearful face"
    ],
    u: "1f628",
    a: "0.6"
  },
  {
    n: [
      "cold sweat",
      "face with open mouth and cold sweat"
    ],
    u: "1f630",
    a: "0.6"
  },
  {
    n: [
      "disappointed relieved",
      "disappointed but relieved face"
    ],
    u: "1f625",
    a: "0.6"
  },
  {
    n: [
      "cry",
      "crying face"
    ],
    u: "1f622",
    a: "0.6"
  },
  {
    n: [
      "sob",
      "loudly crying face"
    ],
    u: "1f62d",
    a: "0.6"
  },
  {
    n: [
      "scream",
      "face screaming in fear"
    ],
    u: "1f631",
    a: "0.6"
  },
  {
    n: [
      "confounded",
      "confounded face"
    ],
    u: "1f616",
    a: "0.6"
  },
  {
    n: [
      "persevere",
      "persevering face"
    ],
    u: "1f623",
    a: "0.6"
  },
  {
    n: [
      "disappointed",
      "disappointed face"
    ],
    u: "1f61e",
    a: "0.6"
  },
  {
    n: [
      "sweat",
      "face with cold sweat"
    ],
    u: "1f613",
    a: "0.6"
  },
  {
    n: [
      "weary",
      "weary face"
    ],
    u: "1f629",
    a: "0.6"
  },
  {
    n: [
      "tired face"
    ],
    u: "1f62b",
    a: "0.6"
  },
  {
    n: [
      "yawning face"
    ],
    u: "1f971",
    a: "12.0"
  },
  {
    n: [
      "triumph",
      "face with look of triumph"
    ],
    u: "1f624",
    a: "0.6"
  },
  {
    n: [
      "rage",
      "pouting face"
    ],
    u: "1f621",
    a: "0.6"
  },
  {
    n: [
      "angry",
      "angry face"
    ],
    u: "1f620",
    a: "0.6"
  },
  {
    n: [
      "face with symbols on mouth",
      "serious face with symbols covering mouth"
    ],
    u: "1f92c",
    a: "5.0"
  },
  {
    n: [
      "smiling imp",
      "smiling face with horns"
    ],
    u: "1f608",
    a: "1.0"
  },
  {
    n: [
      "imp"
    ],
    u: "1f47f",
    a: "0.6"
  },
  {
    n: [
      "skull"
    ],
    u: "1f480",
    a: "0.6"
  },
  {
    n: [
      "skull and crossbones"
    ],
    u: "2620-fe0f",
    a: "1.0"
  },
  {
    n: [
      "poop",
      "shit",
      "hankey",
      "pile of poo"
    ],
    u: "1f4a9",
    a: "0.6"
  },
  {
    n: [
      "clown face"
    ],
    u: "1f921",
    a: "3.0"
  },
  {
    n: [
      "japanese ogre"
    ],
    u: "1f479",
    a: "0.6"
  },
  {
    n: [
      "japanese goblin"
    ],
    u: "1f47a",
    a: "0.6"
  },
  {
    n: [
      "ghost"
    ],
    u: "1f47b",
    a: "0.6"
  },
  {
    n: [
      "alien",
      "extraterrestrial alien"
    ],
    u: "1f47d",
    a: "0.6"
  },
  {
    n: [
      "alien monster",
      "space invader"
    ],
    u: "1f47e",
    a: "0.6"
  },
  {
    n: [
      "robot face"
    ],
    u: "1f916",
    a: "1.0"
  },
  {
    n: [
      "smiley cat",
      "smiling cat face with open mouth"
    ],
    u: "1f63a",
    a: "0.6"
  },
  {
    n: [
      "smile cat",
      "grinning cat face with smiling eyes"
    ],
    u: "1f638",
    a: "0.6"
  },
  {
    n: [
      "joy cat",
      "cat face with tears of joy"
    ],
    u: "1f639",
    a: "0.6"
  },
  {
    n: [
      "heart eyes cat",
      "smiling cat face with heart-shaped eyes"
    ],
    u: "1f63b",
    a: "0.6"
  },
  {
    n: [
      "smirk cat",
      "cat face with wry smile"
    ],
    u: "1f63c",
    a: "0.6"
  },
  {
    n: [
      "kissing cat",
      "kissing cat face with closed eyes"
    ],
    u: "1f63d",
    a: "0.6"
  },
  {
    n: [
      "scream cat",
      "weary cat face"
    ],
    u: "1f640",
    a: "0.6"
  },
  {
    n: [
      "crying cat face"
    ],
    u: "1f63f",
    a: "0.6"
  },
  {
    n: [
      "pouting cat",
      "pouting cat face"
    ],
    u: "1f63e",
    a: "0.6"
  },
  {
    n: [
      "see no evil",
      "see-no-evil monkey"
    ],
    u: "1f648",
    a: "0.6"
  },
  {
    n: [
      "hear no evil",
      "hear-no-evil monkey"
    ],
    u: "1f649",
    a: "0.6"
  },
  {
    n: [
      "speak no evil",
      "speak-no-evil monkey"
    ],
    u: "1f64a",
    a: "0.6"
  },
  {
    n: [
      "kiss",
      "kiss mark"
    ],
    u: "1f48b",
    a: "0.6"
  },
  {
    n: [
      "love letter"
    ],
    u: "1f48c",
    a: "0.6"
  },
  {
    n: [
      "cupid",
      "heart with arrow"
    ],
    u: "1f498",
    a: "0.6"
  },
  {
    n: [
      "gift heart",
      "heart with ribbon"
    ],
    u: "1f49d",
    a: "0.6"
  },
  {
    n: [
      "sparkling heart"
    ],
    u: "1f496",
    a: "0.6"
  },
  {
    n: [
      "heartpulse",
      "growing heart"
    ],
    u: "1f497",
    a: "0.6"
  },
  {
    n: [
      "heartbeat",
      "beating heart"
    ],
    u: "1f493",
    a: "0.6"
  },
  {
    n: [
      "revolving hearts"
    ],
    u: "1f49e",
    a: "0.6"
  },
  {
    n: [
      "two hearts"
    ],
    u: "1f495",
    a: "0.6"
  },
  {
    n: [
      "heart decoration"
    ],
    u: "1f49f",
    a: "0.6"
  },
  {
    n: [
      "heart exclamation",
      "heavy heart exclamation mark ornament"
    ],
    u: "2763-fe0f",
    a: "1.0"
  },
  {
    n: [
      "broken heart"
    ],
    u: "1f494",
    a: "0.6"
  },
  {
    n: [
      "heart on fire"
    ],
    u: "2764-fe0f-200d-1f525",
    a: "13.1"
  },
  {
    n: [
      "mending heart"
    ],
    u: "2764-fe0f-200d-1fa79",
    a: "13.1"
  },
  {
    n: [
      "heart",
      "heavy black heart"
    ],
    u: "2764-fe0f",
    a: "0.6"
  },
  {
    n: [
      "orange heart"
    ],
    u: "1f9e1",
    a: "5.0"
  },
  {
    n: [
      "yellow heart"
    ],
    u: "1f49b",
    a: "0.6"
  },
  {
    n: [
      "green heart"
    ],
    u: "1f49a",
    a: "0.6"
  },
  {
    n: [
      "blue heart"
    ],
    u: "1f499",
    a: "0.6"
  },
  {
    n: [
      "purple heart"
    ],
    u: "1f49c",
    a: "0.6"
  },
  {
    n: [
      "brown heart"
    ],
    u: "1f90e",
    a: "12.0"
  },
  {
    n: [
      "black heart"
    ],
    u: "1f5a4",
    a: "3.0"
  },
  {
    n: [
      "white heart"
    ],
    u: "1f90d",
    a: "12.0"
  },
  {
    n: [
      "100",
      "hundred points symbol"
    ],
    u: "1f4af",
    a: "0.6"
  },
  {
    n: [
      "anger",
      "anger symbol"
    ],
    u: "1f4a2",
    a: "0.6"
  },
  {
    n: [
      "boom",
      "collision",
      "collision symbol"
    ],
    u: "1f4a5",
    a: "0.6"
  },
  {
    n: [
      "dizzy",
      "dizzy symbol"
    ],
    u: "1f4ab",
    a: "0.6"
  },
  {
    n: [
      "sweat drops",
      "splashing sweat symbol"
    ],
    u: "1f4a6",
    a: "0.6"
  },
  {
    n: [
      "dash",
      "dash symbol"
    ],
    u: "1f4a8",
    a: "0.6"
  },
  {
    n: [
      "hole"
    ],
    u: "1f573-fe0f",
    a: "0.7"
  },
  {
    n: [
      "bomb"
    ],
    u: "1f4a3",
    a: "0.6"
  },
  {
    n: [
      "speech balloon"
    ],
    u: "1f4ac",
    a: "0.6"
  },
  {
    n: [
      "eye in speech bubble",
      "eye-in-speech-bubble"
    ],
    u: "1f441-fe0f-200d-1f5e8-fe0f",
    a: "2.0"
  },
  {
    n: [
      "left speech bubble"
    ],
    u: "1f5e8-fe0f",
    a: "2.0"
  },
  {
    n: [
      "right anger bubble"
    ],
    u: "1f5ef-fe0f",
    a: "0.7"
  },
  {
    n: [
      "thought balloon"
    ],
    u: "1f4ad",
    a: "1.0"
  },
  {
    n: [
      "zzz",
      "sleeping symbol"
    ],
    u: "1f4a4",
    a: "0.6"
  },
  {
    n: [
      "wave",
      "waving hand sign"
    ],
    u: "1f44b",
    v: [
      "1f44b-1f3fb",
      "1f44b-1f3fc",
      "1f44b-1f3fd",
      "1f44b-1f3fe",
      "1f44b-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "raised back of hand"
    ],
    u: "1f91a",
    v: [
      "1f91a-1f3fb",
      "1f91a-1f3fc",
      "1f91a-1f3fd",
      "1f91a-1f3fe",
      "1f91a-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "hand with fingers splayed",
      "raised hand with fingers splayed"
    ],
    u: "1f590-fe0f",
    v: [
      "1f590-1f3fb",
      "1f590-1f3fc",
      "1f590-1f3fd",
      "1f590-1f3fe",
      "1f590-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "hand",
      "raised hand"
    ],
    u: "270b",
    v: [
      "270b-1f3fb",
      "270b-1f3fc",
      "270b-1f3fd",
      "270b-1f3fe",
      "270b-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "spock-hand",
      "raised hand with part between middle and ring fingers"
    ],
    u: "1f596",
    v: [
      "1f596-1f3fb",
      "1f596-1f3fc",
      "1f596-1f3fd",
      "1f596-1f3fe",
      "1f596-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "rightwards hand"
    ],
    u: "1faf1",
    v: [
      "1faf1-1f3fb",
      "1faf1-1f3fc",
      "1faf1-1f3fd",
      "1faf1-1f3fe",
      "1faf1-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "leftwards hand"
    ],
    u: "1faf2",
    v: [
      "1faf2-1f3fb",
      "1faf2-1f3fc",
      "1faf2-1f3fd",
      "1faf2-1f3fe",
      "1faf2-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "palm down hand"
    ],
    u: "1faf3",
    v: [
      "1faf3-1f3fb",
      "1faf3-1f3fc",
      "1faf3-1f3fd",
      "1faf3-1f3fe",
      "1faf3-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "palm up hand"
    ],
    u: "1faf4",
    v: [
      "1faf4-1f3fb",
      "1faf4-1f3fc",
      "1faf4-1f3fd",
      "1faf4-1f3fe",
      "1faf4-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "ok hand",
      "ok hand sign"
    ],
    u: "1f44c",
    v: [
      "1f44c-1f3fb",
      "1f44c-1f3fc",
      "1f44c-1f3fd",
      "1f44c-1f3fe",
      "1f44c-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "pinched fingers"
    ],
    u: "1f90c",
    v: [
      "1f90c-1f3fb",
      "1f90c-1f3fc",
      "1f90c-1f3fd",
      "1f90c-1f3fe",
      "1f90c-1f3ff"
    ],
    a: "13.0"
  },
  {
    n: [
      "pinching hand"
    ],
    u: "1f90f",
    v: [
      "1f90f-1f3fb",
      "1f90f-1f3fc",
      "1f90f-1f3fd",
      "1f90f-1f3fe",
      "1f90f-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "v",
      "victory hand"
    ],
    u: "270c-fe0f",
    v: [
      "270c-1f3fb",
      "270c-1f3fc",
      "270c-1f3fd",
      "270c-1f3fe",
      "270c-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "crossed fingers",
      "hand with index and middle fingers crossed"
    ],
    u: "1f91e",
    v: [
      "1f91e-1f3fb",
      "1f91e-1f3fc",
      "1f91e-1f3fd",
      "1f91e-1f3fe",
      "1f91e-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "hand with index finger and thumb crossed"
    ],
    u: "1faf0",
    v: [
      "1faf0-1f3fb",
      "1faf0-1f3fc",
      "1faf0-1f3fd",
      "1faf0-1f3fe",
      "1faf0-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "i love you hand sign"
    ],
    u: "1f91f",
    v: [
      "1f91f-1f3fb",
      "1f91f-1f3fc",
      "1f91f-1f3fd",
      "1f91f-1f3fe",
      "1f91f-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "the horns",
      "sign of the horns"
    ],
    u: "1f918",
    v: [
      "1f918-1f3fb",
      "1f918-1f3fc",
      "1f918-1f3fd",
      "1f918-1f3fe",
      "1f918-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "call me hand"
    ],
    u: "1f919",
    v: [
      "1f919-1f3fb",
      "1f919-1f3fc",
      "1f919-1f3fd",
      "1f919-1f3fe",
      "1f919-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "point left",
      "white left pointing backhand index"
    ],
    u: "1f448",
    v: [
      "1f448-1f3fb",
      "1f448-1f3fc",
      "1f448-1f3fd",
      "1f448-1f3fe",
      "1f448-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "point right",
      "white right pointing backhand index"
    ],
    u: "1f449",
    v: [
      "1f449-1f3fb",
      "1f449-1f3fc",
      "1f449-1f3fd",
      "1f449-1f3fe",
      "1f449-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "point up 2",
      "white up pointing backhand index"
    ],
    u: "1f446",
    v: [
      "1f446-1f3fb",
      "1f446-1f3fc",
      "1f446-1f3fd",
      "1f446-1f3fe",
      "1f446-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "middle finger",
      "reversed hand with middle finger extended"
    ],
    u: "1f595",
    v: [
      "1f595-1f3fb",
      "1f595-1f3fc",
      "1f595-1f3fd",
      "1f595-1f3fe",
      "1f595-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "point down",
      "white down pointing backhand index"
    ],
    u: "1f447",
    v: [
      "1f447-1f3fb",
      "1f447-1f3fc",
      "1f447-1f3fd",
      "1f447-1f3fe",
      "1f447-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "point up",
      "white up pointing index"
    ],
    u: "261d-fe0f",
    v: [
      "261d-1f3fb",
      "261d-1f3fc",
      "261d-1f3fd",
      "261d-1f3fe",
      "261d-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "index pointing at the viewer"
    ],
    u: "1faf5",
    v: [
      "1faf5-1f3fb",
      "1faf5-1f3fc",
      "1faf5-1f3fd",
      "1faf5-1f3fe",
      "1faf5-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "+1",
      "thumbsup",
      "thumbs up sign"
    ],
    u: "1f44d",
    v: [
      "1f44d-1f3fb",
      "1f44d-1f3fc",
      "1f44d-1f3fd",
      "1f44d-1f3fe",
      "1f44d-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "-1",
      "thumbsdown",
      "thumbs down sign"
    ],
    u: "1f44e",
    v: [
      "1f44e-1f3fb",
      "1f44e-1f3fc",
      "1f44e-1f3fd",
      "1f44e-1f3fe",
      "1f44e-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "fist",
      "raised fist"
    ],
    u: "270a",
    v: [
      "270a-1f3fb",
      "270a-1f3fc",
      "270a-1f3fd",
      "270a-1f3fe",
      "270a-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "punch",
      "facepunch",
      "fisted hand sign"
    ],
    u: "1f44a",
    v: [
      "1f44a-1f3fb",
      "1f44a-1f3fc",
      "1f44a-1f3fd",
      "1f44a-1f3fe",
      "1f44a-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "left-facing fist"
    ],
    u: "1f91b",
    v: [
      "1f91b-1f3fb",
      "1f91b-1f3fc",
      "1f91b-1f3fd",
      "1f91b-1f3fe",
      "1f91b-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "right-facing fist"
    ],
    u: "1f91c",
    v: [
      "1f91c-1f3fb",
      "1f91c-1f3fc",
      "1f91c-1f3fd",
      "1f91c-1f3fe",
      "1f91c-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "clap",
      "clapping hands sign"
    ],
    u: "1f44f",
    v: [
      "1f44f-1f3fb",
      "1f44f-1f3fc",
      "1f44f-1f3fd",
      "1f44f-1f3fe",
      "1f44f-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "raised hands",
      "person raising both hands in celebration"
    ],
    u: "1f64c",
    v: [
      "1f64c-1f3fb",
      "1f64c-1f3fc",
      "1f64c-1f3fd",
      "1f64c-1f3fe",
      "1f64c-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "heart hands"
    ],
    u: "1faf6",
    v: [
      "1faf6-1f3fb",
      "1faf6-1f3fc",
      "1faf6-1f3fd",
      "1faf6-1f3fe",
      "1faf6-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "open hands",
      "open hands sign"
    ],
    u: "1f450",
    v: [
      "1f450-1f3fb",
      "1f450-1f3fc",
      "1f450-1f3fd",
      "1f450-1f3fe",
      "1f450-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "palms up together"
    ],
    u: "1f932",
    v: [
      "1f932-1f3fb",
      "1f932-1f3fc",
      "1f932-1f3fd",
      "1f932-1f3fe",
      "1f932-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "handshake"
    ],
    u: "1f91d",
    v: [
      "1f91d-1f3fb",
      "1f91d-1f3fc",
      "1f91d-1f3fd",
      "1f91d-1f3fe",
      "1f91d-1f3ff",
      "1faf1-1f3fb-200d-1faf2-1f3fc",
      "1faf1-1f3fb-200d-1faf2-1f3fd",
      "1faf1-1f3fb-200d-1faf2-1f3fe",
      "1faf1-1f3fb-200d-1faf2-1f3ff",
      "1faf1-1f3fc-200d-1faf2-1f3fb",
      "1faf1-1f3fc-200d-1faf2-1f3fd",
      "1faf1-1f3fc-200d-1faf2-1f3fe",
      "1faf1-1f3fc-200d-1faf2-1f3ff",
      "1faf1-1f3fd-200d-1faf2-1f3fb",
      "1faf1-1f3fd-200d-1faf2-1f3fc",
      "1faf1-1f3fd-200d-1faf2-1f3fe",
      "1faf1-1f3fd-200d-1faf2-1f3ff",
      "1faf1-1f3fe-200d-1faf2-1f3fb",
      "1faf1-1f3fe-200d-1faf2-1f3fc",
      "1faf1-1f3fe-200d-1faf2-1f3fd",
      "1faf1-1f3fe-200d-1faf2-1f3ff",
      "1faf1-1f3ff-200d-1faf2-1f3fb",
      "1faf1-1f3ff-200d-1faf2-1f3fc",
      "1faf1-1f3ff-200d-1faf2-1f3fd",
      "1faf1-1f3ff-200d-1faf2-1f3fe"
    ],
    a: "3.0"
  },
  {
    n: [
      "pray",
      "person with folded hands"
    ],
    u: "1f64f",
    v: [
      "1f64f-1f3fb",
      "1f64f-1f3fc",
      "1f64f-1f3fd",
      "1f64f-1f3fe",
      "1f64f-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "writing hand"
    ],
    u: "270d-fe0f",
    v: [
      "270d-1f3fb",
      "270d-1f3fc",
      "270d-1f3fd",
      "270d-1f3fe",
      "270d-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "nail care",
      "nail polish"
    ],
    u: "1f485",
    v: [
      "1f485-1f3fb",
      "1f485-1f3fc",
      "1f485-1f3fd",
      "1f485-1f3fe",
      "1f485-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "selfie"
    ],
    u: "1f933",
    v: [
      "1f933-1f3fb",
      "1f933-1f3fc",
      "1f933-1f3fd",
      "1f933-1f3fe",
      "1f933-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "muscle",
      "flexed biceps"
    ],
    u: "1f4aa",
    v: [
      "1f4aa-1f3fb",
      "1f4aa-1f3fc",
      "1f4aa-1f3fd",
      "1f4aa-1f3fe",
      "1f4aa-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "mechanical arm"
    ],
    u: "1f9be",
    a: "12.0"
  },
  {
    n: [
      "mechanical leg"
    ],
    u: "1f9bf",
    a: "12.0"
  },
  {
    n: [
      "leg"
    ],
    u: "1f9b5",
    v: [
      "1f9b5-1f3fb",
      "1f9b5-1f3fc",
      "1f9b5-1f3fd",
      "1f9b5-1f3fe",
      "1f9b5-1f3ff"
    ],
    a: "11.0"
  },
  {
    n: [
      "foot"
    ],
    u: "1f9b6",
    v: [
      "1f9b6-1f3fb",
      "1f9b6-1f3fc",
      "1f9b6-1f3fd",
      "1f9b6-1f3fe",
      "1f9b6-1f3ff"
    ],
    a: "11.0"
  },
  {
    n: [
      "ear"
    ],
    u: "1f442",
    v: [
      "1f442-1f3fb",
      "1f442-1f3fc",
      "1f442-1f3fd",
      "1f442-1f3fe",
      "1f442-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "ear with hearing aid"
    ],
    u: "1f9bb",
    v: [
      "1f9bb-1f3fb",
      "1f9bb-1f3fc",
      "1f9bb-1f3fd",
      "1f9bb-1f3fe",
      "1f9bb-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "nose"
    ],
    u: "1f443",
    v: [
      "1f443-1f3fb",
      "1f443-1f3fc",
      "1f443-1f3fd",
      "1f443-1f3fe",
      "1f443-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "brain"
    ],
    u: "1f9e0",
    a: "5.0"
  },
  {
    n: [
      "anatomical heart"
    ],
    u: "1fac0",
    a: "13.0"
  },
  {
    n: [
      "lungs"
    ],
    u: "1fac1",
    a: "13.0"
  },
  {
    n: [
      "tooth"
    ],
    u: "1f9b7",
    a: "11.0"
  },
  {
    n: [
      "bone"
    ],
    u: "1f9b4",
    a: "11.0"
  },
  {
    n: [
      "eyes"
    ],
    u: "1f440",
    a: "0.6"
  },
  {
    n: [
      "eye"
    ],
    u: "1f441-fe0f",
    a: "0.7"
  },
  {
    n: [
      "tongue"
    ],
    u: "1f445",
    a: "0.6"
  },
  {
    n: [
      "lips",
      "mouth"
    ],
    u: "1f444",
    a: "0.6"
  },
  {
    n: [
      "biting lip"
    ],
    u: "1fae6",
    a: "14.0"
  },
  {
    n: [
      "baby"
    ],
    u: "1f476",
    v: [
      "1f476-1f3fb",
      "1f476-1f3fc",
      "1f476-1f3fd",
      "1f476-1f3fe",
      "1f476-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "child"
    ],
    u: "1f9d2",
    v: [
      "1f9d2-1f3fb",
      "1f9d2-1f3fc",
      "1f9d2-1f3fd",
      "1f9d2-1f3fe",
      "1f9d2-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "boy"
    ],
    u: "1f466",
    v: [
      "1f466-1f3fb",
      "1f466-1f3fc",
      "1f466-1f3fd",
      "1f466-1f3fe",
      "1f466-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "girl"
    ],
    u: "1f467",
    v: [
      "1f467-1f3fb",
      "1f467-1f3fc",
      "1f467-1f3fd",
      "1f467-1f3fe",
      "1f467-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "adult"
    ],
    u: "1f9d1",
    v: [
      "1f9d1-1f3fb",
      "1f9d1-1f3fc",
      "1f9d1-1f3fd",
      "1f9d1-1f3fe",
      "1f9d1-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "person with blond hair"
    ],
    u: "1f471",
    v: [
      "1f471-1f3fb",
      "1f471-1f3fc",
      "1f471-1f3fd",
      "1f471-1f3fe",
      "1f471-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man"
    ],
    u: "1f468",
    v: [
      "1f468-1f3fb",
      "1f468-1f3fc",
      "1f468-1f3fd",
      "1f468-1f3fe",
      "1f468-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "bearded person"
    ],
    u: "1f9d4",
    v: [
      "1f9d4-1f3fb",
      "1f9d4-1f3fc",
      "1f9d4-1f3fd",
      "1f9d4-1f3fe",
      "1f9d4-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man: beard",
      "man with beard"
    ],
    u: "1f9d4-200d-2642-fe0f",
    v: [
      "1f9d4-1f3fb-200d-2642-fe0f",
      "1f9d4-1f3fc-200d-2642-fe0f",
      "1f9d4-1f3fd-200d-2642-fe0f",
      "1f9d4-1f3fe-200d-2642-fe0f",
      "1f9d4-1f3ff-200d-2642-fe0f"
    ],
    a: "13.1"
  },
  {
    n: [
      "woman: beard",
      "woman with beard"
    ],
    u: "1f9d4-200d-2640-fe0f",
    v: [
      "1f9d4-1f3fb-200d-2640-fe0f",
      "1f9d4-1f3fc-200d-2640-fe0f",
      "1f9d4-1f3fd-200d-2640-fe0f",
      "1f9d4-1f3fe-200d-2640-fe0f",
      "1f9d4-1f3ff-200d-2640-fe0f"
    ],
    a: "13.1"
  },
  {
    n: [
      "man: red hair",
      "red haired man"
    ],
    u: "1f468-200d-1f9b0",
    v: [
      "1f468-1f3fb-200d-1f9b0",
      "1f468-1f3fc-200d-1f9b0",
      "1f468-1f3fd-200d-1f9b0",
      "1f468-1f3fe-200d-1f9b0",
      "1f468-1f3ff-200d-1f9b0"
    ],
    a: "11.0"
  },
  {
    n: [
      "man: curly hair",
      "curly haired man"
    ],
    u: "1f468-200d-1f9b1",
    v: [
      "1f468-1f3fb-200d-1f9b1",
      "1f468-1f3fc-200d-1f9b1",
      "1f468-1f3fd-200d-1f9b1",
      "1f468-1f3fe-200d-1f9b1",
      "1f468-1f3ff-200d-1f9b1"
    ],
    a: "11.0"
  },
  {
    n: [
      "man: white hair",
      "white haired man"
    ],
    u: "1f468-200d-1f9b3",
    v: [
      "1f468-1f3fb-200d-1f9b3",
      "1f468-1f3fc-200d-1f9b3",
      "1f468-1f3fd-200d-1f9b3",
      "1f468-1f3fe-200d-1f9b3",
      "1f468-1f3ff-200d-1f9b3"
    ],
    a: "11.0"
  },
  {
    n: [
      "bald man",
      "man: bald"
    ],
    u: "1f468-200d-1f9b2",
    v: [
      "1f468-1f3fb-200d-1f9b2",
      "1f468-1f3fc-200d-1f9b2",
      "1f468-1f3fd-200d-1f9b2",
      "1f468-1f3fe-200d-1f9b2",
      "1f468-1f3ff-200d-1f9b2"
    ],
    a: "11.0"
  },
  {
    n: [
      "woman"
    ],
    u: "1f469",
    v: [
      "1f469-1f3fb",
      "1f469-1f3fc",
      "1f469-1f3fd",
      "1f469-1f3fe",
      "1f469-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "woman: red hair",
      "red haired woman"
    ],
    u: "1f469-200d-1f9b0",
    v: [
      "1f469-1f3fb-200d-1f9b0",
      "1f469-1f3fc-200d-1f9b0",
      "1f469-1f3fd-200d-1f9b0",
      "1f469-1f3fe-200d-1f9b0",
      "1f469-1f3ff-200d-1f9b0"
    ],
    a: "11.0"
  },
  {
    n: [
      "person: red hair",
      "red haired person"
    ],
    u: "1f9d1-200d-1f9b0",
    v: [
      "1f9d1-1f3fb-200d-1f9b0",
      "1f9d1-1f3fc-200d-1f9b0",
      "1f9d1-1f3fd-200d-1f9b0",
      "1f9d1-1f3fe-200d-1f9b0",
      "1f9d1-1f3ff-200d-1f9b0"
    ],
    a: "12.1"
  },
  {
    n: [
      "woman: curly hair",
      "curly haired woman"
    ],
    u: "1f469-200d-1f9b1",
    v: [
      "1f469-1f3fb-200d-1f9b1",
      "1f469-1f3fc-200d-1f9b1",
      "1f469-1f3fd-200d-1f9b1",
      "1f469-1f3fe-200d-1f9b1",
      "1f469-1f3ff-200d-1f9b1"
    ],
    a: "11.0"
  },
  {
    n: [
      "person: curly hair",
      "curly haired person"
    ],
    u: "1f9d1-200d-1f9b1",
    v: [
      "1f9d1-1f3fb-200d-1f9b1",
      "1f9d1-1f3fc-200d-1f9b1",
      "1f9d1-1f3fd-200d-1f9b1",
      "1f9d1-1f3fe-200d-1f9b1",
      "1f9d1-1f3ff-200d-1f9b1"
    ],
    a: "12.1"
  },
  {
    n: [
      "woman: white hair",
      "white haired woman"
    ],
    u: "1f469-200d-1f9b3",
    v: [
      "1f469-1f3fb-200d-1f9b3",
      "1f469-1f3fc-200d-1f9b3",
      "1f469-1f3fd-200d-1f9b3",
      "1f469-1f3fe-200d-1f9b3",
      "1f469-1f3ff-200d-1f9b3"
    ],
    a: "11.0"
  },
  {
    n: [
      "person: white hair",
      "white haired person"
    ],
    u: "1f9d1-200d-1f9b3",
    v: [
      "1f9d1-1f3fb-200d-1f9b3",
      "1f9d1-1f3fc-200d-1f9b3",
      "1f9d1-1f3fd-200d-1f9b3",
      "1f9d1-1f3fe-200d-1f9b3",
      "1f9d1-1f3ff-200d-1f9b3"
    ],
    a: "12.1"
  },
  {
    n: [
      "bald woman",
      "woman: bald"
    ],
    u: "1f469-200d-1f9b2",
    v: [
      "1f469-1f3fb-200d-1f9b2",
      "1f469-1f3fc-200d-1f9b2",
      "1f469-1f3fd-200d-1f9b2",
      "1f469-1f3fe-200d-1f9b2",
      "1f469-1f3ff-200d-1f9b2"
    ],
    a: "11.0"
  },
  {
    n: [
      "bald person",
      "person: bald"
    ],
    u: "1f9d1-200d-1f9b2",
    v: [
      "1f9d1-1f3fb-200d-1f9b2",
      "1f9d1-1f3fc-200d-1f9b2",
      "1f9d1-1f3fd-200d-1f9b2",
      "1f9d1-1f3fe-200d-1f9b2",
      "1f9d1-1f3ff-200d-1f9b2"
    ],
    a: "12.1"
  },
  {
    n: [
      "woman: blond hair",
      "blond-haired-woman"
    ],
    u: "1f471-200d-2640-fe0f",
    v: [
      "1f471-1f3fb-200d-2640-fe0f",
      "1f471-1f3fc-200d-2640-fe0f",
      "1f471-1f3fd-200d-2640-fe0f",
      "1f471-1f3fe-200d-2640-fe0f",
      "1f471-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "man: blond hair",
      "blond-haired-man"
    ],
    u: "1f471-200d-2642-fe0f",
    v: [
      "1f471-1f3fb-200d-2642-fe0f",
      "1f471-1f3fc-200d-2642-fe0f",
      "1f471-1f3fd-200d-2642-fe0f",
      "1f471-1f3fe-200d-2642-fe0f",
      "1f471-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "older adult"
    ],
    u: "1f9d3",
    v: [
      "1f9d3-1f3fb",
      "1f9d3-1f3fc",
      "1f9d3-1f3fd",
      "1f9d3-1f3fe",
      "1f9d3-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "older man"
    ],
    u: "1f474",
    v: [
      "1f474-1f3fb",
      "1f474-1f3fc",
      "1f474-1f3fd",
      "1f474-1f3fe",
      "1f474-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "older woman"
    ],
    u: "1f475",
    v: [
      "1f475-1f3fb",
      "1f475-1f3fc",
      "1f475-1f3fd",
      "1f475-1f3fe",
      "1f475-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "person frowning"
    ],
    u: "1f64d",
    v: [
      "1f64d-1f3fb",
      "1f64d-1f3fc",
      "1f64d-1f3fd",
      "1f64d-1f3fe",
      "1f64d-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man frowning",
      "man-frowning"
    ],
    u: "1f64d-200d-2642-fe0f",
    v: [
      "1f64d-1f3fb-200d-2642-fe0f",
      "1f64d-1f3fc-200d-2642-fe0f",
      "1f64d-1f3fd-200d-2642-fe0f",
      "1f64d-1f3fe-200d-2642-fe0f",
      "1f64d-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman frowning",
      "woman-frowning"
    ],
    u: "1f64d-200d-2640-fe0f",
    v: [
      "1f64d-1f3fb-200d-2640-fe0f",
      "1f64d-1f3fc-200d-2640-fe0f",
      "1f64d-1f3fd-200d-2640-fe0f",
      "1f64d-1f3fe-200d-2640-fe0f",
      "1f64d-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "person with pouting face"
    ],
    u: "1f64e",
    v: [
      "1f64e-1f3fb",
      "1f64e-1f3fc",
      "1f64e-1f3fd",
      "1f64e-1f3fe",
      "1f64e-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man pouting",
      "man-pouting"
    ],
    u: "1f64e-200d-2642-fe0f",
    v: [
      "1f64e-1f3fb-200d-2642-fe0f",
      "1f64e-1f3fc-200d-2642-fe0f",
      "1f64e-1f3fd-200d-2642-fe0f",
      "1f64e-1f3fe-200d-2642-fe0f",
      "1f64e-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman pouting",
      "woman-pouting"
    ],
    u: "1f64e-200d-2640-fe0f",
    v: [
      "1f64e-1f3fb-200d-2640-fe0f",
      "1f64e-1f3fc-200d-2640-fe0f",
      "1f64e-1f3fd-200d-2640-fe0f",
      "1f64e-1f3fe-200d-2640-fe0f",
      "1f64e-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "no good",
      "face with no good gesture"
    ],
    u: "1f645",
    v: [
      "1f645-1f3fb",
      "1f645-1f3fc",
      "1f645-1f3fd",
      "1f645-1f3fe",
      "1f645-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man gesturing no",
      "man-gesturing-no"
    ],
    u: "1f645-200d-2642-fe0f",
    v: [
      "1f645-1f3fb-200d-2642-fe0f",
      "1f645-1f3fc-200d-2642-fe0f",
      "1f645-1f3fd-200d-2642-fe0f",
      "1f645-1f3fe-200d-2642-fe0f",
      "1f645-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman gesturing no",
      "woman-gesturing-no"
    ],
    u: "1f645-200d-2640-fe0f",
    v: [
      "1f645-1f3fb-200d-2640-fe0f",
      "1f645-1f3fc-200d-2640-fe0f",
      "1f645-1f3fd-200d-2640-fe0f",
      "1f645-1f3fe-200d-2640-fe0f",
      "1f645-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "ok woman",
      "face with ok gesture"
    ],
    u: "1f646",
    v: [
      "1f646-1f3fb",
      "1f646-1f3fc",
      "1f646-1f3fd",
      "1f646-1f3fe",
      "1f646-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man gesturing ok",
      "man-gesturing-ok"
    ],
    u: "1f646-200d-2642-fe0f",
    v: [
      "1f646-1f3fb-200d-2642-fe0f",
      "1f646-1f3fc-200d-2642-fe0f",
      "1f646-1f3fd-200d-2642-fe0f",
      "1f646-1f3fe-200d-2642-fe0f",
      "1f646-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman gesturing ok",
      "woman-gesturing-ok"
    ],
    u: "1f646-200d-2640-fe0f",
    v: [
      "1f646-1f3fb-200d-2640-fe0f",
      "1f646-1f3fc-200d-2640-fe0f",
      "1f646-1f3fd-200d-2640-fe0f",
      "1f646-1f3fe-200d-2640-fe0f",
      "1f646-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "information desk person"
    ],
    u: "1f481",
    v: [
      "1f481-1f3fb",
      "1f481-1f3fc",
      "1f481-1f3fd",
      "1f481-1f3fe",
      "1f481-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man tipping hand",
      "man-tipping-hand"
    ],
    u: "1f481-200d-2642-fe0f",
    v: [
      "1f481-1f3fb-200d-2642-fe0f",
      "1f481-1f3fc-200d-2642-fe0f",
      "1f481-1f3fd-200d-2642-fe0f",
      "1f481-1f3fe-200d-2642-fe0f",
      "1f481-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman tipping hand",
      "woman-tipping-hand"
    ],
    u: "1f481-200d-2640-fe0f",
    v: [
      "1f481-1f3fb-200d-2640-fe0f",
      "1f481-1f3fc-200d-2640-fe0f",
      "1f481-1f3fd-200d-2640-fe0f",
      "1f481-1f3fe-200d-2640-fe0f",
      "1f481-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "raising hand",
      "happy person raising one hand"
    ],
    u: "1f64b",
    v: [
      "1f64b-1f3fb",
      "1f64b-1f3fc",
      "1f64b-1f3fd",
      "1f64b-1f3fe",
      "1f64b-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man raising hand",
      "man-raising-hand"
    ],
    u: "1f64b-200d-2642-fe0f",
    v: [
      "1f64b-1f3fb-200d-2642-fe0f",
      "1f64b-1f3fc-200d-2642-fe0f",
      "1f64b-1f3fd-200d-2642-fe0f",
      "1f64b-1f3fe-200d-2642-fe0f",
      "1f64b-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman raising hand",
      "woman-raising-hand"
    ],
    u: "1f64b-200d-2640-fe0f",
    v: [
      "1f64b-1f3fb-200d-2640-fe0f",
      "1f64b-1f3fc-200d-2640-fe0f",
      "1f64b-1f3fd-200d-2640-fe0f",
      "1f64b-1f3fe-200d-2640-fe0f",
      "1f64b-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "deaf person"
    ],
    u: "1f9cf",
    v: [
      "1f9cf-1f3fb",
      "1f9cf-1f3fc",
      "1f9cf-1f3fd",
      "1f9cf-1f3fe",
      "1f9cf-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "deaf man"
    ],
    u: "1f9cf-200d-2642-fe0f",
    v: [
      "1f9cf-1f3fb-200d-2642-fe0f",
      "1f9cf-1f3fc-200d-2642-fe0f",
      "1f9cf-1f3fd-200d-2642-fe0f",
      "1f9cf-1f3fe-200d-2642-fe0f",
      "1f9cf-1f3ff-200d-2642-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "deaf woman"
    ],
    u: "1f9cf-200d-2640-fe0f",
    v: [
      "1f9cf-1f3fb-200d-2640-fe0f",
      "1f9cf-1f3fc-200d-2640-fe0f",
      "1f9cf-1f3fd-200d-2640-fe0f",
      "1f9cf-1f3fe-200d-2640-fe0f",
      "1f9cf-1f3ff-200d-2640-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "bow",
      "person bowing deeply"
    ],
    u: "1f647",
    v: [
      "1f647-1f3fb",
      "1f647-1f3fc",
      "1f647-1f3fd",
      "1f647-1f3fe",
      "1f647-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man bowing",
      "man-bowing"
    ],
    u: "1f647-200d-2642-fe0f",
    v: [
      "1f647-1f3fb-200d-2642-fe0f",
      "1f647-1f3fc-200d-2642-fe0f",
      "1f647-1f3fd-200d-2642-fe0f",
      "1f647-1f3fe-200d-2642-fe0f",
      "1f647-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman bowing",
      "woman-bowing"
    ],
    u: "1f647-200d-2640-fe0f",
    v: [
      "1f647-1f3fb-200d-2640-fe0f",
      "1f647-1f3fc-200d-2640-fe0f",
      "1f647-1f3fd-200d-2640-fe0f",
      "1f647-1f3fe-200d-2640-fe0f",
      "1f647-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "face palm"
    ],
    u: "1f926",
    v: [
      "1f926-1f3fb",
      "1f926-1f3fc",
      "1f926-1f3fd",
      "1f926-1f3fe",
      "1f926-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man facepalming",
      "man-facepalming"
    ],
    u: "1f926-200d-2642-fe0f",
    v: [
      "1f926-1f3fb-200d-2642-fe0f",
      "1f926-1f3fc-200d-2642-fe0f",
      "1f926-1f3fd-200d-2642-fe0f",
      "1f926-1f3fe-200d-2642-fe0f",
      "1f926-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman facepalming",
      "woman-facepalming"
    ],
    u: "1f926-200d-2640-fe0f",
    v: [
      "1f926-1f3fb-200d-2640-fe0f",
      "1f926-1f3fc-200d-2640-fe0f",
      "1f926-1f3fd-200d-2640-fe0f",
      "1f926-1f3fe-200d-2640-fe0f",
      "1f926-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "shrug"
    ],
    u: "1f937",
    v: [
      "1f937-1f3fb",
      "1f937-1f3fc",
      "1f937-1f3fd",
      "1f937-1f3fe",
      "1f937-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man shrugging",
      "man-shrugging"
    ],
    u: "1f937-200d-2642-fe0f",
    v: [
      "1f937-1f3fb-200d-2642-fe0f",
      "1f937-1f3fc-200d-2642-fe0f",
      "1f937-1f3fd-200d-2642-fe0f",
      "1f937-1f3fe-200d-2642-fe0f",
      "1f937-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman shrugging",
      "woman-shrugging"
    ],
    u: "1f937-200d-2640-fe0f",
    v: [
      "1f937-1f3fb-200d-2640-fe0f",
      "1f937-1f3fc-200d-2640-fe0f",
      "1f937-1f3fd-200d-2640-fe0f",
      "1f937-1f3fe-200d-2640-fe0f",
      "1f937-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "health worker"
    ],
    u: "1f9d1-200d-2695-fe0f",
    v: [
      "1f9d1-1f3fb-200d-2695-fe0f",
      "1f9d1-1f3fc-200d-2695-fe0f",
      "1f9d1-1f3fd-200d-2695-fe0f",
      "1f9d1-1f3fe-200d-2695-fe0f",
      "1f9d1-1f3ff-200d-2695-fe0f"
    ],
    a: "12.1"
  },
  {
    n: [
      "male-doctor",
      "man health worker"
    ],
    u: "1f468-200d-2695-fe0f",
    v: [
      "1f468-1f3fb-200d-2695-fe0f",
      "1f468-1f3fc-200d-2695-fe0f",
      "1f468-1f3fd-200d-2695-fe0f",
      "1f468-1f3fe-200d-2695-fe0f",
      "1f468-1f3ff-200d-2695-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "female-doctor",
      "woman health worker"
    ],
    u: "1f469-200d-2695-fe0f",
    v: [
      "1f469-1f3fb-200d-2695-fe0f",
      "1f469-1f3fc-200d-2695-fe0f",
      "1f469-1f3fd-200d-2695-fe0f",
      "1f469-1f3fe-200d-2695-fe0f",
      "1f469-1f3ff-200d-2695-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "student"
    ],
    u: "1f9d1-200d-1f393",
    v: [
      "1f9d1-1f3fb-200d-1f393",
      "1f9d1-1f3fc-200d-1f393",
      "1f9d1-1f3fd-200d-1f393",
      "1f9d1-1f3fe-200d-1f393",
      "1f9d1-1f3ff-200d-1f393"
    ],
    a: "12.1"
  },
  {
    n: [
      "man student",
      "male-student"
    ],
    u: "1f468-200d-1f393",
    v: [
      "1f468-1f3fb-200d-1f393",
      "1f468-1f3fc-200d-1f393",
      "1f468-1f3fd-200d-1f393",
      "1f468-1f3fe-200d-1f393",
      "1f468-1f3ff-200d-1f393"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman student",
      "female-student"
    ],
    u: "1f469-200d-1f393",
    v: [
      "1f469-1f3fb-200d-1f393",
      "1f469-1f3fc-200d-1f393",
      "1f469-1f3fd-200d-1f393",
      "1f469-1f3fe-200d-1f393",
      "1f469-1f3ff-200d-1f393"
    ],
    a: "4.0"
  },
  {
    n: [
      "teacher"
    ],
    u: "1f9d1-200d-1f3eb",
    v: [
      "1f9d1-1f3fb-200d-1f3eb",
      "1f9d1-1f3fc-200d-1f3eb",
      "1f9d1-1f3fd-200d-1f3eb",
      "1f9d1-1f3fe-200d-1f3eb",
      "1f9d1-1f3ff-200d-1f3eb"
    ],
    a: "12.1"
  },
  {
    n: [
      "man teacher",
      "male-teacher"
    ],
    u: "1f468-200d-1f3eb",
    v: [
      "1f468-1f3fb-200d-1f3eb",
      "1f468-1f3fc-200d-1f3eb",
      "1f468-1f3fd-200d-1f3eb",
      "1f468-1f3fe-200d-1f3eb",
      "1f468-1f3ff-200d-1f3eb"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman teacher",
      "female-teacher"
    ],
    u: "1f469-200d-1f3eb",
    v: [
      "1f469-1f3fb-200d-1f3eb",
      "1f469-1f3fc-200d-1f3eb",
      "1f469-1f3fd-200d-1f3eb",
      "1f469-1f3fe-200d-1f3eb",
      "1f469-1f3ff-200d-1f3eb"
    ],
    a: "4.0"
  },
  {
    n: [
      "judge"
    ],
    u: "1f9d1-200d-2696-fe0f",
    v: [
      "1f9d1-1f3fb-200d-2696-fe0f",
      "1f9d1-1f3fc-200d-2696-fe0f",
      "1f9d1-1f3fd-200d-2696-fe0f",
      "1f9d1-1f3fe-200d-2696-fe0f",
      "1f9d1-1f3ff-200d-2696-fe0f"
    ],
    a: "12.1"
  },
  {
    n: [
      "man judge",
      "male-judge"
    ],
    u: "1f468-200d-2696-fe0f",
    v: [
      "1f468-1f3fb-200d-2696-fe0f",
      "1f468-1f3fc-200d-2696-fe0f",
      "1f468-1f3fd-200d-2696-fe0f",
      "1f468-1f3fe-200d-2696-fe0f",
      "1f468-1f3ff-200d-2696-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman judge",
      "female-judge"
    ],
    u: "1f469-200d-2696-fe0f",
    v: [
      "1f469-1f3fb-200d-2696-fe0f",
      "1f469-1f3fc-200d-2696-fe0f",
      "1f469-1f3fd-200d-2696-fe0f",
      "1f469-1f3fe-200d-2696-fe0f",
      "1f469-1f3ff-200d-2696-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "farmer"
    ],
    u: "1f9d1-200d-1f33e",
    v: [
      "1f9d1-1f3fb-200d-1f33e",
      "1f9d1-1f3fc-200d-1f33e",
      "1f9d1-1f3fd-200d-1f33e",
      "1f9d1-1f3fe-200d-1f33e",
      "1f9d1-1f3ff-200d-1f33e"
    ],
    a: "12.1"
  },
  {
    n: [
      "man farmer",
      "male-farmer"
    ],
    u: "1f468-200d-1f33e",
    v: [
      "1f468-1f3fb-200d-1f33e",
      "1f468-1f3fc-200d-1f33e",
      "1f468-1f3fd-200d-1f33e",
      "1f468-1f3fe-200d-1f33e",
      "1f468-1f3ff-200d-1f33e"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman farmer",
      "female-farmer"
    ],
    u: "1f469-200d-1f33e",
    v: [
      "1f469-1f3fb-200d-1f33e",
      "1f469-1f3fc-200d-1f33e",
      "1f469-1f3fd-200d-1f33e",
      "1f469-1f3fe-200d-1f33e",
      "1f469-1f3ff-200d-1f33e"
    ],
    a: "4.0"
  },
  {
    n: [
      "cook"
    ],
    u: "1f9d1-200d-1f373",
    v: [
      "1f9d1-1f3fb-200d-1f373",
      "1f9d1-1f3fc-200d-1f373",
      "1f9d1-1f3fd-200d-1f373",
      "1f9d1-1f3fe-200d-1f373",
      "1f9d1-1f3ff-200d-1f373"
    ],
    a: "12.1"
  },
  {
    n: [
      "man cook",
      "male-cook"
    ],
    u: "1f468-200d-1f373",
    v: [
      "1f468-1f3fb-200d-1f373",
      "1f468-1f3fc-200d-1f373",
      "1f468-1f3fd-200d-1f373",
      "1f468-1f3fe-200d-1f373",
      "1f468-1f3ff-200d-1f373"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman cook",
      "female-cook"
    ],
    u: "1f469-200d-1f373",
    v: [
      "1f469-1f3fb-200d-1f373",
      "1f469-1f3fc-200d-1f373",
      "1f469-1f3fd-200d-1f373",
      "1f469-1f3fe-200d-1f373",
      "1f469-1f3ff-200d-1f373"
    ],
    a: "4.0"
  },
  {
    n: [
      "mechanic"
    ],
    u: "1f9d1-200d-1f527",
    v: [
      "1f9d1-1f3fb-200d-1f527",
      "1f9d1-1f3fc-200d-1f527",
      "1f9d1-1f3fd-200d-1f527",
      "1f9d1-1f3fe-200d-1f527",
      "1f9d1-1f3ff-200d-1f527"
    ],
    a: "12.1"
  },
  {
    n: [
      "man mechanic",
      "male-mechanic"
    ],
    u: "1f468-200d-1f527",
    v: [
      "1f468-1f3fb-200d-1f527",
      "1f468-1f3fc-200d-1f527",
      "1f468-1f3fd-200d-1f527",
      "1f468-1f3fe-200d-1f527",
      "1f468-1f3ff-200d-1f527"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman mechanic",
      "female-mechanic"
    ],
    u: "1f469-200d-1f527",
    v: [
      "1f469-1f3fb-200d-1f527",
      "1f469-1f3fc-200d-1f527",
      "1f469-1f3fd-200d-1f527",
      "1f469-1f3fe-200d-1f527",
      "1f469-1f3ff-200d-1f527"
    ],
    a: "4.0"
  },
  {
    n: [
      "factory worker"
    ],
    u: "1f9d1-200d-1f3ed",
    v: [
      "1f9d1-1f3fb-200d-1f3ed",
      "1f9d1-1f3fc-200d-1f3ed",
      "1f9d1-1f3fd-200d-1f3ed",
      "1f9d1-1f3fe-200d-1f3ed",
      "1f9d1-1f3ff-200d-1f3ed"
    ],
    a: "12.1"
  },
  {
    n: [
      "man factory worker",
      "male-factory-worker"
    ],
    u: "1f468-200d-1f3ed",
    v: [
      "1f468-1f3fb-200d-1f3ed",
      "1f468-1f3fc-200d-1f3ed",
      "1f468-1f3fd-200d-1f3ed",
      "1f468-1f3fe-200d-1f3ed",
      "1f468-1f3ff-200d-1f3ed"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman factory worker",
      "female-factory-worker"
    ],
    u: "1f469-200d-1f3ed",
    v: [
      "1f469-1f3fb-200d-1f3ed",
      "1f469-1f3fc-200d-1f3ed",
      "1f469-1f3fd-200d-1f3ed",
      "1f469-1f3fe-200d-1f3ed",
      "1f469-1f3ff-200d-1f3ed"
    ],
    a: "4.0"
  },
  {
    n: [
      "office worker"
    ],
    u: "1f9d1-200d-1f4bc",
    v: [
      "1f9d1-1f3fb-200d-1f4bc",
      "1f9d1-1f3fc-200d-1f4bc",
      "1f9d1-1f3fd-200d-1f4bc",
      "1f9d1-1f3fe-200d-1f4bc",
      "1f9d1-1f3ff-200d-1f4bc"
    ],
    a: "12.1"
  },
  {
    n: [
      "man office worker",
      "male-office-worker"
    ],
    u: "1f468-200d-1f4bc",
    v: [
      "1f468-1f3fb-200d-1f4bc",
      "1f468-1f3fc-200d-1f4bc",
      "1f468-1f3fd-200d-1f4bc",
      "1f468-1f3fe-200d-1f4bc",
      "1f468-1f3ff-200d-1f4bc"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman office worker",
      "female-office-worker"
    ],
    u: "1f469-200d-1f4bc",
    v: [
      "1f469-1f3fb-200d-1f4bc",
      "1f469-1f3fc-200d-1f4bc",
      "1f469-1f3fd-200d-1f4bc",
      "1f469-1f3fe-200d-1f4bc",
      "1f469-1f3ff-200d-1f4bc"
    ],
    a: "4.0"
  },
  {
    n: [
      "scientist"
    ],
    u: "1f9d1-200d-1f52c",
    v: [
      "1f9d1-1f3fb-200d-1f52c",
      "1f9d1-1f3fc-200d-1f52c",
      "1f9d1-1f3fd-200d-1f52c",
      "1f9d1-1f3fe-200d-1f52c",
      "1f9d1-1f3ff-200d-1f52c"
    ],
    a: "12.1"
  },
  {
    n: [
      "man scientist",
      "male-scientist"
    ],
    u: "1f468-200d-1f52c",
    v: [
      "1f468-1f3fb-200d-1f52c",
      "1f468-1f3fc-200d-1f52c",
      "1f468-1f3fd-200d-1f52c",
      "1f468-1f3fe-200d-1f52c",
      "1f468-1f3ff-200d-1f52c"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman scientist",
      "female-scientist"
    ],
    u: "1f469-200d-1f52c",
    v: [
      "1f469-1f3fb-200d-1f52c",
      "1f469-1f3fc-200d-1f52c",
      "1f469-1f3fd-200d-1f52c",
      "1f469-1f3fe-200d-1f52c",
      "1f469-1f3ff-200d-1f52c"
    ],
    a: "4.0"
  },
  {
    n: [
      "technologist"
    ],
    u: "1f9d1-200d-1f4bb",
    v: [
      "1f9d1-1f3fb-200d-1f4bb",
      "1f9d1-1f3fc-200d-1f4bb",
      "1f9d1-1f3fd-200d-1f4bb",
      "1f9d1-1f3fe-200d-1f4bb",
      "1f9d1-1f3ff-200d-1f4bb"
    ],
    a: "12.1"
  },
  {
    n: [
      "man technologist",
      "male-technologist"
    ],
    u: "1f468-200d-1f4bb",
    v: [
      "1f468-1f3fb-200d-1f4bb",
      "1f468-1f3fc-200d-1f4bb",
      "1f468-1f3fd-200d-1f4bb",
      "1f468-1f3fe-200d-1f4bb",
      "1f468-1f3ff-200d-1f4bb"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman technologist",
      "female-technologist"
    ],
    u: "1f469-200d-1f4bb",
    v: [
      "1f469-1f3fb-200d-1f4bb",
      "1f469-1f3fc-200d-1f4bb",
      "1f469-1f3fd-200d-1f4bb",
      "1f469-1f3fe-200d-1f4bb",
      "1f469-1f3ff-200d-1f4bb"
    ],
    a: "4.0"
  },
  {
    n: [
      "singer"
    ],
    u: "1f9d1-200d-1f3a4",
    v: [
      "1f9d1-1f3fb-200d-1f3a4",
      "1f9d1-1f3fc-200d-1f3a4",
      "1f9d1-1f3fd-200d-1f3a4",
      "1f9d1-1f3fe-200d-1f3a4",
      "1f9d1-1f3ff-200d-1f3a4"
    ],
    a: "12.1"
  },
  {
    n: [
      "man singer",
      "male-singer"
    ],
    u: "1f468-200d-1f3a4",
    v: [
      "1f468-1f3fb-200d-1f3a4",
      "1f468-1f3fc-200d-1f3a4",
      "1f468-1f3fd-200d-1f3a4",
      "1f468-1f3fe-200d-1f3a4",
      "1f468-1f3ff-200d-1f3a4"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman singer",
      "female-singer"
    ],
    u: "1f469-200d-1f3a4",
    v: [
      "1f469-1f3fb-200d-1f3a4",
      "1f469-1f3fc-200d-1f3a4",
      "1f469-1f3fd-200d-1f3a4",
      "1f469-1f3fe-200d-1f3a4",
      "1f469-1f3ff-200d-1f3a4"
    ],
    a: "4.0"
  },
  {
    n: [
      "artist"
    ],
    u: "1f9d1-200d-1f3a8",
    v: [
      "1f9d1-1f3fb-200d-1f3a8",
      "1f9d1-1f3fc-200d-1f3a8",
      "1f9d1-1f3fd-200d-1f3a8",
      "1f9d1-1f3fe-200d-1f3a8",
      "1f9d1-1f3ff-200d-1f3a8"
    ],
    a: "12.1"
  },
  {
    n: [
      "man artist",
      "male-artist"
    ],
    u: "1f468-200d-1f3a8",
    v: [
      "1f468-1f3fb-200d-1f3a8",
      "1f468-1f3fc-200d-1f3a8",
      "1f468-1f3fd-200d-1f3a8",
      "1f468-1f3fe-200d-1f3a8",
      "1f468-1f3ff-200d-1f3a8"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman artist",
      "female-artist"
    ],
    u: "1f469-200d-1f3a8",
    v: [
      "1f469-1f3fb-200d-1f3a8",
      "1f469-1f3fc-200d-1f3a8",
      "1f469-1f3fd-200d-1f3a8",
      "1f469-1f3fe-200d-1f3a8",
      "1f469-1f3ff-200d-1f3a8"
    ],
    a: "4.0"
  },
  {
    n: [
      "pilot"
    ],
    u: "1f9d1-200d-2708-fe0f",
    v: [
      "1f9d1-1f3fb-200d-2708-fe0f",
      "1f9d1-1f3fc-200d-2708-fe0f",
      "1f9d1-1f3fd-200d-2708-fe0f",
      "1f9d1-1f3fe-200d-2708-fe0f",
      "1f9d1-1f3ff-200d-2708-fe0f"
    ],
    a: "12.1"
  },
  {
    n: [
      "man pilot",
      "male-pilot"
    ],
    u: "1f468-200d-2708-fe0f",
    v: [
      "1f468-1f3fb-200d-2708-fe0f",
      "1f468-1f3fc-200d-2708-fe0f",
      "1f468-1f3fd-200d-2708-fe0f",
      "1f468-1f3fe-200d-2708-fe0f",
      "1f468-1f3ff-200d-2708-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman pilot",
      "female-pilot"
    ],
    u: "1f469-200d-2708-fe0f",
    v: [
      "1f469-1f3fb-200d-2708-fe0f",
      "1f469-1f3fc-200d-2708-fe0f",
      "1f469-1f3fd-200d-2708-fe0f",
      "1f469-1f3fe-200d-2708-fe0f",
      "1f469-1f3ff-200d-2708-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "astronaut"
    ],
    u: "1f9d1-200d-1f680",
    v: [
      "1f9d1-1f3fb-200d-1f680",
      "1f9d1-1f3fc-200d-1f680",
      "1f9d1-1f3fd-200d-1f680",
      "1f9d1-1f3fe-200d-1f680",
      "1f9d1-1f3ff-200d-1f680"
    ],
    a: "12.1"
  },
  {
    n: [
      "man astronaut",
      "male-astronaut"
    ],
    u: "1f468-200d-1f680",
    v: [
      "1f468-1f3fb-200d-1f680",
      "1f468-1f3fc-200d-1f680",
      "1f468-1f3fd-200d-1f680",
      "1f468-1f3fe-200d-1f680",
      "1f468-1f3ff-200d-1f680"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman astronaut",
      "female-astronaut"
    ],
    u: "1f469-200d-1f680",
    v: [
      "1f469-1f3fb-200d-1f680",
      "1f469-1f3fc-200d-1f680",
      "1f469-1f3fd-200d-1f680",
      "1f469-1f3fe-200d-1f680",
      "1f469-1f3ff-200d-1f680"
    ],
    a: "4.0"
  },
  {
    n: [
      "firefighter"
    ],
    u: "1f9d1-200d-1f692",
    v: [
      "1f9d1-1f3fb-200d-1f692",
      "1f9d1-1f3fc-200d-1f692",
      "1f9d1-1f3fd-200d-1f692",
      "1f9d1-1f3fe-200d-1f692",
      "1f9d1-1f3ff-200d-1f692"
    ],
    a: "12.1"
  },
  {
    n: [
      "man firefighter",
      "male-firefighter"
    ],
    u: "1f468-200d-1f692",
    v: [
      "1f468-1f3fb-200d-1f692",
      "1f468-1f3fc-200d-1f692",
      "1f468-1f3fd-200d-1f692",
      "1f468-1f3fe-200d-1f692",
      "1f468-1f3ff-200d-1f692"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman firefighter",
      "female-firefighter"
    ],
    u: "1f469-200d-1f692",
    v: [
      "1f469-1f3fb-200d-1f692",
      "1f469-1f3fc-200d-1f692",
      "1f469-1f3fd-200d-1f692",
      "1f469-1f3fe-200d-1f692",
      "1f469-1f3ff-200d-1f692"
    ],
    a: "4.0"
  },
  {
    n: [
      "cop",
      "police officer"
    ],
    u: "1f46e",
    v: [
      "1f46e-1f3fb",
      "1f46e-1f3fc",
      "1f46e-1f3fd",
      "1f46e-1f3fe",
      "1f46e-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man police officer",
      "male-police-officer"
    ],
    u: "1f46e-200d-2642-fe0f",
    v: [
      "1f46e-1f3fb-200d-2642-fe0f",
      "1f46e-1f3fc-200d-2642-fe0f",
      "1f46e-1f3fd-200d-2642-fe0f",
      "1f46e-1f3fe-200d-2642-fe0f",
      "1f46e-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman police officer",
      "female-police-officer"
    ],
    u: "1f46e-200d-2640-fe0f",
    v: [
      "1f46e-1f3fb-200d-2640-fe0f",
      "1f46e-1f3fc-200d-2640-fe0f",
      "1f46e-1f3fd-200d-2640-fe0f",
      "1f46e-1f3fe-200d-2640-fe0f",
      "1f46e-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "detective",
      "sleuth or spy"
    ],
    u: "1f575-fe0f",
    v: [
      "1f575-1f3fb",
      "1f575-1f3fc",
      "1f575-1f3fd",
      "1f575-1f3fe",
      "1f575-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "man detective",
      "male-detective"
    ],
    u: "1f575-fe0f-200d-2642-fe0f",
    v: [
      "1f575-1f3fb-200d-2642-fe0f",
      "1f575-1f3fc-200d-2642-fe0f",
      "1f575-1f3fd-200d-2642-fe0f",
      "1f575-1f3fe-200d-2642-fe0f",
      "1f575-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman detective",
      "female-detective"
    ],
    u: "1f575-fe0f-200d-2640-fe0f",
    v: [
      "1f575-1f3fb-200d-2640-fe0f",
      "1f575-1f3fc-200d-2640-fe0f",
      "1f575-1f3fd-200d-2640-fe0f",
      "1f575-1f3fe-200d-2640-fe0f",
      "1f575-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "guardsman"
    ],
    u: "1f482",
    v: [
      "1f482-1f3fb",
      "1f482-1f3fc",
      "1f482-1f3fd",
      "1f482-1f3fe",
      "1f482-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man guard",
      "male-guard"
    ],
    u: "1f482-200d-2642-fe0f",
    v: [
      "1f482-1f3fb-200d-2642-fe0f",
      "1f482-1f3fc-200d-2642-fe0f",
      "1f482-1f3fd-200d-2642-fe0f",
      "1f482-1f3fe-200d-2642-fe0f",
      "1f482-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman guard",
      "female-guard"
    ],
    u: "1f482-200d-2640-fe0f",
    v: [
      "1f482-1f3fb-200d-2640-fe0f",
      "1f482-1f3fc-200d-2640-fe0f",
      "1f482-1f3fd-200d-2640-fe0f",
      "1f482-1f3fe-200d-2640-fe0f",
      "1f482-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "ninja"
    ],
    u: "1f977",
    v: [
      "1f977-1f3fb",
      "1f977-1f3fc",
      "1f977-1f3fd",
      "1f977-1f3fe",
      "1f977-1f3ff"
    ],
    a: "13.0"
  },
  {
    n: [
      "construction worker"
    ],
    u: "1f477",
    v: [
      "1f477-1f3fb",
      "1f477-1f3fc",
      "1f477-1f3fd",
      "1f477-1f3fe",
      "1f477-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man construction worker",
      "male-construction-worker"
    ],
    u: "1f477-200d-2642-fe0f",
    v: [
      "1f477-1f3fb-200d-2642-fe0f",
      "1f477-1f3fc-200d-2642-fe0f",
      "1f477-1f3fd-200d-2642-fe0f",
      "1f477-1f3fe-200d-2642-fe0f",
      "1f477-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman construction worker",
      "female-construction-worker"
    ],
    u: "1f477-200d-2640-fe0f",
    v: [
      "1f477-1f3fb-200d-2640-fe0f",
      "1f477-1f3fc-200d-2640-fe0f",
      "1f477-1f3fd-200d-2640-fe0f",
      "1f477-1f3fe-200d-2640-fe0f",
      "1f477-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "person with crown"
    ],
    u: "1fac5",
    v: [
      "1fac5-1f3fb",
      "1fac5-1f3fc",
      "1fac5-1f3fd",
      "1fac5-1f3fe",
      "1fac5-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "prince"
    ],
    u: "1f934",
    v: [
      "1f934-1f3fb",
      "1f934-1f3fc",
      "1f934-1f3fd",
      "1f934-1f3fe",
      "1f934-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "princess"
    ],
    u: "1f478",
    v: [
      "1f478-1f3fb",
      "1f478-1f3fc",
      "1f478-1f3fd",
      "1f478-1f3fe",
      "1f478-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man with turban"
    ],
    u: "1f473",
    v: [
      "1f473-1f3fb",
      "1f473-1f3fc",
      "1f473-1f3fd",
      "1f473-1f3fe",
      "1f473-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man wearing turban",
      "man-wearing-turban"
    ],
    u: "1f473-200d-2642-fe0f",
    v: [
      "1f473-1f3fb-200d-2642-fe0f",
      "1f473-1f3fc-200d-2642-fe0f",
      "1f473-1f3fd-200d-2642-fe0f",
      "1f473-1f3fe-200d-2642-fe0f",
      "1f473-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman wearing turban",
      "woman-wearing-turban"
    ],
    u: "1f473-200d-2640-fe0f",
    v: [
      "1f473-1f3fb-200d-2640-fe0f",
      "1f473-1f3fc-200d-2640-fe0f",
      "1f473-1f3fd-200d-2640-fe0f",
      "1f473-1f3fe-200d-2640-fe0f",
      "1f473-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "man with gua pi mao"
    ],
    u: "1f472",
    v: [
      "1f472-1f3fb",
      "1f472-1f3fc",
      "1f472-1f3fd",
      "1f472-1f3fe",
      "1f472-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "person with headscarf"
    ],
    u: "1f9d5",
    v: [
      "1f9d5-1f3fb",
      "1f9d5-1f3fc",
      "1f9d5-1f3fd",
      "1f9d5-1f3fe",
      "1f9d5-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man in tuxedo",
      "person in tuxedo"
    ],
    u: "1f935",
    v: [
      "1f935-1f3fb",
      "1f935-1f3fc",
      "1f935-1f3fd",
      "1f935-1f3fe",
      "1f935-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man in tuxedo"
    ],
    u: "1f935-200d-2642-fe0f",
    v: [
      "1f935-1f3fb-200d-2642-fe0f",
      "1f935-1f3fc-200d-2642-fe0f",
      "1f935-1f3fd-200d-2642-fe0f",
      "1f935-1f3fe-200d-2642-fe0f",
      "1f935-1f3ff-200d-2642-fe0f"
    ],
    a: "13.0"
  },
  {
    n: [
      "woman in tuxedo"
    ],
    u: "1f935-200d-2640-fe0f",
    v: [
      "1f935-1f3fb-200d-2640-fe0f",
      "1f935-1f3fc-200d-2640-fe0f",
      "1f935-1f3fd-200d-2640-fe0f",
      "1f935-1f3fe-200d-2640-fe0f",
      "1f935-1f3ff-200d-2640-fe0f"
    ],
    a: "13.0"
  },
  {
    n: [
      "bride with veil"
    ],
    u: "1f470",
    v: [
      "1f470-1f3fb",
      "1f470-1f3fc",
      "1f470-1f3fd",
      "1f470-1f3fe",
      "1f470-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man with veil"
    ],
    u: "1f470-200d-2642-fe0f",
    v: [
      "1f470-1f3fb-200d-2642-fe0f",
      "1f470-1f3fc-200d-2642-fe0f",
      "1f470-1f3fd-200d-2642-fe0f",
      "1f470-1f3fe-200d-2642-fe0f",
      "1f470-1f3ff-200d-2642-fe0f"
    ],
    a: "13.0"
  },
  {
    n: [
      "woman with veil"
    ],
    u: "1f470-200d-2640-fe0f",
    v: [
      "1f470-1f3fb-200d-2640-fe0f",
      "1f470-1f3fc-200d-2640-fe0f",
      "1f470-1f3fd-200d-2640-fe0f",
      "1f470-1f3fe-200d-2640-fe0f",
      "1f470-1f3ff-200d-2640-fe0f"
    ],
    a: "13.0"
  },
  {
    n: [
      "pregnant woman"
    ],
    u: "1f930",
    v: [
      "1f930-1f3fb",
      "1f930-1f3fc",
      "1f930-1f3fd",
      "1f930-1f3fe",
      "1f930-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "pregnant man"
    ],
    u: "1fac3",
    v: [
      "1fac3-1f3fb",
      "1fac3-1f3fc",
      "1fac3-1f3fd",
      "1fac3-1f3fe",
      "1fac3-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "pregnant person"
    ],
    u: "1fac4",
    v: [
      "1fac4-1f3fb",
      "1fac4-1f3fc",
      "1fac4-1f3fd",
      "1fac4-1f3fe",
      "1fac4-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "breast-feeding"
    ],
    u: "1f931",
    v: [
      "1f931-1f3fb",
      "1f931-1f3fc",
      "1f931-1f3fd",
      "1f931-1f3fe",
      "1f931-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman feeding baby"
    ],
    u: "1f469-200d-1f37c",
    v: [
      "1f469-1f3fb-200d-1f37c",
      "1f469-1f3fc-200d-1f37c",
      "1f469-1f3fd-200d-1f37c",
      "1f469-1f3fe-200d-1f37c",
      "1f469-1f3ff-200d-1f37c"
    ],
    a: "13.0"
  },
  {
    n: [
      "man feeding baby"
    ],
    u: "1f468-200d-1f37c",
    v: [
      "1f468-1f3fb-200d-1f37c",
      "1f468-1f3fc-200d-1f37c",
      "1f468-1f3fd-200d-1f37c",
      "1f468-1f3fe-200d-1f37c",
      "1f468-1f3ff-200d-1f37c"
    ],
    a: "13.0"
  },
  {
    n: [
      "person feeding baby"
    ],
    u: "1f9d1-200d-1f37c",
    v: [
      "1f9d1-1f3fb-200d-1f37c",
      "1f9d1-1f3fc-200d-1f37c",
      "1f9d1-1f3fd-200d-1f37c",
      "1f9d1-1f3fe-200d-1f37c",
      "1f9d1-1f3ff-200d-1f37c"
    ],
    a: "13.0"
  },
  {
    n: [
      "angel",
      "baby angel"
    ],
    u: "1f47c",
    v: [
      "1f47c-1f3fb",
      "1f47c-1f3fc",
      "1f47c-1f3fd",
      "1f47c-1f3fe",
      "1f47c-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "santa",
      "father christmas"
    ],
    u: "1f385",
    v: [
      "1f385-1f3fb",
      "1f385-1f3fc",
      "1f385-1f3fd",
      "1f385-1f3fe",
      "1f385-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "mrs claus",
      "mother christmas"
    ],
    u: "1f936",
    v: [
      "1f936-1f3fb",
      "1f936-1f3fc",
      "1f936-1f3fd",
      "1f936-1f3fe",
      "1f936-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "mx claus"
    ],
    u: "1f9d1-200d-1f384",
    v: [
      "1f9d1-1f3fb-200d-1f384",
      "1f9d1-1f3fc-200d-1f384",
      "1f9d1-1f3fd-200d-1f384",
      "1f9d1-1f3fe-200d-1f384",
      "1f9d1-1f3ff-200d-1f384"
    ],
    a: "13.0"
  },
  {
    n: [
      "superhero"
    ],
    u: "1f9b8",
    v: [
      "1f9b8-1f3fb",
      "1f9b8-1f3fc",
      "1f9b8-1f3fd",
      "1f9b8-1f3fe",
      "1f9b8-1f3ff"
    ],
    a: "11.0"
  },
  {
    n: [
      "man superhero",
      "male superhero"
    ],
    u: "1f9b8-200d-2642-fe0f",
    v: [
      "1f9b8-1f3fb-200d-2642-fe0f",
      "1f9b8-1f3fc-200d-2642-fe0f",
      "1f9b8-1f3fd-200d-2642-fe0f",
      "1f9b8-1f3fe-200d-2642-fe0f",
      "1f9b8-1f3ff-200d-2642-fe0f"
    ],
    a: "11.0"
  },
  {
    n: [
      "woman superhero",
      "female superhero"
    ],
    u: "1f9b8-200d-2640-fe0f",
    v: [
      "1f9b8-1f3fb-200d-2640-fe0f",
      "1f9b8-1f3fc-200d-2640-fe0f",
      "1f9b8-1f3fd-200d-2640-fe0f",
      "1f9b8-1f3fe-200d-2640-fe0f",
      "1f9b8-1f3ff-200d-2640-fe0f"
    ],
    a: "11.0"
  },
  {
    n: [
      "supervillain"
    ],
    u: "1f9b9",
    v: [
      "1f9b9-1f3fb",
      "1f9b9-1f3fc",
      "1f9b9-1f3fd",
      "1f9b9-1f3fe",
      "1f9b9-1f3ff"
    ],
    a: "11.0"
  },
  {
    n: [
      "man supervillain",
      "male supervillain"
    ],
    u: "1f9b9-200d-2642-fe0f",
    v: [
      "1f9b9-1f3fb-200d-2642-fe0f",
      "1f9b9-1f3fc-200d-2642-fe0f",
      "1f9b9-1f3fd-200d-2642-fe0f",
      "1f9b9-1f3fe-200d-2642-fe0f",
      "1f9b9-1f3ff-200d-2642-fe0f"
    ],
    a: "11.0"
  },
  {
    n: [
      "woman supervillain",
      "female supervillain"
    ],
    u: "1f9b9-200d-2640-fe0f",
    v: [
      "1f9b9-1f3fb-200d-2640-fe0f",
      "1f9b9-1f3fc-200d-2640-fe0f",
      "1f9b9-1f3fd-200d-2640-fe0f",
      "1f9b9-1f3fe-200d-2640-fe0f",
      "1f9b9-1f3ff-200d-2640-fe0f"
    ],
    a: "11.0"
  },
  {
    n: [
      "mage"
    ],
    u: "1f9d9",
    v: [
      "1f9d9-1f3fb",
      "1f9d9-1f3fc",
      "1f9d9-1f3fd",
      "1f9d9-1f3fe",
      "1f9d9-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man mage",
      "male mage"
    ],
    u: "1f9d9-200d-2642-fe0f",
    v: [
      "1f9d9-1f3fb-200d-2642-fe0f",
      "1f9d9-1f3fc-200d-2642-fe0f",
      "1f9d9-1f3fd-200d-2642-fe0f",
      "1f9d9-1f3fe-200d-2642-fe0f",
      "1f9d9-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman mage",
      "female mage"
    ],
    u: "1f9d9-200d-2640-fe0f",
    v: [
      "1f9d9-1f3fb-200d-2640-fe0f",
      "1f9d9-1f3fc-200d-2640-fe0f",
      "1f9d9-1f3fd-200d-2640-fe0f",
      "1f9d9-1f3fe-200d-2640-fe0f",
      "1f9d9-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "fairy"
    ],
    u: "1f9da",
    v: [
      "1f9da-1f3fb",
      "1f9da-1f3fc",
      "1f9da-1f3fd",
      "1f9da-1f3fe",
      "1f9da-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man fairy",
      "male fairy"
    ],
    u: "1f9da-200d-2642-fe0f",
    v: [
      "1f9da-1f3fb-200d-2642-fe0f",
      "1f9da-1f3fc-200d-2642-fe0f",
      "1f9da-1f3fd-200d-2642-fe0f",
      "1f9da-1f3fe-200d-2642-fe0f",
      "1f9da-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman fairy",
      "female fairy"
    ],
    u: "1f9da-200d-2640-fe0f",
    v: [
      "1f9da-1f3fb-200d-2640-fe0f",
      "1f9da-1f3fc-200d-2640-fe0f",
      "1f9da-1f3fd-200d-2640-fe0f",
      "1f9da-1f3fe-200d-2640-fe0f",
      "1f9da-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "vampire"
    ],
    u: "1f9db",
    v: [
      "1f9db-1f3fb",
      "1f9db-1f3fc",
      "1f9db-1f3fd",
      "1f9db-1f3fe",
      "1f9db-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man vampire",
      "male vampire"
    ],
    u: "1f9db-200d-2642-fe0f",
    v: [
      "1f9db-1f3fb-200d-2642-fe0f",
      "1f9db-1f3fc-200d-2642-fe0f",
      "1f9db-1f3fd-200d-2642-fe0f",
      "1f9db-1f3fe-200d-2642-fe0f",
      "1f9db-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman vampire",
      "female vampire"
    ],
    u: "1f9db-200d-2640-fe0f",
    v: [
      "1f9db-1f3fb-200d-2640-fe0f",
      "1f9db-1f3fc-200d-2640-fe0f",
      "1f9db-1f3fd-200d-2640-fe0f",
      "1f9db-1f3fe-200d-2640-fe0f",
      "1f9db-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "merperson"
    ],
    u: "1f9dc",
    v: [
      "1f9dc-1f3fb",
      "1f9dc-1f3fc",
      "1f9dc-1f3fd",
      "1f9dc-1f3fe",
      "1f9dc-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "merman"
    ],
    u: "1f9dc-200d-2642-fe0f",
    v: [
      "1f9dc-1f3fb-200d-2642-fe0f",
      "1f9dc-1f3fc-200d-2642-fe0f",
      "1f9dc-1f3fd-200d-2642-fe0f",
      "1f9dc-1f3fe-200d-2642-fe0f",
      "1f9dc-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "mermaid"
    ],
    u: "1f9dc-200d-2640-fe0f",
    v: [
      "1f9dc-1f3fb-200d-2640-fe0f",
      "1f9dc-1f3fc-200d-2640-fe0f",
      "1f9dc-1f3fd-200d-2640-fe0f",
      "1f9dc-1f3fe-200d-2640-fe0f",
      "1f9dc-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "elf"
    ],
    u: "1f9dd",
    v: [
      "1f9dd-1f3fb",
      "1f9dd-1f3fc",
      "1f9dd-1f3fd",
      "1f9dd-1f3fe",
      "1f9dd-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man elf",
      "male elf"
    ],
    u: "1f9dd-200d-2642-fe0f",
    v: [
      "1f9dd-1f3fb-200d-2642-fe0f",
      "1f9dd-1f3fc-200d-2642-fe0f",
      "1f9dd-1f3fd-200d-2642-fe0f",
      "1f9dd-1f3fe-200d-2642-fe0f",
      "1f9dd-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman elf",
      "female elf"
    ],
    u: "1f9dd-200d-2640-fe0f",
    v: [
      "1f9dd-1f3fb-200d-2640-fe0f",
      "1f9dd-1f3fc-200d-2640-fe0f",
      "1f9dd-1f3fd-200d-2640-fe0f",
      "1f9dd-1f3fe-200d-2640-fe0f",
      "1f9dd-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "genie"
    ],
    u: "1f9de",
    a: "5.0"
  },
  {
    n: [
      "man genie",
      "male genie"
    ],
    u: "1f9de-200d-2642-fe0f",
    a: "5.0"
  },
  {
    n: [
      "woman genie",
      "female genie"
    ],
    u: "1f9de-200d-2640-fe0f",
    a: "5.0"
  },
  {
    n: [
      "zombie"
    ],
    u: "1f9df",
    a: "5.0"
  },
  {
    n: [
      "man zombie",
      "male zombie"
    ],
    u: "1f9df-200d-2642-fe0f",
    a: "5.0"
  },
  {
    n: [
      "woman zombie",
      "female zombie"
    ],
    u: "1f9df-200d-2640-fe0f",
    a: "5.0"
  },
  {
    n: [
      "troll"
    ],
    u: "1f9cc",
    a: "14.0"
  },
  {
    n: [
      "massage",
      "face massage"
    ],
    u: "1f486",
    v: [
      "1f486-1f3fb",
      "1f486-1f3fc",
      "1f486-1f3fd",
      "1f486-1f3fe",
      "1f486-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man getting massage",
      "man-getting-massage"
    ],
    u: "1f486-200d-2642-fe0f",
    v: [
      "1f486-1f3fb-200d-2642-fe0f",
      "1f486-1f3fc-200d-2642-fe0f",
      "1f486-1f3fd-200d-2642-fe0f",
      "1f486-1f3fe-200d-2642-fe0f",
      "1f486-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman getting massage",
      "woman-getting-massage"
    ],
    u: "1f486-200d-2640-fe0f",
    v: [
      "1f486-1f3fb-200d-2640-fe0f",
      "1f486-1f3fc-200d-2640-fe0f",
      "1f486-1f3fd-200d-2640-fe0f",
      "1f486-1f3fe-200d-2640-fe0f",
      "1f486-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "haircut"
    ],
    u: "1f487",
    v: [
      "1f487-1f3fb",
      "1f487-1f3fc",
      "1f487-1f3fd",
      "1f487-1f3fe",
      "1f487-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man getting haircut",
      "man-getting-haircut"
    ],
    u: "1f487-200d-2642-fe0f",
    v: [
      "1f487-1f3fb-200d-2642-fe0f",
      "1f487-1f3fc-200d-2642-fe0f",
      "1f487-1f3fd-200d-2642-fe0f",
      "1f487-1f3fe-200d-2642-fe0f",
      "1f487-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman getting haircut",
      "woman-getting-haircut"
    ],
    u: "1f487-200d-2640-fe0f",
    v: [
      "1f487-1f3fb-200d-2640-fe0f",
      "1f487-1f3fc-200d-2640-fe0f",
      "1f487-1f3fd-200d-2640-fe0f",
      "1f487-1f3fe-200d-2640-fe0f",
      "1f487-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "walking",
      "pedestrian"
    ],
    u: "1f6b6",
    v: [
      "1f6b6-1f3fb",
      "1f6b6-1f3fc",
      "1f6b6-1f3fd",
      "1f6b6-1f3fe",
      "1f6b6-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man walking",
      "man-walking"
    ],
    u: "1f6b6-200d-2642-fe0f",
    v: [
      "1f6b6-1f3fb-200d-2642-fe0f",
      "1f6b6-1f3fc-200d-2642-fe0f",
      "1f6b6-1f3fd-200d-2642-fe0f",
      "1f6b6-1f3fe-200d-2642-fe0f",
      "1f6b6-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman walking",
      "woman-walking"
    ],
    u: "1f6b6-200d-2640-fe0f",
    v: [
      "1f6b6-1f3fb-200d-2640-fe0f",
      "1f6b6-1f3fc-200d-2640-fe0f",
      "1f6b6-1f3fd-200d-2640-fe0f",
      "1f6b6-1f3fe-200d-2640-fe0f",
      "1f6b6-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "standing person"
    ],
    u: "1f9cd",
    v: [
      "1f9cd-1f3fb",
      "1f9cd-1f3fc",
      "1f9cd-1f3fd",
      "1f9cd-1f3fe",
      "1f9cd-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "man standing"
    ],
    u: "1f9cd-200d-2642-fe0f",
    v: [
      "1f9cd-1f3fb-200d-2642-fe0f",
      "1f9cd-1f3fc-200d-2642-fe0f",
      "1f9cd-1f3fd-200d-2642-fe0f",
      "1f9cd-1f3fe-200d-2642-fe0f",
      "1f9cd-1f3ff-200d-2642-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "woman standing"
    ],
    u: "1f9cd-200d-2640-fe0f",
    v: [
      "1f9cd-1f3fb-200d-2640-fe0f",
      "1f9cd-1f3fc-200d-2640-fe0f",
      "1f9cd-1f3fd-200d-2640-fe0f",
      "1f9cd-1f3fe-200d-2640-fe0f",
      "1f9cd-1f3ff-200d-2640-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "kneeling person"
    ],
    u: "1f9ce",
    v: [
      "1f9ce-1f3fb",
      "1f9ce-1f3fc",
      "1f9ce-1f3fd",
      "1f9ce-1f3fe",
      "1f9ce-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "man kneeling"
    ],
    u: "1f9ce-200d-2642-fe0f",
    v: [
      "1f9ce-1f3fb-200d-2642-fe0f",
      "1f9ce-1f3fc-200d-2642-fe0f",
      "1f9ce-1f3fd-200d-2642-fe0f",
      "1f9ce-1f3fe-200d-2642-fe0f",
      "1f9ce-1f3ff-200d-2642-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "woman kneeling"
    ],
    u: "1f9ce-200d-2640-fe0f",
    v: [
      "1f9ce-1f3fb-200d-2640-fe0f",
      "1f9ce-1f3fc-200d-2640-fe0f",
      "1f9ce-1f3fd-200d-2640-fe0f",
      "1f9ce-1f3fe-200d-2640-fe0f",
      "1f9ce-1f3ff-200d-2640-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "person with white cane",
      "person with probing cane"
    ],
    u: "1f9d1-200d-1f9af",
    v: [
      "1f9d1-1f3fb-200d-1f9af",
      "1f9d1-1f3fc-200d-1f9af",
      "1f9d1-1f3fd-200d-1f9af",
      "1f9d1-1f3fe-200d-1f9af",
      "1f9d1-1f3ff-200d-1f9af"
    ],
    a: "12.1"
  },
  {
    n: [
      "man with white cane",
      "man with probing cane"
    ],
    u: "1f468-200d-1f9af",
    v: [
      "1f468-1f3fb-200d-1f9af",
      "1f468-1f3fc-200d-1f9af",
      "1f468-1f3fd-200d-1f9af",
      "1f468-1f3fe-200d-1f9af",
      "1f468-1f3ff-200d-1f9af"
    ],
    a: "12.0"
  },
  {
    n: [
      "woman with white cane",
      "woman with probing cane"
    ],
    u: "1f469-200d-1f9af",
    v: [
      "1f469-1f3fb-200d-1f9af",
      "1f469-1f3fc-200d-1f9af",
      "1f469-1f3fd-200d-1f9af",
      "1f469-1f3fe-200d-1f9af",
      "1f469-1f3ff-200d-1f9af"
    ],
    a: "12.0"
  },
  {
    n: [
      "person in motorized wheelchair"
    ],
    u: "1f9d1-200d-1f9bc",
    v: [
      "1f9d1-1f3fb-200d-1f9bc",
      "1f9d1-1f3fc-200d-1f9bc",
      "1f9d1-1f3fd-200d-1f9bc",
      "1f9d1-1f3fe-200d-1f9bc",
      "1f9d1-1f3ff-200d-1f9bc"
    ],
    a: "12.1"
  },
  {
    n: [
      "man in motorized wheelchair"
    ],
    u: "1f468-200d-1f9bc",
    v: [
      "1f468-1f3fb-200d-1f9bc",
      "1f468-1f3fc-200d-1f9bc",
      "1f468-1f3fd-200d-1f9bc",
      "1f468-1f3fe-200d-1f9bc",
      "1f468-1f3ff-200d-1f9bc"
    ],
    a: "12.0"
  },
  {
    n: [
      "woman in motorized wheelchair"
    ],
    u: "1f469-200d-1f9bc",
    v: [
      "1f469-1f3fb-200d-1f9bc",
      "1f469-1f3fc-200d-1f9bc",
      "1f469-1f3fd-200d-1f9bc",
      "1f469-1f3fe-200d-1f9bc",
      "1f469-1f3ff-200d-1f9bc"
    ],
    a: "12.0"
  },
  {
    n: [
      "person in manual wheelchair"
    ],
    u: "1f9d1-200d-1f9bd",
    v: [
      "1f9d1-1f3fb-200d-1f9bd",
      "1f9d1-1f3fc-200d-1f9bd",
      "1f9d1-1f3fd-200d-1f9bd",
      "1f9d1-1f3fe-200d-1f9bd",
      "1f9d1-1f3ff-200d-1f9bd"
    ],
    a: "12.1"
  },
  {
    n: [
      "man in manual wheelchair"
    ],
    u: "1f468-200d-1f9bd",
    v: [
      "1f468-1f3fb-200d-1f9bd",
      "1f468-1f3fc-200d-1f9bd",
      "1f468-1f3fd-200d-1f9bd",
      "1f468-1f3fe-200d-1f9bd",
      "1f468-1f3ff-200d-1f9bd"
    ],
    a: "12.0"
  },
  {
    n: [
      "woman in manual wheelchair"
    ],
    u: "1f469-200d-1f9bd",
    v: [
      "1f469-1f3fb-200d-1f9bd",
      "1f469-1f3fc-200d-1f9bd",
      "1f469-1f3fd-200d-1f9bd",
      "1f469-1f3fe-200d-1f9bd",
      "1f469-1f3ff-200d-1f9bd"
    ],
    a: "12.0"
  },
  {
    n: [
      "runner",
      "running"
    ],
    u: "1f3c3",
    v: [
      "1f3c3-1f3fb",
      "1f3c3-1f3fc",
      "1f3c3-1f3fd",
      "1f3c3-1f3fe",
      "1f3c3-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man running",
      "man-running"
    ],
    u: "1f3c3-200d-2642-fe0f",
    v: [
      "1f3c3-1f3fb-200d-2642-fe0f",
      "1f3c3-1f3fc-200d-2642-fe0f",
      "1f3c3-1f3fd-200d-2642-fe0f",
      "1f3c3-1f3fe-200d-2642-fe0f",
      "1f3c3-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman running",
      "woman-running"
    ],
    u: "1f3c3-200d-2640-fe0f",
    v: [
      "1f3c3-1f3fb-200d-2640-fe0f",
      "1f3c3-1f3fc-200d-2640-fe0f",
      "1f3c3-1f3fd-200d-2640-fe0f",
      "1f3c3-1f3fe-200d-2640-fe0f",
      "1f3c3-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "dancer"
    ],
    u: "1f483",
    v: [
      "1f483-1f3fb",
      "1f483-1f3fc",
      "1f483-1f3fd",
      "1f483-1f3fe",
      "1f483-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man dancing"
    ],
    u: "1f57a",
    v: [
      "1f57a-1f3fb",
      "1f57a-1f3fc",
      "1f57a-1f3fd",
      "1f57a-1f3fe",
      "1f57a-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "person in suit levitating",
      "man in business suit levitating"
    ],
    u: "1f574-fe0f",
    v: [
      "1f574-1f3fb",
      "1f574-1f3fc",
      "1f574-1f3fd",
      "1f574-1f3fe",
      "1f574-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "dancers",
      "woman with bunny ears"
    ],
    u: "1f46f",
    a: "0.6"
  },
  {
    n: [
      "men with bunny ears",
      "men-with-bunny-ears-partying",
      "man-with-bunny-ears-partying"
    ],
    u: "1f46f-200d-2642-fe0f",
    a: "4.0"
  },
  {
    n: [
      "women with bunny ears",
      "women-with-bunny-ears-partying",
      "woman-with-bunny-ears-partying"
    ],
    u: "1f46f-200d-2640-fe0f",
    a: "4.0"
  },
  {
    n: [
      "person in steamy room"
    ],
    u: "1f9d6",
    v: [
      "1f9d6-1f3fb",
      "1f9d6-1f3fc",
      "1f9d6-1f3fd",
      "1f9d6-1f3fe",
      "1f9d6-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man in steamy room"
    ],
    u: "1f9d6-200d-2642-fe0f",
    v: [
      "1f9d6-1f3fb-200d-2642-fe0f",
      "1f9d6-1f3fc-200d-2642-fe0f",
      "1f9d6-1f3fd-200d-2642-fe0f",
      "1f9d6-1f3fe-200d-2642-fe0f",
      "1f9d6-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman in steamy room"
    ],
    u: "1f9d6-200d-2640-fe0f",
    v: [
      "1f9d6-1f3fb-200d-2640-fe0f",
      "1f9d6-1f3fc-200d-2640-fe0f",
      "1f9d6-1f3fd-200d-2640-fe0f",
      "1f9d6-1f3fe-200d-2640-fe0f",
      "1f9d6-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "person climbing"
    ],
    u: "1f9d7",
    v: [
      "1f9d7-1f3fb",
      "1f9d7-1f3fc",
      "1f9d7-1f3fd",
      "1f9d7-1f3fe",
      "1f9d7-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man climbing"
    ],
    u: "1f9d7-200d-2642-fe0f",
    v: [
      "1f9d7-1f3fb-200d-2642-fe0f",
      "1f9d7-1f3fc-200d-2642-fe0f",
      "1f9d7-1f3fd-200d-2642-fe0f",
      "1f9d7-1f3fe-200d-2642-fe0f",
      "1f9d7-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman climbing"
    ],
    u: "1f9d7-200d-2640-fe0f",
    v: [
      "1f9d7-1f3fb-200d-2640-fe0f",
      "1f9d7-1f3fc-200d-2640-fe0f",
      "1f9d7-1f3fd-200d-2640-fe0f",
      "1f9d7-1f3fe-200d-2640-fe0f",
      "1f9d7-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "fencer"
    ],
    u: "1f93a",
    a: "3.0"
  },
  {
    n: [
      "horse racing"
    ],
    u: "1f3c7",
    v: [
      "1f3c7-1f3fb",
      "1f3c7-1f3fc",
      "1f3c7-1f3fd",
      "1f3c7-1f3fe",
      "1f3c7-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "skier"
    ],
    u: "26f7-fe0f",
    a: "0.7"
  },
  {
    n: [
      "snowboarder"
    ],
    u: "1f3c2",
    v: [
      "1f3c2-1f3fb",
      "1f3c2-1f3fc",
      "1f3c2-1f3fd",
      "1f3c2-1f3fe",
      "1f3c2-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "golfer",
      "person golfing"
    ],
    u: "1f3cc-fe0f",
    v: [
      "1f3cc-1f3fb",
      "1f3cc-1f3fc",
      "1f3cc-1f3fd",
      "1f3cc-1f3fe",
      "1f3cc-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "man golfing",
      "man-golfing"
    ],
    u: "1f3cc-fe0f-200d-2642-fe0f",
    v: [
      "1f3cc-1f3fb-200d-2642-fe0f",
      "1f3cc-1f3fc-200d-2642-fe0f",
      "1f3cc-1f3fd-200d-2642-fe0f",
      "1f3cc-1f3fe-200d-2642-fe0f",
      "1f3cc-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman golfing",
      "woman-golfing"
    ],
    u: "1f3cc-fe0f-200d-2640-fe0f",
    v: [
      "1f3cc-1f3fb-200d-2640-fe0f",
      "1f3cc-1f3fc-200d-2640-fe0f",
      "1f3cc-1f3fd-200d-2640-fe0f",
      "1f3cc-1f3fe-200d-2640-fe0f",
      "1f3cc-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "surfer"
    ],
    u: "1f3c4",
    v: [
      "1f3c4-1f3fb",
      "1f3c4-1f3fc",
      "1f3c4-1f3fd",
      "1f3c4-1f3fe",
      "1f3c4-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man surfing",
      "man-surfing"
    ],
    u: "1f3c4-200d-2642-fe0f",
    v: [
      "1f3c4-1f3fb-200d-2642-fe0f",
      "1f3c4-1f3fc-200d-2642-fe0f",
      "1f3c4-1f3fd-200d-2642-fe0f",
      "1f3c4-1f3fe-200d-2642-fe0f",
      "1f3c4-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman surfing",
      "woman-surfing"
    ],
    u: "1f3c4-200d-2640-fe0f",
    v: [
      "1f3c4-1f3fb-200d-2640-fe0f",
      "1f3c4-1f3fc-200d-2640-fe0f",
      "1f3c4-1f3fd-200d-2640-fe0f",
      "1f3c4-1f3fe-200d-2640-fe0f",
      "1f3c4-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "rowboat"
    ],
    u: "1f6a3",
    v: [
      "1f6a3-1f3fb",
      "1f6a3-1f3fc",
      "1f6a3-1f3fd",
      "1f6a3-1f3fe",
      "1f6a3-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "man rowing boat",
      "man-rowing-boat"
    ],
    u: "1f6a3-200d-2642-fe0f",
    v: [
      "1f6a3-1f3fb-200d-2642-fe0f",
      "1f6a3-1f3fc-200d-2642-fe0f",
      "1f6a3-1f3fd-200d-2642-fe0f",
      "1f6a3-1f3fe-200d-2642-fe0f",
      "1f6a3-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman rowing boat",
      "woman-rowing-boat"
    ],
    u: "1f6a3-200d-2640-fe0f",
    v: [
      "1f6a3-1f3fb-200d-2640-fe0f",
      "1f6a3-1f3fc-200d-2640-fe0f",
      "1f6a3-1f3fd-200d-2640-fe0f",
      "1f6a3-1f3fe-200d-2640-fe0f",
      "1f6a3-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "swimmer"
    ],
    u: "1f3ca",
    v: [
      "1f3ca-1f3fb",
      "1f3ca-1f3fc",
      "1f3ca-1f3fd",
      "1f3ca-1f3fe",
      "1f3ca-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man swimming",
      "man-swimming"
    ],
    u: "1f3ca-200d-2642-fe0f",
    v: [
      "1f3ca-1f3fb-200d-2642-fe0f",
      "1f3ca-1f3fc-200d-2642-fe0f",
      "1f3ca-1f3fd-200d-2642-fe0f",
      "1f3ca-1f3fe-200d-2642-fe0f",
      "1f3ca-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman swimming",
      "woman-swimming"
    ],
    u: "1f3ca-200d-2640-fe0f",
    v: [
      "1f3ca-1f3fb-200d-2640-fe0f",
      "1f3ca-1f3fc-200d-2640-fe0f",
      "1f3ca-1f3fd-200d-2640-fe0f",
      "1f3ca-1f3fe-200d-2640-fe0f",
      "1f3ca-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "person with ball",
      "person bouncing ball"
    ],
    u: "26f9-fe0f",
    v: [
      "26f9-1f3fb",
      "26f9-1f3fc",
      "26f9-1f3fd",
      "26f9-1f3fe",
      "26f9-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "man bouncing ball",
      "man-bouncing-ball"
    ],
    u: "26f9-fe0f-200d-2642-fe0f",
    v: [
      "26f9-1f3fb-200d-2642-fe0f",
      "26f9-1f3fc-200d-2642-fe0f",
      "26f9-1f3fd-200d-2642-fe0f",
      "26f9-1f3fe-200d-2642-fe0f",
      "26f9-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman bouncing ball",
      "woman-bouncing-ball"
    ],
    u: "26f9-fe0f-200d-2640-fe0f",
    v: [
      "26f9-1f3fb-200d-2640-fe0f",
      "26f9-1f3fc-200d-2640-fe0f",
      "26f9-1f3fd-200d-2640-fe0f",
      "26f9-1f3fe-200d-2640-fe0f",
      "26f9-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "weight lifter",
      "person lifting weights"
    ],
    u: "1f3cb-fe0f",
    v: [
      "1f3cb-1f3fb",
      "1f3cb-1f3fc",
      "1f3cb-1f3fd",
      "1f3cb-1f3fe",
      "1f3cb-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "man lifting weights",
      "man-lifting-weights"
    ],
    u: "1f3cb-fe0f-200d-2642-fe0f",
    v: [
      "1f3cb-1f3fb-200d-2642-fe0f",
      "1f3cb-1f3fc-200d-2642-fe0f",
      "1f3cb-1f3fd-200d-2642-fe0f",
      "1f3cb-1f3fe-200d-2642-fe0f",
      "1f3cb-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman lifting weights",
      "woman-lifting-weights"
    ],
    u: "1f3cb-fe0f-200d-2640-fe0f",
    v: [
      "1f3cb-1f3fb-200d-2640-fe0f",
      "1f3cb-1f3fc-200d-2640-fe0f",
      "1f3cb-1f3fd-200d-2640-fe0f",
      "1f3cb-1f3fe-200d-2640-fe0f",
      "1f3cb-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "bicyclist"
    ],
    u: "1f6b4",
    v: [
      "1f6b4-1f3fb",
      "1f6b4-1f3fc",
      "1f6b4-1f3fd",
      "1f6b4-1f3fe",
      "1f6b4-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "man biking",
      "man-biking"
    ],
    u: "1f6b4-200d-2642-fe0f",
    v: [
      "1f6b4-1f3fb-200d-2642-fe0f",
      "1f6b4-1f3fc-200d-2642-fe0f",
      "1f6b4-1f3fd-200d-2642-fe0f",
      "1f6b4-1f3fe-200d-2642-fe0f",
      "1f6b4-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman biking",
      "woman-biking"
    ],
    u: "1f6b4-200d-2640-fe0f",
    v: [
      "1f6b4-1f3fb-200d-2640-fe0f",
      "1f6b4-1f3fc-200d-2640-fe0f",
      "1f6b4-1f3fd-200d-2640-fe0f",
      "1f6b4-1f3fe-200d-2640-fe0f",
      "1f6b4-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "mountain bicyclist"
    ],
    u: "1f6b5",
    v: [
      "1f6b5-1f3fb",
      "1f6b5-1f3fc",
      "1f6b5-1f3fd",
      "1f6b5-1f3fe",
      "1f6b5-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "man mountain biking",
      "man-mountain-biking"
    ],
    u: "1f6b5-200d-2642-fe0f",
    v: [
      "1f6b5-1f3fb-200d-2642-fe0f",
      "1f6b5-1f3fc-200d-2642-fe0f",
      "1f6b5-1f3fd-200d-2642-fe0f",
      "1f6b5-1f3fe-200d-2642-fe0f",
      "1f6b5-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman mountain biking",
      "woman-mountain-biking"
    ],
    u: "1f6b5-200d-2640-fe0f",
    v: [
      "1f6b5-1f3fb-200d-2640-fe0f",
      "1f6b5-1f3fc-200d-2640-fe0f",
      "1f6b5-1f3fd-200d-2640-fe0f",
      "1f6b5-1f3fe-200d-2640-fe0f",
      "1f6b5-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "person doing cartwheel"
    ],
    u: "1f938",
    v: [
      "1f938-1f3fb",
      "1f938-1f3fc",
      "1f938-1f3fd",
      "1f938-1f3fe",
      "1f938-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man cartwheeling",
      "man-cartwheeling"
    ],
    u: "1f938-200d-2642-fe0f",
    v: [
      "1f938-1f3fb-200d-2642-fe0f",
      "1f938-1f3fc-200d-2642-fe0f",
      "1f938-1f3fd-200d-2642-fe0f",
      "1f938-1f3fe-200d-2642-fe0f",
      "1f938-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman cartwheeling",
      "woman-cartwheeling"
    ],
    u: "1f938-200d-2640-fe0f",
    v: [
      "1f938-1f3fb-200d-2640-fe0f",
      "1f938-1f3fc-200d-2640-fe0f",
      "1f938-1f3fd-200d-2640-fe0f",
      "1f938-1f3fe-200d-2640-fe0f",
      "1f938-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "wrestlers"
    ],
    u: "1f93c",
    a: "3.0"
  },
  {
    n: [
      "men wrestling",
      "man-wrestling"
    ],
    u: "1f93c-200d-2642-fe0f",
    a: "4.0"
  },
  {
    n: [
      "women wrestling",
      "woman-wrestling"
    ],
    u: "1f93c-200d-2640-fe0f",
    a: "4.0"
  },
  {
    n: [
      "water polo"
    ],
    u: "1f93d",
    v: [
      "1f93d-1f3fb",
      "1f93d-1f3fc",
      "1f93d-1f3fd",
      "1f93d-1f3fe",
      "1f93d-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man playing water polo",
      "man-playing-water-polo"
    ],
    u: "1f93d-200d-2642-fe0f",
    v: [
      "1f93d-1f3fb-200d-2642-fe0f",
      "1f93d-1f3fc-200d-2642-fe0f",
      "1f93d-1f3fd-200d-2642-fe0f",
      "1f93d-1f3fe-200d-2642-fe0f",
      "1f93d-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman playing water polo",
      "woman-playing-water-polo"
    ],
    u: "1f93d-200d-2640-fe0f",
    v: [
      "1f93d-1f3fb-200d-2640-fe0f",
      "1f93d-1f3fc-200d-2640-fe0f",
      "1f93d-1f3fd-200d-2640-fe0f",
      "1f93d-1f3fe-200d-2640-fe0f",
      "1f93d-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "handball"
    ],
    u: "1f93e",
    v: [
      "1f93e-1f3fb",
      "1f93e-1f3fc",
      "1f93e-1f3fd",
      "1f93e-1f3fe",
      "1f93e-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man playing handball",
      "man-playing-handball"
    ],
    u: "1f93e-200d-2642-fe0f",
    v: [
      "1f93e-1f3fb-200d-2642-fe0f",
      "1f93e-1f3fc-200d-2642-fe0f",
      "1f93e-1f3fd-200d-2642-fe0f",
      "1f93e-1f3fe-200d-2642-fe0f",
      "1f93e-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman playing handball",
      "woman-playing-handball"
    ],
    u: "1f93e-200d-2640-fe0f",
    v: [
      "1f93e-1f3fb-200d-2640-fe0f",
      "1f93e-1f3fc-200d-2640-fe0f",
      "1f93e-1f3fd-200d-2640-fe0f",
      "1f93e-1f3fe-200d-2640-fe0f",
      "1f93e-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "juggling"
    ],
    u: "1f939",
    v: [
      "1f939-1f3fb",
      "1f939-1f3fc",
      "1f939-1f3fd",
      "1f939-1f3fe",
      "1f939-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man juggling",
      "man-juggling"
    ],
    u: "1f939-200d-2642-fe0f",
    v: [
      "1f939-1f3fb-200d-2642-fe0f",
      "1f939-1f3fc-200d-2642-fe0f",
      "1f939-1f3fd-200d-2642-fe0f",
      "1f939-1f3fe-200d-2642-fe0f",
      "1f939-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman juggling",
      "woman-juggling"
    ],
    u: "1f939-200d-2640-fe0f",
    v: [
      "1f939-1f3fb-200d-2640-fe0f",
      "1f939-1f3fc-200d-2640-fe0f",
      "1f939-1f3fd-200d-2640-fe0f",
      "1f939-1f3fe-200d-2640-fe0f",
      "1f939-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "person in lotus position"
    ],
    u: "1f9d8",
    v: [
      "1f9d8-1f3fb",
      "1f9d8-1f3fc",
      "1f9d8-1f3fd",
      "1f9d8-1f3fe",
      "1f9d8-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man in lotus position"
    ],
    u: "1f9d8-200d-2642-fe0f",
    v: [
      "1f9d8-1f3fb-200d-2642-fe0f",
      "1f9d8-1f3fc-200d-2642-fe0f",
      "1f9d8-1f3fd-200d-2642-fe0f",
      "1f9d8-1f3fe-200d-2642-fe0f",
      "1f9d8-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman in lotus position"
    ],
    u: "1f9d8-200d-2640-fe0f",
    v: [
      "1f9d8-1f3fb-200d-2640-fe0f",
      "1f9d8-1f3fc-200d-2640-fe0f",
      "1f9d8-1f3fd-200d-2640-fe0f",
      "1f9d8-1f3fe-200d-2640-fe0f",
      "1f9d8-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "bath"
    ],
    u: "1f6c0",
    v: [
      "1f6c0-1f3fb",
      "1f6c0-1f3fc",
      "1f6c0-1f3fd",
      "1f6c0-1f3fe",
      "1f6c0-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "sleeping accommodation"
    ],
    u: "1f6cc",
    v: [
      "1f6cc-1f3fb",
      "1f6cc-1f3fc",
      "1f6cc-1f3fd",
      "1f6cc-1f3fe",
      "1f6cc-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "people holding hands"
    ],
    u: "1f9d1-200d-1f91d-200d-1f9d1",
    v: [
      "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
      "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc",
      "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd",
      "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe",
      "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff",
      "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb",
      "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
      "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd",
      "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe",
      "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff",
      "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb",
      "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc",
      "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
      "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe",
      "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff",
      "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb",
      "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc",
      "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd",
      "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
      "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff",
      "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb",
      "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc",
      "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd",
      "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe",
      "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "women holding hands",
      "two women holding hands"
    ],
    u: "1f46d",
    v: [
      "1f46d-1f3fb",
      "1f46d-1f3fc",
      "1f46d-1f3fd",
      "1f46d-1f3fe",
      "1f46d-1f3ff",
      "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc",
      "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd",
      "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe",
      "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff",
      "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb",
      "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd",
      "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe",
      "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff",
      "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb",
      "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc",
      "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe",
      "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff",
      "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb",
      "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc",
      "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd",
      "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff",
      "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb",
      "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc",
      "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd",
      "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe"
    ],
    a: "1.0"
  },
  {
    n: [
      "couple",
      "man and woman holding hands",
      "woman and man holding hands"
    ],
    u: "1f46b",
    v: [
      "1f46b-1f3fb",
      "1f46b-1f3fc",
      "1f46b-1f3fd",
      "1f46b-1f3fe",
      "1f46b-1f3ff",
      "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc",
      "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd",
      "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe",
      "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff",
      "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb",
      "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd",
      "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe",
      "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff",
      "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb",
      "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc",
      "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe",
      "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff",
      "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb",
      "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc",
      "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd",
      "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff",
      "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb",
      "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc",
      "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd",
      "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe"
    ],
    a: "0.6"
  },
  {
    n: [
      "men holding hands",
      "two men holding hands"
    ],
    u: "1f46c",
    v: [
      "1f46c-1f3fb",
      "1f46c-1f3fc",
      "1f46c-1f3fd",
      "1f46c-1f3fe",
      "1f46c-1f3ff",
      "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc",
      "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd",
      "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe",
      "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff",
      "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb",
      "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd",
      "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe",
      "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff",
      "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb",
      "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc",
      "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe",
      "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff",
      "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb",
      "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc",
      "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd",
      "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff",
      "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb",
      "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc",
      "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd",
      "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe"
    ],
    a: "1.0"
  },
  {
    n: [
      "kiss",
      "couplekiss"
    ],
    u: "1f48f",
    v: [
      "1f48f-1f3fb",
      "1f48f-1f3fc",
      "1f48f-1f3fd",
      "1f48f-1f3fe",
      "1f48f-1f3ff",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe"
    ],
    a: "0.6"
  },
  {
    n: [
      "woman-kiss-man",
      "kiss: woman, man"
    ],
    u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
    v: [
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "man-kiss-man",
      "kiss: man, man"
    ],
    u: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
    v: [
      "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "woman-kiss-woman",
      "kiss: woman, woman"
    ],
    u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
    v: [
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "couple with heart"
    ],
    u: "1f491",
    v: [
      "1f491-1f3fb",
      "1f491-1f3fc",
      "1f491-1f3fd",
      "1f491-1f3fe",
      "1f491-1f3ff",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe"
    ],
    a: "0.6"
  },
  {
    n: [
      "woman-heart-man",
      "couple with heart: woman, man"
    ],
    u: "1f469-200d-2764-fe0f-200d-1f468",
    v: [
      "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "man-heart-man",
      "couple with heart: man, man"
    ],
    u: "1f468-200d-2764-fe0f-200d-1f468",
    v: [
      "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "woman-heart-woman",
      "couple with heart: woman, woman"
    ],
    u: "1f469-200d-2764-fe0f-200d-1f469",
    v: [
      "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "family"
    ],
    u: "1f46a",
    a: "0.6"
  },
  {
    n: [
      "man-woman-boy",
      "family: man, woman, boy"
    ],
    u: "1f468-200d-1f469-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-woman-girl",
      "family: man, woman, girl"
    ],
    u: "1f468-200d-1f469-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "man-woman-girl-boy",
      "family: man, woman, girl, boy"
    ],
    u: "1f468-200d-1f469-200d-1f467-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-woman-boy-boy",
      "family: man, woman, boy, boy"
    ],
    u: "1f468-200d-1f469-200d-1f466-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-woman-girl-girl",
      "family: man, woman, girl, girl"
    ],
    u: "1f468-200d-1f469-200d-1f467-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "man-man-boy",
      "family: man, man, boy"
    ],
    u: "1f468-200d-1f468-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-man-girl",
      "family: man, man, girl"
    ],
    u: "1f468-200d-1f468-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "man-man-girl-boy",
      "family: man, man, girl, boy"
    ],
    u: "1f468-200d-1f468-200d-1f467-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-man-boy-boy",
      "family: man, man, boy, boy"
    ],
    u: "1f468-200d-1f468-200d-1f466-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-man-girl-girl",
      "family: man, man, girl, girl"
    ],
    u: "1f468-200d-1f468-200d-1f467-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "woman-woman-boy",
      "family: woman, woman, boy"
    ],
    u: "1f469-200d-1f469-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "woman-woman-girl",
      "family: woman, woman, girl"
    ],
    u: "1f469-200d-1f469-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "woman-woman-girl-boy",
      "family: woman, woman, girl, boy"
    ],
    u: "1f469-200d-1f469-200d-1f467-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "woman-woman-boy-boy",
      "family: woman, woman, boy, boy"
    ],
    u: "1f469-200d-1f469-200d-1f466-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "woman-woman-girl-girl",
      "family: woman, woman, girl, girl"
    ],
    u: "1f469-200d-1f469-200d-1f467-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "man-boy",
      "family: man, boy"
    ],
    u: "1f468-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "man-boy-boy",
      "family: man, boy, boy"
    ],
    u: "1f468-200d-1f466-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "man-girl",
      "family: man, girl"
    ],
    u: "1f468-200d-1f467",
    a: "4.0"
  },
  {
    n: [
      "man-girl-boy",
      "family: man, girl, boy"
    ],
    u: "1f468-200d-1f467-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "man-girl-girl",
      "family: man, girl, girl"
    ],
    u: "1f468-200d-1f467-200d-1f467",
    a: "4.0"
  },
  {
    n: [
      "woman-boy",
      "family: woman, boy"
    ],
    u: "1f469-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "woman-boy-boy",
      "family: woman, boy, boy"
    ],
    u: "1f469-200d-1f466-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "woman-girl",
      "family: woman, girl"
    ],
    u: "1f469-200d-1f467",
    a: "4.0"
  },
  {
    n: [
      "woman-girl-boy",
      "family: woman, girl, boy"
    ],
    u: "1f469-200d-1f467-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "woman-girl-girl",
      "family: woman, girl, girl"
    ],
    u: "1f469-200d-1f467-200d-1f467",
    a: "4.0"
  },
  {
    n: [
      "speaking head",
      "speaking head in silhouette"
    ],
    u: "1f5e3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "bust in silhouette"
    ],
    u: "1f464",
    a: "0.6"
  },
  {
    n: [
      "busts in silhouette"
    ],
    u: "1f465",
    a: "1.0"
  },
  {
    n: [
      "people hugging"
    ],
    u: "1fac2",
    a: "13.0"
  },
  {
    n: [
      "footprints"
    ],
    u: "1f463",
    a: "0.6"
  }
], Yke = [
  {
    n: [
      "monkey face"
    ],
    u: "1f435",
    a: "0.6"
  },
  {
    n: [
      "monkey"
    ],
    u: "1f412",
    a: "0.6"
  },
  {
    n: [
      "gorilla"
    ],
    u: "1f98d",
    a: "3.0"
  },
  {
    n: [
      "orangutan"
    ],
    u: "1f9a7",
    a: "12.0"
  },
  {
    n: [
      "dog",
      "dog face"
    ],
    u: "1f436",
    a: "0.6"
  },
  {
    n: [
      "dog",
      "dog2"
    ],
    u: "1f415",
    a: "0.7"
  },
  {
    n: [
      "guide dog"
    ],
    u: "1f9ae",
    a: "12.0"
  },
  {
    n: [
      "service dog"
    ],
    u: "1f415-200d-1f9ba",
    a: "12.0"
  },
  {
    n: [
      "poodle"
    ],
    u: "1f429",
    a: "0.6"
  },
  {
    n: [
      "wolf",
      "wolf face"
    ],
    u: "1f43a",
    a: "0.6"
  },
  {
    n: [
      "fox face"
    ],
    u: "1f98a",
    a: "3.0"
  },
  {
    n: [
      "raccoon"
    ],
    u: "1f99d",
    a: "11.0"
  },
  {
    n: [
      "cat",
      "cat face"
    ],
    u: "1f431",
    a: "0.6"
  },
  {
    n: [
      "cat",
      "cat2"
    ],
    u: "1f408",
    a: "0.7"
  },
  {
    n: [
      "black cat"
    ],
    u: "1f408-200d-2b1b",
    a: "13.0"
  },
  {
    n: [
      "lion face"
    ],
    u: "1f981",
    a: "1.0"
  },
  {
    n: [
      "tiger",
      "tiger face"
    ],
    u: "1f42f",
    a: "0.6"
  },
  {
    n: [
      "tiger",
      "tiger2"
    ],
    u: "1f405",
    a: "1.0"
  },
  {
    n: [
      "leopard"
    ],
    u: "1f406",
    a: "1.0"
  },
  {
    n: [
      "horse",
      "horse face"
    ],
    u: "1f434",
    a: "0.6"
  },
  {
    n: [
      "horse",
      "racehorse"
    ],
    u: "1f40e",
    a: "0.6"
  },
  {
    n: [
      "unicorn face"
    ],
    u: "1f984",
    a: "1.0"
  },
  {
    n: [
      "zebra face"
    ],
    u: "1f993",
    a: "5.0"
  },
  {
    n: [
      "deer"
    ],
    u: "1f98c",
    a: "3.0"
  },
  {
    n: [
      "bison"
    ],
    u: "1f9ac",
    a: "13.0"
  },
  {
    n: [
      "cow",
      "cow face"
    ],
    u: "1f42e",
    a: "0.6"
  },
  {
    n: [
      "ox"
    ],
    u: "1f402",
    a: "1.0"
  },
  {
    n: [
      "water buffalo"
    ],
    u: "1f403",
    a: "1.0"
  },
  {
    n: [
      "cow",
      "cow2"
    ],
    u: "1f404",
    a: "1.0"
  },
  {
    n: [
      "pig",
      "pig face"
    ],
    u: "1f437",
    a: "0.6"
  },
  {
    n: [
      "pig",
      "pig2"
    ],
    u: "1f416",
    a: "1.0"
  },
  {
    n: [
      "boar"
    ],
    u: "1f417",
    a: "0.6"
  },
  {
    n: [
      "pig nose"
    ],
    u: "1f43d",
    a: "0.6"
  },
  {
    n: [
      "ram"
    ],
    u: "1f40f",
    a: "1.0"
  },
  {
    n: [
      "sheep"
    ],
    u: "1f411",
    a: "0.6"
  },
  {
    n: [
      "goat"
    ],
    u: "1f410",
    a: "1.0"
  },
  {
    n: [
      "dromedary camel"
    ],
    u: "1f42a",
    a: "1.0"
  },
  {
    n: [
      "camel",
      "bactrian camel"
    ],
    u: "1f42b",
    a: "0.6"
  },
  {
    n: [
      "llama"
    ],
    u: "1f999",
    a: "11.0"
  },
  {
    n: [
      "giraffe face"
    ],
    u: "1f992",
    a: "5.0"
  },
  {
    n: [
      "elephant"
    ],
    u: "1f418",
    a: "0.6"
  },
  {
    n: [
      "mammoth"
    ],
    u: "1f9a3",
    a: "13.0"
  },
  {
    n: [
      "rhinoceros"
    ],
    u: "1f98f",
    a: "3.0"
  },
  {
    n: [
      "hippopotamus"
    ],
    u: "1f99b",
    a: "11.0"
  },
  {
    n: [
      "mouse",
      "mouse face"
    ],
    u: "1f42d",
    a: "0.6"
  },
  {
    n: [
      "mouse",
      "mouse2"
    ],
    u: "1f401",
    a: "1.0"
  },
  {
    n: [
      "rat"
    ],
    u: "1f400",
    a: "1.0"
  },
  {
    n: [
      "hamster",
      "hamster face"
    ],
    u: "1f439",
    a: "0.6"
  },
  {
    n: [
      "rabbit",
      "rabbit face"
    ],
    u: "1f430",
    a: "0.6"
  },
  {
    n: [
      "rabbit",
      "rabbit2"
    ],
    u: "1f407",
    a: "1.0"
  },
  {
    n: [
      "chipmunk"
    ],
    u: "1f43f-fe0f",
    a: "0.7"
  },
  {
    n: [
      "beaver"
    ],
    u: "1f9ab",
    a: "13.0"
  },
  {
    n: [
      "hedgehog"
    ],
    u: "1f994",
    a: "5.0"
  },
  {
    n: [
      "bat"
    ],
    u: "1f987",
    a: "3.0"
  },
  {
    n: [
      "bear",
      "bear face"
    ],
    u: "1f43b",
    a: "0.6"
  },
  {
    n: [
      "polar bear"
    ],
    u: "1f43b-200d-2744-fe0f",
    a: "13.0"
  },
  {
    n: [
      "koala"
    ],
    u: "1f428",
    a: "0.6"
  },
  {
    n: [
      "panda face"
    ],
    u: "1f43c",
    a: "0.6"
  },
  {
    n: [
      "sloth"
    ],
    u: "1f9a5",
    a: "12.0"
  },
  {
    n: [
      "otter"
    ],
    u: "1f9a6",
    a: "12.0"
  },
  {
    n: [
      "skunk"
    ],
    u: "1f9a8",
    a: "12.0"
  },
  {
    n: [
      "kangaroo"
    ],
    u: "1f998",
    a: "11.0"
  },
  {
    n: [
      "badger"
    ],
    u: "1f9a1",
    a: "11.0"
  },
  {
    n: [
      "feet",
      "paw prints"
    ],
    u: "1f43e",
    a: "0.6"
  },
  {
    n: [
      "turkey"
    ],
    u: "1f983",
    a: "1.0"
  },
  {
    n: [
      "chicken"
    ],
    u: "1f414",
    a: "0.6"
  },
  {
    n: [
      "rooster"
    ],
    u: "1f413",
    a: "1.0"
  },
  {
    n: [
      "hatching chick"
    ],
    u: "1f423",
    a: "0.6"
  },
  {
    n: [
      "baby chick"
    ],
    u: "1f424",
    a: "0.6"
  },
  {
    n: [
      "hatched chick",
      "front-facing baby chick"
    ],
    u: "1f425",
    a: "0.6"
  },
  {
    n: [
      "bird"
    ],
    u: "1f426",
    a: "0.6"
  },
  {
    n: [
      "penguin"
    ],
    u: "1f427",
    a: "0.6"
  },
  {
    n: [
      "dove",
      "dove of peace"
    ],
    u: "1f54a-fe0f",
    a: "0.7"
  },
  {
    n: [
      "eagle"
    ],
    u: "1f985",
    a: "3.0"
  },
  {
    n: [
      "duck"
    ],
    u: "1f986",
    a: "3.0"
  },
  {
    n: [
      "swan"
    ],
    u: "1f9a2",
    a: "11.0"
  },
  {
    n: [
      "owl"
    ],
    u: "1f989",
    a: "3.0"
  },
  {
    n: [
      "dodo"
    ],
    u: "1f9a4",
    a: "13.0"
  },
  {
    n: [
      "feather"
    ],
    u: "1fab6",
    a: "13.0"
  },
  {
    n: [
      "flamingo"
    ],
    u: "1f9a9",
    a: "12.0"
  },
  {
    n: [
      "peacock"
    ],
    u: "1f99a",
    a: "11.0"
  },
  {
    n: [
      "parrot"
    ],
    u: "1f99c",
    a: "11.0"
  },
  {
    n: [
      "frog",
      "frog face"
    ],
    u: "1f438",
    a: "0.6"
  },
  {
    n: [
      "crocodile"
    ],
    u: "1f40a",
    a: "1.0"
  },
  {
    n: [
      "turtle"
    ],
    u: "1f422",
    a: "0.6"
  },
  {
    n: [
      "lizard"
    ],
    u: "1f98e",
    a: "3.0"
  },
  {
    n: [
      "snake"
    ],
    u: "1f40d",
    a: "0.6"
  },
  {
    n: [
      "dragon face"
    ],
    u: "1f432",
    a: "0.6"
  },
  {
    n: [
      "dragon"
    ],
    u: "1f409",
    a: "1.0"
  },
  {
    n: [
      "sauropod"
    ],
    u: "1f995",
    a: "5.0"
  },
  {
    n: [
      "t-rex"
    ],
    u: "1f996",
    a: "5.0"
  },
  {
    n: [
      "whale",
      "spouting whale"
    ],
    u: "1f433",
    a: "0.6"
  },
  {
    n: [
      "whale",
      "whale2"
    ],
    u: "1f40b",
    a: "1.0"
  },
  {
    n: [
      "dolphin",
      "flipper"
    ],
    u: "1f42c",
    a: "0.6"
  },
  {
    n: [
      "seal"
    ],
    u: "1f9ad",
    a: "13.0"
  },
  {
    n: [
      "fish"
    ],
    u: "1f41f",
    a: "0.6"
  },
  {
    n: [
      "tropical fish"
    ],
    u: "1f420",
    a: "0.6"
  },
  {
    n: [
      "blowfish"
    ],
    u: "1f421",
    a: "0.6"
  },
  {
    n: [
      "shark"
    ],
    u: "1f988",
    a: "3.0"
  },
  {
    n: [
      "octopus"
    ],
    u: "1f419",
    a: "0.6"
  },
  {
    n: [
      "shell",
      "spiral shell"
    ],
    u: "1f41a",
    a: "0.6"
  },
  {
    n: [
      "coral"
    ],
    u: "1fab8",
    a: "14.0"
  },
  {
    n: [
      "snail"
    ],
    u: "1f40c",
    a: "0.6"
  },
  {
    n: [
      "butterfly"
    ],
    u: "1f98b",
    a: "3.0"
  },
  {
    n: [
      "bug"
    ],
    u: "1f41b",
    a: "0.6"
  },
  {
    n: [
      "ant"
    ],
    u: "1f41c",
    a: "0.6"
  },
  {
    n: [
      "bee",
      "honeybee"
    ],
    u: "1f41d",
    a: "0.6"
  },
  {
    n: [
      "beetle"
    ],
    u: "1fab2",
    a: "13.0"
  },
  {
    n: [
      "ladybug",
      "lady beetle"
    ],
    u: "1f41e",
    a: "0.6"
  },
  {
    n: [
      "cricket"
    ],
    u: "1f997",
    a: "5.0"
  },
  {
    n: [
      "cockroach"
    ],
    u: "1fab3",
    a: "13.0"
  },
  {
    n: [
      "spider"
    ],
    u: "1f577-fe0f",
    a: "0.7"
  },
  {
    n: [
      "spider web"
    ],
    u: "1f578-fe0f",
    a: "0.7"
  },
  {
    n: [
      "scorpion"
    ],
    u: "1f982",
    a: "1.0"
  },
  {
    n: [
      "mosquito"
    ],
    u: "1f99f",
    a: "11.0"
  },
  {
    n: [
      "fly"
    ],
    u: "1fab0",
    a: "13.0"
  },
  {
    n: [
      "worm"
    ],
    u: "1fab1",
    a: "13.0"
  },
  {
    n: [
      "microbe"
    ],
    u: "1f9a0",
    a: "11.0"
  },
  {
    n: [
      "bouquet"
    ],
    u: "1f490",
    a: "0.6"
  },
  {
    n: [
      "cherry blossom"
    ],
    u: "1f338",
    a: "0.6"
  },
  {
    n: [
      "white flower"
    ],
    u: "1f4ae",
    a: "0.6"
  },
  {
    n: [
      "lotus"
    ],
    u: "1fab7",
    a: "14.0"
  },
  {
    n: [
      "rosette"
    ],
    u: "1f3f5-fe0f",
    a: "0.7"
  },
  {
    n: [
      "rose"
    ],
    u: "1f339",
    a: "0.6"
  },
  {
    n: [
      "wilted flower"
    ],
    u: "1f940",
    a: "3.0"
  },
  {
    n: [
      "hibiscus"
    ],
    u: "1f33a",
    a: "0.6"
  },
  {
    n: [
      "sunflower"
    ],
    u: "1f33b",
    a: "0.6"
  },
  {
    n: [
      "blossom"
    ],
    u: "1f33c",
    a: "0.6"
  },
  {
    n: [
      "tulip"
    ],
    u: "1f337",
    a: "0.6"
  },
  {
    n: [
      "seedling"
    ],
    u: "1f331",
    a: "0.6"
  },
  {
    n: [
      "potted plant"
    ],
    u: "1fab4",
    a: "13.0"
  },
  {
    n: [
      "evergreen tree"
    ],
    u: "1f332",
    a: "1.0"
  },
  {
    n: [
      "deciduous tree"
    ],
    u: "1f333",
    a: "1.0"
  },
  {
    n: [
      "palm tree"
    ],
    u: "1f334",
    a: "0.6"
  },
  {
    n: [
      "cactus"
    ],
    u: "1f335",
    a: "0.6"
  },
  {
    n: [
      "ear of rice"
    ],
    u: "1f33e",
    a: "0.6"
  },
  {
    n: [
      "herb"
    ],
    u: "1f33f",
    a: "0.6"
  },
  {
    n: [
      "shamrock"
    ],
    u: "2618-fe0f",
    a: "1.0"
  },
  {
    n: [
      "four leaf clover"
    ],
    u: "1f340",
    a: "0.6"
  },
  {
    n: [
      "maple leaf"
    ],
    u: "1f341",
    a: "0.6"
  },
  {
    n: [
      "fallen leaf"
    ],
    u: "1f342",
    a: "0.6"
  },
  {
    n: [
      "leaves",
      "leaf fluttering in wind"
    ],
    u: "1f343",
    a: "0.6"
  },
  {
    n: [
      "empty nest"
    ],
    u: "1fab9",
    a: "14.0"
  },
  {
    n: [
      "nest with eggs"
    ],
    u: "1faba",
    a: "14.0"
  }
], Qke = [
  {
    n: [
      "grapes"
    ],
    u: "1f347",
    a: "0.6"
  },
  {
    n: [
      "melon"
    ],
    u: "1f348",
    a: "0.6"
  },
  {
    n: [
      "watermelon"
    ],
    u: "1f349",
    a: "0.6"
  },
  {
    n: [
      "tangerine"
    ],
    u: "1f34a",
    a: "0.6"
  },
  {
    n: [
      "lemon"
    ],
    u: "1f34b",
    a: "1.0"
  },
  {
    n: [
      "banana"
    ],
    u: "1f34c",
    a: "0.6"
  },
  {
    n: [
      "pineapple"
    ],
    u: "1f34d",
    a: "0.6"
  },
  {
    n: [
      "mango"
    ],
    u: "1f96d",
    a: "11.0"
  },
  {
    n: [
      "apple",
      "red apple"
    ],
    u: "1f34e",
    a: "0.6"
  },
  {
    n: [
      "green apple"
    ],
    u: "1f34f",
    a: "0.6"
  },
  {
    n: [
      "pear"
    ],
    u: "1f350",
    a: "1.0"
  },
  {
    n: [
      "peach"
    ],
    u: "1f351",
    a: "0.6"
  },
  {
    n: [
      "cherries"
    ],
    u: "1f352",
    a: "0.6"
  },
  {
    n: [
      "strawberry"
    ],
    u: "1f353",
    a: "0.6"
  },
  {
    n: [
      "blueberries"
    ],
    u: "1fad0",
    a: "13.0"
  },
  {
    n: [
      "kiwifruit"
    ],
    u: "1f95d",
    a: "3.0"
  },
  {
    n: [
      "tomato"
    ],
    u: "1f345",
    a: "0.6"
  },
  {
    n: [
      "olive"
    ],
    u: "1fad2",
    a: "13.0"
  },
  {
    n: [
      "coconut"
    ],
    u: "1f965",
    a: "5.0"
  },
  {
    n: [
      "avocado"
    ],
    u: "1f951",
    a: "3.0"
  },
  {
    n: [
      "eggplant",
      "aubergine"
    ],
    u: "1f346",
    a: "0.6"
  },
  {
    n: [
      "potato"
    ],
    u: "1f954",
    a: "3.0"
  },
  {
    n: [
      "carrot"
    ],
    u: "1f955",
    a: "3.0"
  },
  {
    n: [
      "corn",
      "ear of maize"
    ],
    u: "1f33d",
    a: "0.6"
  },
  {
    n: [
      "hot pepper"
    ],
    u: "1f336-fe0f",
    a: "0.7"
  },
  {
    n: [
      "bell pepper"
    ],
    u: "1fad1",
    a: "13.0"
  },
  {
    n: [
      "cucumber"
    ],
    u: "1f952",
    a: "3.0"
  },
  {
    n: [
      "leafy green"
    ],
    u: "1f96c",
    a: "11.0"
  },
  {
    n: [
      "broccoli"
    ],
    u: "1f966",
    a: "5.0"
  },
  {
    n: [
      "garlic"
    ],
    u: "1f9c4",
    a: "12.0"
  },
  {
    n: [
      "onion"
    ],
    u: "1f9c5",
    a: "12.0"
  },
  {
    n: [
      "mushroom"
    ],
    u: "1f344",
    a: "0.6"
  },
  {
    n: [
      "peanuts"
    ],
    u: "1f95c",
    a: "3.0"
  },
  {
    n: [
      "beans"
    ],
    u: "1fad8",
    a: "14.0"
  },
  {
    n: [
      "chestnut"
    ],
    u: "1f330",
    a: "0.6"
  },
  {
    n: [
      "bread"
    ],
    u: "1f35e",
    a: "0.6"
  },
  {
    n: [
      "croissant"
    ],
    u: "1f950",
    a: "3.0"
  },
  {
    n: [
      "baguette bread"
    ],
    u: "1f956",
    a: "3.0"
  },
  {
    n: [
      "flatbread"
    ],
    u: "1fad3",
    a: "13.0"
  },
  {
    n: [
      "pretzel"
    ],
    u: "1f968",
    a: "5.0"
  },
  {
    n: [
      "bagel"
    ],
    u: "1f96f",
    a: "11.0"
  },
  {
    n: [
      "pancakes"
    ],
    u: "1f95e",
    a: "3.0"
  },
  {
    n: [
      "waffle"
    ],
    u: "1f9c7",
    a: "12.0"
  },
  {
    n: [
      "cheese wedge"
    ],
    u: "1f9c0",
    a: "1.0"
  },
  {
    n: [
      "meat on bone"
    ],
    u: "1f356",
    a: "0.6"
  },
  {
    n: [
      "poultry leg"
    ],
    u: "1f357",
    a: "0.6"
  },
  {
    n: [
      "cut of meat"
    ],
    u: "1f969",
    a: "5.0"
  },
  {
    n: [
      "bacon"
    ],
    u: "1f953",
    a: "3.0"
  },
  {
    n: [
      "hamburger"
    ],
    u: "1f354",
    a: "0.6"
  },
  {
    n: [
      "fries",
      "french fries"
    ],
    u: "1f35f",
    a: "0.6"
  },
  {
    n: [
      "pizza",
      "slice of pizza"
    ],
    u: "1f355",
    a: "0.6"
  },
  {
    n: [
      "hotdog",
      "hot dog"
    ],
    u: "1f32d",
    a: "1.0"
  },
  {
    n: [
      "sandwich"
    ],
    u: "1f96a",
    a: "5.0"
  },
  {
    n: [
      "taco"
    ],
    u: "1f32e",
    a: "1.0"
  },
  {
    n: [
      "burrito"
    ],
    u: "1f32f",
    a: "1.0"
  },
  {
    n: [
      "tamale"
    ],
    u: "1fad4",
    a: "13.0"
  },
  {
    n: [
      "stuffed flatbread"
    ],
    u: "1f959",
    a: "3.0"
  },
  {
    n: [
      "falafel"
    ],
    u: "1f9c6",
    a: "12.0"
  },
  {
    n: [
      "egg"
    ],
    u: "1f95a",
    a: "3.0"
  },
  {
    n: [
      "cooking",
      "fried egg"
    ],
    u: "1f373",
    a: "0.6"
  },
  {
    n: [
      "shallow pan of food"
    ],
    u: "1f958",
    a: "3.0"
  },
  {
    n: [
      "stew",
      "pot of food"
    ],
    u: "1f372",
    a: "0.6"
  },
  {
    n: [
      "fondue"
    ],
    u: "1fad5",
    a: "13.0"
  },
  {
    n: [
      "bowl with spoon"
    ],
    u: "1f963",
    a: "5.0"
  },
  {
    n: [
      "green salad"
    ],
    u: "1f957",
    a: "3.0"
  },
  {
    n: [
      "popcorn"
    ],
    u: "1f37f",
    a: "1.0"
  },
  {
    n: [
      "butter"
    ],
    u: "1f9c8",
    a: "12.0"
  },
  {
    n: [
      "salt",
      "salt shaker"
    ],
    u: "1f9c2",
    a: "11.0"
  },
  {
    n: [
      "canned food"
    ],
    u: "1f96b",
    a: "5.0"
  },
  {
    n: [
      "bento",
      "bento box"
    ],
    u: "1f371",
    a: "0.6"
  },
  {
    n: [
      "rice cracker"
    ],
    u: "1f358",
    a: "0.6"
  },
  {
    n: [
      "rice ball"
    ],
    u: "1f359",
    a: "0.6"
  },
  {
    n: [
      "rice",
      "cooked rice"
    ],
    u: "1f35a",
    a: "0.6"
  },
  {
    n: [
      "curry",
      "curry and rice"
    ],
    u: "1f35b",
    a: "0.6"
  },
  {
    n: [
      "ramen",
      "steaming bowl"
    ],
    u: "1f35c",
    a: "0.6"
  },
  {
    n: [
      "spaghetti"
    ],
    u: "1f35d",
    a: "0.6"
  },
  {
    n: [
      "sweet potato",
      "roasted sweet potato"
    ],
    u: "1f360",
    a: "0.6"
  },
  {
    n: [
      "oden"
    ],
    u: "1f362",
    a: "0.6"
  },
  {
    n: [
      "sushi"
    ],
    u: "1f363",
    a: "0.6"
  },
  {
    n: [
      "fried shrimp"
    ],
    u: "1f364",
    a: "0.6"
  },
  {
    n: [
      "fish cake",
      "fish cake with swirl design"
    ],
    u: "1f365",
    a: "0.6"
  },
  {
    n: [
      "moon cake"
    ],
    u: "1f96e",
    a: "11.0"
  },
  {
    n: [
      "dango"
    ],
    u: "1f361",
    a: "0.6"
  },
  {
    n: [
      "dumpling"
    ],
    u: "1f95f",
    a: "5.0"
  },
  {
    n: [
      "fortune cookie"
    ],
    u: "1f960",
    a: "5.0"
  },
  {
    n: [
      "takeout box"
    ],
    u: "1f961",
    a: "5.0"
  },
  {
    n: [
      "crab"
    ],
    u: "1f980",
    a: "1.0"
  },
  {
    n: [
      "lobster"
    ],
    u: "1f99e",
    a: "11.0"
  },
  {
    n: [
      "shrimp"
    ],
    u: "1f990",
    a: "3.0"
  },
  {
    n: [
      "squid"
    ],
    u: "1f991",
    a: "3.0"
  },
  {
    n: [
      "oyster"
    ],
    u: "1f9aa",
    a: "12.0"
  },
  {
    n: [
      "icecream",
      "soft ice cream"
    ],
    u: "1f366",
    a: "0.6"
  },
  {
    n: [
      "shaved ice"
    ],
    u: "1f367",
    a: "0.6"
  },
  {
    n: [
      "ice cream"
    ],
    u: "1f368",
    a: "0.6"
  },
  {
    n: [
      "doughnut"
    ],
    u: "1f369",
    a: "0.6"
  },
  {
    n: [
      "cookie"
    ],
    u: "1f36a",
    a: "0.6"
  },
  {
    n: [
      "birthday",
      "birthday cake"
    ],
    u: "1f382",
    a: "0.6"
  },
  {
    n: [
      "cake",
      "shortcake"
    ],
    u: "1f370",
    a: "0.6"
  },
  {
    n: [
      "cupcake"
    ],
    u: "1f9c1",
    a: "11.0"
  },
  {
    n: [
      "pie"
    ],
    u: "1f967",
    a: "5.0"
  },
  {
    n: [
      "chocolate bar"
    ],
    u: "1f36b",
    a: "0.6"
  },
  {
    n: [
      "candy"
    ],
    u: "1f36c",
    a: "0.6"
  },
  {
    n: [
      "lollipop"
    ],
    u: "1f36d",
    a: "0.6"
  },
  {
    n: [
      "custard"
    ],
    u: "1f36e",
    a: "0.6"
  },
  {
    n: [
      "honey pot"
    ],
    u: "1f36f",
    a: "0.6"
  },
  {
    n: [
      "baby bottle"
    ],
    u: "1f37c",
    a: "1.0"
  },
  {
    n: [
      "glass of milk"
    ],
    u: "1f95b",
    a: "3.0"
  },
  {
    n: [
      "coffee",
      "hot beverage"
    ],
    u: "2615",
    a: "0.6"
  },
  {
    n: [
      "teapot"
    ],
    u: "1fad6",
    a: "13.0"
  },
  {
    n: [
      "tea",
      "teacup without handle"
    ],
    u: "1f375",
    a: "0.6"
  },
  {
    n: [
      "sake",
      "sake bottle and cup"
    ],
    u: "1f376",
    a: "0.6"
  },
  {
    n: [
      "champagne",
      "bottle with popping cork"
    ],
    u: "1f37e",
    a: "1.0"
  },
  {
    n: [
      "wine glass"
    ],
    u: "1f377",
    a: "0.6"
  },
  {
    n: [
      "cocktail",
      "cocktail glass"
    ],
    u: "1f378",
    a: "0.6"
  },
  {
    n: [
      "tropical drink"
    ],
    u: "1f379",
    a: "0.6"
  },
  {
    n: [
      "beer",
      "beer mug"
    ],
    u: "1f37a",
    a: "0.6"
  },
  {
    n: [
      "beers",
      "clinking beer mugs"
    ],
    u: "1f37b",
    a: "0.6"
  },
  {
    n: [
      "clinking glasses"
    ],
    u: "1f942",
    a: "3.0"
  },
  {
    n: [
      "tumbler glass"
    ],
    u: "1f943",
    a: "3.0"
  },
  {
    n: [
      "pouring liquid"
    ],
    u: "1fad7",
    a: "14.0"
  },
  {
    n: [
      "cup with straw"
    ],
    u: "1f964",
    a: "5.0"
  },
  {
    n: [
      "bubble tea"
    ],
    u: "1f9cb",
    a: "13.0"
  },
  {
    n: [
      "beverage box"
    ],
    u: "1f9c3",
    a: "12.0"
  },
  {
    n: [
      "mate drink"
    ],
    u: "1f9c9",
    a: "12.0"
  },
  {
    n: [
      "ice cube"
    ],
    u: "1f9ca",
    a: "12.0"
  },
  {
    n: [
      "chopsticks"
    ],
    u: "1f962",
    a: "5.0"
  },
  {
    n: [
      "knife fork plate",
      "fork and knife with plate"
    ],
    u: "1f37d-fe0f",
    a: "0.7"
  },
  {
    n: [
      "fork and knife"
    ],
    u: "1f374",
    a: "0.6"
  },
  {
    n: [
      "spoon"
    ],
    u: "1f944",
    a: "3.0"
  },
  {
    n: [
      "hocho",
      "knife"
    ],
    u: "1f52a",
    a: "0.6"
  },
  {
    n: [
      "jar"
    ],
    u: "1fad9",
    a: "14.0"
  },
  {
    n: [
      "amphora"
    ],
    u: "1f3fa",
    a: "1.0"
  }
], Jke = [
  {
    n: [
      "earth africa",
      "earth globe europe-africa"
    ],
    u: "1f30d",
    a: "0.7"
  },
  {
    n: [
      "earth americas",
      "earth globe americas"
    ],
    u: "1f30e",
    a: "0.7"
  },
  {
    n: [
      "earth asia",
      "earth globe asia-australia"
    ],
    u: "1f30f",
    a: "0.6"
  },
  {
    n: [
      "globe with meridians"
    ],
    u: "1f310",
    a: "1.0"
  },
  {
    n: [
      "world map"
    ],
    u: "1f5fa-fe0f",
    a: "0.7"
  },
  {
    n: [
      "japan",
      "silhouette of japan"
    ],
    u: "1f5fe",
    a: "0.6"
  },
  {
    n: [
      "compass"
    ],
    u: "1f9ed",
    a: "11.0"
  },
  {
    n: [
      "snow-capped mountain",
      "snow capped mountain"
    ],
    u: "1f3d4-fe0f",
    a: "0.7"
  },
  {
    n: [
      "mountain"
    ],
    u: "26f0-fe0f",
    a: "0.7"
  },
  {
    n: [
      "volcano"
    ],
    u: "1f30b",
    a: "0.6"
  },
  {
    n: [
      "mount fuji"
    ],
    u: "1f5fb",
    a: "0.6"
  },
  {
    n: [
      "camping"
    ],
    u: "1f3d5-fe0f",
    a: "0.7"
  },
  {
    n: [
      "beach with umbrella"
    ],
    u: "1f3d6-fe0f",
    a: "0.7"
  },
  {
    n: [
      "desert"
    ],
    u: "1f3dc-fe0f",
    a: "0.7"
  },
  {
    n: [
      "desert island"
    ],
    u: "1f3dd-fe0f",
    a: "0.7"
  },
  {
    n: [
      "national park"
    ],
    u: "1f3de-fe0f",
    a: "0.7"
  },
  {
    n: [
      "stadium"
    ],
    u: "1f3df-fe0f",
    a: "0.7"
  },
  {
    n: [
      "classical building"
    ],
    u: "1f3db-fe0f",
    a: "0.7"
  },
  {
    n: [
      "building construction"
    ],
    u: "1f3d7-fe0f",
    a: "0.7"
  },
  {
    n: [
      "brick",
      "bricks"
    ],
    u: "1f9f1",
    a: "11.0"
  },
  {
    n: [
      "rock"
    ],
    u: "1faa8",
    a: "13.0"
  },
  {
    n: [
      "wood"
    ],
    u: "1fab5",
    a: "13.0"
  },
  {
    n: [
      "hut"
    ],
    u: "1f6d6",
    a: "13.0"
  },
  {
    n: [
      "houses",
      "house buildings"
    ],
    u: "1f3d8-fe0f",
    a: "0.7"
  },
  {
    n: [
      "derelict house",
      "derelict house building"
    ],
    u: "1f3da-fe0f",
    a: "0.7"
  },
  {
    n: [
      "house",
      "house building"
    ],
    u: "1f3e0",
    a: "0.6"
  },
  {
    n: [
      "house with garden"
    ],
    u: "1f3e1",
    a: "0.6"
  },
  {
    n: [
      "office",
      "office building"
    ],
    u: "1f3e2",
    a: "0.6"
  },
  {
    n: [
      "post office",
      "japanese post office"
    ],
    u: "1f3e3",
    a: "0.6"
  },
  {
    n: [
      "european post office"
    ],
    u: "1f3e4",
    a: "1.0"
  },
  {
    n: [
      "hospital"
    ],
    u: "1f3e5",
    a: "0.6"
  },
  {
    n: [
      "bank"
    ],
    u: "1f3e6",
    a: "0.6"
  },
  {
    n: [
      "hotel"
    ],
    u: "1f3e8",
    a: "0.6"
  },
  {
    n: [
      "love hotel"
    ],
    u: "1f3e9",
    a: "0.6"
  },
  {
    n: [
      "convenience store"
    ],
    u: "1f3ea",
    a: "0.6"
  },
  {
    n: [
      "school"
    ],
    u: "1f3eb",
    a: "0.6"
  },
  {
    n: [
      "department store"
    ],
    u: "1f3ec",
    a: "0.6"
  },
  {
    n: [
      "factory"
    ],
    u: "1f3ed",
    a: "0.6"
  },
  {
    n: [
      "japanese castle"
    ],
    u: "1f3ef",
    a: "0.6"
  },
  {
    n: [
      "european castle"
    ],
    u: "1f3f0",
    a: "0.6"
  },
  {
    n: [
      "wedding"
    ],
    u: "1f492",
    a: "0.6"
  },
  {
    n: [
      "tokyo tower"
    ],
    u: "1f5fc",
    a: "0.6"
  },
  {
    n: [
      "statue of liberty"
    ],
    u: "1f5fd",
    a: "0.6"
  },
  {
    n: [
      "church"
    ],
    u: "26ea",
    a: "0.6"
  },
  {
    n: [
      "mosque"
    ],
    u: "1f54c",
    a: "1.0"
  },
  {
    n: [
      "hindu temple"
    ],
    u: "1f6d5",
    a: "12.0"
  },
  {
    n: [
      "synagogue"
    ],
    u: "1f54d",
    a: "1.0"
  },
  {
    n: [
      "shinto shrine"
    ],
    u: "26e9-fe0f",
    a: "0.7"
  },
  {
    n: [
      "kaaba"
    ],
    u: "1f54b",
    a: "1.0"
  },
  {
    n: [
      "fountain"
    ],
    u: "26f2",
    a: "0.6"
  },
  {
    n: [
      "tent"
    ],
    u: "26fa",
    a: "0.6"
  },
  {
    n: [
      "foggy"
    ],
    u: "1f301",
    a: "0.6"
  },
  {
    n: [
      "night with stars"
    ],
    u: "1f303",
    a: "0.6"
  },
  {
    n: [
      "cityscape"
    ],
    u: "1f3d9-fe0f",
    a: "0.7"
  },
  {
    n: [
      "sunrise over mountains"
    ],
    u: "1f304",
    a: "0.6"
  },
  {
    n: [
      "sunrise"
    ],
    u: "1f305",
    a: "0.6"
  },
  {
    n: [
      "city sunset",
      "cityscape at dusk"
    ],
    u: "1f306",
    a: "0.6"
  },
  {
    n: [
      "city sunrise",
      "sunset over buildings"
    ],
    u: "1f307",
    a: "0.6"
  },
  {
    n: [
      "bridge at night"
    ],
    u: "1f309",
    a: "0.6"
  },
  {
    n: [
      "hotsprings",
      "hot springs"
    ],
    u: "2668-fe0f",
    a: "0.6"
  },
  {
    n: [
      "carousel horse"
    ],
    u: "1f3a0",
    a: "0.6"
  },
  {
    n: [
      "playground slide"
    ],
    u: "1f6dd",
    a: "14.0"
  },
  {
    n: [
      "ferris wheel"
    ],
    u: "1f3a1",
    a: "0.6"
  },
  {
    n: [
      "roller coaster"
    ],
    u: "1f3a2",
    a: "0.6"
  },
  {
    n: [
      "barber",
      "barber pole"
    ],
    u: "1f488",
    a: "0.6"
  },
  {
    n: [
      "circus tent"
    ],
    u: "1f3aa",
    a: "0.6"
  },
  {
    n: [
      "steam locomotive"
    ],
    u: "1f682",
    a: "1.0"
  },
  {
    n: [
      "railway car"
    ],
    u: "1f683",
    a: "0.6"
  },
  {
    n: [
      "high-speed train",
      "bullettrain side"
    ],
    u: "1f684",
    a: "0.6"
  },
  {
    n: [
      "bullettrain front",
      "high-speed train with bullet nose"
    ],
    u: "1f685",
    a: "0.6"
  },
  {
    n: [
      "train",
      "train2"
    ],
    u: "1f686",
    a: "1.0"
  },
  {
    n: [
      "metro"
    ],
    u: "1f687",
    a: "0.6"
  },
  {
    n: [
      "light rail"
    ],
    u: "1f688",
    a: "1.0"
  },
  {
    n: [
      "station"
    ],
    u: "1f689",
    a: "0.6"
  },
  {
    n: [
      "tram"
    ],
    u: "1f68a",
    a: "1.0"
  },
  {
    n: [
      "monorail"
    ],
    u: "1f69d",
    a: "1.0"
  },
  {
    n: [
      "mountain railway"
    ],
    u: "1f69e",
    a: "1.0"
  },
  {
    n: [
      "train",
      "tram car"
    ],
    u: "1f68b",
    a: "1.0"
  },
  {
    n: [
      "bus"
    ],
    u: "1f68c",
    a: "0.6"
  },
  {
    n: [
      "oncoming bus"
    ],
    u: "1f68d",
    a: "0.7"
  },
  {
    n: [
      "trolleybus"
    ],
    u: "1f68e",
    a: "1.0"
  },
  {
    n: [
      "minibus"
    ],
    u: "1f690",
    a: "1.0"
  },
  {
    n: [
      "ambulance"
    ],
    u: "1f691",
    a: "0.6"
  },
  {
    n: [
      "fire engine"
    ],
    u: "1f692",
    a: "0.6"
  },
  {
    n: [
      "police car"
    ],
    u: "1f693",
    a: "0.6"
  },
  {
    n: [
      "oncoming police car"
    ],
    u: "1f694",
    a: "0.7"
  },
  {
    n: [
      "taxi"
    ],
    u: "1f695",
    a: "0.6"
  },
  {
    n: [
      "oncoming taxi"
    ],
    u: "1f696",
    a: "1.0"
  },
  {
    n: [
      "car",
      "red car",
      "automobile"
    ],
    u: "1f697",
    a: "0.6"
  },
  {
    n: [
      "oncoming automobile"
    ],
    u: "1f698",
    a: "0.7"
  },
  {
    n: [
      "blue car",
      "recreational vehicle"
    ],
    u: "1f699",
    a: "0.6"
  },
  {
    n: [
      "pickup truck"
    ],
    u: "1f6fb",
    a: "13.0"
  },
  {
    n: [
      "truck",
      "delivery truck"
    ],
    u: "1f69a",
    a: "0.6"
  },
  {
    n: [
      "articulated lorry"
    ],
    u: "1f69b",
    a: "1.0"
  },
  {
    n: [
      "tractor"
    ],
    u: "1f69c",
    a: "1.0"
  },
  {
    n: [
      "racing car"
    ],
    u: "1f3ce-fe0f",
    a: "0.7"
  },
  {
    n: [
      "motorcycle",
      "racing motorcycle"
    ],
    u: "1f3cd-fe0f",
    a: "0.7"
  },
  {
    n: [
      "motor scooter"
    ],
    u: "1f6f5",
    a: "3.0"
  },
  {
    n: [
      "manual wheelchair"
    ],
    u: "1f9bd",
    a: "12.0"
  },
  {
    n: [
      "motorized wheelchair"
    ],
    u: "1f9bc",
    a: "12.0"
  },
  {
    n: [
      "auto rickshaw"
    ],
    u: "1f6fa",
    a: "12.0"
  },
  {
    n: [
      "bike",
      "bicycle"
    ],
    u: "1f6b2",
    a: "0.6"
  },
  {
    n: [
      "scooter"
    ],
    u: "1f6f4",
    a: "3.0"
  },
  {
    n: [
      "skateboard"
    ],
    u: "1f6f9",
    a: "11.0"
  },
  {
    n: [
      "roller skate"
    ],
    u: "1f6fc",
    a: "13.0"
  },
  {
    n: [
      "busstop",
      "bus stop"
    ],
    u: "1f68f",
    a: "0.6"
  },
  {
    n: [
      "motorway"
    ],
    u: "1f6e3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "railway track"
    ],
    u: "1f6e4-fe0f",
    a: "0.7"
  },
  {
    n: [
      "oil drum"
    ],
    u: "1f6e2-fe0f",
    a: "0.7"
  },
  {
    n: [
      "fuelpump",
      "fuel pump"
    ],
    u: "26fd",
    a: "0.6"
  },
  {
    n: [
      "wheel"
    ],
    u: "1f6de",
    a: "14.0"
  },
  {
    n: [
      "rotating light",
      "police cars revolving light"
    ],
    u: "1f6a8",
    a: "0.6"
  },
  {
    n: [
      "traffic light",
      "horizontal traffic light"
    ],
    u: "1f6a5",
    a: "0.6"
  },
  {
    n: [
      "vertical traffic light"
    ],
    u: "1f6a6",
    a: "1.0"
  },
  {
    n: [
      "octagonal sign"
    ],
    u: "1f6d1",
    a: "3.0"
  },
  {
    n: [
      "construction",
      "construction sign"
    ],
    u: "1f6a7",
    a: "0.6"
  },
  {
    n: [
      "anchor"
    ],
    u: "2693",
    a: "0.6"
  },
  {
    n: [
      "ring buoy"
    ],
    u: "1f6df",
    a: "14.0"
  },
  {
    n: [
      "boat",
      "sailboat"
    ],
    u: "26f5",
    a: "0.6"
  },
  {
    n: [
      "canoe"
    ],
    u: "1f6f6",
    a: "3.0"
  },
  {
    n: [
      "speedboat"
    ],
    u: "1f6a4",
    a: "0.6"
  },
  {
    n: [
      "passenger ship"
    ],
    u: "1f6f3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "ferry"
    ],
    u: "26f4-fe0f",
    a: "0.7"
  },
  {
    n: [
      "motor boat"
    ],
    u: "1f6e5-fe0f",
    a: "0.7"
  },
  {
    n: [
      "ship"
    ],
    u: "1f6a2",
    a: "0.6"
  },
  {
    n: [
      "airplane"
    ],
    u: "2708-fe0f",
    a: "0.6"
  },
  {
    n: [
      "small airplane"
    ],
    u: "1f6e9-fe0f",
    a: "0.7"
  },
  {
    n: [
      "airplane departure"
    ],
    u: "1f6eb",
    a: "1.0"
  },
  {
    n: [
      "airplane arriving"
    ],
    u: "1f6ec",
    a: "1.0"
  },
  {
    n: [
      "parachute"
    ],
    u: "1fa82",
    a: "12.0"
  },
  {
    n: [
      "seat"
    ],
    u: "1f4ba",
    a: "0.6"
  },
  {
    n: [
      "helicopter"
    ],
    u: "1f681",
    a: "1.0"
  },
  {
    n: [
      "suspension railway"
    ],
    u: "1f69f",
    a: "1.0"
  },
  {
    n: [
      "mountain cableway"
    ],
    u: "1f6a0",
    a: "1.0"
  },
  {
    n: [
      "aerial tramway"
    ],
    u: "1f6a1",
    a: "1.0"
  },
  {
    n: [
      "satellite"
    ],
    u: "1f6f0-fe0f",
    a: "0.7"
  },
  {
    n: [
      "rocket"
    ],
    u: "1f680",
    a: "0.6"
  },
  {
    n: [
      "flying saucer"
    ],
    u: "1f6f8",
    a: "5.0"
  },
  {
    n: [
      "bellhop bell"
    ],
    u: "1f6ce-fe0f",
    a: "0.7"
  },
  {
    n: [
      "luggage"
    ],
    u: "1f9f3",
    a: "11.0"
  },
  {
    n: [
      "hourglass"
    ],
    u: "231b",
    a: "0.6"
  },
  {
    n: [
      "hourglass flowing sand",
      "hourglass with flowing sand"
    ],
    u: "23f3",
    a: "0.6"
  },
  {
    n: [
      "watch"
    ],
    u: "231a",
    a: "0.6"
  },
  {
    n: [
      "alarm clock"
    ],
    u: "23f0",
    a: "0.6"
  },
  {
    n: [
      "stopwatch"
    ],
    u: "23f1-fe0f",
    a: "1.0"
  },
  {
    n: [
      "timer clock"
    ],
    u: "23f2-fe0f",
    a: "1.0"
  },
  {
    n: [
      "mantelpiece clock"
    ],
    u: "1f570-fe0f",
    a: "0.7"
  },
  {
    n: [
      "clock12",
      "clock face twelve oclock"
    ],
    u: "1f55b",
    a: "0.6"
  },
  {
    n: [
      "clock1230",
      "clock face twelve-thirty"
    ],
    u: "1f567",
    a: "0.7"
  },
  {
    n: [
      "clock1",
      "clock face one oclock"
    ],
    u: "1f550",
    a: "0.6"
  },
  {
    n: [
      "clock130",
      "clock face one-thirty"
    ],
    u: "1f55c",
    a: "0.7"
  },
  {
    n: [
      "clock2",
      "clock face two oclock"
    ],
    u: "1f551",
    a: "0.6"
  },
  {
    n: [
      "clock230",
      "clock face two-thirty"
    ],
    u: "1f55d",
    a: "0.7"
  },
  {
    n: [
      "clock3",
      "clock face three oclock"
    ],
    u: "1f552",
    a: "0.6"
  },
  {
    n: [
      "clock330",
      "clock face three-thirty"
    ],
    u: "1f55e",
    a: "0.7"
  },
  {
    n: [
      "clock4",
      "clock face four oclock"
    ],
    u: "1f553",
    a: "0.6"
  },
  {
    n: [
      "clock430",
      "clock face four-thirty"
    ],
    u: "1f55f",
    a: "0.7"
  },
  {
    n: [
      "clock5",
      "clock face five oclock"
    ],
    u: "1f554",
    a: "0.6"
  },
  {
    n: [
      "clock530",
      "clock face five-thirty"
    ],
    u: "1f560",
    a: "0.7"
  },
  {
    n: [
      "clock6",
      "clock face six oclock"
    ],
    u: "1f555",
    a: "0.6"
  },
  {
    n: [
      "clock630",
      "clock face six-thirty"
    ],
    u: "1f561",
    a: "0.7"
  },
  {
    n: [
      "clock7",
      "clock face seven oclock"
    ],
    u: "1f556",
    a: "0.6"
  },
  {
    n: [
      "clock730",
      "clock face seven-thirty"
    ],
    u: "1f562",
    a: "0.7"
  },
  {
    n: [
      "clock8",
      "clock face eight oclock"
    ],
    u: "1f557",
    a: "0.6"
  },
  {
    n: [
      "clock830",
      "clock face eight-thirty"
    ],
    u: "1f563",
    a: "0.7"
  },
  {
    n: [
      "clock9",
      "clock face nine oclock"
    ],
    u: "1f558",
    a: "0.6"
  },
  {
    n: [
      "clock930",
      "clock face nine-thirty"
    ],
    u: "1f564",
    a: "0.7"
  },
  {
    n: [
      "clock10",
      "clock face ten oclock"
    ],
    u: "1f559",
    a: "0.6"
  },
  {
    n: [
      "clock1030",
      "clock face ten-thirty"
    ],
    u: "1f565",
    a: "0.7"
  },
  {
    n: [
      "clock11",
      "clock face eleven oclock"
    ],
    u: "1f55a",
    a: "0.6"
  },
  {
    n: [
      "clock1130",
      "clock face eleven-thirty"
    ],
    u: "1f566",
    a: "0.7"
  },
  {
    n: [
      "new moon",
      "new moon symbol"
    ],
    u: "1f311",
    a: "0.6"
  },
  {
    n: [
      "waxing crescent moon",
      "waxing crescent moon symbol"
    ],
    u: "1f312",
    a: "1.0"
  },
  {
    n: [
      "first quarter moon",
      "first quarter moon symbol"
    ],
    u: "1f313",
    a: "0.6"
  },
  {
    n: [
      "moon",
      "waxing gibbous moon",
      "waxing gibbous moon symbol"
    ],
    u: "1f314",
    a: "0.6"
  },
  {
    n: [
      "full moon",
      "full moon symbol"
    ],
    u: "1f315",
    a: "0.6"
  },
  {
    n: [
      "waning gibbous moon",
      "waning gibbous moon symbol"
    ],
    u: "1f316",
    a: "1.0"
  },
  {
    n: [
      "last quarter moon",
      "last quarter moon symbol"
    ],
    u: "1f317",
    a: "1.0"
  },
  {
    n: [
      "waning crescent moon",
      "waning crescent moon symbol"
    ],
    u: "1f318",
    a: "1.0"
  },
  {
    n: [
      "crescent moon"
    ],
    u: "1f319",
    a: "0.6"
  },
  {
    n: [
      "new moon with face"
    ],
    u: "1f31a",
    a: "1.0"
  },
  {
    n: [
      "first quarter moon with face"
    ],
    u: "1f31b",
    a: "0.6"
  },
  {
    n: [
      "last quarter moon with face"
    ],
    u: "1f31c",
    a: "0.7"
  },
  {
    n: [
      "thermometer"
    ],
    u: "1f321-fe0f",
    a: "0.7"
  },
  {
    n: [
      "sunny",
      "black sun with rays"
    ],
    u: "2600-fe0f",
    a: "0.6"
  },
  {
    n: [
      "full moon with face"
    ],
    u: "1f31d",
    a: "1.0"
  },
  {
    n: [
      "sun with face"
    ],
    u: "1f31e",
    a: "1.0"
  },
  {
    n: [
      "ringed planet"
    ],
    u: "1fa90",
    a: "12.0"
  },
  {
    n: [
      "star",
      "white medium star"
    ],
    u: "2b50",
    a: "0.6"
  },
  {
    n: [
      "star2",
      "glowing star"
    ],
    u: "1f31f",
    a: "0.6"
  },
  {
    n: [
      "stars",
      "shooting star"
    ],
    u: "1f320",
    a: "0.6"
  },
  {
    n: [
      "milky way"
    ],
    u: "1f30c",
    a: "0.6"
  },
  {
    n: [
      "cloud"
    ],
    u: "2601-fe0f",
    a: "0.6"
  },
  {
    n: [
      "partly sunny",
      "sun behind cloud"
    ],
    u: "26c5",
    a: "0.6"
  },
  {
    n: [
      "thunder cloud and rain",
      "cloud with lightning and rain"
    ],
    u: "26c8-fe0f",
    a: "0.7"
  },
  {
    n: [
      "mostly sunny",
      "sun small cloud",
      "sun behind small cloud"
    ],
    u: "1f324-fe0f",
    a: "0.7"
  },
  {
    n: [
      "barely sunny",
      "sun behind cloud",
      "sun behind large cloud"
    ],
    u: "1f325-fe0f",
    a: "0.7"
  },
  {
    n: [
      "partly sunny rain",
      "sun behind rain cloud"
    ],
    u: "1f326-fe0f",
    a: "0.7"
  },
  {
    n: [
      "rain cloud",
      "cloud with rain"
    ],
    u: "1f327-fe0f",
    a: "0.7"
  },
  {
    n: [
      "snow cloud",
      "cloud with snow"
    ],
    u: "1f328-fe0f",
    a: "0.7"
  },
  {
    n: [
      "lightning",
      "lightning cloud",
      "cloud with lightning"
    ],
    u: "1f329-fe0f",
    a: "0.7"
  },
  {
    n: [
      "tornado",
      "tornado cloud"
    ],
    u: "1f32a-fe0f",
    a: "0.7"
  },
  {
    n: [
      "fog"
    ],
    u: "1f32b-fe0f",
    a: "0.7"
  },
  {
    n: [
      "wind face",
      "wind blowing face"
    ],
    u: "1f32c-fe0f",
    a: "0.7"
  },
  {
    n: [
      "cyclone"
    ],
    u: "1f300",
    a: "0.6"
  },
  {
    n: [
      "rainbow"
    ],
    u: "1f308",
    a: "0.6"
  },
  {
    n: [
      "closed umbrella"
    ],
    u: "1f302",
    a: "0.6"
  },
  {
    n: [
      "umbrella"
    ],
    u: "2602-fe0f",
    a: "0.7"
  },
  {
    n: [
      "umbrella with rain drops"
    ],
    u: "2614",
    a: "0.6"
  },
  {
    n: [
      "umbrella on ground"
    ],
    u: "26f1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "zap",
      "high voltage sign"
    ],
    u: "26a1",
    a: "0.6"
  },
  {
    n: [
      "snowflake"
    ],
    u: "2744-fe0f",
    a: "0.6"
  },
  {
    n: [
      "snowman"
    ],
    u: "2603-fe0f",
    a: "0.7"
  },
  {
    n: [
      "snowman without snow"
    ],
    u: "26c4",
    a: "0.6"
  },
  {
    n: [
      "comet"
    ],
    u: "2604-fe0f",
    a: "1.0"
  },
  {
    n: [
      "fire"
    ],
    u: "1f525",
    a: "0.6"
  },
  {
    n: [
      "droplet"
    ],
    u: "1f4a7",
    a: "0.6"
  },
  {
    n: [
      "ocean",
      "water wave"
    ],
    u: "1f30a",
    a: "0.6"
  }
], Kke = [
  {
    n: [
      "jack-o-lantern",
      "jack o lantern"
    ],
    u: "1f383",
    a: "0.6"
  },
  {
    n: [
      "christmas tree"
    ],
    u: "1f384",
    a: "0.6"
  },
  {
    n: [
      "fireworks"
    ],
    u: "1f386",
    a: "0.6"
  },
  {
    n: [
      "sparkler",
      "firework sparkler"
    ],
    u: "1f387",
    a: "0.6"
  },
  {
    n: [
      "firecracker"
    ],
    u: "1f9e8",
    a: "11.0"
  },
  {
    n: [
      "sparkles"
    ],
    u: "2728",
    a: "0.6"
  },
  {
    n: [
      "balloon"
    ],
    u: "1f388",
    a: "0.6"
  },
  {
    n: [
      "tada",
      "party popper"
    ],
    u: "1f389",
    a: "0.6"
  },
  {
    n: [
      "confetti ball"
    ],
    u: "1f38a",
    a: "0.6"
  },
  {
    n: [
      "tanabata tree"
    ],
    u: "1f38b",
    a: "0.6"
  },
  {
    n: [
      "bamboo",
      "pine decoration"
    ],
    u: "1f38d",
    a: "0.6"
  },
  {
    n: [
      "dolls",
      "japanese dolls"
    ],
    u: "1f38e",
    a: "0.6"
  },
  {
    n: [
      "flags",
      "carp streamer"
    ],
    u: "1f38f",
    a: "0.6"
  },
  {
    n: [
      "wind chime"
    ],
    u: "1f390",
    a: "0.6"
  },
  {
    n: [
      "rice scene",
      "moon viewing ceremony"
    ],
    u: "1f391",
    a: "0.6"
  },
  {
    n: [
      "red envelope",
      "red gift envelope"
    ],
    u: "1f9e7",
    a: "11.0"
  },
  {
    n: [
      "ribbon"
    ],
    u: "1f380",
    a: "0.6"
  },
  {
    n: [
      "gift",
      "wrapped present"
    ],
    u: "1f381",
    a: "0.6"
  },
  {
    n: [
      "reminder ribbon"
    ],
    u: "1f397-fe0f",
    a: "0.7"
  },
  {
    n: [
      "admission tickets"
    ],
    u: "1f39f-fe0f",
    a: "0.7"
  },
  {
    n: [
      "ticket"
    ],
    u: "1f3ab",
    a: "0.6"
  },
  {
    n: [
      "medal",
      "military medal"
    ],
    u: "1f396-fe0f",
    a: "0.7"
  },
  {
    n: [
      "trophy"
    ],
    u: "1f3c6",
    a: "0.6"
  },
  {
    n: [
      "sports medal"
    ],
    u: "1f3c5",
    a: "1.0"
  },
  {
    n: [
      "first place medal"
    ],
    u: "1f947",
    a: "3.0"
  },
  {
    n: [
      "second place medal"
    ],
    u: "1f948",
    a: "3.0"
  },
  {
    n: [
      "third place medal"
    ],
    u: "1f949",
    a: "3.0"
  },
  {
    n: [
      "soccer",
      "soccer ball"
    ],
    u: "26bd",
    a: "0.6"
  },
  {
    n: [
      "baseball"
    ],
    u: "26be",
    a: "0.6"
  },
  {
    n: [
      "softball"
    ],
    u: "1f94e",
    a: "11.0"
  },
  {
    n: [
      "basketball",
      "basketball and hoop"
    ],
    u: "1f3c0",
    a: "0.6"
  },
  {
    n: [
      "volleyball"
    ],
    u: "1f3d0",
    a: "1.0"
  },
  {
    n: [
      "football",
      "american football"
    ],
    u: "1f3c8",
    a: "0.6"
  },
  {
    n: [
      "rugby football"
    ],
    u: "1f3c9",
    a: "1.0"
  },
  {
    n: [
      "tennis",
      "tennis racquet and ball"
    ],
    u: "1f3be",
    a: "0.6"
  },
  {
    n: [
      "flying disc"
    ],
    u: "1f94f",
    a: "11.0"
  },
  {
    n: [
      "bowling"
    ],
    u: "1f3b3",
    a: "0.6"
  },
  {
    n: [
      "cricket bat and ball"
    ],
    u: "1f3cf",
    a: "1.0"
  },
  {
    n: [
      "field hockey stick and ball"
    ],
    u: "1f3d1",
    a: "1.0"
  },
  {
    n: [
      "ice hockey stick and puck"
    ],
    u: "1f3d2",
    a: "1.0"
  },
  {
    n: [
      "lacrosse",
      "lacrosse stick and ball"
    ],
    u: "1f94d",
    a: "11.0"
  },
  {
    n: [
      "table tennis paddle and ball"
    ],
    u: "1f3d3",
    a: "1.0"
  },
  {
    n: [
      "badminton racquet and shuttlecock"
    ],
    u: "1f3f8",
    a: "1.0"
  },
  {
    n: [
      "boxing glove"
    ],
    u: "1f94a",
    a: "3.0"
  },
  {
    n: [
      "martial arts uniform"
    ],
    u: "1f94b",
    a: "3.0"
  },
  {
    n: [
      "goal net"
    ],
    u: "1f945",
    a: "3.0"
  },
  {
    n: [
      "golf",
      "flag in hole"
    ],
    u: "26f3",
    a: "0.6"
  },
  {
    n: [
      "ice skate"
    ],
    u: "26f8-fe0f",
    a: "0.7"
  },
  {
    n: [
      "fishing pole and fish"
    ],
    u: "1f3a3",
    a: "0.6"
  },
  {
    n: [
      "diving mask"
    ],
    u: "1f93f",
    a: "12.0"
  },
  {
    n: [
      "running shirt with sash"
    ],
    u: "1f3bd",
    a: "0.6"
  },
  {
    n: [
      "ski",
      "ski and ski boot"
    ],
    u: "1f3bf",
    a: "0.6"
  },
  {
    n: [
      "sled"
    ],
    u: "1f6f7",
    a: "5.0"
  },
  {
    n: [
      "curling stone"
    ],
    u: "1f94c",
    a: "5.0"
  },
  {
    n: [
      "dart",
      "direct hit"
    ],
    u: "1f3af",
    a: "0.6"
  },
  {
    n: [
      "yo-yo"
    ],
    u: "1fa80",
    a: "12.0"
  },
  {
    n: [
      "kite"
    ],
    u: "1fa81",
    a: "12.0"
  },
  {
    n: [
      "8ball",
      "billiards"
    ],
    u: "1f3b1",
    a: "0.6"
  },
  {
    n: [
      "crystal ball"
    ],
    u: "1f52e",
    a: "0.6"
  },
  {
    n: [
      "magic wand"
    ],
    u: "1fa84",
    a: "13.0"
  },
  {
    n: [
      "nazar amulet"
    ],
    u: "1f9ff",
    a: "11.0"
  },
  {
    n: [
      "hamsa"
    ],
    u: "1faac",
    a: "14.0"
  },
  {
    n: [
      "video game"
    ],
    u: "1f3ae",
    a: "0.6"
  },
  {
    n: [
      "joystick"
    ],
    u: "1f579-fe0f",
    a: "0.7"
  },
  {
    n: [
      "slot machine"
    ],
    u: "1f3b0",
    a: "0.6"
  },
  {
    n: [
      "game die"
    ],
    u: "1f3b2",
    a: "0.6"
  },
  {
    n: [
      "jigsaw",
      "jigsaw puzzle piece"
    ],
    u: "1f9e9",
    a: "11.0"
  },
  {
    n: [
      "teddy bear"
    ],
    u: "1f9f8",
    a: "11.0"
  },
  {
    n: [
      "pinata"
    ],
    u: "1fa85",
    a: "13.0"
  },
  {
    n: [
      "mirror ball"
    ],
    u: "1faa9",
    a: "14.0"
  },
  {
    n: [
      "nesting dolls"
    ],
    u: "1fa86",
    a: "13.0"
  },
  {
    n: [
      "spades",
      "black spade suit"
    ],
    u: "2660-fe0f",
    a: "0.6"
  },
  {
    n: [
      "hearts",
      "black heart suit"
    ],
    u: "2665-fe0f",
    a: "0.6"
  },
  {
    n: [
      "diamonds",
      "black diamond suit"
    ],
    u: "2666-fe0f",
    a: "0.6"
  },
  {
    n: [
      "clubs",
      "black club suit"
    ],
    u: "2663-fe0f",
    a: "0.6"
  },
  {
    n: [
      "chess pawn"
    ],
    u: "265f-fe0f",
    a: "11.0"
  },
  {
    n: [
      "black joker",
      "playing card black joker"
    ],
    u: "1f0cf",
    a: "0.6"
  },
  {
    n: [
      "mahjong",
      "mahjong tile red dragon"
    ],
    u: "1f004",
    a: "0.6"
  },
  {
    n: [
      "flower playing cards"
    ],
    u: "1f3b4",
    a: "0.6"
  },
  {
    n: [
      "performing arts"
    ],
    u: "1f3ad",
    a: "0.6"
  },
  {
    n: [
      "framed picture",
      "frame with picture"
    ],
    u: "1f5bc-fe0f",
    a: "0.7"
  },
  {
    n: [
      "art",
      "artist palette"
    ],
    u: "1f3a8",
    a: "0.6"
  },
  {
    n: [
      "thread",
      "spool of thread"
    ],
    u: "1f9f5",
    a: "11.0"
  },
  {
    n: [
      "sewing needle"
    ],
    u: "1faa1",
    a: "13.0"
  },
  {
    n: [
      "yarn",
      "ball of yarn"
    ],
    u: "1f9f6",
    a: "11.0"
  },
  {
    n: [
      "knot"
    ],
    u: "1faa2",
    a: "13.0"
  }
], Xke = [
  {
    n: [
      "eyeglasses"
    ],
    u: "1f453",
    a: "0.6"
  },
  {
    n: [
      "sunglasses",
      "dark sunglasses"
    ],
    u: "1f576-fe0f",
    a: "0.7"
  },
  {
    n: [
      "goggles"
    ],
    u: "1f97d",
    a: "11.0"
  },
  {
    n: [
      "lab coat"
    ],
    u: "1f97c",
    a: "11.0"
  },
  {
    n: [
      "safety vest"
    ],
    u: "1f9ba",
    a: "12.0"
  },
  {
    n: [
      "necktie"
    ],
    u: "1f454",
    a: "0.6"
  },
  {
    n: [
      "shirt",
      "tshirt",
      "t-shirt"
    ],
    u: "1f455",
    a: "0.6"
  },
  {
    n: [
      "jeans"
    ],
    u: "1f456",
    a: "0.6"
  },
  {
    n: [
      "scarf"
    ],
    u: "1f9e3",
    a: "5.0"
  },
  {
    n: [
      "gloves"
    ],
    u: "1f9e4",
    a: "5.0"
  },
  {
    n: [
      "coat"
    ],
    u: "1f9e5",
    a: "5.0"
  },
  {
    n: [
      "socks"
    ],
    u: "1f9e6",
    a: "5.0"
  },
  {
    n: [
      "dress"
    ],
    u: "1f457",
    a: "0.6"
  },
  {
    n: [
      "kimono"
    ],
    u: "1f458",
    a: "0.6"
  },
  {
    n: [
      "sari"
    ],
    u: "1f97b",
    a: "12.0"
  },
  {
    n: [
      "one-piece swimsuit"
    ],
    u: "1fa71",
    a: "12.0"
  },
  {
    n: [
      "briefs"
    ],
    u: "1fa72",
    a: "12.0"
  },
  {
    n: [
      "shorts"
    ],
    u: "1fa73",
    a: "12.0"
  },
  {
    n: [
      "bikini"
    ],
    u: "1f459",
    a: "0.6"
  },
  {
    n: [
      "womans clothes"
    ],
    u: "1f45a",
    a: "0.6"
  },
  {
    n: [
      "purse"
    ],
    u: "1f45b",
    a: "0.6"
  },
  {
    n: [
      "handbag"
    ],
    u: "1f45c",
    a: "0.6"
  },
  {
    n: [
      "pouch"
    ],
    u: "1f45d",
    a: "0.6"
  },
  {
    n: [
      "shopping bags"
    ],
    u: "1f6cd-fe0f",
    a: "0.7"
  },
  {
    n: [
      "school satchel"
    ],
    u: "1f392",
    a: "0.6"
  },
  {
    n: [
      "thong sandal"
    ],
    u: "1fa74",
    a: "13.0"
  },
  {
    n: [
      "shoe",
      "mans shoe"
    ],
    u: "1f45e",
    a: "0.6"
  },
  {
    n: [
      "athletic shoe"
    ],
    u: "1f45f",
    a: "0.6"
  },
  {
    n: [
      "hiking boot"
    ],
    u: "1f97e",
    a: "11.0"
  },
  {
    n: [
      "flat shoe",
      "womans flat shoe"
    ],
    u: "1f97f",
    a: "11.0"
  },
  {
    n: [
      "high heel",
      "high-heeled shoe"
    ],
    u: "1f460",
    a: "0.6"
  },
  {
    n: [
      "sandal",
      "womans sandal"
    ],
    u: "1f461",
    a: "0.6"
  },
  {
    n: [
      "ballet shoes"
    ],
    u: "1fa70",
    a: "12.0"
  },
  {
    n: [
      "boot",
      "womans boots"
    ],
    u: "1f462",
    a: "0.6"
  },
  {
    n: [
      "crown"
    ],
    u: "1f451",
    a: "0.6"
  },
  {
    n: [
      "womans hat"
    ],
    u: "1f452",
    a: "0.6"
  },
  {
    n: [
      "tophat",
      "top hat"
    ],
    u: "1f3a9",
    a: "0.6"
  },
  {
    n: [
      "mortar board",
      "graduation cap"
    ],
    u: "1f393",
    a: "0.6"
  },
  {
    n: [
      "billed cap"
    ],
    u: "1f9e2",
    a: "5.0"
  },
  {
    n: [
      "military helmet"
    ],
    u: "1fa96",
    a: "13.0"
  },
  {
    n: [
      "rescue worker’s helmet",
      "helmet with white cross"
    ],
    u: "26d1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "prayer beads"
    ],
    u: "1f4ff",
    a: "1.0"
  },
  {
    n: [
      "lipstick"
    ],
    u: "1f484",
    a: "0.6"
  },
  {
    n: [
      "ring"
    ],
    u: "1f48d",
    a: "0.6"
  },
  {
    n: [
      "gem",
      "gem stone"
    ],
    u: "1f48e",
    a: "0.6"
  },
  {
    n: [
      "mute",
      "speaker with cancellation stroke"
    ],
    u: "1f507",
    a: "1.0"
  },
  {
    n: [
      "speaker"
    ],
    u: "1f508",
    a: "0.7"
  },
  {
    n: [
      "sound",
      "speaker with one sound wave"
    ],
    u: "1f509",
    a: "1.0"
  },
  {
    n: [
      "loud sound",
      "speaker with three sound waves"
    ],
    u: "1f50a",
    a: "0.6"
  },
  {
    n: [
      "loudspeaker",
      "public address loudspeaker"
    ],
    u: "1f4e2",
    a: "0.6"
  },
  {
    n: [
      "mega",
      "cheering megaphone"
    ],
    u: "1f4e3",
    a: "0.6"
  },
  {
    n: [
      "postal horn"
    ],
    u: "1f4ef",
    a: "1.0"
  },
  {
    n: [
      "bell"
    ],
    u: "1f514",
    a: "0.6"
  },
  {
    n: [
      "no bell",
      "bell with cancellation stroke"
    ],
    u: "1f515",
    a: "1.0"
  },
  {
    n: [
      "musical score"
    ],
    u: "1f3bc",
    a: "0.6"
  },
  {
    n: [
      "musical note"
    ],
    u: "1f3b5",
    a: "0.6"
  },
  {
    n: [
      "notes",
      "multiple musical notes"
    ],
    u: "1f3b6",
    a: "0.6"
  },
  {
    n: [
      "studio microphone"
    ],
    u: "1f399-fe0f",
    a: "0.7"
  },
  {
    n: [
      "level slider"
    ],
    u: "1f39a-fe0f",
    a: "0.7"
  },
  {
    n: [
      "control knobs"
    ],
    u: "1f39b-fe0f",
    a: "0.7"
  },
  {
    n: [
      "microphone"
    ],
    u: "1f3a4",
    a: "0.6"
  },
  {
    n: [
      "headphone",
      "headphones"
    ],
    u: "1f3a7",
    a: "0.6"
  },
  {
    n: [
      "radio"
    ],
    u: "1f4fb",
    a: "0.6"
  },
  {
    n: [
      "saxophone"
    ],
    u: "1f3b7",
    a: "0.6"
  },
  {
    n: [
      "accordion"
    ],
    u: "1fa97",
    a: "13.0"
  },
  {
    n: [
      "guitar"
    ],
    u: "1f3b8",
    a: "0.6"
  },
  {
    n: [
      "musical keyboard"
    ],
    u: "1f3b9",
    a: "0.6"
  },
  {
    n: [
      "trumpet"
    ],
    u: "1f3ba",
    a: "0.6"
  },
  {
    n: [
      "violin"
    ],
    u: "1f3bb",
    a: "0.6"
  },
  {
    n: [
      "banjo"
    ],
    u: "1fa95",
    a: "12.0"
  },
  {
    n: [
      "drum with drumsticks"
    ],
    u: "1f941",
    a: "3.0"
  },
  {
    n: [
      "long drum"
    ],
    u: "1fa98",
    a: "13.0"
  },
  {
    n: [
      "iphone",
      "mobile phone"
    ],
    u: "1f4f1",
    a: "0.6"
  },
  {
    n: [
      "calling",
      "mobile phone with rightwards arrow at left"
    ],
    u: "1f4f2",
    a: "0.6"
  },
  {
    n: [
      "phone",
      "telephone",
      "black telephone"
    ],
    u: "260e-fe0f",
    a: "0.6"
  },
  {
    n: [
      "telephone receiver"
    ],
    u: "1f4de",
    a: "0.6"
  },
  {
    n: [
      "pager"
    ],
    u: "1f4df",
    a: "0.6"
  },
  {
    n: [
      "fax",
      "fax machine"
    ],
    u: "1f4e0",
    a: "0.6"
  },
  {
    n: [
      "battery"
    ],
    u: "1f50b",
    a: "0.6"
  },
  {
    n: [
      "low battery"
    ],
    u: "1faab",
    a: "14.0"
  },
  {
    n: [
      "electric plug"
    ],
    u: "1f50c",
    a: "0.6"
  },
  {
    n: [
      "computer",
      "personal computer"
    ],
    u: "1f4bb",
    a: "0.6"
  },
  {
    n: [
      "desktop computer"
    ],
    u: "1f5a5-fe0f",
    a: "0.7"
  },
  {
    n: [
      "printer"
    ],
    u: "1f5a8-fe0f",
    a: "0.7"
  },
  {
    n: [
      "keyboard"
    ],
    u: "2328-fe0f",
    a: "1.0"
  },
  {
    n: [
      "computer mouse",
      "three button mouse"
    ],
    u: "1f5b1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "trackball"
    ],
    u: "1f5b2-fe0f",
    a: "0.7"
  },
  {
    n: [
      "minidisc"
    ],
    u: "1f4bd",
    a: "0.6"
  },
  {
    n: [
      "floppy disk"
    ],
    u: "1f4be",
    a: "0.6"
  },
  {
    n: [
      "cd",
      "optical disc"
    ],
    u: "1f4bf",
    a: "0.6"
  },
  {
    n: [
      "dvd"
    ],
    u: "1f4c0",
    a: "0.6"
  },
  {
    n: [
      "abacus"
    ],
    u: "1f9ee",
    a: "11.0"
  },
  {
    n: [
      "movie camera"
    ],
    u: "1f3a5",
    a: "0.6"
  },
  {
    n: [
      "film frames"
    ],
    u: "1f39e-fe0f",
    a: "0.7"
  },
  {
    n: [
      "film projector"
    ],
    u: "1f4fd-fe0f",
    a: "0.7"
  },
  {
    n: [
      "clapper",
      "clapper board"
    ],
    u: "1f3ac",
    a: "0.6"
  },
  {
    n: [
      "tv",
      "television"
    ],
    u: "1f4fa",
    a: "0.6"
  },
  {
    n: [
      "camera"
    ],
    u: "1f4f7",
    a: "0.6"
  },
  {
    n: [
      "camera with flash"
    ],
    u: "1f4f8",
    a: "1.0"
  },
  {
    n: [
      "video camera"
    ],
    u: "1f4f9",
    a: "0.6"
  },
  {
    n: [
      "vhs",
      "videocassette"
    ],
    u: "1f4fc",
    a: "0.6"
  },
  {
    n: [
      "mag",
      "left-pointing magnifying glass"
    ],
    u: "1f50d",
    a: "0.6"
  },
  {
    n: [
      "mag right",
      "right-pointing magnifying glass"
    ],
    u: "1f50e",
    a: "0.6"
  },
  {
    n: [
      "candle"
    ],
    u: "1f56f-fe0f",
    a: "0.7"
  },
  {
    n: [
      "bulb",
      "electric light bulb"
    ],
    u: "1f4a1",
    a: "0.6"
  },
  {
    n: [
      "flashlight",
      "electric torch"
    ],
    u: "1f526",
    a: "0.6"
  },
  {
    n: [
      "lantern",
      "izakaya lantern"
    ],
    u: "1f3ee",
    a: "0.6"
  },
  {
    n: [
      "diya lamp"
    ],
    u: "1fa94",
    a: "12.0"
  },
  {
    n: [
      "notebook with decorative cover"
    ],
    u: "1f4d4",
    a: "0.6"
  },
  {
    n: [
      "closed book"
    ],
    u: "1f4d5",
    a: "0.6"
  },
  {
    n: [
      "book",
      "open book"
    ],
    u: "1f4d6",
    a: "0.6"
  },
  {
    n: [
      "green book"
    ],
    u: "1f4d7",
    a: "0.6"
  },
  {
    n: [
      "blue book"
    ],
    u: "1f4d8",
    a: "0.6"
  },
  {
    n: [
      "orange book"
    ],
    u: "1f4d9",
    a: "0.6"
  },
  {
    n: [
      "books"
    ],
    u: "1f4da",
    a: "0.6"
  },
  {
    n: [
      "notebook"
    ],
    u: "1f4d3",
    a: "0.6"
  },
  {
    n: [
      "ledger"
    ],
    u: "1f4d2",
    a: "0.6"
  },
  {
    n: [
      "page with curl"
    ],
    u: "1f4c3",
    a: "0.6"
  },
  {
    n: [
      "scroll"
    ],
    u: "1f4dc",
    a: "0.6"
  },
  {
    n: [
      "page facing up"
    ],
    u: "1f4c4",
    a: "0.6"
  },
  {
    n: [
      "newspaper"
    ],
    u: "1f4f0",
    a: "0.6"
  },
  {
    n: [
      "rolled-up newspaper",
      "rolled up newspaper"
    ],
    u: "1f5de-fe0f",
    a: "0.7"
  },
  {
    n: [
      "bookmark tabs"
    ],
    u: "1f4d1",
    a: "0.6"
  },
  {
    n: [
      "bookmark"
    ],
    u: "1f516",
    a: "0.6"
  },
  {
    n: [
      "label"
    ],
    u: "1f3f7-fe0f",
    a: "0.7"
  },
  {
    n: [
      "moneybag",
      "money bag"
    ],
    u: "1f4b0",
    a: "0.6"
  },
  {
    n: [
      "coin"
    ],
    u: "1fa99",
    a: "13.0"
  },
  {
    n: [
      "yen",
      "banknote with yen sign"
    ],
    u: "1f4b4",
    a: "0.6"
  },
  {
    n: [
      "dollar",
      "banknote with dollar sign"
    ],
    u: "1f4b5",
    a: "0.6"
  },
  {
    n: [
      "euro",
      "banknote with euro sign"
    ],
    u: "1f4b6",
    a: "1.0"
  },
  {
    n: [
      "pound",
      "banknote with pound sign"
    ],
    u: "1f4b7",
    a: "1.0"
  },
  {
    n: [
      "money with wings"
    ],
    u: "1f4b8",
    a: "0.6"
  },
  {
    n: [
      "credit card"
    ],
    u: "1f4b3",
    a: "0.6"
  },
  {
    n: [
      "receipt"
    ],
    u: "1f9fe",
    a: "11.0"
  },
  {
    n: [
      "chart",
      "chart with upwards trend and yen sign"
    ],
    u: "1f4b9",
    a: "0.6"
  },
  {
    n: [
      "email",
      "envelope"
    ],
    u: "2709-fe0f",
    a: "0.6"
  },
  {
    n: [
      "e-mail",
      "e-mail symbol"
    ],
    u: "1f4e7",
    a: "0.6"
  },
  {
    n: [
      "incoming envelope"
    ],
    u: "1f4e8",
    a: "0.6"
  },
  {
    n: [
      "envelope with arrow",
      "envelope with downwards arrow above"
    ],
    u: "1f4e9",
    a: "0.6"
  },
  {
    n: [
      "outbox tray"
    ],
    u: "1f4e4",
    a: "0.6"
  },
  {
    n: [
      "inbox tray"
    ],
    u: "1f4e5",
    a: "0.6"
  },
  {
    n: [
      "package"
    ],
    u: "1f4e6",
    a: "0.6"
  },
  {
    n: [
      "mailbox",
      "closed mailbox with raised flag"
    ],
    u: "1f4eb",
    a: "0.6"
  },
  {
    n: [
      "mailbox closed",
      "closed mailbox with lowered flag"
    ],
    u: "1f4ea",
    a: "0.6"
  },
  {
    n: [
      "mailbox with mail",
      "open mailbox with raised flag"
    ],
    u: "1f4ec",
    a: "0.7"
  },
  {
    n: [
      "mailbox with no mail",
      "open mailbox with lowered flag"
    ],
    u: "1f4ed",
    a: "0.7"
  },
  {
    n: [
      "postbox"
    ],
    u: "1f4ee",
    a: "0.6"
  },
  {
    n: [
      "ballot box with ballot"
    ],
    u: "1f5f3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "pencil",
      "pencil2"
    ],
    u: "270f-fe0f",
    a: "0.6"
  },
  {
    n: [
      "black nib"
    ],
    u: "2712-fe0f",
    a: "0.6"
  },
  {
    n: [
      "fountain pen",
      "lower left fountain pen"
    ],
    u: "1f58b-fe0f",
    a: "0.7"
  },
  {
    n: [
      "pen",
      "lower left ballpoint pen"
    ],
    u: "1f58a-fe0f",
    a: "0.7"
  },
  {
    n: [
      "paintbrush",
      "lower left paintbrush"
    ],
    u: "1f58c-fe0f",
    a: "0.7"
  },
  {
    n: [
      "crayon",
      "lower left crayon"
    ],
    u: "1f58d-fe0f",
    a: "0.7"
  },
  {
    n: [
      "memo",
      "pencil"
    ],
    u: "1f4dd",
    a: "0.6"
  },
  {
    n: [
      "briefcase"
    ],
    u: "1f4bc",
    a: "0.6"
  },
  {
    n: [
      "file folder"
    ],
    u: "1f4c1",
    a: "0.6"
  },
  {
    n: [
      "open file folder"
    ],
    u: "1f4c2",
    a: "0.6"
  },
  {
    n: [
      "card index dividers"
    ],
    u: "1f5c2-fe0f",
    a: "0.7"
  },
  {
    n: [
      "date",
      "calendar"
    ],
    u: "1f4c5",
    a: "0.6"
  },
  {
    n: [
      "calendar",
      "tear-off calendar"
    ],
    u: "1f4c6",
    a: "0.6"
  },
  {
    n: [
      "spiral notepad",
      "spiral note pad"
    ],
    u: "1f5d2-fe0f",
    a: "0.7"
  },
  {
    n: [
      "spiral calendar",
      "spiral calendar pad"
    ],
    u: "1f5d3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "card index"
    ],
    u: "1f4c7",
    a: "0.6"
  },
  {
    n: [
      "chart with upwards trend"
    ],
    u: "1f4c8",
    a: "0.6"
  },
  {
    n: [
      "chart with downwards trend"
    ],
    u: "1f4c9",
    a: "0.6"
  },
  {
    n: [
      "bar chart"
    ],
    u: "1f4ca",
    a: "0.6"
  },
  {
    n: [
      "clipboard"
    ],
    u: "1f4cb",
    a: "0.6"
  },
  {
    n: [
      "pushpin"
    ],
    u: "1f4cc",
    a: "0.6"
  },
  {
    n: [
      "round pushpin"
    ],
    u: "1f4cd",
    a: "0.6"
  },
  {
    n: [
      "paperclip"
    ],
    u: "1f4ce",
    a: "0.6"
  },
  {
    n: [
      "linked paperclips"
    ],
    u: "1f587-fe0f",
    a: "0.7"
  },
  {
    n: [
      "straight ruler"
    ],
    u: "1f4cf",
    a: "0.6"
  },
  {
    n: [
      "triangular ruler"
    ],
    u: "1f4d0",
    a: "0.6"
  },
  {
    n: [
      "scissors",
      "black scissors"
    ],
    u: "2702-fe0f",
    a: "0.6"
  },
  {
    n: [
      "card file box"
    ],
    u: "1f5c3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "file cabinet"
    ],
    u: "1f5c4-fe0f",
    a: "0.7"
  },
  {
    n: [
      "wastebasket"
    ],
    u: "1f5d1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "lock"
    ],
    u: "1f512",
    a: "0.6"
  },
  {
    n: [
      "unlock",
      "open lock"
    ],
    u: "1f513",
    a: "0.6"
  },
  {
    n: [
      "lock with ink pen"
    ],
    u: "1f50f",
    a: "0.6"
  },
  {
    n: [
      "closed lock with key"
    ],
    u: "1f510",
    a: "0.6"
  },
  {
    n: [
      "key"
    ],
    u: "1f511",
    a: "0.6"
  },
  {
    n: [
      "old key"
    ],
    u: "1f5dd-fe0f",
    a: "0.7"
  },
  {
    n: [
      "hammer"
    ],
    u: "1f528",
    a: "0.6"
  },
  {
    n: [
      "axe"
    ],
    u: "1fa93",
    a: "12.0"
  },
  {
    n: [
      "pick"
    ],
    u: "26cf-fe0f",
    a: "0.7"
  },
  {
    n: [
      "hammer and pick"
    ],
    u: "2692-fe0f",
    a: "1.0"
  },
  {
    n: [
      "hammer and wrench"
    ],
    u: "1f6e0-fe0f",
    a: "0.7"
  },
  {
    n: [
      "dagger",
      "dagger knife"
    ],
    u: "1f5e1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "crossed swords"
    ],
    u: "2694-fe0f",
    a: "1.0"
  },
  {
    n: [
      "gun",
      "pistol"
    ],
    u: "1f52b",
    a: "0.6"
  },
  {
    n: [
      "boomerang"
    ],
    u: "1fa83",
    a: "13.0"
  },
  {
    n: [
      "bow and arrow"
    ],
    u: "1f3f9",
    a: "1.0"
  },
  {
    n: [
      "shield"
    ],
    u: "1f6e1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "carpentry saw"
    ],
    u: "1fa9a",
    a: "13.0"
  },
  {
    n: [
      "wrench"
    ],
    u: "1f527",
    a: "0.6"
  },
  {
    n: [
      "screwdriver"
    ],
    u: "1fa9b",
    a: "13.0"
  },
  {
    n: [
      "nut and bolt"
    ],
    u: "1f529",
    a: "0.6"
  },
  {
    n: [
      "gear"
    ],
    u: "2699-fe0f",
    a: "1.0"
  },
  {
    n: [
      "clamp",
      "compression"
    ],
    u: "1f5dc-fe0f",
    a: "0.7"
  },
  {
    n: [
      "scales",
      "balance scale"
    ],
    u: "2696-fe0f",
    a: "1.0"
  },
  {
    n: [
      "probing cane"
    ],
    u: "1f9af",
    a: "12.0"
  },
  {
    n: [
      "link",
      "link symbol"
    ],
    u: "1f517",
    a: "0.6"
  },
  {
    n: [
      "chains"
    ],
    u: "26d3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "hook"
    ],
    u: "1fa9d",
    a: "13.0"
  },
  {
    n: [
      "toolbox"
    ],
    u: "1f9f0",
    a: "11.0"
  },
  {
    n: [
      "magnet"
    ],
    u: "1f9f2",
    a: "11.0"
  },
  {
    n: [
      "ladder"
    ],
    u: "1fa9c",
    a: "13.0"
  },
  {
    n: [
      "alembic"
    ],
    u: "2697-fe0f",
    a: "1.0"
  },
  {
    n: [
      "test tube"
    ],
    u: "1f9ea",
    a: "11.0"
  },
  {
    n: [
      "petri dish"
    ],
    u: "1f9eb",
    a: "11.0"
  },
  {
    n: [
      "dna",
      "dna double helix"
    ],
    u: "1f9ec",
    a: "11.0"
  },
  {
    n: [
      "microscope"
    ],
    u: "1f52c",
    a: "1.0"
  },
  {
    n: [
      "telescope"
    ],
    u: "1f52d",
    a: "1.0"
  },
  {
    n: [
      "satellite antenna"
    ],
    u: "1f4e1",
    a: "0.6"
  },
  {
    n: [
      "syringe"
    ],
    u: "1f489",
    a: "0.6"
  },
  {
    n: [
      "drop of blood"
    ],
    u: "1fa78",
    a: "12.0"
  },
  {
    n: [
      "pill"
    ],
    u: "1f48a",
    a: "0.6"
  },
  {
    n: [
      "adhesive bandage"
    ],
    u: "1fa79",
    a: "12.0"
  },
  {
    n: [
      "crutch"
    ],
    u: "1fa7c",
    a: "14.0"
  },
  {
    n: [
      "stethoscope"
    ],
    u: "1fa7a",
    a: "12.0"
  },
  {
    n: [
      "x-ray"
    ],
    u: "1fa7b",
    a: "14.0"
  },
  {
    n: [
      "door"
    ],
    u: "1f6aa",
    a: "0.6"
  },
  {
    n: [
      "elevator"
    ],
    u: "1f6d7",
    a: "13.0"
  },
  {
    n: [
      "mirror"
    ],
    u: "1fa9e",
    a: "13.0"
  },
  {
    n: [
      "window"
    ],
    u: "1fa9f",
    a: "13.0"
  },
  {
    n: [
      "bed"
    ],
    u: "1f6cf-fe0f",
    a: "0.7"
  },
  {
    n: [
      "couch and lamp"
    ],
    u: "1f6cb-fe0f",
    a: "0.7"
  },
  {
    n: [
      "chair"
    ],
    u: "1fa91",
    a: "12.0"
  },
  {
    n: [
      "toilet"
    ],
    u: "1f6bd",
    a: "0.6"
  },
  {
    n: [
      "plunger"
    ],
    u: "1faa0",
    a: "13.0"
  },
  {
    n: [
      "shower"
    ],
    u: "1f6bf",
    a: "1.0"
  },
  {
    n: [
      "bathtub"
    ],
    u: "1f6c1",
    a: "1.0"
  },
  {
    n: [
      "mouse trap"
    ],
    u: "1faa4",
    a: "13.0"
  },
  {
    n: [
      "razor"
    ],
    u: "1fa92",
    a: "12.0"
  },
  {
    n: [
      "lotion bottle"
    ],
    u: "1f9f4",
    a: "11.0"
  },
  {
    n: [
      "safety pin"
    ],
    u: "1f9f7",
    a: "11.0"
  },
  {
    n: [
      "broom"
    ],
    u: "1f9f9",
    a: "11.0"
  },
  {
    n: [
      "basket"
    ],
    u: "1f9fa",
    a: "11.0"
  },
  {
    n: [
      "roll of paper"
    ],
    u: "1f9fb",
    a: "11.0"
  },
  {
    n: [
      "bucket"
    ],
    u: "1faa3",
    a: "13.0"
  },
  {
    n: [
      "soap",
      "bar of soap"
    ],
    u: "1f9fc",
    a: "11.0"
  },
  {
    n: [
      "bubbles"
    ],
    u: "1fae7",
    a: "14.0"
  },
  {
    n: [
      "toothbrush"
    ],
    u: "1faa5",
    a: "13.0"
  },
  {
    n: [
      "sponge"
    ],
    u: "1f9fd",
    a: "11.0"
  },
  {
    n: [
      "fire extinguisher"
    ],
    u: "1f9ef",
    a: "11.0"
  },
  {
    n: [
      "shopping trolley"
    ],
    u: "1f6d2",
    a: "3.0"
  },
  {
    n: [
      "smoking",
      "smoking symbol"
    ],
    u: "1f6ac",
    a: "0.6"
  },
  {
    n: [
      "coffin"
    ],
    u: "26b0-fe0f",
    a: "1.0"
  },
  {
    n: [
      "headstone"
    ],
    u: "1faa6",
    a: "13.0"
  },
  {
    n: [
      "funeral urn"
    ],
    u: "26b1-fe0f",
    a: "1.0"
  },
  {
    n: [
      "moyai"
    ],
    u: "1f5ff",
    a: "0.6"
  },
  {
    n: [
      "placard"
    ],
    u: "1faa7",
    a: "13.0"
  },
  {
    n: [
      "identification card"
    ],
    u: "1faaa",
    a: "14.0"
  }
], ege = [
  {
    n: [
      "atm",
      "automated teller machine"
    ],
    u: "1f3e7",
    a: "0.6"
  },
  {
    n: [
      "put litter in its place",
      "put litter in its place symbol"
    ],
    u: "1f6ae",
    a: "1.0"
  },
  {
    n: [
      "potable water",
      "potable water symbol"
    ],
    u: "1f6b0",
    a: "1.0"
  },
  {
    n: [
      "wheelchair",
      "wheelchair symbol"
    ],
    u: "267f",
    a: "0.6"
  },
  {
    n: [
      "mens",
      "mens symbol"
    ],
    u: "1f6b9",
    a: "0.6"
  },
  {
    n: [
      "womens",
      "womens symbol"
    ],
    u: "1f6ba",
    a: "0.6"
  },
  {
    n: [
      "restroom"
    ],
    u: "1f6bb",
    a: "0.6"
  },
  {
    n: [
      "baby symbol"
    ],
    u: "1f6bc",
    a: "0.6"
  },
  {
    n: [
      "wc",
      "water closet"
    ],
    u: "1f6be",
    a: "0.6"
  },
  {
    n: [
      "passport control"
    ],
    u: "1f6c2",
    a: "1.0"
  },
  {
    n: [
      "customs"
    ],
    u: "1f6c3",
    a: "1.0"
  },
  {
    n: [
      "baggage claim"
    ],
    u: "1f6c4",
    a: "1.0"
  },
  {
    n: [
      "left luggage"
    ],
    u: "1f6c5",
    a: "1.0"
  },
  {
    n: [
      "warning",
      "warning sign"
    ],
    u: "26a0-fe0f",
    a: "0.6"
  },
  {
    n: [
      "children crossing"
    ],
    u: "1f6b8",
    a: "1.0"
  },
  {
    n: [
      "no entry"
    ],
    u: "26d4",
    a: "0.6"
  },
  {
    n: [
      "no entry sign"
    ],
    u: "1f6ab",
    a: "0.6"
  },
  {
    n: [
      "no bicycles"
    ],
    u: "1f6b3",
    a: "1.0"
  },
  {
    n: [
      "no smoking",
      "no smoking symbol"
    ],
    u: "1f6ad",
    a: "0.6"
  },
  {
    n: [
      "do not litter",
      "do not litter symbol"
    ],
    u: "1f6af",
    a: "1.0"
  },
  {
    n: [
      "non-potable water",
      "non-potable water symbol"
    ],
    u: "1f6b1",
    a: "1.0"
  },
  {
    n: [
      "no pedestrians"
    ],
    u: "1f6b7",
    a: "1.0"
  },
  {
    n: [
      "no mobile phones"
    ],
    u: "1f4f5",
    a: "1.0"
  },
  {
    n: [
      "underage",
      "no one under eighteen symbol"
    ],
    u: "1f51e",
    a: "0.6"
  },
  {
    n: [
      "radioactive",
      "radioactive sign"
    ],
    u: "2622-fe0f",
    a: "1.0"
  },
  {
    n: [
      "biohazard",
      "biohazard sign"
    ],
    u: "2623-fe0f",
    a: "1.0"
  },
  {
    n: [
      "arrow up",
      "upwards black arrow"
    ],
    u: "2b06-fe0f",
    a: "0.6"
  },
  {
    n: [
      "north east arrow",
      "arrow upper right"
    ],
    u: "2197-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow right",
      "black rightwards arrow"
    ],
    u: "27a1-fe0f",
    a: "0.6"
  },
  {
    n: [
      "south east arrow",
      "arrow lower right"
    ],
    u: "2198-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow down",
      "downwards black arrow"
    ],
    u: "2b07-fe0f",
    a: "0.6"
  },
  {
    n: [
      "south west arrow",
      "arrow lower left"
    ],
    u: "2199-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow left",
      "leftwards black arrow"
    ],
    u: "2b05-fe0f",
    a: "0.6"
  },
  {
    n: [
      "north west arrow",
      "arrow upper left"
    ],
    u: "2196-fe0f",
    a: "0.6"
  },
  {
    n: [
      "up down arrow",
      "arrow up down"
    ],
    u: "2195-fe0f",
    a: "0.6"
  },
  {
    n: [
      "left right arrow"
    ],
    u: "2194-fe0f",
    a: "0.6"
  },
  {
    n: [
      "leftwards arrow with hook"
    ],
    u: "21a9-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow right hook",
      "rightwards arrow with hook"
    ],
    u: "21aa-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow heading up",
      "arrow pointing rightwards then curving upwards"
    ],
    u: "2934-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow heading down",
      "arrow pointing rightwards then curving downwards"
    ],
    u: "2935-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrows clockwise",
      "clockwise downwards and upwards open circle arrows"
    ],
    u: "1f503",
    a: "0.6"
  },
  {
    n: [
      "arrows counterclockwise",
      "anticlockwise downwards and upwards open circle arrows"
    ],
    u: "1f504",
    a: "1.0"
  },
  {
    n: [
      "back",
      "back with leftwards arrow above"
    ],
    u: "1f519",
    a: "0.6"
  },
  {
    n: [
      "end",
      "end with leftwards arrow above"
    ],
    u: "1f51a",
    a: "0.6"
  },
  {
    n: [
      "on",
      "on with exclamation mark with left right arrow above"
    ],
    u: "1f51b",
    a: "0.6"
  },
  {
    n: [
      "soon",
      "soon with rightwards arrow above"
    ],
    u: "1f51c",
    a: "0.6"
  },
  {
    n: [
      "top",
      "top with upwards arrow above"
    ],
    u: "1f51d",
    a: "0.6"
  },
  {
    n: [
      "place of worship"
    ],
    u: "1f6d0",
    a: "1.0"
  },
  {
    n: [
      "atom symbol"
    ],
    u: "269b-fe0f",
    a: "1.0"
  },
  {
    n: [
      "om",
      "om symbol"
    ],
    u: "1f549-fe0f",
    a: "0.7"
  },
  {
    n: [
      "star of david"
    ],
    u: "2721-fe0f",
    a: "0.7"
  },
  {
    n: [
      "wheel of dharma"
    ],
    u: "2638-fe0f",
    a: "0.7"
  },
  {
    n: [
      "yin yang"
    ],
    u: "262f-fe0f",
    a: "0.7"
  },
  {
    n: [
      "latin cross"
    ],
    u: "271d-fe0f",
    a: "0.7"
  },
  {
    n: [
      "orthodox cross"
    ],
    u: "2626-fe0f",
    a: "1.0"
  },
  {
    n: [
      "star and crescent"
    ],
    u: "262a-fe0f",
    a: "0.7"
  },
  {
    n: [
      "peace symbol"
    ],
    u: "262e-fe0f",
    a: "1.0"
  },
  {
    n: [
      "menorah with nine branches"
    ],
    u: "1f54e",
    a: "1.0"
  },
  {
    n: [
      "six pointed star",
      "six pointed star with middle dot"
    ],
    u: "1f52f",
    a: "0.6"
  },
  {
    n: [
      "aries"
    ],
    u: "2648",
    a: "0.6"
  },
  {
    n: [
      "taurus"
    ],
    u: "2649",
    a: "0.6"
  },
  {
    n: [
      "gemini"
    ],
    u: "264a",
    a: "0.6"
  },
  {
    n: [
      "cancer"
    ],
    u: "264b",
    a: "0.6"
  },
  {
    n: [
      "leo"
    ],
    u: "264c",
    a: "0.6"
  },
  {
    n: [
      "virgo"
    ],
    u: "264d",
    a: "0.6"
  },
  {
    n: [
      "libra"
    ],
    u: "264e",
    a: "0.6"
  },
  {
    n: [
      "scorpius"
    ],
    u: "264f",
    a: "0.6"
  },
  {
    n: [
      "sagittarius"
    ],
    u: "2650",
    a: "0.6"
  },
  {
    n: [
      "capricorn"
    ],
    u: "2651",
    a: "0.6"
  },
  {
    n: [
      "aquarius"
    ],
    u: "2652",
    a: "0.6"
  },
  {
    n: [
      "pisces"
    ],
    u: "2653",
    a: "0.6"
  },
  {
    n: [
      "ophiuchus"
    ],
    u: "26ce",
    a: "0.6"
  },
  {
    n: [
      "twisted rightwards arrows"
    ],
    u: "1f500",
    a: "1.0"
  },
  {
    n: [
      "repeat",
      "clockwise rightwards and leftwards open circle arrows"
    ],
    u: "1f501",
    a: "1.0"
  },
  {
    n: [
      "repeat one",
      "clockwise rightwards and leftwards open circle arrows with circled one overlay"
    ],
    u: "1f502",
    a: "1.0"
  },
  {
    n: [
      "arrow forward",
      "black right-pointing triangle"
    ],
    u: "25b6-fe0f",
    a: "0.6"
  },
  {
    n: [
      "fast forward",
      "black right-pointing double triangle"
    ],
    u: "23e9",
    a: "0.6"
  },
  {
    n: [
      "next track button",
      "black right pointing double triangle with vertical bar"
    ],
    u: "23ed-fe0f",
    a: "0.7"
  },
  {
    n: [
      "play or pause button",
      "black right pointing triangle with double vertical bar"
    ],
    u: "23ef-fe0f",
    a: "1.0"
  },
  {
    n: [
      "arrow backward",
      "black left-pointing triangle"
    ],
    u: "25c0-fe0f",
    a: "0.6"
  },
  {
    n: [
      "rewind",
      "black left-pointing double triangle"
    ],
    u: "23ea",
    a: "0.6"
  },
  {
    n: [
      "last track button",
      "black left pointing double triangle with vertical bar"
    ],
    u: "23ee-fe0f",
    a: "0.7"
  },
  {
    n: [
      "arrow up small",
      "up-pointing small red triangle"
    ],
    u: "1f53c",
    a: "0.6"
  },
  {
    n: [
      "arrow double up",
      "black up-pointing double triangle"
    ],
    u: "23eb",
    a: "0.6"
  },
  {
    n: [
      "arrow down small",
      "down-pointing small red triangle"
    ],
    u: "1f53d",
    a: "0.6"
  },
  {
    n: [
      "arrow double down",
      "black down-pointing double triangle"
    ],
    u: "23ec",
    a: "0.6"
  },
  {
    n: [
      "pause button",
      "double vertical bar"
    ],
    u: "23f8-fe0f",
    a: "0.7"
  },
  {
    n: [
      "stop button",
      "black square for stop"
    ],
    u: "23f9-fe0f",
    a: "0.7"
  },
  {
    n: [
      "record button",
      "black circle for record"
    ],
    u: "23fa-fe0f",
    a: "0.7"
  },
  {
    n: [
      "eject",
      "eject button"
    ],
    u: "23cf-fe0f",
    a: "1.0"
  },
  {
    n: [
      "cinema"
    ],
    u: "1f3a6",
    a: "0.6"
  },
  {
    n: [
      "low brightness",
      "low brightness symbol"
    ],
    u: "1f505",
    a: "1.0"
  },
  {
    n: [
      "high brightness",
      "high brightness symbol"
    ],
    u: "1f506",
    a: "1.0"
  },
  {
    n: [
      "signal strength",
      "antenna with bars"
    ],
    u: "1f4f6",
    a: "0.6"
  },
  {
    n: [
      "vibration mode"
    ],
    u: "1f4f3",
    a: "0.6"
  },
  {
    n: [
      "mobile phone off"
    ],
    u: "1f4f4",
    a: "0.6"
  },
  {
    n: [
      "female sign"
    ],
    u: "2640-fe0f",
    a: "4.0"
  },
  {
    n: [
      "male sign"
    ],
    u: "2642-fe0f",
    a: "4.0"
  },
  {
    n: [
      "transgender symbol"
    ],
    u: "26a7-fe0f",
    a: "13.0"
  },
  {
    n: [
      "heavy multiplication x"
    ],
    u: "2716-fe0f",
    a: "0.6"
  },
  {
    n: [
      "heavy plus sign"
    ],
    u: "2795",
    a: "0.6"
  },
  {
    n: [
      "heavy minus sign"
    ],
    u: "2796",
    a: "0.6"
  },
  {
    n: [
      "heavy division sign"
    ],
    u: "2797",
    a: "0.6"
  },
  {
    n: [
      "heavy equals sign"
    ],
    u: "1f7f0",
    a: "14.0"
  },
  {
    n: [
      "infinity"
    ],
    u: "267e-fe0f",
    a: "11.0"
  },
  {
    n: [
      "bangbang",
      "double exclamation mark"
    ],
    u: "203c-fe0f",
    a: "0.6"
  },
  {
    n: [
      "interrobang",
      "exclamation question mark"
    ],
    u: "2049-fe0f",
    a: "0.6"
  },
  {
    n: [
      "question",
      "black question mark ornament"
    ],
    u: "2753",
    a: "0.6"
  },
  {
    n: [
      "grey question",
      "white question mark ornament"
    ],
    u: "2754",
    a: "0.6"
  },
  {
    n: [
      "grey exclamation",
      "white exclamation mark ornament"
    ],
    u: "2755",
    a: "0.6"
  },
  {
    n: [
      "exclamation",
      "heavy exclamation mark",
      "heavy exclamation mark symbol"
    ],
    u: "2757",
    a: "0.6"
  },
  {
    n: [
      "wavy dash"
    ],
    u: "3030-fe0f",
    a: "0.6"
  },
  {
    n: [
      "currency exchange"
    ],
    u: "1f4b1",
    a: "0.6"
  },
  {
    n: [
      "heavy dollar sign"
    ],
    u: "1f4b2",
    a: "0.6"
  },
  {
    n: [
      "medical symbol",
      "staff of aesculapius"
    ],
    u: "2695-fe0f",
    a: "4.0"
  },
  {
    n: [
      "recycle",
      "black universal recycling symbol"
    ],
    u: "267b-fe0f",
    a: "0.6"
  },
  {
    n: [
      "fleur-de-lis",
      "fleur de lis"
    ],
    u: "269c-fe0f",
    a: "1.0"
  },
  {
    n: [
      "trident",
      "trident emblem"
    ],
    u: "1f531",
    a: "0.6"
  },
  {
    n: [
      "name badge"
    ],
    u: "1f4db",
    a: "0.6"
  },
  {
    n: [
      "beginner",
      "japanese symbol for beginner"
    ],
    u: "1f530",
    a: "0.6"
  },
  {
    n: [
      "o",
      "heavy large circle"
    ],
    u: "2b55",
    a: "0.6"
  },
  {
    n: [
      "white check mark",
      "white heavy check mark"
    ],
    u: "2705",
    a: "0.6"
  },
  {
    n: [
      "ballot box with check"
    ],
    u: "2611-fe0f",
    a: "0.6"
  },
  {
    n: [
      "heavy check mark"
    ],
    u: "2714-fe0f",
    a: "0.6"
  },
  {
    n: [
      "x",
      "cross mark"
    ],
    u: "274c",
    a: "0.6"
  },
  {
    n: [
      "negative squared cross mark"
    ],
    u: "274e",
    a: "0.6"
  },
  {
    n: [
      "curly loop"
    ],
    u: "27b0",
    a: "0.6"
  },
  {
    n: [
      "loop",
      "double curly loop"
    ],
    u: "27bf",
    a: "1.0"
  },
  {
    n: [
      "part alternation mark"
    ],
    u: "303d-fe0f",
    a: "0.6"
  },
  {
    n: [
      "eight spoked asterisk"
    ],
    u: "2733-fe0f",
    a: "0.6"
  },
  {
    n: [
      "eight pointed black star"
    ],
    u: "2734-fe0f",
    a: "0.6"
  },
  {
    n: [
      "sparkle"
    ],
    u: "2747-fe0f",
    a: "0.6"
  },
  {
    n: [
      "copyright",
      "copyright sign"
    ],
    u: "00a9-fe0f",
    a: "0.6"
  },
  {
    n: [
      "registered",
      "registered sign"
    ],
    u: "00ae-fe0f",
    a: "0.6"
  },
  {
    n: [
      "tm",
      "trade mark sign"
    ],
    u: "2122-fe0f",
    a: "0.6"
  },
  {
    n: [
      "hash",
      "hash key"
    ],
    u: "0023-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "keycap: *",
      "keycap star"
    ],
    u: "002a-fe0f-20e3",
    a: "2.0"
  },
  {
    n: [
      "zero",
      "keycap 0"
    ],
    u: "0030-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "one",
      "keycap 1"
    ],
    u: "0031-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "two",
      "keycap 2"
    ],
    u: "0032-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "three",
      "keycap 3"
    ],
    u: "0033-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "four",
      "keycap 4"
    ],
    u: "0034-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "five",
      "keycap 5"
    ],
    u: "0035-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "six",
      "keycap 6"
    ],
    u: "0036-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "seven",
      "keycap 7"
    ],
    u: "0037-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "eight",
      "keycap 8"
    ],
    u: "0038-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "nine",
      "keycap 9"
    ],
    u: "0039-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "keycap ten"
    ],
    u: "1f51f",
    a: "0.6"
  },
  {
    n: [
      "capital abcd",
      "input symbol for latin capital letters"
    ],
    u: "1f520",
    a: "0.6"
  },
  {
    n: [
      "abcd",
      "input symbol for latin small letters"
    ],
    u: "1f521",
    a: "0.6"
  },
  {
    n: [
      "1234",
      "input symbol for numbers"
    ],
    u: "1f522",
    a: "0.6"
  },
  {
    n: [
      "symbols",
      "input symbol for symbols"
    ],
    u: "1f523",
    a: "0.6"
  },
  {
    n: [
      "abc",
      "input symbol for latin letters"
    ],
    u: "1f524",
    a: "0.6"
  },
  {
    n: [
      "a",
      "negative squared latin capital letter a"
    ],
    u: "1f170-fe0f",
    a: "0.6"
  },
  {
    n: [
      "ab",
      "negative squared ab"
    ],
    u: "1f18e",
    a: "0.6"
  },
  {
    n: [
      "b",
      "negative squared latin capital letter b"
    ],
    u: "1f171-fe0f",
    a: "0.6"
  },
  {
    n: [
      "cl",
      "squared cl"
    ],
    u: "1f191",
    a: "0.6"
  },
  {
    n: [
      "cool",
      "squared cool"
    ],
    u: "1f192",
    a: "0.6"
  },
  {
    n: [
      "free",
      "squared free"
    ],
    u: "1f193",
    a: "0.6"
  },
  {
    n: [
      "information source"
    ],
    u: "2139-fe0f",
    a: "0.6"
  },
  {
    n: [
      "id",
      "squared id"
    ],
    u: "1f194",
    a: "0.6"
  },
  {
    n: [
      "m",
      "circled latin capital letter m"
    ],
    u: "24c2-fe0f",
    a: "0.6"
  },
  {
    n: [
      "new",
      "squared new"
    ],
    u: "1f195",
    a: "0.6"
  },
  {
    n: [
      "ng",
      "squared ng"
    ],
    u: "1f196",
    a: "0.6"
  },
  {
    n: [
      "o2",
      "negative squared latin capital letter o"
    ],
    u: "1f17e-fe0f",
    a: "0.6"
  },
  {
    n: [
      "ok",
      "squared ok"
    ],
    u: "1f197",
    a: "0.6"
  },
  {
    n: [
      "parking",
      "negative squared latin capital letter p"
    ],
    u: "1f17f-fe0f",
    a: "0.6"
  },
  {
    n: [
      "sos",
      "squared sos"
    ],
    u: "1f198",
    a: "0.6"
  },
  {
    n: [
      "up",
      "squared up with exclamation mark"
    ],
    u: "1f199",
    a: "0.6"
  },
  {
    n: [
      "vs",
      "squared vs"
    ],
    u: "1f19a",
    a: "0.6"
  },
  {
    n: [
      "koko",
      "squared katakana koko"
    ],
    u: "1f201",
    a: "0.6"
  },
  {
    n: [
      "sa",
      "squared katakana sa"
    ],
    u: "1f202-fe0f",
    a: "0.6"
  },
  {
    n: [
      "u6708",
      "squared cjk unified ideograph-6708"
    ],
    u: "1f237-fe0f",
    a: "0.6"
  },
  {
    n: [
      "u6709",
      "squared cjk unified ideograph-6709"
    ],
    u: "1f236",
    a: "0.6"
  },
  {
    n: [
      "u6307",
      "squared cjk unified ideograph-6307"
    ],
    u: "1f22f",
    a: "0.6"
  },
  {
    n: [
      "ideograph advantage",
      "circled ideograph advantage"
    ],
    u: "1f250",
    a: "0.6"
  },
  {
    n: [
      "u5272",
      "squared cjk unified ideograph-5272"
    ],
    u: "1f239",
    a: "0.6"
  },
  {
    n: [
      "u7121",
      "squared cjk unified ideograph-7121"
    ],
    u: "1f21a",
    a: "0.6"
  },
  {
    n: [
      "u7981",
      "squared cjk unified ideograph-7981"
    ],
    u: "1f232",
    a: "0.6"
  },
  {
    n: [
      "accept",
      "circled ideograph accept"
    ],
    u: "1f251",
    a: "0.6"
  },
  {
    n: [
      "u7533",
      "squared cjk unified ideograph-7533"
    ],
    u: "1f238",
    a: "0.6"
  },
  {
    n: [
      "u5408",
      "squared cjk unified ideograph-5408"
    ],
    u: "1f234",
    a: "0.6"
  },
  {
    n: [
      "u7a7a",
      "squared cjk unified ideograph-7a7a"
    ],
    u: "1f233",
    a: "0.6"
  },
  {
    n: [
      "congratulations",
      "circled ideograph congratulation"
    ],
    u: "3297-fe0f",
    a: "0.6"
  },
  {
    n: [
      "secret",
      "circled ideograph secret"
    ],
    u: "3299-fe0f",
    a: "0.6"
  },
  {
    n: [
      "u55b6",
      "squared cjk unified ideograph-55b6"
    ],
    u: "1f23a",
    a: "0.6"
  },
  {
    n: [
      "u6e80",
      "squared cjk unified ideograph-6e80"
    ],
    u: "1f235",
    a: "0.6"
  },
  {
    n: [
      "red circle",
      "large red circle"
    ],
    u: "1f534",
    a: "0.6"
  },
  {
    n: [
      "large orange circle"
    ],
    u: "1f7e0",
    a: "12.0"
  },
  {
    n: [
      "large yellow circle"
    ],
    u: "1f7e1",
    a: "12.0"
  },
  {
    n: [
      "large green circle"
    ],
    u: "1f7e2",
    a: "12.0"
  },
  {
    n: [
      "large blue circle"
    ],
    u: "1f535",
    a: "0.6"
  },
  {
    n: [
      "large purple circle"
    ],
    u: "1f7e3",
    a: "12.0"
  },
  {
    n: [
      "large brown circle"
    ],
    u: "1f7e4",
    a: "12.0"
  },
  {
    n: [
      "black circle",
      "medium black circle"
    ],
    u: "26ab",
    a: "0.6"
  },
  {
    n: [
      "white circle",
      "medium white circle"
    ],
    u: "26aa",
    a: "0.6"
  },
  {
    n: [
      "large red square"
    ],
    u: "1f7e5",
    a: "12.0"
  },
  {
    n: [
      "large orange square"
    ],
    u: "1f7e7",
    a: "12.0"
  },
  {
    n: [
      "large yellow square"
    ],
    u: "1f7e8",
    a: "12.0"
  },
  {
    n: [
      "large green square"
    ],
    u: "1f7e9",
    a: "12.0"
  },
  {
    n: [
      "large blue square"
    ],
    u: "1f7e6",
    a: "12.0"
  },
  {
    n: [
      "large purple square"
    ],
    u: "1f7ea",
    a: "12.0"
  },
  {
    n: [
      "large brown square"
    ],
    u: "1f7eb",
    a: "12.0"
  },
  {
    n: [
      "black large square"
    ],
    u: "2b1b",
    a: "0.6"
  },
  {
    n: [
      "white large square"
    ],
    u: "2b1c",
    a: "0.6"
  },
  {
    n: [
      "black medium square"
    ],
    u: "25fc-fe0f",
    a: "0.6"
  },
  {
    n: [
      "white medium square"
    ],
    u: "25fb-fe0f",
    a: "0.6"
  },
  {
    n: [
      "black medium small square"
    ],
    u: "25fe",
    a: "0.6"
  },
  {
    n: [
      "white medium small square"
    ],
    u: "25fd",
    a: "0.6"
  },
  {
    n: [
      "black small square"
    ],
    u: "25aa-fe0f",
    a: "0.6"
  },
  {
    n: [
      "white small square"
    ],
    u: "25ab-fe0f",
    a: "0.6"
  },
  {
    n: [
      "large orange diamond"
    ],
    u: "1f536",
    a: "0.6"
  },
  {
    n: [
      "large blue diamond"
    ],
    u: "1f537",
    a: "0.6"
  },
  {
    n: [
      "small orange diamond"
    ],
    u: "1f538",
    a: "0.6"
  },
  {
    n: [
      "small blue diamond"
    ],
    u: "1f539",
    a: "0.6"
  },
  {
    n: [
      "small red triangle",
      "up-pointing red triangle"
    ],
    u: "1f53a",
    a: "0.6"
  },
  {
    n: [
      "small red triangle down",
      "down-pointing red triangle"
    ],
    u: "1f53b",
    a: "0.6"
  },
  {
    n: [
      "diamond shape with a dot inside"
    ],
    u: "1f4a0",
    a: "0.6"
  },
  {
    n: [
      "radio button"
    ],
    u: "1f518",
    a: "0.6"
  },
  {
    n: [
      "white square button"
    ],
    u: "1f533",
    a: "0.6"
  },
  {
    n: [
      "black square button"
    ],
    u: "1f532",
    a: "0.6"
  }
], tge = [
  {
    n: [
      "chequered flag",
      "checkered flag"
    ],
    u: "1f3c1",
    a: "0.6"
  },
  {
    n: [
      "triangular flag on post"
    ],
    u: "1f6a9",
    a: "0.6"
  },
  {
    n: [
      "crossed flags"
    ],
    u: "1f38c",
    a: "0.6"
  },
  {
    n: [
      "waving black flag"
    ],
    u: "1f3f4",
    a: "1.0"
  },
  {
    n: [
      "white flag",
      "waving white flag"
    ],
    u: "1f3f3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "rainbow flag",
      "rainbow-flag"
    ],
    u: "1f3f3-fe0f-200d-1f308",
    a: "4.0"
  },
  {
    n: [
      "transgender flag"
    ],
    u: "1f3f3-fe0f-200d-26a7-fe0f",
    a: "13.0"
  },
  {
    n: [
      "pirate flag"
    ],
    u: "1f3f4-200d-2620-fe0f",
    a: "11.0"
  },
  {
    n: [
      "flag-ac",
      "ascension island flag"
    ],
    u: "1f1e6-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-ad",
      "andorra flag"
    ],
    u: "1f1e6-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-ae",
      "united arab emirates flag"
    ],
    u: "1f1e6-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-af",
      "afghanistan flag"
    ],
    u: "1f1e6-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-ag",
      "antigua & barbuda flag"
    ],
    u: "1f1e6-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-ai",
      "anguilla flag"
    ],
    u: "1f1e6-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-al",
      "albania flag"
    ],
    u: "1f1e6-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-am",
      "armenia flag"
    ],
    u: "1f1e6-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-ao",
      "angola flag"
    ],
    u: "1f1e6-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-aq",
      "antarctica flag"
    ],
    u: "1f1e6-1f1f6",
    a: "2.0"
  },
  {
    n: [
      "flag-ar",
      "argentina flag"
    ],
    u: "1f1e6-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-as",
      "american samoa flag"
    ],
    u: "1f1e6-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-at",
      "austria flag"
    ],
    u: "1f1e6-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-au",
      "australia flag"
    ],
    u: "1f1e6-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-aw",
      "aruba flag"
    ],
    u: "1f1e6-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-ax",
      "åland islands flag"
    ],
    u: "1f1e6-1f1fd",
    a: "2.0"
  },
  {
    n: [
      "flag-az",
      "azerbaijan flag"
    ],
    u: "1f1e6-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-ba",
      "bosnia & herzegovina flag"
    ],
    u: "1f1e7-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-bb",
      "barbados flag"
    ],
    u: "1f1e7-1f1e7",
    a: "2.0"
  },
  {
    n: [
      "flag-bd",
      "bangladesh flag"
    ],
    u: "1f1e7-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-be",
      "belgium flag"
    ],
    u: "1f1e7-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-bf",
      "burkina faso flag"
    ],
    u: "1f1e7-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-bg",
      "bulgaria flag"
    ],
    u: "1f1e7-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-bh",
      "bahrain flag"
    ],
    u: "1f1e7-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-bi",
      "burundi flag"
    ],
    u: "1f1e7-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-bj",
      "benin flag"
    ],
    u: "1f1e7-1f1ef",
    a: "2.0"
  },
  {
    n: [
      "flag-bl",
      "st. barthélemy flag"
    ],
    u: "1f1e7-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-bm",
      "bermuda flag"
    ],
    u: "1f1e7-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-bn",
      "brunei flag"
    ],
    u: "1f1e7-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-bo",
      "bolivia flag"
    ],
    u: "1f1e7-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-bq",
      "caribbean netherlands flag"
    ],
    u: "1f1e7-1f1f6",
    a: "2.0"
  },
  {
    n: [
      "flag-br",
      "brazil flag"
    ],
    u: "1f1e7-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-bs",
      "bahamas flag"
    ],
    u: "1f1e7-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-bt",
      "bhutan flag"
    ],
    u: "1f1e7-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-bv",
      "bouvet island flag"
    ],
    u: "1f1e7-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-bw",
      "botswana flag"
    ],
    u: "1f1e7-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-by",
      "belarus flag"
    ],
    u: "1f1e7-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-bz",
      "belize flag"
    ],
    u: "1f1e7-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-ca",
      "canada flag"
    ],
    u: "1f1e8-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-cc",
      "cocos (keeling) islands flag"
    ],
    u: "1f1e8-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-cd",
      "congo - kinshasa flag"
    ],
    u: "1f1e8-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-cf",
      "central african republic flag"
    ],
    u: "1f1e8-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-cg",
      "congo - brazzaville flag"
    ],
    u: "1f1e8-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-ch",
      "switzerland flag"
    ],
    u: "1f1e8-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-ci",
      "côte d’ivoire flag"
    ],
    u: "1f1e8-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-ck",
      "cook islands flag"
    ],
    u: "1f1e8-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-cl",
      "chile flag"
    ],
    u: "1f1e8-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-cm",
      "cameroon flag"
    ],
    u: "1f1e8-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "cn",
      "flag-cn",
      "china flag"
    ],
    u: "1f1e8-1f1f3",
    a: "0.6"
  },
  {
    n: [
      "flag-co",
      "colombia flag"
    ],
    u: "1f1e8-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-cp",
      "clipperton island flag"
    ],
    u: "1f1e8-1f1f5",
    a: "2.0"
  },
  {
    n: [
      "flag-cr",
      "costa rica flag"
    ],
    u: "1f1e8-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-cu",
      "cuba flag"
    ],
    u: "1f1e8-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-cv",
      "cape verde flag"
    ],
    u: "1f1e8-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-cw",
      "curaçao flag"
    ],
    u: "1f1e8-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-cx",
      "christmas island flag"
    ],
    u: "1f1e8-1f1fd",
    a: "2.0"
  },
  {
    n: [
      "flag-cy",
      "cyprus flag"
    ],
    u: "1f1e8-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-cz",
      "czechia flag"
    ],
    u: "1f1e8-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "de",
      "flag-de",
      "germany flag"
    ],
    u: "1f1e9-1f1ea",
    a: "0.6"
  },
  {
    n: [
      "flag-dg",
      "diego garcia flag"
    ],
    u: "1f1e9-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-dj",
      "djibouti flag"
    ],
    u: "1f1e9-1f1ef",
    a: "2.0"
  },
  {
    n: [
      "flag-dk",
      "denmark flag"
    ],
    u: "1f1e9-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-dm",
      "dominica flag"
    ],
    u: "1f1e9-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-do",
      "dominican republic flag"
    ],
    u: "1f1e9-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-dz",
      "algeria flag"
    ],
    u: "1f1e9-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-ea",
      "ceuta & melilla flag"
    ],
    u: "1f1ea-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-ec",
      "ecuador flag"
    ],
    u: "1f1ea-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-ee",
      "estonia flag"
    ],
    u: "1f1ea-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-eg",
      "egypt flag"
    ],
    u: "1f1ea-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-eh",
      "western sahara flag"
    ],
    u: "1f1ea-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-er",
      "eritrea flag"
    ],
    u: "1f1ea-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "es",
      "flag-es",
      "spain flag"
    ],
    u: "1f1ea-1f1f8",
    a: "0.6"
  },
  {
    n: [
      "flag-et",
      "ethiopia flag"
    ],
    u: "1f1ea-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-eu",
      "european union flag"
    ],
    u: "1f1ea-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-fi",
      "finland flag"
    ],
    u: "1f1eb-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-fj",
      "fiji flag"
    ],
    u: "1f1eb-1f1ef",
    a: "2.0"
  },
  {
    n: [
      "flag-fk",
      "falkland islands flag"
    ],
    u: "1f1eb-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-fm",
      "micronesia flag"
    ],
    u: "1f1eb-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-fo",
      "faroe islands flag"
    ],
    u: "1f1eb-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "fr",
      "flag-fr",
      "france flag"
    ],
    u: "1f1eb-1f1f7",
    a: "0.6"
  },
  {
    n: [
      "flag-ga",
      "gabon flag"
    ],
    u: "1f1ec-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "gb",
      "uk",
      "flag-gb",
      "united kingdom flag"
    ],
    u: "1f1ec-1f1e7",
    a: "0.6"
  },
  {
    n: [
      "flag-gd",
      "grenada flag"
    ],
    u: "1f1ec-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-ge",
      "georgia flag"
    ],
    u: "1f1ec-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-gf",
      "french guiana flag"
    ],
    u: "1f1ec-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-gg",
      "guernsey flag"
    ],
    u: "1f1ec-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-gh",
      "ghana flag"
    ],
    u: "1f1ec-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-gi",
      "gibraltar flag"
    ],
    u: "1f1ec-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-gl",
      "greenland flag"
    ],
    u: "1f1ec-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-gm",
      "gambia flag"
    ],
    u: "1f1ec-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-gn",
      "guinea flag"
    ],
    u: "1f1ec-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-gp",
      "guadeloupe flag"
    ],
    u: "1f1ec-1f1f5",
    a: "2.0"
  },
  {
    n: [
      "flag-gq",
      "equatorial guinea flag"
    ],
    u: "1f1ec-1f1f6",
    a: "2.0"
  },
  {
    n: [
      "flag-gr",
      "greece flag"
    ],
    u: "1f1ec-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-gs",
      "south georgia & south sandwich islands flag"
    ],
    u: "1f1ec-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-gt",
      "guatemala flag"
    ],
    u: "1f1ec-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-gu",
      "guam flag"
    ],
    u: "1f1ec-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-gw",
      "guinea-bissau flag"
    ],
    u: "1f1ec-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-gy",
      "guyana flag"
    ],
    u: "1f1ec-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-hk",
      "hong kong sar china flag"
    ],
    u: "1f1ed-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-hm",
      "heard & mcdonald islands flag"
    ],
    u: "1f1ed-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-hn",
      "honduras flag"
    ],
    u: "1f1ed-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-hr",
      "croatia flag"
    ],
    u: "1f1ed-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-ht",
      "haiti flag"
    ],
    u: "1f1ed-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-hu",
      "hungary flag"
    ],
    u: "1f1ed-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-ic",
      "canary islands flag"
    ],
    u: "1f1ee-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-id",
      "indonesia flag"
    ],
    u: "1f1ee-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-ie",
      "ireland flag"
    ],
    u: "1f1ee-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-il",
      "israel flag"
    ],
    u: "1f1ee-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-im",
      "isle of man flag"
    ],
    u: "1f1ee-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-in",
      "india flag"
    ],
    u: "1f1ee-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-io",
      "british indian ocean territory flag"
    ],
    u: "1f1ee-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-iq",
      "iraq flag"
    ],
    u: "1f1ee-1f1f6",
    a: "2.0"
  },
  {
    n: [
      "flag-ir",
      "iran flag"
    ],
    u: "1f1ee-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-is",
      "iceland flag"
    ],
    u: "1f1ee-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "it",
      "flag-it",
      "italy flag"
    ],
    u: "1f1ee-1f1f9",
    a: "0.6"
  },
  {
    n: [
      "flag-je",
      "jersey flag"
    ],
    u: "1f1ef-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-jm",
      "jamaica flag"
    ],
    u: "1f1ef-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-jo",
      "jordan flag"
    ],
    u: "1f1ef-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "jp",
      "flag-jp",
      "japan flag"
    ],
    u: "1f1ef-1f1f5",
    a: "0.6"
  },
  {
    n: [
      "flag-ke",
      "kenya flag"
    ],
    u: "1f1f0-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-kg",
      "kyrgyzstan flag"
    ],
    u: "1f1f0-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-kh",
      "cambodia flag"
    ],
    u: "1f1f0-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-ki",
      "kiribati flag"
    ],
    u: "1f1f0-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-km",
      "comoros flag"
    ],
    u: "1f1f0-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-kn",
      "st. kitts & nevis flag"
    ],
    u: "1f1f0-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-kp",
      "north korea flag"
    ],
    u: "1f1f0-1f1f5",
    a: "2.0"
  },
  {
    n: [
      "kr",
      "flag-kr",
      "south korea flag"
    ],
    u: "1f1f0-1f1f7",
    a: "0.6"
  },
  {
    n: [
      "flag-kw",
      "kuwait flag"
    ],
    u: "1f1f0-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-ky",
      "cayman islands flag"
    ],
    u: "1f1f0-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-kz",
      "kazakhstan flag"
    ],
    u: "1f1f0-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-la",
      "laos flag"
    ],
    u: "1f1f1-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-lb",
      "lebanon flag"
    ],
    u: "1f1f1-1f1e7",
    a: "2.0"
  },
  {
    n: [
      "flag-lc",
      "st. lucia flag"
    ],
    u: "1f1f1-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-li",
      "liechtenstein flag"
    ],
    u: "1f1f1-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-lk",
      "sri lanka flag"
    ],
    u: "1f1f1-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-lr",
      "liberia flag"
    ],
    u: "1f1f1-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-ls",
      "lesotho flag"
    ],
    u: "1f1f1-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-lt",
      "lithuania flag"
    ],
    u: "1f1f1-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-lu",
      "luxembourg flag"
    ],
    u: "1f1f1-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-lv",
      "latvia flag"
    ],
    u: "1f1f1-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-ly",
      "libya flag"
    ],
    u: "1f1f1-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-ma",
      "morocco flag"
    ],
    u: "1f1f2-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-mc",
      "monaco flag"
    ],
    u: "1f1f2-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-md",
      "moldova flag"
    ],
    u: "1f1f2-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-me",
      "montenegro flag"
    ],
    u: "1f1f2-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-mf",
      "st. martin flag"
    ],
    u: "1f1f2-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-mg",
      "madagascar flag"
    ],
    u: "1f1f2-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-mh",
      "marshall islands flag"
    ],
    u: "1f1f2-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-mk",
      "north macedonia flag"
    ],
    u: "1f1f2-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-ml",
      "mali flag"
    ],
    u: "1f1f2-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-mm",
      "myanmar (burma) flag"
    ],
    u: "1f1f2-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-mn",
      "mongolia flag"
    ],
    u: "1f1f2-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-mo",
      "macao sar china flag"
    ],
    u: "1f1f2-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-mp",
      "northern mariana islands flag"
    ],
    u: "1f1f2-1f1f5",
    a: "2.0"
  },
  {
    n: [
      "flag-mq",
      "martinique flag"
    ],
    u: "1f1f2-1f1f6",
    a: "2.0"
  },
  {
    n: [
      "flag-mr",
      "mauritania flag"
    ],
    u: "1f1f2-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-ms",
      "montserrat flag"
    ],
    u: "1f1f2-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-mt",
      "malta flag"
    ],
    u: "1f1f2-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-mu",
      "mauritius flag"
    ],
    u: "1f1f2-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-mv",
      "maldives flag"
    ],
    u: "1f1f2-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-mw",
      "malawi flag"
    ],
    u: "1f1f2-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-mx",
      "mexico flag"
    ],
    u: "1f1f2-1f1fd",
    a: "2.0"
  },
  {
    n: [
      "flag-my",
      "malaysia flag"
    ],
    u: "1f1f2-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-mz",
      "mozambique flag"
    ],
    u: "1f1f2-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-na",
      "namibia flag"
    ],
    u: "1f1f3-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-nc",
      "new caledonia flag"
    ],
    u: "1f1f3-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-ne",
      "niger flag"
    ],
    u: "1f1f3-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-nf",
      "norfolk island flag"
    ],
    u: "1f1f3-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-ng",
      "nigeria flag"
    ],
    u: "1f1f3-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-ni",
      "nicaragua flag"
    ],
    u: "1f1f3-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-nl",
      "netherlands flag"
    ],
    u: "1f1f3-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-no",
      "norway flag"
    ],
    u: "1f1f3-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-np",
      "nepal flag"
    ],
    u: "1f1f3-1f1f5",
    a: "2.0"
  },
  {
    n: [
      "flag-nr",
      "nauru flag"
    ],
    u: "1f1f3-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-nu",
      "niue flag"
    ],
    u: "1f1f3-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-nz",
      "new zealand flag"
    ],
    u: "1f1f3-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-om",
      "oman flag"
    ],
    u: "1f1f4-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-pa",
      "panama flag"
    ],
    u: "1f1f5-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-pe",
      "peru flag"
    ],
    u: "1f1f5-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-pf",
      "french polynesia flag"
    ],
    u: "1f1f5-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-pg",
      "papua new guinea flag"
    ],
    u: "1f1f5-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-ph",
      "philippines flag"
    ],
    u: "1f1f5-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-pk",
      "pakistan flag"
    ],
    u: "1f1f5-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-pl",
      "poland flag"
    ],
    u: "1f1f5-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-pm",
      "st. pierre & miquelon flag"
    ],
    u: "1f1f5-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-pn",
      "pitcairn islands flag"
    ],
    u: "1f1f5-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-pr",
      "puerto rico flag"
    ],
    u: "1f1f5-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-ps",
      "palestinian territories flag"
    ],
    u: "1f1f5-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-pt",
      "portugal flag"
    ],
    u: "1f1f5-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-pw",
      "palau flag"
    ],
    u: "1f1f5-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-py",
      "paraguay flag"
    ],
    u: "1f1f5-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-qa",
      "qatar flag"
    ],
    u: "1f1f6-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-re",
      "réunion flag"
    ],
    u: "1f1f7-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-ro",
      "romania flag"
    ],
    u: "1f1f7-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-rs",
      "serbia flag"
    ],
    u: "1f1f7-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "ru",
      "flag-ru",
      "russia flag"
    ],
    u: "1f1f7-1f1fa",
    a: "0.6"
  },
  {
    n: [
      "flag-rw",
      "rwanda flag"
    ],
    u: "1f1f7-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-sa",
      "saudi arabia flag"
    ],
    u: "1f1f8-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-sb",
      "solomon islands flag"
    ],
    u: "1f1f8-1f1e7",
    a: "2.0"
  },
  {
    n: [
      "flag-sc",
      "seychelles flag"
    ],
    u: "1f1f8-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-sd",
      "sudan flag"
    ],
    u: "1f1f8-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-se",
      "sweden flag"
    ],
    u: "1f1f8-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-sg",
      "singapore flag"
    ],
    u: "1f1f8-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-sh",
      "st. helena flag"
    ],
    u: "1f1f8-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-si",
      "slovenia flag"
    ],
    u: "1f1f8-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-sj",
      "svalbard & jan mayen flag"
    ],
    u: "1f1f8-1f1ef",
    a: "2.0"
  },
  {
    n: [
      "flag-sk",
      "slovakia flag"
    ],
    u: "1f1f8-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-sl",
      "sierra leone flag"
    ],
    u: "1f1f8-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-sm",
      "san marino flag"
    ],
    u: "1f1f8-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-sn",
      "senegal flag"
    ],
    u: "1f1f8-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-so",
      "somalia flag"
    ],
    u: "1f1f8-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-sr",
      "suriname flag"
    ],
    u: "1f1f8-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-ss",
      "south sudan flag"
    ],
    u: "1f1f8-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-st",
      "são tomé & príncipe flag"
    ],
    u: "1f1f8-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-sv",
      "el salvador flag"
    ],
    u: "1f1f8-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-sx",
      "sint maarten flag"
    ],
    u: "1f1f8-1f1fd",
    a: "2.0"
  },
  {
    n: [
      "flag-sy",
      "syria flag"
    ],
    u: "1f1f8-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-sz",
      "eswatini flag"
    ],
    u: "1f1f8-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-ta",
      "tristan da cunha flag"
    ],
    u: "1f1f9-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-tc",
      "turks & caicos islands flag"
    ],
    u: "1f1f9-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-td",
      "chad flag"
    ],
    u: "1f1f9-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-tf",
      "french southern territories flag"
    ],
    u: "1f1f9-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-tg",
      "togo flag"
    ],
    u: "1f1f9-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-th",
      "thailand flag"
    ],
    u: "1f1f9-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-tj",
      "tajikistan flag"
    ],
    u: "1f1f9-1f1ef",
    a: "2.0"
  },
  {
    n: [
      "flag-tk",
      "tokelau flag"
    ],
    u: "1f1f9-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-tl",
      "timor-leste flag"
    ],
    u: "1f1f9-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-tm",
      "turkmenistan flag"
    ],
    u: "1f1f9-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-tn",
      "tunisia flag"
    ],
    u: "1f1f9-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-to",
      "tonga flag"
    ],
    u: "1f1f9-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-tr",
      "turkey flag"
    ],
    u: "1f1f9-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-tt",
      "trinidad & tobago flag"
    ],
    u: "1f1f9-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-tv",
      "tuvalu flag"
    ],
    u: "1f1f9-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-tw",
      "taiwan flag"
    ],
    u: "1f1f9-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-tz",
      "tanzania flag"
    ],
    u: "1f1f9-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-ua",
      "ukraine flag"
    ],
    u: "1f1fa-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-ug",
      "uganda flag"
    ],
    u: "1f1fa-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-um",
      "u.s. outlying islands flag"
    ],
    u: "1f1fa-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-un",
      "united nations flag"
    ],
    u: "1f1fa-1f1f3",
    a: "4.0"
  },
  {
    n: [
      "us",
      "flag-us",
      "united states flag"
    ],
    u: "1f1fa-1f1f8",
    a: "0.6"
  },
  {
    n: [
      "flag-uy",
      "uruguay flag"
    ],
    u: "1f1fa-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-uz",
      "uzbekistan flag"
    ],
    u: "1f1fa-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-va",
      "vatican city flag"
    ],
    u: "1f1fb-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-vc",
      "st. vincent & grenadines flag"
    ],
    u: "1f1fb-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-ve",
      "venezuela flag"
    ],
    u: "1f1fb-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-vg",
      "british virgin islands flag"
    ],
    u: "1f1fb-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-vi",
      "u.s. virgin islands flag"
    ],
    u: "1f1fb-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-vn",
      "vietnam flag"
    ],
    u: "1f1fb-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-vu",
      "vanuatu flag"
    ],
    u: "1f1fb-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-wf",
      "wallis & futuna flag"
    ],
    u: "1f1fc-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-ws",
      "samoa flag"
    ],
    u: "1f1fc-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-xk",
      "kosovo flag"
    ],
    u: "1f1fd-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-ye",
      "yemen flag"
    ],
    u: "1f1fe-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-yt",
      "mayotte flag"
    ],
    u: "1f1fe-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-za",
      "south africa flag"
    ],
    u: "1f1ff-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-zm",
      "zambia flag"
    ],
    u: "1f1ff-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-zw",
      "zimbabwe flag"
    ],
    u: "1f1ff-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "england flag",
      "flag-england"
    ],
    u: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
    a: "5.0"
  },
  {
    n: [
      "scotland flag",
      "flag-scotland"
    ],
    u: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
    a: "5.0"
  },
  {
    n: [
      "wales flag",
      "flag-wales"
    ],
    u: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
    a: "5.0"
  }
], xn = {
  custom: Uke,
  smileys_people: Wke,
  animals_nature: Yke,
  food_drink: Qke,
  travel_places: Jke,
  activities: Kke,
  objects: Xke,
  symbols: ege,
  flags: tge
}, Qo = [Tt.NEUTRAL, Tt.LIGHT, Tt.MEDIUM_LIGHT, Tt.MEDIUM, Tt.MEDIUM_DARK, Tt.DARK], age = /* @__PURE__ */ Object.entries(Tt).reduce(function(e, t) {
  var a = t[0], n = t[1];
  return e[n] = a, e;
}, {}), nge = /* @__PURE__ */ Qo.reduce(function(e, t) {
  var a;
  return Object.assign(e, (a = {}, a[t] = t, a));
}, {}), bt;
(function(e) {
  e.name = "n", e.unified = "u", e.variations = "v", e.added_in = "a", e.imgUrl = "imgUrl";
})(bt || (bt = {}));
var ln = {};
setTimeout(function() {
  Vr.reduce(function(e, t) {
    return Qp(t), e;
  }, ln);
});
function Qp(e) {
  var t = Zn(e).flat().join("").toLowerCase().replace(/[^a-zA-Z\d]/g, "").split("");
  t.forEach(function(a) {
    var n;
    ln[a] = (n = ln[a]) != null ? n : {}, ln[a][tt(e)] = e;
  });
}
function Zn(e) {
  var t;
  return (t = e[bt.name]) != null ? t : [];
}
function oge(e) {
  return parseFloat(e[bt.added_in]);
}
function Ri(e) {
  return e ? Zn(e)[0] : "";
}
function Ts(e) {
  var t = e.split("-"), a = t.splice(1, 1), n = a[0];
  return nge[n] ? t.join("-") : e;
}
function tt(e, t) {
  var a, n = e[bt.unified];
  return !t || !Ea(e) ? n : (a = ige(e, t)) != null ? a : n;
}
function rge(e) {
  var t;
  return (t = xn == null ? void 0 : xn[e]) != null ? t : [];
}
function Jp(e, t) {
  return "" + $ke(t) + e + ".png";
}
function Fn(e) {
  var t;
  return (t = e[bt.variations]) != null ? t : [];
}
function Ea(e) {
  return Fn(e).length > 0;
}
function ige(e, t) {
  return t ? Fn(e).find(function(a) {
    return a.includes(t);
  }) : tt(e);
}
function ba(e) {
  if (e) {
    if (ya[e])
      return ya[e];
    var t = Ts(e);
    return ya[t];
  }
}
var Vr = /* @__PURE__ */ Object.values(xn).flat();
function sge(e) {
  xn[se.CUSTOM].length = 0, e.forEach(function(t) {
    var a = cge(t);
    xn[se.CUSTOM].push(a), !ya[a[bt.unified]] && (Vr.push(a), ya[a[bt.unified]] = a, Qp(a));
  });
}
function cge(e) {
  var t;
  return t = {}, t[bt.name] = e.names.map(function(a) {
    return a.toLowerCase();
  }), t[bt.unified] = e.id.toLowerCase(), t[bt.added_in] = "0", t[bt.imgUrl] = e.imgUrl, t;
}
var ya = {};
setTimeout(function() {
  Vr.reduce(function(e, t) {
    return e[tt(t)] = t, Ea(t) && Fn(t).forEach(function(a) {
      e[a] = t;
    }), e;
  }, ya);
});
function fge(e) {
  var t = e.split("-"), a = t[1];
  return Qo.includes(a) ? a : null;
}
var dge = ["2640-fe0f", "2642-fe0f", "2695-fe0f"], Jo = "Search", lge = "No results found", Kp = " found. Use up and down arrow keys to navigate.", uge = "1 result" + Kp, hge = "%n results" + Kp;
function ed(e) {
  var t, a;
  e === void 0 && (e = {});
  var n = Xp(), o = Object.assign(n.previewConfig, (t = e.previewConfig) != null ? t : {}), i = Object.assign(n, e), s = qke(e.categories, {
    suggestionMode: i.suggestedEmojisMode
  });
  i.hiddenEmojis.forEach(function(f) {
    i.unicodeToHide.add(f);
  }), sge((a = i.customEmojis) != null ? a : []);
  var c = i.searchDisabled ? Ca.PREVIEW : i.skinTonePickerLocation;
  return Pe({}, i, {
    categories: s,
    previewConfig: o,
    skinTonePickerLocation: c
  });
}
function Xp() {
  return {
    autoFocusSearch: !0,
    categories: Wp(),
    className: "",
    customEmojis: [],
    defaultSkinTone: Tt.NEUTRAL,
    emojiStyle: it.APPLE,
    emojiVersion: null,
    getEmojiUrl: Jp,
    height: 450,
    lazyLoadEmojis: !1,
    previewConfig: Pe({}, pge),
    searchDisabled: !1,
    searchPlaceHolder: Jo,
    searchPlaceholder: Jo,
    skinTonePickerLocation: Ca.SEARCH,
    skinTonesDisabled: !1,
    style: {},
    suggestedEmojisMode: Mn.FREQUENT,
    theme: wn.LIGHT,
    unicodeToHide: new Set(dge),
    width: 350,
    reactionsDefaultOpen: !1,
    reactions: Hke,
    open: !0,
    allowExpandReactions: !0,
    hiddenEmojis: []
  };
}
var pge = {
  defaultEmoji: "1f60a",
  defaultCaption: "What's your mood?",
  showPreview: !0
}, yge = ["children"], ey = /* @__PURE__ */ Wt(/* @__PURE__ */ Xp());
function mge(e) {
  var t = e.children, a = Gp(e, yge), n = kge(a);
  return P(ey.Provider, {
    value: n
  }, t);
}
function kge(e) {
  var t, a = ve(function() {
    return ed(e);
  }), n = a[0], o = a[1];
  return Ne(function() {
    $p(n, e) || o(ed(e));
  }, [(t = e.customEmojis) == null ? void 0 : t.length, e.open, e.emojiVersion, e.reactionsDefaultOpen, e.searchPlaceHolder, e.searchPlaceholder, e.defaultSkinTone, e.skinTonesDisabled, e.autoFocusSearch, e.emojiStyle, e.theme, e.suggestedEmojisMode, e.lazyLoadEmojis, e.className, e.height, e.width, e.searchDisabled, e.skinTonePickerLocation, e.allowExpandReactions]), n;
}
function Ee() {
  return xe(ey);
}
var ty = /* @__PURE__ */ I.createContext({});
function ay() {
  var e = I.useContext(ty);
  return e;
}
function gge(e) {
  var t = I.useRef({
    onEmojiClick: e.onEmojiClick || ko,
    onReactionClick: e.onReactionClick || e.onEmojiClick,
    onSkinToneChange: e.onSkinToneChange || ko
  });
  return I.useEffect(function() {
    t.current.onEmojiClick = e.onEmojiClick || ko, t.current.onReactionClick = e.onReactionClick || e.onEmojiClick;
  }, [e.onEmojiClick, e.onReactionClick]), I.useEffect(function() {
    t.current.onSkinToneChange = e.onSkinToneChange || ko;
  }, [e.onSkinToneChange]), t;
}
function ko() {
}
var Cn;
(function(e) {
  e.REACTIONS = "reactions", e.PICKER = "picker";
})(Cn || (Cn = {}));
function vge() {
  var e, t = Ee(), a = t.searchPlaceHolder, n = t.searchPlaceholder;
  return (e = [a, n].find(function(o) {
    return o !== Jo;
  })) != null ? e : Jo;
}
function Mge() {
  var e = Ee(), t = e.defaultSkinTone;
  return t;
}
function ny() {
  var e = Ee(), t = e.allowExpandReactions;
  return t;
}
function oy() {
  var e = Ee(), t = e.skinTonesDisabled;
  return t;
}
function W1() {
  var e = Ee(), t = e.emojiStyle;
  return t;
}
function wge() {
  var e = Ee(), t = e.autoFocusSearch;
  return t;
}
function ry() {
  var e = Ee(), t = e.categories;
  return t;
}
function xge() {
  var e = Ee(), t = e.customEmojis;
  return t;
}
function Cge() {
  var e = Ee(), t = e.open;
  return t;
}
function bge(e) {
  var t, a = ay(), n = a.current, o = (t = e === Cn.REACTIONS ? n.onReactionClick : n.onEmojiClick) != null ? t : n.onEmojiClick;
  return o || function() {
  };
}
function Lge() {
  var e = ay(), t = e.current;
  return t.onSkinToneChange || function() {
  };
}
function iy() {
  var e = Ee(), t = e.previewConfig;
  return t;
}
function jge() {
  var e = Ee(), t = e.theme;
  return t;
}
function Nge() {
  var e = Ee(), t = e.suggestedEmojisMode;
  return t;
}
function Age() {
  var e = Ee(), t = e.lazyLoadEmojis;
  return t;
}
function Sge() {
  var e = Ee(), t = e.className;
  return t;
}
function Ige() {
  var e = Ee(), t = e.height, a = e.width, n = e.style;
  return Pe({
    height: td(t),
    width: td(a)
  }, n);
}
function Tge() {
  var e = Ee(), t = e.reactionsDefaultOpen;
  return t;
}
function zge() {
  var e = Ee(), t = e.emojiVersion;
  return t;
}
function sy() {
  var e = Ee(), t = e.searchDisabled;
  return t;
}
function cy() {
  var e = Ee(), t = e.skinTonePickerLocation;
  return t;
}
function Dge() {
  var e = Ee(), t = e.unicodeToHide;
  return t;
}
function _ge() {
  var e = Ee(), t = e.reactions;
  return t;
}
function Y1() {
  var e = Ee(), t = e.getEmojiUrl;
  return t;
}
function td(e) {
  return typeof e == "number" ? e + "px" : e;
}
function Pge(e) {
  var t = e > 0, a = e > 1;
  return t ? a ? hge.replace("%n", e.toString()) : uge : lge;
}
function ad(e, t) {
  t === void 0 && (t = 0);
  var a = ve(e), n = a[0], o = a[1], i = Le(null);
  function s(c) {
    return new Promise(function(f) {
      var d;
      i.current && clearTimeout(i.current), i.current = (d = window) == null ? void 0 : d.setTimeout(function() {
        o(c), f(c);
      }, t);
    });
  }
  return [n, s];
}
function Ege() {
  var e = Dge();
  return function(t) {
    return e.has(t);
  };
}
function fy() {
  var e = Le({}), t = zge();
  return Ke(function() {
    var a = parseFloat("" + t);
    return !t || Number.isNaN(a) ? e.current : Vr.reduce(function(n, o) {
      return Hge(o, a) && (n[tt(o)] = !0), n;
    }, e.current);
  }, [t]);
}
function Rge() {
  var e = fy(), t = Ege();
  return function(n) {
    var o = Ts(tt(n));
    return !!(e[o] || t(o));
  };
}
function Hge(e, t) {
  return oge(e) > t;
}
function Vge(e) {
  Ne(function() {
    e(!0);
  }, [e]);
}
function Oge(e) {
  var t = e.children, a = fy(), n = Mge(), o = Tge(), i = Le(ln), s = Le(!1), c = Le(!1), f = Le(a), d = ad(Date.now(), 200), u = ad("", 100), h = ve(!1), y = ve(n), m = ve(null), v = ve(/* @__PURE__ */ new Set()), k = ve(null), g = ve(o), M = ve(!1), w = M[0], x = M[1];
  return Vge(x), P(jt.Provider, {
    value: {
      activeCategoryState: m,
      activeSkinTone: y,
      disallowClickRef: s,
      disallowMouseRef: c,
      disallowedEmojisRef: f,
      emojiVariationPickerState: k,
      emojisThatFailedToLoadState: v,
      filterRef: i,
      isPastInitialLoad: w,
      searchTerm: u,
      skinToneFanOpenState: h,
      suggestedUpdateState: d,
      reactionsModeState: g
    }
  }, t);
}
var jt = /* @__PURE__ */ Wt({
  activeCategoryState: [null, function() {
  }],
  activeSkinTone: [Tt.NEUTRAL, function() {
  }],
  disallowClickRef: {
    current: !1
  },
  disallowMouseRef: {
    current: !1
  },
  disallowedEmojisRef: {
    current: {}
  },
  emojiVariationPickerState: [null, function() {
  }],
  emojisThatFailedToLoadState: [/* @__PURE__ */ new Set(), function() {
  }],
  filterRef: {
    current: {}
  },
  isPastInitialLoad: !0,
  searchTerm: ["", function() {
    return new Promise(function() {
    });
  }],
  skinToneFanOpenState: [!1, function() {
  }],
  suggestedUpdateState: [/* @__PURE__ */ Date.now(), function() {
  }],
  reactionsModeState: [!1, function() {
  }]
});
function zs() {
  var e = xe(jt), t = e.filterRef;
  return t;
}
function qge() {
  var e = xe(jt), t = e.disallowClickRef;
  return t;
}
function Ds() {
  var e = xe(jt), t = e.disallowMouseRef;
  return t;
}
function Or() {
  var e = xe(jt), t = e.reactionsModeState;
  return t;
}
function qr() {
  var e = xe(jt), t = e.searchTerm;
  return t;
}
function _s() {
  var e = xe(jt), t = e.activeSkinTone;
  return t;
}
function dy() {
  var e = xe(jt), t = e.emojisThatFailedToLoadState;
  return t;
}
function Bge() {
  var e = xe(jt), t = e.isPastInitialLoad;
  return t;
}
function Ra() {
  var e = xe(jt), t = e.emojiVariationPickerState;
  return t;
}
function Gn() {
  var e = xe(jt), t = e.skinToneFanOpenState;
  return t;
}
function ly() {
  var e = xe(jt), t = e.suggestedUpdateState, a = t[0], n = t[1];
  return [a, function() {
    n(Date.now());
  }];
}
function Br() {
  var e = qr(), t = e[0];
  return !!t;
}
function kt(e) {
  e && requestAnimationFrame(function() {
    e.focus();
  });
}
function uy(e) {
  if (e) {
    var t = e.previousElementSibling;
    kt(t);
  }
}
function hy(e) {
  if (e) {
    var t = e.nextElementSibling;
    kt(t);
  }
}
function py(e) {
  if (e) {
    var t = e.firstElementChild;
    kt(t);
  }
}
function bn() {
  return document.activeElement;
}
function Zge(e) {
  var t = e.children, a = Le(null), n = Le(null), o = Le(null), i = Le(null), s = Le(null), c = Le(null), f = Le(null), d = Le(null);
  return P(yy.Provider, {
    value: {
      AnchoredEmojiRef: n,
      BodyRef: o,
      CategoryNavigationRef: c,
      PickerMainRef: a,
      SearchInputRef: i,
      SkinTonePickerRef: s,
      VariationPickerRef: f,
      ReactionsRef: d
    }
  }, t);
}
var yy = /* @__PURE__ */ Wt({
  AnchoredEmojiRef: /* @__PURE__ */ n1(),
  BodyRef: /* @__PURE__ */ n1(),
  CategoryNavigationRef: /* @__PURE__ */ n1(),
  PickerMainRef: /* @__PURE__ */ n1(),
  SearchInputRef: /* @__PURE__ */ n1(),
  SkinTonePickerRef: /* @__PURE__ */ n1(),
  VariationPickerRef: /* @__PURE__ */ n1(),
  ReactionsRef: /* @__PURE__ */ n1()
});
function x1() {
  return xe(yy);
}
function $n() {
  return x1().PickerMainRef;
}
function Zr() {
  return x1().AnchoredEmojiRef;
}
function my() {
  var e = Zr();
  return function(t) {
    t === null && e.current !== null && kt(e.current), e.current = t;
  };
}
function Nt() {
  return x1().BodyRef;
}
function Fge() {
  return x1().ReactionsRef;
}
function C1() {
  return x1().SearchInputRef;
}
function Ps() {
  return x1().SkinTonePickerRef;
}
function Es() {
  return x1().CategoryNavigationRef;
}
function Gge() {
  return x1().VariationPickerRef;
}
function ky(e, t) {
  t === void 0 && (t = 0);
  var a = zy(e);
  a && requestAnimationFrame(function() {
    a.scrollTop = t;
  });
}
function $ge(e, t) {
  var a = zy(e);
  a && requestAnimationFrame(function() {
    a.scrollTop = a.scrollTop + t;
  });
}
function Uge() {
  var e = Nt();
  return Ve(function(t) {
    requestAnimationFrame(function() {
      e.current && (e.current.scrollTop = t);
    });
  }, [e]);
}
function Fr(e) {
  if (!(!e || !Rve(e)) && !e.closest(Xe(ce.variationPicker))) {
    var t = _y(e), a = Dy(e);
    $ge(t, -(Bs(b1(e)) - a));
  }
}
function Gr(e) {
  var t = $s(e);
  kt(t), Fr(t);
}
function Wge(e) {
  var t = $s(e);
  kt(t), t == null || t.click();
}
function Yge(e) {
  kt(Hy(e));
}
function Qge(e) {
  if (e) {
    var t = Vy(e);
    if (!t)
      return Gr(Ur(e));
    kt(t), Fr(t);
  }
}
function Jge(e) {
  if (e) {
    var t = Gs(e);
    if (!t)
      return Yge($r(e));
    kt(t), Fr(t);
  }
}
function Kge(e, t) {
  if (e) {
    var a = eve(e);
    if (!a)
      return t();
    kt(a), Fr(a);
  }
}
function Xge(e) {
  if (e) {
    var t = tve(e);
    return kt(t);
  }
}
function eve(e) {
  if (!e)
    return null;
  var t = Oy(e), a = b1(t), n = Ay(t, e), o = Sy(t, e), i = Ny(t, e);
  if (o === 0) {
    var s = $r(a);
    return s ? Iy(
      La(s),
      -1,
      // last row
      i,
      n
    ) : null;
  }
  return Tve(La(t), o, i, n);
}
function tve(e) {
  if (!e)
    return null;
  var t = Oy(e), a = b1(t), n = Ay(t, e), o = Sy(t, e), i = Ny(t, e);
  if (!Ave(t, e)) {
    var s = Ur(a);
    return s ? Iy(La(s), 0, i, n) : null;
  }
  var c = Ive(La(t), o, i, n);
  return c;
}
function Q1() {
  var e = Ra(), t = e[0], a = e[1], n = Gn(), o = n[0], i = n[1], s = Ve(function() {
    t && a(null), o && i(!1);
  }, [t, o, a, i]);
  return s;
}
function gy() {
  var e = Ra(), t = e[0], a = Gn(), n = a[0];
  return function() {
    return !!t || n;
  };
}
function ave() {
  var e = Ds();
  return function() {
    e.current = !0;
  };
}
function vy() {
  var e = Ds();
  return function() {
    e.current = !1;
  };
}
function My() {
  var e = Ds();
  return function() {
    return e.current;
  };
}
function nve() {
  var e = Nt(), t = vy(), a = My();
  Ne(function() {
    var n = e.current;
    n == null || n.addEventListener("mousemove", o, {
      passive: !0
    });
    function o() {
      a() && t();
    }
    return function() {
      n == null || n.removeEventListener("mousemove", o);
    };
  }, [e, t, a]);
}
function J1() {
  var e = C1();
  return Ve(function() {
    kt(e.current);
  }, [e]);
}
function ove() {
  var e = Ps();
  return Ve(function() {
    e.current && py(e.current);
  }, [e]);
}
function wy() {
  var e = Es();
  return Ve(function() {
    e.current && py(e.current);
  }, [e]);
}
function rve() {
  var e = zs();
  return function t(a) {
    if (typeof a == "function")
      return t(a(e.current));
    e.current = a;
  };
}
function xy() {
  var e = Rs(), t = C1(), a = J1();
  return function() {
    t.current && (t.current.value = ""), e(""), a();
  };
}
function ive() {
  var e = C1(), t = Rs();
  return function(n) {
    e.current ? (e.current.value = "" + e.current.value + n, t(Hi(e.current.value))) : t(Hi(n));
  };
}
function sve() {
  var e = C1(), t = zs(), a = rve(), n = Rs(), o = qr(), i = o[0], s = hve(t.current, i);
  return {
    onChange: c,
    searchTerm: i,
    SearchInputRef: e,
    statusSearchResults: s
  };
  function c(f) {
    var d = t.current, u = f.toLowerCase();
    if (d != null && d[u] || u.length <= 1)
      return n(u);
    var h = uve(u, d);
    if (!h)
      return n(u);
    a(function(y) {
      var m;
      return Object.assign(y, (m = {}, m[u] = cve(h, u), m));
    }), n(u);
  }
}
function Rs() {
  var e = qr(), t = e[1], a = $n();
  return function(o) {
    requestAnimationFrame(function() {
      t(o && (o == null ? void 0 : o.toLowerCase())).then(function() {
        ky(a.current, 0);
      });
    });
  };
}
function cve(e, t) {
  var a = {};
  for (var n in e) {
    var o = e[n];
    fve(o, t) && (a[n] = o);
  }
  return a;
}
function fve(e, t) {
  return Zn(e).some(function(a) {
    return a.includes(t);
  });
}
function dve() {
  var e = zs(), t = e.current, a = qr(), n = a[0];
  return function(o) {
    return lve(o, t, n);
  };
}
function lve(e, t, a) {
  var n;
  return !t || !a ? !1 : !((n = t[a]) != null && n[e]);
}
function uve(e, t) {
  if (!t)
    return null;
  if (t[e])
    return t[e];
  var a = Object.keys(t).sort(function(n, o) {
    return o.length - n.length;
  }).find(function(n) {
    return e.includes(n);
  });
  return a ? t[a] : null;
}
function Hi(e) {
  return !e || typeof e != "string" ? "" : e.trim().toLowerCase();
}
function hve(e, t) {
  var a;
  if (!(e != null && e[t])) return "";
  var n = ((a = Object.entries(e == null ? void 0 : e[t])) == null ? void 0 : a.length) || 0;
  return Pge(n);
}
function Cy() {
  var e = my(), t = Ra(), a = t[1];
  return function(o) {
    var i = qs(o), s = i[0];
    s && (e(o), a(s));
  };
}
function Hs() {
  var e = cy();
  return e === Ca.SEARCH;
}
function by() {
  var e = cy();
  return e === Ca.PREVIEW;
}
var Be;
(function(e) {
  e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.Escape = "Escape", e.Enter = "Enter", e.Space = " ";
})(Be || (Be = {}));
function pve() {
  yve(), mve(), kve(), gve(), vve();
}
function yve() {
  var e = $n(), t = xy(), a = Uge(), n = C1(), o = J1(), i = gy(), s = ave(), c = Q1(), f = Ke(function() {
    return function(u) {
      var h = u.key;
      switch (s(), h) {
        case Be.Escape:
          if (u.preventDefault(), i()) {
            c();
            return;
          }
          t(), a(0), o();
          break;
      }
    };
  }, [a, t, c, o, i, s]);
  Ne(function() {
    var d = e.current;
    if (d)
      return d.addEventListener("keydown", f), function() {
        d.removeEventListener("keydown", f);
      };
  }, [e, n, a, f]);
}
function mve() {
  var e = ove(), t = $n(), a = Nt(), n = C1(), o = Gn(), i = o[1], s = Ly(), c = Hs(), f = Ke(function() {
    return function(u) {
      var h = u.key;
      switch (h) {
        case Be.ArrowRight:
          if (!c)
            return;
          u.preventDefault(), i(!0), e();
          break;
        case Be.ArrowDown:
          u.preventDefault(), s();
          break;
        case Be.Enter:
          u.preventDefault(), Wge(a.current);
          break;
      }
    };
  }, [e, s, i, a, c]);
  Ne(function() {
    var d = n.current;
    if (d)
      return d.addEventListener("keydown", f), function() {
        d.removeEventListener("keydown", f);
      };
  }, [t, n, f]);
}
function kve() {
  var e = Ps(), t = J1(), a = C1(), n = Ly(), o = Gn(), i = o[0], s = o[1], c = by(), f = Hs(), d = Vs(), u = Ke(function() {
    return (
      // eslint-disable-next-line complexity
      function(y) {
        var m = y.key;
        if (f)
          switch (m) {
            case Be.ArrowLeft:
              if (y.preventDefault(), !i)
                return t();
              nd(t);
              break;
            case Be.ArrowRight:
              if (y.preventDefault(), !i)
                return t();
              od();
              break;
            case Be.ArrowDown:
              y.preventDefault(), i && s(!1), n();
              break;
            default:
              d(y);
              break;
          }
        if (c)
          switch (m) {
            case Be.ArrowUp:
              if (y.preventDefault(), !i)
                return t();
              nd(t);
              break;
            case Be.ArrowDown:
              if (y.preventDefault(), !i)
                return t();
              od();
              break;
            default:
              d(y);
              break;
          }
      }
    );
  }, [i, t, s, n, d, c, f]);
  Ne(function() {
    var h = e.current;
    if (h)
      return h.addEventListener("keydown", u), function() {
        h.removeEventListener("keydown", u);
      };
  }, [e, a, i, u]);
}
function gve() {
  var e = J1(), t = Es(), a = Nt(), n = Vs(), o = Ke(function() {
    return function(s) {
      var c = s.key;
      switch (c) {
        case Be.ArrowUp:
          s.preventDefault(), e();
          break;
        case Be.ArrowRight:
          s.preventDefault(), hy(bn());
          break;
        case Be.ArrowLeft:
          s.preventDefault(), uy(bn());
          break;
        case Be.ArrowDown:
          s.preventDefault(), Gr(a.current);
          break;
        default:
          n(s);
          break;
      }
    };
  }, [a, e, n]);
  Ne(function() {
    var i = t.current;
    if (i)
      return i.addEventListener("keydown", o), function() {
        i.removeEventListener("keydown", o);
      };
  }, [t, a, o]);
}
function vve() {
  var e = Nt(), t = Mve(), a = Cy(), n = gy(), o = Q1(), i = Vs(), s = Ke(function() {
    return (
      // eslint-disable-next-line complexity
      function(f) {
        var d = f.key, u = Dt(bn());
        switch (d) {
          case Be.ArrowRight:
            f.preventDefault(), Qge(u);
            break;
          case Be.ArrowLeft:
            f.preventDefault(), Jge(u);
            break;
          case Be.ArrowDown:
            if (f.preventDefault(), n()) {
              o();
              break;
            }
            Xge(u);
            break;
          case Be.ArrowUp:
            if (f.preventDefault(), n()) {
              o();
              break;
            }
            Kge(u, t);
            break;
          case Be.Space:
            f.preventDefault(), a(f.target);
            break;
          default:
            i(f);
            break;
        }
      }
    );
  }, [t, i, a, n, o]);
  Ne(function() {
    var c = e.current;
    if (c)
      return c.addEventListener("keydown", s), function() {
        c.removeEventListener("keydown", s);
      };
  }, [e, s]);
}
function Ly() {
  var e = wy(), t = Br(), a = Nt();
  return Ve(function() {
    return t ? Gr(a.current) : e();
  }, [a, e, t]);
}
function Mve() {
  var e = J1(), t = wy(), a = Br();
  return Ve(function() {
    return a ? e() : t();
  }, [e, a, t]);
}
function nd(e) {
  var t = bn();
  t && (Dve(t) || e(), hy(t));
}
function od() {
  var e = bn();
  e && uy(e);
}
function Vs() {
  var e = ive(), t = J1(), a = sy(), n = Q1();
  return function(i) {
    var s = i.key;
    wve(i) || a || s.match(/(^[a-zA-Z0-9]$){1}/) && (i.preventDefault(), n(), t(), e(s));
  };
}
function wve(e) {
  var t = e.metaKey, a = e.ctrlKey, n = e.altKey;
  return t || a || n;
}
function xve(e, t, a) {
  if (t && a !== it.NATIVE) {
    var n = tt(t);
    rd.has(n) || (Fn(t).forEach(function(o) {
      var i = e(o, a);
      Cve(i);
    }), rd.add(n));
  }
}
var rd = /* @__PURE__ */ new Set();
function Cve(e) {
  var t = new Image();
  t.src = e;
}
function bve() {
  var e = Nt(), t = W1(), a = Y1();
  Ne(function() {
    if (t === it.NATIVE)
      return;
    var n = e.current;
    return n == null || n.addEventListener("focusin", o), function() {
      n == null || n.removeEventListener("focusin", o);
    };
    function o(i) {
      var s = Dt(i.target);
      if (s) {
        var c = qs(s), f = c[0];
        f && Ea(f) && xve(a, f, t);
      }
    }
  }, [e, t, a]);
}
var Lve = ["width", "height"], jy = 40;
function jve(e) {
  var t = e.children;
  return P(Oge, null, P(Nve, null, t));
}
function Nve(e) {
  var t, a = e.children, n = Or(), o = n[0], i = jge(), s = Br(), c = $n(), f = Sge(), d = Ige();
  pve(), bve();
  var u = d || {}, h = u.width, y = u.height, m = Gp(u, Lve);
  return P("aside", {
    className: pe(Ja.main, Ja.baseVariables, i === wn.DARK && Ja.darkTheme, i === wn.AUTO && Ja.autoThemeDark, (t = {}, t[ce.searchActive] = s, t), o && Ja.reactionsMenu, f),
    ref: c,
    style: Pe({}, m, !o && {
      height: y,
      width: h
    })
  }, a);
}
var id = {
  "--epr-emoji-variation-picker-bg-color": "var(--epr-dark-emoji-variation-picker-bg-color)",
  "--epr-hover-bg-color-reduced-opacity": "var(--epr-dark-hover-bg-color-reduced-opacity)",
  "--epr-highlight-color": "var(--epr-dark-highlight-color)",
  "--epr-text-color": "var(--epr-dark-text-color)",
  "--epr-hover-bg-color": "var(--epr-dark-hover-bg-color)",
  "--epr-focus-bg-color": "var(--epr-dark-focus-bg-color)",
  "--epr-search-input-bg-color": "var(--epr-dark-search-input-bg-color)",
  "--epr-category-label-bg-color": "var(--epr-dark-category-label-bg-color)",
  "--epr-picker-border-color": "var(--epr-dark-picker-border-color)",
  "--epr-bg-color": "var(--epr-dark-bg-color)",
  "--epr-reactions-bg-color": "var(--epr-dark-reactions-bg-color)",
  "--epr-search-input-bg-color-active": "var(--epr-dark-search-input-bg-color-active)",
  "--epr-emoji-variation-indicator-color": "var(--epr-dark-emoji-variation-indicator-color)",
  "--epr-category-icon-active-color": "var(--epr-dark-category-icon-active-color)",
  "--epr-skin-tone-picker-menu-color": "var(--epr-dark-skin-tone-picker-menu-color)",
  "--epr-skin-tone-outer-border-color": "var(--epr-dark-skin-tone-outer-border-color)",
  "--epr-skin-tone-inner-border-color": "var(--epr-dark-skin-tone-inner-border-color)"
}, Ja = /* @__PURE__ */ Te.create({
  main: {
    ".": ["epr-main", ce.emojiPicker],
    position: "relative",
    display: "flex",
    flexDirection: "column",
    borderWidth: "1px",
    borderStyle: "solid",
    borderRadius: "var(--epr-picker-border-radius)",
    borderColor: "var(--epr-picker-border-color)",
    backgroundColor: "var(--epr-bg-color)",
    overflow: "hidden",
    transition: "all 0.3s ease-in-out, background-color 0.1s ease-in-out",
    "*": {
      boxSizing: "border-box",
      fontFamily: "sans-serif"
    }
  },
  baseVariables: {
    "--": {
      "--epr-highlight-color": "#007aeb",
      "--epr-hover-bg-color": "#e5f0fa",
      "--epr-hover-bg-color-reduced-opacity": "#e5f0fa80",
      "--epr-focus-bg-color": "#e0f0ff",
      "--epr-text-color": "#858585",
      "--epr-search-input-bg-color": "#f6f6f6",
      "--epr-picker-border-color": "#e7e7e7",
      "--epr-bg-color": "#fff",
      "--epr-reactions-bg-color": "#ffffff90",
      "--epr-category-icon-active-color": "#6aa8de",
      "--epr-skin-tone-picker-menu-color": "#ffffff95",
      "--epr-skin-tone-outer-border-color": "#555555",
      "--epr-skin-tone-inner-border-color": "var(--epr-bg-color)",
      "--epr-horizontal-padding": "10px",
      "--epr-picker-border-radius": "8px",
      /* Header */
      "--epr-search-border-color": "var(--epr-highlight-color)",
      "--epr-header-padding": "15px var(--epr-horizontal-padding)",
      /* Skin Tone Picker */
      "--epr-active-skin-tone-indicator-border-color": "var(--epr-highlight-color)",
      "--epr-active-skin-hover-color": "var(--epr-hover-bg-color)",
      /* Search */
      "--epr-search-input-bg-color-active": "var(--epr-search-input-bg-color)",
      "--epr-search-input-padding": "0 30px",
      "--epr-search-input-border-radius": "8px",
      "--epr-search-input-height": "40px",
      "--epr-search-input-text-color": "var(--epr-text-color)",
      "--epr-search-input-placeholder-color": "var(--epr-text-color)",
      "--epr-search-bar-inner-padding": "var(--epr-horizontal-padding)",
      /*  Category Navigation */
      "--epr-category-navigation-button-size": "30px",
      /* Variation Picker */
      "--epr-emoji-variation-picker-height": "45px",
      "--epr-emoji-variation-picker-bg-color": "var(--epr-bg-color)",
      /*  Preview */
      "--epr-preview-height": "70px",
      "--epr-preview-text-size": "14px",
      "--epr-preview-text-padding": "0 var(--epr-horizontal-padding)",
      "--epr-preview-border-color": "var(--epr-picker-border-color)",
      "--epr-preview-text-color": "var(--epr-text-color)",
      /* Category */
      "--epr-category-padding": "0 var(--epr-horizontal-padding)",
      /*  Category Label */
      "--epr-category-label-bg-color": "#ffffffe6",
      "--epr-category-label-text-color": "var(--epr-text-color)",
      "--epr-category-label-padding": "0 var(--epr-horizontal-padding)",
      "--epr-category-label-height": jy + "px",
      /*  Emoji */
      "--epr-emoji-size": "30px",
      "--epr-emoji-padding": "5px",
      "--epr-emoji-fullsize": "calc(var(--epr-emoji-size) + var(--epr-emoji-padding) * 2)",
      "--epr-emoji-hover-color": "var(--epr-hover-bg-color)",
      "--epr-emoji-variation-indicator-color": "var(--epr-picker-border-color)",
      "--epr-emoji-variation-indicator-color-hover": "var(--epr-text-color)",
      /* Z-Index */
      "--epr-header-overlay-z-index": "3",
      "--epr-emoji-variations-indictator-z-index": "1",
      "--epr-category-label-z-index": "2",
      "--epr-skin-variation-picker-z-index": "5",
      "--epr-preview-z-index": "6",
      /* Dark Theme Variables */
      "--epr-dark": "#000",
      "--epr-dark-emoji-variation-picker-bg-color": "var(--epr-dark)",
      "--epr-dark-highlight-color": "#c0c0c0",
      "--epr-dark-text-color": "var(--epr-highlight-color)",
      "--epr-dark-hover-bg-color": "#363636f6",
      "--epr-dark-hover-bg-color-reduced-opacity": "#36363680",
      "--epr-dark-focus-bg-color": "#474747",
      "--epr-dark-search-input-bg-color": "#333333",
      "--epr-dark-category-label-bg-color": "#222222e6",
      "--epr-dark-picker-border-color": "#151617",
      "--epr-dark-bg-color": "#222222",
      "--epr-dark-reactions-bg-color": "#22222290",
      "--epr-dark-search-input-bg-color-active": "var(--epr-dark)",
      "--epr-dark-emoji-variation-indicator-color": "#444",
      "--epr-dark-category-icon-active-color": "#3271b7",
      "--epr-dark-skin-tone-picker-menu-color": "#22222295",
      "--epr-dark-skin-tone-outer-border-color": "var(--epr-dark-picker-border-color)",
      "--epr-dark-skin-tone-inner-border-color": "#FFFFFF"
    }
  },
  autoThemeDark: {
    ".": ce.autoTheme,
    "@media (prefers-color-scheme: dark)": {
      "--": id
    }
  },
  darkTheme: {
    ".": ce.darkTheme,
    "--": id
  },
  reactionsMenu: {
    ".": "epr-reactions",
    height: "50px",
    display: "inline-flex",
    backgroundColor: "var(--epr-reactions-bg-color)",
    // @ts-ignore - backdropFilter is not recognized.
    backdropFilter: "blur(8px)",
    "--": {
      "--epr-picker-border-radius": "50px"
    }
  }
});
function Ny(e, t) {
  if (!e || !t)
    return 0;
  var a = e.getBoundingClientRect().width, n = t.getBoundingClientRect().width;
  return Math.floor(a / n);
}
function Ay(e, t) {
  if (!e || !t)
    return 0;
  var a = t.getBoundingClientRect().width, n = t.getBoundingClientRect().left, o = e.getBoundingClientRect().left;
  return Math.floor((n - o) / a);
}
function Sy(e, t) {
  if (!e || !t)
    return 0;
  var a = t.getBoundingClientRect().height, n = t.getBoundingClientRect().top, o = e.getBoundingClientRect().top;
  return Math.round((n - o) / a);
}
function Ave(e, t) {
  if (!e || !t)
    return !1;
  var a = t.getBoundingClientRect().height, n = t.getBoundingClientRect().top, o = e.getBoundingClientRect().top, i = e.getBoundingClientRect().height;
  return Math.round(n - o + a) < i;
}
function Os(e, t, a) {
  if (t === -1) {
    var n = Math.floor((e.length - 1) / a), o = n * a, i = e.length - 1;
    return e.slice(o, i + 1);
  }
  return e.slice(t * a, (t + 1) * a);
}
function Sve(e, t, a) {
  var n = t + 1;
  return n * a > e.length ? [] : Os(e, n, a);
}
function Iy(e, t, a, n) {
  var o = Os(e, t, a);
  return o[n] || o[o.length - 1] || null;
}
function Ive(e, t, a, n) {
  var o = Sve(e, t, a);
  return o[n] || o[o.length - 1] || null;
}
function Tve(e, t, a, n) {
  var o = Os(e, t - 1, a);
  return o[n] || o[o.length - 1] || null;
}
function zve(e, t, a) {
  if (!e || !t.length)
    return null;
  var n = e.getBoundingClientRect().top, o = e.getBoundingClientRect().bottom, i = n + _ve(e), s = t.find(function(c) {
    var f = c.getBoundingClientRect().top, d = c.getBoundingClientRect().bottom, u = c.clientHeight * a, h = f + u, y = d - u;
    return h < i ? !1 : h >= n && h <= o || y >= n && y <= o;
  });
  return s || null;
}
function Dve(e) {
  return !!e.nextElementSibling;
}
function _ve(e) {
  for (var t = Array.from(e.querySelectorAll(Xe(ce.label))), a = 0, n = t; a < n.length; a++) {
    var o = n[a], i = o.getBoundingClientRect().height;
    if (i > 0)
      return i;
  }
  return jy;
}
var Ko = "button" + /* @__PURE__ */ Xe(ce.emoji), Pve = /* @__PURE__ */ [Ko, Xe(ce.visible), ":not(" + Xe(ce.hidden) + ")"].join("");
function Dt(e) {
  var t;
  return (t = e == null ? void 0 : e.closest(Ko)) != null ? t : null;
}
function qs(e) {
  var t = Py(e), a = Zs(e);
  if (!t)
    return [];
  var n = ba(a ?? t);
  return n ? [n, a] : [];
}
function Eve(e) {
  var t;
  return !!(e != null && e.matches(Ko) || !(e == null || (t = e.parentElement) == null) && t.matches(Ko));
}
function sd(e) {
  var t;
  return (t = e == null ? void 0 : e.clientHeight) != null ? t : 0;
}
function Ty(e) {
  if (!e)
    return 0;
  var t = Dt(e), a = b1(t), n = Bs(a);
  return cd(t) + cd(a) + n;
}
function Bs(e) {
  var t, a;
  if (!e)
    return 0;
  var n = e.querySelector(Xe(ce.categoryContent));
  return ((t = e == null ? void 0 : e.clientHeight) != null ? t : 0) - ((a = n == null ? void 0 : n.clientHeight) != null ? a : 0);
}
function Rve(e) {
  return e ? Dy(e) < Bs(b1(e)) : !1;
}
function zy(e) {
  return e ? e.matches(Xe(ce.scrollBody)) ? e : e.querySelector(Xe(ce.scrollBody)) : null;
}
function Dy(e) {
  var t, a;
  return e ? Ty(e) - ((t = (a = _y(e)) == null ? void 0 : a.scrollTop) != null ? t : 0) : 0;
}
function _y(e) {
  var t;
  return e && (t = e.closest(Xe(ce.scrollBody))) != null ? t : null;
}
function Hve(e) {
  var t = Dt(e), a = b1(t);
  return fd(t) + fd(a);
}
function cd(e) {
  var t;
  return (t = e == null ? void 0 : e.offsetTop) != null ? t : 0;
}
function fd(e) {
  var t;
  return (t = e == null ? void 0 : e.offsetLeft) != null ? t : 0;
}
function Zs(e) {
  var t;
  return (t = Vve(Dt(e), "unified")) != null ? t : null;
}
function Py(e) {
  var t = Zs(e);
  return t ? Ts(t) : null;
}
function Ey(e) {
  return e ? {
    unified: Zs(e),
    originalUnified: Py(e)
  } : {
    unified: null,
    originalUnified: null
  };
}
function Vve(e, t) {
  var a;
  return (a = Ove(e)[t]) != null ? a : null;
}
function Ove(e) {
  var t;
  return (t = e == null ? void 0 : e.dataset) != null ? t : {};
}
function Fs(e) {
  return e.classList.contains(ce.visible);
}
function Ry(e) {
  return e ? e.classList.contains(ce.hidden) : !0;
}
function La(e) {
  return e ? Array.from(e.querySelectorAll(Pve)) : [];
}
function Hy(e) {
  if (!e) return null;
  var t = La(e), a = t.slice(-1), n = a[0];
  return n ? Fs(n) ? n : Gs(n) : null;
}
function Vy(e) {
  var t = e.nextElementSibling;
  return t ? Fs(t) ? t : Vy(t) : $s(Ur(e));
}
function Gs(e) {
  var t = e.previousElementSibling;
  return t ? Fs(t) ? t : Gs(t) : Hy($r(e));
}
function $s(e) {
  if (!e)
    return null;
  var t = La(e);
  return zve(e, t, 0.1);
}
function $r(e) {
  var t = b1(e);
  if (!t)
    return null;
  var a = t.previousElementSibling;
  return a ? Ry(a) ? $r(a) : a : null;
}
function Ur(e) {
  var t = b1(e);
  if (!t)
    return null;
  var a = t.nextElementSibling;
  return a ? Ry(a) ? Ur(a) : a : null;
}
function b1(e) {
  return e ? e.closest(Xe(ce.category)) : null;
}
function Oy(e) {
  return e ? e.closest(Xe(ce.categoryContent)) : null;
}
function qy(e) {
  return e.split("-").map(function(t) {
    return String.fromCodePoint(parseInt(t, 16));
  }).join("");
}
var By = "epr_suggested";
function Zy(e) {
  try {
    var t, a, n;
    if (!((t = window) != null && t.localStorage))
      return [];
    var o = JSON.parse((a = (n = window) == null ? void 0 : n.localStorage.getItem(By)) != null ? a : "[]");
    return e === Mn.FREQUENT ? o.sort(function(i, s) {
      return s.count - i.count;
    }) : o;
  } catch {
    return [];
  }
}
function qve(e, t) {
  var a = Zy(), n = tt(e, t), o = tt(e), i = a.find(function(f) {
    var d = f.unified;
    return d === n;
  }), s;
  i ? s = [i].concat(a.filter(function(f) {
    return f !== i;
  })) : (i = {
    unified: n,
    original: o,
    count: 0
  }, s = [i].concat(a)), i.count++, s.length = Math.min(s.length, 14);
  try {
    var c;
    (c = window) == null || c.localStorage.setItem(By, JSON.stringify(s));
  } catch {
  }
}
function Bve(e) {
  return e.category === se.CUSTOM;
}
function Fy(e) {
  return e.imgUrl !== void 0;
}
function Gy(e, t) {
  var a = Le(), n = Cy(), o = qge(), i = Ra(), s = i[1], c = Q1(), f = _s(), d = f[0], u = bge(t), h = ly(), y = h[1], m = Y1(), v = W1(), k = Ve(function(x) {
    if (!o.current) {
      c();
      var C = dd(x), L = C[0], N = C[1];
      if (!(!L || !N)) {
        var j = fge(N) || d;
        y(), qve(L, j), u(Zve(L, j, v, m), x);
      }
    }
  }, [d, c, o, u, y, m, v]), g = Ve(function(x) {
    var C;
    a.current && clearTimeout(a.current);
    var L = dd(x), N = L[0];
    !N || !Ea(N) || (a.current = (C = window) == null ? void 0 : C.setTimeout(function() {
      o.current = !0, a.current = void 0, c(), n(x.target), s(N);
    }, 500));
  }, [o, c, n, s]), M = Ve(function() {
    a.current ? (clearTimeout(a.current), a.current = void 0) : o.current && requestAnimationFrame(function() {
      o.current = !1;
    });
  }, [o]);
  Ne(function() {
    if (e.current) {
      var w = e.current;
      return w.addEventListener("click", k, {
        passive: !0
      }), w.addEventListener("mousedown", g, {
        passive: !0
      }), w.addEventListener("mouseup", M, {
        passive: !0
      }), function() {
        w == null || w.removeEventListener("click", k), w == null || w.removeEventListener("mousedown", g), w == null || w.removeEventListener("mouseup", M);
      };
    }
  }, [e, k, g, M]);
}
function dd(e) {
  var t = e == null ? void 0 : e.target;
  return Eve(t) ? qs(t) : [];
}
function Zve(e, t, a, n) {
  var o = Zn(e);
  if (Fy(e)) {
    var i = tt(e);
    return {
      activeSkinTone: t,
      emoji: i,
      getImageUrl: function() {
        return e.imgUrl;
      },
      imageUrl: e.imgUrl,
      isCustom: !0,
      names: o,
      unified: i,
      unifiedWithoutSkinTone: i
    };
  }
  var s = tt(e, t);
  return {
    activeSkinTone: t,
    emoji: qy(s),
    getImageUrl: function(f) {
      return f === void 0 && (f = a ?? it.APPLE), n(s, f);
    },
    imageUrl: n(s, a ?? it.APPLE),
    isCustom: !1,
    names: o,
    unified: s,
    unifiedWithoutSkinTone: tt(e)
  };
}
function Un(e) {
  return P("button", Object.assign({
    type: "button"
  }, e, {
    className: pe(Fve.button, e.className)
  }), e.children);
}
var Fve = /* @__PURE__ */ Te.create({
  button: {
    ".": "epr-btn",
    cursor: "pointer",
    border: "0",
    background: "none",
    outline: "none"
  }
});
function Gve(e) {
  var t, a = e.emojiNames, n = e.unified, o = e.hidden, i = e.hiddenOnSearch, s = e.showVariations, c = s === void 0 ? !0 : s, f = e.hasVariations, d = e.children, u = e.className, h = e.noBackground, y = h === void 0 ? !1 : h;
  return P(Un, {
    className: pe(R2.emoji, o && Ss.hidden, i && U1.hiddenOnSearch, (t = {}, t[ce.visible] = !o && !i, t), !!(f && c) && R2.hasVariations, y && R2.noBackground, u),
    "data-unified": n,
    "aria-label": $ve(a),
    "data-full-name": a
  }, d);
}
function $ve(e) {
  var t;
  return e[0].match("flag-") && (t = e[1]) != null ? t : e[0];
}
var R2 = /* @__PURE__ */ Te.create({
  emoji: {
    ".": ce.emoji,
    position: "relative",
    width: "var(--epr-emoji-fullsize)",
    height: "var(--epr-emoji-fullsize)",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "var(--epr-emoji-fullsize)",
    maxHeight: "var(--epr-emoji-fullsize)",
    borderRadius: "8px",
    overflow: "hidden",
    transition: "background-color 0.2s",
    ":hover": {
      backgroundColor: "var(--epr-emoji-hover-color)"
    },
    ":focus": {
      backgroundColor: "var(--epr-focus-bg-color)"
    }
  },
  noBackground: {
    background: "none",
    ":hover": {
      backgroundColor: "transparent",
      background: "none"
    },
    ":focus": {
      backgroundColor: "transparent",
      background: "none"
    }
  },
  hasVariations: {
    ".": ce.emojiHasVariations,
    ":after": {
      content: "",
      display: "block",
      width: "0",
      height: "0",
      right: "0px",
      bottom: "1px",
      position: "absolute",
      borderLeft: "4px solid transparent",
      borderRight: "4px solid transparent",
      transform: "rotate(135deg)",
      borderBottom: "4px solid var(--epr-emoji-variation-indicator-color)",
      zIndex: "var(--epr-emoji-variations-indictator-z-index)"
    },
    ":hover:after": {
      borderBottom: "4px solid var(--epr-emoji-variation-indicator-color-hover)"
    }
  }
}), Xo = /* @__PURE__ */ Te.create({
  external: {
    ".": ce.external,
    fontSize: "0"
  },
  common: {
    alignSelf: "center",
    justifySelf: "center",
    display: "block"
  }
});
function ld(e) {
  var t = e.emojiName, a = e.style, n = e.lazyLoad, o = n === void 0 ? !1 : n, i = e.imgUrl, s = e.onError, c = e.className;
  return P("img", {
    src: i,
    alt: t,
    className: pe(Uve.emojiImag, Xo.external, Xo.common, c),
    loading: o ? "lazy" : "eager",
    onError: s,
    style: a
  });
}
var Uve = /* @__PURE__ */ Te.create({
  emojiImag: {
    ".": "epr-emoji-img",
    maxWidth: "var(--epr-emoji-fullsize)",
    maxHeight: "var(--epr-emoji-fullsize)",
    minWidth: "var(--epr-emoji-fullsize)",
    minHeight: "var(--epr-emoji-fullsize)",
    padding: "var(--epr-emoji-padding)"
  }
});
function Wve(e) {
  var t = e.unified, a = e.style, n = e.className;
  return P("span", {
    className: pe(Yve.nativeEmoji, Xo.common, Xo.external, n),
    "data-unified": t,
    style: a
  }, qy(t));
}
var Yve = /* @__PURE__ */ Te.create({
  nativeEmoji: {
    ".": "epr-emoji-native",
    fontFamily: '"Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "EmojiOne Color", "Android Emoji"!important',
    position: "relative",
    lineHeight: "100%",
    fontSize: "var(--epr-emoji-size)",
    textAlign: "center",
    alignSelf: "center",
    justifySelf: "center",
    letterSpacing: "0",
    padding: "var(--epr-emoji-padding)"
  }
});
function Vi(e) {
  var t = e.emoji, a = e.unified, n = e.emojiStyle, o = e.size, i = e.lazyLoad, s = e.getEmojiUrl, c = s === void 0 ? Jp : s, f = e.className, d = dy(), u = d[1], h = {};
  o && (h.width = h.height = h.fontSize = o + "px");
  var y = t || ba(a);
  if (!y)
    return null;
  if (Fy(y))
    return P(ld, {
      style: h,
      emojiName: a,
      emojiStyle: it.NATIVE,
      lazyLoad: i,
      imgUrl: y.imgUrl,
      onError: m,
      className: f
    });
  return P(Nn, null, n === it.NATIVE ? P(Wve, {
    unified: a,
    style: h,
    className: f
  }) : P(ld, {
    style: h,
    emojiName: Ri(y),
    emojiStyle: n,
    lazyLoad: i,
    imgUrl: c(a, n),
    onError: m,
    className: f
  }));
  function m() {
    u(function(v) {
      return new Set(v).add(a);
    });
  }
}
function Wr(e) {
  var t = e.emoji, a = e.unified, n = e.hidden, o = e.hiddenOnSearch, i = e.emojiStyle, s = e.showVariations, c = s === void 0 ? !0 : s, f = e.size, d = e.lazyLoad, u = e.getEmojiUrl, h = e.className, y = e.noBackground, m = y === void 0 ? !1 : y, v = Ea(t);
  return P(Gve, {
    hasVariations: v,
    showVariations: c,
    hidden: n,
    hiddenOnSearch: o,
    emojiNames: Zn(t),
    unified: a,
    noBackground: m
  }, P(Vi, {
    unified: a,
    emoji: t,
    size: f,
    emojiStyle: i,
    lazyLoad: d,
    getEmojiUrl: u,
    className: h
  }));
}
var Qve = "data:image/svg+xml;base64,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";
function Jve() {
  var e = Or(), t = e[1];
  return P(Un, {
    "aria-label": "Show all Emojis",
    title: "Show all Emojis",
    tabIndex: 0,
    className: pe(Kve.plusSign),
    onClick: function() {
      return t(!1);
    }
  });
}
var Kve = /* @__PURE__ */ Te.create(/* @__PURE__ */ Pe({
  plusSign: {
    fontSize: "20px",
    padding: "17px",
    color: "var(--epr-text-color)",
    borderRadius: "50%",
    textAlign: "center",
    lineHeight: "100%",
    width: "20px",
    height: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transition: "background-color 0.2s ease-in-out",
    ":after": {
      content: "",
      minWidth: "20px",
      minHeight: "20px",
      backgroundImage: "url(" + Qve + ")",
      backgroundColor: "transparent",
      backgroundRepeat: "no-repeat",
      backgroundSize: "20px",
      backgroundPositionY: "0"
    },
    ":hover": {
      color: "var(--epr-highlight-color)",
      backgroundColor: "var(--epr-hover-bg-color-reduced-opacity)",
      ":after": {
        backgroundPositionY: "-20px"
      }
    },
    ":focus": {
      color: "var(--epr-highlight-color)",
      backgroundColor: "var(--epr-hover-bg-color-reduced-opacity)",
      ":after": {
        backgroundPositionY: "-40px"
      }
    }
  }
}, /* @__PURE__ */ y1("plusSign", {
  ":after": {
    backgroundPositionY: "-40px"
  },
  ":hover:after": {
    backgroundPositionY: "-60px"
  }
})));
function Xve() {
  var e = Or(), t = e[0], a = Fge(), n = _ge();
  Gy(a, Cn.REACTIONS);
  var o = W1(), i = ny(), s = Y1();
  return t ? P("ul", {
    className: pe(ud.list, !t && Ss.hidden),
    ref: a
  }, n.map(function(c) {
    return P("li", {
      key: c
    }, P(Wr, {
      emoji: ba(c),
      emojiStyle: o,
      unified: c,
      showVariations: !1,
      className: pe(ud.emojiButton),
      noBackground: !0,
      getEmojiUrl: s
    }));
  }), i ? P("li", null, P(Jve, null)) : null) : null;
}
var ud = /* @__PURE__ */ Te.create({
  list: {
    listStyle: "none",
    margin: "0",
    padding: "0 5px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%"
  },
  emojiButton: {
    ":hover": {
      transform: "scale(1.2)"
    },
    ":focus": {
      transform: "scale(1.2)"
    },
    ":active": {
      transform: "scale(1.1)"
    },
    transition: "transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.5)"
  }
});
function eMe(e) {
  var t = Q1();
  Ne(function() {
    var a = e.current;
    if (!a)
      return;
    a.addEventListener("scroll", n, {
      passive: !0
    });
    function n() {
      t();
    }
    return function() {
      a == null || a.removeEventListener("scroll", n);
    };
  }, [e, t]);
}
function tMe() {
  var e = dy(), t = e[0], a = dve();
  return function(n) {
    var o = tt(n), i = t.has(o), s = a(o);
    return {
      failedToLoad: i,
      filteredOut: s,
      hidden: i || s
    };
  };
}
function $y(e) {
  var t = e.categoryConfig, a = e.children, n = e.hidden, o = e.hiddenOnSearch, i = Is(t), s = Yp(t);
  return P("li", {
    className: pe(H2.category, n && Ss.hidden, o && U1.hiddenOnSearch),
    "data-name": i,
    "aria-label": s
  }, P("h2", {
    className: pe(H2.label)
  }, s), P("div", {
    className: pe(H2.categoryContent)
  }, a));
}
var H2 = /* @__PURE__ */ Te.create({
  category: {
    ".": ce.category,
    ":not(:has(.epr-visible))": {
      display: "none"
    }
  },
  categoryContent: {
    ".": ce.categoryContent,
    display: "grid",
    gridGap: "0",
    gridTemplateColumns: "repeat(auto-fill, var(--epr-emoji-fullsize))",
    justifyContent: "space-between",
    margin: "var(--epr-category-padding)",
    position: "relative"
  },
  label: {
    ".": ce.label,
    alignItems: "center",
    // @ts-ignore - backdropFilter is not recognized.
    backdropFilter: "blur(3px)",
    backgroundColor: "var(--epr-category-label-bg-color)",
    color: "var(--epr-category-label-text-color)",
    display: "flex",
    fontSize: "16px",
    fontWeight: "bold",
    height: "var(--epr-category-label-height)",
    margin: "0",
    padding: "var(--epr-category-label-padding)",
    position: "sticky",
    textTransform: "capitalize",
    top: "0",
    width: "100%",
    zIndex: "var(--epr-category-label-z-index)"
  }
}), V2 = !1;
function aMe() {
  var e = ve(V2), t = e[0], a = e[1];
  return Ne(function() {
    a(!0), V2 = !0;
  }, []), t || V2;
}
function nMe(e) {
  var t = e.categoryConfig, a = ly(), n = a[0], o = aMe(), i = Nge(), s = Y1(), c = Ke(
    function() {
      var d;
      return (d = Zy(i)) != null ? d : [];
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, i]
  ), f = W1();
  return o ? P($y, {
    categoryConfig: t,
    hiddenOnSearch: !0,
    hidden: c.length === 0
  }, c.map(function(d) {
    var u = ba(d.original);
    return u ? P(Wr, {
      showVariations: !1,
      unified: d.unified,
      emojiStyle: f,
      emoji: u,
      key: d.unified,
      getEmojiUrl: s
    }) : null;
  })) : null;
}
function oMe() {
  var e = ry(), t = Le(0);
  return P("ul", {
    className: pe(iMe.emojiList)
  }, e.map(function(a) {
    var n = Is(a);
    return n === se.SUGGESTED ? P(nMe, {
      key: n,
      categoryConfig: a
    }) : P(L6, {
      key: n
    }, P(rMe, {
      category: n,
      categoryConfig: a,
      renderdCategoriesCountRef: t
    }));
  }));
}
function rMe(e) {
  var t = e.category, a = e.categoryConfig, n = e.renderdCategoriesCountRef, o = tMe(), i = Age(), s = W1(), c = Bge(), f = _s(), d = f[0], u = Rge(), h = Y1(), y = !oy(), m = !c && n.current > 0 ? [] : rge(t);
  m.length > 0 && n.current++;
  var v = 0, k = m.map(function(g) {
    var M = tt(g, d), w = o(g), x = w.failedToLoad, C = w.filteredOut, L = w.hidden, N = u(g);
    return (L || N) && v++, N ? null : P(Wr, {
      showVariations: y,
      key: M,
      emoji: g,
      unified: M,
      hidden: x,
      hiddenOnSearch: C,
      emojiStyle: s,
      lazyLoad: i,
      getEmojiUrl: h
    });
  });
  return P($y, {
    categoryConfig: a,
    // Indicates that there are no visible emojis
    // Hence, the category should be hidden
    hidden: v === k.length
  }, k);
}
var iMe = /* @__PURE__ */ Te.create({
  emojiList: {
    ".": ce.emojiList,
    listStyle: "none",
    margin: "0",
    padding: "0"
  }
}), sMe = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI1MHB4IgoJIGhlaWdodD0iMTVweCIgdmlld0JveD0iMCAwIDUwIDE1IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MCAxNSIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnIGlkPSJMYXllcl8xIj4KPC9nPgo8ZyBpZD0iTGF5ZXJfMiI+Cgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBzdHJva2U9IiNFOEU3RTciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTEuODYtMC40M2w5LjgzLDExLjUzYzAuNTksMC42OSwxLjU2LDAuNjksMi4xNCwwbDkuODMtMTEuNTMiLz4KCTxwYXRoIGZpbGw9IiMwMTAyMDIiIHN0cm9rZT0iIzE1MTYxNyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMjYuODYtMC40M2w5LjgzLDExLjUzYzAuNTksMC42OSwxLjU2LDAuNjksMi4xNCwwbDkuODMtMTEuNTMiLz4KPC9nPgo8L3N2Zz4=", ma;
(function(e) {
  e[e.Up = 0] = "Up", e[e.Down = 1] = "Down";
})(ma || (ma = {}));
function cMe() {
  var e = Zr(), t = Gge(), a = Ra(), n = a[0], o = W1(), i = dMe(t), s = i.getTop, c = i.getMenuDirection, f = my(), d = fMe(t), u = Y1(), h = Dt(e.current), y = !!(n && h && Ea(n) && h.classList.contains(ce.emojiHasVariations));
  Ne(function() {
    y && Gr(t.current);
  }, [t, y, e]);
  var m, v;
  return !y && e.current ? f(null) : (m = s(), v = d()), P("div", {
    ref: t,
    className: pe(go.variationPicker, c() === ma.Down && go.pointingUp, y && go.visible),
    style: {
      top: m
    }
  }, y && n ? [tt(n)].concat(Fn(n)).slice(0, 6).map(function(k) {
    return P(Wr, {
      key: k,
      emoji: n,
      unified: k,
      emojiStyle: o,
      showVariations: !1,
      getEmojiUrl: u
    });
  }) : null, P("div", {
    className: pe(go.pointer),
    style: v
  }));
}
function fMe(e) {
  var t = Zr();
  return function() {
    var n = {};
    if (!e.current)
      return n;
    if (t.current) {
      var o = Dt(t.current), i = Hve(o);
      if (!o)
        return n;
      n.left = i + (o == null ? void 0 : o.clientWidth) / 2;
    }
    return n;
  };
}
function dMe(e) {
  var t = Zr(), a = Nt(), n = ma.Up;
  return {
    getMenuDirection: o,
    getTop: i
  };
  function o() {
    return n;
  }
  function i() {
    n = ma.Up;
    var s = 0;
    if (!e.current)
      return 0;
    var c = sd(e.current);
    if (t.current) {
      var f, d = a.current, u = Dt(t.current), h = sd(u);
      s = Ty(u);
      var y = (f = d == null ? void 0 : d.scrollTop) != null ? f : 0;
      y > s - c && (n = ma.Down, s += h + c);
    }
    return s - c;
  }
}
var go = /* @__PURE__ */ Te.create(/* @__PURE__ */ Pe({
  variationPicker: {
    ".": ce.variationPicker,
    position: "absolute",
    right: "15px",
    left: "15px",
    padding: "5px",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
    borderRadius: "3px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    opacity: "0",
    visibility: "hidden",
    pointerEvents: "none",
    top: "-100%",
    border: "1px solid var(--epr-picker-border-color)",
    height: "var(--epr-emoji-variation-picker-height)",
    zIndex: "var(--epr-skin-variation-picker-z-index)",
    background: "var(--epr-emoji-variation-picker-bg-color)",
    transform: "scale(0.9)",
    transition: "transform 0.1s ease-out, opacity 0.2s ease-out"
  },
  visible: {
    opacity: "1",
    visibility: "visible",
    pointerEvents: "all",
    transform: "scale(1)"
  },
  pointingUp: {
    ".": "pointing-up",
    transformOrigin: "center 0%",
    transform: "scale(0.9)"
  },
  ".pointing-up": {
    pointer: {
      top: "0",
      transform: "rotate(180deg) translateY(100%) translateX(18px)"
    }
  },
  pointer: {
    ".": "epr-emoji-pointer",
    content: "",
    position: "absolute",
    width: "25px",
    height: "15px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "0 0",
    backgroundSize: "50px 15px",
    top: "100%",
    transform: "translateX(-18px)",
    backgroundImage: "url(" + sMe + ")"
  }
}, /* @__PURE__ */ y1("pointer", {
  backgroundPosition: "-25px 0"
})));
function lMe() {
  var e = Nt();
  return eMe(e), Gy(e, Cn.PICKER), nve(), P("div", {
    className: pe(uMe.body, U1.hiddenOnReactions),
    ref: e
  }, P(cMe, null), P(oMe, null));
}
var uMe = /* @__PURE__ */ Te.create({
  body: {
    ".": ce.scrollBody,
    flex: "1",
    overflowY: "scroll",
    overflowX: "hidden",
    position: "relative"
  }
});
function hMe(e, t) {
  if (!e || !t)
    return 0;
  var a = e.getBoundingClientRect(), n = t.getBoundingClientRect();
  return n.height - (a.y - n.y);
}
function pMe(e, t) {
  var a = Nt(), n = My(), o = vy();
  Ne(function() {
    if (!e)
      return;
    var i = a.current;
    i == null || i.addEventListener("keydown", f, {
      passive: !0
    }), i == null || i.addEventListener("mouseover", d, !0), i == null || i.addEventListener("focus", s, !0), i == null || i.addEventListener("mouseout", c, {
      passive: !0
    }), i == null || i.addEventListener("blur", c, !0);
    function s(u) {
      var h = Dt(u.target);
      if (!h)
        return c();
      var y = Ey(h), m = y.unified, v = y.originalUnified;
      if (!m || !v)
        return c();
      t({
        unified: m,
        originalUnified: v
      });
    }
    function c(u) {
      if (u) {
        var h = u.relatedTarget;
        if (!Dt(h))
          return t(null);
      }
      t(null);
    }
    function f(u) {
      u.key === "Escape" && t(null);
    }
    function d(u) {
      if (!n()) {
        var h = Dt(u.target);
        if (h) {
          var y = hMe(h, i), m = h.getBoundingClientRect().height;
          if (y < m)
            return yMe(h, t);
          kt(h);
        }
      }
    }
    return function() {
      i == null || i.removeEventListener("mouseover", d), i == null || i.removeEventListener("mouseout", c), i == null || i.removeEventListener("focus", s, !0), i == null || i.removeEventListener("blur", c, !0), i == null || i.removeEventListener("keydown", f);
    };
  }, [a, e, t, n, o]);
}
function yMe(e, t) {
  var a, n = Ey(e), o = n.unified, i = n.originalUnified;
  !o || !i || ((a = document.activeElement) == null || a.blur == null || a.blur(), t({
    unified: o,
    originalUnified: i
  }));
}
var vo, Ln;
(function(e) {
  e.ROW = "FlexRow", e.COLUMN = "FlexColumn";
})(Ln || (Ln = {}));
function Uy(e) {
  var t = e.children, a = e.className, n = e.style, o = n === void 0 ? {} : n, i = e.direction, s = i === void 0 ? Ln.ROW : i;
  return P("div", {
    style: Pe({}, o),
    className: pe(hd.flex, a, hd[s])
  }, t);
}
var hd = /* @__PURE__ */ Te.create((vo = {
  flex: {
    display: "flex"
  }
}, vo[Ln.ROW] = {
  flexDirection: "row"
}, vo[Ln.COLUMN] = {
  flexDirection: "column"
}, vo));
function mMe(e) {
  var t = e.className, a = e.style, n = a === void 0 ? {} : a;
  return P("div", {
    style: Pe({
      flex: 1
    }, n),
    className: pe(t)
  });
}
function kMe(e) {
  var t = e.children, a = e.className, n = e.style;
  return P("div", {
    style: Pe({}, n, {
      position: "absolute"
    }),
    className: a
  }, t);
}
function Yr(e) {
  var t = e.children, a = e.className, n = e.style;
  return P("div", {
    style: Pe({}, n, {
      position: "relative"
    }),
    className: a
  }, t);
}
function gMe(e) {
  var t = e.isOpen, a = e.onClick, n = e.isActive, o = e.skinToneVariation, i = e.style;
  return P(Un, {
    style: i,
    onClick: a,
    className: pe("epr-tone-" + o, O2.tone, !t && O2.closedTone, n && O2.active),
    "aria-pressed": n,
    "aria-label": "Skin tone " + age[o]
  });
}
var O2 = /* @__PURE__ */ Te.create({
  closedTone: {
    opacity: "0",
    zIndex: "0"
  },
  active: {
    ".": "epr-active",
    zIndex: "1",
    opacity: "1"
  },
  tone: {
    ".": "epr-tone",
    width: "var(--epr-skin-tone-size)",
    display: "block",
    cursor: "pointer",
    borderRadius: "4px",
    height: "var(--epr-skin-tone-size)",
    position: "absolute",
    right: "0",
    transition: "transform 0.3s ease-in-out, opacity 0.35s ease-in-out",
    zIndex: "0",
    border: "1px solid var(--epr-skin-tone-outer-border-color)",
    boxShadow: "inset 0px 0px 0 1px var(--epr-skin-tone-inner-border-color)",
    ":hover": {
      boxShadow: "0 0 0 3px var(--epr-active-skin-hover-color), inset 0px 0px 0 1px var(--epr-skin-tone-inner-border-color)"
    },
    ":focus": {
      boxShadow: "0 0 0 3px var(--epr-focus-bg-color)"
    },
    "&.epr-tone-neutral": {
      backgroundColor: "#ffd225"
    },
    "&.epr-tone-1f3fb": {
      backgroundColor: "#ffdfbd"
    },
    "&.epr-tone-1f3fc": {
      backgroundColor: "#e9c197"
    },
    "&.epr-tone-1f3fd": {
      backgroundColor: "#c88e62"
    },
    "&.epr-tone-1f3fe": {
      backgroundColor: "#a86637"
    },
    "&.epr-tone-1f3ff": {
      backgroundColor: "#60463a"
    }
  }
}), on = 28;
function vMe() {
  return P(Yr, {
    style: {
      height: on
    }
  }, P(kMe, {
    style: {
      bottom: 0,
      right: 0
    }
  }, P(Wy, {
    direction: jn.VERTICAL
  })));
}
function Wy(e) {
  var t = e.direction, a = t === void 0 ? jn.HORIZONTAL : t, n = Ps(), o = oy(), i = Gn(), s = i[0], c = i[1], f = _s(), d = f[0], u = f[1], h = Lge(), y = Q1(), m = J1();
  if (o)
    return null;
  var v = on * Qo.length + "px", k = s ? v : on + "px", g = a === jn.VERTICAL;
  return P(Yr, {
    className: pe(Ka.skinTones, g && Ka.vertical, s && Ka.open, g && s && Ka.verticalShadow),
    style: g ? {
      flexBasis: k,
      height: k
    } : {
      flexBasis: k
    }
  }, P("div", {
    className: pe(Ka.select),
    ref: n
  }, Qo.map(function(M, w) {
    var x = M === d;
    return P(gMe, {
      key: M,
      skinToneVariation: M,
      isOpen: s,
      style: {
        transform: pe(g ? "translateY(-" + w * (s ? on : 0) + "px)" : "translateX(-" + w * (s ? on : 0) + "px)", s && x && "scale(1.3)")
      },
      isActive: x,
      onClick: function() {
        s ? (u(M), h(M), m()) : c(!0), y();
      }
    });
  })));
}
var jn;
(function(e) {
  e.VERTICAL = "epr-vertical", e.HORIZONTAL = "epr-horizontal";
})(jn || (jn = {}));
var Ka = /* @__PURE__ */ Te.create({
  skinTones: {
    ".": "epr-skin-tones",
    "--": {
      "--epr-skin-tone-size": "15px"
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    transition: "all 0.3s ease-in-out",
    padding: "10px 0"
  },
  vertical: {
    padding: "9px",
    alignItems: "flex-end",
    flexDirection: "column",
    borderRadius: "6px",
    border: "1px solid var(--epr-bg-color)"
  },
  verticalShadow: {
    boxShadow: "0px 0 7px var(--epr-picker-border-color)"
  },
  open: {
    // @ts-ignore - backdropFilter is not recognized.
    backdropFilter: "blur(5px)",
    background: "var(--epr-skin-tone-picker-menu-color)",
    ".epr-active": {
      border: "1px solid var(--epr-active-skin-tone-indicator-border-color)"
    }
  },
  select: {
    ".": "epr-skin-tone-select",
    position: "relative",
    width: "var(--epr-skin-tone-size)",
    height: "var(--epr-skin-tone-size)"
  }
});
function MMe() {
  var e = iy(), t = by();
  return e.showPreview ? P(Uy, {
    className: pe(Ao.preview, U1.hiddenOnReactions)
  }, P(wMe, null), P(mMe, null), t ? P(vMe, null) : null) : null;
}
function wMe() {
  var e, t = iy(), a = ve(null), n = a[0], o = a[1], i = W1(), s = Ra(), c = s[0], f = Y1();
  pMe(t.showPreview, o);
  var d = ba((e = n == null ? void 0 : n.unified) != null ? e : n == null ? void 0 : n.originalUnified), u = d != null && n != null;
  return P(h, null);
  function h() {
    var y = c ?? ba(t.defaultEmoji);
    if (!y)
      return null;
    var m = c ? Ri(c) : t.defaultCaption;
    return P(Nn, null, P("div", null, u ? P(Vi, {
      unified: n == null ? void 0 : n.unified,
      emoji: d,
      emojiStyle: i,
      size: 45,
      getEmojiUrl: f,
      className: pe(Ao.emoji)
    }) : y ? P(Vi, {
      unified: tt(y),
      emoji: y,
      emojiStyle: i,
      size: 45,
      getEmojiUrl: f,
      className: pe(Ao.emoji)
    }) : null), P("div", {
      className: pe(Ao.label)
    }, u ? Ri(d) : m));
  }
}
var Ao = /* @__PURE__ */ Te.create({
  preview: {
    alignItems: "center",
    borderTop: "1px solid var(--epr-preview-border-color)",
    height: "var(--epr-preview-height)",
    padding: "0 var(--epr-horizontal-padding)",
    position: "relative",
    zIndex: "var(--epr-preview-z-index)"
  },
  label: {
    color: "var(--epr-preview-text-color)",
    fontSize: "var(--epr-preview-text-size)",
    padding: "var(--epr-preview-text-padding)",
    textTransform: "capitalize"
  },
  emoji: {
    padding: "0"
  }
});
function xMe(e) {
  var t;
  return (t = e == null ? void 0 : e.getAttribute("data-name")) != null ? t : null;
}
function CMe(e) {
  var t = Nt();
  Ne(function() {
    var a = /* @__PURE__ */ new Map(), n = t.current, o = new IntersectionObserver(function(i) {
      if (n) {
        for (var s = Eke(i), c; !(c = s()).done; ) {
          var f = c.value, d = xMe(f.target);
          a.set(d, f.intersectionRatio);
        }
        var u = Array.from(a), h = u[u.length - 1];
        if (h[1] == 1)
          return e(h[0]);
        for (var y = 0, m = u; y < m.length; y++) {
          var v = m[y], k = v[0], g = v[1];
          if (g) {
            e(k);
            break;
          }
        }
      }
    }, {
      threshold: [0, 1]
    });
    n == null || n.querySelectorAll(Xe(ce.category)).forEach(function(i) {
      o.observe(i);
    });
  }, [t, e]);
}
function bMe() {
  var e = Nt(), t = $n();
  return function(n) {
    var o;
    if (e.current) {
      var i = (o = e.current) == null ? void 0 : o.querySelector('[data-name="' + n + '"]');
      if (i) {
        var s = i.offsetTop || 0;
        ky(t.current, s);
      }
    }
  };
}
function LMe() {
  var e = xge();
  return e ? e.length === 0 : !1;
}
var jMe = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIyMDBweCIgaGVpZ2h0PSI4MHB4IiB2aWV3Qm94PSIwIDAgMjAwIDgwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyMDAgODAiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8ZyBpZD0iTGF5ZXJfMTEiPgoJPGc+CgkJPHBhdGggZmlsbD0iIzMzNzFCNyIgc3Ryb2tlPSIjMzM3MUI3IiBzdHJva2Utd2lkdGg9IjAuMSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMTIuOCwyOS41YzAuNiwwLDEuMS0wLjUsMS4xLTEuMQoJCQljMC0wLjYtMC41LTEuMi0xLjEtMS4yYy0wLjYsMC0xLjIsMC41LTEuMiwxLjJDMTEuNiwyOSwxMi4yLDI5LjUsMTIuOCwyOS41eiBNMTIuOCwyOGMwLjIsMCwwLjQsMC4yLDAuNCwwLjQKCQkJYzAsMC4yLTAuMiwwLjQtMC40LDAuNGMtMC4yLDAtMC40LTAuMi0wLjQtMC40QzEyLjQsMjguMSwxMi42LDI4LDEyLjgsMjh6Ii8+CgkJPHBhdGggZmlsbD0iIzMzNzFCNyIgc3Ryb2tlPSIjMzM3MUI3IiBzdHJva2Utd2lkdGg9IjAuMSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMTAsMjNjLTMuOCwwLTcsMy4xLTcsN2MwLDMuOCwzLjEsNyw3LDcKCQkJczctMy4xLDctN0MxNywyNi4yLDEzLjgsMjMsMTAsMjN6IE0xMCwzNi4yYy0zLjQsMC02LjItMi44LTYuMi02LjJjMC0zLjQsMi44LTYuMiw2LjItNi4yczYuMiwyLjgsNi4yLDYuMgoJCQlDMTYuMiwzMy40LDEzLjQsMzYuMiwxMCwzNi4yeiIvPgoJCTxwYXRoIGZpbGw9IiMzMzcxQjciIHN0cm9rZT0iIzMzNzFCNyIgc3Ryb2tlLXdpZHRoPSIwLjEiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTE0LjYsMzEuMmMtMC4xLTAuMS0wLjItMC4yLTAuMy0wLjJINS43CgkJCWMtMC4xLDAtMC4yLDAuMS0wLjMsMC4yYy0wLjEsMC4xLTAuMSwwLjIsMCwwLjRjMC43LDIsMi41LDMuMyw0LjYsMy4zczMuOS0xLjMsNC42LTMuM0MxNC43LDMxLjUsMTQuNywzMS4zLDE0LjYsMzEuMnogTTEwLDM0LjEKCQkJYy0xLjYsMC0zLTAuOS0zLjctMi4yaDcuM0MxMywzMy4yLDExLjYsMzQuMSwxMCwzNC4xeiIvPgoJCTxwYXRoIGZpbGw9IiMzMzcxQjciIHN0cm9rZT0iIzMzNzFCNyIgc3Ryb2tlLXdpZHRoPSIwLjEiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTcuMiwyOS41YzAuNiwwLDEuMi0wLjUsMS4yLTEuMQoJCQljMC0wLjYtMC41LTEuMi0xLjItMS4yYy0wLjYsMC0xLjEsMC41LTEuMSwxLjJDNi4xLDI5LDYuNiwyOS41LDcuMiwyOS41eiBNNy4yLDI4YzAuMiwwLDAuNCwwLjIsMC40LDAuNGMwLDAuMi0wLjIsMC40LTAuNCwwLjQKCQkJYy0wLjIsMC0wLjQtMC4yLTAuNC0wLjRDNi44LDI4LjEsNywyOCw3LjIsMjh6Ii8+Cgk8L2c+Cgk8Zz4KCQk8Zz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMzM3MUI3IiBkPSJNNjQuMSwzMy40bDIuMywwYzAuMiwwLDAuNCwwLjIsMC40LDAuNHYyLjFjMCwwLjItMC4yLDAuNC0wLjQsMC40aC0yLjMKCQkJCWMtMC4yLDAtMC40LTAuMi0wLjQtMC40di0yLjFDNjMuNywzMy42LDYzLjgsMzMuNCw2NC4xLDMzLjR6Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzMzNzFCNyIgZD0iTTczLjUsMzMuNWgyLjRjMC4yLDAsMC40LDAuMiwwLjQsMC40djJjMCwwLjItMC4yLDAuNC0wLjQsMC40aC0yLjQKCQkJCWMtMC4yLDAtMC40LTAuMi0wLjQtMC40bDAtMkM3My4xLDMzLjYsNzMuMywzMy41LDczLjUsMzMuNXoiLz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMzM3MUI3IiBkPSJNNjMuNywyOC40aDEyLjZ2NUg2My43VjI4LjR6Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzMzNzFCNyIgZD0iTTY1LjUsMjMuNmg4LjljMSwwLDEuOSwwLjgsMS45LDEuOXYzLjFINjMuN3YtMy4xQzYzLjcsMjQuNSw2NC41LDIzLjYsNjUuNSwyMy42eiIvPgoJCQk8ZWxsaXBzZSBmaWxsPSIjMzM3MUI3IiBjeD0iNjYuMiIgY3k9IjMwLjkiIHJ4PSIwLjkiIHJ5PSIxIi8+CgkJCTxlbGxpcHNlIGZpbGw9IiMzMzcxQjciIGN4PSI3My44IiBjeT0iMzAuOSIgcng9IjAuOSIgcnk9IjEiLz4KCQk8L2c+Cgk8L2c+Cgk8Zz4KCQk8Zz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMzM3MUI3IiBkPSJNOTYuNCwzMGMwLDMuNi0yLjksNi41LTYuNCw2LjVzLTYuNC0yLjktNi40LTYuNXMyLjktNi41LDYuNC02LjVTOTYuNCwyNi40LDk2LjQsMzB6Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzMzNzFCNyIgZD0iTTk2LjMsMjguNmMwLDAsMCwwLjEsMCwwLjFjLTAuOSwwLjEtMi45LDAuMS00LjYtMS4xYy0xLjEtMC44LTItMS43LTIuNi0yLjUKCQkJCWMtMC4zLTAuNC0wLjYtMC44LTAuNy0xYy0wLjEtMC4xLTAuMS0wLjEtMC4xLTAuMmMwLjUtMC4xLDEuMi0wLjIsMi0wLjFjMS4yLDAsMi41LDAuMywzLjUsMS4xYzEsMC44LDEuNywxLjgsMi4xLDIuOAoJCQkJQzk2LjEsMjcuOSw5Ni4yLDI4LjMsOTYuMywyOC42eiIvPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMzMzcxQjciIGQ9Ik04NCwzMi4yYzAsMCwwLTAuMSwwLTAuMWMwLjktMC4yLDIuOS0wLjQsNC43LDAuNmMxLjEsMC43LDEuOSwxLjUsMi40LDIuMwoJCQkJYzAuNCwwLjUsMC42LDEsMC43LDEuM2MtMC40LDAuMS0xLDAuMi0xLjcsMC4zYy0xLDAtMi4xLTAuMS0zLjItMC44cy0xLjktMS42LTIuNC0yLjVDODQuMiwzMi44LDg0LjEsMzIuNSw4NCwzMi4yeiIvPgoJCTwvZz4KCTwvZz4KCTxnPgoJCTxnPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMzMzcxQjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgZD0iTTExNi4zLDI2LjhsLTEuNCwybC0wLjgtMC44bC0wLjYtMC42bDAsMC45bC0wLjEsOC4yaC02LjgKCQkJCWwtMC4xLTguMmwwLTAuOWwtMC42LDAuNmwtMC44LDAuOGwtMS40LTJsMi42LTIuOWMwLjEtMC4xLDAuMi0wLjEsMC4zLTAuMWgxLjNsMC40LDAuN2MwLjcsMS4zLDIuNiwxLjMsMy4zLTAuMWwwLjMtMC42aDEuMgoJCQkJYzAuMSwwLDAuMiwwLDAuMywwLjFsMC4zLTAuM2wtMC4zLDAuM0wxMTYuMywyNi44eiIvPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMzMzcxQjciIGQ9Ik0xMTAuMSwyNy43aDJ2MC45YzAsMC40LTAuNCwwLjctMSwwLjdjLTAuNiwwLTEtMC4zLTEtMC43TDExMC4xLDI3LjdMMTEwLjEsMjcuN3oiLz4KCQk8L2c+Cgk8L2c+Cgk8Zz4KCQk8Zz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMzM3MUI3IiBkPSJNMTI2LjgsMzQuM2MwLDEuMi0xLDIuMi0yLjIsMi4ycy0yLjItMS0yLjItMi4yczEtMi4yLDIuMi0yLjJTMTI2LjgsMzMuMSwxMjYuOCwzNC4zeiIvPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMzMzcxQjciIGQ9Ik0xMzcuNiwzNC4zYzAsMS4yLTEsMi4yLTIuMiwyLjJjLTEuMiwwLTIuMi0xLTIuMi0yLjJzMS0yLjIsMi4yLTIuMgoJCQkJQzEzNi42LDMyLjEsMTM3LjYsMzMuMSwxMzcuNiwzNC4zeiIvPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMzMzcxQjciIGQ9Ik0xMjYuOCwyNC40djkuOSIvPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMzMzcxQjciIGQ9Ik0xMzcuNywyNC40djkuOSIvPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMzMzcxQjciIGQ9Ik0xMjYuOCwyMy41aDEwLjh2Mi43aC0xMC44QzEyNi44LDI2LjIsMTI2LjgsMjMuNSwxMjYuOCwyMy41eiIvPgoJCTwvZz4KCTwvZz4KCTxnPgoJCTxnPgoJCQk8cGF0aCBmaWxsPSIjMzM3MUI3IiBkPSJNMTcwLjgsMjMuMUwxNzAuOCwyMy4xYy0wLjMsMC0wLjUsMC0wLjgsMGMtMi4xLDAtNCwxLTUuMywyLjVsLTAuMSwwbC0wLjEtMC4xbC0xLTEuMmwtMC4zLDMuNGwzLjQsMC4zCgkJCQlsLTEuMS0xLjNsLTAuMS0wLjFsMC4xLTAuMWMxLjEtMS41LDMtMi4zLDUtMi4xbDAsMGMzLjIsMC4zLDUuNSwzLjEsNS4yLDYuM2MtMC4zLDMtMy4xLDUuMy02LjEsNS4xYy0zLjEtMC4yLTUuNC0yLjktNS4zLTYKCQkJCWwtMS4zLTAuMWMtMC4yLDMuOCwyLjYsNy4xLDYuMyw3LjRjMy45LDAuMyw3LjMtMi42LDcuNi02LjVDMTc3LjIsMjYuOCwxNzQuNCwyMy41LDE3MC44LDIzLjF6Ii8+CgkJCTxwYXRoIGZpbGw9IiMzMzcxQjciIGQ9Ik0xNzAuMywyNy40YzAtMC4zLTAuMy0wLjYtMC42LTAuNnMtMC42LDAuMy0wLjYsMC42djMuMmMwLDAuMiwwLjEsMC4zLDAuMiwwLjRjMC4xLDAuMSwwLjMsMC4yLDAuNCwwLjIKCQkJCWgyLjRjMC40LDAsMC42LTAuMywwLjYtMC42YzAtMC40LTAuMy0wLjYtMC42LTAuNmgtMS42aC0wLjJ2LTAuMkwxNzAuMywyNy40TDE3MC4zLDI3LjR6Ii8+CgkJPC9nPgoJPC9nPgoJPGc+CgkJPGc+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzMzNzFCNyIgZD0iTTE4Ni4yLDIzLjRoNy43YzEuNSwwLDIuNywxLjIsMi43LDIuN3Y3LjdjMCwxLjUtMS4yLDIuNy0yLjcsMi43aC03LjcKCQkJCWMtMS41LDAtMi43LTEuMi0yLjctMi43di03LjdDMTgzLjQsMjQuNiwxODQuNywyMy40LDE4Ni4yLDIzLjR6Ii8+CgkJCTxlbGxpcHNlIGZpbGw9IiMzMzcxQjciIGN4PSIxODYiIGN5PSIyOC45IiByeD0iMC43IiByeT0iMC43Ii8+CgkJCTxlbGxpcHNlIGZpbGw9IiMzMzcxQjciIGN4PSIxOTQiIGN5PSIyNi43IiByeD0iMC43IiByeT0iMC43Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzMzNzFCNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMTg2LDMzLjNsMC40LTAuM2MwLjQtMC4zLDEtMC4zLDEuNS0wLjFsMSwwLjQKCQkJCWMwLjUsMC4yLDEsMC4yLDEuNS0wLjFsMC44LTAuNWMwLjQtMC4zLDEtMC4zLDEuNS0wLjFsMS44LDAuOCIvPgoJCTwvZz4KCTwvZz4KCTxwYXRoIGZpbGw9IiMzMzcxQjciIHN0cm9rZT0iIzMzNzFCNyIgc3Ryb2tlLXdpZHRoPSIwLjI1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0xNTYsMjQuM2MtMC4yLTAuMS0wLjQtMC4xLTAuNSwwCgkJYzAsMC0wLjIsMC4xLTAuOSwwLjJjLTAuNywwLTIuNC0wLjEtMy44LTAuNmMtMC44LTAuMy0xLjctMC41LTIuNS0wLjVjLTAuMiwwLTAuNCwwLTAuNSwwYy0xLjMsMC0yLjUsMC4zLTMuNiwxCgkJYy0wLjIsMC4xLTAuMiwwLjItMC4yLDAuNHYxMS42YzAsMC4zLDAuMSwwLjUsMC4zLDAuNWMwLjYsMCwwLjUtMC40LDAuNS0wLjZ2LTUuN2MwLjctMC4zLDMuMi0xLjEsNS44LTAuMQoJCWMxLjYsMC42LDMuNSwwLjcsNC4zLDAuN2MwLjgsMCwxLjMtMC4zLDEuMy0wLjNjMC4yLTAuMSwwLjMtMC4yLDAuMy0wLjR2LTUuN0MxNTYuMiwyNC42LDE1Ni4xLDI0LjQsMTU2LDI0LjN6IE0xNTUuNiwzMC4yCgkJYy0wLjEsMC0wLjcsMC4xLTEsMC4xYy0wLjcsMC0yLjQtMC4xLTMuOC0wLjZjLTIuNS0xLTUtMC41LTYuMi0wLjF2LTQuOWMwLjktMC41LDIuMi0wLjcsMy4yLTAuN2MwLjEsMCwwLjMsMCwwLjQsMAoJCWMwLjcsMCwxLjUsMC4yLDIuMiwwLjRjMS42LDAuNiwzLjUsMC43LDQuMywwLjdjMC4yLDAsMC44LDAsMS0wLjFWMzAuMnoiLz4KCTxnPgoJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzMzNzFCNyIgZD0iTTQ4LjEsMjMuNWgzLjdjMi41LDAsNC41LDIsNC41LDQuNWMwLDAuNS0wLjQsMC45LTAuOSwwLjlINDQuNWMtMC41LDAtMC45LTAuNC0wLjktMC45CgkJCUM0My42LDI1LjUsNDUuNiwyMy41LDQ4LjEsMjMuNXoiLz4KCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMzMzcxQjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgZD0iTTQzLjUsMjguOGMtMC4yLDAuMS0wLjUsMS4yLDAsMS41YzEuNCwxLDguNSwwLjgsMTEuMywwLjYKCQkJYzAuOC0wLjEsMS42LTAuNCwxLjctMS4yYzAtMC4zLTAuMS0wLjYtMC42LTAuOSIvPgoJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzMzNzFCNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNNDMuNSwzMC42TDQzLjMsMzFjLTAuMiwwLjUsMC4yLDEsMC43LDAuOWMwLjMtMC4xLDAuNSwwLDAuNywwLjMKCQkJbDAuMSwwLjJjMC4zLDAuNSwxLDAuNiwxLjUsMC4ybDAsMGMwLjMtMC4yLDAuNy0wLjMsMS0wLjJsMC44LDAuM2MwLjQsMC4yLDAuOCwwLjEsMS4yLDBsMC41LTAuMmMwLjQtMC4yLDAuOS0wLjIsMS4zLDBsMC41LDAuMgoJCQljMC40LDAuMiwwLjgsMC4yLDEuMiwwbDAuMi0wLjFjMC4zLTAuMiwwLjgtMC4yLDEuMSwwLjFsMC4yLDAuMmMwLjMsMC4zLDAuOCwwLjIsMS0wLjJsMC4xLTAuMmMwLjEtMC4yLDAtMC4zLDAuMi0wLjMKCQkJYzAuNSwwLDEuMi0wLjMsMS4xLTAuN2wtMC40LTEuMSIvPgoJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzMzNzFCNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNNDMuNSwzMi4yYy0wLjEsMC4yLTAuMywwLjgsMCwxLjFjMC4zLDAuNCwzLDEuMSw2LjQsMS4xCgkJCWMyLjIsMCw0LjYtMC4zLDYtMC42YzAuNS0wLjEsMC45LTAuNSwwLjgtMC45YzAtMC4yLTAuMi0wLjUtMC40LTAuNyIvPgoJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzMzNzFCNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNNDMuNSwzMy4zYzAsMC41LDAuNiwyLjMsMS4zLDIuN2MxLjgsMC44LDUuNywwLjcsOC4xLDAuNQoJCQljMS4zLTAuMSwyLjUtMC43LDMuMi0xLjhjMC4zLTAuNSwwLjUtMSwwLjUtMS40Ii8+CgkJPGVsbGlwc2UgZmlsbD0iIzMzNzFCNyIgY3g9IjUxLjYiIGN5PSIyNi41IiByeD0iMC4zIiByeT0iMC40Ii8+CgkJPGVsbGlwc2UgZmlsbD0iIzMzNzFCNyIgY3g9IjUzIiBjeT0iMjUiIHJ4PSIwLjMiIHJ5PSIwLjQiLz4KCQk8ZWxsaXBzZSBmaWxsPSIjMzM3MUI3IiBjeD0iNTMiIGN5PSIyNy4yIiByeD0iMC4zIiByeT0iMC40Ii8+CgkJPGVsbGlwc2UgZmlsbD0iIzMzNzFCNyIgY3g9IjU0LjMiIGN5PSIyNi41IiByeD0iMC4zIiByeT0iMC40Ii8+CgkJPGVsbGlwc2UgZmlsbD0iIzMzNzFCNyIgY3g9IjUwLjkiIGN5PSIyNSIgcng9IjAuMyIgcnk9IjAuNCIvPgoJPC9nPgoJPGc+CgkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMzM3MUI3IiBkPSJNMjQuMiwzMXYtNy42YzAuMSwwLjEsMC44LDAuOSwyLjgsMy4xYzIuNS0xLjYsNS42LTAuNyw2LjksMGwyLjQtMy4xdjcuMQoJCQljMCwxLjItMC4xLDIuNS0wLjksMy40Yy0xLDEuMi0yLjcsMi41LTUuMywyLjVjLTIuOSwwLTQuNS0xLjUtNS4zLTIuOUMyNC4yLDMyLjksMjQuMiwzMiwyNC4yLDMxeiIvPgoJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzMzNzFCNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMjEuMiwzMGw1LjQsMS4yIi8+CgkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMzM3MUI3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik0yMS4yLDM0LjFsNS40LTEuMiIvPgoJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzMzNzFCNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMzguOCwzMGwtNS40LDEuMiIvPgoJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzMzNzFCNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMzguOCwzNC4xbC01LjQtMS4yIi8+CgkJPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiMzMzcxQjciIGQ9Ik0yOS41LDMyLjRMMjksMzEuN2MtMC4yLTAuMywwLTAuNiwwLjMtMC42aDEuNAoJCQljMC4zLDAsMC41LDAuNCwwLjMsMC42bC0wLjcsMWwwLDBjLTAuNywxLjItMi42LDEuMS0zLjEtMC4zbC0wLjEtMC4yYy0wLjEtMC4yLDAtMC40LDAuMi0wLjVzMC40LDAsMC41LDAuMmwwLjEsMC4yCgkJCUMyOC4zLDMyLjgsMjkuMSwzMi45LDI5LjUsMzIuNHoiLz4KCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMzMzcxQjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgZD0iTTMyLjQsMzIuMWwtMC4xLDAuMmMtMC40LDEtMS44LDEuMS0yLjMsMC4yIi8+CgkJPGVsbGlwc2UgZmlsbD0iIzMzNzFCNyIgY3g9IjI3LjYiIGN5PSIyOS43IiByeD0iMC43IiByeT0iMC43Ii8+CgkJPGVsbGlwc2UgZmlsbD0iIzMzNzFCNyIgY3g9IjMyLjQiIGN5PSIyOS43IiByeD0iMC43IiByeT0iMC43Ii8+Cgk8L2c+Cgk8Zz4KCQk8cGF0aCBmaWxsPSIjQzBDMEJGIiBzdHJva2U9IiNDMEMwQkYiIHN0cm9rZS13aWR0aD0iMC4xIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0xMi44LDQ5LjVjMC42LDAsMS4xLTAuNSwxLjEtMS4xCgkJCWMwLTAuNi0wLjUtMS4yLTEuMS0xLjJjLTAuNiwwLTEuMiwwLjUtMS4yLDEuMkMxMS42LDQ5LDEyLjIsNDkuNSwxMi44LDQ5LjV6IE0xMi44LDQ4YzAuMiwwLDAuNCwwLjIsMC40LDAuNAoJCQljMCwwLjItMC4yLDAuNC0wLjQsMC40Yy0wLjIsMC0wLjQtMC4yLTAuNC0wLjRDMTIuNCw0OC4xLDEyLjYsNDgsMTIuOCw0OHoiLz4KCQk8cGF0aCBmaWxsPSIjQzBDMEJGIiBzdHJva2U9IiNDMEMwQkYiIHN0cm9rZS13aWR0aD0iMC4xIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0xNC42LDUxLjJjLTAuMS0wLjEtMC4yLTAuMi0wLjMtMC4ySDUuNwoJCQljLTAuMSwwLTAuMiwwLjEtMC4zLDAuMmMtMC4xLDAuMS0wLjEsMC4yLDAsMC40YzAuNywyLDIuNSwzLjMsNC42LDMuM3MzLjktMS4zLDQuNi0zLjNDMTQuNyw1MS41LDE0LjcsNTEuMywxNC42LDUxLjJ6IE0xMCw1NC4xCgkJCWMtMS42LDAtMy0wLjktMy43LTIuMmg3LjNDMTMsNTMuMiwxMS42LDU0LjEsMTAsNTQuMXoiLz4KCQk8cGF0aCBmaWxsPSIjQzBDMEJGIiBzdHJva2U9IiNDMEMwQkYiIHN0cm9rZS13aWR0aD0iMC4xIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik03LjIsNDkuNWMwLjYsMCwxLjItMC41LDEuMi0xLjEKCQkJYzAtMC42LTAuNS0xLjItMS4yLTEuMmMtMC42LDAtMS4xLDAuNS0xLjEsMS4yQzYuMSw0OSw2LjYsNDkuNSw3LjIsNDkuNXogTTcuMiw0OGMwLjIsMCwwLjQsMC4yLDAuNCwwLjRjMCwwLjItMC4yLDAuNC0wLjQsMC40CgkJCWMtMC4yLDAtMC40LTAuMi0wLjQtMC40QzYuOCw0OC4xLDcsNDgsNy4yLDQ4eiIvPgoJCTxwYXRoIGZpbGw9IiNDMEMwQkYiIHN0cm9rZT0iI0MwQzBCRiIgc3Ryb2tlLXdpZHRoPSIwLjEiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTEwLDQzYy0zLjgsMC03LDMuMS03LDdjMCwzLjgsMy4xLDcsNyw3CgkJCXM3LTMuMSw3LTdDMTcsNDYuMiwxMy44LDQzLDEwLDQzeiBNMTAsNTYuMmMtMy40LDAtNi4yLTIuOC02LjItNi4yYzAtMy40LDIuOC02LjIsNi4yLTYuMnM2LjIsMi44LDYuMiw2LjIKCQkJQzE2LjIsNTMuNCwxMy40LDU2LjIsMTAsNTYuMnoiLz4KCTwvZz4KCTxnPgoJCTxnPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNDMEMwQkYiIGQ9Ik02NC4xLDUzLjRsMi4zLDBjMC4yLDAsMC40LDAuMiwwLjQsMC40djIuMWMwLDAuMi0wLjIsMC40LTAuNCwwLjRoLTIuMwoJCQkJYy0wLjIsMC0wLjQtMC4yLTAuNC0wLjR2LTIuMUM2My43LDUzLjYsNjMuOCw1My40LDY0LjEsNTMuNHoiLz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjQzBDMEJGIiBkPSJNNzMuNSw1My41aDIuNGMwLjIsMCwwLjQsMC4yLDAuNCwwLjR2MmMwLDAuMi0wLjIsMC40LTAuNCwwLjRoLTIuNAoJCQkJYy0wLjIsMC0wLjQtMC4yLTAuNC0wLjRsMC0yQzczLjEsNTMuNiw3My4zLDUzLjUsNzMuNSw1My41eiIvPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNDMEMwQkYiIGQ9Ik02My43LDQ4LjRoMTIuNnY1SDYzLjdWNDguNHoiLz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjQzBDMEJGIiBkPSJNNjUuNSw0My42aDguOWMxLDAsMS45LDAuOCwxLjksMS45djMuMUg2My43di0zLjFDNjMuNyw0NC41LDY0LjUsNDMuNiw2NS41LDQzLjZ6Ii8+CgkJCTxlbGxpcHNlIGZpbGw9IiNDMEMwQkYiIGN4PSI2Ni4yIiBjeT0iNTAuOSIgcng9IjAuOSIgcnk9IjEiLz4KCQkJPGVsbGlwc2UgZmlsbD0iI0MwQzBCRiIgY3g9IjczLjgiIGN5PSI1MC45IiByeD0iMC45IiByeT0iMSIvPgoJCTwvZz4KCTwvZz4KCTxnPgoJCTxnPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNDMEMwQkYiIGQ9Ik05Ni40LDUwYzAsMy42LTIuOSw2LjUtNi40LDYuNXMtNi40LTIuOS02LjQtNi41czIuOS02LjUsNi40LTYuNVM5Ni40LDQ2LjQsOTYuNCw1MHoiLz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjQzBDMEJGIiBkPSJNOTYuMyw0OC42YzAsMCwwLDAuMSwwLDAuMWMtMC45LDAuMS0yLjksMC4xLTQuNi0xLjJjLTEuMS0wLjgtMi0xLjctMi42LTIuNQoJCQkJYy0wLjMtMC40LTAuNi0wLjgtMC43LTFjLTAuMS0wLjEtMC4xLTAuMi0wLjEtMC4yYzAuNS0wLjEsMS4yLTAuMiwyLTAuMmMxLjIsMCwyLjUsMC4zLDMuNSwxLjFjMSwwLjgsMS43LDEuOCwyLjEsMi44CgkJCQlDOTYuMSw0Ny45LDk2LjIsNDguMyw5Ni4zLDQ4LjZ6Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0MwQzBCRiIgZD0iTTg0LDUyLjJjMCwwLDAtMC4xLDAtMC4xYzAuOS0wLjIsMi45LTAuNCw0LjcsMC42YzEuMSwwLjcsMS45LDEuNSwyLjQsMi4zCgkJCQljMC40LDAuNSwwLjYsMSwwLjcsMS4zYy0wLjQsMC4xLTEsMC4yLTEuNywwLjNjLTEsMC0yLjEtMC4xLTMuMi0wLjhzLTEuOS0xLjYtMi40LTIuNUM4NC4yLDUyLjgsODQuMSw1Mi41LDg0LDUyLjJ6Ii8+CgkJPC9nPgoJPC9nPgoJPGc+CgkJPGc+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0MwQzBCRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMTE2LjMsNDYuOGwtMS40LDJsLTAuOC0wLjhsLTAuNi0wLjdsMCwwLjlsLTAuMSw4LjJoLTYuOAoJCQkJbC0wLjEtOC4ybDAtMC45bC0wLjYsMC43bC0wLjgsMC44bC0xLjQtMmwyLjYtMi45YzAuMS0wLjEsMC4yLTAuMSwwLjMtMC4xaDEuM2wwLjQsMC43YzAuNywxLjMsMi42LDEuMywzLjMtMC4xbDAuMy0wLjZoMS4yCgkJCQljMC4xLDAsMC4yLDAsMC4zLDAuMWwwLjMtMC4zbC0wLjMsMC4zTDExNi4zLDQ2Ljh6Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0MwQzBCRiIgZD0iTTExMC4xLDQ3LjdoMnYwLjljMCwwLjQtMC40LDAuNy0xLDAuN2MtMC42LDAtMS0wLjMtMS0wLjdMMTEwLjEsNDcuN0wxMTAuMSw0Ny43eiIvPgoJCTwvZz4KCTwvZz4KCTxnPgoJCTxnPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNDMEMwQkYiIGQ9Ik0xMjYuOCw1NC4zYzAsMS4yLTEsMi4yLTIuMiwyLjJzLTIuMi0xLTIuMi0yLjJzMS0yLjIsMi4yLTIuMlMxMjYuOCw1My4xLDEyNi44LDU0LjN6Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0MwQzBCRiIgZD0iTTEzNy42LDU0LjNjMCwxLjItMSwyLjItMi4yLDIuMmMtMS4yLDAtMi4yLTEtMi4yLTIuMnMxLTIuMiwyLjItMi4yCgkJCQlDMTM2LjYsNTIuMSwxMzcuNiw1My4xLDEzNy42LDU0LjN6Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0MwQzBCRiIgZD0iTTEyNi44LDQ0LjR2OS45Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0MwQzBCRiIgZD0iTTEzNy43LDQ0LjR2OS45Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0MwQzBCRiIgZD0iTTEyNi44LDQzLjVoMTAuOHYyLjdoLTEwLjhDMTI2LjgsNDYuMiwxMjYuOCw0My41LDEyNi44LDQzLjV6Ii8+CgkJPC9nPgoJPC9nPgoJPGc+CgkJPGc+CgkJCTxwYXRoIGZpbGw9IiNDMEMwQkYiIGQ9Ik0xNzAuOCw0My4xTDE3MC44LDQzLjFjLTAuMywwLTAuNSwwLTAuOCwwYy0yLjEsMC00LDEtNS4zLDIuNWwtMC4xLDBsLTAuMS0wLjFsLTEtMS4ybC0wLjMsMy40bDMuNCwwLjMKCQkJCWwtMS4xLTEuM2wtMC4xLTAuMWwwLjEtMC4xYzEuMS0xLjUsMy0yLjMsNS0yLjFsMCwwYzMuMiwwLjMsNS41LDMuMSw1LjIsNi4zYy0wLjMsMy0zLjEsNS4zLTYuMSw1LjFjLTMuMS0wLjItNS40LTIuOS01LjMtNgoJCQkJbC0xLjMtMC4xYy0wLjIsMy44LDIuNiw3LjEsNi4zLDcuNGMzLjksMC4zLDcuMy0yLjYsNy42LTYuNUMxNzcuMiw0Ni44LDE3NC40LDQzLjUsMTcwLjgsNDMuMXoiLz4KCQkJPHBhdGggZmlsbD0iI0MwQzBCRiIgZD0iTTE3MC4zLDQ3LjRjMC0wLjMtMC4zLTAuNi0wLjYtMC42cy0wLjYsMC4zLTAuNiwwLjZ2My4yYzAsMC4yLDAuMSwwLjMsMC4yLDAuNGMwLjEsMC4xLDAuMywwLjIsMC40LDAuMgoJCQkJaDIuNGMwLjQsMCwwLjYtMC4zLDAuNi0wLjZjMC0wLjMtMC4zLTAuNi0wLjYtMC42aC0xLjZoLTAuMnYtMC4yTDE3MC4zLDQ3LjRMMTcwLjMsNDcuNHoiLz4KCQk8L2c+Cgk8L2c+Cgk8Zz4KCQk8Zz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjQzBDMEJGIiBkPSJNMTg2LjIsNDMuNGg3LjdjMS41LDAsMi43LDEuMiwyLjcsMi43djcuN2MwLDEuNS0xLjIsMi43LTIuNywyLjdoLTcuNwoJCQkJYy0xLjUsMC0yLjctMS4yLTIuNy0yLjd2LTcuN0MxODMuNCw0NC43LDE4NC43LDQzLjQsMTg2LjIsNDMuNHoiLz4KCQkJPGVsbGlwc2UgZmlsbD0iI0MwQzBCRiIgY3g9IjE4NiIgY3k9IjQ4LjkiIHJ4PSIwLjciIHJ5PSIwLjciLz4KCQkJPGVsbGlwc2UgZmlsbD0iI0MwQzBCRiIgY3g9IjE5NCIgY3k9IjQ2LjciIHJ4PSIwLjciIHJ5PSIwLjciLz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjQzBDMEJGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik0xODYsNTMuM2wwLjQtMC4zYzAuNC0wLjMsMS0wLjMsMS41LTAuMWwxLDAuNAoJCQkJYzAuNSwwLjIsMSwwLjIsMS41LTAuMWwwLjgtMC41YzAuNC0wLjMsMS0wLjMsMS41LTAuMWwxLjgsMC44Ii8+CgkJPC9nPgoJPC9nPgoJPHBhdGggZmlsbD0iI0MwQzBCRiIgc3Ryb2tlPSIjQzBDMEJGIiBzdHJva2Utd2lkdGg9IjAuMjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTE1Niw0NC4zYy0wLjItMC4xLTAuNC0wLjEtMC41LDAKCQljMCwwLTAuMiwwLjEtMC45LDAuMmMtMC43LDAtMi40LTAuMS0zLjgtMC42Yy0wLjgtMC4zLTEuNy0wLjUtMi41LTAuNWMtMC4yLDAtMC40LDAtMC41LDBjLTEuMywwLTIuNSwwLjMtMy42LDEKCQljLTAuMiwwLjEtMC4yLDAuMi0wLjIsMC40djExLjZjMCwwLjMsMC4xLDAuNSwwLjMsMC41YzAuNiwwLDAuNS0wLjQsMC41LTAuNnYtNS43YzAuNy0wLjMsMy4yLTEuMSw1LjgtMC4xCgkJYzEuNiwwLjYsMy41LDAuNyw0LjMsMC43YzAuOCwwLDEuMy0wLjMsMS4zLTAuM2MwLjItMC4xLDAuMy0wLjIsMC4zLTAuNHYtNS43QzE1Ni4yLDQ0LjYsMTU2LjEsNDQuNCwxNTYsNDQuM3ogTTE1NS42LDUwLjIKCQljLTAuMSwwLTAuNywwLjEtMSwwLjFjLTAuNywwLTIuNC0wLjEtMy44LTAuNmMtMi41LTEtNS0wLjUtNi4yLTAuMXYtNC45YzAuOS0wLjUsMi4yLTAuNywzLjItMC43YzAuMSwwLDAuMywwLDAuNCwwCgkJYzAuNywwLDEuNSwwLjIsMi4yLDAuNGMxLjYsMC42LDMuNSwwLjcsNC4zLDAuN2MwLjIsMCwwLjgsMCwxLTAuMVY1MC4yeiIvPgoJPGc+CgkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjQzBDMEJGIiBkPSJNNDguMSw0My41aDMuN2MyLjUsMCw0LjUsMiw0LjUsNC41YzAsMC41LTAuNCwwLjktMC45LDAuOUg0NC41Yy0wLjUsMC0wLjktMC40LTAuOS0wLjkKCQkJQzQzLjYsNDUuNSw0NS42LDQzLjUsNDguMSw0My41eiIvPgoJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0MwQzBCRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNNDMuNSw0OC44Yy0wLjIsMC4xLTAuNSwxLjIsMCwxLjVjMS40LDEsOC41LDAuOCwxMS4zLDAuNgoJCQljMC44LTAuMSwxLjYtMC40LDEuNy0xLjJjMC0wLjMtMC4xLTAuNi0wLjYtMC45Ii8+CgkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjQzBDMEJGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik00My41LDUwLjZMNDMuMyw1MWMtMC4yLDAuNSwwLjIsMSwwLjcsMC45YzAuMy0wLjEsMC41LDAsMC43LDAuMwoJCQlsMC4xLDAuMmMwLjMsMC41LDEsMC42LDEuNSwwLjJsMCwwYzAuMy0wLjIsMC43LTAuMywxLTAuMmwwLjgsMC4zYzAuNCwwLjIsMC44LDAuMSwxLjIsMGwwLjUtMC4yYzAuNC0wLjIsMC45LTAuMiwxLjMsMGwwLjUsMC4yCgkJCWMwLjQsMC4yLDAuOCwwLjIsMS4yLDBsMC4yLTAuMWMwLjMtMC4yLDAuOC0wLjIsMS4xLDAuMWwwLjIsMC4yYzAuMywwLjMsMC44LDAuMiwxLTAuMmwwLjEtMC4yYzAuMS0wLjIsMC0wLjMsMC4yLTAuMwoJCQljMC41LDAsMS4yLTAuMywxLjEtMC43bC0wLjQtMS4xIi8+CgkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjQzBDMEJGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik00My41LDUyLjJjLTAuMSwwLjItMC4zLDAuOCwwLDEuMWMwLjMsMC40LDMsMS4xLDYuNCwxLjEKCQkJYzIuMiwwLDQuNi0wLjMsNi0wLjZjMC41LTAuMSwwLjktMC41LDAuOC0wLjljMC0wLjItMC4yLTAuNS0wLjQtMC43Ii8+CgkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjQzBDMEJGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik00My41LDUzLjNjMCwwLjUsMC42LDIuMywxLjMsMi43YzEuOCwwLjgsNS43LDAuNyw4LjEsMC41CgkJCWMxLjMtMC4xLDIuNS0wLjcsMy4yLTEuOGMwLjMtMC41LDAuNS0xLDAuNS0xLjQiLz4KCQk8ZWxsaXBzZSBmaWxsPSIjQzBDMEJGIiBjeD0iNTEuNiIgY3k9IjQ2LjUiIHJ4PSIwLjMiIHJ5PSIwLjQiLz4KCQk8ZWxsaXBzZSBmaWxsPSIjQzBDMEJGIiBjeD0iNTMiIGN5PSI0NSIgcng9IjAuMyIgcnk9IjAuNCIvPgoJCTxlbGxpcHNlIGZpbGw9IiNDMEMwQkYiIGN4PSI1MyIgY3k9IjQ3LjIiIHJ4PSIwLjMiIHJ5PSIwLjQiLz4KCQk8ZWxsaXBzZSBmaWxsPSIjQzBDMEJGIiBjeD0iNTQuMyIgY3k9IjQ2LjUiIHJ4PSIwLjMiIHJ5PSIwLjQiLz4KCQk8ZWxsaXBzZSBmaWxsPSIjQzBDMEJGIiBjeD0iNTAuOSIgY3k9IjQ1IiByeD0iMC4zIiByeT0iMC40Ii8+Cgk8L2c+Cgk8Zz4KCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNDMEMwQkYiIGQ9Ik0yNC4yLDUxdi03LjZjMC4xLDAuMSwwLjgsMC45LDIuOCwzLjFjMi41LTEuNyw1LjYtMC43LDYuOSwwbDIuNC0zLjF2Ny4xCgkJCWMwLDEuMi0wLjEsMi41LTAuOSwzLjRjLTEsMS4yLTIuNywyLjUtNS4zLDIuNWMtMi45LDAtNC41LTEuNS01LjMtMi45QzI0LjIsNTIuOSwyNC4yLDUyLDI0LjIsNTF6Ii8+CgkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjQzBDMEJGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik0yMS4yLDUwbDUuNCwxLjIiLz4KCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNDMEMwQkYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgZD0iTTIxLjIsNTQuMWw1LjQtMS4yIi8+CgkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjQzBDMEJGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik0zOC44LDUwbC01LjQsMS4yIi8+CgkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjQzBDMEJGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik0zOC44LDU0LjFsLTUuNC0xLjIiLz4KCQk8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI0MwQzBCRiIgZD0iTTI5LjUsNTIuNEwyOSw1MS43Yy0wLjItMC4zLDAtMC42LDAuMy0wLjZoMS40CgkJCWMwLjMsMCwwLjUsMC40LDAuMywwLjZsLTAuNywxbDAsMGMtMC43LDEuMi0yLjYsMS4xLTMuMS0wLjNsLTAuMS0wLjJjLTAuMS0wLjIsMC0wLjQsMC4yLTAuNXMwLjQsMCwwLjUsMC4ybDAuMSwwLjIKCQkJQzI4LjMsNTIuOCwyOS4xLDUyLjksMjkuNSw1Mi40eiIvPgoJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0MwQzBCRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMzIuNCw1Mi4xbC0wLjEsMC4yYy0wLjQsMS0xLjgsMS4xLTIuMywwLjIiLz4KCQk8ZWxsaXBzZSBmaWxsPSIjQzBDMEJGIiBjeD0iMjcuNiIgY3k9IjQ5LjciIHJ4PSIwLjciIHJ5PSIwLjciLz4KCQk8ZWxsaXBzZSBmaWxsPSIjQzBDMEJGIiBjeD0iMzIuNCIgY3k9IjQ5LjciIHJ4PSIwLjciIHJ5PSIwLjciLz4KCTwvZz4KCTxnPgoJCTxwYXRoIGZpbGw9IiM2QUE5REQiIHN0cm9rZT0iIzZBQTlERCIgc3Ryb2tlLXdpZHRoPSIwLjEiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTE0LjYsNzEuMmMtMC4xLTAuMS0wLjItMC4yLTAuMy0wLjJINS43CgkJCWMtMC4xLDAtMC4yLDAuMS0wLjMsMC4yYy0wLjEsMC4xLTAuMSwwLjIsMCwwLjRjMC43LDIsMi41LDMuMyw0LjYsMy4zczMuOS0xLjMsNC42LTMuM0MxNC43LDcxLjUsMTQuNyw3MS4zLDE0LjYsNzEuMnogTTEwLDc0LjEKCQkJYy0xLjYsMC0zLTAuOS0zLjctMi4yaDcuM0MxMyw3My4yLDExLjYsNzQuMSwxMCw3NC4xeiIvPgoJCTxwYXRoIGZpbGw9IiM2QUE5REQiIHN0cm9rZT0iIzZBQTlERCIgc3Ryb2tlLXdpZHRoPSIwLjEiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTEyLjgsNjkuNWMwLjYsMCwxLjEtMC41LDEuMS0xLjEKCQkJYzAtMC42LTAuNS0xLjItMS4xLTEuMmMtMC42LDAtMS4yLDAuNS0xLjIsMS4yQzExLjYsNjksMTIuMiw2OS41LDEyLjgsNjkuNXogTTEyLjgsNjhjMC4yLDAsMC40LDAuMiwwLjQsMC40CgkJCWMwLDAuMi0wLjIsMC40LTAuNCwwLjRjLTAuMiwwLTAuNC0wLjItMC40LTAuNEMxMi40LDY4LjEsMTIuNiw2OCwxMi44LDY4eiIvPgoJCTxwYXRoIGZpbGw9IiM2QUE5REQiIHN0cm9rZT0iIzZBQTlERCIgc3Ryb2tlLXdpZHRoPSIwLjEiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTcuMiw2OS41YzAuNiwwLDEuMi0wLjUsMS4yLTEuMQoJCQljMC0wLjYtMC41LTEuMi0xLjItMS4yYy0wLjYsMC0xLjEsMC41LTEuMSwxLjJDNi4xLDY5LDYuNiw2OS41LDcuMiw2OS41eiBNNy4yLDY4YzAuMiwwLDAuNCwwLjIsMC40LDAuNGMwLDAuMi0wLjIsMC40LTAuNCwwLjQKCQkJYy0wLjIsMC0wLjQtMC4yLTAuNC0wLjRDNi44LDY4LjEsNyw2OCw3LjIsNjh6Ii8+CgkJPHBhdGggZmlsbD0iIzZBQTlERCIgc3Ryb2tlPSIjNkFBOUREIiBzdHJva2Utd2lkdGg9IjAuMSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMTAsNjNjLTMuOCwwLTcsMy4xLTcsN2MwLDMuOCwzLjEsNyw3LDcKCQkJczctMy4xLDctN0MxNyw2Ni4yLDEzLjgsNjMsMTAsNjN6IE0xMCw3Ni4yYy0zLjQsMC02LjItMi44LTYuMi02LjJjMC0zLjQsMi44LTYuMiw2LjItNi4yczYuMiwyLjgsNi4yLDYuMgoJCQlDMTYuMiw3My40LDEzLjQsNzYuMiwxMCw3Ni4yeiIvPgoJPC9nPgoJPGc+CgkJPGc+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzZBQTlERCIgZD0iTTY0LjEsNzMuNGwyLjMsMGMwLjIsMCwwLjQsMC4yLDAuNCwwLjR2Mi4xYzAsMC4yLTAuMiwwLjQtMC40LDAuNGgtMi4zCgkJCQljLTAuMiwwLTAuNC0wLjItMC40LTAuNHYtMi4xQzYzLjcsNzMuNiw2My44LDczLjQsNjQuMSw3My40eiIvPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiM2QUE5REQiIGQ9Ik03My41LDczLjVoMi40YzAuMiwwLDAuNCwwLjIsMC40LDAuNHYyLjFjMCwwLjItMC4yLDAuNC0wLjQsMC40aC0yLjQKCQkJCWMtMC4yLDAtMC40LTAuMi0wLjQtMC40bDAtMi4xQzczLjEsNzMuNiw3My4zLDczLjUsNzMuNSw3My41eiIvPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiM2QUE5REQiIGQ9Ik02My43LDY4LjRoMTIuNnY1SDYzLjdWNjguNHoiLz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNkFBOUREIiBkPSJNNjUuNSw2My42aDguOWMxLDAsMS45LDAuOCwxLjksMS45djMuMUg2My43di0zLjFDNjMuNyw2NC41LDY0LjUsNjMuNiw2NS41LDYzLjZ6Ii8+CgkJCTxlbGxpcHNlIGZpbGw9IiM2QUE5REQiIGN4PSI2Ni4yIiBjeT0iNzAuOSIgcng9IjAuOSIgcnk9IjAuOSIvPgoJCQk8ZWxsaXBzZSBmaWxsPSIjNkFBOUREIiBjeD0iNzMuOCIgY3k9IjcwLjkiIHJ4PSIwLjkiIHJ5PSIwLjkiLz4KCQk8L2c+Cgk8L2c+Cgk8Zz4KCQk8Zz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNkFBOUREIiBkPSJNOTYuNCw3MGMwLDMuNi0yLjksNi41LTYuNCw2LjVzLTYuNC0yLjktNi40LTYuNXMyLjktNi41LDYuNC02LjVTOTYuNCw2Ni40LDk2LjQsNzB6Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzZBQTlERCIgZD0iTTk2LjMsNjguNmMwLDAsMCwwLjEsMCwwLjFjLTAuOSwwLjEtMi45LDAuMS00LjYtMS4yYy0xLjEtMC44LTItMS43LTIuNi0yLjUKCQkJCWMtMC4zLTAuNC0wLjYtMC44LTAuNy0xLjFjLTAuMS0wLjEtMC4xLTAuMi0wLjEtMC4yYzAuNS0wLjEsMS4yLTAuMiwyLTAuMmMxLjIsMCwyLjUsMC4zLDMuNSwxLjFjMSwwLjgsMS43LDEuOCwyLjEsMi44CgkJCQlDOTYuMSw2Ny45LDk2LjIsNjguMyw5Ni4zLDY4LjZ6Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzZBQTlERCIgZD0iTTg0LDcyLjJjMCwwLDAtMC4xLDAtMC4xYzAuOS0wLjIsMi45LTAuNCw0LjcsMC42YzEuMSwwLjcsMS45LDEuNSwyLjQsMi4zCgkJCQljMC40LDAuNSwwLjYsMSwwLjcsMS4zYy0wLjQsMC4xLTEsMC4yLTEuNywwLjNjLTEsMC0yLjEtMC4xLTMuMi0wLjhzLTEuOS0xLjYtMi40LTIuNUM4NC4yLDcyLjgsODQuMSw3Mi40LDg0LDcyLjJ6Ii8+CgkJPC9nPgoJPC9nPgoJPGc+CgkJPGc+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzZBQTlERCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMTE2LjMsNjYuOGwtMS40LDJsLTAuOC0wLjhsLTAuNi0wLjdsMCwwLjlsLTAuMSw4LjJoLTYuOAoJCQkJbC0wLjEtOC4ybDAtMC45bC0wLjYsMC43bC0wLjgsMC44bC0xLjQtMmwyLjYtMi45YzAuMS0wLjEsMC4yLTAuMSwwLjMtMC4xaDEuM2wwLjQsMC43YzAuNywxLjMsMi42LDEuMywzLjMtMC4xbDAuMy0wLjZoMS4yCgkJCQljMC4xLDAsMC4yLDAsMC4zLDAuMWwwLjMtMC4zbC0wLjMsMC4zTDExNi4zLDY2Ljh6Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzZBQTlERCIgZD0iTTExMC4xLDY3LjdoMnYwLjljMCwwLjQtMC40LDAuNy0xLDAuN2MtMC42LDAtMS0wLjMtMS0wLjdMMTEwLjEsNjcuN0wxMTAuMSw2Ny43eiIvPgoJCTwvZz4KCTwvZz4KCTxnPgoJCTxnPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiM2QUE5REQiIGQ9Ik0xMjYuOCw3NC4zYzAsMS4yLTEsMi4yLTIuMiwyLjJzLTIuMi0xLTIuMi0yLjJzMS0yLjIsMi4yLTIuMlMxMjYuOCw3My4xLDEyNi44LDc0LjN6Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzZBQTlERCIgZD0iTTEzNy42LDc0LjNjMCwxLjItMSwyLjItMi4yLDIuMmMtMS4yLDAtMi4yLTEtMi4yLTIuMnMxLTIuMiwyLjItMi4yCgkJCQlDMTM2LjYsNzIuMSwxMzcuNiw3My4xLDEzNy42LDc0LjN6Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzZBQTlERCIgZD0iTTEyNi44LDY0LjR2OS45Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzZBQTlERCIgZD0iTTEzNy43LDY0LjR2OS45Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzZBQTlERCIgZD0iTTEyNi44LDYzLjVoMTAuOHYyLjdoLTEwLjhDMTI2LjgsNjYuMiwxMjYuOCw2My41LDEyNi44LDYzLjV6Ii8+CgkJPC9nPgoJPC9nPgoJPGc+CgkJPGc+CgkJCTxwYXRoIGZpbGw9IiM2QUE5REQiIGQ9Ik0xNzAuOCw2My4xTDE3MC44LDYzLjFjLTAuMywwLTAuNSwwLTAuOCwwYy0yLjEsMC00LDEtNS4zLDIuNWwtMC4xLDBsLTAuMS0wLjFsLTEtMS4ybC0wLjMsMy40bDMuNCwwLjMKCQkJCWwtMS4xLTEuM2wtMC4xLTAuMWwwLjEtMC4xYzEuMS0xLjQsMy0yLjMsNS0yLjFsMCwwYzMuMiwwLjMsNS41LDMuMSw1LjIsNi4zYy0wLjMsMy0zLjEsNS4zLTYuMSw1LjFjLTMuMS0wLjItNS40LTIuOS01LjMtNgoJCQkJbC0xLjMtMC4xYy0wLjIsMy44LDIuNiw3LjEsNi4zLDcuNGMzLjksMC4zLDcuMy0yLjYsNy42LTYuNUMxNzcuMiw2Ni44LDE3NC40LDYzLjUsMTcwLjgsNjMuMXoiLz4KCQkJPHBhdGggZmlsbD0iIzZBQTlERCIgZD0iTTE3MC4zLDY3LjRjMC0wLjMtMC4zLTAuNi0wLjYtMC42cy0wLjYsMC4zLTAuNiwwLjZ2My4yYzAsMC4yLDAuMSwwLjMsMC4yLDAuNGMwLjEsMC4xLDAuMywwLjIsMC40LDAuMgoJCQkJaDIuNGMwLjQsMCwwLjYtMC4zLDAuNi0wLjZTMTcyLjQsNzAsMTcyLDcwaC0xLjZoLTAuMnYtMC4yTDE3MC4zLDY3LjRMMTcwLjMsNjcuNHoiLz4KCQk8L2c+Cgk8L2c+Cgk8Zz4KCQk8Zz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNkFBOUREIiBkPSJNMTg2LjIsNjMuNGg3LjdjMS41LDAsMi43LDEuMiwyLjcsMi43djcuN2MwLDEuNS0xLjIsMi43LTIuNywyLjdoLTcuNwoJCQkJYy0xLjUsMC0yLjctMS4yLTIuNy0yLjd2LTcuN0MxODMuNCw2NC43LDE4NC43LDYzLjQsMTg2LjIsNjMuNHoiLz4KCQkJPGVsbGlwc2UgZmlsbD0iIzZBQTlERCIgY3g9IjE4NiIgY3k9IjY4LjkiIHJ4PSIwLjciIHJ5PSIwLjciLz4KCQkJPGVsbGlwc2UgZmlsbD0iIzZBQTlERCIgY3g9IjE5NCIgY3k9IjY2LjciIHJ4PSIwLjciIHJ5PSIwLjciLz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNkFBOUREIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik0xODYsNzMuM2wwLjQtMC4zYzAuNC0wLjMsMS0wLjMsMS41LTAuMWwxLDAuNAoJCQkJYzAuNSwwLjIsMSwwLjIsMS41LTAuMWwwLjgtMC41YzAuNC0wLjMsMS0wLjMsMS41LTAuMWwxLjgsMC44Ii8+CgkJPC9nPgoJPC9nPgoJPHBhdGggZmlsbD0iIzZBQTlERCIgc3Ryb2tlPSIjNkFBOUREIiBzdHJva2Utd2lkdGg9IjAuMjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTE1Niw2NC4zYy0wLjItMC4xLTAuNC0wLjEtMC41LDAKCQljMCwwLTAuMiwwLjEtMC45LDAuMmMtMC43LDAtMi40LTAuMS0zLjgtMC42Yy0wLjgtMC4zLTEuNy0wLjUtMi41LTAuNWMtMC4yLDAtMC40LDAtMC41LDBjLTEuMywwLTIuNSwwLjMtMy42LDEKCQljLTAuMiwwLjEtMC4yLDAuMi0wLjIsMC40djExLjZjMCwwLjMsMC4xLDAuNSwwLjMsMC41YzAuNiwwLDAuNS0wLjQsMC41LTAuNnYtNS43YzAuNy0wLjMsMy4yLTEuMSw1LjgtMC4xCgkJYzEuNiwwLjYsMy41LDAuNyw0LjMsMC43YzAuOCwwLDEuMy0wLjMsMS4zLTAuM2MwLjItMC4xLDAuMy0wLjIsMC4zLTAuNHYtNS43QzE1Ni4yLDY0LjYsMTU2LjEsNjQuNCwxNTYsNjQuM3ogTTE1NS42LDcwLjIKCQljLTAuMSwwLTAuNywwLjEtMSwwLjFjLTAuNywwLTIuNC0wLjEtMy44LTAuNmMtMi41LTEtNS0wLjUtNi4yLTAuMXYtNC45YzAuOS0wLjUsMi4yLTAuNywzLjItMC43YzAuMSwwLDAuMywwLDAuNCwwCgkJYzAuNywwLDEuNSwwLjIsMi4yLDAuNGMxLjYsMC42LDMuNSwwLjcsNC4zLDAuN2MwLjIsMCwwLjgsMCwxLTAuMVY3MC4yeiIvPgoJPGc+CgkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNkFBOUREIiBkPSJNNDguMSw2My41aDMuN2MyLjUsMCw0LjUsMiw0LjUsNC41YzAsMC41LTAuNCwwLjktMC45LDAuOUg0NC41Yy0wLjUsMC0wLjktMC40LTAuOS0wLjkKCQkJQzQzLjYsNjUuNSw0NS42LDYzLjUsNDguMSw2My41eiIvPgoJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzZBQTlERCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNNDMuNSw2OC44Yy0wLjIsMC4xLTAuNSwxLjIsMCwxLjVjMS40LDAuOSw4LjUsMC44LDExLjMsMC42CgkJCWMwLjgtMC4xLDEuNi0wLjQsMS43LTEuMmMwLTAuMy0wLjEtMC42LTAuNi0wLjkiLz4KCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiM2QUE5REQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgZD0iTTQzLjUsNzAuNkw0My4zLDcxYy0wLjIsMC41LDAuMiwxLDAuNywwLjljMC4zLTAuMSwwLjUsMC4xLDAuNywwLjMKCQkJbDAuMSwwLjJjMC4zLDAuNSwxLDAuNiwxLjUsMC4ybDAsMGMwLjMtMC4yLDAuNy0wLjMsMS0wLjJsMC44LDAuM2MwLjQsMC4yLDAuOCwwLjEsMS4yLDBsMC41LTAuMmMwLjQtMC4yLDAuOS0wLjIsMS4zLDBsMC41LDAuMgoJCQljMC40LDAuMiwwLjgsMC4yLDEuMi0wLjFsMC4yLTAuMWMwLjMtMC4yLDAuOC0wLjIsMS4xLDAuMWwwLjIsMC4yYzAuMywwLjMsMC44LDAuMiwxLTAuMmwwLjEtMC4yYzAuMS0wLjIsMC0wLjMsMC4yLTAuMwoJCQljMC41LDAsMS4yLTAuMywxLjEtMC43bC0wLjQtMS4xIi8+CgkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNkFBOUREIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik00My41LDcyLjJjLTAuMSwwLjItMC4zLDAuOCwwLDEuMWMwLjMsMC40LDMsMS4xLDYuNCwxLjEKCQkJYzIuMiwwLDQuNi0wLjMsNi0wLjZjMC41LTAuMSwwLjktMC40LDAuOC0wLjljMC0wLjItMC4yLTAuNS0wLjQtMC43Ii8+CgkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNkFBOUREIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik00My41LDczLjNjMCwwLjUsMC42LDIuMywxLjMsMi43YzEuOCwwLjgsNS43LDAuNyw4LjEsMC41CgkJCWMxLjMtMC4xLDIuNS0wLjcsMy4yLTEuOGMwLjMtMC41LDAuNS0xLDAuNS0xLjQiLz4KCQk8ZWxsaXBzZSBmaWxsPSIjNkFBOUREIiBjeD0iNTEuNiIgY3k9IjY2LjUiIHJ4PSIwLjMiIHJ5PSIwLjQiLz4KCQk8ZWxsaXBzZSBmaWxsPSIjNkFBOUREIiBjeD0iNTMiIGN5PSI2NSIgcng9IjAuMyIgcnk9IjAuNCIvPgoJCTxlbGxpcHNlIGZpbGw9IiM2QUE5REQiIGN4PSI1MyIgY3k9IjY3LjIiIHJ4PSIwLjMiIHJ5PSIwLjQiLz4KCQk8ZWxsaXBzZSBmaWxsPSIjNkFBOUREIiBjeD0iNTQuMyIgY3k9IjY2LjUiIHJ4PSIwLjMiIHJ5PSIwLjQiLz4KCQk8ZWxsaXBzZSBmaWxsPSIjNkFBOUREIiBjeD0iNTAuOSIgY3k9IjY1IiByeD0iMC4zIiByeT0iMC40Ii8+Cgk8L2c+Cgk8Zz4KCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiM2QUE5REQiIGQ9Ik0yNC4yLDcxdi03LjZjMC4xLDAuMSwwLjgsMC45LDIuOCwzLjFjMi41LTEuNyw1LjYtMC43LDYuOSwwbDIuNC0zLjF2Ny4xCgkJCWMwLDEuMi0wLjEsMi41LTAuOSwzLjRjLTEsMS4yLTIuNywyLjUtNS4zLDIuNWMtMi45LDAtNC41LTEuNS01LjMtMi45QzI0LjIsNzIuOSwyNC4yLDcyLDI0LjIsNzF6Ii8+CgkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNkFBOUREIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik0yMS4yLDcwLjFsNS40LDEuMiIvPgoJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzZBQTlERCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMjEuMiw3NC4xbDUuNC0xLjIiLz4KCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiM2QUE5REQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgZD0iTTM4LjgsNzAuMWwtNS40LDEuMiIvPgoJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzZBQTlERCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMzguOCw3NC4xbC01LjQtMS4yIi8+CgkJPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiM2QUE5REQiIGQ9Ik0yOS41LDcyLjRMMjksNzEuN2MtMC4yLTAuMywwLTAuNiwwLjMtMC42aDEuNAoJCQljMC4zLDAsMC41LDAuNCwwLjMsMC42bC0wLjcsMWwwLDBjLTAuNywxLjItMi42LDEuMS0zLjEtMC4zbC0wLjEtMC4yYy0wLjEtMC4yLDAtMC40LDAuMi0wLjVjMC4yLTAuMSwwLjQsMCwwLjUsMC4ybDAuMSwwLjIKCQkJQzI4LjMsNzIuOCwyOS4xLDcyLjksMjkuNSw3Mi40eiIvPgoJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzZBQTlERCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMzIuNCw3Mi4xbC0wLjEsMC4yYy0wLjQsMS0xLjgsMS4xLTIuMywwLjIiLz4KCQk8ZWxsaXBzZSBmaWxsPSIjNkFBOUREIiBjeD0iMjcuNiIgY3k9IjY5LjciIHJ4PSIwLjciIHJ5PSIwLjciLz4KCQk8ZWxsaXBzZSBmaWxsPSIjNkFBOUREIiBjeD0iMzIuNCIgY3k9IjY5LjciIHJ4PSIwLjciIHJ5PSIwLjciLz4KCTwvZz4KPC9nPgo8Zz4KCTxwYXRoIGZpbGw9IiM4Njg2ODYiIHN0cm9rZT0iIzg2ODY4NiIgc3Ryb2tlLXdpZHRoPSIwLjEiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTEyLjgsOS41YzAuNiwwLDEuMS0wLjUsMS4xLTEuMgoJCWMwLTAuNi0wLjUtMS4xLTEuMS0xLjFjLTAuNiwwLTEuMiwwLjUtMS4yLDEuMVMxMi4yLDkuNSwxMi44LDkuNXogTTEyLjgsNy45YzAuMiwwLDAuNCwwLjIsMC40LDAuNGMwLDAuMi0wLjIsMC40LTAuNCwwLjQKCQljLTAuMiwwLTAuNC0wLjItMC40LTAuNEMxMi40LDguMSwxMi42LDcuOSwxMi44LDcuOXoiLz4KCTxwYXRoIGZpbGw9IiM4Njg2ODYiIHN0cm9rZT0iIzg2ODY4NiIgc3Ryb2tlLXdpZHRoPSIwLjEiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTcuMiw5LjVjMC42LDAsMS4yLTAuNSwxLjItMS4yCgkJYzAtMC42LTAuNS0xLjEtMS4yLTEuMWMtMC42LDAtMS4xLDAuNS0xLjEsMS4xUzYuNiw5LjUsNy4yLDkuNXogTTcuMiw3LjljMC4yLDAsMC40LDAuMiwwLjQsMC40YzAsMC4yLTAuMiwwLjQtMC40LDAuNAoJCUM3LDguNyw2LjgsOC41LDYuOCw4LjNDNi44LDguMSw3LDcuOSw3LjIsNy45eiIvPgoJPHBhdGggZmlsbD0iIzg2ODY4NiIgc3Ryb2tlPSIjODY4Njg2IiBzdHJva2Utd2lkdGg9IjAuMSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMTQuNiwxMS4yYy0wLjEtMC4xLTAuMi0wLjItMC4zLTAuMkg1LjcKCQljLTAuMSwwLTAuMiwwLjEtMC4zLDAuMmMtMC4xLDAuMS0wLjEsMC4yLDAsMC40YzAuNywyLDIuNSwzLjMsNC42LDMuM3MzLjktMS4zLDQuNi0zLjNDMTQuNywxMS40LDE0LjcsMTEuMywxNC42LDExLjJ6IE0xMCwxNC4xCgkJYy0xLjYsMC0zLTAuOS0zLjctMi4yaDcuM0MxMywxMy4yLDExLjYsMTQuMSwxMCwxNC4xeiIvPgoJPHBhdGggZmlsbD0iIzg2ODY4NiIgc3Ryb2tlPSIjODY4Njg2IiBzdHJva2Utd2lkdGg9IjAuMSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMTAsM2MtMy44LDAtNywzLjEtNyw3czMuMSw3LDcsN3M3LTMuMSw3LTcKCQlTMTMuOCwzLDEwLDN6IE0xMCwxNi4yYy0zLjQsMC02LjItMi44LTYuMi02LjJTNi42LDMuOCwxMCwzLjhzNi4yLDIuOCw2LjIsNi4yUzEzLjQsMTYuMiwxMCwxNi4yeiIvPgo8L2c+CjxnIGlkPSJDYXJfMDAwMDAwMTg5MzUzOTUwODU0MTM0MTM3NTAwMDAwMDA4MjUyNzM4Nzc4NDI3NzU3MTVfIj4KCTxnPgoJCTxnPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiM4Njg2ODYiIGQ9Ik02NC4xLDEzLjRsMi4zLDBjMC4yLDAsMC40LDAuMiwwLjQsMC40djIuMWMwLDAuMi0wLjIsMC40LTAuNCwwLjRoLTIuMwoJCQkJYy0wLjIsMC0wLjQtMC4yLTAuNC0wLjR2LTIuMUM2My43LDEzLjYsNjMuOCwxMy40LDY0LjEsMTMuNHoiLz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjODY4Njg2IiBkPSJNNzMuNSwxMy40aDIuNGMwLjIsMCwwLjQsMC4yLDAuNCwwLjR2Mi4xYzAsMC4yLTAuMiwwLjQtMC40LDAuNGgtMi40CgkJCQljLTAuMiwwLTAuNC0wLjItMC40LTAuNGwwLTIuMUM3My4xLDEzLjYsNzMuMywxMy40LDczLjUsMTMuNHoiLz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjODY4Njg2IiBkPSJNNjMuNyw4LjRoMTIuNnY1SDYzLjdWOC40eiIvPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiM4Njg2ODYiIGQ9Ik02NS41LDMuNmg4LjljMSwwLDEuOSwwLjgsMS45LDEuOXYzLjFINjMuN1Y1LjVDNjMuNyw0LjQsNjQuNSwzLjYsNjUuNSwzLjZ6Ii8+CgkJCTxlbGxpcHNlIGZpbGw9IiM4Njg2ODYiIGN4PSI2Ni4yIiBjeT0iMTAuOSIgcng9IjAuOSIgcnk9IjAuOSIvPgoJCQk8ZWxsaXBzZSBmaWxsPSIjODY4Njg2IiBjeD0iNzMuOCIgY3k9IjEwLjkiIHJ4PSIwLjkiIHJ5PSIwLjkiLz4KCQk8L2c+Cgk8L2c+CjwvZz4KPGcgaWQ9IkFjdGl2aXRpZXMiPgoJPGc+CgkJPGc+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzg2ODY4NiIgZD0iTTk2LjQsMTBjMCwzLjYtMi45LDYuNS02LjQsNi41cy02LjQtMi45LTYuNC02LjVzMi45LTYuNSw2LjQtNi41Uzk2LjQsNi40LDk2LjQsMTB6Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzg2ODY4NiIgZD0iTTk2LjMsOC42YzAsMCwwLDAuMSwwLDAuMWMtMC45LDAuMS0yLjksMC4xLTQuNi0xLjJjLTEuMS0wLjgtMi0xLjctMi42LTIuNQoJCQkJYy0wLjMtMC40LTAuNi0wLjgtMC43LTEuMWMtMC4xLTAuMS0wLjEtMC4yLTAuMS0wLjJjMC41LTAuMSwxLjItMC4yLDItMC4yYzEuMiwwLDIuNSwwLjMsMy41LDEuMWMxLDAuOCwxLjcsMS44LDIuMSwyLjgKCQkJCUM5Ni4xLDcuOSw5Ni4yLDguMyw5Ni4zLDguNnoiLz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjODY4Njg2IiBkPSJNODQsMTIuMWMwLDAsMC0wLjEsMC0wLjFjMC45LTAuMiwyLjktMC40LDQuNywwLjZjMS4xLDAuNiwxLjksMS41LDIuNCwyLjMKCQkJCWMwLjQsMC41LDAuNiwxLDAuNywxLjNjLTAuNCwwLjEtMSwwLjItMS43LDAuM2MtMSwwLTIuMS0wLjEtMy4yLTAuOGMtMS4xLTAuNi0xLjktMS42LTIuNC0yLjVDODQuMiwxMi44LDg0LjEsMTIuNCw4NCwxMi4xeiIvPgoJCTwvZz4KCTwvZz4KPC9nPgo8ZyBpZD0iT2JqZWN0c18wMDAwMDA2NDMxMjM3MTczOTEzMDMxNTI1MDAwMDAxMDIyNTg4OTAzMjIyODYzMjk3NV8iPgoJPGc+CgkJPGc+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzg2ODY4NiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMTE2LjMsNi44bC0xLjQsMkwxMTQuMSw4bC0wLjYtMC43bDAsMC45bC0wLjEsOC4yaC02LjhsLTAuMS04LjIKCQkJCWwwLTAuOUwxMDUuOSw4bC0wLjgsMC44bC0xLjQtMmwyLjYtMi45YzAuMS0wLjEsMC4yLTAuMSwwLjMtMC4xaDEuM2wwLjQsMC43YzAuNywxLjMsMi42LDEuMywzLjMtMC4xbDAuMy0wLjZoMS4yCgkJCQljMC4xLDAsMC4yLDAsMC4zLDAuMWwwLjMtMC4zbC0wLjMsMC4zTDExNi4zLDYuOHoiLz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjODY4Njg2IiBkPSJNMTEwLjEsNy43aDJ2MC45YzAsMC40LTAuNCwwLjctMSwwLjdjLTAuNiwwLTEtMC4zLTEtMC43TDExMC4xLDcuN0wxMTAuMSw3Ljd6Ii8+CgkJPC9nPgoJPC9nPgo8L2c+CjxnIGlkPSJTeW1ib2xzXzAwMDAwMDk2NzQ2OTA3ODY5OTI5OTIxMTgwMDAwMDA2NDg0ODEyODMwMjgyNTgyNDE2XyI+Cgk8Zz4KCQk8Zz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjODY4Njg2IiBkPSJNMTI2LjgsMTQuM2MwLDEuMi0xLDIuMi0yLjIsMi4ycy0yLjItMS0yLjItMi4yczEtMi4yLDIuMi0yLjJTMTI2LjgsMTMuMSwxMjYuOCwxNC4zeiIvPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiM4Njg2ODYiIGQ9Ik0xMzcuNiwxNC4zYzAsMS4yLTEsMi4yLTIuMiwyLjJjLTEuMiwwLTIuMi0xLTIuMi0yLjJzMS0yLjIsMi4yLTIuMgoJCQkJQzEzNi42LDEyLjEsMTM3LjYsMTMuMSwxMzcuNiwxNC4zeiIvPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiM4Njg2ODYiIGQ9Ik0xMjYuOCw0LjR2OS45Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzg2ODY4NiIgZD0iTTEzNy43LDQuNHY5LjkiLz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjODY4Njg2IiBkPSJNMTI2LjgsMy41aDEwLjh2Mi43aC0xMC44QzEyNi44LDYuMiwxMjYuOCwzLjUsMTI2LjgsMy41eiIvPgoJCTwvZz4KCTwvZz4KPC9nPgo8ZyBpZD0iUmVjZW50cyI+Cgk8Zz4KCQk8Zz4KCQkJPHBhdGggZmlsbD0iIzg2ODY4NiIgZD0iTTE3MC44LDMuMUwxNzAuOCwzLjFjLTAuMywwLTAuNSwwLTAuOCwwYy0yLjEsMC00LDEtNS4zLDIuNWwtMC4xLDBsLTAuMS0wLjFsLTEtMS4ybC0wLjMsMy40bDMuNCwwLjMKCQkJCWwtMS4xLTEuM2wtMC4xLTAuMWwwLjEtMC4xYzEuMS0xLjQsMy0yLjMsNS0yLjFsMCwwYzMuMiwwLjMsNS41LDMuMSw1LjIsNi4zYy0wLjMsMy0zLjEsNS4zLTYuMSw1LjFjLTMuMS0wLjItNS40LTIuOS01LjMtNgoJCQkJTDE2Myw5LjVjLTAuMiwzLjgsMi42LDcuMSw2LjMsNy40YzMuOSwwLjQsNy4zLTIuNiw3LjYtNi41QzE3Ny4yLDYuOCwxNzQuNCwzLjUsMTcwLjgsMy4xeiIvPgoJCQk8cGF0aCBmaWxsPSIjODY4Njg2IiBkPSJNMTcwLjMsNy40YzAtMC4zLTAuMy0wLjYtMC42LTAuNlMxNjksNy4xLDE2OSw3LjR2My4yYzAsMC4yLDAuMSwwLjMsMC4yLDAuNGMwLjEsMC4xLDAuMywwLjIsMC40LDAuMgoJCQkJaDIuNGMwLjQsMCwwLjYtMC4zLDAuNi0wLjZzLTAuMy0wLjYtMC42LTAuNmgtMS42aC0wLjJWOS44TDE3MC4zLDcuNEwxNzAuMyw3LjR6Ii8+CgkJPC9nPgoJPC9nPgo8L2c+CjxnIGlkPSJDdXN0b21fMDAwMDAxODEwODcyMjk0MzQzMDIzMzY3ODAwMDAwMDUxNTIyNzc5NDU5NDA2NzQ0ODhfIj4KCTxnPgoJCTxnPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiM4Njg2ODYiIGQ9Ik0xODYuMiwzLjRoNy43YzEuNSwwLDIuNywxLjIsMi43LDIuN3Y3LjdjMCwxLjUtMS4yLDIuNy0yLjcsMi43aC03LjcKCQkJCWMtMS41LDAtMi43LTEuMi0yLjctMi43VjYuMUMxODMuNCw0LjYsMTg0LjcsMy40LDE4Ni4yLDMuNHoiLz4KCQkJPGVsbGlwc2UgZmlsbD0iIzg2ODY4NiIgY3g9IjE4NiIgY3k9IjguOSIgcng9IjAuNyIgcnk9IjAuNyIvPgoJCQk8ZWxsaXBzZSBmaWxsPSIjODY4Njg2IiBjeD0iMTk0IiBjeT0iNi43IiByeD0iMC43IiByeT0iMC43Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzg2ODY4NiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMTg2LDEzLjNsMC40LTAuM2MwLjQtMC4zLDEtMC4zLDEuNS0wLjFsMSwwLjQKCQkJCWMwLjUsMC4yLDEsMC4yLDEuNS0wLjFsMC44LTAuNWMwLjQtMC4zLDEtMC4zLDEuNS0wLjFsMS44LDAuOCIvPgoJCTwvZz4KCTwvZz4KPC9nPgo8cGF0aCBmaWxsPSIjODY4Njg2IiBzdHJva2U9IiM4Njg2ODYiIHN0cm9rZS13aWR0aD0iMC4yNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMTU2LDQuM2MtMC4yLTAuMS0wLjQtMC4xLTAuNSwwCgljMCwwLTAuMiwwLjEtMC45LDAuMWMtMC43LDAtMi40LTAuMS0zLjgtMC42Yy0wLjgtMC4zLTEuNy0wLjUtMi41LTAuNWMtMC4yLDAtMC40LDAtMC41LDBjLTEuMywwLTIuNSwwLjMtMy42LDEKCWMtMC4yLDAuMS0wLjIsMC4yLTAuMiwwLjR2MTEuNmMwLDAuMywwLjEsMC41LDAuMywwLjVjMC42LDAsMC41LTAuNCwwLjUtMC42di01LjdjMC43LTAuMywzLjItMS4xLDUuOC0wLjFjMS42LDAuNiwzLjUsMC43LDQuMywwLjcKCWMwLjgsMCwxLjMtMC4zLDEuMy0wLjNjMC4yLTAuMSwwLjMtMC4yLDAuMy0wLjRWNC43QzE1Ni4yLDQuNSwxNTYuMSw0LjQsMTU2LDQuM3ogTTE1NS42LDEwLjJjLTAuMSwwLTAuNywwLjEtMSwwLjEKCWMtMC43LDAtMi40LTAuMS0zLjgtMC42Yy0yLjUtMS01LTAuNS02LjItMC4xVjQuN2MwLjktMC41LDIuMi0wLjcsMy4yLTAuN2MwLjEsMCwwLjMsMCwwLjQsMGMwLjcsMCwxLjUsMC4yLDIuMiwwLjQKCWMxLjYsMC42LDMuNSwwLjcsNC4zLDAuN2MwLjIsMCwwLjgsMCwxLTAuMVYxMC4yeiIvPgo8ZyBpZD0iRm9vZCI+Cgk8ZyBpZD0iTGF5ZXJfMTIiPgoJCTxnPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiM4Njg2ODYiIGQ9Ik00OC4xLDMuNWgzLjdjMi41LDAsNC41LDIsNC41LDQuNWMwLDAuNS0wLjQsMC45LTAuOSwwLjlINDQuNWMtMC41LDAtMC45LTAuNC0wLjktMC45CgkJCQlDNDMuNiw1LjUsNDUuNiwzLjUsNDguMSwzLjV6Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzg2ODY4NiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNNDMuNSw4LjdjLTAuMiwwLjEtMC41LDEuMiwwLDEuNWMxLjQsMC45LDguNSwwLjgsMTEuMywwLjYKCQkJCWMwLjgtMC4xLDEuNi0wLjQsMS43LTEuMmMwLTAuMy0wLjEtMC42LTAuNi0wLjkiLz4KCQkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjODY4Njg2IiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik00My41LDEwLjZMNDMuMywxMWMtMC4yLDAuNSwwLjIsMSwwLjcsMC45CgkJCQljMC4zLTAuMSwwLjUsMC4xLDAuNywwLjNsMC4xLDAuMmMwLjMsMC41LDEsMC42LDEuNSwwLjJsMCwwYzAuMy0wLjIsMC43LTAuMywxLTAuMmwwLjgsMC4zYzAuNCwwLjEsMC44LDAuMSwxLjIsMGwwLjUtMC4yCgkJCQljMC40LTAuMiwwLjktMC4yLDEuMywwbDAuNSwwLjJjMC40LDAuMiwwLjgsMC4xLDEuMi0wLjFsMC4yLTAuMWMwLjMtMC4yLDAuOC0wLjEsMS4xLDAuMWwwLjIsMC4yYzAuMywwLjMsMC44LDAuMiwxLTAuMmwwLjEtMC4yCgkJCQljMC4xLTAuMiwwLTAuMywwLjItMC40YzAuNSwwLDEuMi0wLjMsMS4xLTAuN2wtMC40LTEuMSIvPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiM4Njg2ODYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgZD0iTTQzLjUsMTIuMWMtMC4xLDAuMi0wLjMsMC44LDAsMS4xYzAuMywwLjQsMywxLjEsNi40LDEuMQoJCQkJYzIuMiwwLDQuNi0wLjMsNi0wLjZjMC41LTAuMSwwLjktMC40LDAuOC0wLjljMC0wLjItMC4yLTAuNS0wLjQtMC43Ii8+CgkJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzg2ODY4NiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNNDMuNSwxMy4zYzAsMC41LDAuNiwyLjQsMS4zLDIuNmMxLjgsMC44LDUuNywwLjcsOC4xLDAuNQoJCQkJYzEuMy0wLjEsMi41LTAuNywzLjItMS44YzAuMy0wLjUsMC41LTEsMC41LTEuNCIvPgoJCQk8ZWxsaXBzZSBmaWxsPSIjODY4Njg2IiBjeD0iNTEuNiIgY3k9IjYuNSIgcng9IjAuMyIgcnk9IjAuNCIvPgoJCQk8ZWxsaXBzZSBmaWxsPSIjODY4Njg2IiBjeD0iNTMiIGN5PSI0LjkiIHJ4PSIwLjMiIHJ5PSIwLjQiLz4KCQkJPGVsbGlwc2UgZmlsbD0iIzg2ODY4NiIgY3g9IjUzIiBjeT0iNy4yIiByeD0iMC4zIiByeT0iMC40Ii8+CgkJCTxlbGxpcHNlIGZpbGw9IiM4Njg2ODYiIGN4PSI1NC4zIiBjeT0iNi41IiByeD0iMC4zIiByeT0iMC40Ii8+CgkJCTxlbGxpcHNlIGZpbGw9IiM4Njg2ODYiIGN4PSI1MC45IiBjeT0iNC45IiByeD0iMC4zIiByeT0iMC40Ii8+CgkJPC9nPgoJPC9nPgo8L2c+CjxnIGlkPSJBbmltYWxzIj4KCTxnPgoJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzg2ODY4NiIgZD0iTTI0LjIsMTFWMy41YzAuMSwwLjEsMC44LDAuOSwyLjgsMy4xYzIuNS0xLjcsNS42LTAuNyw2LjksMGwyLjQtMy4xdjcuMQoJCQljMCwxLjItMC4xLDIuNS0wLjksMy40Yy0xLDEuMi0yLjcsMi41LTUuMywyLjVjLTIuOSwwLTQuNS0xLjUtNS4zLTIuOUMyNC4yLDEyLjksMjQuMiwxMS45LDI0LjIsMTF6Ii8+CgkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjODY4Njg2IiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik0yMS4yLDEwbDUuNCwxLjIiLz4KCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiM4Njg2ODYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgZD0iTTIxLjIsMTQuMWw1LjQtMS4yIi8+CgkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjODY4Njg2IiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik0zOC44LDEwbC01LjQsMS4yIi8+CgkJPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjODY4Njg2IiBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik0zOC44LDE0LjFsLTUuNC0xLjIiLz4KCQk8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzg2ODY4NiIgZD0iTTI5LjUsMTIuNEwyOSwxMS43Yy0wLjItMC4zLDAtMC42LDAuMy0wLjZoMS40CgkJCWMwLjMsMCwwLjUsMC40LDAuMywwLjZsLTAuNywxbDAsMGMtMC43LDEuMi0yLjYsMS4xLTMuMS0wLjNsLTAuMS0wLjJjLTAuMS0wLjIsMC0wLjQsMC4yLTAuNXMwLjQsMCwwLjUsMC4ybDAuMSwwLjIKCQkJQzI4LjMsMTIuNywyOS4xLDEyLjksMjkuNSwxMi40eiIvPgoJCTxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzg2ODY4NiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMzIuNCwxMi4xbC0wLjEsMC4yYy0wLjQsMS0xLjgsMS4xLTIuMywwLjIiLz4KCQk8ZWxsaXBzZSBmaWxsPSIjODY4Njg2IiBjeD0iMjcuNiIgY3k9IjkuNyIgcng9IjAuNyIgcnk9IjAuNyIvPgoJCTxlbGxpcHNlIGZpbGw9IiM4Njg2ODYiIGN4PSIzMi40IiBjeT0iOS43IiByeD0iMC43IiByeT0iMC43Ii8+Cgk8L2c+CjwvZz4KPC9zdmc+";
function NMe(e) {
  var t, a = e.isActiveCategory, n = e.category, o = e.allowNavigation, i = e.categoryConfig, s = e.onClick;
  return P(Un, {
    tabIndex: o ? 0 : -1,
    className: pe(SMe.catBtn, U1.categoryBtn, "epr-icn-" + n, (t = {}, t[ce.active] = a, t)),
    onClick: s,
    "aria-label": Yp(i),
    "aria-selected": a,
    role: "tab",
    "aria-controls": "epr-category-nav-id"
  });
}
var pd = {
  backgroundPositionY: "calc(var(--epr-category-navigation-button-size) * 3)"
}, AMe = {
  backgroundPositionY: "calc(var(--epr-category-navigation-button-size) * 2)"
}, yd = {
  ":not(.epr-search-active)": {
    catBtn: {
      ":hover": pd,
      "&.epr-active": pd
    }
  }
}, SMe = /* @__PURE__ */ Te.create(/* @__PURE__ */ Pe({
  catBtn: {
    ".": "epr-cat-btn",
    display: "inline-block",
    transition: "opacity 0.2s ease-in-out",
    position: "relative",
    height: "var(--epr-category-navigation-button-size)",
    width: "var(--epr-category-navigation-button-size)",
    backgroundSize: "calc(var(--epr-category-navigation-button-size) * 10)",
    outline: "none",
    backgroundPosition: "0 0",
    backgroundImage: "url(" + jMe + ")",
    ":focus:before": {
      content: "",
      position: "absolute",
      top: "-2px",
      left: "-2px",
      right: "-2px",
      bottom: "-2px",
      border: "2px solid var(--epr-category-icon-active-color)",
      borderRadius: "50%"
    },
    "&.epr-icn-suggested": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -8)"
    },
    "&.epr-icn-custom": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -9)"
    },
    "&.epr-icn-activities": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -4)"
    },
    "&.epr-icn-animals_nature": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -1)"
    },
    "&.epr-icn-flags": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -7)"
    },
    "&.epr-icn-food_drink": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -2)"
    },
    "&.epr-icn-objects": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -5)"
    },
    "&.epr-icn-smileys_people": {
      backgroundPositionX: "0px"
    },
    "&.epr-icn-symbols": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -6)"
    },
    "&.epr-icn-travel_places": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -3)"
    }
  }
}, /* @__PURE__ */ y1("catBtn", AMe), {
  ".epr-dark-theme": /* @__PURE__ */ Pe({}, yd),
  ".epr-auto-theme": /* @__PURE__ */ Pe({}, yd)
}));
function IMe() {
  var e = ve(null), t = e[0], a = e[1], n = bMe();
  CMe(a);
  var o = Br(), i = ry(), s = Es(), c = LMe();
  return P("div", {
    className: pe(TMe.nav),
    role: "tablist",
    "aria-label": "Category navigation",
    id: "epr-category-nav-id",
    ref: s
  }, i.map(function(f) {
    var d = Is(f), u = d === t;
    if (Bve(f) && c)
      return null;
    var h = !o && !u;
    return P(NMe, {
      key: d,
      category: d,
      isActiveCategory: u,
      allowNavigation: h,
      categoryConfig: f,
      onClick: function() {
        a(d), n(d);
      }
    });
  }));
}
var TMe = /* @__PURE__ */ Te.create({
  nav: {
    ".": "epr-category-nav",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    padding: "var(--epr-header-padding)"
  },
  ".epr-search-active": {
    nav: {
      opacity: "0.3",
      cursor: "default",
      pointerEvents: "none"
    }
  },
  ".epr-main:has(input:not(:placeholder-shown))": {
    nav: {
      opacity: "0.3",
      cursor: "default",
      pointerEvents: "none"
    }
  }
}), Yy = "data:image/svg+xml;base64,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";
function zMe() {
  var e = xy();
  return P(Un, {
    className: pe(md.btnClearSearch, U1.visibleOnSearchOnly),
    onClick: e,
    "aria-label": "Clear",
    title: "Clear"
  }, P("div", {
    className: pe(md.icnClearnSearch)
  }));
}
var DMe = {
  ":hover": {
    "> .epr-icn-clear-search": {
      backgroundPositionY: "-60px"
    }
  }
}, md = /* @__PURE__ */ Te.create(/* @__PURE__ */ Pe({
  btnClearSearch: {
    ".": "epr-btn-clear-search",
    position: "absolute",
    right: "var(--epr-search-bar-inner-padding)",
    height: "30px",
    width: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: "50%",
    transform: "translateY(-50%)",
    padding: "0",
    borderRadius: "50%",
    ":hover": {
      background: "var(--epr-hover-bg-color)"
    },
    ":focus": {
      background: "var(--epr-hover-bg-color)"
    }
  },
  icnClearnSearch: {
    ".": "epr-icn-clear-search",
    backgroundColor: "transparent",
    backgroundRepeat: "no-repeat",
    backgroundSize: "20px",
    height: "20px",
    width: "20px",
    backgroundImage: "url(" + Yy + ")",
    ":hover": {
      backgroundPositionY: "-20px"
    },
    ":focus": {
      backgroundPositionY: "-20px"
    }
  }
}, /* @__PURE__ */ y1("icnClearnSearch", {
  backgroundPositionY: "-40px"
}), /* @__PURE__ */ y1("btnClearSearch", DMe))), q2 = /* @__PURE__ */ Xe(ce.emojiPicker) + " " + /* @__PURE__ */ Xe(ce.emojiList), Qy = /* @__PURE__ */ ["button", Xe(ce.emoji)].join(""), _Me = /* @__PURE__ */ Xe(ce.category);
function PMe(e) {
  var t = e.value;
  if (!t)
    return null;
  var a = EMe(t);
  return P("style", null, `
    ` + q2 + " " + Qy + ` {
      display: none;
    }


    ` + q2 + " " + a + ` {
      display: flex;
    }

    ` + q2 + " " + _Me + ":not(:has(" + a + `)) {
      display: none;
    }
  `);
}
function EMe(e) {
  return [Qy, '[data-full-name*="', Hi(e), '"]'].join("");
}
var RMe = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIyMHB4IiBoZWlnaHQ9IjQwcHgiIHZpZXdCb3g9IjAgMCAyMCA0MCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjAgNDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzg2ODY4NiIgZD0iTTEyLDguODFjMCwyLjA4LTEuNjgsMy43Ni0zLjc2LDMuNzZjLTIuMDgsMC0zLjc2LTEuNjgtMy43Ni0zLjc2CgljMC0yLjA4LDEuNjgtMy43NiwzLjc2LTMuNzZDMTAuMzIsNS4wNSwxMiw2LjczLDEyLDguODF6IE0xMS4yMywxMi43MmMtMC44MywwLjY0LTEuODcsMS4wMS0yLjk5LDEuMDFjLTIuNzIsMC00LjkyLTIuMi00LjkyLTQuOTIKCWMwLTIuNzIsMi4yLTQuOTIsNC45Mi00LjkyYzIuNzIsMCw0LjkyLDIuMiw0LjkyLDQuOTJjMCwxLjEzLTAuMzgsMi4xNi0xLjAxLDIuOTlsMy45NCwzLjkzYzAuMjUsMC4yNSwwLjI1LDAuNjYsMCwwLjkyCgljLTAuMjUsMC4yNS0wLjY2LDAuMjUtMC45MiwwTDExLjIzLDEyLjcyeiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI0MwQzBCRiIgZD0iTTEyLDI4LjgxYzAsMi4wOC0xLjY4LDMuNzYtMy43NiwzLjc2Yy0yLjA4LDAtMy43Ni0xLjY4LTMuNzYtMy43NgoJYzAtMi4wOCwxLjY4LTMuNzYsMy43Ni0zLjc2QzEwLjMyLDI1LjA1LDEyLDI2LjczLDEyLDI4LjgxeiBNMTEuMjMsMzIuNzJjLTAuODMsMC42NC0xLjg3LDEuMDEtMi45OSwxLjAxCgljLTIuNzIsMC00LjkyLTIuMi00LjkyLTQuOTJjMC0yLjcyLDIuMi00LjkyLDQuOTItNC45MmMyLjcyLDAsNC45MiwyLjIsNC45Miw0LjkyYzAsMS4xMy0wLjM4LDIuMTYtMS4wMSwyLjk5bDMuOTQsMy45MwoJYzAuMjUsMC4yNSwwLjI1LDAuNjYsMCwwLjkyYy0wLjI1LDAuMjUtMC42NiwwLjI1LTAuOTIsMEwxMS4yMywzMi43MnoiLz4KPC9zdmc+";
function HMe() {
  return P("div", {
    className: pe(VMe.icnSearch)
  });
}
var VMe = /* @__PURE__ */ Te.create(/* @__PURE__ */ Pe({
  icnSearch: {
    ".": "epr-icn-search",
    content: "",
    position: "absolute",
    top: "50%",
    left: "var(--epr-search-bar-inner-padding)",
    transform: "translateY(-50%)",
    width: "20px",
    height: "20px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "0 0",
    backgroundSize: "20px",
    backgroundImage: "url(" + RMe + ")"
  }
}, /* @__PURE__ */ y1("icnSearch", {
  backgroundPositionY: "-20px"
})));
function OMe() {
  var e = sy(), t = Hs();
  return e ? null : P(Uy, {
    className: pe(So.overlay)
  }, P(qMe, null), t ? P(Wy, null) : null);
}
function qMe() {
  var e = ve(0), t = e[0], a = e[1], n = Q1(), o = C1(), i = vge(), s = wge(), c = sve(), f = c.statusSearchResults, d = c.searchTerm, u = c.onChange, h = o == null ? void 0 : o.current, y = h == null ? void 0 : h.value;
  return P(Yr, {
    className: pe(So.searchContainer)
  }, P(PMe, {
    value: y
  }), P("input", {
    // eslint-disable-next-line jsx-a11y/no-autofocus
    autoFocus: s,
    "aria-label": "Type to search for an emoji",
    onFocus: n,
    className: pe(So.search),
    type: "text",
    "aria-controls": "epr-search-id",
    placeholder: i,
    onChange: function(v) {
      a(t + 1), setTimeout(function() {
        var k, g;
        u((k = v == null || (g = v.target) == null ? void 0 : g.value) != null ? k : y);
      });
    },
    ref: o
  }), d ? P("div", {
    role: "status",
    className: pe("epr-status-search-results", So.visuallyHidden),
    "aria-live": "polite",
    id: "epr-search-id",
    "aria-atomic": "true"
  }, f) : null, P(HMe, null), P(zMe, null));
}
var So = /* @__PURE__ */ Te.create(/* @__PURE__ */ Pe({
  overlay: {
    padding: "var(--epr-header-padding)",
    zIndex: "var(--epr-header-overlay-z-index)"
  },
  searchContainer: {
    ".": "epr-search-container",
    flex: "1",
    display: "block",
    minWidth: "0"
  },
  visuallyHidden: {
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    overflow: "hidden",
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
  },
  search: {
    outline: "none",
    transition: "all 0.2s ease-in-out",
    color: "var(--epr-search-input-text-color)",
    borderRadius: "var(--epr-search-input-border-radius)",
    padding: "var(--epr-search-input-padding)",
    height: "var(--epr-search-input-height)",
    backgroundColor: "var(--epr-search-input-bg-color)",
    border: "1px solid var(--epr-search-input-bg-color)",
    width: "100%",
    ":focus": {
      backgroundColor: "var(--epr-search-input-bg-color-active)",
      border: "1px solid var(--epr-search-border-color)"
    },
    "::placeholder": {
      color: "var(--epr-search-input-placeholder-color)"
    }
  },
  btnClearSearch: {
    ".": "epr-btn-clear-search",
    position: "absolute",
    right: "var(--epr-search-bar-inner-padding)",
    height: "30px",
    width: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: "50%",
    transform: "translateY(-50%)",
    padding: "0",
    borderRadius: "50%",
    ":hover": {
      background: "var(--epr-hover-bg-color)"
    },
    ":focus": {
      background: "var(--epr-hover-bg-color)"
    }
  },
  icnClearnSearch: {
    ".": "epr-icn-clear-search",
    backgroundColor: "transparent",
    backgroundRepeat: "no-repeat",
    backgroundSize: "20px",
    height: "20px",
    width: "20px",
    backgroundImage: "url(" + Yy + ")",
    ":hover": {
      backgroundPositionY: "-20px"
    },
    ":focus": {
      backgroundPositionY: "-20px"
    }
  }
}, /* @__PURE__ */ y1("icnClearnSearch", {
  backgroundPositionY: "-40px"
}), /* @__PURE__ */ y1("btnClearSearch", {
  ":hover > .epr-icn-clear-search": {
    backgroundPositionY: "-60px"
  }
})));
function BMe() {
  return P(Yr, {
    className: pe("epr-header", U1.hiddenOnReactions)
  }, P(OMe, null), P(IMe, null));
}
function ZMe(e) {
  return P(Zge, null, P(Rke, null), P(mge, Object.assign({}, e), P(FMe, null)));
}
function FMe() {
  var e = Or(), t = e[0], a = ny(), n = ve(!t), o = n[0], i = n[1], s = Cge();
  return Ne(function() {
    t && !a || o || i(!0);
  }, [o, a, t]), s ? P(jve, null, P(Xve, null), P(GMe, {
    renderAll: o
  })) : null;
}
function GMe(e) {
  var t = e.renderAll;
  return t ? P(Nn, null, P(BMe, null), P(lMe, null), P(MMe, null)) : null;
}
var $Me = /* @__PURE__ */ Cd(ZMe, $p), UMe = /* @__PURE__ */ function(e) {
  _ke(t, e);
  function t(n) {
    var o;
    return o = e.call(this, n) || this, o.state = {
      hasError: !1
    }, o;
  }
  t.getDerivedStateFromError = function() {
    return {
      hasError: !0
    };
  };
  var a = t.prototype;
  return a.componentDidCatch = function(o, i) {
    console.error("Emoji Picker React failed to render:", o, i);
  }, a.render = function() {
    return this.state.hasError ? null : this.props.children;
  }, t;
}(xd);
function WMe(e) {
  var t = gge({
    onEmojiClick: e.onEmojiClick,
    onReactionClick: e.onReactionClick,
    onSkinToneChange: e.onSkinToneChange
  });
  return P(UMe, null, P(ty.Provider, {
    value: t
  }, P($Me, Object.assign({}, e))));
}
const Mxe = Et(
  ({ handleEmojiClick: e, handleAvatarInput: t, onRemove: a, className: n, ...o }, i) => {
    const [s, c] = ve("emojiPicker"), f = Le(null), d = () => {
      f.current && f.current.click();
    };
    return /* @__PURE__ */ l.jsx("div", { ref: i, className: n, ...o, children: /* @__PURE__ */ l.jsxs(
      Q5e,
      {
        defaultValue: s,
        className: he(
          "px-4 pt-2 gap-4 rounded-lg shadow-elevation-4 w-[350px] bg-white pb-4",
          s === "emojiPicker" && "h-[400px]"
        ),
        children: [
          /* @__PURE__ */ l.jsxs(v4, { className: "w-full justify-between items-center border-b color-border-default rounded-none px-0", children: [
            /* @__PURE__ */ l.jsxs("div", { className: "w-full flex justify-start", children: [
              /* @__PURE__ */ l.jsx(
                Mi,
                {
                  value: "emojiPicker",
                  onClick: () => c("emojiPicker"),
                  className: "w-full lg:w-auto gap-1 text-body-sm-bold data-[state=active]:color-text-default data-[state=active]:border-b-2 data-[state=active]:color-border-active color-text-default h-[38px] data-[state=inactive]:border-transparent",
                  children: "Emojis"
                }
              ),
              /* @__PURE__ */ l.jsx(
                Mi,
                {
                  value: "customUpload",
                  onClick: () => c("customUpload"),
                  className: "w-full lg:w-auto gap-1 text-body-sm-bold data-[state=active]:color-text-default data-[state=active]:border-b-2 data-[state=active]:color-border-active color-text-default h-[38px] data-[state=inactive]:border-transparent",
                  children: "Custom"
                }
              )
            ] }),
            /* @__PURE__ */ l.jsx(
              zt,
              {
                variant: "ghost",
                className: "min-w-fit bg-transparent hidden lg:block color-text-default",
                onClick: a,
                children: "Remove"
              }
            )
          ] }),
          /* @__PURE__ */ l.jsx(M4, { value: s, className: "w-full h-full", children: s === "emojiPicker" ? /* @__PURE__ */ l.jsx("div", { className: "w-full h-auto overflow-hidden absolute top-0 translate-y-12 left-0", children: /* @__PURE__ */ l.jsx(
            WMe,
            {
              previewConfig: {
                showPreview: !1
              },
              height: 340,
              className: "!border-none !rounded-none overflow-auto h-full",
              emojiStyle: it.NATIVE,
              onEmojiClick: e
            }
          ) }) : /* @__PURE__ */ l.jsxs("div", { className: "w-full h-full mt-4 space-y-3", children: [
            /* @__PURE__ */ l.jsx(
              zt,
              {
                size: "lg",
                variant: "secondary",
                className: "w-full",
                onClick: d,
                children: "Upload file"
              }
            ),
            /* @__PURE__ */ l.jsx(
              "input",
              {
                type: "file",
                accept: "image/*",
                ref: f,
                onChange: t,
                className: "hidden"
              }
            ),
            /* @__PURE__ */ l.jsx("p", { className: "text-helper-text-sm color-text-secondary text-center", children: "Recommended size is 256 x 256 pixels" })
          ] }) })
        ]
      }
    ) });
  }
), wxe = ({
  open: e,
  onOpenChange: t,
  title: a,
  description: n,
  content: o,
  primaryAction: i,
  secondaryAction: s,
  className: c,
  contentClassName: f,
  hasCloseIcon: d,
  headerClassName: u,
  footerClassName: h,
  overlayClasses: y,
  noOverlay: m
}) => /* @__PURE__ */ l.jsx(gs, { open: e, onOpenChange: (v) => t(v), children: /* @__PURE__ */ l.jsxs(
  Ms,
  {
    className: S("w-full", c),
    hasCloseIcon: d,
    overlayClasses: S(y, { "bg-transparent": m }),
    children: [
      a && /* @__PURE__ */ l.jsx(ws, { className: S("px-4 pt-4", u), children: /* @__PURE__ */ l.jsx(Cs, { className: "text-left text-heading-md", children: a }) }),
      /* @__PURE__ */ l.jsxs(
        "div",
        {
          className: S(
            "flex flex-col gap-4 w-full h-full border-t-[1px] text-body-sm color-text-default",
            {
              "px-4 pt-4 pb-2": !f
            },
            f
          ),
          children: [
            /* @__PURE__ */ l.jsx(bs, { className: "hidden" }),
            n && /* @__PURE__ */ l.jsx("p", { children: n }),
            o && o
          ]
        }
      ),
      /* @__PURE__ */ l.jsxs(xs, { className: S("px-5 pb-5 gap-2 w-full", h), children: [
        s && /* @__PURE__ */ l.jsx(vs, { asChild: !0, children: /* @__PURE__ */ l.jsx(
          zt,
          {
            disabled: s == null ? void 0 : s.isLoading,
            isLoading: s == null ? void 0 : s.isLoading,
            className: s == null ? void 0 : s.className,
            variant: (s == null ? void 0 : s.variant) || "ghost",
            onClick: s == null ? void 0 : s.onClick,
            children: s == null ? void 0 : s.label
          }
        ) }),
        i && /* @__PURE__ */ l.jsx(
          zt,
          {
            disabled: i == null ? void 0 : i.isLoading,
            isLoading: i == null ? void 0 : i.isLoading,
            className: i == null ? void 0 : i.className,
            variant: (i == null ? void 0 : i.variant) || "default",
            onClick: i == null ? void 0 : i.onClick,
            children: i == null ? void 0 : i.label
          }
        )
      ] })
    ]
  }
) });
var kd = 1, YMe = 0.9, QMe = 0.8, JMe = 0.17, B2 = 0.1, Z2 = 0.999, KMe = 0.9999, XMe = 0.99, ewe = /[\\\/_+.#"@\[\(\{&]/, twe = /[\\\/_+.#"@\[\(\{&]/g, awe = /[\s-]/, Jy = /[\s-]/g;
function Oi(e, t, a, n, o, i, s) {
  if (i === t.length) return o === e.length ? kd : XMe;
  var c = `${o},${i}`;
  if (s[c] !== void 0) return s[c];
  for (var f = n.charAt(i), d = a.indexOf(f, o), u = 0, h, y, m, v; d >= 0; ) h = Oi(e, t, a, n, d + 1, i + 1, s), h > u && (d === o ? h *= kd : ewe.test(e.charAt(d - 1)) ? (h *= QMe, m = e.slice(o, d - 1).match(twe), m && o > 0 && (h *= Math.pow(Z2, m.length))) : awe.test(e.charAt(d - 1)) ? (h *= YMe, v = e.slice(o, d - 1).match(Jy), v && o > 0 && (h *= Math.pow(Z2, v.length))) : (h *= JMe, o > 0 && (h *= Math.pow(Z2, d - o))), e.charAt(d) !== t.charAt(i) && (h *= KMe)), (h < B2 && a.charAt(d - 1) === n.charAt(i + 1) || n.charAt(i + 1) === n.charAt(i) && a.charAt(d - 1) !== n.charAt(i)) && (y = Oi(e, t, a, n, d + 1, i + 2, s), y * B2 > h && (h = y * B2)), h > u && (u = h), d = a.indexOf(f, d + 1);
  return s[c] = u, u;
}
function gd(e) {
  return e.toLowerCase().replace(Jy, " ");
}
function nwe(e, t, a) {
  return e = a && a.length > 0 ? `${e + " " + a.join(" ")}` : e, Oi(e, t, gd(e), gd(t), 0, 0, {});
}
var Xa = '[cmdk-group=""]', F2 = '[cmdk-group-items=""]', owe = '[cmdk-group-heading=""]', Ky = '[cmdk-item=""]', vd = `${Ky}:not([aria-disabled="true"])`, qi = "cmdk-item-select", ra = "data-value", rwe = (e, t, a) => nwe(e, t, a), Xy = p.createContext(void 0), Wn = () => p.useContext(Xy), e6 = p.createContext(void 0), Us = () => p.useContext(e6), t6 = p.createContext(void 0), a6 = p.forwardRef((e, t) => {
  let a = ia(() => {
    var z, W;
    return { search: "", value: (W = (z = e.value) != null ? z : e.defaultValue) != null ? W : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), n = ia(() => /* @__PURE__ */ new Set()), o = ia(() => /* @__PURE__ */ new Map()), i = ia(() => /* @__PURE__ */ new Map()), s = ia(() => /* @__PURE__ */ new Set()), c = n6(e), { label: f, children: d, value: u, onValueChange: h, filter: y, shouldFilter: m, loop: v, disablePointerSelection: k = !1, vimBindings: g = !0, ...M } = e, w = $e(), x = $e(), C = $e(), L = p.useRef(null), N = mwe();
  B1(() => {
    if (u !== void 0) {
      let z = u.trim();
      a.current.value = z, j.emit();
    }
  }, [u]), B1(() => {
    N(6, _);
  }, []);
  let j = p.useMemo(() => ({ subscribe: (z) => (s.current.add(z), () => s.current.delete(z)), snapshot: () => a.current, setState: (z, W, K) => {
    var U, ne, O, X;
    if (!Object.is(a.current[z], W)) {
      if (a.current[z] = W, z === "search") R(), H(), N(1, Z);
      else if (z === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let re = document.getElementById(C);
          re ? re.focus() : (U = document.getElementById(w)) == null || U.focus();
        }
        if (N(7, () => {
          var re;
          a.current.selectedItemId = (re = T()) == null ? void 0 : re.id, j.emit();
        }), K || N(5, _), ((ne = c.current) == null ? void 0 : ne.value) !== void 0) {
          let re = W ?? "";
          (X = (O = c.current).onValueChange) == null || X.call(O, re);
          return;
        }
      }
      j.emit();
    }
  }, emit: () => {
    s.current.forEach((z) => z());
  } }), []), A = p.useMemo(() => ({ value: (z, W, K) => {
    var U;
    W !== ((U = i.current.get(z)) == null ? void 0 : U.value) && (i.current.set(z, { value: W, keywords: K }), a.current.filtered.items.set(z, D(W, K)), N(2, () => {
      H(), j.emit();
    }));
  }, item: (z, W) => (n.current.add(z), W && (o.current.has(W) ? o.current.get(W).add(z) : o.current.set(W, /* @__PURE__ */ new Set([z]))), N(3, () => {
    R(), H(), a.current.value || Z(), j.emit();
  }), () => {
    i.current.delete(z), n.current.delete(z), a.current.filtered.items.delete(z);
    let K = T();
    N(4, () => {
      R(), (K == null ? void 0 : K.getAttribute("id")) === z && Z(), j.emit();
    });
  }), group: (z) => (o.current.has(z) || o.current.set(z, /* @__PURE__ */ new Set()), () => {
    i.current.delete(z), o.current.delete(z);
  }), filter: () => c.current.shouldFilter, label: f || e["aria-label"], getDisablePointerSelection: () => c.current.disablePointerSelection, listId: w, inputId: C, labelId: x, listInnerRef: L }), []);
  function D(z, W) {
    var K, U;
    let ne = (U = (K = c.current) == null ? void 0 : K.filter) != null ? U : rwe;
    return z ? ne(z, a.current.search, W) : 0;
  }
  function H() {
    if (!a.current.search || c.current.shouldFilter === !1) return;
    let z = a.current.filtered.items, W = [];
    a.current.filtered.groups.forEach((U) => {
      let ne = o.current.get(U), O = 0;
      ne.forEach((X) => {
        let re = z.get(X);
        O = Math.max(re, O);
      }), W.push([U, O]);
    });
    let K = L.current;
    G().sort((U, ne) => {
      var O, X;
      let re = U.getAttribute("id"), ie = ne.getAttribute("id");
      return ((O = z.get(ie)) != null ? O : 0) - ((X = z.get(re)) != null ? X : 0);
    }).forEach((U) => {
      let ne = U.closest(F2);
      ne ? ne.appendChild(U.parentElement === ne ? U : U.closest(`${F2} > *`)) : K.appendChild(U.parentElement === K ? U : U.closest(`${F2} > *`));
    }), W.sort((U, ne) => ne[1] - U[1]).forEach((U) => {
      var ne;
      let O = (ne = L.current) == null ? void 0 : ne.querySelector(`${Xa}[${ra}="${encodeURIComponent(U[0])}"]`);
      O == null || O.parentElement.appendChild(O);
    });
  }
  function Z() {
    let z = G().find((K) => K.getAttribute("aria-disabled") !== "true"), W = z == null ? void 0 : z.getAttribute(ra);
    j.setState("value", W || void 0);
  }
  function R() {
    var z, W, K, U;
    if (!a.current.search || c.current.shouldFilter === !1) {
      a.current.filtered.count = n.current.size;
      return;
    }
    a.current.filtered.groups = /* @__PURE__ */ new Set();
    let ne = 0;
    for (let O of n.current) {
      let X = (W = (z = i.current.get(O)) == null ? void 0 : z.value) != null ? W : "", re = (U = (K = i.current.get(O)) == null ? void 0 : K.keywords) != null ? U : [], ie = D(X, re);
      a.current.filtered.items.set(O, ie), ie > 0 && ne++;
    }
    for (let [O, X] of o.current) for (let re of X) if (a.current.filtered.items.get(re) > 0) {
      a.current.filtered.groups.add(O);
      break;
    }
    a.current.filtered.count = ne;
  }
  function _() {
    var z, W, K;
    let U = T();
    U && (((z = U.parentElement) == null ? void 0 : z.firstChild) === U && ((K = (W = U.closest(Xa)) == null ? void 0 : W.querySelector(owe)) == null || K.scrollIntoView({ block: "nearest" })), U.scrollIntoView({ block: "nearest" }));
  }
  function T() {
    var z;
    return (z = L.current) == null ? void 0 : z.querySelector(`${Ky}[aria-selected="true"]`);
  }
  function G() {
    var z;
    return Array.from(((z = L.current) == null ? void 0 : z.querySelectorAll(vd)) || []);
  }
  function q(z) {
    let W = G()[z];
    W && j.setState("value", W.getAttribute(ra));
  }
  function V(z) {
    var W;
    let K = T(), U = G(), ne = U.findIndex((X) => X === K), O = U[ne + z];
    (W = c.current) != null && W.loop && (O = ne + z < 0 ? U[U.length - 1] : ne + z === U.length ? U[0] : U[ne + z]), O && j.setState("value", O.getAttribute(ra));
  }
  function B(z) {
    let W = T(), K = W == null ? void 0 : W.closest(Xa), U;
    for (; K && !U; ) K = z > 0 ? pwe(K, Xa) : ywe(K, Xa), U = K == null ? void 0 : K.querySelector(vd);
    U ? j.setState("value", U.getAttribute(ra)) : V(z);
  }
  let Q = () => q(G().length - 1), me = (z) => {
    z.preventDefault(), z.metaKey ? Q() : z.altKey ? B(1) : V(1);
  }, be = (z) => {
    z.preventDefault(), z.metaKey ? q(0) : z.altKey ? B(-1) : V(-1);
  };
  return p.createElement(Y.div, { ref: t, tabIndex: -1, ...M, "cmdk-root": "", onKeyDown: (z) => {
    var W;
    (W = M.onKeyDown) == null || W.call(M, z);
    let K = z.nativeEvent.isComposing || z.keyCode === 229;
    if (!(z.defaultPrevented || K)) switch (z.key) {
      case "n":
      case "j": {
        g && z.ctrlKey && me(z);
        break;
      }
      case "ArrowDown": {
        me(z);
        break;
      }
      case "p":
      case "k": {
        g && z.ctrlKey && be(z);
        break;
      }
      case "ArrowUp": {
        be(z);
        break;
      }
      case "Home": {
        z.preventDefault(), q(0);
        break;
      }
      case "End": {
        z.preventDefault(), Q();
        break;
      }
      case "Enter": {
        z.preventDefault();
        let U = T();
        if (U) {
          let ne = new Event(qi);
          U.dispatchEvent(ne);
        }
      }
    }
  } }, p.createElement("label", { "cmdk-label": "", htmlFor: A.inputId, id: A.labelId, style: gwe }, f), Qr(e, (z) => p.createElement(e6.Provider, { value: j }, p.createElement(Xy.Provider, { value: A }, z))));
}), iwe = p.forwardRef((e, t) => {
  var a, n;
  let o = $e(), i = p.useRef(null), s = p.useContext(t6), c = Wn(), f = n6(e), d = (n = (a = f.current) == null ? void 0 : a.forceMount) != null ? n : s == null ? void 0 : s.forceMount;
  B1(() => {
    if (!d) return c.item(o, s == null ? void 0 : s.id);
  }, [d]);
  let u = o6(o, i, [e.value, e.children, i], e.keywords), h = Us(), y = m1((N) => N.value && N.value === u.current), m = m1((N) => d || c.filter() === !1 ? !0 : N.search ? N.filtered.items.get(o) > 0 : !0);
  p.useEffect(() => {
    let N = i.current;
    if (!(!N || e.disabled)) return N.addEventListener(qi, v), () => N.removeEventListener(qi, v);
  }, [m, e.onSelect, e.disabled]);
  function v() {
    var N, j;
    k(), (j = (N = f.current).onSelect) == null || j.call(N, u.current);
  }
  function k() {
    h.setState("value", u.current, !0);
  }
  if (!m) return null;
  let { disabled: g, value: M, onSelect: w, forceMount: x, keywords: C, ...L } = e;
  return p.createElement(Y.div, { ref: H1(i, t), ...L, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!g, "aria-selected": !!y, "data-disabled": !!g, "data-selected": !!y, onPointerMove: g || c.getDisablePointerSelection() ? void 0 : k, onClick: g ? void 0 : v }, e.children);
}), swe = p.forwardRef((e, t) => {
  let { heading: a, children: n, forceMount: o, ...i } = e, s = $e(), c = p.useRef(null), f = p.useRef(null), d = $e(), u = Wn(), h = m1((m) => o || u.filter() === !1 ? !0 : m.search ? m.filtered.groups.has(s) : !0);
  B1(() => u.group(s), []), o6(s, c, [e.value, e.heading, f]);
  let y = p.useMemo(() => ({ id: s, forceMount: o }), [o]);
  return p.createElement(Y.div, { ref: H1(c, t), ...i, "cmdk-group": "", role: "presentation", hidden: h ? void 0 : !0 }, a && p.createElement("div", { ref: f, "cmdk-group-heading": "", "aria-hidden": !0, id: d }, a), Qr(e, (m) => p.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": a ? d : void 0 }, p.createElement(t6.Provider, { value: y }, m))));
}), cwe = p.forwardRef((e, t) => {
  let { alwaysRender: a, ...n } = e, o = p.useRef(null), i = m1((s) => !s.search);
  return !a && !i ? null : p.createElement(Y.div, { ref: H1(o, t), ...n, "cmdk-separator": "", role: "separator" });
}), fwe = p.forwardRef((e, t) => {
  let { onValueChange: a, ...n } = e, o = e.value != null, i = Us(), s = m1((d) => d.search), c = m1((d) => d.selectedItemId), f = Wn();
  return p.useEffect(() => {
    e.value != null && i.setState("search", e.value);
  }, [e.value]), p.createElement(Y.input, { ref: t, ...n, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": f.listId, "aria-labelledby": f.labelId, "aria-activedescendant": c, id: f.inputId, type: "text", value: o ? e.value : s, onChange: (d) => {
    o || i.setState("search", d.target.value), a == null || a(d.target.value);
  } });
}), dwe = p.forwardRef((e, t) => {
  let { children: a, label: n = "Suggestions", ...o } = e, i = p.useRef(null), s = p.useRef(null), c = m1((d) => d.selectedItemId), f = Wn();
  return p.useEffect(() => {
    if (s.current && i.current) {
      let d = s.current, u = i.current, h, y = new ResizeObserver(() => {
        h = requestAnimationFrame(() => {
          let m = d.offsetHeight;
          u.style.setProperty("--cmdk-list-height", m.toFixed(1) + "px");
        });
      });
      return y.observe(d), () => {
        cancelAnimationFrame(h), y.unobserve(d);
      };
    }
  }, []), p.createElement(Y.div, { ref: H1(i, t), ...o, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": c, "aria-label": n, id: f.listId }, Qr(e, (d) => p.createElement("div", { ref: H1(s, f.listInnerRef), "cmdk-list-sizer": "" }, d)));
}), lwe = p.forwardRef((e, t) => {
  let { open: a, onOpenChange: n, overlayClassName: o, contentClassName: i, container: s, ...c } = e;
  return p.createElement(Nr, { open: a, onOpenChange: n }, p.createElement(Ar, { container: s }, p.createElement(Da, { "cmdk-overlay": "", className: o }), p.createElement(_a, { "aria-label": e.label, "cmdk-dialog": "", className: i }, p.createElement(a6, { ref: t, ...c }))));
}), uwe = p.forwardRef((e, t) => m1((a) => a.filtered.count === 0) ? p.createElement(Y.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), hwe = p.forwardRef((e, t) => {
  let { progress: a, children: n, label: o = "Loading...", ...i } = e;
  return p.createElement(Y.div, { ref: t, ...i, "cmdk-loading": "", role: "progressbar", "aria-valuenow": a, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, Qr(e, (s) => p.createElement("div", { "aria-hidden": !0 }, s)));
}), dt = Object.assign(a6, { List: dwe, Item: iwe, Input: fwe, Group: swe, Separator: cwe, Dialog: lwe, Empty: uwe, Loading: hwe });
function pwe(e, t) {
  let a = e.nextElementSibling;
  for (; a; ) {
    if (a.matches(t)) return a;
    a = a.nextElementSibling;
  }
}
function ywe(e, t) {
  let a = e.previousElementSibling;
  for (; a; ) {
    if (a.matches(t)) return a;
    a = a.previousElementSibling;
  }
}
function n6(e) {
  let t = p.useRef(e);
  return B1(() => {
    t.current = e;
  }), t;
}
var B1 = typeof window > "u" ? p.useEffect : p.useLayoutEffect;
function ia(e) {
  let t = p.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function m1(e) {
  let t = Us(), a = () => e(t.snapshot());
  return p.useSyncExternalStore(t.subscribe, a, a);
}
function o6(e, t, a, n = []) {
  let o = p.useRef(), i = Wn();
  return B1(() => {
    var s;
    let c = (() => {
      var d;
      for (let u of a) {
        if (typeof u == "string") return u.trim();
        if (typeof u == "object" && "current" in u) return u.current ? (d = u.current.textContent) == null ? void 0 : d.trim() : o.current;
      }
    })(), f = n.map((d) => d.trim());
    i.value(e, c, f), (s = t.current) == null || s.setAttribute(ra, c), o.current = c;
  }), o;
}
var mwe = () => {
  let [e, t] = p.useState(), a = ia(() => /* @__PURE__ */ new Map());
  return B1(() => {
    a.current.forEach((n) => n()), a.current = /* @__PURE__ */ new Map();
  }, [e]), (n, o) => {
    a.current.set(n, o), t({});
  };
};
function kwe(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function Qr({ asChild: e, children: t }, a) {
  return e && p.isValidElement(t) ? p.cloneElement(kwe(t), { ref: t.ref }, a(t.props.children)) : a(t);
}
var gwe = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const Ws = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  dt,
  {
    ref: a,
    className: S(
      "flex h-full w-full flex-col overflow-hidden rounded-md color-bg-default color-text-default",
      e
    ),
    ...t
  }
));
Ws.displayName = dt.displayName;
const xxe = ({ children: e, ...t }) => /* @__PURE__ */ l.jsx(up, { ...t, children: /* @__PURE__ */ l.jsx(ks, { className: "overflow-hidden p-0", children: /* @__PURE__ */ l.jsx(Ws, { className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:color-text-disabled [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5", children: e }) }) }), r6 = p.forwardRef(({ className: e, disabledIcon: t = !1, inputWrapperClassName: a, ...n }, o) => /* @__PURE__ */ l.jsxs(
  "div",
  {
    className: S("flex items-center border-b px-3", a),
    "cmdk-input-wrapper": "",
    children: [
      !t && /* @__PURE__ */ l.jsx(zd, { size: 16, className: "mr-2 color-text-disabled", "aria-hidden": "true" }),
      /* @__PURE__ */ l.jsx(
        dt.Input,
        {
          ref: o,
          className: S(
            "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:color-text-disabled disabled:cursor-not-allowed disabled:opacity-50",
            e
          ),
          ...n
        }
      )
    ]
  }
));
r6.displayName = dt.Input.displayName;
const i6 = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  dt.List,
  {
    ref: a,
    className: S("max-h-[300px] overflow-y-auto overflow-x-hidden", e),
    ...t
  }
));
i6.displayName = dt.List.displayName;
const s6 = p.forwardRef((e, t) => /* @__PURE__ */ l.jsx(
  dt.Empty,
  {
    ref: t,
    className: "py-6 text-center text-body-sm",
    ...e
  }
));
s6.displayName = dt.Empty.displayName;
const c6 = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  dt.Group,
  {
    ref: a,
    className: S(
      "overflow-hidden p-1 color-text-default [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-helper-text-sm [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:color-text-disabled",
      e
    ),
    ...t
  }
));
c6.displayName = dt.Group.displayName;
const vwe = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  dt.Separator,
  {
    ref: a,
    className: S("-mx-1 h-px color-border-default", e),
    ...t
  }
));
vwe.displayName = dt.Separator.displayName;
const f6 = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  dt.Item,
  {
    ref: a,
    className: S(
      "relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-body-sm outline-none aria-selected:color-bg-default-selected aria-selected:color-text-default",
      e
    ),
    ...t
  }
));
f6.displayName = dt.Item.displayName;
const Mwe = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.jsx(
  "span",
  {
    className: S(
      "ml-auto text-helper-text-sm tracking-widest color-text-disabled",
      e
    ),
    ...t
  }
);
Mwe.displayName = "CommandShortcut";
const Cxe = Et(({ count: e = 0 }, t) => {
  const a = e > 9;
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      ref: t,
      className: S(
        "color-bg-tertiary color-text-default rounded-full h-[18px] !font-bold text-helper-text-sm flex justify-center items-center",
        {
          "aspect-square": !a,
          "w-auto p-2": a
        }
      ),
      children: e
    }
  );
}), bxe = ({ className: e, ...t }) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: S("animate-pulse rounded-md color-bg-disabled", e),
    ...t
  }
), Lxe = A9e, jxe = S9e, wwe = p.forwardRef(({ className: e, align: t = "center", sideOffset: a = 4, ...n }, o) => /* @__PURE__ */ l.jsx(
  yh,
  {
    ref: o,
    align: t,
    sideOffset: a,
    className: S(
      "z-50 w-64 rounded-md border color-bg-default color-text-default p-4 shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
));
wwe.displayName = yh.displayName;
const xwe = ({ duration: e, variant: t }) => {
  const [a, n] = ve(100);
  return Ne(() => {
    const o = Date.now(), i = setInterval(() => {
      const s = Date.now() - o, c = Math.max(0, 100 - s / e * 100);
      n(c), c <= 0 && clearInterval(i);
    }, 16);
    return () => clearInterval(i);
  }, [e]), /* @__PURE__ */ l.jsx(
    R1.div,
    {
      className: S("absolute bottom-2 left-0 right-0 h-1", {
        "color-bg-default": t === "default",
        "color-bg-default-inverse": t === "secondary",
        "color-bg-danger": t === "danger",
        "bg-green-700": t === "success"
      }),
      initial: { width: "100%" },
      animate: { width: `${a}%` },
      transition: { duration: 0, ease: "linear" }
    }
  );
}, Cwe = q7e, d6 = p.forwardRef(({ className: e, position: t = "bottom-right", ...a }, n) => /* @__PURE__ */ l.jsx(
  R3,
  {
    ref: n,
    className: S(
      "fixed z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:flex-col md:max-w-[420px]",
      {
        "top-0 right-0": t === "top-right",
        "top-0 left-0": t === "top-left",
        "bottom-0 right-0": t === "bottom-right",
        "bottom-0 left-0": t === "bottom-left",
        "top-0 left-1/2 -translate-x-1/2": t === "center-top",
        "bottom-0 left-1/2 -translate-x-1/2": t === "center-bottom"
      },
      e
    ),
    ...a
  }
));
d6.displayName = R3.displayName;
const bwe = Lt(
  "group pointer-events-auto relative flex w-full items-center justify-between overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80",
  {
    variants: {
      variant: {
        default: "default group color-bg-default-inverse color-text-inverse dark:text-[#363B3F] space-x-4",
        secondary: "secondary group color-bg-secondary color-text-default color-border-default space-x-4",
        danger: "danger group color-bg-danger-light color-text-danger color-border-danger space-x-4",
        success: "success group color-bg-success-light color-text-success color-border-default space-x-4",
        mini: "toast-mini group color-bg-default-inverse color-text-inverse dark:text-[#363B3F] space-x-0"
      },
      position: {
        "top-right": "data-[state=open]:slide-in-from-top-full data-[state=closed]:slide-out-to-right-full data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)]",
        "top-left": "data-[state=open]:slide-in-from-top-full data-[state=closed]:slide-out-to-left-full data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)]",
        "bottom-right": "data-[state=open]:slide-in-from-bottom-full data-[state=closed]:slide-out-to-right-full data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)]",
        "bottom-left": "data-[state=open]:slide-in-from-bottom-full data-[state=closed]:slide-out-to-left-full data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)]",
        "center-top": "data-[state=open]:slide-in-from-top-full data-[state=closed]:slide-out-to-top-full data-[swipe=cancel]:translate-y-0 data-[swipe=end]:translate-y-[var(--radix-toast-swipe-end-y)] data-[swipe=move]:translate-y-[var(--radix-toast-swipe-move-y)]",
        "center-bottom": "data-[state=open]:slide-in-from-bottom-full data-[state=closed]:slide-out-to-bottom-full data-[swipe=cancel]:translate-y-0 data-[swipe=end]:translate-y-[var(--radix-toast-swipe-end-y)] data-[swipe=move]:translate-y-[var(--radix-toast-swipe-move-y)]"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), l6 = p.forwardRef(
  ({
    className: e,
    variant: t,
    position: a,
    duration: n,
    hasIcon: o = !1,
    customIcon: i,
    ...s
  }, c) => /* @__PURE__ */ l.jsxs(
    H3,
    {
      ref: c,
      className: S(bwe({ variant: t, position: a }), e),
      ...s,
      children: [
        o && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          t === "danger" && /* @__PURE__ */ l.jsx(Ce, { name: "CircleX", className: "min-w-5 aspect-square" }),
          t === "success" && /* @__PURE__ */ l.jsx(Ce, { name: "CircleCheck", className: "min-w-5 aspect-square" }),
          t === "default" && /* @__PURE__ */ l.jsx(Ce, { name: "TriangleAlert", className: "min-w-5 aspect-square" }),
          t === "secondary" && /* @__PURE__ */ l.jsx(Ce, { name: "Info", className: "min-w-5 aspect-square" })
        ] }),
        i && /* @__PURE__ */ l.jsx(Ce, { name: i, className: "w-4 aspect-square" }),
        s.children,
        t !== "mini" && /* @__PURE__ */ l.jsx(
          xwe,
          {
            duration: n || 3e3,
            variant: t || "default"
          }
        )
      ]
    }
  )
);
l6.displayName = H3.displayName;
const Lwe = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  q3,
  {
    ref: a,
    className: S(
      "inline-flex h-8 shrink-0 items-center justify-center rounded border bg-transparent px-3 text-body-sm ring-offset-transparent transition-colors disabled:pointer-events-none disabled:opacity-50 group-hover:brightness-95",
      "group-[.danger]:color-border-danger group-[.danger]:hover:color-bg-danger-light group-[.danger]:hover:color-text-danger",
      "group-[.success]:color-border-hover group-[.success]:hover:color-bg-success-light group-[.success]:hover:color-text-success",
      "group-[.secondary]:color-border-hover group-[.secondary]:hover:color-bg-secondary group-[.secondary]:hover:color-text-default",
      "group-[.default]:color-border-default group-[.default]:hover:color-bg-default-inverse group-[.default]:hover:color-text-inverse",
      e
    ),
    ...t
  }
));
Lwe.displayName = q3.displayName;
const u6 = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  B3,
  {
    ref: a,
    className: S(
      "absolute right-2 top-2 rounded-md p-1 opacity-0 transition-opacity focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100",
      "group-[.default]:color-bg-default-inverse group-[.default]:color-text-inverse",
      "group-[.secondary]:color-bg-secondary group-[.secondary]:color-text-default group-[.secondary]:color-border-default",
      "group-[.danger]:color-bg-danger-light group-[.danger]:color-text-danger group-[.danger]:color-border-danger",
      "group-[.success]:color-bg-success-light group-[.success]:color-text-success group-[.success]:color-border-default",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ l.jsx(Ce, { name: "X", className: "w-4 h-4" })
  }
));
u6.displayName = B3.displayName;
const h6 = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  V3,
  {
    ref: a,
    className: S("text-heading-xsm-bold", e),
    ...t
  }
));
h6.displayName = V3.displayName;
const p6 = p.forwardRef(({ className: e, ...t }, a) => /* @__PURE__ */ l.jsx(
  O3,
  {
    ref: a,
    className: S("text-body-sm opacity-90", e),
    ...t
  }
));
p6.displayName = O3.displayName;
const jwe = 1, Nwe = 1e6;
let G2 = 0;
function Awe() {
  return G2 = (G2 + 1) % Number.MAX_SAFE_INTEGER, G2.toString();
}
const $2 = /* @__PURE__ */ new Map(), Md = (e) => {
  if ($2.has(e))
    return;
  const t = setTimeout(() => {
    $2.delete(e), un({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, Nwe);
  $2.set(e, t);
}, Swe = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, jwe)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map(
          (a) => a.id === t.toast.id ? { ...a, ...t.toast } : a
        )
      };
    case "DISMISS_TOAST": {
      const { toastId: a } = t;
      return a ? Md(a) : e.toasts.forEach((n) => {
        Md(n.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (n) => n.id === a || a === void 0 ? {
            ...n,
            open: !1
          } : n
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((a) => a.id !== t.toastId)
      };
  }
}, Io = [];
let To = { toasts: [] };
function un(e) {
  To = Swe(To, e), Io.forEach((t) => {
    t(To);
  });
}
function Iwe({ ...e }) {
  const t = Awe(), a = (o) => un({
    type: "UPDATE_TOAST",
    toast: { ...o, id: t }
  }), n = () => un({ type: "DISMISS_TOAST", toastId: t });
  return un({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (o) => {
        o || n();
      }
    }
  }), {
    id: t,
    dismiss: n,
    update: a
  };
}
function Twe() {
  const [e, t] = p.useState(To);
  return p.useEffect(() => (Io.push(t), () => {
    const a = Io.indexOf(t);
    a > -1 && Io.splice(a, 1);
  }), [e]), {
    ...e,
    toast: Iwe,
    dismiss: (a) => un({ type: "DISMISS_TOAST", toastId: a })
  };
}
const Nxe = ({
  position: e = "top-right",
  duration: t = 5e3
}) => {
  const { toasts: a } = Twe(), n = Ke(() => {
    switch (e) {
      case "top-right":
        return "right";
      case "top-left":
        return "left";
      case "bottom-right":
        return "right";
      case "bottom-left":
        return "left";
      case "center-top":
        return "up";
      case "center-bottom":
        return "down";
      default:
        return "right";
    }
  }, [e]);
  return /* @__PURE__ */ l.jsxs(Cwe, { swipeDirection: n, duration: t, children: [
    a.map(function({
      id: o,
      title: i,
      description: s,
      action: c,
      variant: f,
      hasIcon: d,
      customIcon: u,
      position: h,
      duration: y,
      ...m
    }) {
      return /* @__PURE__ */ l.jsxs(
        l6,
        {
          ...m,
          variant: f,
          position: h,
          className: "justify-start relative",
          duration: y,
          hasIcon: d,
          customIcon: u,
          children: [
            /* @__PURE__ */ l.jsxs("div", { className: "grid gap-1 ", children: [
              i && /* @__PURE__ */ l.jsx(h6, { children: i }),
              s && /* @__PURE__ */ l.jsx(p6, { children: s })
            ] }),
            c,
            f !== "mini" && /* @__PURE__ */ l.jsx(u6, {})
          ]
        },
        o
      );
    }),
    /* @__PURE__ */ l.jsx(d6, { position: e })
  ] });
}, y6 = Wt({
  theme: "light",
  toggleTheme: () => null
}), Axe = ({
  children: e,
  defaultTheme: t = "light"
}) => {
  const [a, n] = ve(() => localStorage.getItem("theme") || t);
  Ne(() => {
    const i = window.document.documentElement;
    i.classList.remove("light", "dark"), i.classList.add(a), localStorage.setItem("theme", a);
  }, [a]);
  const o = () => {
    n((i) => i === "light" ? "dark" : "light");
  };
  return /* @__PURE__ */ l.jsx(y6.Provider, { value: { theme: a, toggleTheme: o }, children: e });
}, zwe = () => {
  const e = xe(y6);
  if (!e) throw new Error("useTheme must be used within ThemeProvider");
  return e;
}, Sxe = () => {
  const { theme: e, toggleTheme: t } = zwe();
  return /* @__PURE__ */ l.jsxs("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ l.jsx(Ce, { name: "Sun", size: "sm" }),
    /* @__PURE__ */ l.jsx(
      Yi,
      {
        checked: e === "dark",
        onCheckedChange: t,
        "aria-label": "Toggle theme"
      }
    ),
    /* @__PURE__ */ l.jsx(Ce, { name: "Moon", size: "sm" })
  ] });
}, m6 = ({
  direction: e = "horizontal",
  size: t = "lg",
  className: a,
  ...n
}) => {
  const o = {
    sm: "divider-x-sm",
    md: "divider-x-md",
    lg: "divider-x-lg",
    xlg: "divider-x-xlg"
  }, i = {
    sm: "divider-y-sm",
    md: "divider-y-md",
    lg: "divider-y-lg",
    xlg: "divider-y-xlg"
  };
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: S(
        {
          [`${o[t]} mx-auto w-4`]: e === "horizontal",
          [`${i[t]} my-auto h-4`]: e === "vertical"
        },
        a
      ),
      ...n
    }
  );
};
m6.displayName = "Divider";
var Bi = /* @__PURE__ */ ((e) => (e.LIST = "LIST", e.CARD = "CARD", e))(Bi || {});
const Dwe = ({
  delay: e = 2e3
}) => {
  const [t, a] = ve(!1), [n, o] = ve(!1), i = Le(null), s = Ve(() => {
    i.current && clearTimeout(i.current), i.current = setTimeout(() => {
      a(!0), o(!0);
    }, e);
  }, [e]), c = Ve(() => {
    n || a(!1), i.current && clearTimeout(i.current), o(!1);
  }, [n]), f = Ve(() => a(!0), []), d = Ve(() => a(!1), []), u = Ve(() => s(), [s]), h = Ve(() => c(), [c]);
  return {
    onMouseEnter: f,
    onMouseLeave: d,
    onTouchStart: u,
    onTouchEnd: h,
    isActive: t
  };
};
function Ixe(e, t) {
  const [a, n] = ve(e), [o, i] = ve({
    keyName: (t == null ? void 0 : t.keyName) || null,
    order: (t == null ? void 0 : t.order) || "default"
  }), s = (c) => {
    const f = o.keyName === c && o.order === "asc" ? "desc" : "asc", d = [...a].sort((u, h) => {
      const y = typeof u[c] == "number" ? u[c] : String(u[c]).toLowerCase(), m = typeof h[c] == "number" ? h[c] : String(h[c]).toLowerCase();
      return y < m ? f === "asc" ? -1 : 1 : y > m ? f === "asc" ? 1 : -1 : 0;
    });
    n(d), i({ keyName: c, order: f });
  };
  return Ne(() => {
    n(e);
  }, [e]), { data: a, sortState: o, sortData: s };
}
export {
  ske as Accordion,
  dke as AccordionContent,
  cke as AccordionItem,
  fke as AccordionTrigger,
  zp as Alert,
  _p as AlertDescription,
  Dp as AlertTitle,
  axe as AnimatedLoader,
  zo as Avatar,
  Hwe as AvatarGroup,
  Mxe as AvatarSelector,
  wxe as BottomDrawer,
  zt as Button,
  Vwe as ButtonGroup,
  J5e as Card,
  t8e as CardContent,
  e8e as CardDescription,
  a8e as CardFooter,
  K5e as CardHeader,
  X5e as CardTitle,
  Fwe as Checkbox,
  Ws as Command,
  xxe as CommandDialog,
  s6 as CommandEmpty,
  c6 as CommandGroup,
  r6 as CommandInput,
  f6 as CommandItem,
  i6 as CommandList,
  vwe as CommandSeparator,
  Mwe as CommandShortcut,
  Cxe as Counter,
  up as Dialog,
  hp as DialogClose,
  ks as DialogContent,
  gp as DialogDescription,
  mp as DialogFooter,
  yp as DialogHeader,
  pp as DialogOverlay,
  Xme as DialogPortal,
  kp as DialogTitle,
  oxe as DialogTrigger,
  m6 as Divider,
  gs as Drawer,
  vs as DrawerClose,
  Ms as DrawerContent,
  bs as DrawerDescription,
  xs as DrawerFooter,
  ws as DrawerHeader,
  vp as DrawerOverlay,
  eke as DrawerPortal,
  Cs as DrawerTitle,
  rxe as DrawerTrigger,
  vxe as DynamicAlert,
  cxe as DynamicContentController,
  uxe as DynamicDrawer,
  hxe as DynamicDrawerV2,
  mxe as DynamicDropdown,
  kxe as DynamicDropdownV2,
  ixe as DynamicModal,
  sxe as DynamicRadio,
  gxe as DynamicSelect,
  WMe as EmojiPicker,
  it as EmojiStyle,
  bme as FloatingToolbar,
  txe as GridLayout,
  Lxe as HoverCard,
  wwe as HoverCardContent,
  jxe as HoverCardTrigger,
  _5e as Icon,
  ar as IconButton,
  Z1 as Label,
  Bi as LayoutModes,
  Ce as LucideIcon,
  Ls as Popover,
  pxe as PopoverAnchor,
  yxe as PopoverClose,
  Er as PopoverContent,
  js as PopoverTrigger,
  lke as RadioCard,
  Mp as RadioGroup,
  wp as RadioGroupItem,
  xr as SegmentedControl,
  vke as Select,
  Sp as SelectContent,
  Mke as SelectGroup,
  Tp as SelectItem,
  Ip as SelectLabel,
  Ap as SelectScrollDownButton,
  Np as SelectScrollUpButton,
  xke as SelectSeparator,
  jp as SelectTrigger,
  wke as SelectValue,
  hke as Sheet,
  pke as SheetClose,
  Cp as SheetContent,
  gke as SheetDescription,
  kke as SheetFooter,
  bp as SheetHeader,
  xp as SheetOverlay,
  yke as SheetPortal,
  Lp as SheetTitle,
  lxe as SheetTrigger,
  bxe as Skeleton,
  nxe as StaticLoader,
  fxe as Step,
  dxe as Stepper,
  hme as Table,
  yme as TableBody,
  Mme as TableCaption,
  vme as TableCell,
  mme as TableFooter,
  gme as TableHead,
  pme as TableHeader,
  kme as TableRow,
  Q5e as Tabs,
  M4 as TabsContent,
  v4 as TabsList,
  Mi as TabsTrigger,
  Ju as Tag,
  Zwe as TagInput,
  Xue as TextAreaField,
  Kue as TextAreaFieldV2,
  Hd as TextField,
  Axe as ThemeProvider,
  Sxe as ThemeToggle,
  l6 as Toast,
  Lwe as ToastAction,
  u6 as ToastClose,
  p6 as ToastDescription,
  Cwe as ToastProvider,
  h6 as ToastTitle,
  d6 as ToastViewport,
  Nxe as Toaster,
  Yi as Toggle,
  I5e as Tooltip,
  Zue as UltimateIcons,
  S as cn,
  Ewe as formatCounter,
  Rwe as getTrimmedName,
  c5 as isDarkColor,
  Iwe as toast,
  Dwe as useHoverAndLongPress,
  Ixe as useSortableData,
  zwe as useTheme,
  Twe as useToast
};
